import { ROTATION_MATRICES as Ri, defaultPalette as ng, toVoxBytesScene as du } from "@voxel-tool/core";
import * as ie from "three";
import { GLTFExporter as pu } from "three/addons/exporters/GLTFExporter.js";
import { OBJExporter as og } from "three/addons/exporters/OBJExporter.js";
import { STLExporter as lg } from "three/addons/exporters/STLExporter.js";
import { PLYExporter as ug } from "three/addons/exporters/PLYExporter.js";
import { USDZExporter as hg } from "three/addons/exporters/USDZExporter.js";
import { FBXExporter as cg } from "@comfyorg/fbx-exporter-three";
const Ch = "185", dg = 0, pg = 1, mg = 2, ya = 3, ho = 0, vi = 1, gg = 2, ko = 0, co = 1, fg = 6, po = 100, mo = 204, go = 205, mu = 3, yg = 0, fo = 0, Do = 300, yi = 301, yo = 302, zh = 306, gu = 1e3, Js = 1001, fu = 1002, at = 1003, ms = 1006, Rh = 1008, xg = 1008, bg = 1009, vg = 1013, Wo = 1014, qo = 1015, us = 1016, Eh = 1023, xo = 1026, Tg = 1027, Rr = 1030, wg = 37490, Ng = 36285, fn = 0, Mg = 1, Ta = "", zt = "srgb", wa = "srgb-linear", yu = "linear", di = "srgb", yn = "", Lh = "rg", Sg = "ga", mr = 7680, xu = 519, _g = 513, jo = 515, bu = 516, Na = 518, kr = 35044, Da = 35048, Vs = 2e3, Ls = 2001, Ih = {
  TEXTURE_COMPARE: "depthTextureCompare"
};
function Ag(r) {
  for (let e = r.length - 1; e >= 0; --e)
    if (r[e] >= 65535) return !0;
  return !1;
}
function vu(r) {
  return document.createElementNS("http://www.w3.org/1999/xhtml", r);
}
const Tu = {};
function bo(...r) {
  const e = "THREE." + r.shift();
  console.log(e, ...r);
}
function Oh(r) {
  const e = r[0];
  if (typeof e == "string" && e.startsWith("TSL:")) {
    const t = r[1];
    t && t.isStackTrace ? r[0] += " " + t.getLocation() : r[1] = 'Stack trace not available. Enable "THREE.Node.captureStackTrace" to capture stack traces.';
  }
  return r;
}
function X(...r) {
  r = Oh(r);
  const e = "THREE." + r.shift();
  {
    const t = r[0];
    t && t.isStackTrace ? console.warn(t.getError(e)) : console.warn(e, ...r);
  }
}
function te(...r) {
  r = Oh(r);
  const e = "THREE." + r.shift();
  {
    const t = r[0];
    t && t.isStackTrace ? console.error(t.getError(e)) : console.error(e, ...r);
  }
}
function Be(...r) {
  const e = r.join(" ");
  e in Tu || (Tu[e] = !0, X(...r));
}
class Ps {
  /**
   * Adds the given event listener to the given event type.
   *
   * @param {string} type - The type of event to listen to.
   * @param {Function} listener - The function that gets called when the event is fired.
   */
  addEventListener(e, t) {
    this._listeners === void 0 && (this._listeners = {});
    const s = this._listeners;
    s[e] === void 0 && (s[e] = []), s[e].indexOf(t) === -1 && s[e].push(t);
  }
  /**
   * Returns `true` if the given event listener has been added to the given event type.
   *
   * @param {string} type - The type of event.
   * @param {Function} listener - The listener to check.
   * @return {boolean} Whether the given event listener has been added to the given event type.
   */
  hasEventListener(e, t) {
    const s = this._listeners;
    return s === void 0 ? !1 : s[e] !== void 0 && s[e].indexOf(t) !== -1;
  }
  /**
   * Removes the given event listener from the given event type.
   *
   * @param {string} type - The type of event.
   * @param {Function} listener - The listener to remove.
   */
  removeEventListener(e, t) {
    const s = this._listeners;
    if (s === void 0) return;
    const i = s[e];
    if (i !== void 0) {
      const a = i.indexOf(t);
      a !== -1 && i.splice(a, 1);
    }
  }
  /**
   * Dispatches an event object.
   *
   * @param {Object} event - The event that gets fired.
   */
  dispatchEvent(e) {
    const t = this._listeners;
    if (t === void 0) return;
    const s = t[e.type];
    if (s !== void 0) {
      e.target = this;
      const i = s.slice(0);
      for (let a = 0, n = i.length; a < n; a++)
        i[a].call(this, e);
      e.target = null;
    }
  }
}
const qe = ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "0a", "0b", "0c", "0d", "0e", "0f", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "1a", "1b", "1c", "1d", "1e", "1f", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "2a", "2b", "2c", "2d", "2e", "2f", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "3a", "3b", "3c", "3d", "3e", "3f", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "4a", "4b", "4c", "4d", "4e", "4f", "50", "51", "52", "53", "54", "55", "56", "57", "58", "59", "5a", "5b", "5c", "5d", "5e", "5f", "60", "61", "62", "63", "64", "65", "66", "67", "68", "69", "6a", "6b", "6c", "6d", "6e", "6f", "70", "71", "72", "73", "74", "75", "76", "77", "78", "79", "7a", "7b", "7c", "7d", "7e", "7f", "80", "81", "82", "83", "84", "85", "86", "87", "88", "89", "8a", "8b", "8c", "8d", "8e", "8f", "90", "91", "92", "93", "94", "95", "96", "97", "98", "99", "9a", "9b", "9c", "9d", "9e", "9f", "a0", "a1", "a2", "a3", "a4", "a5", "a6", "a7", "a8", "a9", "aa", "ab", "ac", "ad", "ae", "af", "b0", "b1", "b2", "b3", "b4", "b5", "b6", "b7", "b8", "b9", "ba", "bb", "bc", "bd", "be", "bf", "c0", "c1", "c2", "c3", "c4", "c5", "c6", "c7", "c8", "c9", "ca", "cb", "cc", "cd", "ce", "cf", "d0", "d1", "d2", "d3", "d4", "d5", "d6", "d7", "d8", "d9", "da", "db", "dc", "dd", "de", "df", "e0", "e1", "e2", "e3", "e4", "e5", "e6", "e7", "e8", "e9", "ea", "eb", "ec", "ed", "ee", "ef", "f0", "f1", "f2", "f3", "f4", "f5", "f6", "f7", "f8", "f9", "fa", "fb", "fc", "fd", "fe", "ff"];
let wu = 1234567;
const pi = Math.PI / 180, Ma = 180 / Math.PI;
function cs() {
  const r = Math.random() * 4294967295 | 0, e = Math.random() * 4294967295 | 0, t = Math.random() * 4294967295 | 0, s = Math.random() * 4294967295 | 0;
  return (qe[r & 255] + qe[r >> 8 & 255] + qe[r >> 16 & 255] + qe[r >> 24 & 255] + "-" + qe[e & 255] + qe[e >> 8 & 255] + "-" + qe[e >> 16 & 15 | 64] + qe[e >> 24 & 255] + "-" + qe[t & 63 | 128] + qe[t >> 8 & 255] + "-" + qe[t >> 16 & 255] + qe[t >> 24 & 255] + qe[s & 255] + qe[s >> 8 & 255] + qe[s >> 16 & 255] + qe[s >> 24 & 255]).toLowerCase();
}
function ee(r, e, t) {
  return Math.max(e, Math.min(t, r));
}
function Go(r, e) {
  return (r % e + e) % e;
}
function Vg(r, e, t, s, i) {
  return s + (r - e) * (i - s) / (t - e);
}
function Cg(r, e, t) {
  return r !== e ? (t - r) / (e - r) : 0;
}
function mi(r, e, t) {
  return (1 - t) * r + t * e;
}
function zg(r, e, t, s) {
  return mi(r, e, 1 - Math.exp(-t * s));
}
function Rg(r, e = 1) {
  return e - Math.abs(Go(r, e * 2) - e);
}
function Eg(r, e, t) {
  return r <= e ? 0 : r >= t ? 1 : (r = (r - e) / (t - e), r * r * (3 - 2 * r));
}
function Lg(r, e, t) {
  return r <= e ? 0 : r >= t ? 1 : (r = (r - e) / (t - e), r * r * r * (r * (r * 6 - 15) + 10));
}
function Ig(r, e) {
  return r + Math.floor(Math.random() * (e - r + 1));
}
function Og(r, e) {
  return r + Math.random() * (e - r);
}
function Pg(r) {
  return r * (0.5 - Math.random());
}
function Fg(r) {
  r !== void 0 && (wu = r);
  let e = wu += 1831565813;
  return e = Math.imul(e ^ e >>> 15, e | 1), e ^= e + Math.imul(e ^ e >>> 7, e | 61), ((e ^ e >>> 14) >>> 0) / 4294967296;
}
function Bg(r) {
  return r * pi;
}
function Ug(r) {
  return r * Ma;
}
function kg(r) {
  return (r & r - 1) === 0 && r !== 0;
}
function Dg(r) {
  return Math.pow(2, Math.ceil(Math.log(r) / Math.LN2));
}
function Wg(r) {
  return Math.pow(2, Math.floor(Math.log(r) / Math.LN2));
}
function qg(r, e, t, s, i) {
  const a = Math.cos, n = Math.sin, o = a(t / 2), l = n(t / 2), u = a((e + s) / 2), h = n((e + s) / 2), d = a((e - s) / 2), p = n((e - s) / 2), m = a((s - e) / 2), g = n((s - e) / 2);
  switch (i) {
    case "XYX":
      r.set(o * h, l * d, l * p, o * u);
      break;
    case "YZY":
      r.set(l * p, o * h, l * d, o * u);
      break;
    case "ZXZ":
      r.set(l * d, l * p, o * h, o * u);
      break;
    case "XZX":
      r.set(o * h, l * g, l * m, o * u);
      break;
    case "YXY":
      r.set(l * m, o * h, l * g, o * u);
      break;
    case "ZYZ":
      r.set(l * g, l * m, o * h, o * u);
      break;
    default:
      X("MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + i);
  }
}
function Et(r, e) {
  switch (e.constructor) {
    case Float32Array:
      return r;
    case Uint32Array:
      return r / 4294967295;
    case Uint16Array:
      return r / 65535;
    case Uint8Array:
      return r / 255;
    case Int32Array:
      return Math.max(r / 2147483647, -1);
    case Int16Array:
      return Math.max(r / 32767, -1);
    case Int8Array:
      return Math.max(r / 127, -1);
    default:
      throw new Error("THREE.MathUtils: Invalid component type.");
  }
}
function oe(r, e) {
  switch (e.constructor) {
    case Float32Array:
      return r;
    case Uint32Array:
      return Math.round(r * 4294967295);
    case Uint16Array:
      return Math.round(r * 65535);
    case Uint8Array:
      return Math.round(r * 255);
    case Int32Array:
      return Math.round(r * 2147483647);
    case Int16Array:
      return Math.round(r * 32767);
    case Int8Array:
      return Math.round(r * 127);
    default:
      throw new Error("THREE.MathUtils: Invalid component type.");
  }
}
const Ph = {
  DEG2RAD: pi,
  RAD2DEG: Ma,
  /**
   * Generate a [UUID](https://en.wikipedia.org/wiki/Universally_unique_identifier)
   * (universally unique identifier).
   *
   * @static
   * @method
   * @return {string} The UUID.
   */
  generateUUID: cs,
  /**
   * Clamps the given value between min and max.
   *
   * @static
   * @method
   * @param {number} value - The value to clamp.
   * @param {number} min - The min value.
   * @param {number} max - The max value.
   * @return {number} The clamped value.
   */
  clamp: ee,
  /**
   * Computes the Euclidean modulo of the given parameters that
   * is `( ( n % m ) + m ) % m`.
   *
   * @static
   * @method
   * @param {number} n - The first parameter.
   * @param {number} m - The second parameter.
   * @return {number} The Euclidean modulo.
   */
  euclideanModulo: Go,
  /**
   * Performs a linear mapping from range `<a1, a2>` to range `<b1, b2>`
   * for the given value.
   *
   * @static
   * @method
   * @param {number} x - The value to be mapped.
   * @param {number} a1 - Minimum value for range A.
   * @param {number} a2 - Maximum value for range A.
   * @param {number} b1 - Minimum value for range B.
   * @param {number} b2 - Maximum value for range B.
   * @return {number} The mapped value.
   */
  mapLinear: Vg,
  /**
   * Returns the percentage in the closed interval `[0, 1]` of the given value
   * between the start and end point.
   *
   * @static
   * @method
   * @param {number} x - The start point
   * @param {number} y - The end point.
   * @param {number} value - A value between start and end.
   * @return {number} The interpolation factor.
   */
  inverseLerp: Cg,
  /**
   * Returns a value linearly interpolated from two known points based on the given interval -
   * `t = 0` will return `x` and `t = 1` will return `y`.
   *
   * @static
   * @method
   * @param {number} x - The start point
   * @param {number} y - The end point.
   * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
   * @return {number} The interpolated value.
   */
  lerp: mi,
  /**
   * Smoothly interpolate a number from `x` to `y` in  a spring-like manner using a delta
   * time to maintain frame rate independent movement. For details, see
   * [Frame rate independent damping using lerp](http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/).
   *
   * @static
   * @method
   * @param {number} x - The current point.
   * @param {number} y - The target point.
   * @param {number} lambda - A higher lambda value will make the movement more sudden,
   * and a lower value will make the movement more gradual.
   * @param {number} dt - Delta time in seconds.
   * @return {number} The interpolated value.
   */
  damp: zg,
  /**
   * Returns a value that alternates between `0` and the given `length` parameter.
   *
   * @static
   * @method
   * @param {number} x - The value to pingpong.
   * @param {number} [length=1] - The positive value the function will pingpong to.
   * @return {number} The alternated value.
   */
  pingpong: Rg,
  /**
   * Returns a value in the range `[0,1]` that represents the percentage that `x` has
   * moved between `min` and `max`, but smoothed or slowed down the closer `x` is to
   * the `min` and `max`.
   *
   * See [Smoothstep](http://en.wikipedia.org/wiki/Smoothstep) for more details.
   *
   * @static
   * @method
   * @param {number} x - The value to evaluate based on its position between min and max.
   * @param {number} min - The min value. Any x value below min will be `0`.
   * @param {number} max - The max value. Any x value above max will be `1`.
   * @return {number} The alternated value.
   */
  smoothstep: Eg,
  /**
   * A [variation on smoothstep](https://en.wikipedia.org/wiki/Smoothstep#Variations)
   * that has zero 1st and 2nd order derivatives at x=0 and x=1.
   *
   * @static
   * @method
   * @param {number} x - The value to evaluate based on its position between min and max.
   * @param {number} min - The min value. Any x value below min will be `0`.
   * @param {number} max - The max value. Any x value above max will be `1`.
   * @return {number} The alternated value.
   */
  smootherstep: Lg,
  /**
   * Returns a random integer from `<low, high>` interval.
   *
   * @static
   * @method
   * @param {number} low - The lower value boundary.
   * @param {number} high - The upper value boundary
   * @return {number} A random integer.
   */
  randInt: Ig,
  /**
   * Returns a random float from `<low, high>` interval.
   *
   * @static
   * @method
   * @param {number} low - The lower value boundary.
   * @param {number} high - The upper value boundary
   * @return {number} A random float.
   */
  randFloat: Og,
  /**
   * Returns a random integer from `<-range/2, range/2>` interval.
   *
   * @static
   * @method
   * @param {number} range - Defines the value range.
   * @return {number} A random float.
   */
  randFloatSpread: Pg,
  /**
   * Returns a deterministic pseudo-random float in the interval `[0, 1]`.
   *
   * @static
   * @method
   * @param {number} [s] - The integer seed.
   * @return {number} A random float.
   */
  seededRandom: Fg,
  /**
   * Converts degrees to radians.
   *
   * @static
   * @method
   * @param {number} degrees - A value in degrees.
   * @return {number} The converted value in radians.
   */
  degToRad: Bg,
  /**
   * Converts radians to degrees.
   *
   * @static
   * @method
   * @param {number} radians - A value in radians.
   * @return {number} The converted value in degrees.
   */
  radToDeg: Ug,
  /**
   * Returns `true` if the given number is a power of two.
   *
   * @static
   * @method
   * @param {number} value - The value to check.
   * @return {boolean} Whether the given number is a power of two or not.
   */
  isPowerOfTwo: kg,
  /**
   * Returns the smallest power of two that is greater than or equal to the given number.
   *
   * @static
   * @method
   * @param {number} value - The value to find a POT for.
   * @return {number} The smallest power of two that is greater than or equal to the given number.
   */
  ceilPowerOfTwo: Dg,
  /**
   * Returns the largest power of two that is less than or equal to the given number.
   *
   * @static
   * @method
   * @param {number} value - The value to find a POT for.
   * @return {number} The largest power of two that is less than or equal to the given number.
   */
  floorPowerOfTwo: Wg,
  /**
   * Sets the given quaternion from the [Intrinsic Proper Euler Angles](https://en.wikipedia.org/wiki/Euler_angles)
   * defined by the given angles and order.
   *
   * Rotations are applied to the axes in the order specified by order:
   * rotation by angle `a` is applied first, then by angle `b`, then by angle `c`.
   *
   * @static
   * @method
   * @param {Quaternion} q - The quaternion to set.
   * @param {number} a - The rotation applied to the first axis, in radians.
   * @param {number} b - The rotation applied to the second axis, in radians.
   * @param {number} c - The rotation applied to the third axis, in radians.
   * @param {('XYX'|'XZX'|'YXY'|'YZY'|'ZXZ'|'ZYZ')} order - A string specifying the axes order.
   */
  setQuaternionFromProperEuler: qg,
  /**
   * Normalizes the given value according to the given typed array.
   *
   * @static
   * @method
   * @param {number} value - The float value in the range `[0,1]` to normalize.
   * @param {TypedArray} array - The typed array that defines the data type of the value.
   * @return {number} The normalize value.
   */
  normalize: oe,
  /**
   * Denormalizes the given value according to the given typed array.
   *
   * @static
   * @method
   * @param {number} value - The value to denormalize.
   * @param {TypedArray} array - The typed array that defines the data type of the value.
   * @return {number} The denormalize (float) value in the range `[0,1]`.
   */
  denormalize: Et
}, Fh = class {
  /**
   * Constructs a new 2D vector.
   *
   * @param {number} [x=0] - The x value of this vector.
   * @param {number} [y=0] - The y value of this vector.
   */
  constructor(e = 0, t = 0) {
    this.x = e, this.y = t;
  }
  /**
   * Alias for {@link Vector2#x}.
   *
   * @type {number}
   */
  get width() {
    return this.x;
  }
  set width(e) {
    this.x = e;
  }
  /**
   * Alias for {@link Vector2#y}.
   *
   * @type {number}
   */
  get height() {
    return this.y;
  }
  set height(e) {
    this.y = e;
  }
  /**
   * Sets the vector components.
   *
   * @param {number} x - The value of the x component.
   * @param {number} y - The value of the y component.
   * @return {Vector2} A reference to this vector.
   */
  set(e, t) {
    return this.x = e, this.y = t, this;
  }
  /**
   * Sets the vector components to the same value.
   *
   * @param {number} scalar - The value to set for all vector components.
   * @return {Vector2} A reference to this vector.
   */
  setScalar(e) {
    return this.x = e, this.y = e, this;
  }
  /**
   * Sets the vector's x component to the given value
   *
   * @param {number} x - The value to set.
   * @return {Vector2} A reference to this vector.
   */
  setX(e) {
    return this.x = e, this;
  }
  /**
   * Sets the vector's y component to the given value
   *
   * @param {number} y - The value to set.
   * @return {Vector2} A reference to this vector.
   */
  setY(e) {
    return this.y = e, this;
  }
  /**
   * Allows to set a vector component with an index.
   *
   * @param {number} index - The component index. `0` equals to x, `1` equals to y.
   * @param {number} value - The value to set.
   * @return {Vector2} A reference to this vector.
   */
  setComponent(e, t) {
    switch (e) {
      case 0:
        this.x = t;
        break;
      case 1:
        this.y = t;
        break;
      default:
        throw new Error("THREE.Vector2: index is out of range: " + e);
    }
    return this;
  }
  /**
   * Returns the value of the vector component which matches the given index.
   *
   * @param {number} index - The component index. `0` equals to x, `1` equals to y.
   * @return {number} A vector component value.
   */
  getComponent(e) {
    switch (e) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      default:
        throw new Error("THREE.Vector2: index is out of range: " + e);
    }
  }
  /**
   * Returns a new vector with copied values from this instance.
   *
   * @return {Vector2} A clone of this instance.
   */
  clone() {
    return new this.constructor(this.x, this.y);
  }
  /**
   * Copies the values of the given vector to this instance.
   *
   * @param {Vector2} v - The vector to copy.
   * @return {Vector2} A reference to this vector.
   */
  copy(e) {
    return this.x = e.x, this.y = e.y, this;
  }
  /**
   * Adds the given vector to this instance.
   *
   * @param {Vector2} v - The vector to add.
   * @return {Vector2} A reference to this vector.
   */
  add(e) {
    return this.x += e.x, this.y += e.y, this;
  }
  /**
   * Adds the given scalar value to all components of this instance.
   *
   * @param {number} s - The scalar to add.
   * @return {Vector2} A reference to this vector.
   */
  addScalar(e) {
    return this.x += e, this.y += e, this;
  }
  /**
   * Adds the given vectors and stores the result in this instance.
   *
   * @param {Vector2} a - The first vector.
   * @param {Vector2} b - The second vector.
   * @return {Vector2} A reference to this vector.
   */
  addVectors(e, t) {
    return this.x = e.x + t.x, this.y = e.y + t.y, this;
  }
  /**
   * Adds the given vector scaled by the given factor to this instance.
   *
   * @param {Vector2} v - The vector.
   * @param {number} s - The factor that scales `v`.
   * @return {Vector2} A reference to this vector.
   */
  addScaledVector(e, t) {
    return this.x += e.x * t, this.y += e.y * t, this;
  }
  /**
   * Subtracts the given vector from this instance.
   *
   * @param {Vector2} v - The vector to subtract.
   * @return {Vector2} A reference to this vector.
   */
  sub(e) {
    return this.x -= e.x, this.y -= e.y, this;
  }
  /**
   * Subtracts the given scalar value from all components of this instance.
   *
   * @param {number} s - The scalar to subtract.
   * @return {Vector2} A reference to this vector.
   */
  subScalar(e) {
    return this.x -= e, this.y -= e, this;
  }
  /**
   * Subtracts the given vectors and stores the result in this instance.
   *
   * @param {Vector2} a - The first vector.
   * @param {Vector2} b - The second vector.
   * @return {Vector2} A reference to this vector.
   */
  subVectors(e, t) {
    return this.x = e.x - t.x, this.y = e.y - t.y, this;
  }
  /**
   * Multiplies the given vector with this instance.
   *
   * @param {Vector2} v - The vector to multiply.
   * @return {Vector2} A reference to this vector.
   */
  multiply(e) {
    return this.x *= e.x, this.y *= e.y, this;
  }
  /**
   * Multiplies the given scalar value with all components of this instance.
   *
   * @param {number} scalar - The scalar to multiply.
   * @return {Vector2} A reference to this vector.
   */
  multiplyScalar(e) {
    return this.x *= e, this.y *= e, this;
  }
  /**
   * Divides this instance by the given vector.
   *
   * @param {Vector2} v - The vector to divide.
   * @return {Vector2} A reference to this vector.
   */
  divide(e) {
    return this.x /= e.x, this.y /= e.y, this;
  }
  /**
   * Divides this vector by the given scalar.
   *
   * @param {number} scalar - The scalar to divide.
   * @return {Vector2} A reference to this vector.
   */
  divideScalar(e) {
    return this.multiplyScalar(1 / e);
  }
  /**
   * Multiplies this vector (with an implicit 1 as the 3rd component) by
   * the given 3x3 matrix.
   *
   * @param {Matrix3} m - The matrix to apply.
   * @return {Vector2} A reference to this vector.
   */
  applyMatrix3(e) {
    const t = this.x, s = this.y, i = e.elements;
    return this.x = i[0] * t + i[3] * s + i[6], this.y = i[1] * t + i[4] * s + i[7], this;
  }
  /**
   * If this vector's x or y value is greater than the given vector's x or y
   * value, replace that value with the corresponding min value.
   *
   * @param {Vector2} v - The vector.
   * @return {Vector2} A reference to this vector.
   */
  min(e) {
    return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this;
  }
  /**
   * If this vector's x or y value is less than the given vector's x or y
   * value, replace that value with the corresponding max value.
   *
   * @param {Vector2} v - The vector.
   * @return {Vector2} A reference to this vector.
   */
  max(e) {
    return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this;
  }
  /**
   * If this vector's x or y value is greater than the max vector's x or y
   * value, it is replaced by the corresponding value.
   * If this vector's x or y value is less than the min vector's x or y value,
   * it is replaced by the corresponding value.
   *
   * @param {Vector2} min - The minimum x and y values.
   * @param {Vector2} max - The maximum x and y values in the desired range.
   * @return {Vector2} A reference to this vector.
   */
  clamp(e, t) {
    return this.x = ee(this.x, e.x, t.x), this.y = ee(this.y, e.y, t.y), this;
  }
  /**
   * If this vector's x or y values are greater than the max value, they are
   * replaced by the max value.
   * If this vector's x or y values are less than the min value, they are
   * replaced by the min value.
   *
   * @param {number} minVal - The minimum value the components will be clamped to.
   * @param {number} maxVal - The maximum value the components will be clamped to.
   * @return {Vector2} A reference to this vector.
   */
  clampScalar(e, t) {
    return this.x = ee(this.x, e, t), this.y = ee(this.y, e, t), this;
  }
  /**
   * If this vector's length is greater than the max value, it is replaced by
   * the max value.
   * If this vector's length is less than the min value, it is replaced by the
   * min value.
   *
   * @param {number} min - The minimum value the vector length will be clamped to.
   * @param {number} max - The maximum value the vector length will be clamped to.
   * @return {Vector2} A reference to this vector.
   */
  clampLength(e, t) {
    const s = this.length();
    return this.divideScalar(s || 1).multiplyScalar(ee(s, e, t));
  }
  /**
   * The components of this vector are rounded down to the nearest integer value.
   *
   * @return {Vector2} A reference to this vector.
   */
  floor() {
    return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
  }
  /**
   * The components of this vector are rounded up to the nearest integer value.
   *
   * @return {Vector2} A reference to this vector.
   */
  ceil() {
    return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
  }
  /**
   * The components of this vector are rounded to the nearest integer value
   *
   * @return {Vector2} A reference to this vector.
   */
  round() {
    return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
  }
  /**
   * The components of this vector are rounded towards zero (up if negative,
   * down if positive) to an integer value.
   *
   * @return {Vector2} A reference to this vector.
   */
  roundToZero() {
    return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this;
  }
  /**
   * Inverts this vector - i.e. sets x = -x and y = -y.
   *
   * @return {Vector2} A reference to this vector.
   */
  negate() {
    return this.x = -this.x, this.y = -this.y, this;
  }
  /**
   * Calculates the dot product of the given vector with this instance.
   *
   * @param {Vector2} v - The vector to compute the dot product with.
   * @return {number} The result of the dot product.
   */
  dot(e) {
    return this.x * e.x + this.y * e.y;
  }
  /**
   * Calculates the cross product of the given vector with this instance.
   *
   * @param {Vector2} v - The vector to compute the cross product with.
   * @return {number} The result of the cross product.
   */
  cross(e) {
    return this.x * e.y - this.y * e.x;
  }
  /**
   * Computes the square of the Euclidean length (straight-line length) from
   * (0, 0) to (x, y). If you are comparing the lengths of vectors, you should
   * compare the length squared instead as it is slightly more efficient to calculate.
   *
   * @return {number} The square length of this vector.
   */
  lengthSq() {
    return this.x * this.x + this.y * this.y;
  }
  /**
   * Computes the  Euclidean length (straight-line length) from (0, 0) to (x, y).
   *
   * @return {number} The length of this vector.
   */
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y);
  }
  /**
   * Computes the Manhattan length of this vector.
   *
   * @return {number} The length of this vector.
   */
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y);
  }
  /**
   * Converts this vector to a unit vector - that is, sets it equal to a vector
   * with the same direction as this one, but with a vector length of `1`.
   *
   * @return {Vector2} A reference to this vector.
   */
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  /**
   * Computes the angle in radians of this vector with respect to the positive x-axis.
   *
   * @return {number} The angle in radians.
   */
  angle() {
    return Math.atan2(-this.y, -this.x) + Math.PI;
  }
  /**
   * Returns the angle between the given vector and this instance in radians.
   *
   * @param {Vector2} v - The vector to compute the angle with.
   * @return {number} The angle in radians.
   */
  angleTo(e) {
    const t = Math.sqrt(this.lengthSq() * e.lengthSq());
    if (t === 0) return Math.PI / 2;
    const s = this.dot(e) / t;
    return Math.acos(ee(s, -1, 1));
  }
  /**
   * Computes the distance from the given vector to this instance.
   *
   * @param {Vector2} v - The vector to compute the distance to.
   * @return {number} The distance.
   */
  distanceTo(e) {
    return Math.sqrt(this.distanceToSquared(e));
  }
  /**
   * Computes the squared distance from the given vector to this instance.
   * If you are just comparing the distance with another distance, you should compare
   * the distance squared instead as it is slightly more efficient to calculate.
   *
   * @param {Vector2} v - The vector to compute the squared distance to.
   * @return {number} The squared distance.
   */
  distanceToSquared(e) {
    const t = this.x - e.x, s = this.y - e.y;
    return t * t + s * s;
  }
  /**
   * Computes the Manhattan distance from the given vector to this instance.
   *
   * @param {Vector2} v - The vector to compute the Manhattan distance to.
   * @return {number} The Manhattan distance.
   */
  manhattanDistanceTo(e) {
    return Math.abs(this.x - e.x) + Math.abs(this.y - e.y);
  }
  /**
   * Sets this vector to a vector with the same direction as this one, but
   * with the specified length.
   *
   * @param {number} length - The new length of this vector.
   * @return {Vector2} A reference to this vector.
   */
  setLength(e) {
    return this.normalize().multiplyScalar(e);
  }
  /**
   * Linearly interpolates between the given vector and this instance, where
   * alpha is the percent distance along the line - alpha = 0 will be this
   * vector, and alpha = 1 will be the given one.
   *
   * @param {Vector2} v - The vector to interpolate towards.
   * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
   * @return {Vector2} A reference to this vector.
   */
  lerp(e, t) {
    return this.x += (e.x - this.x) * t, this.y += (e.y - this.y) * t, this;
  }
  /**
   * Linearly interpolates between the given vectors, where alpha is the percent
   * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
   * be the second one. The result is stored in this instance.
   *
   * @param {Vector2} v1 - The first vector.
   * @param {Vector2} v2 - The second vector.
   * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
   * @return {Vector2} A reference to this vector.
   */
  lerpVectors(e, t, s) {
    return this.x = e.x + (t.x - e.x) * s, this.y = e.y + (t.y - e.y) * s, this;
  }
  /**
   * Returns `true` if this vector is equal with the given one.
   *
   * @param {Vector2} v - The vector to test for equality.
   * @return {boolean} Whether this vector is equal with the given one.
   */
  equals(e) {
    return e.x === this.x && e.y === this.y;
  }
  /**
   * Sets this vector's x value to be `array[ offset ]` and y
   * value to be `array[ offset + 1 ]`.
   *
   * @param {Array<number>} array - An array holding the vector component values.
   * @param {number} [offset=0] - The offset into the array.
   * @return {Vector2} A reference to this vector.
   */
  fromArray(e, t = 0) {
    return this.x = e[t], this.y = e[t + 1], this;
  }
  /**
   * Writes the components of this vector to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the vector components.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The vector components.
   */
  toArray(e = [], t = 0) {
    return e[t] = this.x, e[t + 1] = this.y, e;
  }
  /**
   * Sets the components of this vector from the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
   * @param {number} index - The index into the attribute.
   * @return {Vector2} A reference to this vector.
   */
  fromBufferAttribute(e, t) {
    return this.x = e.getX(t), this.y = e.getY(t), this;
  }
  /**
   * Rotates this vector around the given center by the given angle.
   *
   * @param {Vector2} center - The point around which to rotate.
   * @param {number} angle - The angle to rotate, in radians.
   * @return {Vector2} A reference to this vector.
   */
  rotateAround(e, t) {
    const s = Math.cos(t), i = Math.sin(t), a = this.x - e.x, n = this.y - e.y;
    return this.x = a * s - n * i + e.x, this.y = a * i + n * s + e.y, this;
  }
  /**
   * Sets each component of this vector to a pseudo-random value between `0` and
   * `1`, excluding `1`.
   *
   * @return {Vector2} A reference to this vector.
   */
  random() {
    return this.x = Math.random(), this.y = Math.random(), this;
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y;
  }
};
Fh.prototype.isVector2 = !0;
let _e = Fh;
class Gr {
  /**
   * Constructs a new quaternion.
   *
   * @param {number} [x=0] - The x value of this quaternion.
   * @param {number} [y=0] - The y value of this quaternion.
   * @param {number} [z=0] - The z value of this quaternion.
   * @param {number} [w=1] - The w value of this quaternion.
   */
  constructor(e = 0, t = 0, s = 0, i = 1) {
    this.isQuaternion = !0, this._x = e, this._y = t, this._z = s, this._w = i;
  }
  /**
   * Interpolates between two quaternions via SLERP. This implementation assumes the
   * quaternion data are managed in flat arrays.
   *
   * @param {Array<number>} dst - The destination array.
   * @param {number} dstOffset - An offset into the destination array.
   * @param {Array<number>} src0 - The source array of the first quaternion.
   * @param {number} srcOffset0 - An offset into the first source array.
   * @param {Array<number>} src1 -  The source array of the second quaternion.
   * @param {number} srcOffset1 - An offset into the second source array.
   * @param {number} t - The interpolation factor. A value in the range `[0,1]` will interpolate. A value outside the range `[0,1]` will extrapolate.
   * @see {@link Quaternion#slerp}
   */
  static slerpFlat(e, t, s, i, a, n, o) {
    let l = s[i + 0], u = s[i + 1], h = s[i + 2], d = s[i + 3], p = a[n + 0], m = a[n + 1], g = a[n + 2], y = a[n + 3];
    if (d !== y || l !== p || u !== m || h !== g) {
      let v = l * p + u * m + h * g + d * y;
      v < 0 && (p = -p, m = -m, g = -g, y = -y, v = -v);
      let w = 1 - o;
      if (v < 0.9995) {
        const _ = Math.acos(v), C = Math.sin(_);
        w = Math.sin(w * _) / C, o = Math.sin(o * _) / C, l = l * w + p * o, u = u * w + m * o, h = h * w + g * o, d = d * w + y * o;
      } else {
        l = l * w + p * o, u = u * w + m * o, h = h * w + g * o, d = d * w + y * o;
        const _ = 1 / Math.sqrt(l * l + u * u + h * h + d * d);
        l *= _, u *= _, h *= _, d *= _;
      }
    }
    e[t] = l, e[t + 1] = u, e[t + 2] = h, e[t + 3] = d;
  }
  /**
   * Multiplies two quaternions. This implementation assumes the quaternion data are managed
   * in flat arrays.
   *
   * @param {Array<number>} dst - The destination array.
   * @param {number} dstOffset - An offset into the destination array.
   * @param {Array<number>} src0 - The source array of the first quaternion.
   * @param {number} srcOffset0 - An offset into the first source array.
   * @param {Array<number>} src1 -  The source array of the second quaternion.
   * @param {number} srcOffset1 - An offset into the second source array.
   * @return {Array<number>} The destination array.
   * @see {@link Quaternion#multiplyQuaternions}.
   */
  static multiplyQuaternionsFlat(e, t, s, i, a, n) {
    const o = s[i], l = s[i + 1], u = s[i + 2], h = s[i + 3], d = a[n], p = a[n + 1], m = a[n + 2], g = a[n + 3];
    return e[t] = o * g + h * d + l * m - u * p, e[t + 1] = l * g + h * p + u * d - o * m, e[t + 2] = u * g + h * m + o * p - l * d, e[t + 3] = h * g - o * d - l * p - u * m, e;
  }
  /**
   * The x value of this quaternion.
   *
   * @type {number}
   * @default 0
   */
  get x() {
    return this._x;
  }
  set x(e) {
    this._x = e, this._onChangeCallback();
  }
  /**
   * The y value of this quaternion.
   *
   * @type {number}
   * @default 0
   */
  get y() {
    return this._y;
  }
  set y(e) {
    this._y = e, this._onChangeCallback();
  }
  /**
   * The z value of this quaternion.
   *
   * @type {number}
   * @default 0
   */
  get z() {
    return this._z;
  }
  set z(e) {
    this._z = e, this._onChangeCallback();
  }
  /**
   * The w value of this quaternion.
   *
   * @type {number}
   * @default 1
   */
  get w() {
    return this._w;
  }
  set w(e) {
    this._w = e, this._onChangeCallback();
  }
  /**
   * Sets the quaternion components.
   *
   * @param {number} x - The x value of this quaternion.
   * @param {number} y - The y value of this quaternion.
   * @param {number} z - The z value of this quaternion.
   * @param {number} w - The w value of this quaternion.
   * @return {Quaternion} A reference to this quaternion.
   */
  set(e, t, s, i) {
    return this._x = e, this._y = t, this._z = s, this._w = i, this._onChangeCallback(), this;
  }
  /**
   * Returns a new quaternion with copied values from this instance.
   *
   * @return {Quaternion} A clone of this instance.
   */
  clone() {
    return new this.constructor(this._x, this._y, this._z, this._w);
  }
  /**
   * Copies the values of the given quaternion to this instance.
   *
   * @param {Quaternion} quaternion - The quaternion to copy.
   * @return {Quaternion} A reference to this quaternion.
   */
  copy(e) {
    return this._x = e.x, this._y = e.y, this._z = e.z, this._w = e.w, this._onChangeCallback(), this;
  }
  /**
   * Sets this quaternion from the rotation specified by the given
   * Euler angles.
   *
   * @param {Euler} euler - The Euler angles.
   * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
   * @return {Quaternion} A reference to this quaternion.
   */
  setFromEuler(e, t = !0) {
    const s = e._x, i = e._y, a = e._z, n = e._order, o = Math.cos, l = Math.sin, u = o(s / 2), h = o(i / 2), d = o(a / 2), p = l(s / 2), m = l(i / 2), g = l(a / 2);
    switch (n) {
      case "XYZ":
        this._x = p * h * d + u * m * g, this._y = u * m * d - p * h * g, this._z = u * h * g + p * m * d, this._w = u * h * d - p * m * g;
        break;
      case "YXZ":
        this._x = p * h * d + u * m * g, this._y = u * m * d - p * h * g, this._z = u * h * g - p * m * d, this._w = u * h * d + p * m * g;
        break;
      case "ZXY":
        this._x = p * h * d - u * m * g, this._y = u * m * d + p * h * g, this._z = u * h * g + p * m * d, this._w = u * h * d - p * m * g;
        break;
      case "ZYX":
        this._x = p * h * d - u * m * g, this._y = u * m * d + p * h * g, this._z = u * h * g - p * m * d, this._w = u * h * d + p * m * g;
        break;
      case "YZX":
        this._x = p * h * d + u * m * g, this._y = u * m * d + p * h * g, this._z = u * h * g - p * m * d, this._w = u * h * d - p * m * g;
        break;
      case "XZY":
        this._x = p * h * d - u * m * g, this._y = u * m * d - p * h * g, this._z = u * h * g + p * m * d, this._w = u * h * d + p * m * g;
        break;
      default:
        X("Quaternion: .setFromEuler() encountered an unknown order: " + n);
    }
    return t === !0 && this._onChangeCallback(), this;
  }
  /**
   * Sets this quaternion from the given axis and angle.
   *
   * @param {Vector3} axis - The normalized axis.
   * @param {number} angle - The angle in radians.
   * @return {Quaternion} A reference to this quaternion.
   */
  setFromAxisAngle(e, t) {
    const s = t / 2, i = Math.sin(s);
    return this._x = e.x * i, this._y = e.y * i, this._z = e.z * i, this._w = Math.cos(s), this._onChangeCallback(), this;
  }
  /**
   * Sets this quaternion from the given rotation matrix.
   *
   * @param {Matrix4} m - A 4x4 matrix of which the upper 3x3 of matrix is a pure rotation matrix (i.e. unscaled).
   * @return {Quaternion} A reference to this quaternion.
   */
  setFromRotationMatrix(e) {
    const t = e.elements, s = t[0], i = t[4], a = t[8], n = t[1], o = t[5], l = t[9], u = t[2], h = t[6], d = t[10], p = s + o + d;
    if (p > 0) {
      const m = 0.5 / Math.sqrt(p + 1);
      this._w = 0.25 / m, this._x = (h - l) * m, this._y = (a - u) * m, this._z = (n - i) * m;
    } else if (s > o && s > d) {
      const m = 2 * Math.sqrt(1 + s - o - d);
      this._w = (h - l) / m, this._x = 0.25 * m, this._y = (i + n) / m, this._z = (a + u) / m;
    } else if (o > d) {
      const m = 2 * Math.sqrt(1 + o - s - d);
      this._w = (a - u) / m, this._x = (i + n) / m, this._y = 0.25 * m, this._z = (l + h) / m;
    } else {
      const m = 2 * Math.sqrt(1 + d - s - o);
      this._w = (n - i) / m, this._x = (a + u) / m, this._y = (l + h) / m, this._z = 0.25 * m;
    }
    return this._onChangeCallback(), this;
  }
  /**
   * Sets this quaternion to the rotation required to rotate the direction vector
   * `vFrom` to the direction vector `vTo`.
   *
   * @param {Vector3} vFrom - The first (normalized) direction vector.
   * @param {Vector3} vTo - The second (normalized) direction vector.
   * @return {Quaternion} A reference to this quaternion.
   */
  setFromUnitVectors(e, t) {
    let s = e.dot(t) + 1;
    return s < 1e-8 ? (s = 0, Math.abs(e.x) > Math.abs(e.z) ? (this._x = -e.y, this._y = e.x, this._z = 0, this._w = s) : (this._x = 0, this._y = -e.z, this._z = e.y, this._w = s)) : (this._x = e.y * t.z - e.z * t.y, this._y = e.z * t.x - e.x * t.z, this._z = e.x * t.y - e.y * t.x, this._w = s), this.normalize();
  }
  /**
   * Returns the angle between this quaternion and the given one in radians.
   *
   * @param {Quaternion} q - The quaternion to compute the angle with.
   * @return {number} The angle in radians.
   */
  angleTo(e) {
    return 2 * Math.acos(Math.abs(ee(this.dot(e), -1, 1)));
  }
  /**
   * Rotates this quaternion by a given angular step to the given quaternion.
   * The method ensures that the final quaternion will not overshoot `q`.
   *
   * @param {Quaternion} q - The target quaternion.
   * @param {number} step - The angular step in radians.
   * @return {Quaternion} A reference to this quaternion.
   */
  rotateTowards(e, t) {
    const s = this.angleTo(e);
    if (s === 0) return this;
    const i = Math.min(1, t / s);
    return this.slerp(e, i), this;
  }
  /**
   * Sets this quaternion to the identity quaternion; that is, to the
   * quaternion that represents "no rotation".
   *
   * @return {Quaternion} A reference to this quaternion.
   */
  identity() {
    return this.set(0, 0, 0, 1);
  }
  /**
   * Inverts this quaternion via {@link Quaternion#conjugate}. The
   * quaternion is assumed to have unit length.
   *
   * @return {Quaternion} A reference to this quaternion.
   */
  invert() {
    return this.conjugate();
  }
  /**
   * Returns the rotational conjugate of this quaternion. The conjugate of a
   * quaternion represents the same rotation in the opposite direction about
   * the rotational axis.
   *
   * @return {Quaternion} A reference to this quaternion.
   */
  conjugate() {
    return this._x *= -1, this._y *= -1, this._z *= -1, this._onChangeCallback(), this;
  }
  /**
   * Calculates the dot product of this quaternion and the given one.
   *
   * @param {Quaternion} v - The quaternion to compute the dot product with.
   * @return {number} The result of the dot product.
   */
  dot(e) {
    return this._x * e._x + this._y * e._y + this._z * e._z + this._w * e._w;
  }
  /**
   * Computes the squared Euclidean length (straight-line length) of this quaternion,
   * considered as a 4 dimensional vector. This can be useful if you are comparing the
   * lengths of two quaternions, as this is a slightly more efficient calculation than
   * {@link Quaternion#length}.
   *
   * @return {number} The squared Euclidean length.
   */
  lengthSq() {
    return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
  }
  /**
   * Computes the Euclidean length (straight-line length) of this quaternion,
   * considered as a 4 dimensional vector.
   *
   * @return {number} The Euclidean length.
   */
  length() {
    return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
  }
  /**
   * Normalizes this quaternion - that is, calculated the quaternion that performs
   * the same rotation as this one, but has a length equal to `1`.
   *
   * @return {Quaternion} A reference to this quaternion.
   */
  normalize() {
    let e = this.length();
    return e === 0 ? (this._x = 0, this._y = 0, this._z = 0, this._w = 1) : (e = 1 / e, this._x = this._x * e, this._y = this._y * e, this._z = this._z * e, this._w = this._w * e), this._onChangeCallback(), this;
  }
  /**
   * Multiplies this quaternion by the given one.
   *
   * @param {Quaternion} q - The quaternion.
   * @return {Quaternion} A reference to this quaternion.
   */
  multiply(e) {
    return this.multiplyQuaternions(this, e);
  }
  /**
   * Pre-multiplies this quaternion by the given one.
   *
   * @param {Quaternion} q - The quaternion.
   * @return {Quaternion} A reference to this quaternion.
   */
  premultiply(e) {
    return this.multiplyQuaternions(e, this);
  }
  /**
   * Multiplies the given quaternions and stores the result in this instance.
   *
   * @param {Quaternion} a - The first quaternion.
   * @param {Quaternion} b - The second quaternion.
   * @return {Quaternion} A reference to this quaternion.
   */
  multiplyQuaternions(e, t) {
    const s = e._x, i = e._y, a = e._z, n = e._w, o = t._x, l = t._y, u = t._z, h = t._w;
    return this._x = s * h + n * o + i * u - a * l, this._y = i * h + n * l + a * o - s * u, this._z = a * h + n * u + s * l - i * o, this._w = n * h - s * o - i * l - a * u, this._onChangeCallback(), this;
  }
  /**
   * Performs a spherical linear interpolation between this quaternion and the target quaternion.
   *
   * @param {Quaternion} qb - The target quaternion.
   * @param {number} t - The interpolation factor. A value in the range `[0,1]` will interpolate. A value outside the range `[0,1]` will extrapolate.
   * @return {Quaternion} A reference to this quaternion.
   */
  slerp(e, t) {
    let s = e._x, i = e._y, a = e._z, n = e._w, o = this.dot(e);
    o < 0 && (s = -s, i = -i, a = -a, n = -n, o = -o);
    let l = 1 - t;
    if (o < 0.9995) {
      const u = Math.acos(o), h = Math.sin(u);
      l = Math.sin(l * u) / h, t = Math.sin(t * u) / h, this._x = this._x * l + s * t, this._y = this._y * l + i * t, this._z = this._z * l + a * t, this._w = this._w * l + n * t, this._onChangeCallback();
    } else
      this._x = this._x * l + s * t, this._y = this._y * l + i * t, this._z = this._z * l + a * t, this._w = this._w * l + n * t, this.normalize();
    return this;
  }
  /**
   * Performs a spherical linear interpolation between the given quaternions
   * and stores the result in this quaternion.
   *
   * @param {Quaternion} qa - The source quaternion.
   * @param {Quaternion} qb - The target quaternion.
   * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
   * @return {Quaternion} A reference to this quaternion.
   */
  slerpQuaternions(e, t, s) {
    return this.copy(e).slerp(t, s);
  }
  /**
   * Sets this quaternion to a uniformly random, normalized quaternion.
   *
   * @return {Quaternion} A reference to this quaternion.
   */
  random() {
    const e = 2 * Math.PI * Math.random(), t = 2 * Math.PI * Math.random(), s = Math.random(), i = Math.sqrt(1 - s), a = Math.sqrt(s);
    return this.set(
      i * Math.sin(e),
      i * Math.cos(e),
      a * Math.sin(t),
      a * Math.cos(t)
    );
  }
  /**
   * Returns `true` if this quaternion is equal with the given one.
   *
   * @param {Quaternion} quaternion - The quaternion to test for equality.
   * @return {boolean} Whether this quaternion is equal with the given one.
   */
  equals(e) {
    return e._x === this._x && e._y === this._y && e._z === this._z && e._w === this._w;
  }
  /**
   * Sets this quaternion's components from the given array.
   *
   * @param {Array<number>} array - An array holding the quaternion component values.
   * @param {number} [offset=0] - The offset into the array.
   * @return {Quaternion} A reference to this quaternion.
   */
  fromArray(e, t = 0) {
    return this._x = e[t], this._y = e[t + 1], this._z = e[t + 2], this._w = e[t + 3], this._onChangeCallback(), this;
  }
  /**
   * Writes the components of this quaternion to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the quaternion components.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The quaternion components.
   */
  toArray(e = [], t = 0) {
    return e[t] = this._x, e[t + 1] = this._y, e[t + 2] = this._z, e[t + 3] = this._w, e;
  }
  /**
   * Sets the components of this quaternion from the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute holding quaternion data.
   * @param {number} index - The index into the attribute.
   * @return {Quaternion} A reference to this quaternion.
   */
  fromBufferAttribute(e, t) {
    return this._x = e.getX(t), this._y = e.getY(t), this._z = e.getZ(t), this._w = e.getW(t), this._onChangeCallback(), this;
  }
  /**
   * This methods defines the serialization result of this class. Returns the
   * numerical elements of this quaternion in an array of format `[x, y, z, w]`.
   *
   * @return {Array<number>} The serialized quaternion.
   */
  toJSON() {
    return this.toArray();
  }
  _onChange(e) {
    return this._onChangeCallback = e, this;
  }
  _onChangeCallback() {
  }
  *[Symbol.iterator]() {
    yield this._x, yield this._y, yield this._z, yield this._w;
  }
}
const Bh = class {
  /**
   * Constructs a new 3D vector.
   *
   * @param {number} [x=0] - The x value of this vector.
   * @param {number} [y=0] - The y value of this vector.
   * @param {number} [z=0] - The z value of this vector.
   */
  constructor(e = 0, t = 0, s = 0) {
    this.x = e, this.y = t, this.z = s;
  }
  /**
   * Sets the vector components.
   *
   * @param {number} x - The value of the x component.
   * @param {number} y - The value of the y component.
   * @param {number} z - The value of the z component.
   * @return {Vector3} A reference to this vector.
   */
  set(e, t, s) {
    return s === void 0 && (s = this.z), this.x = e, this.y = t, this.z = s, this;
  }
  /**
   * Sets the vector components to the same value.
   *
   * @param {number} scalar - The value to set for all vector components.
   * @return {Vector3} A reference to this vector.
   */
  setScalar(e) {
    return this.x = e, this.y = e, this.z = e, this;
  }
  /**
   * Sets the vector's x component to the given value.
   *
   * @param {number} x - The value to set.
   * @return {Vector3} A reference to this vector.
   */
  setX(e) {
    return this.x = e, this;
  }
  /**
   * Sets the vector's y component to the given value.
   *
   * @param {number} y - The value to set.
   * @return {Vector3} A reference to this vector.
   */
  setY(e) {
    return this.y = e, this;
  }
  /**
   * Sets the vector's z component to the given value.
   *
   * @param {number} z - The value to set.
   * @return {Vector3} A reference to this vector.
   */
  setZ(e) {
    return this.z = e, this;
  }
  /**
   * Allows to set a vector component with an index.
   *
   * @param {number} index - The component index. `0` equals to x, `1` equals to y, `2` equals to z.
   * @param {number} value - The value to set.
   * @return {Vector3} A reference to this vector.
   */
  setComponent(e, t) {
    switch (e) {
      case 0:
        this.x = t;
        break;
      case 1:
        this.y = t;
        break;
      case 2:
        this.z = t;
        break;
      default:
        throw new Error("THREE.Vector3: index is out of range: " + e);
    }
    return this;
  }
  /**
   * Returns the value of the vector component which matches the given index.
   *
   * @param {number} index - The component index. `0` equals to x, `1` equals to y, `2` equals to z.
   * @return {number} A vector component value.
   */
  getComponent(e) {
    switch (e) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      case 2:
        return this.z;
      default:
        throw new Error("THREE.Vector3: index is out of range: " + e);
    }
  }
  /**
   * Returns a new vector with copied values from this instance.
   *
   * @return {Vector3} A clone of this instance.
   */
  clone() {
    return new this.constructor(this.x, this.y, this.z);
  }
  /**
   * Copies the values of the given vector to this instance.
   *
   * @param {Vector3} v - The vector to copy.
   * @return {Vector3} A reference to this vector.
   */
  copy(e) {
    return this.x = e.x, this.y = e.y, this.z = e.z, this;
  }
  /**
   * Adds the given vector to this instance.
   *
   * @param {Vector3} v - The vector to add.
   * @return {Vector3} A reference to this vector.
   */
  add(e) {
    return this.x += e.x, this.y += e.y, this.z += e.z, this;
  }
  /**
   * Adds the given scalar value to all components of this instance.
   *
   * @param {number} s - The scalar to add.
   * @return {Vector3} A reference to this vector.
   */
  addScalar(e) {
    return this.x += e, this.y += e, this.z += e, this;
  }
  /**
   * Adds the given vectors and stores the result in this instance.
   *
   * @param {Vector3} a - The first vector.
   * @param {Vector3} b - The second vector.
   * @return {Vector3} A reference to this vector.
   */
  addVectors(e, t) {
    return this.x = e.x + t.x, this.y = e.y + t.y, this.z = e.z + t.z, this;
  }
  /**
   * Adds the given vector scaled by the given factor to this instance.
   *
   * @param {Vector3|Vector4} v - The vector.
   * @param {number} s - The factor that scales `v`.
   * @return {Vector3} A reference to this vector.
   */
  addScaledVector(e, t) {
    return this.x += e.x * t, this.y += e.y * t, this.z += e.z * t, this;
  }
  /**
   * Subtracts the given vector from this instance.
   *
   * @param {Vector3} v - The vector to subtract.
   * @return {Vector3} A reference to this vector.
   */
  sub(e) {
    return this.x -= e.x, this.y -= e.y, this.z -= e.z, this;
  }
  /**
   * Subtracts the given scalar value from all components of this instance.
   *
   * @param {number} s - The scalar to subtract.
   * @return {Vector3} A reference to this vector.
   */
  subScalar(e) {
    return this.x -= e, this.y -= e, this.z -= e, this;
  }
  /**
   * Subtracts the given vectors and stores the result in this instance.
   *
   * @param {Vector3} a - The first vector.
   * @param {Vector3} b - The second vector.
   * @return {Vector3} A reference to this vector.
   */
  subVectors(e, t) {
    return this.x = e.x - t.x, this.y = e.y - t.y, this.z = e.z - t.z, this;
  }
  /**
   * Multiplies the given vector with this instance.
   *
   * @param {Vector3} v - The vector to multiply.
   * @return {Vector3} A reference to this vector.
   */
  multiply(e) {
    return this.x *= e.x, this.y *= e.y, this.z *= e.z, this;
  }
  /**
   * Multiplies the given scalar value with all components of this instance.
   *
   * @param {number} scalar - The scalar to multiply.
   * @return {Vector3} A reference to this vector.
   */
  multiplyScalar(e) {
    return this.x *= e, this.y *= e, this.z *= e, this;
  }
  /**
   * Multiplies the given vectors and stores the result in this instance.
   *
   * @param {Vector3} a - The first vector.
   * @param {Vector3} b - The second vector.
   * @return {Vector3} A reference to this vector.
   */
  multiplyVectors(e, t) {
    return this.x = e.x * t.x, this.y = e.y * t.y, this.z = e.z * t.z, this;
  }
  /**
   * Applies the given Euler rotation to this vector.
   *
   * @param {Euler} euler - The Euler angles.
   * @return {Vector3} A reference to this vector.
   */
  applyEuler(e) {
    return this.applyQuaternion(Nu.setFromEuler(e));
  }
  /**
   * Applies a rotation specified by an axis and an angle to this vector.
   *
   * @param {Vector3} axis - A normalized vector representing the rotation axis.
   * @param {number} angle - The angle in radians.
   * @return {Vector3} A reference to this vector.
   */
  applyAxisAngle(e, t) {
    return this.applyQuaternion(Nu.setFromAxisAngle(e, t));
  }
  /**
   * Multiplies this vector with the given 3x3 matrix.
   *
   * @param {Matrix3} m - The 3x3 matrix.
   * @return {Vector3} A reference to this vector.
   */
  applyMatrix3(e) {
    const t = this.x, s = this.y, i = this.z, a = e.elements;
    return this.x = a[0] * t + a[3] * s + a[6] * i, this.y = a[1] * t + a[4] * s + a[7] * i, this.z = a[2] * t + a[5] * s + a[8] * i, this;
  }
  /**
   * Multiplies this vector by the given normal matrix and normalizes
   * the result.
   *
   * @param {Matrix3} m - The normal matrix.
   * @return {Vector3} A reference to this vector.
   */
  applyNormalMatrix(e) {
    return this.applyMatrix3(e).normalize();
  }
  /**
   * Multiplies this vector (with an implicit 1 in the 4th dimension) by m, and
   * divides by perspective.
   *
   * @param {Matrix4} m - The matrix to apply.
   * @return {Vector3} A reference to this vector.
   */
  applyMatrix4(e) {
    const t = this.x, s = this.y, i = this.z, a = e.elements, n = 1 / (a[3] * t + a[7] * s + a[11] * i + a[15]);
    return this.x = (a[0] * t + a[4] * s + a[8] * i + a[12]) * n, this.y = (a[1] * t + a[5] * s + a[9] * i + a[13]) * n, this.z = (a[2] * t + a[6] * s + a[10] * i + a[14]) * n, this;
  }
  /**
   * Applies the given Quaternion to this vector.
   *
   * @param {Quaternion} q - The Quaternion.
   * @return {Vector3} A reference to this vector.
   */
  applyQuaternion(e) {
    const t = this.x, s = this.y, i = this.z, a = e.x, n = e.y, o = e.z, l = e.w, u = 2 * (n * i - o * s), h = 2 * (o * t - a * i), d = 2 * (a * s - n * t);
    return this.x = t + l * u + n * d - o * h, this.y = s + l * h + o * u - a * d, this.z = i + l * d + a * h - n * u, this;
  }
  /**
   * Projects this vector from world space into the camera's normalized
   * device coordinate (NDC) space.
   *
   * @param {Camera} camera - The camera.
   * @return {Vector3} A reference to this vector.
   */
  project(e) {
    return this.applyMatrix4(e.matrixWorldInverse).applyMatrix4(e.projectionMatrix);
  }
  /**
   * Unprojects this vector from the camera's normalized device coordinate (NDC)
   * space into world space.
   *
   * @param {Camera} camera - The camera.
   * @return {Vector3} A reference to this vector.
   */
  unproject(e) {
    return this.applyMatrix4(e.projectionMatrixInverse).applyMatrix4(e.matrixWorld);
  }
  /**
   * Transforms the direction of this vector by a matrix (the upper left 3 x 3
   * subset of the given 4x4 matrix and then normalizes the result.
   *
   * @param {Matrix4} m - The matrix.
   * @return {Vector3} A reference to this vector.
   */
  transformDirection(e) {
    const t = this.x, s = this.y, i = this.z, a = e.elements;
    return this.x = a[0] * t + a[4] * s + a[8] * i, this.y = a[1] * t + a[5] * s + a[9] * i, this.z = a[2] * t + a[6] * s + a[10] * i, this.normalize();
  }
  /**
   * Divides this instance by the given vector.
   *
   * @param {Vector3} v - The vector to divide.
   * @return {Vector3} A reference to this vector.
   */
  divide(e) {
    return this.x /= e.x, this.y /= e.y, this.z /= e.z, this;
  }
  /**
   * Divides this vector by the given scalar.
   *
   * @param {number} scalar - The scalar to divide.
   * @return {Vector3} A reference to this vector.
   */
  divideScalar(e) {
    return this.multiplyScalar(1 / e);
  }
  /**
   * If this vector's x, y or z value is greater than the given vector's x, y or z
   * value, replace that value with the corresponding min value.
   *
   * @param {Vector3} v - The vector.
   * @return {Vector3} A reference to this vector.
   */
  min(e) {
    return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this.z = Math.min(this.z, e.z), this;
  }
  /**
   * If this vector's x, y or z value is less than the given vector's x, y or z
   * value, replace that value with the corresponding max value.
   *
   * @param {Vector3} v - The vector.
   * @return {Vector3} A reference to this vector.
   */
  max(e) {
    return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this.z = Math.max(this.z, e.z), this;
  }
  /**
   * If this vector's x, y or z value is greater than the max vector's x, y or z
   * value, it is replaced by the corresponding value.
   * If this vector's x, y or z value is less than the min vector's x, y or z value,
   * it is replaced by the corresponding value.
   *
   * @param {Vector3} min - The minimum x, y and z values.
   * @param {Vector3} max - The maximum x, y and z values in the desired range.
   * @return {Vector3} A reference to this vector.
   */
  clamp(e, t) {
    return this.x = ee(this.x, e.x, t.x), this.y = ee(this.y, e.y, t.y), this.z = ee(this.z, e.z, t.z), this;
  }
  /**
   * If this vector's x, y or z values are greater than the max value, they are
   * replaced by the max value.
   * If this vector's x, y or z values are less than the min value, they are
   * replaced by the min value.
   *
   * @param {number} minVal - The minimum value the components will be clamped to.
   * @param {number} maxVal - The maximum value the components will be clamped to.
   * @return {Vector3} A reference to this vector.
   */
  clampScalar(e, t) {
    return this.x = ee(this.x, e, t), this.y = ee(this.y, e, t), this.z = ee(this.z, e, t), this;
  }
  /**
   * If this vector's length is greater than the max value, it is replaced by
   * the max value.
   * If this vector's length is less than the min value, it is replaced by the
   * min value.
   *
   * @param {number} min - The minimum value the vector length will be clamped to.
   * @param {number} max - The maximum value the vector length will be clamped to.
   * @return {Vector3} A reference to this vector.
   */
  clampLength(e, t) {
    const s = this.length();
    return this.divideScalar(s || 1).multiplyScalar(ee(s, e, t));
  }
  /**
   * The components of this vector are rounded down to the nearest integer value.
   *
   * @return {Vector3} A reference to this vector.
   */
  floor() {
    return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this;
  }
  /**
   * The components of this vector are rounded up to the nearest integer value.
   *
   * @return {Vector3} A reference to this vector.
   */
  ceil() {
    return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this;
  }
  /**
   * The components of this vector are rounded to the nearest integer value
   *
   * @return {Vector3} A reference to this vector.
   */
  round() {
    return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this;
  }
  /**
   * The components of this vector are rounded towards zero (up if negative,
   * down if positive) to an integer value.
   *
   * @return {Vector3} A reference to this vector.
   */
  roundToZero() {
    return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this;
  }
  /**
   * Inverts this vector - i.e. sets x = -x, y = -y and z = -z.
   *
   * @return {Vector3} A reference to this vector.
   */
  negate() {
    return this.x = -this.x, this.y = -this.y, this.z = -this.z, this;
  }
  /**
   * Calculates the dot product of the given vector with this instance.
   *
   * @param {Vector3} v - The vector to compute the dot product with.
   * @return {number} The result of the dot product.
   */
  dot(e) {
    return this.x * e.x + this.y * e.y + this.z * e.z;
  }
  /**
   * Computes the square of the Euclidean length (straight-line length) from
   * (0, 0, 0) to (x, y, z). If you are comparing the lengths of vectors, you should
   * compare the length squared instead as it is slightly more efficient to calculate.
   *
   * @return {number} The square length of this vector.
   */
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z;
  }
  /**
   * Computes the  Euclidean length (straight-line length) from (0, 0, 0) to (x, y, z).
   *
   * @return {number} The length of this vector.
   */
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
  }
  /**
   * Computes the Manhattan length of this vector.
   *
   * @return {number} The length of this vector.
   */
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
  }
  /**
   * Converts this vector to a unit vector - that is, sets it equal to a vector
   * with the same direction as this one, but with a vector length of `1`.
   *
   * @return {Vector3} A reference to this vector.
   */
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  /**
   * Sets this vector to a vector with the same direction as this one, but
   * with the specified length.
   *
   * @param {number} length - The new length of this vector.
   * @return {Vector3} A reference to this vector.
   */
  setLength(e) {
    return this.normalize().multiplyScalar(e);
  }
  /**
   * Linearly interpolates between the given vector and this instance, where
   * alpha is the percent distance along the line - alpha = 0 will be this
   * vector, and alpha = 1 will be the given one.
   *
   * @param {Vector3} v - The vector to interpolate towards.
   * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
   * @return {Vector3} A reference to this vector.
   */
  lerp(e, t) {
    return this.x += (e.x - this.x) * t, this.y += (e.y - this.y) * t, this.z += (e.z - this.z) * t, this;
  }
  /**
   * Linearly interpolates between the given vectors, where alpha is the percent
   * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
   * be the second one. The result is stored in this instance.
   *
   * @param {Vector3} v1 - The first vector.
   * @param {Vector3} v2 - The second vector.
   * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
   * @return {Vector3} A reference to this vector.
   */
  lerpVectors(e, t, s) {
    return this.x = e.x + (t.x - e.x) * s, this.y = e.y + (t.y - e.y) * s, this.z = e.z + (t.z - e.z) * s, this;
  }
  /**
   * Calculates the cross product of the given vector with this instance.
   *
   * @param {Vector3} v - The vector to compute the cross product with.
   * @return {Vector3} The result of the cross product.
   */
  cross(e) {
    return this.crossVectors(this, e);
  }
  /**
   * Calculates the cross product of the given vectors and stores the result
   * in this instance.
   *
   * @param {Vector3} a - The first vector.
   * @param {Vector3} b - The second vector.
   * @return {Vector3} A reference to this vector.
   */
  crossVectors(e, t) {
    const s = e.x, i = e.y, a = e.z, n = t.x, o = t.y, l = t.z;
    return this.x = i * l - a * o, this.y = a * n - s * l, this.z = s * o - i * n, this;
  }
  /**
   * Projects this vector onto the given one.
   *
   * @param {Vector3} v - The vector to project to.
   * @return {Vector3} A reference to this vector.
   */
  projectOnVector(e) {
    const t = e.lengthSq();
    if (t === 0) return this.set(0, 0, 0);
    const s = e.dot(this) / t;
    return this.copy(e).multiplyScalar(s);
  }
  /**
   * Projects this vector onto a plane by subtracting this
   * vector projected onto the plane's normal from this vector.
   *
   * @param {Vector3} planeNormal - The plane normal.
   * @return {Vector3} A reference to this vector.
   */
  projectOnPlane(e) {
    return xn.copy(this).projectOnVector(e), this.sub(xn);
  }
  /**
   * Reflects this vector off a plane orthogonal to the given normal vector.
   *
   * @param {Vector3} normal - The (normalized) normal vector.
   * @return {Vector3} A reference to this vector.
   */
  reflect(e) {
    return this.sub(xn.copy(e).multiplyScalar(2 * this.dot(e)));
  }
  /**
   * Returns the angle between the given vector and this instance in radians.
   *
   * @param {Vector3} v - The vector to compute the angle with.
   * @return {number} The angle in radians.
   */
  angleTo(e) {
    const t = Math.sqrt(this.lengthSq() * e.lengthSq());
    if (t === 0) return Math.PI / 2;
    const s = this.dot(e) / t;
    return Math.acos(ee(s, -1, 1));
  }
  /**
   * Computes the distance from the given vector to this instance.
   *
   * @param {Vector3} v - The vector to compute the distance to.
   * @return {number} The distance.
   */
  distanceTo(e) {
    return Math.sqrt(this.distanceToSquared(e));
  }
  /**
   * Computes the squared distance from the given vector to this instance.
   * If you are just comparing the distance with another distance, you should compare
   * the distance squared instead as it is slightly more efficient to calculate.
   *
   * @param {Vector3} v - The vector to compute the squared distance to.
   * @return {number} The squared distance.
   */
  distanceToSquared(e) {
    const t = this.x - e.x, s = this.y - e.y, i = this.z - e.z;
    return t * t + s * s + i * i;
  }
  /**
   * Computes the Manhattan distance from the given vector to this instance.
   *
   * @param {Vector3} v - The vector to compute the Manhattan distance to.
   * @return {number} The Manhattan distance.
   */
  manhattanDistanceTo(e) {
    return Math.abs(this.x - e.x) + Math.abs(this.y - e.y) + Math.abs(this.z - e.z);
  }
  /**
   * Sets the vector components from the given spherical coordinates.
   *
   * @param {Spherical} s - The spherical coordinates.
   * @return {Vector3} A reference to this vector.
   */
  setFromSpherical(e) {
    return this.setFromSphericalCoords(e.radius, e.phi, e.theta);
  }
  /**
   * Sets the vector components from the given spherical coordinates.
   *
   * @param {number} radius - The radius.
   * @param {number} phi - The phi angle in radians.
   * @param {number} theta - The theta angle in radians.
   * @return {Vector3} A reference to this vector.
   */
  setFromSphericalCoords(e, t, s) {
    const i = Math.sin(t) * e;
    return this.x = i * Math.sin(s), this.y = Math.cos(t) * e, this.z = i * Math.cos(s), this;
  }
  /**
   * Sets the vector components from the given cylindrical coordinates.
   *
   * @param {Cylindrical} c - The cylindrical coordinates.
   * @return {Vector3} A reference to this vector.
   */
  setFromCylindrical(e) {
    return this.setFromCylindricalCoords(e.radius, e.theta, e.y);
  }
  /**
   * Sets the vector components from the given cylindrical coordinates.
   *
   * @param {number} radius - The radius.
   * @param {number} theta - The theta angle in radians.
   * @param {number} y - The y value.
   * @return {Vector3} A reference to this vector.
   */
  setFromCylindricalCoords(e, t, s) {
    return this.x = e * Math.sin(t), this.y = s, this.z = e * Math.cos(t), this;
  }
  /**
   * Sets the vector components to the position elements of the
   * given transformation matrix.
   *
   * @param {Matrix4} m - The 4x4 matrix.
   * @return {Vector3} A reference to this vector.
   */
  setFromMatrixPosition(e) {
    const t = e.elements;
    return this.x = t[12], this.y = t[13], this.z = t[14], this;
  }
  /**
   * Sets the vector components to the scale elements of the
   * given transformation matrix.
   *
   * @param {Matrix4} m - The 4x4 matrix.
   * @return {Vector3} A reference to this vector.
   */
  setFromMatrixScale(e) {
    const t = this.setFromMatrixColumn(e, 0).length(), s = this.setFromMatrixColumn(e, 1).length(), i = this.setFromMatrixColumn(e, 2).length();
    return this.x = t, this.y = s, this.z = i, this;
  }
  /**
   * Sets the vector components from the specified matrix column.
   *
   * @param {Matrix4} m - The 4x4 matrix.
   * @param {number} index - The column index.
   * @return {Vector3} A reference to this vector.
   */
  setFromMatrixColumn(e, t) {
    return this.fromArray(e.elements, t * 4);
  }
  /**
   * Sets the vector components from the specified matrix column.
   *
   * @param {Matrix3} m - The 3x3 matrix.
   * @param {number} index - The column index.
   * @return {Vector3} A reference to this vector.
   */
  setFromMatrix3Column(e, t) {
    return this.fromArray(e.elements, t * 3);
  }
  /**
   * Sets the vector components from the given Euler angles.
   *
   * @param {Euler} e - The Euler angles to set.
   * @return {Vector3} A reference to this vector.
   */
  setFromEuler(e) {
    return this.x = e._x, this.y = e._y, this.z = e._z, this;
  }
  /**
   * Sets the vector components from the RGB components of the
   * given color.
   *
   * @param {Color} c - The color to set.
   * @return {Vector3} A reference to this vector.
   */
  setFromColor(e) {
    return this.x = e.r, this.y = e.g, this.z = e.b, this;
  }
  /**
   * Returns `true` if this vector is equal with the given one.
   *
   * @param {Vector3} v - The vector to test for equality.
   * @return {boolean} Whether this vector is equal with the given one.
   */
  equals(e) {
    return e.x === this.x && e.y === this.y && e.z === this.z;
  }
  /**
   * Sets this vector's x value to be `array[ offset ]`, y value to be `array[ offset + 1 ]`
   * and z value to be `array[ offset + 2 ]`.
   *
   * @param {Array<number>} array - An array holding the vector component values.
   * @param {number} [offset=0] - The offset into the array.
   * @return {Vector3} A reference to this vector.
   */
  fromArray(e, t = 0) {
    return this.x = e[t], this.y = e[t + 1], this.z = e[t + 2], this;
  }
  /**
   * Writes the components of this vector to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the vector components.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The vector components.
   */
  toArray(e = [], t = 0) {
    return e[t] = this.x, e[t + 1] = this.y, e[t + 2] = this.z, e;
  }
  /**
   * Sets the components of this vector from the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
   * @param {number} index - The index into the attribute.
   * @return {Vector3} A reference to this vector.
   */
  fromBufferAttribute(e, t) {
    return this.x = e.getX(t), this.y = e.getY(t), this.z = e.getZ(t), this;
  }
  /**
   * Sets each component of this vector to a pseudo-random value between `0` and
   * `1`, excluding `1`.
   *
   * @return {Vector3} A reference to this vector.
   */
  random() {
    return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this;
  }
  /**
   * Sets this vector to a uniformly random point on a unit sphere.
   *
   * @return {Vector3} A reference to this vector.
   */
  randomDirection() {
    const e = Math.random() * Math.PI * 2, t = Math.random() * 2 - 1, s = Math.sqrt(1 - t * t);
    return this.x = s * Math.cos(e), this.y = t, this.z = s * Math.sin(e), this;
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y, yield this.z;
  }
};
Bh.prototype.isVector3 = !0;
let M = Bh;
const xn = /* @__PURE__ */ new M(), Nu = /* @__PURE__ */ new Gr(), Uh = class {
  /**
   * Constructs a new 3x3 matrix. The arguments are supposed to be
   * in row-major order. If no arguments are provided, the constructor
   * initializes the matrix as an identity matrix.
   *
   * @param {number} [n11] - 1-1 matrix element.
   * @param {number} [n12] - 1-2 matrix element.
   * @param {number} [n13] - 1-3 matrix element.
   * @param {number} [n21] - 2-1 matrix element.
   * @param {number} [n22] - 2-2 matrix element.
   * @param {number} [n23] - 2-3 matrix element.
   * @param {number} [n31] - 3-1 matrix element.
   * @param {number} [n32] - 3-2 matrix element.
   * @param {number} [n33] - 3-3 matrix element.
   */
  constructor(e, t, s, i, a, n, o, l, u) {
    this.elements = [
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1
    ], e !== void 0 && this.set(e, t, s, i, a, n, o, l, u);
  }
  /**
   * Sets the elements of the matrix.The arguments are supposed to be
   * in row-major order.
   *
   * @param {number} [n11] - 1-1 matrix element.
   * @param {number} [n12] - 1-2 matrix element.
   * @param {number} [n13] - 1-3 matrix element.
   * @param {number} [n21] - 2-1 matrix element.
   * @param {number} [n22] - 2-2 matrix element.
   * @param {number} [n23] - 2-3 matrix element.
   * @param {number} [n31] - 3-1 matrix element.
   * @param {number} [n32] - 3-2 matrix element.
   * @param {number} [n33] - 3-3 matrix element.
   * @return {Matrix3} A reference to this matrix.
   */
  set(e, t, s, i, a, n, o, l, u) {
    const h = this.elements;
    return h[0] = e, h[1] = i, h[2] = o, h[3] = t, h[4] = a, h[5] = l, h[6] = s, h[7] = n, h[8] = u, this;
  }
  /**
   * Sets this matrix to the 3x3 identity matrix.
   *
   * @return {Matrix3} A reference to this matrix.
   */
  identity() {
    return this.set(
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Copies the values of the given matrix to this instance.
   *
   * @param {Matrix3} m - The matrix to copy.
   * @return {Matrix3} A reference to this matrix.
   */
  copy(e) {
    const t = this.elements, s = e.elements;
    return t[0] = s[0], t[1] = s[1], t[2] = s[2], t[3] = s[3], t[4] = s[4], t[5] = s[5], t[6] = s[6], t[7] = s[7], t[8] = s[8], this;
  }
  /**
   * Extracts the basis of this matrix into the three axis vectors provided.
   *
   * @param {Vector3} xAxis - The basis's x axis.
   * @param {Vector3} yAxis - The basis's y axis.
   * @param {Vector3} zAxis - The basis's z axis.
   * @return {Matrix3} A reference to this matrix.
   */
  extractBasis(e, t, s) {
    return e.setFromMatrix3Column(this, 0), t.setFromMatrix3Column(this, 1), s.setFromMatrix3Column(this, 2), this;
  }
  /**
   * Set this matrix to the upper 3x3 matrix of the given 4x4 matrix.
   *
   * @param {Matrix4} m - The 4x4 matrix.
   * @return {Matrix3} A reference to this matrix.
   */
  setFromMatrix4(e) {
    const t = e.elements;
    return this.set(
      t[0],
      t[4],
      t[8],
      t[1],
      t[5],
      t[9],
      t[2],
      t[6],
      t[10]
    ), this;
  }
  /**
   * Post-multiplies this matrix by the given 3x3 matrix.
   *
   * @param {Matrix3} m - The matrix to multiply with.
   * @return {Matrix3} A reference to this matrix.
   */
  multiply(e) {
    return this.multiplyMatrices(this, e);
  }
  /**
   * Pre-multiplies this matrix by the given 3x3 matrix.
   *
   * @param {Matrix3} m - The matrix to multiply with.
   * @return {Matrix3} A reference to this matrix.
   */
  premultiply(e) {
    return this.multiplyMatrices(e, this);
  }
  /**
   * Multiples the given 3x3 matrices and stores the result
   * in this matrix.
   *
   * @param {Matrix3} a - The first matrix.
   * @param {Matrix3} b - The second matrix.
   * @return {Matrix3} A reference to this matrix.
   */
  multiplyMatrices(e, t) {
    const s = e.elements, i = t.elements, a = this.elements, n = s[0], o = s[3], l = s[6], u = s[1], h = s[4], d = s[7], p = s[2], m = s[5], g = s[8], y = i[0], v = i[3], w = i[6], _ = i[1], C = i[4], V = i[7], P = i[2], z = i[5], R = i[8];
    return a[0] = n * y + o * _ + l * P, a[3] = n * v + o * C + l * z, a[6] = n * w + o * V + l * R, a[1] = u * y + h * _ + d * P, a[4] = u * v + h * C + d * z, a[7] = u * w + h * V + d * R, a[2] = p * y + m * _ + g * P, a[5] = p * v + m * C + g * z, a[8] = p * w + m * V + g * R, this;
  }
  /**
   * Multiplies every component of the matrix by the given scalar.
   *
   * @param {number} s - The scalar.
   * @return {Matrix3} A reference to this matrix.
   */
  multiplyScalar(e) {
    const t = this.elements;
    return t[0] *= e, t[3] *= e, t[6] *= e, t[1] *= e, t[4] *= e, t[7] *= e, t[2] *= e, t[5] *= e, t[8] *= e, this;
  }
  /**
   * Computes and returns the determinant of this matrix.
   *
   * @return {number} The determinant.
   */
  determinant() {
    const e = this.elements, t = e[0], s = e[1], i = e[2], a = e[3], n = e[4], o = e[5], l = e[6], u = e[7], h = e[8];
    return t * n * h - t * o * u - s * a * h + s * o * l + i * a * u - i * n * l;
  }
  /**
   * Inverts this matrix, using the [analytic method](https://en.wikipedia.org/wiki/Invertible_matrix#Analytic_solution).
   * You can not invert with a determinant of zero. If you attempt this, the method produces
   * a zero matrix instead.
   *
   * @return {Matrix3} A reference to this matrix.
   */
  invert() {
    const e = this.elements, t = e[0], s = e[1], i = e[2], a = e[3], n = e[4], o = e[5], l = e[6], u = e[7], h = e[8], d = h * n - o * u, p = o * l - h * a, m = u * a - n * l, g = t * d + s * p + i * m;
    if (g === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
    const y = 1 / g;
    return e[0] = d * y, e[1] = (i * u - h * s) * y, e[2] = (o * s - i * n) * y, e[3] = p * y, e[4] = (h * t - i * l) * y, e[5] = (i * a - o * t) * y, e[6] = m * y, e[7] = (s * l - u * t) * y, e[8] = (n * t - s * a) * y, this;
  }
  /**
   * Transposes this matrix in place.
   *
   * @return {Matrix3} A reference to this matrix.
   */
  transpose() {
    let e;
    const t = this.elements;
    return e = t[1], t[1] = t[3], t[3] = e, e = t[2], t[2] = t[6], t[6] = e, e = t[5], t[5] = t[7], t[7] = e, this;
  }
  /**
   * Computes the normal matrix which is the inverse transpose of the upper
   * left 3x3 portion of the given 4x4 matrix.
   *
   * @param {Matrix4} matrix4 - The 4x4 matrix.
   * @return {Matrix3} A reference to this matrix.
   */
  getNormalMatrix(e) {
    return this.setFromMatrix4(e).invert().transpose();
  }
  /**
   * Transposes this matrix into the supplied array, and returns itself unchanged.
   *
   * @param {Array<number>} r - An array to store the transposed matrix elements.
   * @return {Matrix3} A reference to this matrix.
   */
  transposeIntoArray(e) {
    const t = this.elements;
    return e[0] = t[0], e[1] = t[3], e[2] = t[6], e[3] = t[1], e[4] = t[4], e[5] = t[7], e[6] = t[2], e[7] = t[5], e[8] = t[8], this;
  }
  /**
   * Sets the UV transform matrix from offset, repeat, rotation, and center.
   *
   * @param {number} tx - Offset x.
   * @param {number} ty - Offset y.
   * @param {number} sx - Repeat x.
   * @param {number} sy - Repeat y.
   * @param {number} rotation - Rotation, in radians. Positive values rotate counterclockwise.
   * @param {number} cx - Center x of rotation.
   * @param {number} cy - Center y of rotation
   * @return {Matrix3} A reference to this matrix.
   */
  setUvTransform(e, t, s, i, a, n, o) {
    const l = Math.cos(a), u = Math.sin(a);
    return this.set(
      s * l,
      s * u,
      -s * (l * n + u * o) + n + e,
      -i * u,
      i * l,
      -i * (-u * n + l * o) + o + t,
      0,
      0,
      1
    ), this;
  }
  /**
   * Scales this matrix with the given scalar values.
   *
   * @deprecated
   * @param {number} sx - The amount to scale in the X axis.
   * @param {number} sy - The amount to scale in the Y axis.
   * @return {Matrix3} A reference to this matrix.
   */
  scale(e, t) {
    return Be("Matrix3: .scale() is deprecated. Use .makeScale() instead."), this.premultiply(bn.makeScale(e, t)), this;
  }
  /**
   * Rotates this matrix by the given angle.
   *
   * @deprecated
   * @param {number} theta - The rotation in radians.
   * @return {Matrix3} A reference to this matrix.
   */
  rotate(e) {
    return Be("Matrix3: .rotate() is deprecated. Use .makeRotation() instead."), this.premultiply(bn.makeRotation(-e)), this;
  }
  /**
   * Translates this matrix by the given scalar values.
   *
   * @deprecated
   * @param {number} tx - The amount to translate in the X axis.
   * @param {number} ty - The amount to translate in the Y axis.
   * @return {Matrix3} A reference to this matrix.
   */
  translate(e, t) {
    return Be("Matrix3: .translate() is deprecated. Use .makeTranslation() instead."), this.premultiply(bn.makeTranslation(e, t)), this;
  }
  // for 2D Transforms
  /**
   * Sets this matrix as a 2D translation transform.
   *
   * @param {number|Vector2} x - The amount to translate in the X axis or alternatively a translation vector.
   * @param {number} y - The amount to translate in the Y axis.
   * @return {Matrix3} A reference to this matrix.
   */
  makeTranslation(e, t) {
    return e.isVector2 ? this.set(
      1,
      0,
      e.x,
      0,
      1,
      e.y,
      0,
      0,
      1
    ) : this.set(
      1,
      0,
      e,
      0,
      1,
      t,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a 2D rotational transformation.
   *
   * @param {number} theta - The rotation in radians.
   * @return {Matrix3} A reference to this matrix.
   */
  makeRotation(e) {
    const t = Math.cos(e), s = Math.sin(e);
    return this.set(
      t,
      -s,
      0,
      s,
      t,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a 2D scale transform.
   *
   * @param {number} x - The amount to scale in the X axis.
   * @param {number} y - The amount to scale in the Y axis.
   * @return {Matrix3} A reference to this matrix.
   */
  makeScale(e, t) {
    return this.set(
      e,
      0,
      0,
      0,
      t,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Returns `true` if this matrix is equal with the given one.
   *
   * @param {Matrix3} matrix - The matrix to test for equality.
   * @return {boolean} Whether this matrix is equal with the given one.
   */
  equals(e) {
    const t = this.elements, s = e.elements;
    for (let i = 0; i < 9; i++)
      if (t[i] !== s[i]) return !1;
    return !0;
  }
  /**
   * Sets the elements of the matrix from the given array.
   *
   * @param {Array<number>} array - The matrix elements in column-major order.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Matrix3} A reference to this matrix.
   */
  fromArray(e, t = 0) {
    for (let s = 0; s < 9; s++)
      this.elements[s] = e[s + t];
    return this;
  }
  /**
   * Writes the elements of this matrix to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the matrix elements in column-major order.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The matrix elements in column-major order.
   */
  toArray(e = [], t = 0) {
    const s = this.elements;
    return e[t] = s[0], e[t + 1] = s[1], e[t + 2] = s[2], e[t + 3] = s[3], e[t + 4] = s[4], e[t + 5] = s[5], e[t + 6] = s[6], e[t + 7] = s[7], e[t + 8] = s[8], e;
  }
  /**
   * Returns a matrix with copied values from this instance.
   *
   * @return {Matrix3} A clone of this instance.
   */
  clone() {
    return new this.constructor().fromArray(this.elements);
  }
};
Uh.prototype.isMatrix3 = !0;
let Kt = Uh;
const bn = /* @__PURE__ */ new Kt(), Mu = /* @__PURE__ */ new Kt().set(
  0.4123908,
  0.3575843,
  0.1804808,
  0.212639,
  0.7151687,
  0.0721923,
  0.0193308,
  0.1191948,
  0.9505322
), Su = /* @__PURE__ */ new Kt().set(
  3.2409699,
  -1.5373832,
  -0.4986108,
  -0.9692436,
  1.8759675,
  0.0415551,
  0.0556301,
  -0.203977,
  1.0569715
);
function jg() {
  const r = {
    enabled: !0,
    workingColorSpace: wa,
    /**
     * Implementations of supported color spaces.
     *
     * Required:
     *	- primaries: chromaticity coordinates [ rx ry gx gy bx by ]
     *	- whitePoint: reference white [ x y ]
     *	- transfer: transfer function (pre-defined)
     *	- toXYZ: Matrix3 RGB to XYZ transform
     *	- fromXYZ: Matrix3 XYZ to RGB transform
     *	- luminanceCoefficients: RGB luminance coefficients
     *
     * Optional:
     *  - outputColorSpaceConfig: { drawingBufferColorSpace: ColorSpace, toneMappingMode: 'extended' | 'standard' }
     *  - workingColorSpaceConfig: { unpackColorSpace: ColorSpace }
     *
     * Reference:
     * - https://www.russellcottrell.com/photo/matrixCalculator.htm
     */
    spaces: {},
    convert: function(i, a, n) {
      return this.enabled === !1 || a === n || !a || !n || (this.spaces[a].transfer === di && (i.r = ds(i.r), i.g = ds(i.g), i.b = ds(i.b)), this.spaces[a].primaries !== this.spaces[n].primaries && (i.applyMatrix3(this.spaces[a].toXYZ), i.applyMatrix3(this.spaces[n].fromXYZ)), this.spaces[n].transfer === di && (i.r = Lr(i.r), i.g = Lr(i.g), i.b = Lr(i.b))), i;
    },
    workingToColorSpace: function(i, a) {
      return this.convert(i, this.workingColorSpace, a);
    },
    colorSpaceToWorking: function(i, a) {
      return this.convert(i, a, this.workingColorSpace);
    },
    getPrimaries: function(i) {
      return this.spaces[i].primaries;
    },
    getTransfer: function(i) {
      return i === Ta ? yu : this.spaces[i].transfer;
    },
    getToneMappingMode: function(i) {
      return this.spaces[i].outputColorSpaceConfig.toneMappingMode || "standard";
    },
    getLuminanceCoefficients: function(i, a = this.workingColorSpace) {
      return i.fromArray(this.spaces[a].luminanceCoefficients);
    },
    define: function(i) {
      Object.assign(this.spaces, i);
    },
    // Internal APIs
    _getMatrix: function(i, a, n) {
      return i.copy(this.spaces[a].toXYZ).multiply(this.spaces[n].fromXYZ);
    },
    _getDrawingBufferColorSpace: function(i) {
      return this.spaces[i].outputColorSpaceConfig.drawingBufferColorSpace;
    },
    _getUnpackColorSpace: function(i = this.workingColorSpace) {
      return this.spaces[i].workingColorSpaceConfig.unpackColorSpace;
    },
    // Deprecated
    fromWorkingColorSpace: function(i, a) {
      return Be("ColorManagement: .fromWorkingColorSpace() has been renamed to .workingToColorSpace()."), r.workingToColorSpace(i, a);
    },
    toWorkingColorSpace: function(i, a) {
      return Be("ColorManagement: .toWorkingColorSpace() has been renamed to .colorSpaceToWorking()."), r.colorSpaceToWorking(i, a);
    }
  }, e = [0.64, 0.33, 0.3, 0.6, 0.15, 0.06], t = [0.2126, 0.7152, 0.0722], s = [0.3127, 0.329];
  return r.define({
    [wa]: {
      primaries: e,
      whitePoint: s,
      transfer: yu,
      toXYZ: Mu,
      fromXYZ: Su,
      luminanceCoefficients: t,
      workingColorSpaceConfig: { unpackColorSpace: zt },
      outputColorSpaceConfig: { drawingBufferColorSpace: zt }
    },
    [zt]: {
      primaries: e,
      whitePoint: s,
      transfer: di,
      toXYZ: Mu,
      fromXYZ: Su,
      luminanceCoefficients: t,
      outputColorSpaceConfig: { drawingBufferColorSpace: zt }
    }
  }), r;
}
const Ne = /* @__PURE__ */ jg();
function ds(r) {
  return r < 0.04045 ? r * 0.0773993808 : Math.pow(r * 0.9478672986 + 0.0521327014, 2.4);
}
function Lr(r) {
  return r < 31308e-7 ? r * 12.92 : 1.055 * Math.pow(r, 0.41666) - 0.055;
}
let gr;
class Gg {
  /**
   * Returns a data URI containing a representation of the given image.
   *
   * @param {(HTMLImageElement|HTMLCanvasElement)} image - The image object.
   * @param {string} [type='image/png'] - Indicates the image format.
   * @return {string} The data URI.
   */
  static getDataURL(e, t = "image/png") {
    if (/^data:/i.test(e.src) || typeof HTMLCanvasElement > "u")
      return e.src;
    let s;
    if (e instanceof HTMLCanvasElement)
      s = e;
    else {
      gr === void 0 && (gr = vu("canvas")), gr.width = e.width, gr.height = e.height;
      const i = gr.getContext("2d");
      e instanceof ImageData ? i.putImageData(e, 0, 0) : i.drawImage(e, 0, 0, e.width, e.height), s = gr;
    }
    return s.toDataURL(t);
  }
  /**
   * Converts the given sRGB image data to linear color space.
   *
   * @param {(HTMLImageElement|HTMLCanvasElement|ImageBitmap|Object)} image - The image object.
   * @return {HTMLCanvasElement|Object} The converted image.
   */
  static sRGBToLinear(e) {
    if (typeof HTMLImageElement < "u" && e instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && e instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && e instanceof ImageBitmap) {
      const t = vu("canvas");
      t.width = e.width, t.height = e.height;
      const s = t.getContext("2d");
      s.drawImage(e, 0, 0, e.width, e.height);
      const i = s.getImageData(0, 0, e.width, e.height), a = i.data;
      for (let n = 0; n < a.length; n++)
        a[n] = ds(a[n] / 255) * 255;
      return s.putImageData(i, 0, 0), t;
    } else if (e.data) {
      const t = e.data.slice(0);
      for (let s = 0; s < t.length; s++)
        t instanceof Uint8Array || t instanceof Uint8ClampedArray ? t[s] = Math.floor(ds(t[s] / 255) * 255) : t[s] = ds(t[s]);
      return {
        data: t,
        width: e.width,
        height: e.height
      };
    } else
      return X("ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied."), e;
  }
}
let Hg = 0;
class Ho {
  /**
   * Constructs a new video texture.
   *
   * @param {any} [data=null] - The data definition of a texture.
   */
  constructor(e = null) {
    this.isSource = !0, Object.defineProperty(this, "id", { value: Hg++ }), this.uuid = cs(), this.data = e, this.dataReady = !0, this.version = 0;
  }
  /**
   * Returns the dimensions of the source into the given target vector.
   *
   * @param {(Vector2|Vector3)} target - The target object the result is written into.
   * @return {(Vector2|Vector3)} The dimensions of the source.
   */
  getSize(e) {
    const t = this.data;
    return typeof HTMLVideoElement < "u" && t instanceof HTMLVideoElement ? e.set(t.videoWidth, t.videoHeight, 0) : typeof VideoFrame < "u" && t instanceof VideoFrame ? e.set(t.displayWidth, t.displayHeight, 0) : t !== null ? e.set(t.width, t.height, t.depth || 0) : e.set(0, 0, 0), e;
  }
  /**
   * When the property is set to `true`, the engine allocates the memory
   * for the texture (if necessary) and triggers the actual texture upload
   * to the GPU next time the source is used.
   *
   * @type {boolean}
   * @default false
   * @param {boolean} value
   */
  set needsUpdate(e) {
    e === !0 && this.version++;
  }
  /**
   * Serializes the source into JSON.
   *
   * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
   * @return {Object} A JSON object representing the serialized source.
   * @see {@link ObjectLoader#parse}
   */
  toJSON(e) {
    const t = e === void 0 || typeof e == "string";
    if (!t && e.images[this.uuid] !== void 0)
      return e.images[this.uuid];
    const s = {
      uuid: this.uuid,
      url: ""
    }, i = this.data;
    if (i !== null) {
      let a;
      if (Array.isArray(i)) {
        a = [];
        for (let n = 0, o = i.length; n < o; n++)
          i[n].isDataTexture ? a.push(vn(i[n].image)) : a.push(vn(i[n]));
      } else
        a = vn(i);
      s.url = a;
    }
    return t || (e.images[this.uuid] = s), s;
  }
}
function vn(r) {
  return typeof HTMLImageElement < "u" && r instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && r instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && r instanceof ImageBitmap ? Gg.getDataURL(r) : r.data ? {
    data: Array.from(r.data),
    width: r.width,
    height: r.height,
    type: r.data.constructor.name
  } : (X("Texture: Unable to serialize Texture."), {});
}
let Xg = 0;
const Tn = /* @__PURE__ */ new M();
class Ke extends Ps {
  /**
   * Constructs a new texture.
   *
   * @param {?Object} [image=Texture.DEFAULT_IMAGE] - The image holding the texture data.
   * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
   * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
   * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
   * @param {number} [magFilter=LinearFilter] - The mag filter value.
   * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
   * @param {number} [format=RGBAFormat] - The texture format.
   * @param {number} [type=UnsignedByteType] - The texture type.
   * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
   * @param {string} [colorSpace=NoColorSpace] - The color space.
   */
  constructor(e = Ke.DEFAULT_IMAGE, t = Ke.DEFAULT_MAPPING, s = Js, i = Js, a = ms, n = Rh, o = Eh, l = bg, u = Ke.DEFAULT_ANISOTROPY, h = Ta) {
    super(), this.isTexture = !0, Object.defineProperty(this, "id", { value: Xg++ }), this.uuid = cs(), this.name = "", this.source = new Ho(e), this.mipmaps = [], this.mapping = t, this.channel = 0, this.wrapS = s, this.wrapT = i, this.magFilter = a, this.minFilter = n, this.anisotropy = u, this.format = o, this.internalFormat = null, this.type = l, this.offset = new _e(0, 0), this.repeat = new _e(1, 1), this.center = new _e(0, 0), this.rotation = 0, this.matrixAutoUpdate = !0, this.matrix = new Kt(), this.generateMipmaps = !0, this.premultiplyAlpha = !1, this.flipY = !0, this.unpackAlignment = 4, this.colorSpace = h, this.userData = {}, this.updateRanges = [], this.version = 0, this.onUpdate = null, this.renderTarget = null, this.isRenderTargetTexture = !1, this.isArrayTexture = !!(e && e.depth && e.depth > 1), this.pmremVersion = 0, this.normalized = !1;
  }
  /**
   * The width of the texture in pixels.
   */
  get width() {
    return this.source.getSize(Tn).x;
  }
  /**
   * The height of the texture in pixels.
   */
  get height() {
    return this.source.getSize(Tn).y;
  }
  /**
   * The depth of the texture in pixels.
   */
  get depth() {
    return this.source.getSize(Tn).z;
  }
  /**
   * The image object holding the texture data.
   *
   * @type {?Object}
   */
  get image() {
    return this.source.data;
  }
  set image(e) {
    this.source.data = e;
  }
  /**
   * Updates the texture transformation matrix from the properties {@link Texture#offset},
   * {@link Texture#repeat}, {@link Texture#rotation}, and {@link Texture#center}.
   */
  updateMatrix() {
    this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
  }
  /**
   * Adds a range of data in the data texture to be updated on the GPU.
   *
   * @param {number} start - Position at which to start update.
   * @param {number} count - The number of components to update.
   */
  addUpdateRange(e, t) {
    this.updateRanges.push({ start: e, count: t });
  }
  /**
   * Clears the update ranges.
   */
  clearUpdateRanges() {
    this.updateRanges.length = 0;
  }
  /**
   * Returns a new texture with copied values from this instance.
   *
   * @return {Texture} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
  /**
   * Copies the values of the given texture to this instance.
   *
   * @param {Texture} source - The texture to copy.
   * @return {Texture} A reference to this instance.
   */
  copy(e) {
    return this.name = e.name, this.source = e.source, this.mipmaps = e.mipmaps.slice(0), this.mapping = e.mapping, this.channel = e.channel, this.wrapS = e.wrapS, this.wrapT = e.wrapT, this.magFilter = e.magFilter, this.minFilter = e.minFilter, this.anisotropy = e.anisotropy, this.format = e.format, this.internalFormat = e.internalFormat, this.type = e.type, this.normalized = e.normalized, this.offset.copy(e.offset), this.repeat.copy(e.repeat), this.center.copy(e.center), this.rotation = e.rotation, this.matrixAutoUpdate = e.matrixAutoUpdate, this.matrix.copy(e.matrix), this.generateMipmaps = e.generateMipmaps, this.premultiplyAlpha = e.premultiplyAlpha, this.flipY = e.flipY, this.unpackAlignment = e.unpackAlignment, this.colorSpace = e.colorSpace, this.renderTarget = e.renderTarget, this.isRenderTargetTexture = e.isRenderTargetTexture, this.isArrayTexture = e.isArrayTexture, this.userData = JSON.parse(JSON.stringify(e.userData)), this.needsUpdate = !0, this;
  }
  /**
   * Sets this texture's properties based on `values`.
   * @param {Object} values - A container with texture parameters.
   */
  setValues(e) {
    for (const t in e) {
      const s = e[t];
      if (s === void 0) {
        X(`Texture.setValues(): parameter '${t}' has value of undefined.`);
        continue;
      }
      const i = this[t];
      if (i === void 0) {
        X(`Texture.setValues(): property '${t}' does not exist.`);
        continue;
      }
      i && s && i.isVector2 && s.isVector2 || i && s && i.isVector3 && s.isVector3 || i && s && i.isMatrix3 && s.isMatrix3 ? i.copy(s) : this[t] = s;
    }
  }
  /**
   * Serializes the texture into JSON.
   *
   * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
   * @return {Object} A JSON object representing the serialized texture.
   * @see {@link ObjectLoader#parse}
   */
  toJSON(e) {
    const t = e === void 0 || typeof e == "string";
    if (!t && e.textures[this.uuid] !== void 0)
      return e.textures[this.uuid];
    const s = {
      metadata: {
        version: 4.7,
        type: "Texture",
        generator: "Texture.toJSON"
      },
      uuid: this.uuid,
      name: this.name,
      image: this.source.toJSON(e).uuid,
      mapping: this.mapping,
      channel: this.channel,
      repeat: [this.repeat.x, this.repeat.y],
      offset: [this.offset.x, this.offset.y],
      center: [this.center.x, this.center.y],
      rotation: this.rotation,
      wrap: [this.wrapS, this.wrapT],
      format: this.format,
      internalFormat: this.internalFormat,
      type: this.type,
      normalized: this.normalized,
      colorSpace: this.colorSpace,
      minFilter: this.minFilter,
      magFilter: this.magFilter,
      anisotropy: this.anisotropy,
      flipY: this.flipY,
      generateMipmaps: this.generateMipmaps,
      premultiplyAlpha: this.premultiplyAlpha,
      unpackAlignment: this.unpackAlignment
    };
    return Object.keys(this.userData).length > 0 && (s.userData = this.userData), t || (e.textures[this.uuid] = s), s;
  }
  /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever this instance is no longer used in your app.
   *
   * @fires Texture#dispose
   */
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
  /**
   * Transforms the given uv vector with the textures uv transformation matrix.
   *
   * @param {Vector2} uv - The uv vector.
   * @return {Vector2} The transformed uv vector.
   */
  transformUv(e) {
    if (this.mapping !== Do) return e;
    if (e.applyMatrix3(this.matrix), e.x < 0 || e.x > 1)
      switch (this.wrapS) {
        case gu:
          e.x = e.x - Math.floor(e.x);
          break;
        case Js:
          e.x = e.x < 0 ? 0 : 1;
          break;
        case fu:
          Math.abs(Math.floor(e.x) % 2) === 1 ? e.x = Math.ceil(e.x) - e.x : e.x = e.x - Math.floor(e.x);
          break;
      }
    if (e.y < 0 || e.y > 1)
      switch (this.wrapT) {
        case gu:
          e.y = e.y - Math.floor(e.y);
          break;
        case Js:
          e.y = e.y < 0 ? 0 : 1;
          break;
        case fu:
          Math.abs(Math.floor(e.y) % 2) === 1 ? e.y = Math.ceil(e.y) - e.y : e.y = e.y - Math.floor(e.y);
          break;
      }
    return this.flipY && (e.y = 1 - e.y), e;
  }
  /**
   * Setting this property to `true` indicates the engine the texture
   * must be updated in the next render. This triggers a texture upload
   * to the GPU and ensures correct texture parameter configuration.
   *
   * @type {boolean}
   * @default false
   * @param {boolean} value
   */
  set needsUpdate(e) {
    e === !0 && (this.version++, this.source.needsUpdate = !0);
  }
  /**
   * Setting this property to `true` indicates the engine the PMREM
   * must be regenerated.
   *
   * @type {boolean}
   * @default false
   * @param {boolean} value
   */
  set needsPMREMUpdate(e) {
    e === !0 && this.pmremVersion++;
  }
}
Ke.DEFAULT_IMAGE = null;
Ke.DEFAULT_MAPPING = Do;
Ke.DEFAULT_ANISOTROPY = 1;
const kh = class {
  /**
   * Constructs a new 4D vector.
   *
   * @param {number} [x=0] - The x value of this vector.
   * @param {number} [y=0] - The y value of this vector.
   * @param {number} [z=0] - The z value of this vector.
   * @param {number} [w=1] - The w value of this vector.
   */
  constructor(e = 0, t = 0, s = 0, i = 1) {
    this.x = e, this.y = t, this.z = s, this.w = i;
  }
  /**
   * Alias for {@link Vector4#z}.
   *
   * @type {number}
   */
  get width() {
    return this.z;
  }
  set width(e) {
    this.z = e;
  }
  /**
   * Alias for {@link Vector4#w}.
   *
   * @type {number}
   */
  get height() {
    return this.w;
  }
  set height(e) {
    this.w = e;
  }
  /**
   * Sets the vector components.
   *
   * @param {number} x - The value of the x component.
   * @param {number} y - The value of the y component.
   * @param {number} z - The value of the z component.
   * @param {number} w - The value of the w component.
   * @return {Vector4} A reference to this vector.
   */
  set(e, t, s, i) {
    return this.x = e, this.y = t, this.z = s, this.w = i, this;
  }
  /**
   * Sets the vector components to the same value.
   *
   * @param {number} scalar - The value to set for all vector components.
   * @return {Vector4} A reference to this vector.
   */
  setScalar(e) {
    return this.x = e, this.y = e, this.z = e, this.w = e, this;
  }
  /**
   * Sets the vector's x component to the given value
   *
   * @param {number} x - The value to set.
   * @return {Vector4} A reference to this vector.
   */
  setX(e) {
    return this.x = e, this;
  }
  /**
   * Sets the vector's y component to the given value
   *
   * @param {number} y - The value to set.
   * @return {Vector4} A reference to this vector.
   */
  setY(e) {
    return this.y = e, this;
  }
  /**
   * Sets the vector's z component to the given value
   *
   * @param {number} z - The value to set.
   * @return {Vector4} A reference to this vector.
   */
  setZ(e) {
    return this.z = e, this;
  }
  /**
   * Sets the vector's w component to the given value
   *
   * @param {number} w - The value to set.
   * @return {Vector4} A reference to this vector.
   */
  setW(e) {
    return this.w = e, this;
  }
  /**
   * Allows to set a vector component with an index.
   *
   * @param {number} index - The component index. `0` equals to x, `1` equals to y,
   * `2` equals to z, `3` equals to w.
   * @param {number} value - The value to set.
   * @return {Vector4} A reference to this vector.
   */
  setComponent(e, t) {
    switch (e) {
      case 0:
        this.x = t;
        break;
      case 1:
        this.y = t;
        break;
      case 2:
        this.z = t;
        break;
      case 3:
        this.w = t;
        break;
      default:
        throw new Error("THREE.Vector4: index is out of range: " + e);
    }
    return this;
  }
  /**
   * Returns the value of the vector component which matches the given index.
   *
   * @param {number} index - The component index. `0` equals to x, `1` equals to y,
   * `2` equals to z, `3` equals to w.
   * @return {number} A vector component value.
   */
  getComponent(e) {
    switch (e) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      case 2:
        return this.z;
      case 3:
        return this.w;
      default:
        throw new Error("THREE.Vector4: index is out of range: " + e);
    }
  }
  /**
   * Returns a new vector with copied values from this instance.
   *
   * @return {Vector4} A clone of this instance.
   */
  clone() {
    return new this.constructor(this.x, this.y, this.z, this.w);
  }
  /**
   * Copies the values of the given vector to this instance.
   *
   * @param {Vector3|Vector4} v - The vector to copy.
   * @return {Vector4} A reference to this vector.
   */
  copy(e) {
    return this.x = e.x, this.y = e.y, this.z = e.z, this.w = e.w !== void 0 ? e.w : 1, this;
  }
  /**
   * Adds the given vector to this instance.
   *
   * @param {Vector4} v - The vector to add.
   * @return {Vector4} A reference to this vector.
   */
  add(e) {
    return this.x += e.x, this.y += e.y, this.z += e.z, this.w += e.w, this;
  }
  /**
   * Adds the given scalar value to all components of this instance.
   *
   * @param {number} s - The scalar to add.
   * @return {Vector4} A reference to this vector.
   */
  addScalar(e) {
    return this.x += e, this.y += e, this.z += e, this.w += e, this;
  }
  /**
   * Adds the given vectors and stores the result in this instance.
   *
   * @param {Vector4} a - The first vector.
   * @param {Vector4} b - The second vector.
   * @return {Vector4} A reference to this vector.
   */
  addVectors(e, t) {
    return this.x = e.x + t.x, this.y = e.y + t.y, this.z = e.z + t.z, this.w = e.w + t.w, this;
  }
  /**
   * Adds the given vector scaled by the given factor to this instance.
   *
   * @param {Vector4} v - The vector.
   * @param {number} s - The factor that scales `v`.
   * @return {Vector4} A reference to this vector.
   */
  addScaledVector(e, t) {
    return this.x += e.x * t, this.y += e.y * t, this.z += e.z * t, this.w += e.w * t, this;
  }
  /**
   * Subtracts the given vector from this instance.
   *
   * @param {Vector4} v - The vector to subtract.
   * @return {Vector4} A reference to this vector.
   */
  sub(e) {
    return this.x -= e.x, this.y -= e.y, this.z -= e.z, this.w -= e.w, this;
  }
  /**
   * Subtracts the given scalar value from all components of this instance.
   *
   * @param {number} s - The scalar to subtract.
   * @return {Vector4} A reference to this vector.
   */
  subScalar(e) {
    return this.x -= e, this.y -= e, this.z -= e, this.w -= e, this;
  }
  /**
   * Subtracts the given vectors and stores the result in this instance.
   *
   * @param {Vector4} a - The first vector.
   * @param {Vector4} b - The second vector.
   * @return {Vector4} A reference to this vector.
   */
  subVectors(e, t) {
    return this.x = e.x - t.x, this.y = e.y - t.y, this.z = e.z - t.z, this.w = e.w - t.w, this;
  }
  /**
   * Multiplies the given vector with this instance.
   *
   * @param {Vector4} v - The vector to multiply.
   * @return {Vector4} A reference to this vector.
   */
  multiply(e) {
    return this.x *= e.x, this.y *= e.y, this.z *= e.z, this.w *= e.w, this;
  }
  /**
   * Multiplies the given scalar value with all components of this instance.
   *
   * @param {number} scalar - The scalar to multiply.
   * @return {Vector4} A reference to this vector.
   */
  multiplyScalar(e) {
    return this.x *= e, this.y *= e, this.z *= e, this.w *= e, this;
  }
  /**
   * Multiplies this vector with the given 4x4 matrix.
   *
   * @param {Matrix4} m - The 4x4 matrix.
   * @return {Vector4} A reference to this vector.
   */
  applyMatrix4(e) {
    const t = this.x, s = this.y, i = this.z, a = this.w, n = e.elements;
    return this.x = n[0] * t + n[4] * s + n[8] * i + n[12] * a, this.y = n[1] * t + n[5] * s + n[9] * i + n[13] * a, this.z = n[2] * t + n[6] * s + n[10] * i + n[14] * a, this.w = n[3] * t + n[7] * s + n[11] * i + n[15] * a, this;
  }
  /**
   * Divides this instance by the given vector.
   *
   * @param {Vector4} v - The vector to divide.
   * @return {Vector4} A reference to this vector.
   */
  divide(e) {
    return this.x /= e.x, this.y /= e.y, this.z /= e.z, this.w /= e.w, this;
  }
  /**
   * Divides this vector by the given scalar.
   *
   * @param {number} scalar - The scalar to divide.
   * @return {Vector4} A reference to this vector.
   */
  divideScalar(e) {
    return this.multiplyScalar(1 / e);
  }
  /**
   * Sets the x, y and z components of this
   * vector to the quaternion's axis and w to the angle.
   *
   * @param {Quaternion} q - The Quaternion to set.
   * @return {Vector4} A reference to this vector.
   */
  setAxisAngleFromQuaternion(e) {
    this.w = 2 * Math.acos(e.w);
    const t = Math.sqrt(1 - e.w * e.w);
    return t < 1e-4 ? (this.x = 1, this.y = 0, this.z = 0) : (this.x = e.x / t, this.y = e.y / t, this.z = e.z / t), this;
  }
  /**
   * Sets the x, y and z components of this
   * vector to the axis of rotation and w to the angle.
   *
   * @param {Matrix4} m - A 4x4 matrix of which the upper left 3x3 matrix is a pure rotation matrix.
   * @return {Vector4} A reference to this vector.
   */
  setAxisAngleFromRotationMatrix(e) {
    let t, s, i, a;
    const n = e.elements, o = n[0], l = n[4], u = n[8], h = n[1], d = n[5], p = n[9], m = n[2], g = n[6], y = n[10];
    if (Math.abs(l - h) < 0.01 && Math.abs(u - m) < 0.01 && Math.abs(p - g) < 0.01) {
      if (Math.abs(l + h) < 0.1 && Math.abs(u + m) < 0.1 && Math.abs(p + g) < 0.1 && Math.abs(o + d + y - 3) < 0.1)
        return this.set(1, 0, 0, 0), this;
      t = Math.PI;
      const w = (o + 1) / 2, _ = (d + 1) / 2, C = (y + 1) / 2, V = (l + h) / 4, P = (u + m) / 4, z = (p + g) / 4;
      return w > _ && w > C ? w < 0.01 ? (s = 0, i = 0.707106781, a = 0.707106781) : (s = Math.sqrt(w), i = V / s, a = P / s) : _ > C ? _ < 0.01 ? (s = 0.707106781, i = 0, a = 0.707106781) : (i = Math.sqrt(_), s = V / i, a = z / i) : C < 0.01 ? (s = 0.707106781, i = 0.707106781, a = 0) : (a = Math.sqrt(C), s = P / a, i = z / a), this.set(s, i, a, t), this;
    }
    let v = Math.sqrt((g - p) * (g - p) + (u - m) * (u - m) + (h - l) * (h - l));
    return Math.abs(v) < 1e-3 && (v = 1), this.x = (g - p) / v, this.y = (u - m) / v, this.z = (h - l) / v, this.w = Math.acos((o + d + y - 1) / 2), this;
  }
  /**
   * Sets the vector components to the position elements of the
   * given transformation matrix.
   *
   * @param {Matrix4} m - The 4x4 matrix.
   * @return {Vector4} A reference to this vector.
   */
  setFromMatrixPosition(e) {
    const t = e.elements;
    return this.x = t[12], this.y = t[13], this.z = t[14], this.w = t[15], this;
  }
  /**
   * If this vector's x, y, z or w value is greater than the given vector's x, y, z or w
   * value, replace that value with the corresponding min value.
   *
   * @param {Vector4} v - The vector.
   * @return {Vector4} A reference to this vector.
   */
  min(e) {
    return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this.z = Math.min(this.z, e.z), this.w = Math.min(this.w, e.w), this;
  }
  /**
   * If this vector's x, y, z or w value is less than the given vector's x, y, z or w
   * value, replace that value with the corresponding max value.
   *
   * @param {Vector4} v - The vector.
   * @return {Vector4} A reference to this vector.
   */
  max(e) {
    return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this.z = Math.max(this.z, e.z), this.w = Math.max(this.w, e.w), this;
  }
  /**
   * If this vector's x, y, z or w value is greater than the max vector's x, y, z or w
   * value, it is replaced by the corresponding value.
   * If this vector's x, y, z or w value is less than the min vector's x, y, z or w value,
   * it is replaced by the corresponding value.
   *
   * @param {Vector4} min - The minimum x, y and z values.
   * @param {Vector4} max - The maximum x, y and z values in the desired range.
   * @return {Vector4} A reference to this vector.
   */
  clamp(e, t) {
    return this.x = ee(this.x, e.x, t.x), this.y = ee(this.y, e.y, t.y), this.z = ee(this.z, e.z, t.z), this.w = ee(this.w, e.w, t.w), this;
  }
  /**
   * If this vector's x, y, z or w values are greater than the max value, they are
   * replaced by the max value.
   * If this vector's x, y, z or w values are less than the min value, they are
   * replaced by the min value.
   *
   * @param {number} minVal - The minimum value the components will be clamped to.
   * @param {number} maxVal - The maximum value the components will be clamped to.
   * @return {Vector4} A reference to this vector.
   */
  clampScalar(e, t) {
    return this.x = ee(this.x, e, t), this.y = ee(this.y, e, t), this.z = ee(this.z, e, t), this.w = ee(this.w, e, t), this;
  }
  /**
   * If this vector's length is greater than the max value, it is replaced by
   * the max value.
   * If this vector's length is less than the min value, it is replaced by the
   * min value.
   *
   * @param {number} min - The minimum value the vector length will be clamped to.
   * @param {number} max - The maximum value the vector length will be clamped to.
   * @return {Vector4} A reference to this vector.
   */
  clampLength(e, t) {
    const s = this.length();
    return this.divideScalar(s || 1).multiplyScalar(ee(s, e, t));
  }
  /**
   * The components of this vector are rounded down to the nearest integer value.
   *
   * @return {Vector4} A reference to this vector.
   */
  floor() {
    return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this.w = Math.floor(this.w), this;
  }
  /**
   * The components of this vector are rounded up to the nearest integer value.
   *
   * @return {Vector4} A reference to this vector.
   */
  ceil() {
    return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this.w = Math.ceil(this.w), this;
  }
  /**
   * The components of this vector are rounded to the nearest integer value
   *
   * @return {Vector4} A reference to this vector.
   */
  round() {
    return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this.w = Math.round(this.w), this;
  }
  /**
   * The components of this vector are rounded towards zero (up if negative,
   * down if positive) to an integer value.
   *
   * @return {Vector4} A reference to this vector.
   */
  roundToZero() {
    return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this.w = Math.trunc(this.w), this;
  }
  /**
   * Inverts this vector - i.e. sets x = -x, y = -y, z = -z, w = -w.
   *
   * @return {Vector4} A reference to this vector.
   */
  negate() {
    return this.x = -this.x, this.y = -this.y, this.z = -this.z, this.w = -this.w, this;
  }
  /**
   * Calculates the dot product of the given vector with this instance.
   *
   * @param {Vector4} v - The vector to compute the dot product with.
   * @return {number} The result of the dot product.
   */
  dot(e) {
    return this.x * e.x + this.y * e.y + this.z * e.z + this.w * e.w;
  }
  /**
   * Computes the square of the Euclidean length (straight-line length) from
   * (0, 0, 0, 0) to (x, y, z, w). If you are comparing the lengths of vectors, you should
   * compare the length squared instead as it is slightly more efficient to calculate.
   *
   * @return {number} The square length of this vector.
   */
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
  }
  /**
   * Computes the  Euclidean length (straight-line length) from (0, 0, 0, 0) to (x, y, z, w).
   *
   * @return {number} The length of this vector.
   */
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
  }
  /**
   * Computes the Manhattan length of this vector.
   *
   * @return {number} The length of this vector.
   */
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
  }
  /**
   * Converts this vector to a unit vector - that is, sets it equal to a vector
   * with the same direction as this one, but with a vector length of `1`.
   *
   * @return {Vector4} A reference to this vector.
   */
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  /**
   * Sets this vector to a vector with the same direction as this one, but
   * with the specified length.
   *
   * @param {number} length - The new length of this vector.
   * @return {Vector4} A reference to this vector.
   */
  setLength(e) {
    return this.normalize().multiplyScalar(e);
  }
  /**
   * Linearly interpolates between the given vector and this instance, where
   * alpha is the percent distance along the line - alpha = 0 will be this
   * vector, and alpha = 1 will be the given one.
   *
   * @param {Vector4} v - The vector to interpolate towards.
   * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
   * @return {Vector4} A reference to this vector.
   */
  lerp(e, t) {
    return this.x += (e.x - this.x) * t, this.y += (e.y - this.y) * t, this.z += (e.z - this.z) * t, this.w += (e.w - this.w) * t, this;
  }
  /**
   * Linearly interpolates between the given vectors, where alpha is the percent
   * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
   * be the second one. The result is stored in this instance.
   *
   * @param {Vector4} v1 - The first vector.
   * @param {Vector4} v2 - The second vector.
   * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
   * @return {Vector4} A reference to this vector.
   */
  lerpVectors(e, t, s) {
    return this.x = e.x + (t.x - e.x) * s, this.y = e.y + (t.y - e.y) * s, this.z = e.z + (t.z - e.z) * s, this.w = e.w + (t.w - e.w) * s, this;
  }
  /**
   * Returns `true` if this vector is equal with the given one.
   *
   * @param {Vector4} v - The vector to test for equality.
   * @return {boolean} Whether this vector is equal with the given one.
   */
  equals(e) {
    return e.x === this.x && e.y === this.y && e.z === this.z && e.w === this.w;
  }
  /**
   * Sets this vector's x value to be `array[ offset ]`, y value to be `array[ offset + 1 ]`,
   * z value to be `array[ offset + 2 ]`, w value to be `array[ offset + 3 ]`.
   *
   * @param {Array<number>} array - An array holding the vector component values.
   * @param {number} [offset=0] - The offset into the array.
   * @return {Vector4} A reference to this vector.
   */
  fromArray(e, t = 0) {
    return this.x = e[t], this.y = e[t + 1], this.z = e[t + 2], this.w = e[t + 3], this;
  }
  /**
   * Writes the components of this vector to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the vector components.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The vector components.
   */
  toArray(e = [], t = 0) {
    return e[t] = this.x, e[t + 1] = this.y, e[t + 2] = this.z, e[t + 3] = this.w, e;
  }
  /**
   * Sets the components of this vector from the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
   * @param {number} index - The index into the attribute.
   * @return {Vector4} A reference to this vector.
   */
  fromBufferAttribute(e, t) {
    return this.x = e.getX(t), this.y = e.getY(t), this.z = e.getZ(t), this.w = e.getW(t), this;
  }
  /**
   * Sets each component of this vector to a pseudo-random value between `0` and
   * `1`, excluding `1`.
   *
   * @return {Vector4} A reference to this vector.
   */
  random() {
    return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this.w = Math.random(), this;
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y, yield this.z, yield this.w;
  }
};
kh.prototype.isVector4 = !0;
let tt = kh;
class Ti extends Ps {
  /**
   * Render target options.
   *
   * @typedef {Object} RenderTarget~Options
   * @property {boolean} [generateMipmaps=false] - Whether to generate mipmaps or not.
   * @property {number} [magFilter=LinearFilter] - The mag filter.
   * @property {number} [minFilter=LinearFilter] - The min filter.
   * @property {number} [format=RGBAFormat] - The texture format.
   * @property {number} [type=UnsignedByteType] - The texture type.
   * @property {?string} [internalFormat=null] - The texture's internal format.
   * @property {number} [wrapS=ClampToEdgeWrapping] - The texture's uv wrapping mode.
   * @property {number} [wrapT=ClampToEdgeWrapping] - The texture's uv wrapping mode.
   * @property {number} [anisotropy=1] - The texture's anisotropy value.
   * @property {string} [colorSpace=NoColorSpace] - The texture's color space.
   * @property {boolean} [depthBuffer=true] - Whether to allocate a depth buffer or not.
   * @property {boolean} [stencilBuffer=false] - Whether to allocate a stencil buffer or not.
   * @property {boolean} [resolveDepthBuffer=true] - Whether to resolve the depth buffer or not.
   * @property {boolean} [resolveStencilBuffer=true] - Whether  to resolve the stencil buffer or not.
   * @property {?Texture} [depthTexture=null] - Reference to a depth texture.
   * @property {number} [samples=0] - The MSAA samples count.
   * @property {number} [count=1] - Defines the number of color attachments . Must be at least `1`.
   * @property {number} [depth=1] - The texture depth.
   * @property {boolean} [multiview=false] - Whether this target is used for multiview rendering (WebGL OVR_multiview2 extension).
   * @property {boolean} [useArrayDepthTexture=false] - Whether to create the depth texture as an array texture for per-layer depth testing. This is separate from multiview so layered render targets can use array depth without the multiview extension.
   */
  /**
   * Constructs a new render target.
   *
   * @param {number} [width=1] - The width of the render target.
   * @param {number} [height=1] - The height of the render target.
   * @param {RenderTarget~Options} [options] - The configuration object.
   */
  constructor(e = 1, t = 1, s = {}) {
    super(), s = Object.assign({
      generateMipmaps: !1,
      internalFormat: null,
      minFilter: ms,
      depthBuffer: !0,
      stencilBuffer: !1,
      resolveDepthBuffer: !0,
      resolveStencilBuffer: !0,
      depthTexture: null,
      samples: 0,
      count: 1,
      depth: 1,
      multiview: !1,
      useArrayDepthTexture: !1
    }, s), this.isRenderTarget = !0, this.width = e, this.height = t, this.depth = s.depth, this.scissor = new tt(0, 0, e, t), this.scissorTest = !1, this.viewport = new tt(0, 0, e, t), this.textures = [];
    const i = { width: e, height: t, depth: s.depth }, a = new Ke(i), n = s.count;
    for (let o = 0; o < n; o++)
      this.textures[o] = a.clone(), this.textures[o].isRenderTargetTexture = !0, this.textures[o].renderTarget = this;
    this._setTextureOptions(s), this.depthBuffer = s.depthBuffer, this.stencilBuffer = s.stencilBuffer, this.resolveDepthBuffer = s.resolveDepthBuffer, this.resolveStencilBuffer = s.resolveStencilBuffer, this._depthTexture = null, this.depthTexture = s.depthTexture, this.samples = s.samples, this.multiview = s.multiview, this.useArrayDepthTexture = s.useArrayDepthTexture;
  }
  _setTextureOptions(e = {}) {
    const t = {
      minFilter: ms,
      generateMipmaps: !1,
      flipY: !1,
      internalFormat: null
    };
    e.mapping !== void 0 && (t.mapping = e.mapping), e.wrapS !== void 0 && (t.wrapS = e.wrapS), e.wrapT !== void 0 && (t.wrapT = e.wrapT), e.wrapR !== void 0 && (t.wrapR = e.wrapR), e.magFilter !== void 0 && (t.magFilter = e.magFilter), e.minFilter !== void 0 && (t.minFilter = e.minFilter), e.format !== void 0 && (t.format = e.format), e.type !== void 0 && (t.type = e.type), e.anisotropy !== void 0 && (t.anisotropy = e.anisotropy), e.colorSpace !== void 0 && (t.colorSpace = e.colorSpace), e.flipY !== void 0 && (t.flipY = e.flipY), e.generateMipmaps !== void 0 && (t.generateMipmaps = e.generateMipmaps), e.internalFormat !== void 0 && (t.internalFormat = e.internalFormat);
    for (let s = 0; s < this.textures.length; s++)
      this.textures[s].setValues(t);
  }
  /**
   * The texture representing the default color attachment.
   *
   * @type {Texture}
   */
  get texture() {
    return this.textures[0];
  }
  set texture(e) {
    this.textures[0] = e;
  }
  set depthTexture(e) {
    this._depthTexture !== null && (this._depthTexture.renderTarget = null), e !== null && (e.renderTarget = this), this._depthTexture = e;
  }
  /**
   * Instead of saving the depth in a renderbuffer, a texture
   * can be used instead which is useful for further processing
   * e.g. in context of post-processing.
   *
   * @type {?DepthTexture}
   * @default null
   */
  get depthTexture() {
    return this._depthTexture;
  }
  /**
   * Sets the size of this render target.
   *
   * @param {number} width - The width.
   * @param {number} height - The height.
   * @param {number} [depth=1] - The depth.
   */
  setSize(e, t, s = 1) {
    if (this.width !== e || this.height !== t || this.depth !== s) {
      this.width = e, this.height = t, this.depth = s;
      for (let i = 0, a = this.textures.length; i < a; i++)
        this.textures[i].image.width = e, this.textures[i].image.height = t, this.textures[i].image.depth = s, this.textures[i].isData3DTexture !== !0 && (this.textures[i].isArrayTexture = this.textures[i].image.depth > 1);
      this.dispose();
    }
    this.viewport.set(0, 0, e, t), this.scissor.set(0, 0, e, t);
  }
  /**
   * Returns a new render target with copied values from this instance.
   *
   * @return {RenderTarget} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
  /**
   * Copies the settings of the given render target. This is a structural copy so
   * no resources are shared between render targets after the copy. That includes
   * all MRT textures and the depth texture.
   *
   * @param {RenderTarget} source - The render target to copy.
   * @return {RenderTarget} A reference to this instance.
   */
  copy(e) {
    this.width = e.width, this.height = e.height, this.depth = e.depth, this.scissor.copy(e.scissor), this.scissorTest = e.scissorTest, this.viewport.copy(e.viewport), this.textures.length = 0;
    for (let t = 0, s = e.textures.length; t < s; t++) {
      this.textures[t] = e.textures[t].clone(), this.textures[t].isRenderTargetTexture = !0, this.textures[t].renderTarget = this;
      const i = Object.assign({}, e.textures[t].image);
      this.textures[t].source = new Ho(i);
    }
    return this.depthBuffer = e.depthBuffer, this.stencilBuffer = e.stencilBuffer, this.resolveDepthBuffer = e.resolveDepthBuffer, this.resolveStencilBuffer = e.resolveStencilBuffer, e.depthTexture !== null && (this.depthTexture = e.depthTexture.clone()), this.samples = e.samples, this.multiview = e.multiview, this.useArrayDepthTexture = e.useArrayDepthTexture, this;
  }
  /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever this instance is no longer used in your app.
   *
   * @fires RenderTarget#dispose
   */
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
}
class $g extends Ke {
  /**
   * Constructs a new data array texture.
   *
   * @param {?TypedArray} [data=null] - The buffer data.
   * @param {number} [width=1] - The width of the texture.
   * @param {number} [height=1] - The height of the texture.
   * @param {number} [depth=1] - The depth of the texture.
   */
  constructor(e = null, t = 1, s = 1, i = 1) {
    super(null), this.isDataArrayTexture = !0, this.image = { data: e, width: t, height: s, depth: i }, this.magFilter = at, this.minFilter = at, this.wrapR = Js, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1, this.layerUpdates = /* @__PURE__ */ new Set();
  }
  /**
   * Describes that a specific layer of the texture needs to be updated.
   * Normally when {@link Texture#needsUpdate} is set to `true`, the
   * entire data texture array is sent to the GPU. Marking specific
   * layers will only transmit subsets of all mipmaps associated with a
   * specific depth in the array which is often much more performant.
   *
   * @param {number} layerIndex - The layer index that should be updated.
   */
  addLayerUpdate(e) {
    this.layerUpdates.add(e);
  }
  /**
   * Resets the layer updates registry.
   */
  clearLayerUpdates() {
    this.layerUpdates.clear();
  }
}
const Dh = class Wh {
  /**
   * Constructs a new 4x4 matrix. The arguments are supposed to be
   * in row-major order. If no arguments are provided, the constructor
   * initializes the matrix as an identity matrix.
   *
   * @param {number} [n11] - 1-1 matrix element.
   * @param {number} [n12] - 1-2 matrix element.
   * @param {number} [n13] - 1-3 matrix element.
   * @param {number} [n14] - 1-4 matrix element.
   * @param {number} [n21] - 2-1 matrix element.
   * @param {number} [n22] - 2-2 matrix element.
   * @param {number} [n23] - 2-3 matrix element.
   * @param {number} [n24] - 2-4 matrix element.
   * @param {number} [n31] - 3-1 matrix element.
   * @param {number} [n32] - 3-2 matrix element.
   * @param {number} [n33] - 3-3 matrix element.
   * @param {number} [n34] - 3-4 matrix element.
   * @param {number} [n41] - 4-1 matrix element.
   * @param {number} [n42] - 4-2 matrix element.
   * @param {number} [n43] - 4-3 matrix element.
   * @param {number} [n44] - 4-4 matrix element.
   */
  constructor(e, t, s, i, a, n, o, l, u, h, d, p, m, g, y, v) {
    this.elements = [
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    ], e !== void 0 && this.set(e, t, s, i, a, n, o, l, u, h, d, p, m, g, y, v);
  }
  /**
   * Sets the elements of the matrix.The arguments are supposed to be
   * in row-major order.
   *
   * @param {number} [n11] - 1-1 matrix element.
   * @param {number} [n12] - 1-2 matrix element.
   * @param {number} [n13] - 1-3 matrix element.
   * @param {number} [n14] - 1-4 matrix element.
   * @param {number} [n21] - 2-1 matrix element.
   * @param {number} [n22] - 2-2 matrix element.
   * @param {number} [n23] - 2-3 matrix element.
   * @param {number} [n24] - 2-4 matrix element.
   * @param {number} [n31] - 3-1 matrix element.
   * @param {number} [n32] - 3-2 matrix element.
   * @param {number} [n33] - 3-3 matrix element.
   * @param {number} [n34] - 3-4 matrix element.
   * @param {number} [n41] - 4-1 matrix element.
   * @param {number} [n42] - 4-2 matrix element.
   * @param {number} [n43] - 4-3 matrix element.
   * @param {number} [n44] - 4-4 matrix element.
   * @return {Matrix4} A reference to this matrix.
   */
  set(e, t, s, i, a, n, o, l, u, h, d, p, m, g, y, v) {
    const w = this.elements;
    return w[0] = e, w[4] = t, w[8] = s, w[12] = i, w[1] = a, w[5] = n, w[9] = o, w[13] = l, w[2] = u, w[6] = h, w[10] = d, w[14] = p, w[3] = m, w[7] = g, w[11] = y, w[15] = v, this;
  }
  /**
   * Sets this matrix to the 4x4 identity matrix.
   *
   * @return {Matrix4} A reference to this matrix.
   */
  identity() {
    return this.set(
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Returns a matrix with copied values from this instance.
   *
   * @return {Matrix4} A clone of this instance.
   */
  clone() {
    return new Wh().fromArray(this.elements);
  }
  /**
   * Copies the values of the given matrix to this instance.
   *
   * @param {Matrix4} m - The matrix to copy.
   * @return {Matrix4} A reference to this matrix.
   */
  copy(e) {
    const t = this.elements, s = e.elements;
    return t[0] = s[0], t[1] = s[1], t[2] = s[2], t[3] = s[3], t[4] = s[4], t[5] = s[5], t[6] = s[6], t[7] = s[7], t[8] = s[8], t[9] = s[9], t[10] = s[10], t[11] = s[11], t[12] = s[12], t[13] = s[13], t[14] = s[14], t[15] = s[15], this;
  }
  /**
   * Copies the translation component of the given matrix
   * into this matrix's translation component.
   *
   * @param {Matrix4} m - The matrix to copy the translation component.
   * @return {Matrix4} A reference to this matrix.
   */
  copyPosition(e) {
    const t = this.elements, s = e.elements;
    return t[12] = s[12], t[13] = s[13], t[14] = s[14], this;
  }
  /**
   * Set the upper 3x3 elements of this matrix to the values of given 3x3 matrix.
   *
   * @param {Matrix3} m - The 3x3 matrix.
   * @return {Matrix4} A reference to this matrix.
   */
  setFromMatrix3(e) {
    const t = e.elements;
    return this.set(
      t[0],
      t[3],
      t[6],
      0,
      t[1],
      t[4],
      t[7],
      0,
      t[2],
      t[5],
      t[8],
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Extracts the basis of this matrix into the three axis vectors provided.
   *
   * @param {Vector3} xAxis - The basis's x axis.
   * @param {Vector3} yAxis - The basis's y axis.
   * @param {Vector3} zAxis - The basis's z axis.
   * @return {Matrix4} A reference to this matrix.
   */
  extractBasis(e, t, s) {
    return this.determinantAffine() === 0 ? (e.set(1, 0, 0), t.set(0, 1, 0), s.set(0, 0, 1), this) : (e.setFromMatrixColumn(this, 0), t.setFromMatrixColumn(this, 1), s.setFromMatrixColumn(this, 2), this);
  }
  /**
   * Sets the given basis vectors to this matrix.
   *
   * @param {Vector3} xAxis - The basis's x axis.
   * @param {Vector3} yAxis - The basis's y axis.
   * @param {Vector3} zAxis - The basis's z axis.
   * @return {Matrix4} A reference to this matrix.
   */
  makeBasis(e, t, s) {
    return this.set(
      e.x,
      t.x,
      s.x,
      0,
      e.y,
      t.y,
      s.y,
      0,
      e.z,
      t.z,
      s.z,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Extracts the rotation component of the given matrix
   * into this matrix's rotation component.
   *
   * Note: This method does not support reflection matrices.
   *
   * @param {Matrix4} m - The matrix.
   * @return {Matrix4} A reference to this matrix.
   */
  extractRotation(e) {
    if (e.determinantAffine() === 0)
      return this.identity();
    const t = this.elements, s = e.elements, i = 1 / fr.setFromMatrixColumn(e, 0).length(), a = 1 / fr.setFromMatrixColumn(e, 1).length(), n = 1 / fr.setFromMatrixColumn(e, 2).length();
    return t[0] = s[0] * i, t[1] = s[1] * i, t[2] = s[2] * i, t[3] = 0, t[4] = s[4] * a, t[5] = s[5] * a, t[6] = s[6] * a, t[7] = 0, t[8] = s[8] * n, t[9] = s[9] * n, t[10] = s[10] * n, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, this;
  }
  /**
   * Sets the rotation component (the upper left 3x3 matrix) of this matrix to
   * the rotation specified by the given Euler angles. The rest of
   * the matrix is set to the identity. Depending on the {@link Euler#order},
   * there are six possible outcomes. See [this page](https://en.wikipedia.org/wiki/Euler_angles#Rotation_matrix)
   * for a complete list.
   *
   * @param {Euler} euler - The Euler angles.
   * @return {Matrix4} A reference to this matrix.
   */
  makeRotationFromEuler(e) {
    const t = this.elements, s = e.x, i = e.y, a = e.z, n = Math.cos(s), o = Math.sin(s), l = Math.cos(i), u = Math.sin(i), h = Math.cos(a), d = Math.sin(a);
    if (e.order === "XYZ") {
      const p = n * h, m = n * d, g = o * h, y = o * d;
      t[0] = l * h, t[4] = -l * d, t[8] = u, t[1] = m + g * u, t[5] = p - y * u, t[9] = -o * l, t[2] = y - p * u, t[6] = g + m * u, t[10] = n * l;
    } else if (e.order === "YXZ") {
      const p = l * h, m = l * d, g = u * h, y = u * d;
      t[0] = p + y * o, t[4] = g * o - m, t[8] = n * u, t[1] = n * d, t[5] = n * h, t[9] = -o, t[2] = m * o - g, t[6] = y + p * o, t[10] = n * l;
    } else if (e.order === "ZXY") {
      const p = l * h, m = l * d, g = u * h, y = u * d;
      t[0] = p - y * o, t[4] = -n * d, t[8] = g + m * o, t[1] = m + g * o, t[5] = n * h, t[9] = y - p * o, t[2] = -n * u, t[6] = o, t[10] = n * l;
    } else if (e.order === "ZYX") {
      const p = n * h, m = n * d, g = o * h, y = o * d;
      t[0] = l * h, t[4] = g * u - m, t[8] = p * u + y, t[1] = l * d, t[5] = y * u + p, t[9] = m * u - g, t[2] = -u, t[6] = o * l, t[10] = n * l;
    } else if (e.order === "YZX") {
      const p = n * l, m = n * u, g = o * l, y = o * u;
      t[0] = l * h, t[4] = y - p * d, t[8] = g * d + m, t[1] = d, t[5] = n * h, t[9] = -o * h, t[2] = -u * h, t[6] = m * d + g, t[10] = p - y * d;
    } else if (e.order === "XZY") {
      const p = n * l, m = n * u, g = o * l, y = o * u;
      t[0] = l * h, t[4] = -d, t[8] = u * h, t[1] = p * d + y, t[5] = n * h, t[9] = m * d - g, t[2] = g * d - m, t[6] = o * h, t[10] = y * d + p;
    }
    return t[3] = 0, t[7] = 0, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, this;
  }
  /**
   * Sets the rotation component of this matrix to the rotation specified by
   * the given Quaternion as outlined [here](https://en.wikipedia.org/wiki/Rotation_matrix#Quaternion)
   * The rest of the matrix is set to the identity.
   *
   * @param {Quaternion} q - The Quaternion.
   * @return {Matrix4} A reference to this matrix.
   */
  makeRotationFromQuaternion(e) {
    return this.compose(Yg, e, Zg);
  }
  /**
   * Sets the rotation component of the transformation matrix, looking from `eye` towards
   * `target`, and oriented by the up-direction.
   *
   * @param {Vector3} eye - The eye vector.
   * @param {Vector3} target - The target vector.
   * @param {Vector3} up - The up vector.
   * @return {Matrix4} A reference to this matrix.
   */
  lookAt(e, t, s) {
    const i = this.elements;
    return ot.subVectors(e, t), ot.lengthSq() === 0 && (ot.z = 1), ot.normalize(), bs.crossVectors(s, ot), bs.lengthSq() === 0 && (Math.abs(s.z) === 1 ? ot.x += 1e-4 : ot.z += 1e-4, ot.normalize(), bs.crossVectors(s, ot)), bs.normalize(), Ei.crossVectors(ot, bs), i[0] = bs.x, i[4] = Ei.x, i[8] = ot.x, i[1] = bs.y, i[5] = Ei.y, i[9] = ot.y, i[2] = bs.z, i[6] = Ei.z, i[10] = ot.z, this;
  }
  /**
   * Post-multiplies this matrix by the given 4x4 matrix.
   *
   * @param {Matrix4} m - The matrix to multiply with.
   * @return {Matrix4} A reference to this matrix.
   */
  multiply(e) {
    return this.multiplyMatrices(this, e);
  }
  /**
   * Pre-multiplies this matrix by the given 4x4 matrix.
   *
   * @param {Matrix4} m - The matrix to multiply with.
   * @return {Matrix4} A reference to this matrix.
   */
  premultiply(e) {
    return this.multiplyMatrices(e, this);
  }
  /**
   * Multiples the given 4x4 matrices and stores the result
   * in this matrix.
   *
   * @param {Matrix4} a - The first matrix.
   * @param {Matrix4} b - The second matrix.
   * @return {Matrix4} A reference to this matrix.
   */
  multiplyMatrices(e, t) {
    const s = e.elements, i = t.elements, a = this.elements, n = s[0], o = s[4], l = s[8], u = s[12], h = s[1], d = s[5], p = s[9], m = s[13], g = s[2], y = s[6], v = s[10], w = s[14], _ = s[3], C = s[7], V = s[11], P = s[15], z = i[0], R = i[4], I = i[8], G = i[12], $ = i[1], Z = i[5], Ve = i[9], ue = i[13], Ye = i[2], se = i[6], ss = i[10], ks = i[14], xs = i[3], ke = i[7], We = i[11], nt = i[15];
    return a[0] = n * z + o * $ + l * Ye + u * xs, a[4] = n * R + o * Z + l * se + u * ke, a[8] = n * I + o * Ve + l * ss + u * We, a[12] = n * G + o * ue + l * ks + u * nt, a[1] = h * z + d * $ + p * Ye + m * xs, a[5] = h * R + d * Z + p * se + m * ke, a[9] = h * I + d * Ve + p * ss + m * We, a[13] = h * G + d * ue + p * ks + m * nt, a[2] = g * z + y * $ + v * Ye + w * xs, a[6] = g * R + y * Z + v * se + w * ke, a[10] = g * I + y * Ve + v * ss + w * We, a[14] = g * G + y * ue + v * ks + w * nt, a[3] = _ * z + C * $ + V * Ye + P * xs, a[7] = _ * R + C * Z + V * se + P * ke, a[11] = _ * I + C * Ve + V * ss + P * We, a[15] = _ * G + C * ue + V * ks + P * nt, this;
  }
  /**
   * Multiplies every component of the matrix by the given scalar.
   *
   * @param {number} s - The scalar.
   * @return {Matrix4} A reference to this matrix.
   */
  multiplyScalar(e) {
    const t = this.elements;
    return t[0] *= e, t[4] *= e, t[8] *= e, t[12] *= e, t[1] *= e, t[5] *= e, t[9] *= e, t[13] *= e, t[2] *= e, t[6] *= e, t[10] *= e, t[14] *= e, t[3] *= e, t[7] *= e, t[11] *= e, t[15] *= e, this;
  }
  /**
   * Computes and returns the determinant of this matrix.
   *
   * Based on the method outlined [here](http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.html).
   *
   * @return {number} The determinant.
   */
  determinant() {
    const e = this.elements, t = e[0], s = e[4], i = e[8], a = e[12], n = e[1], o = e[5], l = e[9], u = e[13], h = e[2], d = e[6], p = e[10], m = e[14], g = e[3], y = e[7], v = e[11], w = e[15], _ = l * m - u * p, C = o * m - u * d, V = o * p - l * d, P = n * m - u * h, z = n * p - l * h, R = n * d - o * h;
    return t * (y * _ - v * C + w * V) - s * (g * _ - v * P + w * z) + i * (g * C - y * P + w * R) - a * (g * V - y * z + v * R);
  }
  /**
   * Computes and returns the determinant of the 4x4 matrix, but assumes the
   * matrix is affine, saving some computations.
   *
   * For affine matrices (like an object's world matrix), this value equals the
   * full 4x4 {@link Matrix4#determinant} but is cheaper to compute.
   *
   * Assumes the bottom row is [0, 0, 0, 1].
   *
   * @return {number} The determinant of the matrix.
   */
  determinantAffine() {
    const e = this.elements, t = e[0], s = e[4], i = e[8], a = e[1], n = e[5], o = e[9], l = e[2], u = e[6], h = e[10];
    return t * (n * h - o * u) - s * (a * h - o * l) + i * (a * u - n * l);
  }
  /**
   * Transposes this matrix in place.
   *
   * @return {Matrix4} A reference to this matrix.
   */
  transpose() {
    const e = this.elements;
    let t;
    return t = e[1], e[1] = e[4], e[4] = t, t = e[2], e[2] = e[8], e[8] = t, t = e[6], e[6] = e[9], e[9] = t, t = e[3], e[3] = e[12], e[12] = t, t = e[7], e[7] = e[13], e[13] = t, t = e[11], e[11] = e[14], e[14] = t, this;
  }
  /**
   * Sets the position component for this matrix from the given vector,
   * without affecting the rest of the matrix.
   *
   * @param {number|Vector3} x - The x component of the vector or alternatively the vector object.
   * @param {number} y - The y component of the vector.
   * @param {number} z - The z component of the vector.
   * @return {Matrix4} A reference to this matrix.
   */
  setPosition(e, t, s) {
    const i = this.elements;
    return e.isVector3 ? (i[12] = e.x, i[13] = e.y, i[14] = e.z) : (i[12] = e, i[13] = t, i[14] = s), this;
  }
  /**
   * Inverts this matrix, using the [analytic method](https://en.wikipedia.org/wiki/Invertible_matrix#Analytic_solution).
   * You can not invert with a determinant of zero. If you attempt this, the method produces
   * a zero matrix instead.
   *
   * @return {Matrix4} A reference to this matrix.
   */
  invert() {
    const e = this.elements, t = e[0], s = e[1], i = e[2], a = e[3], n = e[4], o = e[5], l = e[6], u = e[7], h = e[8], d = e[9], p = e[10], m = e[11], g = e[12], y = e[13], v = e[14], w = e[15], _ = t * o - s * n, C = t * l - i * n, V = t * u - a * n, P = s * l - i * o, z = s * u - a * o, R = i * u - a * l, I = h * y - d * g, G = h * v - p * g, $ = h * w - m * g, Z = d * v - p * y, Ve = d * w - m * y, ue = p * w - m * v, Ye = _ * ue - C * Ve + V * Z + P * $ - z * G + R * I;
    if (Ye === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    const se = 1 / Ye;
    return e[0] = (o * ue - l * Ve + u * Z) * se, e[1] = (i * Ve - s * ue - a * Z) * se, e[2] = (y * R - v * z + w * P) * se, e[3] = (p * z - d * R - m * P) * se, e[4] = (l * $ - n * ue - u * G) * se, e[5] = (t * ue - i * $ + a * G) * se, e[6] = (v * V - g * R - w * C) * se, e[7] = (h * R - p * V + m * C) * se, e[8] = (n * Ve - o * $ + u * I) * se, e[9] = (s * $ - t * Ve - a * I) * se, e[10] = (g * z - y * V + w * _) * se, e[11] = (d * V - h * z - m * _) * se, e[12] = (o * G - n * Z - l * I) * se, e[13] = (t * Z - s * G + i * I) * se, e[14] = (y * C - g * P - v * _) * se, e[15] = (h * P - d * C + p * _) * se, this;
  }
  /**
   * Multiplies the columns of this matrix by the given vector.
   *
   * @param {Vector3} v - The scale vector.
   * @return {Matrix4} A reference to this matrix.
   */
  scale(e) {
    const t = this.elements, s = e.x, i = e.y, a = e.z;
    return t[0] *= s, t[4] *= i, t[8] *= a, t[1] *= s, t[5] *= i, t[9] *= a, t[2] *= s, t[6] *= i, t[10] *= a, t[3] *= s, t[7] *= i, t[11] *= a, this;
  }
  /**
   * Gets the maximum scale value of the three axes.
   *
   * @return {number} The maximum scale.
   */
  getMaxScaleOnAxis() {
    const e = this.elements, t = e[0] * e[0] + e[1] * e[1] + e[2] * e[2], s = e[4] * e[4] + e[5] * e[5] + e[6] * e[6], i = e[8] * e[8] + e[9] * e[9] + e[10] * e[10];
    return Math.sqrt(Math.max(t, s, i));
  }
  /**
   * Sets this matrix as a translation transform from the given vector.
   *
   * @param {number|Vector3} x - The amount to translate in the X axis or alternatively a translation vector.
   * @param {number} y - The amount to translate in the Y axis.
   * @param {number} z - The amount to translate in the z axis.
   * @return {Matrix4} A reference to this matrix.
   */
  makeTranslation(e, t, s) {
    return e.isVector3 ? this.set(
      1,
      0,
      0,
      e.x,
      0,
      1,
      0,
      e.y,
      0,
      0,
      1,
      e.z,
      0,
      0,
      0,
      1
    ) : this.set(
      1,
      0,
      0,
      e,
      0,
      1,
      0,
      t,
      0,
      0,
      1,
      s,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a rotational transformation around the X axis by
   * the given angle.
   *
   * @param {number} theta - The rotation in radians.
   * @return {Matrix4} A reference to this matrix.
   */
  makeRotationX(e) {
    const t = Math.cos(e), s = Math.sin(e);
    return this.set(
      1,
      0,
      0,
      0,
      0,
      t,
      -s,
      0,
      0,
      s,
      t,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a rotational transformation around the Y axis by
   * the given angle.
   *
   * @param {number} theta - The rotation in radians.
   * @return {Matrix4} A reference to this matrix.
   */
  makeRotationY(e) {
    const t = Math.cos(e), s = Math.sin(e);
    return this.set(
      t,
      0,
      s,
      0,
      0,
      1,
      0,
      0,
      -s,
      0,
      t,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a rotational transformation around the Z axis by
   * the given angle.
   *
   * @param {number} theta - The rotation in radians.
   * @return {Matrix4} A reference to this matrix.
   */
  makeRotationZ(e) {
    const t = Math.cos(e), s = Math.sin(e);
    return this.set(
      t,
      -s,
      0,
      0,
      s,
      t,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a rotational transformation around the given axis by
   * the given angle.
   *
   * This is a somewhat controversial but mathematically sound alternative to
   * rotating via Quaternions. See the discussion [here](https://www.gamedev.net/articles/programming/math-and-physics/do-we-really-need-quaternions-r1199).
   *
   * @param {Vector3} axis - The normalized rotation axis.
   * @param {number} angle - The rotation in radians.
   * @return {Matrix4} A reference to this matrix.
   */
  makeRotationAxis(e, t) {
    const s = Math.cos(t), i = Math.sin(t), a = 1 - s, n = e.x, o = e.y, l = e.z, u = a * n, h = a * o;
    return this.set(
      u * n + s,
      u * o - i * l,
      u * l + i * o,
      0,
      u * o + i * l,
      h * o + s,
      h * l - i * n,
      0,
      u * l - i * o,
      h * l + i * n,
      a * l * l + s,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a scale transformation.
   *
   * @param {number} x - The amount to scale in the X axis.
   * @param {number} y - The amount to scale in the Y axis.
   * @param {number} z - The amount to scale in the Z axis.
   * @return {Matrix4} A reference to this matrix.
   */
  makeScale(e, t, s) {
    return this.set(
      e,
      0,
      0,
      0,
      0,
      t,
      0,
      0,
      0,
      0,
      s,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a shear transformation.
   *
   * @param {number} xy - The amount to shear X by Y.
   * @param {number} xz - The amount to shear X by Z.
   * @param {number} yx - The amount to shear Y by X.
   * @param {number} yz - The amount to shear Y by Z.
   * @param {number} zx - The amount to shear Z by X.
   * @param {number} zy - The amount to shear Z by Y.
   * @return {Matrix4} A reference to this matrix.
   */
  makeShear(e, t, s, i, a, n) {
    return this.set(
      1,
      s,
      a,
      0,
      e,
      1,
      n,
      0,
      t,
      i,
      1,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix to the transformation composed of the given position,
   * rotation (Quaternion) and scale.
   *
   * @param {Vector3} position - The position vector.
   * @param {Quaternion} quaternion - The rotation as a Quaternion.
   * @param {Vector3} scale - The scale vector.
   * @return {Matrix4} A reference to this matrix.
   */
  compose(e, t, s) {
    const i = this.elements, a = t._x, n = t._y, o = t._z, l = t._w, u = a + a, h = n + n, d = o + o, p = a * u, m = a * h, g = a * d, y = n * h, v = n * d, w = o * d, _ = l * u, C = l * h, V = l * d, P = s.x, z = s.y, R = s.z;
    return i[0] = (1 - (y + w)) * P, i[1] = (m + V) * P, i[2] = (g - C) * P, i[3] = 0, i[4] = (m - V) * z, i[5] = (1 - (p + w)) * z, i[6] = (v + _) * z, i[7] = 0, i[8] = (g + C) * R, i[9] = (v - _) * R, i[10] = (1 - (p + y)) * R, i[11] = 0, i[12] = e.x, i[13] = e.y, i[14] = e.z, i[15] = 1, this;
  }
  /**
   * Decomposes this matrix into its position, rotation and scale components
   * and provides the result in the given objects.
   *
   * Note: Not all matrices are decomposable in this way. For example, if an
   * object has a non-uniformly scaled parent, then the object's world matrix
   * may not be decomposable, and this method may not be appropriate.
   *
   * @param {Vector3} position - The position vector.
   * @param {Quaternion} quaternion - The rotation as a Quaternion.
   * @param {Vector3} scale - The scale vector.
   * @return {Matrix4} A reference to this matrix.
   */
  decompose(e, t, s) {
    const i = this.elements;
    e.x = i[12], e.y = i[13], e.z = i[14];
    const a = this.determinantAffine();
    if (a === 0)
      return s.set(1, 1, 1), t.identity(), this;
    let n = fr.set(i[0], i[1], i[2]).length();
    const o = fr.set(i[4], i[5], i[6]).length(), l = fr.set(i[8], i[9], i[10]).length();
    a < 0 && (n = -n), At.copy(this);
    const u = 1 / n, h = 1 / o, d = 1 / l;
    return At.elements[0] *= u, At.elements[1] *= u, At.elements[2] *= u, At.elements[4] *= h, At.elements[5] *= h, At.elements[6] *= h, At.elements[8] *= d, At.elements[9] *= d, At.elements[10] *= d, t.setFromRotationMatrix(At), s.x = n, s.y = o, s.z = l, this;
  }
  /**
  	 * Creates a perspective projection matrix. This is used internally by
  	 * {@link PerspectiveCamera#updateProjectionMatrix}.
  
  	 * @param {number} left - Left boundary of the viewing frustum at the near plane.
  	 * @param {number} right - Right boundary of the viewing frustum at the near plane.
  	 * @param {number} top - Top boundary of the viewing frustum at the near plane.
  	 * @param {number} bottom - Bottom boundary of the viewing frustum at the near plane.
  	 * @param {number} near - The distance from the camera to the near plane.
  	 * @param {number} far - The distance from the camera to the far plane.
  	 * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} [coordinateSystem=WebGLCoordinateSystem] - The coordinate system.
  	 * @param {boolean} [reversedDepth=false] - Whether to use a reversed depth.
  	 * @return {Matrix4} A reference to this matrix.
  	 */
  makePerspective(e, t, s, i, a, n, o = Vs, l = !1) {
    const u = this.elements, h = 2 * a / (t - e), d = 2 * a / (s - i), p = (t + e) / (t - e), m = (s + i) / (s - i);
    let g, y;
    if (l)
      g = a / (n - a), y = n * a / (n - a);
    else if (o === Vs)
      g = -(n + a) / (n - a), y = -2 * n * a / (n - a);
    else if (o === Ls)
      g = -n / (n - a), y = -n * a / (n - a);
    else
      throw new Error("THREE.Matrix4.makePerspective(): Invalid coordinate system: " + o);
    return u[0] = h, u[4] = 0, u[8] = p, u[12] = 0, u[1] = 0, u[5] = d, u[9] = m, u[13] = 0, u[2] = 0, u[6] = 0, u[10] = g, u[14] = y, u[3] = 0, u[7] = 0, u[11] = -1, u[15] = 0, this;
  }
  /**
  	 * Creates a orthographic projection matrix. This is used internally by
  	 * {@link OrthographicCamera#updateProjectionMatrix}.
  
  	 * @param {number} left - Left boundary of the viewing frustum at the near plane.
  	 * @param {number} right - Right boundary of the viewing frustum at the near plane.
  	 * @param {number} top - Top boundary of the viewing frustum at the near plane.
  	 * @param {number} bottom - Bottom boundary of the viewing frustum at the near plane.
  	 * @param {number} near - The distance from the camera to the near plane.
  	 * @param {number} far - The distance from the camera to the far plane.
  	 * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} [coordinateSystem=WebGLCoordinateSystem] - The coordinate system.
  	 * @param {boolean} [reversedDepth=false] - Whether to use a reversed depth.
  	 * @return {Matrix4} A reference to this matrix.
  	 */
  makeOrthographic(e, t, s, i, a, n, o = Vs, l = !1) {
    const u = this.elements, h = 2 / (t - e), d = 2 / (s - i), p = -(t + e) / (t - e), m = -(s + i) / (s - i);
    let g, y;
    if (l)
      g = 1 / (n - a), y = n / (n - a);
    else if (o === Vs)
      g = -2 / (n - a), y = -(n + a) / (n - a);
    else if (o === Ls)
      g = -1 / (n - a), y = -a / (n - a);
    else
      throw new Error("THREE.Matrix4.makeOrthographic(): Invalid coordinate system: " + o);
    return u[0] = h, u[4] = 0, u[8] = 0, u[12] = p, u[1] = 0, u[5] = d, u[9] = 0, u[13] = m, u[2] = 0, u[6] = 0, u[10] = g, u[14] = y, u[3] = 0, u[7] = 0, u[11] = 0, u[15] = 1, this;
  }
  /**
   * Returns `true` if this matrix is equal with the given one.
   *
   * @param {Matrix4} matrix - The matrix to test for equality.
   * @return {boolean} Whether this matrix is equal with the given one.
   */
  equals(e) {
    const t = this.elements, s = e.elements;
    for (let i = 0; i < 16; i++)
      if (t[i] !== s[i]) return !1;
    return !0;
  }
  /**
   * Sets the elements of the matrix from the given array.
   *
   * @param {Array<number>} array - The matrix elements in column-major order.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Matrix4} A reference to this matrix.
   */
  fromArray(e, t = 0) {
    for (let s = 0; s < 16; s++)
      this.elements[s] = e[s + t];
    return this;
  }
  /**
   * Writes the elements of this matrix to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the matrix elements in column-major order.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The matrix elements in column-major order.
   */
  toArray(e = [], t = 0) {
    const s = this.elements;
    return e[t] = s[0], e[t + 1] = s[1], e[t + 2] = s[2], e[t + 3] = s[3], e[t + 4] = s[4], e[t + 5] = s[5], e[t + 6] = s[6], e[t + 7] = s[7], e[t + 8] = s[8], e[t + 9] = s[9], e[t + 10] = s[10], e[t + 11] = s[11], e[t + 12] = s[12], e[t + 13] = s[13], e[t + 14] = s[14], e[t + 15] = s[15], e;
  }
};
Dh.prototype.isMatrix4 = !0;
let de = Dh;
const fr = /* @__PURE__ */ new M(), At = /* @__PURE__ */ new de(), Yg = /* @__PURE__ */ new M(0, 0, 0), Zg = /* @__PURE__ */ new M(1, 1, 1), bs = /* @__PURE__ */ new M(), Ei = /* @__PURE__ */ new M(), ot = /* @__PURE__ */ new M(), _u = /* @__PURE__ */ new de(), Au = /* @__PURE__ */ new Gr();
class wi {
  /**
   * Constructs a new euler instance.
   *
   * @param {number} [x=0] - The angle of the x axis in radians.
   * @param {number} [y=0] - The angle of the y axis in radians.
   * @param {number} [z=0] - The angle of the z axis in radians.
   * @param {string} [order=Euler.DEFAULT_ORDER] - A string representing the order that the rotations are applied.
   */
  constructor(e = 0, t = 0, s = 0, i = wi.DEFAULT_ORDER) {
    this.isEuler = !0, this._x = e, this._y = t, this._z = s, this._order = i;
  }
  /**
   * The angle of the x axis in radians.
   *
   * @type {number}
   * @default 0
   */
  get x() {
    return this._x;
  }
  set x(e) {
    this._x = e, this._onChangeCallback();
  }
  /**
   * The angle of the y axis in radians.
   *
   * @type {number}
   * @default 0
   */
  get y() {
    return this._y;
  }
  set y(e) {
    this._y = e, this._onChangeCallback();
  }
  /**
   * The angle of the z axis in radians.
   *
   * @type {number}
   * @default 0
   */
  get z() {
    return this._z;
  }
  set z(e) {
    this._z = e, this._onChangeCallback();
  }
  /**
   * A string representing the order that the rotations are applied.
   *
   * @type {string}
   * @default 'XYZ'
   */
  get order() {
    return this._order;
  }
  set order(e) {
    this._order = e, this._onChangeCallback();
  }
  /**
   * Sets the Euler components.
   *
   * @param {number} x - The angle of the x axis in radians.
   * @param {number} y - The angle of the y axis in radians.
   * @param {number} z - The angle of the z axis in radians.
   * @param {string} [order] - A string representing the order that the rotations are applied.
   * @return {Euler} A reference to this Euler instance.
   */
  set(e, t, s, i = this._order) {
    return this._x = e, this._y = t, this._z = s, this._order = i, this._onChangeCallback(), this;
  }
  /**
   * Returns a new Euler instance with copied values from this instance.
   *
   * @return {Euler} A clone of this instance.
   */
  clone() {
    return new this.constructor(this._x, this._y, this._z, this._order);
  }
  /**
   * Copies the values of the given Euler instance to this instance.
   *
   * @param {Euler} euler - The Euler instance to copy.
   * @return {Euler} A reference to this Euler instance.
   */
  copy(e) {
    return this._x = e._x, this._y = e._y, this._z = e._z, this._order = e._order, this._onChangeCallback(), this;
  }
  /**
   * Sets the angles of this Euler instance from a pure rotation matrix.
   *
   * @param {Matrix4} m - A 4x4 matrix of which the upper 3x3 of matrix is a pure rotation matrix (i.e. unscaled).
   * @param {string} [order] - A string representing the order that the rotations are applied.
   * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
   * @return {Euler} A reference to this Euler instance.
   */
  setFromRotationMatrix(e, t = this._order, s = !0) {
    const i = e.elements, a = i[0], n = i[4], o = i[8], l = i[1], u = i[5], h = i[9], d = i[2], p = i[6], m = i[10];
    switch (t) {
      case "XYZ":
        this._y = Math.asin(ee(o, -1, 1)), Math.abs(o) < 0.9999999 ? (this._x = Math.atan2(-h, m), this._z = Math.atan2(-n, a)) : (this._x = Math.atan2(p, u), this._z = 0);
        break;
      case "YXZ":
        this._x = Math.asin(-ee(h, -1, 1)), Math.abs(h) < 0.9999999 ? (this._y = Math.atan2(o, m), this._z = Math.atan2(l, u)) : (this._y = Math.atan2(-d, a), this._z = 0);
        break;
      case "ZXY":
        this._x = Math.asin(ee(p, -1, 1)), Math.abs(p) < 0.9999999 ? (this._y = Math.atan2(-d, m), this._z = Math.atan2(-n, u)) : (this._y = 0, this._z = Math.atan2(l, a));
        break;
      case "ZYX":
        this._y = Math.asin(-ee(d, -1, 1)), Math.abs(d) < 0.9999999 ? (this._x = Math.atan2(p, m), this._z = Math.atan2(l, a)) : (this._x = 0, this._z = Math.atan2(-n, u));
        break;
      case "YZX":
        this._z = Math.asin(ee(l, -1, 1)), Math.abs(l) < 0.9999999 ? (this._x = Math.atan2(-h, u), this._y = Math.atan2(-d, a)) : (this._x = 0, this._y = Math.atan2(o, m));
        break;
      case "XZY":
        this._z = Math.asin(-ee(n, -1, 1)), Math.abs(n) < 0.9999999 ? (this._x = Math.atan2(p, u), this._y = Math.atan2(o, a)) : (this._x = Math.atan2(-h, m), this._y = 0);
        break;
      default:
        X("Euler: .setFromRotationMatrix() encountered an unknown order: " + t);
    }
    return this._order = t, s === !0 && this._onChangeCallback(), this;
  }
  /**
   * Sets the angles of this Euler instance from a normalized quaternion.
   *
   * @param {Quaternion} q - A normalized Quaternion.
   * @param {string} [order] - A string representing the order that the rotations are applied.
   * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
   * @return {Euler} A reference to this Euler instance.
   */
  setFromQuaternion(e, t, s) {
    return _u.makeRotationFromQuaternion(e), this.setFromRotationMatrix(_u, t, s);
  }
  /**
   * Sets the angles of this Euler instance from the given vector.
   *
   * @param {Vector3} v - The vector.
   * @param {string} [order] - A string representing the order that the rotations are applied.
   * @return {Euler} A reference to this Euler instance.
   */
  setFromVector3(e, t = this._order) {
    return this.set(e.x, e.y, e.z, t);
  }
  /**
   * Resets the euler angle with a new order by creating a quaternion from this
   * euler angle and then setting this euler angle with the quaternion and the
   * new order.
   *
   * Warning: This discards revolution information.
   *
   * @param {string} [newOrder] - A string representing the new order that the rotations are applied.
   * @return {Euler} A reference to this Euler instance.
   */
  reorder(e) {
    return Au.setFromEuler(this), this.setFromQuaternion(Au, e);
  }
  /**
   * Returns `true` if this Euler instance is equal with the given one.
   *
   * @param {Euler} euler - The Euler instance to test for equality.
   * @return {boolean} Whether this Euler instance is equal with the given one.
   */
  equals(e) {
    return e._x === this._x && e._y === this._y && e._z === this._z && e._order === this._order;
  }
  /**
   * Sets this Euler instance's components to values from the given array. The first three
   * entries of the array are assign to the x,y and z components. An optional fourth entry
   * defines the Euler order.
   *
   * @param {Array<number,number,number,?string>} array - An array holding the Euler component values.
   * @return {Euler} A reference to this Euler instance.
   */
  fromArray(e) {
    return this._x = e[0], this._y = e[1], this._z = e[2], e[3] !== void 0 && (this._order = e[3]), this._onChangeCallback(), this;
  }
  /**
   * Writes the components of this Euler instance to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number,number,number,string>} [array=[]] - The target array holding the Euler components.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number,number,number,string>} The Euler components.
   */
  toArray(e = [], t = 0) {
    return e[t] = this._x, e[t + 1] = this._y, e[t + 2] = this._z, e[t + 3] = this._order, e;
  }
  _onChange(e) {
    return this._onChangeCallback = e, this;
  }
  _onChangeCallback() {
  }
  *[Symbol.iterator]() {
    yield this._x, yield this._y, yield this._z, yield this._order;
  }
}
wi.DEFAULT_ORDER = "XYZ";
class Jg {
  /**
   * Constructs a new layers instance, with membership
   * initially set to layer `0`.
   */
  constructor() {
    this.mask = 1;
  }
  /**
   * Sets membership to the given layer, and remove membership all other layers.
   *
   * @param {number} layer - The layer to set.
   */
  set(e) {
    this.mask = (1 << e | 0) >>> 0;
  }
  /**
   * Adds membership of the given layer.
   *
   * @param {number} layer - The layer to enable.
   */
  enable(e) {
    this.mask |= 1 << e | 0;
  }
  /**
   * Adds membership to all layers.
   */
  enableAll() {
    this.mask = -1;
  }
  /**
   * Toggles the membership of the given layer.
   *
   * @param {number} layer - The layer to toggle.
   */
  toggle(e) {
    this.mask ^= 1 << e | 0;
  }
  /**
   * Removes membership of the given layer.
   *
   * @param {number} layer - The layer to enable.
   */
  disable(e) {
    this.mask &= ~(1 << e | 0);
  }
  /**
   * Removes the membership from all layers.
   */
  disableAll() {
    this.mask = 0;
  }
  /**
   * Returns `true` if this and the given layers object have at least one
   * layer in common.
   *
   * @param {Layers} layers - The layers to test.
   * @return {boolean } Whether this and the given layers object have at least one layer in common or not.
   */
  test(e) {
    return (this.mask & e.mask) !== 0;
  }
  /**
   * Returns `true` if the given layer is enabled.
   *
   * @param {number} layer - The layer to test.
   * @return {boolean } Whether the given layer is enabled or not.
   */
  isEnabled(e) {
    return (this.mask & (1 << e | 0)) !== 0;
  }
}
let Qg = 0;
const Vu = /* @__PURE__ */ new M(), yr = /* @__PURE__ */ new Gr(), rs = /* @__PURE__ */ new de(), Li = /* @__PURE__ */ new M(), Kr = /* @__PURE__ */ new M(), Kg = /* @__PURE__ */ new M(), ef = /* @__PURE__ */ new Gr(), Cu = /* @__PURE__ */ new M(1, 0, 0), zu = /* @__PURE__ */ new M(0, 1, 0), Ru = /* @__PURE__ */ new M(0, 0, 1), Eu = { type: "added" }, tf = { type: "removed" }, xr = { type: "childadded", child: null }, wn = { type: "childremoved", child: null };
class Pt extends Ps {
  /**
   * Constructs a new 3D object.
   */
  constructor() {
    super(), this.isObject3D = !0, Object.defineProperty(this, "id", { value: Qg++ }), this.uuid = cs(), this.name = "", this.type = "Object3D", this.parent = null, this.children = [], this.up = Pt.DEFAULT_UP.clone();
    const e = new M(), t = new wi(), s = new Gr(), i = new M(1, 1, 1);
    function a() {
      s.setFromEuler(t, !1);
    }
    function n() {
      t.setFromQuaternion(s, void 0, !1);
    }
    t._onChange(a), s._onChange(n), Object.defineProperties(this, {
      /**
       * Represents the object's local position.
       *
       * @name Object3D#position
       * @type {Vector3}
       * @default (0,0,0)
       */
      position: {
        configurable: !0,
        enumerable: !0,
        value: e
      },
      /**
       * Represents the object's local rotation as Euler angles, in radians.
       *
       * @name Object3D#rotation
       * @type {Euler}
       * @default (0,0,0)
       */
      rotation: {
        configurable: !0,
        enumerable: !0,
        value: t
      },
      /**
       * Represents the object's local rotation as Quaternions.
       *
       * @name Object3D#quaternion
       * @type {Quaternion}
       */
      quaternion: {
        configurable: !0,
        enumerable: !0,
        value: s
      },
      /**
       * Represents the object's local scale.
       *
       * @name Object3D#scale
       * @type {Vector3}
       * @default (1,1,1)
       */
      scale: {
        configurable: !0,
        enumerable: !0,
        value: i
      },
      /**
       * Represents the object's model-view matrix.
       *
       * @name Object3D#modelViewMatrix
       * @type {Matrix4}
       */
      modelViewMatrix: {
        value: new de()
      },
      /**
       * Represents the object's normal matrix.
       *
       * @name Object3D#normalMatrix
       * @type {Matrix3}
       */
      normalMatrix: {
        value: new Kt()
      }
    }), this.matrix = new de(), this.matrixWorld = new de(), this.matrixAutoUpdate = Pt.DEFAULT_MATRIX_AUTO_UPDATE, this.matrixWorldAutoUpdate = Pt.DEFAULT_MATRIX_WORLD_AUTO_UPDATE, this.matrixWorldNeedsUpdate = !1, this.layers = new Jg(), this.visible = !0, this.castShadow = !1, this.receiveShadow = !1, this.frustumCulled = !0, this.renderOrder = 0, this.animations = [], this.customDepthMaterial = void 0, this.customDistanceMaterial = void 0, this.static = !1, this.userData = {}, this.pivot = null;
  }
  /**
   * A callback that is executed immediately before a 3D object is rendered to a shadow map.
   *
   * @param {Renderer|WebGLRenderer} renderer - The renderer.
   * @param {Object3D} object - The 3D object.
   * @param {Camera} camera - The camera that is used to render the scene.
   * @param {Camera} shadowCamera - The shadow camera.
   * @param {BufferGeometry} geometry - The 3D object's geometry.
   * @param {Material} depthMaterial - The depth material.
   * @param {Object} group - The geometry group data.
   */
  onBeforeShadow() {
  }
  /**
   * A callback that is executed immediately after a 3D object is rendered to a shadow map.
   *
   * @param {Renderer|WebGLRenderer} renderer - The renderer.
   * @param {Object3D} object - The 3D object.
   * @param {Camera} camera - The camera that is used to render the scene.
   * @param {Camera} shadowCamera - The shadow camera.
   * @param {BufferGeometry} geometry - The 3D object's geometry.
   * @param {Material} depthMaterial - The depth material.
   * @param {Object} group - The geometry group data.
   */
  onAfterShadow() {
  }
  /**
   * A callback that is executed immediately before a 3D object is rendered.
   *
   * @param {Renderer|WebGLRenderer} renderer - The renderer.
   * @param {Object3D} object - The 3D object.
   * @param {Camera} camera - The camera that is used to render the scene.
   * @param {BufferGeometry} geometry - The 3D object's geometry.
   * @param {Material} material - The 3D object's material.
   * @param {Object} group - The geometry group data.
   */
  onBeforeRender() {
  }
  /**
   * A callback that is executed immediately after a 3D object is rendered.
   *
   * @param {Renderer|WebGLRenderer} renderer - The renderer.
   * @param {Object3D} object - The 3D object.
   * @param {Camera} camera - The camera that is used to render the scene.
   * @param {BufferGeometry} geometry - The 3D object's geometry.
   * @param {Material} material - The 3D object's material.
   * @param {Object} group - The geometry group data.
   */
  onAfterRender() {
  }
  /**
   * Applies the given transformation matrix to the object and updates the object's position,
   * rotation and scale.
   *
   * @param {Matrix4} matrix - The transformation matrix.
   */
  applyMatrix4(e) {
    this.matrixAutoUpdate && this.updateMatrix(), this.matrix.premultiply(e), this.matrix.decompose(this.position, this.quaternion, this.scale);
  }
  /**
   * Applies a rotation represented by given the quaternion to the 3D object.
   *
   * @param {Quaternion} q - The quaternion.
   * @return {Object3D} A reference to this instance.
   */
  applyQuaternion(e) {
    return this.quaternion.premultiply(e), this;
  }
  /**
   * Sets the given rotation represented as an axis/angle couple to the 3D object.
   *
   * @param {Vector3} axis - The (normalized) axis vector.
   * @param {number} angle - The angle in radians.
   */
  setRotationFromAxisAngle(e, t) {
    this.quaternion.setFromAxisAngle(e, t);
  }
  /**
   * Sets the given rotation represented as Euler angles to the 3D object.
   *
   * @param {Euler} euler - The Euler angles.
   */
  setRotationFromEuler(e) {
    this.quaternion.setFromEuler(e, !0);
  }
  /**
   * Sets the given rotation represented as rotation matrix to the 3D object.
   *
   * @param {Matrix4} m - Although a 4x4 matrix is expected, the upper 3x3 portion must be
   * a pure rotation matrix (i.e, unscaled).
   */
  setRotationFromMatrix(e) {
    this.quaternion.setFromRotationMatrix(e);
  }
  /**
   * Sets the given rotation represented as a Quaternion to the 3D object.
   *
   * @param {Quaternion} q - The Quaternion
   */
  setRotationFromQuaternion(e) {
    this.quaternion.copy(e);
  }
  /**
   * Rotates the 3D object along an axis in local space.
   *
   * @param {Vector3} axis - The (normalized) axis vector.
   * @param {number} angle - The angle in radians.
   * @return {Object3D} A reference to this instance.
   */
  rotateOnAxis(e, t) {
    return yr.setFromAxisAngle(e, t), this.quaternion.multiply(yr), this;
  }
  /**
   * Rotates the 3D object along an axis in world space.
   *
   * @param {Vector3} axis - The (normalized) axis vector.
   * @param {number} angle - The angle in radians.
   * @return {Object3D} A reference to this instance.
   */
  rotateOnWorldAxis(e, t) {
    return yr.setFromAxisAngle(e, t), this.quaternion.premultiply(yr), this;
  }
  /**
   * Rotates the 3D object around its X axis in local space.
   *
   * @param {number} angle - The angle in radians.
   * @return {Object3D} A reference to this instance.
   */
  rotateX(e) {
    return this.rotateOnAxis(Cu, e);
  }
  /**
   * Rotates the 3D object around its Y axis in local space.
   *
   * @param {number} angle - The angle in radians.
   * @return {Object3D} A reference to this instance.
   */
  rotateY(e) {
    return this.rotateOnAxis(zu, e);
  }
  /**
   * Rotates the 3D object around its Z axis in local space.
   *
   * @param {number} angle - The angle in radians.
   * @return {Object3D} A reference to this instance.
   */
  rotateZ(e) {
    return this.rotateOnAxis(Ru, e);
  }
  /**
   * Translate the 3D object by a distance along the given axis in local space.
   *
   * @param {Vector3} axis - The (normalized) axis vector.
   * @param {number} distance - The distance in world units.
   * @return {Object3D} A reference to this instance.
   */
  translateOnAxis(e, t) {
    return Vu.copy(e).applyQuaternion(this.quaternion), this.position.add(Vu.multiplyScalar(t)), this;
  }
  /**
   * Translate the 3D object by a distance along its X-axis in local space.
   *
   * @param {number} distance - The distance in world units.
   * @return {Object3D} A reference to this instance.
   */
  translateX(e) {
    return this.translateOnAxis(Cu, e);
  }
  /**
   * Translate the 3D object by a distance along its Y-axis in local space.
   *
   * @param {number} distance - The distance in world units.
   * @return {Object3D} A reference to this instance.
   */
  translateY(e) {
    return this.translateOnAxis(zu, e);
  }
  /**
   * Translate the 3D object by a distance along its Z-axis in local space.
   *
   * @param {number} distance - The distance in world units.
   * @return {Object3D} A reference to this instance.
   */
  translateZ(e) {
    return this.translateOnAxis(Ru, e);
  }
  /**
   * Converts the given vector from this 3D object's local space to world space.
   *
   * @param {Vector3} vector - The vector to convert.
   * @return {Vector3} The converted vector.
   */
  localToWorld(e) {
    return this.updateWorldMatrix(!0, !1), e.applyMatrix4(this.matrixWorld);
  }
  /**
   * Converts the given vector from this 3D object's world space to local space.
   *
   * @param {Vector3} vector - The vector to convert.
   * @return {Vector3} The converted vector.
   */
  worldToLocal(e) {
    return this.updateWorldMatrix(!0, !1), e.applyMatrix4(rs.copy(this.matrixWorld).invert());
  }
  /**
   * Rotates the object to face a point in world space.
   *
   * This method does not support objects having non-uniformly-scaled parent(s).
   *
   * @param {number|Vector3} x - The x coordinate in world space. Alternatively, a vector representing a position in world space
   * @param {number} [y] - The y coordinate in world space.
   * @param {number} [z] - The z coordinate in world space.
   */
  lookAt(e, t, s) {
    e.isVector3 ? Li.copy(e) : Li.set(e, t, s);
    const i = this.parent;
    this.updateWorldMatrix(!0, !1), Kr.setFromMatrixPosition(this.matrixWorld), this.isCamera || this.isLight ? rs.lookAt(Kr, Li, this.up) : rs.lookAt(Li, Kr, this.up), this.quaternion.setFromRotationMatrix(rs), i && (rs.extractRotation(i.matrixWorld), yr.setFromRotationMatrix(rs), this.quaternion.premultiply(yr.invert()));
  }
  /**
   * Adds the given 3D object as a child to this 3D object. An arbitrary number of
   * objects may be added. Any current parent on an object passed in here will be
   * removed, since an object can have at most one parent.
   *
   * @fires Object3D#added
   * @fires Object3D#childadded
   * @param {Object3D} object - The 3D object to add.
   * @return {Object3D} A reference to this instance.
   */
  add(e) {
    if (arguments.length > 1) {
      for (let t = 0; t < arguments.length; t++)
        this.add(arguments[t]);
      return this;
    }
    return e === this ? (te("Object3D.add: object can't be added as a child of itself.", e), this) : (e && e.isObject3D ? (e.removeFromParent(), e.parent = this, this.children.push(e), e.dispatchEvent(Eu), xr.child = e, this.dispatchEvent(xr), xr.child = null) : te("Object3D.add: object not an instance of THREE.Object3D.", e), this);
  }
  /**
   * Removes the given 3D object as child from this 3D object.
   * An arbitrary number of objects may be removed.
   *
   * @fires Object3D#removed
   * @fires Object3D#childremoved
   * @param {Object3D} object - The 3D object to remove.
   * @return {Object3D} A reference to this instance.
   */
  remove(e) {
    if (arguments.length > 1) {
      for (let s = 0; s < arguments.length; s++)
        this.remove(arguments[s]);
      return this;
    }
    const t = this.children.indexOf(e);
    return t !== -1 && (e.parent = null, this.children.splice(t, 1), e.dispatchEvent(tf), wn.child = e, this.dispatchEvent(wn), wn.child = null), this;
  }
  /**
   * Removes this 3D object from its current parent.
   *
   * @fires Object3D#removed
   * @fires Object3D#childremoved
   * @return {Object3D} A reference to this instance.
   */
  removeFromParent() {
    const e = this.parent;
    return e !== null && e.remove(this), this;
  }
  /**
   * Removes all child objects.
   *
   * @fires Object3D#removed
   * @fires Object3D#childremoved
   * @return {Object3D} A reference to this instance.
   */
  clear() {
    return this.remove(...this.children);
  }
  /**
   * Adds the given 3D object as a child of this 3D object, while maintaining the object's world
   * transform. This method does not support scene graphs having non-uniformly-scaled nodes(s).
   *
   * @fires Object3D#added
   * @fires Object3D#childadded
   * @param {Object3D} object - The 3D object to attach.
   * @return {Object3D} A reference to this instance.
   */
  attach(e) {
    return this.updateWorldMatrix(!0, !1), rs.copy(this.matrixWorld).invert(), e.parent !== null && (e.parent.updateWorldMatrix(!0, !1), rs.multiply(e.parent.matrixWorld)), e.applyMatrix4(rs), e.removeFromParent(), e.parent = this, this.children.push(e), e.updateWorldMatrix(!1, !0), e.dispatchEvent(Eu), xr.child = e, this.dispatchEvent(xr), xr.child = null, this;
  }
  /**
   * Searches through the 3D object and its children, starting with the 3D object
   * itself, and returns the first with a matching ID.
   *
   * @param {number} id - The id.
   * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
   */
  getObjectById(e) {
    return this.getObjectByProperty("id", e);
  }
  /**
   * Searches through the 3D object and its children, starting with the 3D object
   * itself, and returns the first with a matching name.
   *
   * @param {string} name - The name.
   * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
   */
  getObjectByName(e) {
    return this.getObjectByProperty("name", e);
  }
  /**
   * Searches through the 3D object and its children, starting with the 3D object
   * itself, and returns the first with a matching property value.
   *
   * @param {string} name - The name of the property.
   * @param {any} value - The value.
   * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
   */
  getObjectByProperty(e, t) {
    if (this[e] === t) return this;
    for (let s = 0, i = this.children.length; s < i; s++) {
      const a = this.children[s].getObjectByProperty(e, t);
      if (a !== void 0)
        return a;
    }
  }
  /**
   * Searches through the 3D object and its children, starting with the 3D object
   * itself, and returns all 3D objects with a matching property value.
   *
   * @param {string} name - The name of the property.
   * @param {any} value - The value.
   * @param {Array<Object3D>} result - The method stores the result in this array.
   * @return {Array<Object3D>} The found 3D objects.
   */
  getObjectsByProperty(e, t, s = []) {
    this[e] === t && s.push(this);
    const i = this.children;
    for (let a = 0, n = i.length; a < n; a++)
      i[a].getObjectsByProperty(e, t, s);
    return s;
  }
  /**
   * Returns a vector representing the position of the 3D object in world space.
   *
   * @param {Vector3} target - The target vector the result is stored to.
   * @return {Vector3} The 3D object's position in world space.
   */
  getWorldPosition(e) {
    return this.updateWorldMatrix(!0, !1), e.setFromMatrixPosition(this.matrixWorld);
  }
  /**
   * Returns a Quaternion representing the position of the 3D object in world space.
   *
   * @param {Quaternion} target - The target Quaternion the result is stored to.
   * @return {Quaternion} The 3D object's rotation in world space.
   */
  getWorldQuaternion(e) {
    return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(Kr, e, Kg), e;
  }
  /**
   * Returns a vector representing the scale of the 3D object in world space.
   *
   * @param {Vector3} target - The target vector the result is stored to.
   * @return {Vector3} The 3D object's scale in world space.
   */
  getWorldScale(e) {
    return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(Kr, ef, e), e;
  }
  /**
   * Returns a vector representing the ("look") direction of the 3D object in world space.
   *
   * @param {Vector3} target - The target vector the result is stored to.
   * @return {Vector3} The 3D object's direction in world space.
   */
  getWorldDirection(e) {
    this.updateWorldMatrix(!0, !1);
    const t = this.matrixWorld.elements;
    return e.set(t[8], t[9], t[10]).normalize();
  }
  /**
   * Abstract method to get intersections between a casted ray and this
   * 3D object. Renderable 3D objects such as {@link Mesh}, {@link Line} or {@link Points}
   * implement this method in order to use raycasting.
   *
   * @abstract
   * @param {Raycaster} raycaster - The raycaster.
   * @param {Array<Object>} intersects - An array holding the result of the method.
   */
  raycast() {
  }
  /**
   * Executes the callback on this 3D object and all descendants.
   *
   * Note: Modifying the scene graph inside the callback is discouraged.
   *
   * @param {Function} callback - A callback function that allows to process the current 3D object.
   */
  traverse(e) {
    e(this);
    const t = this.children;
    for (let s = 0, i = t.length; s < i; s++)
      t[s].traverse(e);
  }
  /**
   * Like {@link Object3D#traverse}, but the callback will only be executed for visible 3D objects.
   * Descendants of invisible 3D objects are not traversed.
   *
   * Note: Modifying the scene graph inside the callback is discouraged.
   *
   * @param {Function} callback - A callback function that allows to process the current 3D object.
   */
  traverseVisible(e) {
    if (this.visible === !1) return;
    e(this);
    const t = this.children;
    for (let s = 0, i = t.length; s < i; s++)
      t[s].traverseVisible(e);
  }
  /**
   * Like {@link Object3D#traverse}, but the callback will only be executed for all ancestors.
   *
   * Note: Modifying the scene graph inside the callback is discouraged.
   *
   * @param {Function} callback - A callback function that allows to process the current 3D object.
   */
  traverseAncestors(e) {
    const t = this.parent;
    t !== null && (e(t), t.traverseAncestors(e));
  }
  /**
   * Updates the transformation matrix in local space by computing it from the current
   * position, rotation and scale values.
   */
  updateMatrix() {
    this.matrix.compose(this.position, this.quaternion, this.scale);
    const e = this.pivot;
    if (e !== null) {
      const t = e.x, s = e.y, i = e.z, a = this.matrix.elements;
      a[12] += t - a[0] * t - a[4] * s - a[8] * i, a[13] += s - a[1] * t - a[5] * s - a[9] * i, a[14] += i - a[2] * t - a[6] * s - a[10] * i;
    }
    this.matrixWorldNeedsUpdate = !0;
  }
  /**
   * Updates the transformation matrix in world space of this 3D objects and its descendants.
   *
   * To ensure correct results, this method also recomputes the 3D object's transformation matrix in
   * local space. The computation of the local and world matrix can be controlled with the
   * {@link Object3D#matrixAutoUpdate} and {@link Object3D#matrixWorldAutoUpdate} flags which are both
   * `true` by default.  Set these flags to `false` if you need more control over the update matrix process.
   *
   * @param {boolean} [force=false] - When set to `true`, a recomputation of world matrices is forced even
   * when {@link Object3D#matrixWorldNeedsUpdate} is `false`.
   */
  updateMatrixWorld(e) {
    this.matrixAutoUpdate && this.updateMatrix(), (this.matrixWorldNeedsUpdate || e) && (this.matrixWorldAutoUpdate === !0 && (this.parent === null ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix)), this.matrixWorldNeedsUpdate = !1, e = !0);
    const t = this.children;
    for (let s = 0, i = t.length; s < i; s++)
      t[s].updateMatrixWorld(e);
  }
  /**
   * An alternative version of {@link Object3D#updateMatrixWorld} with more control over the
   * update of ancestor and descendant nodes.
   *
   * @param {boolean} [updateParents=false] Whether ancestor nodes should be updated or not.
   * @param {boolean} [updateChildren=false] Whether descendant nodes should be updated or not.
   * @param {boolean} [force=false] - When set to `true`, a recomputation of world matrices is forced even
   * when {@link Object3D#matrixWorldNeedsUpdate} is `false`.
   */
  updateWorldMatrix(e, t, s = !1) {
    const i = this.parent;
    if (e === !0 && i !== null && i.updateWorldMatrix(!0, !1), this.matrixAutoUpdate && this.updateMatrix(), (this.matrixWorldNeedsUpdate || s) && (this.matrixWorldAutoUpdate === !0 && (this.parent === null ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix)), this.matrixWorldNeedsUpdate = !1, s = !0), t === !0) {
      const a = this.children;
      for (let n = 0, o = a.length; n < o; n++)
        a[n].updateWorldMatrix(!1, !0, s);
    }
  }
  /**
   * Serializes the 3D object into JSON.
   *
   * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
   * @return {Object} A JSON object representing the serialized 3D object.
   * @see {@link ObjectLoader#parse}
   */
  toJSON(e) {
    const t = e === void 0 || typeof e == "string", s = {};
    t && (e = {
      geometries: {},
      materials: {},
      textures: {},
      images: {},
      shapes: {},
      skeletons: {},
      animations: {},
      nodes: {}
    }, s.metadata = {
      version: 4.7,
      type: "Object",
      generator: "Object3D.toJSON"
    });
    const i = {};
    i.uuid = this.uuid, i.type = this.type, this.name !== "" && (i.name = this.name), this.castShadow === !0 && (i.castShadow = !0), this.receiveShadow === !0 && (i.receiveShadow = !0), this.visible === !1 && (i.visible = !1), this.frustumCulled === !1 && (i.frustumCulled = !1), this.renderOrder !== 0 && (i.renderOrder = this.renderOrder), this.static !== !1 && (i.static = this.static), Object.keys(this.userData).length > 0 && (i.userData = this.userData), i.layers = this.layers.mask, i.matrix = this.matrix.toArray(), i.up = this.up.toArray(), this.pivot !== null && (i.pivot = this.pivot.toArray()), this.matrixAutoUpdate === !1 && (i.matrixAutoUpdate = !1), this.morphTargetDictionary !== void 0 && (i.morphTargetDictionary = Object.assign({}, this.morphTargetDictionary)), this.morphTargetInfluences !== void 0 && (i.morphTargetInfluences = this.morphTargetInfluences.slice()), this.isInstancedMesh && (i.type = "InstancedMesh", i.count = this.count, i.instanceMatrix = this.instanceMatrix.toJSON(), this.instanceColor !== null && (i.instanceColor = this.instanceColor.toJSON())), this.isBatchedMesh && (i.type = "BatchedMesh", i.perObjectFrustumCulled = this.perObjectFrustumCulled, i.sortObjects = this.sortObjects, i.drawRanges = this._drawRanges, i.reservedRanges = this._reservedRanges, i.geometryInfo = this._geometryInfo.map((o) => ({
      ...o,
      boundingBox: o.boundingBox ? o.boundingBox.toJSON() : void 0,
      boundingSphere: o.boundingSphere ? o.boundingSphere.toJSON() : void 0
    })), i.instanceInfo = this._instanceInfo.map((o) => ({ ...o })), i.availableInstanceIds = this._availableInstanceIds.slice(), i.availableGeometryIds = this._availableGeometryIds.slice(), i.nextIndexStart = this._nextIndexStart, i.nextVertexStart = this._nextVertexStart, i.geometryCount = this._geometryCount, i.maxInstanceCount = this._maxInstanceCount, i.maxVertexCount = this._maxVertexCount, i.maxIndexCount = this._maxIndexCount, i.geometryInitialized = this._geometryInitialized, i.matricesTexture = this._matricesTexture.toJSON(e), i.indirectTexture = this._indirectTexture.toJSON(e), this._colorsTexture !== null && (i.colorsTexture = this._colorsTexture.toJSON(e)), this.boundingSphere !== null && (i.boundingSphere = this.boundingSphere.toJSON()), this.boundingBox !== null && (i.boundingBox = this.boundingBox.toJSON()));
    function a(o, l) {
      return o[l.uuid] === void 0 && (o[l.uuid] = l.toJSON(e)), l.uuid;
    }
    if (this.isScene)
      this.background && (this.background.isColor ? i.background = this.background.toJSON() : this.background.isTexture && (i.background = this.background.toJSON(e).uuid)), this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== !0 && (i.environment = this.environment.toJSON(e).uuid);
    else if (this.isMesh || this.isLine || this.isPoints) {
      i.geometry = a(e.geometries, this.geometry);
      const o = this.geometry.parameters;
      if (o !== void 0 && o.shapes !== void 0) {
        const l = o.shapes;
        if (Array.isArray(l))
          for (let u = 0, h = l.length; u < h; u++) {
            const d = l[u];
            a(e.shapes, d);
          }
        else
          a(e.shapes, l);
      }
    }
    if (this.isSkinnedMesh && (i.bindMode = this.bindMode, i.bindMatrix = this.bindMatrix.toArray(), this.skeleton !== void 0 && (a(e.skeletons, this.skeleton), i.skeleton = this.skeleton.uuid)), this.material !== void 0)
      if (Array.isArray(this.material)) {
        const o = [];
        for (let l = 0, u = this.material.length; l < u; l++)
          o.push(a(e.materials, this.material[l]));
        i.material = o;
      } else
        i.material = a(e.materials, this.material);
    if (this.children.length > 0) {
      i.children = [];
      for (let o = 0; o < this.children.length; o++)
        i.children.push(this.children[o].toJSON(e).object);
    }
    if (this.animations.length > 0) {
      i.animations = [];
      for (let o = 0; o < this.animations.length; o++) {
        const l = this.animations[o];
        i.animations.push(a(e.animations, l));
      }
    }
    if (t) {
      const o = n(e.geometries), l = n(e.materials), u = n(e.textures), h = n(e.images), d = n(e.shapes), p = n(e.skeletons), m = n(e.animations), g = n(e.nodes);
      o.length > 0 && (s.geometries = o), l.length > 0 && (s.materials = l), u.length > 0 && (s.textures = u), h.length > 0 && (s.images = h), d.length > 0 && (s.shapes = d), p.length > 0 && (s.skeletons = p), m.length > 0 && (s.animations = m), g.length > 0 && (s.nodes = g);
    }
    return s.object = i, s;
    function n(o) {
      const l = [];
      for (const u in o) {
        const h = o[u];
        delete h.metadata, l.push(h);
      }
      return l;
    }
  }
  /**
   * Returns a new 3D object with copied values from this instance.
   *
   * @param {boolean} [recursive=true] - When set to `true`, descendants of the 3D object are also cloned.
   * @return {Object3D} A clone of this instance.
   */
  clone(e) {
    return new this.constructor().copy(this, e);
  }
  /**
   * Copies the values of the given 3D object to this instance.
   *
   * @param {Object3D} source - The 3D object to copy.
   * @param {boolean} [recursive=true] - When set to `true`, descendants of the 3D object are cloned.
   * @return {Object3D} A reference to this instance.
   */
  copy(e, t = !0) {
    if (this.name = e.name, this.up.copy(e.up), this.position.copy(e.position), this.rotation.order = e.rotation.order, this.quaternion.copy(e.quaternion), this.scale.copy(e.scale), this.pivot = e.pivot !== null ? e.pivot.clone() : null, this.matrix.copy(e.matrix), this.matrixWorld.copy(e.matrixWorld), this.matrixAutoUpdate = e.matrixAutoUpdate, this.matrixWorldAutoUpdate = e.matrixWorldAutoUpdate, this.matrixWorldNeedsUpdate = e.matrixWorldNeedsUpdate, this.layers.mask = e.layers.mask, this.visible = e.visible, this.castShadow = e.castShadow, this.receiveShadow = e.receiveShadow, this.frustumCulled = e.frustumCulled, this.renderOrder = e.renderOrder, this.static = e.static, this.animations = e.animations.slice(), this.userData = JSON.parse(JSON.stringify(e.userData)), t === !0)
      for (let s = 0; s < e.children.length; s++) {
        const i = e.children[s];
        this.add(i.clone());
      }
    return this;
  }
}
Pt.DEFAULT_UP = /* @__PURE__ */ new M(0, 1, 0);
Pt.DEFAULT_MATRIX_AUTO_UPDATE = !0;
Pt.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = !0;
const qh = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
}, vs = { h: 0, s: 0, l: 0 }, Ii = { h: 0, s: 0, l: 0 };
function Nn(r, e, t) {
  return t < 0 && (t += 1), t > 1 && (t -= 1), t < 1 / 6 ? r + (e - r) * 6 * t : t < 1 / 2 ? e : t < 2 / 3 ? r + (e - r) * 6 * (2 / 3 - t) : r;
}
class Yt {
  /**
   * Constructs a new color.
   *
   * Note that standard method of specifying color in three.js is with a hexadecimal triplet,
   * and that method is used throughout the rest of the documentation.
   *
   * @param {(number|string|Color)} [r] - The red component of the color. If `g` and `b` are
   * not provided, it can be hexadecimal triplet, a CSS-style string or another `Color` instance.
   * @param {number} [g] - The green component.
   * @param {number} [b] - The blue component.
   */
  constructor(e, t, s) {
    return this.isColor = !0, this.r = 1, this.g = 1, this.b = 1, this.set(e, t, s);
  }
  /**
   * Sets the colors's components from the given values.
   *
   * @param {(number|string|Color)} [r] - The red component of the color. If `g` and `b` are
   * not provided, it can be hexadecimal triplet, a CSS-style string or another `Color` instance.
   * @param {number} [g] - The green component.
   * @param {number} [b] - The blue component.
   * @return {Color} A reference to this color.
   */
  set(e, t, s) {
    if (t === void 0 && s === void 0) {
      const i = e;
      i && i.isColor ? this.copy(i) : typeof i == "number" ? this.setHex(i) : typeof i == "string" && this.setStyle(i);
    } else
      this.setRGB(e, t, s);
    return this;
  }
  /**
   * Sets the colors's components to the given scalar value.
   *
   * @param {number} scalar - The scalar value.
   * @return {Color} A reference to this color.
   */
  setScalar(e) {
    return this.r = e, this.g = e, this.b = e, this;
  }
  /**
   * Sets this color from a hexadecimal value.
   *
   * @param {number} hex - The hexadecimal value.
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {Color} A reference to this color.
   */
  setHex(e, t = zt) {
    return e = Math.floor(e), this.r = (e >> 16 & 255) / 255, this.g = (e >> 8 & 255) / 255, this.b = (e & 255) / 255, Ne.colorSpaceToWorking(this, t), this;
  }
  /**
   * Sets this color from RGB values.
   *
   * @param {number} r - Red channel value between `0.0` and `1.0`.
   * @param {number} g - Green channel value between `0.0` and `1.0`.
   * @param {number} b - Blue channel value between `0.0` and `1.0`.
   * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
   * @return {Color} A reference to this color.
   */
  setRGB(e, t, s, i = Ne.workingColorSpace) {
    return this.r = e, this.g = t, this.b = s, Ne.colorSpaceToWorking(this, i), this;
  }
  /**
   * Sets this color from RGB values.
   *
   * @param {number} h - Hue value between `0.0` and `1.0`.
   * @param {number} s - Saturation value between `0.0` and `1.0`.
   * @param {number} l - Lightness value between `0.0` and `1.0`.
   * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
   * @return {Color} A reference to this color.
   */
  setHSL(e, t, s, i = Ne.workingColorSpace) {
    if (e = Go(e, 1), t = ee(t, 0, 1), s = ee(s, 0, 1), t === 0)
      this.r = this.g = this.b = s;
    else {
      const a = s <= 0.5 ? s * (1 + t) : s + t - s * t, n = 2 * s - a;
      this.r = Nn(n, a, e + 1 / 3), this.g = Nn(n, a, e), this.b = Nn(n, a, e - 1 / 3);
    }
    return Ne.colorSpaceToWorking(this, i), this;
  }
  /**
   * Sets this color from a CSS-style string. For example, `rgb(250, 0,0)`,
   * `rgb(100%, 0%, 0%)`, `hsl(0, 100%, 50%)`, `#ff0000`, `#f00`, or `red` ( or
   * any [X11 color name](https://en.wikipedia.org/wiki/X11_color_names#Color_name_chart) -
   * all 140 color names are supported).
   *
   * @param {string} style - Color as a CSS-style string.
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {Color} A reference to this color.
   */
  setStyle(e, t = zt) {
    function s(a) {
      a !== void 0 && parseFloat(a) < 1 && X("Color: Alpha component of " + e + " will be ignored.");
    }
    let i;
    if (i = /^(\w+)\(([^\)]*)\)/.exec(e)) {
      let a;
      const n = i[1], o = i[2];
      switch (n) {
        case "rgb":
        case "rgba":
          if (a = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(o))
            return s(a[4]), this.setRGB(
              Math.min(255, parseInt(a[1], 10)) / 255,
              Math.min(255, parseInt(a[2], 10)) / 255,
              Math.min(255, parseInt(a[3], 10)) / 255,
              t
            );
          if (a = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(o))
            return s(a[4]), this.setRGB(
              Math.min(100, parseInt(a[1], 10)) / 100,
              Math.min(100, parseInt(a[2], 10)) / 100,
              Math.min(100, parseInt(a[3], 10)) / 100,
              t
            );
          break;
        case "hsl":
        case "hsla":
          if (a = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(o))
            return s(a[4]), this.setHSL(
              parseFloat(a[1]) / 360,
              parseFloat(a[2]) / 100,
              parseFloat(a[3]) / 100,
              t
            );
          break;
        default:
          X("Color: Unknown color model " + e);
      }
    } else if (i = /^\#([A-Fa-f\d]+)$/.exec(e)) {
      const a = i[1], n = a.length;
      if (n === 3)
        return this.setRGB(
          parseInt(a.charAt(0), 16) / 15,
          parseInt(a.charAt(1), 16) / 15,
          parseInt(a.charAt(2), 16) / 15,
          t
        );
      if (n === 6)
        return this.setHex(parseInt(a, 16), t);
      X("Color: Invalid hex color " + e);
    } else if (e && e.length > 0)
      return this.setColorName(e, t);
    return this;
  }
  /**
   * Sets this color from a color name. Faster than {@link Color#setStyle} if
   * you don't need the other CSS-style formats.
   *
   * For convenience, the list of names is exposed in `Color.NAMES` as a hash.
   * ```js
   * Color.NAMES.aliceblue // returns 0xF0F8FF
   * ```
   *
   * @param {string} style - The color name.
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {Color} A reference to this color.
   */
  setColorName(e, t = zt) {
    const s = qh[e.toLowerCase()];
    return s !== void 0 ? this.setHex(s, t) : X("Color: Unknown color " + e), this;
  }
  /**
   * Returns a new color with copied values from this instance.
   *
   * @return {Color} A clone of this instance.
   */
  clone() {
    return new this.constructor(this.r, this.g, this.b);
  }
  /**
   * Copies the values of the given color to this instance.
   *
   * @param {Color} color - The color to copy.
   * @return {Color} A reference to this color.
   */
  copy(e) {
    return this.r = e.r, this.g = e.g, this.b = e.b, this;
  }
  /**
   * Copies the given color into this color, and then converts this color from
   * `SRGBColorSpace` to `LinearSRGBColorSpace`.
   *
   * @param {Color} color - The color to copy/convert.
   * @return {Color} A reference to this color.
   */
  copySRGBToLinear(e) {
    return this.r = ds(e.r), this.g = ds(e.g), this.b = ds(e.b), this;
  }
  /**
   * Copies the given color into this color, and then converts this color from
   * `LinearSRGBColorSpace` to `SRGBColorSpace`.
   *
   * @param {Color} color - The color to copy/convert.
   * @return {Color} A reference to this color.
   */
  copyLinearToSRGB(e) {
    return this.r = Lr(e.r), this.g = Lr(e.g), this.b = Lr(e.b), this;
  }
  /**
   * Converts this color from `SRGBColorSpace` to `LinearSRGBColorSpace`.
   *
   * @return {Color} A reference to this color.
   */
  convertSRGBToLinear() {
    return this.copySRGBToLinear(this), this;
  }
  /**
   * Converts this color from `LinearSRGBColorSpace` to `SRGBColorSpace`.
   *
   * @return {Color} A reference to this color.
   */
  convertLinearToSRGB() {
    return this.copyLinearToSRGB(this), this;
  }
  /**
   * Returns the hexadecimal value of this color.
   *
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {number} The hexadecimal value.
   */
  getHex(e = zt) {
    return Ne.workingToColorSpace(je.copy(this), e), Math.round(ee(je.r * 255, 0, 255)) * 65536 + Math.round(ee(je.g * 255, 0, 255)) * 256 + Math.round(ee(je.b * 255, 0, 255));
  }
  /**
   * Returns the hexadecimal value of this color as a string (for example, 'FFFFFF').
   *
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {string} The hexadecimal value as a string.
   */
  getHexString(e = zt) {
    return ("000000" + this.getHex(e).toString(16)).slice(-6);
  }
  /**
   * Converts the colors RGB values into the HSL format and stores them into the
   * given target object.
   *
   * @param {{h:number,s:number,l:number}} target - The target object that is used to store the method's result.
   * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
   * @return {{h:number,s:number,l:number}} The HSL representation of this color.
   */
  getHSL(e, t = Ne.workingColorSpace) {
    Ne.workingToColorSpace(je.copy(this), t);
    const s = je.r, i = je.g, a = je.b, n = Math.max(s, i, a), o = Math.min(s, i, a);
    let l, u;
    const h = (o + n) / 2;
    if (o === n)
      l = 0, u = 0;
    else {
      const d = n - o;
      switch (u = h <= 0.5 ? d / (n + o) : d / (2 - n - o), n) {
        case s:
          l = (i - a) / d + (i < a ? 6 : 0);
          break;
        case i:
          l = (a - s) / d + 2;
          break;
        case a:
          l = (s - i) / d + 4;
          break;
      }
      l /= 6;
    }
    return e.h = l, e.s = u, e.l = h, e;
  }
  /**
   * Returns the RGB values of this color and stores them into the given target object.
   *
   * @param {Color} target - The target color that is used to store the method's result.
   * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
   * @return {Color} The RGB representation of this color.
   */
  getRGB(e, t = Ne.workingColorSpace) {
    return Ne.workingToColorSpace(je.copy(this), t), e.r = je.r, e.g = je.g, e.b = je.b, e;
  }
  /**
   * Returns the value of this color as a CSS style string. Example: `rgb(255,0,0)`.
   *
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {string} The CSS representation of this color.
   */
  getStyle(e = zt) {
    Ne.workingToColorSpace(je.copy(this), e);
    const t = je.r, s = je.g, i = je.b;
    return e !== zt ? `color(${e} ${t.toFixed(3)} ${s.toFixed(3)} ${i.toFixed(3)})` : `rgb(${Math.round(t * 255)},${Math.round(s * 255)},${Math.round(i * 255)})`;
  }
  /**
   * Adds the given HSL values to this color's values.
   * Internally, this converts the color's RGB values to HSL, adds HSL
   * and then converts the color back to RGB.
   *
   * @param {number} h - Hue value between `0.0` and `1.0`.
   * @param {number} s - Saturation value between `0.0` and `1.0`.
   * @param {number} l - Lightness value between `0.0` and `1.0`.
   * @return {Color} A reference to this color.
   */
  offsetHSL(e, t, s) {
    return this.getHSL(vs), this.setHSL(vs.h + e, vs.s + t, vs.l + s);
  }
  /**
   * Adds the RGB values of the given color to the RGB values of this color.
   *
   * @param {Color} color - The color to add.
   * @return {Color} A reference to this color.
   */
  add(e) {
    return this.r += e.r, this.g += e.g, this.b += e.b, this;
  }
  /**
   * Adds the RGB values of the given colors and stores the result in this instance.
   *
   * @param {Color} color1 - The first color.
   * @param {Color} color2 - The second color.
   * @return {Color} A reference to this color.
   */
  addColors(e, t) {
    return this.r = e.r + t.r, this.g = e.g + t.g, this.b = e.b + t.b, this;
  }
  /**
   * Adds the given scalar value to the RGB values of this color.
   *
   * @param {number} s - The scalar to add.
   * @return {Color} A reference to this color.
   */
  addScalar(e) {
    return this.r += e, this.g += e, this.b += e, this;
  }
  /**
   * Subtracts the RGB values of the given color from the RGB values of this color.
   *
   * @param {Color} color - The color to subtract.
   * @return {Color} A reference to this color.
   */
  sub(e) {
    return this.r = Math.max(0, this.r - e.r), this.g = Math.max(0, this.g - e.g), this.b = Math.max(0, this.b - e.b), this;
  }
  /**
   * Multiplies the RGB values of the given color with the RGB values of this color.
   *
   * @param {Color} color - The color to multiply.
   * @return {Color} A reference to this color.
   */
  multiply(e) {
    return this.r *= e.r, this.g *= e.g, this.b *= e.b, this;
  }
  /**
   * Multiplies the given scalar value with the RGB values of this color.
   *
   * @param {number} s - The scalar to multiply.
   * @return {Color} A reference to this color.
   */
  multiplyScalar(e) {
    return this.r *= e, this.g *= e, this.b *= e, this;
  }
  /**
   * Linearly interpolates this color's RGB values toward the RGB values of the
   * given color. The alpha argument can be thought of as the ratio between
   * the two colors, where `0.0` is this color and `1.0` is the first argument.
   *
   * @param {Color} color - The color to converge on.
   * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
   * @return {Color} A reference to this color.
   */
  lerp(e, t) {
    return this.r += (e.r - this.r) * t, this.g += (e.g - this.g) * t, this.b += (e.b - this.b) * t, this;
  }
  /**
   * Linearly interpolates between the given colors and stores the result in this instance.
   * The alpha argument can be thought of as the ratio between the two colors, where `0.0`
   * is the first and `1.0` is the second color.
   *
   * @param {Color} color1 - The first color.
   * @param {Color} color2 - The second color.
   * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
   * @return {Color} A reference to this color.
   */
  lerpColors(e, t, s) {
    return this.r = e.r + (t.r - e.r) * s, this.g = e.g + (t.g - e.g) * s, this.b = e.b + (t.b - e.b) * s, this;
  }
  /**
   * Linearly interpolates this color's HSL values toward the HSL values of the
   * given color. It differs from {@link Color#lerp} by not interpolating straight
   * from one color to the other, but instead going through all the hues in between
   * those two colors. The alpha argument can be thought of as the ratio between
   * the two colors, where 0.0 is this color and 1.0 is the first argument.
   *
   * @param {Color} color - The color to converge on.
   * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
   * @return {Color} A reference to this color.
   */
  lerpHSL(e, t) {
    this.getHSL(vs), e.getHSL(Ii);
    const s = mi(vs.h, Ii.h, t), i = mi(vs.s, Ii.s, t), a = mi(vs.l, Ii.l, t);
    return this.setHSL(s, i, a), this;
  }
  /**
   * Sets the color's RGB components from the given 3D vector.
   *
   * @param {Vector3} v - The vector to set.
   * @return {Color} A reference to this color.
   */
  setFromVector3(e) {
    return this.r = e.x, this.g = e.y, this.b = e.z, this;
  }
  /**
   * Transforms this color with the given 3x3 matrix.
   *
   * @param {Matrix3} m - The matrix.
   * @return {Color} A reference to this color.
   */
  applyMatrix3(e) {
    const t = this.r, s = this.g, i = this.b, a = e.elements;
    return this.r = a[0] * t + a[3] * s + a[6] * i, this.g = a[1] * t + a[4] * s + a[7] * i, this.b = a[2] * t + a[5] * s + a[8] * i, this;
  }
  /**
   * Returns `true` if this color is equal with the given one.
   *
   * @param {Color} c - The color to test for equality.
   * @return {boolean} Whether this bounding color is equal with the given one.
   */
  equals(e) {
    return e.r === this.r && e.g === this.g && e.b === this.b;
  }
  /**
   * Sets this color's RGB components from the given array.
   *
   * @param {Array<number>} array - An array holding the RGB values.
   * @param {number} [offset=0] - The offset into the array.
   * @return {Color} A reference to this color.
   */
  fromArray(e, t = 0) {
    return this.r = e[t], this.g = e[t + 1], this.b = e[t + 2], this;
  }
  /**
   * Writes the RGB components of this color to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the color components.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The color components.
   */
  toArray(e = [], t = 0) {
    return e[t] = this.r, e[t + 1] = this.g, e[t + 2] = this.b, e;
  }
  /**
   * Sets the components of this color from the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute holding color data.
   * @param {number} index - The index into the attribute.
   * @return {Color} A reference to this color.
   */
  fromBufferAttribute(e, t) {
    return this.r = e.getX(t), this.g = e.getY(t), this.b = e.getZ(t), this;
  }
  /**
   * This methods defines the serialization result of this class. Returns the color
   * as a hexadecimal value.
   *
   * @return {number} The hexadecimal value.
   */
  toJSON() {
    return this.getHex();
  }
  *[Symbol.iterator]() {
    yield this.r, yield this.g, yield this.b;
  }
}
const je = /* @__PURE__ */ new Yt();
Yt.NAMES = qh;
const Vt = /* @__PURE__ */ new M(), is = /* @__PURE__ */ new M(), Mn = /* @__PURE__ */ new M(), as = /* @__PURE__ */ new M(), br = /* @__PURE__ */ new M(), vr = /* @__PURE__ */ new M(), Lu = /* @__PURE__ */ new M(), Sn = /* @__PURE__ */ new M(), _n = /* @__PURE__ */ new M(), An = /* @__PURE__ */ new M(), Vn = /* @__PURE__ */ new tt(), Cn = /* @__PURE__ */ new tt(), zn = /* @__PURE__ */ new tt();
class Lt {
  /**
   * Constructs a new triangle.
   *
   * @param {Vector3} [a=(0,0,0)] - The first corner of the triangle.
   * @param {Vector3} [b=(0,0,0)] - The second corner of the triangle.
   * @param {Vector3} [c=(0,0,0)] - The third corner of the triangle.
   */
  constructor(e = new M(), t = new M(), s = new M()) {
    this.a = e, this.b = t, this.c = s;
  }
  /**
   * Computes the normal vector of a triangle.
   *
   * @param {Vector3} a - The first corner of the triangle.
   * @param {Vector3} b - The second corner of the triangle.
   * @param {Vector3} c - The third corner of the triangle.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The triangle's normal.
   */
  static getNormal(e, t, s, i) {
    i.subVectors(s, t), Vt.subVectors(e, t), i.cross(Vt);
    const a = i.lengthSq();
    return a > 0 ? i.multiplyScalar(1 / Math.sqrt(a)) : i.set(0, 0, 0);
  }
  /**
   * Computes a barycentric coordinates from the given vector.
   * Returns `null` if the triangle is degenerate.
   *
   * @param {Vector3} point - A point in 3D space.
   * @param {Vector3} a - The first corner of the triangle.
   * @param {Vector3} b - The second corner of the triangle.
   * @param {Vector3} c - The third corner of the triangle.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The barycentric coordinates for the given point
   */
  static getBarycoord(e, t, s, i, a) {
    Vt.subVectors(i, t), is.subVectors(s, t), Mn.subVectors(e, t);
    const n = Vt.dot(Vt), o = Vt.dot(is), l = Vt.dot(Mn), u = is.dot(is), h = is.dot(Mn), d = n * u - o * o;
    if (d === 0)
      return a.set(0, 0, 0), null;
    const p = 1 / d, m = (u * l - o * h) * p, g = (n * h - o * l) * p;
    return a.set(1 - m - g, g, m);
  }
  /**
   * Returns `true` if the given point, when projected onto the plane of the
   * triangle, lies within the triangle.
   *
   * @param {Vector3} point - The point in 3D space to test.
   * @param {Vector3} a - The first corner of the triangle.
   * @param {Vector3} b - The second corner of the triangle.
   * @param {Vector3} c - The third corner of the triangle.
   * @return {boolean} Whether the given point, when projected onto the plane of the
   * triangle, lies within the triangle or not.
   */
  static containsPoint(e, t, s, i) {
    return this.getBarycoord(e, t, s, i, as) === null ? !1 : as.x >= 0 && as.y >= 0 && as.x + as.y <= 1;
  }
  /**
   * Computes the value barycentrically interpolated for the given point on the
   * triangle. Returns `null` if the triangle is degenerate.
   *
   * @param {Vector3} point - Position of interpolated point.
   * @param {Vector3} p1 - The first corner of the triangle.
   * @param {Vector3} p2 - The second corner of the triangle.
   * @param {Vector3} p3 - The third corner of the triangle.
   * @param {Vector3} v1 - Value to interpolate of first vertex.
   * @param {Vector3} v2 - Value to interpolate of second vertex.
   * @param {Vector3} v3 - Value to interpolate of third vertex.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The interpolated value.
   */
  static getInterpolation(e, t, s, i, a, n, o, l) {
    return this.getBarycoord(e, t, s, i, as) === null ? (l.x = 0, l.y = 0, "z" in l && (l.z = 0), "w" in l && (l.w = 0), null) : (l.setScalar(0), l.addScaledVector(a, as.x), l.addScaledVector(n, as.y), l.addScaledVector(o, as.z), l);
  }
  /**
   * Computes the value barycentrically interpolated for the given attribute and indices.
   *
   * @param {BufferAttribute} attr - The attribute to interpolate.
   * @param {number} i1 - Index of first vertex.
   * @param {number} i2 - Index of second vertex.
   * @param {number} i3 - Index of third vertex.
   * @param {Vector3} barycoord - The barycoordinate value to use to interpolate.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The interpolated attribute value.
   */
  static getInterpolatedAttribute(e, t, s, i, a, n) {
    return Vn.setScalar(0), Cn.setScalar(0), zn.setScalar(0), Vn.fromBufferAttribute(e, t), Cn.fromBufferAttribute(e, s), zn.fromBufferAttribute(e, i), n.setScalar(0), n.addScaledVector(Vn, a.x), n.addScaledVector(Cn, a.y), n.addScaledVector(zn, a.z), n;
  }
  /**
   * Returns `true` if the triangle is oriented towards the given direction.
   *
   * @param {Vector3} a - The first corner of the triangle.
   * @param {Vector3} b - The second corner of the triangle.
   * @param {Vector3} c - The third corner of the triangle.
   * @param {Vector3} direction - The (normalized) direction vector.
   * @return {boolean} Whether the triangle is oriented towards the given direction or not.
   */
  static isFrontFacing(e, t, s, i) {
    return Vt.subVectors(s, t), is.subVectors(e, t), Vt.cross(is).dot(i) < 0;
  }
  /**
   * Sets the triangle's vertices by copying the given values.
   *
   * @param {Vector3} a - The first corner of the triangle.
   * @param {Vector3} b - The second corner of the triangle.
   * @param {Vector3} c - The third corner of the triangle.
   * @return {Triangle} A reference to this triangle.
   */
  set(e, t, s) {
    return this.a.copy(e), this.b.copy(t), this.c.copy(s), this;
  }
  /**
   * Sets the triangle's vertices by copying the given array values.
   *
   * @param {Array<Vector3>} points - An array with 3D points.
   * @param {number} i0 - The array index representing the first corner of the triangle.
   * @param {number} i1 - The array index representing the second corner of the triangle.
   * @param {number} i2 - The array index representing the third corner of the triangle.
   * @return {Triangle} A reference to this triangle.
   */
  setFromPointsAndIndices(e, t, s, i) {
    return this.a.copy(e[t]), this.b.copy(e[s]), this.c.copy(e[i]), this;
  }
  /**
   * Sets the triangle's vertices by copying the given attribute values.
   *
   * @param {BufferAttribute} attribute - A buffer attribute with 3D points data.
   * @param {number} i0 - The attribute index representing the first corner of the triangle.
   * @param {number} i1 - The attribute index representing the second corner of the triangle.
   * @param {number} i2 - The attribute index representing the third corner of the triangle.
   * @return {Triangle} A reference to this triangle.
   */
  setFromAttributeAndIndices(e, t, s, i) {
    return this.a.fromBufferAttribute(e, t), this.b.fromBufferAttribute(e, s), this.c.fromBufferAttribute(e, i), this;
  }
  /**
   * Returns a new triangle with copied values from this instance.
   *
   * @return {Triangle} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
  /**
   * Copies the values of the given triangle to this instance.
   *
   * @param {Triangle} triangle - The triangle to copy.
   * @return {Triangle} A reference to this triangle.
   */
  copy(e) {
    return this.a.copy(e.a), this.b.copy(e.b), this.c.copy(e.c), this;
  }
  /**
   * Computes the area of the triangle.
   *
   * @return {number} The triangle's area.
   */
  getArea() {
    return Vt.subVectors(this.c, this.b), is.subVectors(this.a, this.b), Vt.cross(is).length() * 0.5;
  }
  /**
   * Computes the midpoint of the triangle.
   *
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The triangle's midpoint.
   */
  getMidpoint(e) {
    return e.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
  }
  /**
   * Computes the normal of the triangle.
   *
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The triangle's normal.
   */
  getNormal(e) {
    return Lt.getNormal(this.a, this.b, this.c, e);
  }
  /**
   * Computes a plane the triangle lies within.
   *
   * @param {Plane} target - The target vector that is used to store the method's result.
   * @return {Plane} The plane the triangle lies within.
   */
  getPlane(e) {
    return e.setFromCoplanarPoints(this.a, this.b, this.c);
  }
  /**
   * Computes a barycentric coordinates from the given vector.
   * Returns `null` if the triangle is degenerate.
   *
   * @param {Vector3} point - A point in 3D space.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The barycentric coordinates for the given point
   */
  getBarycoord(e, t) {
    return Lt.getBarycoord(e, this.a, this.b, this.c, t);
  }
  /**
   * Computes the value barycentrically interpolated for the given point on the
   * triangle. Returns `null` if the triangle is degenerate.
   *
   * @param {Vector3} point - Position of interpolated point.
   * @param {Vector3} v1 - Value to interpolate of first vertex.
   * @param {Vector3} v2 - Value to interpolate of second vertex.
   * @param {Vector3} v3 - Value to interpolate of third vertex.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The interpolated value.
   */
  getInterpolation(e, t, s, i, a) {
    return Lt.getInterpolation(e, this.a, this.b, this.c, t, s, i, a);
  }
  /**
   * Returns `true` if the given point, when projected onto the plane of the
   * triangle, lies within the triangle.
   *
   * @param {Vector3} point - The point in 3D space to test.
   * @return {boolean} Whether the given point, when projected onto the plane of the
   * triangle, lies within the triangle or not.
   */
  containsPoint(e) {
    return Lt.containsPoint(e, this.a, this.b, this.c);
  }
  /**
   * Returns `true` if the triangle is oriented towards the given direction.
   *
   * @param {Vector3} direction - The (normalized) direction vector.
   * @return {boolean} Whether the triangle is oriented towards the given direction or not.
   */
  isFrontFacing(e) {
    return Lt.isFrontFacing(this.a, this.b, this.c, e);
  }
  /**
   * Returns `true` if this triangle intersects with the given box.
   *
   * @param {Box3} box - The box to intersect.
   * @return {boolean} Whether this triangle intersects with the given box or not.
   */
  intersectsBox(e) {
    return e.intersectsTriangle(this);
  }
  /**
   * Returns the closest point on the triangle to the given point.
   *
   * @param {Vector3} p - The point to compute the closest point for.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The closest point on the triangle.
   */
  closestPointToPoint(e, t) {
    const s = this.a, i = this.b, a = this.c;
    let n, o;
    br.subVectors(i, s), vr.subVectors(a, s), Sn.subVectors(e, s);
    const l = br.dot(Sn), u = vr.dot(Sn);
    if (l <= 0 && u <= 0)
      return t.copy(s);
    _n.subVectors(e, i);
    const h = br.dot(_n), d = vr.dot(_n);
    if (h >= 0 && d <= h)
      return t.copy(i);
    const p = l * d - h * u;
    if (p <= 0 && l >= 0 && h <= 0)
      return n = l / (l - h), t.copy(s).addScaledVector(br, n);
    An.subVectors(e, a);
    const m = br.dot(An), g = vr.dot(An);
    if (g >= 0 && m <= g)
      return t.copy(a);
    const y = m * u - l * g;
    if (y <= 0 && u >= 0 && g <= 0)
      return o = u / (u - g), t.copy(s).addScaledVector(vr, o);
    const v = h * g - m * d;
    if (v <= 0 && d - h >= 0 && m - g >= 0)
      return Lu.subVectors(a, i), o = (d - h) / (d - h + (m - g)), t.copy(i).addScaledVector(Lu, o);
    const w = 1 / (v + y + p);
    return n = y * w, o = p * w, t.copy(s).addScaledVector(br, n).addScaledVector(vr, o);
  }
  /**
   * Returns `true` if this triangle is equal with the given one.
   *
   * @param {Triangle} triangle - The triangle to test for equality.
   * @return {boolean} Whether this triangle is equal with the given one.
   */
  equals(e) {
    return e.a.equals(this.a) && e.b.equals(this.b) && e.c.equals(this.c);
  }
}
class Ni {
  /**
   * Constructs a new bounding box.
   *
   * @param {Vector3} [min=(Infinity,Infinity,Infinity)] - A vector representing the lower boundary of the box.
   * @param {Vector3} [max=(-Infinity,-Infinity,-Infinity)] - A vector representing the upper boundary of the box.
   */
  constructor(e = new M(1 / 0, 1 / 0, 1 / 0), t = new M(-1 / 0, -1 / 0, -1 / 0)) {
    this.isBox3 = !0, this.min = e, this.max = t;
  }
  /**
   * Sets the lower and upper boundaries of this box.
   * Please note that this method only copies the values from the given objects.
   *
   * @param {Vector3} min - The lower boundary of the box.
   * @param {Vector3} max - The upper boundary of the box.
   * @return {Box3} A reference to this bounding box.
   */
  set(e, t) {
    return this.min.copy(e), this.max.copy(t), this;
  }
  /**
   * Sets the upper and lower bounds of this box so it encloses the position data
   * in the given array.
   *
   * @param {Array<number>} array - An array holding 3D position data.
   * @return {Box3} A reference to this bounding box.
   */
  setFromArray(e) {
    this.makeEmpty();
    for (let t = 0, s = e.length; t < s; t += 3)
      this.expandByPoint(Ct.fromArray(e, t));
    return this;
  }
  /**
   * Sets the upper and lower bounds of this box so it encloses the position data
   * in the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - A buffer attribute holding 3D position data.
   * @return {Box3} A reference to this bounding box.
   */
  setFromBufferAttribute(e) {
    this.makeEmpty();
    for (let t = 0, s = e.count; t < s; t++)
      this.expandByPoint(Ct.fromBufferAttribute(e, t));
    return this;
  }
  /**
   * Sets the upper and lower bounds of this box so it encloses the position data
   * in the given array.
   *
   * @param {Array<Vector3>} points - An array holding 3D position data as instances of {@link Vector3}.
   * @return {Box3} A reference to this bounding box.
   */
  setFromPoints(e) {
    this.makeEmpty();
    for (let t = 0, s = e.length; t < s; t++)
      this.expandByPoint(e[t]);
    return this;
  }
  /**
   * Centers this box on the given center vector and sets this box's width, height and
   * depth to the given size values.
   *
   * @param {Vector3} center - The center of the box.
   * @param {Vector3} size - The x, y and z dimensions of the box.
   * @return {Box3} A reference to this bounding box.
   */
  setFromCenterAndSize(e, t) {
    const s = Ct.copy(t).multiplyScalar(0.5);
    return this.min.copy(e).sub(s), this.max.copy(e).add(s), this;
  }
  /**
   * Computes the world-axis-aligned bounding box for the given 3D object
   * (including its children), accounting for the object's, and children's,
   * world transforms. The function may result in a larger box than strictly necessary.
   *
   * Note: To compute the correct bounding box, make sure the given 3D object
   * has an up-to-date world matrix that reflects the current transformation of its
   * ancestor nodes. Call `object.updateWorldMatrix( true, false )` beforehand if
   * you're unsure.
   *
   * @param {Object3D} object - The 3D object to compute the bounding box for.
   * @param {boolean} [precise=false] - If set to `true`, the method computes the smallest
   * world-axis-aligned bounding box at the expense of more computation.
   * @return {Box3} A reference to this bounding box.
   */
  setFromObject(e, t = !1) {
    return this.makeEmpty(), this.expandByObject(e, t);
  }
  /**
   * Returns a new box with copied values from this instance.
   *
   * @return {Box3} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
  /**
   * Copies the values of the given box to this instance.
   *
   * @param {Box3} box - The box to copy.
   * @return {Box3} A reference to this bounding box.
   */
  copy(e) {
    return this.min.copy(e.min), this.max.copy(e.max), this;
  }
  /**
   * Makes this box empty which means in encloses a zero space in 3D.
   *
   * @return {Box3} A reference to this bounding box.
   */
  makeEmpty() {
    return this.min.x = this.min.y = this.min.z = 1 / 0, this.max.x = this.max.y = this.max.z = -1 / 0, this;
  }
  /**
   * Returns true if this box includes zero points within its bounds.
   * Note that a box with equal lower and upper bounds still includes one
   * point, the one both bounds share.
   *
   * @return {boolean} Whether this box is empty or not.
   */
  isEmpty() {
    return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
  }
  /**
   * Returns the center point of this box.
   *
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The center point.
   */
  getCenter(e) {
    return this.isEmpty() ? e.set(0, 0, 0) : e.addVectors(this.min, this.max).multiplyScalar(0.5);
  }
  /**
   * Returns the dimensions of this box.
   *
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The size.
   */
  getSize(e) {
    return this.isEmpty() ? e.set(0, 0, 0) : e.subVectors(this.max, this.min);
  }
  /**
   * Expands the boundaries of this box to include the given point.
   *
   * @param {Vector3} point - The point that should be included by the bounding box.
   * @return {Box3} A reference to this bounding box.
   */
  expandByPoint(e) {
    return this.min.min(e), this.max.max(e), this;
  }
  /**
   * Expands this box equilaterally by the given vector. The width of this
   * box will be expanded by the x component of the vector in both
   * directions. The height of this box will be expanded by the y component of
   * the vector in both directions. The depth of this box will be
   * expanded by the z component of the vector in both directions.
   *
   * @param {Vector3} vector - The vector that should expand the bounding box.
   * @return {Box3} A reference to this bounding box.
   */
  expandByVector(e) {
    return this.min.sub(e), this.max.add(e), this;
  }
  /**
   * Expands each dimension of the box by the given scalar. If negative, the
   * dimensions of the box will be contracted.
   *
   * @param {number} scalar - The scalar value that should expand the bounding box.
   * @return {Box3} A reference to this bounding box.
   */
  expandByScalar(e) {
    return this.min.addScalar(-e), this.max.addScalar(e), this;
  }
  /**
   * Expands the boundaries of this box to include the given 3D object and
   * its children, accounting for the object's, and children's, world
   * transforms. The function may result in a larger box than strictly
   * necessary (unless the precise parameter is set to true).
   *
   * @param {Object3D} object - The 3D object that should expand the bounding box.
   * @param {boolean} precise - If set to `true`, the method expands the bounding box
   * as little as necessary at the expense of more computation.
   * @return {Box3} A reference to this bounding box.
   */
  expandByObject(e, t = !1) {
    e.updateWorldMatrix(!1, !1);
    const s = e.geometry;
    if (s !== void 0) {
      const a = s.getAttribute("position");
      if (t === !0 && a !== void 0 && e.isInstancedMesh !== !0)
        for (let n = 0, o = a.count; n < o; n++)
          e.isMesh === !0 ? e.getVertexPosition(n, Ct) : Ct.fromBufferAttribute(a, n), Ct.applyMatrix4(e.matrixWorld), this.expandByPoint(Ct);
      else
        e.boundingBox !== void 0 ? (e.boundingBox === null && e.computeBoundingBox(), Oi.copy(e.boundingBox)) : (s.boundingBox === null && s.computeBoundingBox(), Oi.copy(s.boundingBox)), Oi.applyMatrix4(e.matrixWorld), this.union(Oi);
    }
    const i = e.children;
    for (let a = 0, n = i.length; a < n; a++)
      this.expandByObject(i[a], t);
    return this;
  }
  /**
   * Returns `true` if the given point lies within or on the boundaries of this box.
   *
   * @param {Vector3} point - The point to test.
   * @return {boolean} Whether the bounding box contains the given point or not.
   */
  containsPoint(e) {
    return e.x >= this.min.x && e.x <= this.max.x && e.y >= this.min.y && e.y <= this.max.y && e.z >= this.min.z && e.z <= this.max.z;
  }
  /**
   * Returns `true` if this bounding box includes the entirety of the given bounding box.
   * If this box and the given one are identical, this function also returns `true`.
   *
   * @param {Box3} box - The bounding box to test.
   * @return {boolean} Whether the bounding box contains the given bounding box or not.
   */
  containsBox(e) {
    return this.min.x <= e.min.x && e.max.x <= this.max.x && this.min.y <= e.min.y && e.max.y <= this.max.y && this.min.z <= e.min.z && e.max.z <= this.max.z;
  }
  /**
   * Returns a point as a proportion of this box's width, height and depth.
   *
   * @param {Vector3} point - A point in 3D space.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} A point as a proportion of this box's width, height and depth.
   */
  getParameter(e, t) {
    return t.set(
      (e.x - this.min.x) / (this.max.x - this.min.x),
      (e.y - this.min.y) / (this.max.y - this.min.y),
      (e.z - this.min.z) / (this.max.z - this.min.z)
    );
  }
  /**
   * Returns `true` if the given bounding box intersects with this bounding box.
   *
   * @param {Box3} box - The bounding box to test.
   * @return {boolean} Whether the given bounding box intersects with this bounding box.
   */
  intersectsBox(e) {
    return e.max.x >= this.min.x && e.min.x <= this.max.x && e.max.y >= this.min.y && e.min.y <= this.max.y && e.max.z >= this.min.z && e.min.z <= this.max.z;
  }
  /**
   * Returns `true` if the given bounding sphere intersects with this bounding box.
   *
   * @param {Sphere} sphere - The bounding sphere to test.
   * @return {boolean} Whether the given bounding sphere intersects with this bounding box.
   */
  intersectsSphere(e) {
    return this.clampPoint(e.center, Ct), Ct.distanceToSquared(e.center) <= e.radius * e.radius;
  }
  /**
   * Returns `true` if the given plane intersects with this bounding box.
   *
   * @param {Plane} plane - The plane to test.
   * @return {boolean} Whether the given plane intersects with this bounding box.
   */
  intersectsPlane(e) {
    let t, s;
    return e.normal.x > 0 ? (t = e.normal.x * this.min.x, s = e.normal.x * this.max.x) : (t = e.normal.x * this.max.x, s = e.normal.x * this.min.x), e.normal.y > 0 ? (t += e.normal.y * this.min.y, s += e.normal.y * this.max.y) : (t += e.normal.y * this.max.y, s += e.normal.y * this.min.y), e.normal.z > 0 ? (t += e.normal.z * this.min.z, s += e.normal.z * this.max.z) : (t += e.normal.z * this.max.z, s += e.normal.z * this.min.z), t <= -e.constant && s >= -e.constant;
  }
  /**
   * Returns `true` if the given triangle intersects with this bounding box.
   *
   * @param {Triangle} triangle - The triangle to test.
   * @return {boolean} Whether the given triangle intersects with this bounding box.
   */
  intersectsTriangle(e) {
    if (this.isEmpty())
      return !1;
    this.getCenter(ei), Pi.subVectors(this.max, ei), Tr.subVectors(e.a, ei), wr.subVectors(e.b, ei), Nr.subVectors(e.c, ei), Ts.subVectors(wr, Tr), ws.subVectors(Nr, wr), Ds.subVectors(Tr, Nr);
    let t = [
      0,
      -Ts.z,
      Ts.y,
      0,
      -ws.z,
      ws.y,
      0,
      -Ds.z,
      Ds.y,
      Ts.z,
      0,
      -Ts.x,
      ws.z,
      0,
      -ws.x,
      Ds.z,
      0,
      -Ds.x,
      -Ts.y,
      Ts.x,
      0,
      -ws.y,
      ws.x,
      0,
      -Ds.y,
      Ds.x,
      0
    ];
    return !Rn(t, Tr, wr, Nr, Pi) || (t = [1, 0, 0, 0, 1, 0, 0, 0, 1], !Rn(t, Tr, wr, Nr, Pi)) ? !1 : (Fi.crossVectors(Ts, ws), t = [Fi.x, Fi.y, Fi.z], Rn(t, Tr, wr, Nr, Pi));
  }
  /**
   * Clamps the given point within the bounds of this box.
   *
   * @param {Vector3} point - The point to clamp.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The clamped point.
   */
  clampPoint(e, t) {
    return t.copy(e).clamp(this.min, this.max);
  }
  /**
   * Returns the euclidean distance from any edge of this box to the specified point. If
   * the given point lies inside of this box, the distance will be `0`.
   *
   * @param {Vector3} point - The point to compute the distance to.
   * @return {number} The euclidean distance.
   */
  distanceToPoint(e) {
    return this.clampPoint(e, Ct).distanceTo(e);
  }
  /**
   * Returns a bounding sphere that encloses this bounding box.
   *
   * @param {Sphere} target - The target sphere that is used to store the method's result.
   * @return {Sphere} The bounding sphere that encloses this bounding box.
   */
  getBoundingSphere(e) {
    return this.isEmpty() ? e.makeEmpty() : (this.getCenter(e.center), e.radius = this.getSize(Ct).length() * 0.5), e;
  }
  /**
   * Computes the intersection of this bounding box and the given one, setting the upper
   * bound of this box to the lesser of the two boxes' upper bounds and the
   * lower bound of this box to the greater of the two boxes' lower bounds. If
   * there's no overlap, makes this box empty.
   *
   * @param {Box3} box - The bounding box to intersect with.
   * @return {Box3} A reference to this bounding box.
   */
  intersect(e) {
    return this.min.max(e.min), this.max.min(e.max), this.isEmpty() && this.makeEmpty(), this;
  }
  /**
   * Computes the union of this box and another and the given one, setting the upper
   * bound of this box to the greater of the two boxes' upper bounds and the
   * lower bound of this box to the lesser of the two boxes' lower bounds.
   *
   * @param {Box3} box - The bounding box that will be unioned with this instance.
   * @return {Box3} A reference to this bounding box.
   */
  union(e) {
    return this.min.min(e.min), this.max.max(e.max), this;
  }
  /**
   * Transforms this bounding box by the given 4x4 transformation matrix.
   *
   * @param {Matrix4} matrix - The transformation matrix.
   * @return {Box3} A reference to this bounding box.
   */
  applyMatrix4(e) {
    return this.isEmpty() ? this : (ns[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(e), ns[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(e), ns[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(e), ns[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(e), ns[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(e), ns[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(e), ns[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(e), ns[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(e), this.setFromPoints(ns), this);
  }
  /**
   * Adds the given offset to both the upper and lower bounds of this bounding box,
   * effectively moving it in 3D space.
   *
   * @param {Vector3} offset - The offset that should be used to translate the bounding box.
   * @return {Box3} A reference to this bounding box.
   */
  translate(e) {
    return this.min.add(e), this.max.add(e), this;
  }
  /**
   * Returns `true` if this bounding box is equal with the given one.
   *
   * @param {Box3} box - The box to test for equality.
   * @return {boolean} Whether this bounding box is equal with the given one.
   */
  equals(e) {
    return e.min.equals(this.min) && e.max.equals(this.max);
  }
  /**
   * Returns a serialized structure of the bounding box.
   *
   * @return {Object} Serialized structure with fields representing the object state.
   */
  toJSON() {
    return {
      min: this.min.toArray(),
      max: this.max.toArray()
    };
  }
  /**
   * Returns a serialized structure of the bounding box.
   *
   * @param {Object} json - The serialized json to set the box from.
   * @return {Box3} A reference to this bounding box.
   */
  fromJSON(e) {
    return this.min.fromArray(e.min), this.max.fromArray(e.max), this;
  }
}
const ns = [
  /* @__PURE__ */ new M(),
  /* @__PURE__ */ new M(),
  /* @__PURE__ */ new M(),
  /* @__PURE__ */ new M(),
  /* @__PURE__ */ new M(),
  /* @__PURE__ */ new M(),
  /* @__PURE__ */ new M(),
  /* @__PURE__ */ new M()
], Ct = /* @__PURE__ */ new M(), Oi = /* @__PURE__ */ new Ni(), Tr = /* @__PURE__ */ new M(), wr = /* @__PURE__ */ new M(), Nr = /* @__PURE__ */ new M(), Ts = /* @__PURE__ */ new M(), ws = /* @__PURE__ */ new M(), Ds = /* @__PURE__ */ new M(), ei = /* @__PURE__ */ new M(), Pi = /* @__PURE__ */ new M(), Fi = /* @__PURE__ */ new M(), Ws = /* @__PURE__ */ new M();
function Rn(r, e, t, s, i) {
  for (let a = 0, n = r.length - 3; a <= n; a += 3) {
    Ws.fromArray(r, a);
    const o = i.x * Math.abs(Ws.x) + i.y * Math.abs(Ws.y) + i.z * Math.abs(Ws.z), l = e.dot(Ws), u = t.dot(Ws), h = s.dot(Ws);
    if (Math.max(-Math.max(l, u, h), Math.min(l, u, h)) > o)
      return !1;
  }
  return !0;
}
const Ce = /* @__PURE__ */ new M(), Bi = /* @__PURE__ */ new _e();
let sf = 0;
class wt extends Ps {
  /**
   * Constructs a new buffer attribute.
   *
   * @param {TypedArray} array - The array holding the attribute data.
   * @param {number} itemSize - The item size.
   * @param {boolean} [normalized=false] - Whether the data are normalized or not.
   */
  constructor(e, t, s = !1) {
    if (super(), Array.isArray(e))
      throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
    this.isBufferAttribute = !0, Object.defineProperty(this, "id", { value: sf++ }), this.name = "", this.array = e, this.itemSize = t, this.count = e !== void 0 ? e.length / t : 0, this.normalized = s, this.usage = kr, this.updateRanges = [], this.gpuType = qo, this.version = 0;
  }
  /**
   * A callback function that is executed after the renderer has transferred the attribute
   * array data to the GPU.
   */
  onUploadCallback() {
  }
  /**
   * Flag to indicate that this attribute has changed and should be re-sent to
   * the GPU. Set this to `true` when you modify the value of the array.
   *
   * @type {number}
   * @default false
   * @param {boolean} value
   */
  set needsUpdate(e) {
    e === !0 && this.version++;
  }
  /**
   * Sets the usage of this buffer attribute.
   *
   * @param {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)} value - The usage to set.
   * @return {BufferAttribute} A reference to this buffer attribute.
   */
  setUsage(e) {
    return this.usage = e, this;
  }
  /**
   * Adds a range of data in the data array to be updated on the GPU.
   *
   * @param {number} start - Position at which to start update.
   * @param {number} count - The number of components to update.
   */
  addUpdateRange(e, t) {
    this.updateRanges.push({ start: e, count: t });
  }
  /**
   * Clears the update ranges.
   */
  clearUpdateRanges() {
    this.updateRanges.length = 0;
  }
  /**
   * Copies the values of the given buffer attribute to this instance.
   *
   * @param {BufferAttribute} source - The buffer attribute to copy.
   * @return {BufferAttribute} A reference to this instance.
   */
  copy(e) {
    return this.name = e.name, this.array = new e.array.constructor(e.array), this.itemSize = e.itemSize, this.count = e.count, this.normalized = e.normalized, this.usage = e.usage, this.gpuType = e.gpuType, this;
  }
  /**
   * Copies a vector from the given buffer attribute to this one. The start
   * and destination position in the attribute buffers are represented by the
   * given indices.
   *
   * @param {number} index1 - The destination index into this buffer attribute.
   * @param {BufferAttribute} attribute - The buffer attribute to copy from.
   * @param {number} index2 - The source index into the given buffer attribute.
   * @return {BufferAttribute} A reference to this instance.
   */
  copyAt(e, t, s) {
    e *= this.itemSize, s *= t.itemSize;
    for (let i = 0, a = this.itemSize; i < a; i++)
      this.array[e + i] = t.array[s + i];
    return this;
  }
  /**
   * Copies the given array data into this buffer attribute.
   *
   * @param {(TypedArray|Array)} array - The array to copy.
   * @return {BufferAttribute} A reference to this instance.
   */
  copyArray(e) {
    return this.array.set(e), this;
  }
  /**
   * Applies the given 3x3 matrix to the given attribute. Works with
   * item size `2` and `3`.
   *
   * @param {Matrix3} m - The matrix to apply.
   * @return {BufferAttribute} A reference to this instance.
   */
  applyMatrix3(e) {
    if (this.itemSize === 2)
      for (let t = 0, s = this.count; t < s; t++)
        Bi.fromBufferAttribute(this, t), Bi.applyMatrix3(e), this.setXY(t, Bi.x, Bi.y);
    else if (this.itemSize === 3)
      for (let t = 0, s = this.count; t < s; t++)
        Ce.fromBufferAttribute(this, t), Ce.applyMatrix3(e), this.setXYZ(t, Ce.x, Ce.y, Ce.z);
    return this;
  }
  /**
   * Applies the given 4x4 matrix to the given attribute. Only works with
   * item size `3`.
   *
   * @param {Matrix4} m - The matrix to apply.
   * @return {BufferAttribute} A reference to this instance.
   */
  applyMatrix4(e) {
    for (let t = 0, s = this.count; t < s; t++)
      Ce.fromBufferAttribute(this, t), Ce.applyMatrix4(e), this.setXYZ(t, Ce.x, Ce.y, Ce.z);
    return this;
  }
  /**
   * Applies the given 3x3 normal matrix to the given attribute. Only works with
   * item size `3`.
   *
   * @param {Matrix3} m - The normal matrix to apply.
   * @return {BufferAttribute} A reference to this instance.
   */
  applyNormalMatrix(e) {
    for (let t = 0, s = this.count; t < s; t++)
      Ce.fromBufferAttribute(this, t), Ce.applyNormalMatrix(e), this.setXYZ(t, Ce.x, Ce.y, Ce.z);
    return this;
  }
  /**
   * Applies the given 4x4 matrix to the given attribute. Only works with
   * item size `3` and with direction vectors.
   *
   * @param {Matrix4} m - The matrix to apply.
   * @return {BufferAttribute} A reference to this instance.
   */
  transformDirection(e) {
    for (let t = 0, s = this.count; t < s; t++)
      Ce.fromBufferAttribute(this, t), Ce.transformDirection(e), this.setXYZ(t, Ce.x, Ce.y, Ce.z);
    return this;
  }
  /**
   * Sets the given array data in the buffer attribute.
   *
   * @param {(TypedArray|Array)} value - The array data to set.
   * @param {number} [offset=0] - The offset in this buffer attribute's array.
   * @return {BufferAttribute} A reference to this instance.
   */
  set(e, t = 0) {
    return this.array.set(e, t), this;
  }
  /**
   * Returns the given component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} component - The component index.
   * @return {number} The returned value.
   */
  getComponent(e, t) {
    let s = this.array[e * this.itemSize + t];
    return this.normalized && (s = Et(s, this.array)), s;
  }
  /**
   * Sets the given value to the given component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} component - The component index.
   * @param {number} value - The value to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setComponent(e, t, s) {
    return this.normalized && (s = oe(s, this.array)), this.array[e * this.itemSize + t] = s, this;
  }
  /**
   * Returns the x component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The x component.
   */
  getX(e) {
    let t = this.array[e * this.itemSize];
    return this.normalized && (t = Et(t, this.array)), t;
  }
  /**
   * Sets the x component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setX(e, t) {
    return this.normalized && (t = oe(t, this.array)), this.array[e * this.itemSize] = t, this;
  }
  /**
   * Returns the y component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The y component.
   */
  getY(e) {
    let t = this.array[e * this.itemSize + 1];
    return this.normalized && (t = Et(t, this.array)), t;
  }
  /**
   * Sets the y component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} y - The value to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setY(e, t) {
    return this.normalized && (t = oe(t, this.array)), this.array[e * this.itemSize + 1] = t, this;
  }
  /**
   * Returns the z component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The z component.
   */
  getZ(e) {
    let t = this.array[e * this.itemSize + 2];
    return this.normalized && (t = Et(t, this.array)), t;
  }
  /**
   * Sets the z component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} z - The value to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setZ(e, t) {
    return this.normalized && (t = oe(t, this.array)), this.array[e * this.itemSize + 2] = t, this;
  }
  /**
   * Returns the w component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The w component.
   */
  getW(e) {
    let t = this.array[e * this.itemSize + 3];
    return this.normalized && (t = Et(t, this.array)), t;
  }
  /**
   * Sets the w component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} w - The value to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setW(e, t) {
    return this.normalized && (t = oe(t, this.array)), this.array[e * this.itemSize + 3] = t, this;
  }
  /**
   * Sets the x and y component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value for the x component to set.
   * @param {number} y - The value for the y component to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setXY(e, t, s) {
    return e *= this.itemSize, this.normalized && (t = oe(t, this.array), s = oe(s, this.array)), this.array[e + 0] = t, this.array[e + 1] = s, this;
  }
  /**
   * Sets the x, y and z component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value for the x component to set.
   * @param {number} y - The value for the y component to set.
   * @param {number} z - The value for the z component to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setXYZ(e, t, s, i) {
    return e *= this.itemSize, this.normalized && (t = oe(t, this.array), s = oe(s, this.array), i = oe(i, this.array)), this.array[e + 0] = t, this.array[e + 1] = s, this.array[e + 2] = i, this;
  }
  /**
   * Sets the x, y, z and w component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value for the x component to set.
   * @param {number} y - The value for the y component to set.
   * @param {number} z - The value for the z component to set.
   * @param {number} w - The value for the w component to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setXYZW(e, t, s, i, a) {
    return e *= this.itemSize, this.normalized && (t = oe(t, this.array), s = oe(s, this.array), i = oe(i, this.array), a = oe(a, this.array)), this.array[e + 0] = t, this.array[e + 1] = s, this.array[e + 2] = i, this.array[e + 3] = a, this;
  }
  /**
   * Sets the given callback function that is executed after the Renderer has transferred
   * the attribute array data to the GPU. Can be used to perform clean-up operations after
   * the upload when attribute data are not needed anymore on the CPU side.
   *
   * @param {Function} callback - The `onUpload()` callback.
   * @return {BufferAttribute} A reference to this instance.
   */
  onUpload(e) {
    return this.onUploadCallback = e, this;
  }
  /**
   * Returns a new buffer attribute with copied values from this instance.
   *
   * @return {BufferAttribute} A clone of this instance.
   */
  clone() {
    return new this.constructor(this.array, this.itemSize).copy(this);
  }
  /**
   * Serializes the buffer attribute into JSON.
   *
   * @return {Object} A JSON object representing the serialized buffer attribute.
   */
  toJSON() {
    const e = {
      itemSize: this.itemSize,
      type: this.array.constructor.name,
      array: Array.from(this.array),
      normalized: this.normalized
    };
    return this.name !== "" && (e.name = this.name), this.usage !== kr && (e.usage = this.usage), e;
  }
  /**
   * Disposes of the buffer attribute. Available only in {@link WebGPURenderer}.
   */
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
}
class rf extends wt {
  /**
   * Constructs a new buffer attribute.
   *
   * @param {(Array<number>|Uint16Array)} array - The array holding the attribute data.
   * @param {number} itemSize - The item size.
   * @param {boolean} [normalized=false] - Whether the data are normalized or not.
   */
  constructor(e, t, s) {
    super(new Uint16Array(e), t, s);
  }
}
class af extends wt {
  /**
   * Constructs a new buffer attribute.
   *
   * @param {(Array<number>|Uint32Array)} array - The array holding the attribute data.
   * @param {number} itemSize - The item size.
   * @param {boolean} [normalized=false] - Whether the data are normalized or not.
   */
  constructor(e, t, s) {
    super(new Uint32Array(e), t, s);
  }
}
class Ir extends wt {
  /**
   * Constructs a new buffer attribute.
   *
   * @param {(Array<number>|Float32Array)} array - The array holding the attribute data.
   * @param {number} itemSize - The item size.
   * @param {boolean} [normalized=false] - Whether the data are normalized or not.
   */
  constructor(e, t, s) {
    super(new Float32Array(e), t, s);
  }
}
const nf = /* @__PURE__ */ new Ni(), ti = /* @__PURE__ */ new M(), En = /* @__PURE__ */ new M();
class Xo {
  /**
   * Constructs a new sphere.
   *
   * @param {Vector3} [center=(0,0,0)] - The center of the sphere
   * @param {number} [radius=-1] - The radius of the sphere.
   */
  constructor(e = new M(), t = -1) {
    this.isSphere = !0, this.center = e, this.radius = t;
  }
  /**
   * Sets the sphere's components by copying the given values.
   *
   * @param {Vector3} center - The center.
   * @param {number} radius - The radius.
   * @return {Sphere} A reference to this sphere.
   */
  set(e, t) {
    return this.center.copy(e), this.radius = t, this;
  }
  /**
   * Computes the minimum bounding sphere for list of points.
   * If the optional center point is given, it is used as the sphere's
   * center. Otherwise, the center of the axis-aligned bounding box
   * encompassing the points is calculated.
   *
   * @param {Array<Vector3>} points - A list of points in 3D space.
   * @param {Vector3} [optionalCenter] - The center of the sphere.
   * @return {Sphere} A reference to this sphere.
   */
  setFromPoints(e, t) {
    const s = this.center;
    t !== void 0 ? s.copy(t) : nf.setFromPoints(e).getCenter(s);
    let i = 0;
    for (let a = 0, n = e.length; a < n; a++)
      i = Math.max(i, s.distanceToSquared(e[a]));
    return this.radius = Math.sqrt(i), this;
  }
  /**
   * Copies the values of the given sphere to this instance.
   *
   * @param {Sphere} sphere - The sphere to copy.
   * @return {Sphere} A reference to this sphere.
   */
  copy(e) {
    return this.center.copy(e.center), this.radius = e.radius, this;
  }
  /**
   * Returns `true` if the sphere is empty (the radius set to a negative number).
   *
   * Spheres with a radius of `0` contain only their center point and are not
   * considered to be empty.
   *
   * @return {boolean} Whether this sphere is empty or not.
   */
  isEmpty() {
    return this.radius < 0;
  }
  /**
   * Makes this sphere empty which means in encloses a zero space in 3D.
   *
   * @return {Sphere} A reference to this sphere.
   */
  makeEmpty() {
    return this.center.set(0, 0, 0), this.radius = -1, this;
  }
  /**
   * Returns `true` if this sphere contains the given point inclusive of
   * the surface of the sphere.
   *
   * @param {Vector3} point - The point to check.
   * @return {boolean} Whether this sphere contains the given point or not.
   */
  containsPoint(e) {
    return e.distanceToSquared(this.center) <= this.radius * this.radius;
  }
  /**
   * Returns the closest distance from the boundary of the sphere to the
   * given point. If the sphere contains the point, the distance will
   * be negative.
   *
   * @param {Vector3} point - The point to compute the distance to.
   * @return {number} The distance to the point.
   */
  distanceToPoint(e) {
    return e.distanceTo(this.center) - this.radius;
  }
  /**
   * Returns `true` if this sphere intersects with the given one.
   *
   * @param {Sphere} sphere - The sphere to test.
   * @return {boolean} Whether this sphere intersects with the given one or not.
   */
  intersectsSphere(e) {
    const t = this.radius + e.radius;
    return e.center.distanceToSquared(this.center) <= t * t;
  }
  /**
   * Returns `true` if this sphere intersects with the given box.
   *
   * @param {Box3} box - The box to test.
   * @return {boolean} Whether this sphere intersects with the given box or not.
   */
  intersectsBox(e) {
    return e.intersectsSphere(this);
  }
  /**
   * Returns `true` if this sphere intersects with the given plane.
   *
   * @param {Plane} plane - The plane to test.
   * @return {boolean} Whether this sphere intersects with the given plane or not.
   */
  intersectsPlane(e) {
    return Math.abs(e.distanceToPoint(this.center)) <= this.radius;
  }
  /**
   * Clamps a point within the sphere. If the point is outside the sphere, it
   * will clamp it to the closest point on the edge of the sphere. Points
   * already inside the sphere will not be affected.
   *
   * @param {Vector3} point - The plane to clamp.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The clamped point.
   */
  clampPoint(e, t) {
    const s = this.center.distanceToSquared(e);
    return t.copy(e), s > this.radius * this.radius && (t.sub(this.center).normalize(), t.multiplyScalar(this.radius).add(this.center)), t;
  }
  /**
   * Returns a bounding box that encloses this sphere.
   *
   * @param {Box3} target - The target box that is used to store the method's result.
   * @return {Box3} The bounding box that encloses this sphere.
   */
  getBoundingBox(e) {
    return this.isEmpty() ? (e.makeEmpty(), e) : (e.set(this.center, this.center), e.expandByScalar(this.radius), e);
  }
  /**
   * Transforms this sphere with the given 4x4 transformation matrix.
   *
   * @param {Matrix4} matrix - The transformation matrix.
   * @return {Sphere} A reference to this sphere.
   */
  applyMatrix4(e) {
    return this.center.applyMatrix4(e), this.radius = this.radius * e.getMaxScaleOnAxis(), this;
  }
  /**
   * Translates the sphere's center by the given offset.
   *
   * @param {Vector3} offset - The offset.
   * @return {Sphere} A reference to this sphere.
   */
  translate(e) {
    return this.center.add(e), this;
  }
  /**
   * Expands the boundaries of this sphere to include the given point.
   *
   * @param {Vector3} point - The point to include.
   * @return {Sphere} A reference to this sphere.
   */
  expandByPoint(e) {
    if (this.isEmpty())
      return this.center.copy(e), this.radius = 0, this;
    ti.subVectors(e, this.center);
    const t = ti.lengthSq();
    if (t > this.radius * this.radius) {
      const s = Math.sqrt(t), i = (s - this.radius) * 0.5;
      this.center.addScaledVector(ti, i / s), this.radius += i;
    }
    return this;
  }
  /**
   * Expands this sphere to enclose both the original sphere and the given sphere.
   *
   * @param {Sphere} sphere - The sphere to include.
   * @return {Sphere} A reference to this sphere.
   */
  union(e) {
    return e.isEmpty() ? this : this.isEmpty() ? (this.copy(e), this) : (this.center.equals(e.center) === !0 ? this.radius = Math.max(this.radius, e.radius) : (En.subVectors(e.center, this.center).setLength(e.radius), this.expandByPoint(ti.copy(e.center).add(En)), this.expandByPoint(ti.copy(e.center).sub(En))), this);
  }
  /**
   * Returns `true` if this sphere is equal with the given one.
   *
   * @param {Sphere} sphere - The sphere to test for equality.
   * @return {boolean} Whether this bounding sphere is equal with the given one.
   */
  equals(e) {
    return e.center.equals(this.center) && e.radius === this.radius;
  }
  /**
   * Returns a new sphere with copied values from this instance.
   *
   * @return {Sphere} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
  /**
   * Returns a serialized structure of the bounding sphere.
   *
   * @return {Object} Serialized structure with fields representing the object state.
   */
  toJSON() {
    return {
      radius: this.radius,
      center: this.center.toArray()
    };
  }
  /**
   * Returns a serialized structure of the bounding sphere.
   *
   * @param {Object} json - The serialized json to set the sphere from.
   * @return {Sphere} A reference to this bounding sphere.
   */
  fromJSON(e) {
    return this.radius = e.radius, this.center.fromArray(e.center), this;
  }
}
let of = 0;
const ft = /* @__PURE__ */ new de(), Ln = /* @__PURE__ */ new Pt(), Mr = /* @__PURE__ */ new M(), lt = /* @__PURE__ */ new Ni(), si = /* @__PURE__ */ new Ni(), Pe = /* @__PURE__ */ new M();
class ar extends Ps {
  /**
   * Constructs a new geometry.
   */
  constructor() {
    super(), this.isBufferGeometry = !0, Object.defineProperty(this, "id", { value: of++ }), this.uuid = cs(), this.name = "", this.type = "BufferGeometry", this.index = null, this.indirect = null, this.indirectOffset = 0, this.attributes = {}, this.morphAttributes = {}, this.morphTargetsRelative = !1, this.groups = [], this.boundingBox = null, this.boundingSphere = null, this.drawRange = { start: 0, count: 1 / 0 }, this.userData = {}, this._transformed = !1;
  }
  /**
   * Returns the index of this geometry.
   *
   * @return {?BufferAttribute} The index. Returns `null` if no index is defined.
   */
  getIndex() {
    return this.index;
  }
  /**
   * Sets the given index to this geometry.
   *
   * @param {Array<number>|BufferAttribute} index - The index to set.
   * @return {BufferGeometry} A reference to this instance.
   */
  setIndex(e) {
    return Array.isArray(e) ? this.index = new (Ag(e) ? af : rf)(e, 1) : this.index = e, this;
  }
  /**
   * Sets the given indirect attribute to this geometry.
   *
   * @param {BufferAttribute} indirect - The attribute holding indirect draw calls.
   * @param {number|Array<number>} [indirectOffset=0] - The offset, in bytes, into the indirect drawing buffer where the value data begins. If an array is provided, multiple indirect draw calls will be made for each offset.
   * @return {BufferGeometry} A reference to this instance.
   */
  setIndirect(e, t = 0) {
    return this.indirect = e, this.indirectOffset = t, this;
  }
  /**
   * Returns the indirect attribute of this geometry.
   *
   * @return {?BufferAttribute} The indirect attribute. Returns `null` if no indirect attribute is defined.
   */
  getIndirect() {
    return this.indirect;
  }
  /**
   * Returns the buffer attribute for the given name.
   *
   * @param {string} name - The attribute name.
   * @return {BufferAttribute|InterleavedBufferAttribute|undefined} The buffer attribute.
   * Returns `undefined` if not attribute has been found.
   */
  getAttribute(e) {
    return this.attributes[e];
  }
  /**
   * Sets the given attribute for the given name.
   *
   * @param {string} name - The attribute name.
   * @param {BufferAttribute|InterleavedBufferAttribute} attribute - The attribute to set.
   * @return {BufferGeometry} A reference to this instance.
   */
  setAttribute(e, t) {
    return this.attributes[e] = t, this;
  }
  /**
   * Deletes the attribute for the given name.
   *
   * @param {string} name - The attribute name to delete.
   * @return {BufferGeometry} A reference to this instance.
   */
  deleteAttribute(e) {
    return delete this.attributes[e], this;
  }
  /**
   * Returns `true` if this geometry has an attribute for the given name.
   *
   * @param {string} name - The attribute name.
   * @return {boolean} Whether this geometry has an attribute for the given name or not.
   */
  hasAttribute(e) {
    return this.attributes[e] !== void 0;
  }
  /**
   * Adds a group to this geometry.
   *
   * @param {number} start - The first element in this draw call. That is the first
   * vertex for non-indexed geometry, otherwise the first triangle index.
   * @param {number} count - Specifies how many vertices (or indices) are part of this group.
   * @param {number} [materialIndex=0] - The material array index to use.
   */
  addGroup(e, t, s = 0) {
    this.groups.push({
      start: e,
      count: t,
      materialIndex: s
    });
  }
  /**
   * Clears all groups.
   */
  clearGroups() {
    this.groups = [];
  }
  /**
   * Sets the draw range for this geometry.
   *
   * @param {number} start - The first vertex for non-indexed geometry, otherwise the first triangle index.
   * @param {number} count - For non-indexed BufferGeometry, `count` is the number of vertices to render.
   * For indexed BufferGeometry, `count` is the number of indices to render.
   */
  setDrawRange(e, t) {
    this.drawRange.start = e, this.drawRange.count = t;
  }
  /**
   * Applies the given 4x4 transformation matrix to the geometry.
   *
   * @param {Matrix4} matrix - The matrix to apply.
   * @return {BufferGeometry} A reference to this instance.
   */
  applyMatrix4(e) {
    const t = this.attributes.position;
    t !== void 0 && (t.applyMatrix4(e), t.needsUpdate = !0);
    const s = this.attributes.normal;
    if (s !== void 0) {
      const a = new Kt().getNormalMatrix(e);
      s.applyNormalMatrix(a), s.needsUpdate = !0;
    }
    const i = this.attributes.tangent;
    return i !== void 0 && (i.transformDirection(e), i.needsUpdate = !0), this.boundingBox !== null && this.computeBoundingBox(), this.boundingSphere !== null && this.computeBoundingSphere(), this._transformed = !0, this;
  }
  /**
   * Applies the rotation represented by the Quaternion to the geometry.
   *
   * @param {Quaternion} q - The Quaternion to apply.
   * @return {BufferGeometry} A reference to this instance.
   */
  applyQuaternion(e) {
    return ft.makeRotationFromQuaternion(e), this.applyMatrix4(ft), this;
  }
  /**
   * Rotates the geometry about the X axis. This is typically done as a one time
   * operation, and not during a loop. Use {@link Object3D#rotation} for typical
   * real-time mesh rotation.
   *
   * @param {number} angle - The angle in radians.
   * @return {BufferGeometry} A reference to this instance.
   */
  rotateX(e) {
    return ft.makeRotationX(e), this.applyMatrix4(ft), this;
  }
  /**
   * Rotates the geometry about the Y axis. This is typically done as a one time
   * operation, and not during a loop. Use {@link Object3D#rotation} for typical
   * real-time mesh rotation.
   *
   * @param {number} angle - The angle in radians.
   * @return {BufferGeometry} A reference to this instance.
   */
  rotateY(e) {
    return ft.makeRotationY(e), this.applyMatrix4(ft), this;
  }
  /**
   * Rotates the geometry about the Z axis. This is typically done as a one time
   * operation, and not during a loop. Use {@link Object3D#rotation} for typical
   * real-time mesh rotation.
   *
   * @param {number} angle - The angle in radians.
   * @return {BufferGeometry} A reference to this instance.
   */
  rotateZ(e) {
    return ft.makeRotationZ(e), this.applyMatrix4(ft), this;
  }
  /**
   * Translates the geometry. This is typically done as a one time
   * operation, and not during a loop. Use {@link Object3D#position} for typical
   * real-time mesh rotation.
   *
   * @param {number} x - The x offset.
   * @param {number} y - The y offset.
   * @param {number} z - The z offset.
   * @return {BufferGeometry} A reference to this instance.
   */
  translate(e, t, s) {
    return ft.makeTranslation(e, t, s), this.applyMatrix4(ft), this;
  }
  /**
   * Scales the geometry. This is typically done as a one time
   * operation, and not during a loop. Use {@link Object3D#scale} for typical
   * real-time mesh rotation.
   *
   * @param {number} x - The x scale.
   * @param {number} y - The y scale.
   * @param {number} z - The z scale.
   * @return {BufferGeometry} A reference to this instance.
   */
  scale(e, t, s) {
    return ft.makeScale(e, t, s), this.applyMatrix4(ft), this;
  }
  /**
   * Rotates the geometry to face a point in 3D space. This is typically done as a one time
   * operation, and not during a loop. Use {@link Object3D#lookAt} for typical
   * real-time mesh rotation.
   *
   * @param {Vector3} vector - The target point.
   * @return {BufferGeometry} A reference to this instance.
   */
  lookAt(e) {
    return Ln.lookAt(e), Ln.updateMatrix(), this.applyMatrix4(Ln.matrix), this;
  }
  /**
   * Center the geometry based on its bounding box.
   *
   * @return {BufferGeometry} A reference to this instance.
   */
  center() {
    return this.computeBoundingBox(), this.boundingBox.getCenter(Mr).negate(), this.translate(Mr.x, Mr.y, Mr.z), this;
  }
  /**
   * Defines a geometry by creating a `position` attribute based on the given array of points. The array
   * can hold 2D or 3D vectors. When using two-dimensional data, the `z` coordinate for all vertices is
   * set to `0`.
   *
   * If the method is used with an existing `position` attribute, the vertex data are overwritten with the
   * data from the array. The length of the array must match the vertex count.
   *
   * @param {Array<Vector2>|Array<Vector3>} points - The points.
   * @return {BufferGeometry} A reference to this instance.
   */
  setFromPoints(e) {
    const t = this.getAttribute("position");
    if (t === void 0) {
      const s = [];
      for (let i = 0, a = e.length; i < a; i++) {
        const n = e[i];
        s.push(n.x, n.y, n.z || 0);
      }
      this.setAttribute("position", new Ir(s, 3));
    } else {
      const s = Math.min(e.length, t.count);
      for (let i = 0; i < s; i++) {
        const a = e[i];
        t.setXYZ(i, a.x, a.y, a.z || 0);
      }
      e.length > t.count && X("BufferGeometry: Buffer size too small for points data. Use .dispose() and create a new geometry."), t.needsUpdate = !0;
    }
    return this;
  }
  /**
   * Computes the bounding box of the geometry, and updates the `boundingBox` member.
   * The bounding box is not computed by the engine; it must be computed by your app.
   * You may need to recompute the bounding box if the geometry vertices are modified.
   */
  computeBoundingBox() {
    this.boundingBox === null && (this.boundingBox = new Ni());
    const e = this.attributes.position, t = this.morphAttributes.position;
    if (e && e.isGLBufferAttribute) {
      te("BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.", this), this.boundingBox.set(
        new M(-1 / 0, -1 / 0, -1 / 0),
        new M(1 / 0, 1 / 0, 1 / 0)
      );
      return;
    }
    if (e !== void 0) {
      if (this.boundingBox.setFromBufferAttribute(e), t)
        for (let s = 0, i = t.length; s < i; s++) {
          const a = t[s];
          lt.setFromBufferAttribute(a), this.morphTargetsRelative ? (Pe.addVectors(this.boundingBox.min, lt.min), this.boundingBox.expandByPoint(Pe), Pe.addVectors(this.boundingBox.max, lt.max), this.boundingBox.expandByPoint(Pe)) : (this.boundingBox.expandByPoint(lt.min), this.boundingBox.expandByPoint(lt.max));
        }
    } else
      this.boundingBox.makeEmpty();
    (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) && te('BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
  }
  /**
   * Computes the bounding sphere of the geometry, and updates the `boundingSphere` member.
   * The engine automatically computes the bounding sphere when it is needed, e.g., for ray casting or view frustum culling.
   * You may need to recompute the bounding sphere if the geometry vertices are modified.
   */
  computeBoundingSphere() {
    this.boundingSphere === null && (this.boundingSphere = new Xo());
    const e = this.attributes.position, t = this.morphAttributes.position;
    if (e && e.isGLBufferAttribute) {
      te("BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.", this), this.boundingSphere.set(new M(), 1 / 0);
      return;
    }
    if (e) {
      const s = this.boundingSphere.center;
      if (lt.setFromBufferAttribute(e), t)
        for (let a = 0, n = t.length; a < n; a++) {
          const o = t[a];
          si.setFromBufferAttribute(o), this.morphTargetsRelative ? (Pe.addVectors(lt.min, si.min), lt.expandByPoint(Pe), Pe.addVectors(lt.max, si.max), lt.expandByPoint(Pe)) : (lt.expandByPoint(si.min), lt.expandByPoint(si.max));
        }
      lt.getCenter(s);
      let i = 0;
      for (let a = 0, n = e.count; a < n; a++)
        Pe.fromBufferAttribute(e, a), i = Math.max(i, s.distanceToSquared(Pe));
      if (t)
        for (let a = 0, n = t.length; a < n; a++) {
          const o = t[a], l = this.morphTargetsRelative;
          for (let u = 0, h = o.count; u < h; u++)
            Pe.fromBufferAttribute(o, u), l && (Mr.fromBufferAttribute(e, u), Pe.add(Mr)), i = Math.max(i, s.distanceToSquared(Pe));
        }
      this.boundingSphere.radius = Math.sqrt(i), isNaN(this.boundingSphere.radius) && te('BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
    }
  }
  /**
   * Calculates and adds a tangent attribute to this geometry.
   *
   * The computation is only supported for indexed geometries and if position, normal, and uv attributes
   * are defined. When using a tangent space normal map, prefer the MikkTSpace algorithm provided by
   * {@link BufferGeometryUtils#computeMikkTSpaceTangents} instead.
   */
  computeTangents() {
    const e = this.index, t = this.attributes;
    if (e === null || t.position === void 0 || t.normal === void 0 || t.uv === void 0) {
      te("BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
      return;
    }
    const s = t.position, i = t.normal, a = t.uv;
    let n = this.getAttribute("tangent");
    (n === void 0 || n.count !== s.count) && (n = new wt(new Float32Array(4 * s.count), 4), this.setAttribute("tangent", n));
    const o = [], l = [];
    for (let I = 0; I < s.count; I++)
      o[I] = new M(), l[I] = new M();
    const u = new M(), h = new M(), d = new M(), p = new _e(), m = new _e(), g = new _e(), y = new M(), v = new M();
    function w(I, G, $) {
      u.fromBufferAttribute(s, I), h.fromBufferAttribute(s, G), d.fromBufferAttribute(s, $), p.fromBufferAttribute(a, I), m.fromBufferAttribute(a, G), g.fromBufferAttribute(a, $), h.sub(u), d.sub(u), m.sub(p), g.sub(p);
      const Z = 1 / (m.x * g.y - g.x * m.y);
      isFinite(Z) && (y.copy(h).multiplyScalar(g.y).addScaledVector(d, -m.y).multiplyScalar(Z), v.copy(d).multiplyScalar(m.x).addScaledVector(h, -g.x).multiplyScalar(Z), o[I].add(y), o[G].add(y), o[$].add(y), l[I].add(v), l[G].add(v), l[$].add(v));
    }
    let _ = this.groups;
    _.length === 0 && (_ = [{
      start: 0,
      count: e.count
    }]);
    for (let I = 0, G = _.length; I < G; ++I) {
      const $ = _[I], Z = $.start, Ve = $.count;
      for (let ue = Z, Ye = Z + Ve; ue < Ye; ue += 3)
        w(
          e.getX(ue + 0),
          e.getX(ue + 1),
          e.getX(ue + 2)
        );
    }
    const C = new M(), V = new M(), P = new M(), z = new M();
    function R(I) {
      P.fromBufferAttribute(i, I), z.copy(P);
      const G = o[I];
      C.copy(G), C.sub(P.multiplyScalar(P.dot(G))).normalize(), V.crossVectors(z, G);
      const $ = V.dot(l[I]) < 0 ? -1 : 1;
      n.setXYZW(I, C.x, C.y, C.z, $);
    }
    for (let I = 0, G = _.length; I < G; ++I) {
      const $ = _[I], Z = $.start, Ve = $.count;
      for (let ue = Z, Ye = Z + Ve; ue < Ye; ue += 3)
        R(e.getX(ue + 0)), R(e.getX(ue + 1)), R(e.getX(ue + 2));
    }
    this._transformed = !0;
  }
  /**
   * Computes vertex normals for the given vertex data. For indexed geometries, the method sets
   * each vertex normal to be the average of the face normals of the faces that share that vertex.
   * For non-indexed geometries, vertices are not shared, and the method sets each vertex normal
   * to be the same as the face normal.
   */
  computeVertexNormals() {
    const e = this.index, t = this.getAttribute("position");
    if (t !== void 0) {
      let s = this.getAttribute("normal");
      if (s === void 0 || s.count !== t.count)
        s = new wt(new Float32Array(t.count * 3), 3), this.setAttribute("normal", s);
      else
        for (let p = 0, m = s.count; p < m; p++)
          s.setXYZ(p, 0, 0, 0);
      const i = new M(), a = new M(), n = new M(), o = new M(), l = new M(), u = new M(), h = new M(), d = new M();
      if (e)
        for (let p = 0, m = e.count; p < m; p += 3) {
          const g = e.getX(p + 0), y = e.getX(p + 1), v = e.getX(p + 2);
          i.fromBufferAttribute(t, g), a.fromBufferAttribute(t, y), n.fromBufferAttribute(t, v), h.subVectors(n, a), d.subVectors(i, a), h.cross(d), o.fromBufferAttribute(s, g), l.fromBufferAttribute(s, y), u.fromBufferAttribute(s, v), o.add(h), l.add(h), u.add(h), s.setXYZ(g, o.x, o.y, o.z), s.setXYZ(y, l.x, l.y, l.z), s.setXYZ(v, u.x, u.y, u.z);
        }
      else
        for (let p = 0, m = t.count; p < m; p += 3)
          i.fromBufferAttribute(t, p + 0), a.fromBufferAttribute(t, p + 1), n.fromBufferAttribute(t, p + 2), h.subVectors(n, a), d.subVectors(i, a), h.cross(d), s.setXYZ(p + 0, h.x, h.y, h.z), s.setXYZ(p + 1, h.x, h.y, h.z), s.setXYZ(p + 2, h.x, h.y, h.z);
      this.normalizeNormals(), s.needsUpdate = !0;
    }
  }
  /**
   * Ensures every normal vector in a geometry will have a magnitude of `1`. This will
   * correct lighting on the geometry surfaces.
   */
  normalizeNormals() {
    const e = this.attributes.normal;
    for (let t = 0, s = e.count; t < s; t++)
      Pe.fromBufferAttribute(e, t), Pe.normalize(), e.setXYZ(t, Pe.x, Pe.y, Pe.z);
  }
  /**
   * Return a new non-index version of this indexed geometry. If the geometry
   * is already non-indexed, the method is a NOOP.
   *
   * @return {BufferGeometry} The non-indexed version of this indexed geometry.
   */
  toNonIndexed() {
    function e(o, l) {
      const u = o.array, h = o.itemSize, d = o.normalized, p = new u.constructor(l.length * h);
      let m = 0, g = 0;
      for (let y = 0, v = l.length; y < v; y++) {
        o.isInterleavedBufferAttribute ? m = l[y] * o.data.stride + o.offset : m = l[y] * h;
        for (let w = 0; w < h; w++)
          p[g++] = u[m++];
      }
      return new wt(p, h, d);
    }
    if (this.index === null)
      return X("BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed."), this;
    const t = new ar(), s = this.index.array, i = this.attributes;
    for (const o in i) {
      const l = i[o], u = e(l, s);
      t.setAttribute(o, u);
    }
    const a = this.morphAttributes;
    for (const o in a) {
      const l = [], u = a[o];
      for (let h = 0, d = u.length; h < d; h++) {
        const p = u[h], m = e(p, s);
        l.push(m);
      }
      t.morphAttributes[o] = l;
    }
    t.morphTargetsRelative = this.morphTargetsRelative;
    const n = this.groups;
    for (let o = 0, l = n.length; o < l; o++) {
      const u = n[o];
      t.addGroup(u.start, u.count, u.materialIndex);
    }
    return t;
  }
  /**
   * Serializes the geometry into JSON.
   *
   * @return {Object} A JSON object representing the serialized geometry.
   */
  toJSON() {
    const e = {
      metadata: {
        version: 4.7,
        type: "BufferGeometry",
        generator: "BufferGeometry.toJSON"
      }
    };
    if (e.uuid = this.uuid, e.type = this.parameters !== void 0 && this._transformed === !0 ? "BufferGeometry" : this.type, this.name !== "" && (e.name = this.name), Object.keys(this.userData).length > 0 && (e.userData = this.userData), this.parameters !== void 0 && this._transformed !== !0) {
      const l = this.parameters;
      for (const u in l)
        l[u] !== void 0 && (e[u] = l[u]);
      return e;
    }
    e.data = { attributes: {} };
    const t = this.index;
    t !== null && (e.data.index = {
      type: t.array.constructor.name,
      array: Array.prototype.slice.call(t.array)
    });
    const s = this.attributes;
    for (const l in s) {
      const u = s[l];
      e.data.attributes[l] = u.toJSON(e.data);
    }
    const i = {};
    let a = !1;
    for (const l in this.morphAttributes) {
      const u = this.morphAttributes[l], h = [];
      for (let d = 0, p = u.length; d < p; d++) {
        const m = u[d];
        h.push(m.toJSON(e.data));
      }
      h.length > 0 && (i[l] = h, a = !0);
    }
    a && (e.data.morphAttributes = i, e.data.morphTargetsRelative = this.morphTargetsRelative);
    const n = this.groups;
    n.length > 0 && (e.data.groups = JSON.parse(JSON.stringify(n)));
    const o = this.boundingSphere;
    return o !== null && (e.data.boundingSphere = o.toJSON()), e;
  }
  /**
   * Returns a new geometry with copied values from this instance.
   *
   * @return {BufferGeometry} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
  /**
   * Copies the values of the given geometry to this instance.
   *
   * @param {BufferGeometry} source - The geometry to copy.
   * @return {BufferGeometry} A reference to this instance.
   */
  copy(e) {
    this.index = null, this.attributes = {}, this.morphAttributes = {}, this.groups = [], this.boundingBox = null, this.boundingSphere = null;
    const t = {};
    this.name = e.name;
    const s = e.index;
    s !== null && this.setIndex(s.clone());
    const i = e.attributes;
    for (const u in i) {
      const h = i[u];
      this.setAttribute(u, h.clone(t));
    }
    const a = e.morphAttributes;
    for (const u in a) {
      const h = [], d = a[u];
      for (let p = 0, m = d.length; p < m; p++)
        h.push(d[p].clone(t));
      this.morphAttributes[u] = h;
    }
    this.morphTargetsRelative = e.morphTargetsRelative;
    const n = e.groups;
    for (let u = 0, h = n.length; u < h; u++) {
      const d = n[u];
      this.addGroup(d.start, d.count, d.materialIndex);
    }
    const o = e.boundingBox;
    o !== null && (this.boundingBox = o.clone());
    const l = e.boundingSphere;
    return l !== null && (this.boundingSphere = l.clone()), this.drawRange.start = e.drawRange.start, this.drawRange.count = e.drawRange.count, this.userData = e.userData, this._transformed = e._transformed, this;
  }
  /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever this instance is no longer used in your app.
   *
   * @fires BufferGeometry#dispose
   */
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
}
class jh {
  /**
   * Constructs a new interleaved buffer.
   *
   * @param {TypedArray} array - A typed array with a shared buffer storing attribute data.
   * @param {number} stride - The number of typed-array elements per vertex.
   */
  constructor(e, t) {
    this.isInterleavedBuffer = !0, this.array = e, this.stride = t, this.count = e !== void 0 ? e.length / t : 0, this.usage = kr, this.updateRanges = [], this.version = 0, this.uuid = cs();
  }
  /**
   * A callback function that is executed after the renderer has transferred the attribute array
   * data to the GPU.
   */
  onUploadCallback() {
  }
  /**
   * Flag to indicate that this attribute has changed and should be re-sent to
   * the GPU. Set this to `true` when you modify the value of the array.
   *
   * @type {number}
   * @default false
   * @param {boolean} value
   */
  set needsUpdate(e) {
    e === !0 && this.version++;
  }
  /**
   * Sets the usage of this interleaved buffer.
   *
   * @param {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)} value - The usage to set.
   * @return {InterleavedBuffer} A reference to this interleaved buffer.
   */
  setUsage(e) {
    return this.usage = e, this;
  }
  /**
   * Adds a range of data in the data array to be updated on the GPU.
   *
   * @param {number} start - Position at which to start update.
   * @param {number} count - The number of components to update.
   */
  addUpdateRange(e, t) {
    this.updateRanges.push({ start: e, count: t });
  }
  /**
   * Clears the update ranges.
   */
  clearUpdateRanges() {
    this.updateRanges.length = 0;
  }
  /**
   * Copies the values of the given interleaved buffer to this instance.
   *
   * @param {InterleavedBuffer} source - The interleaved buffer to copy.
   * @return {InterleavedBuffer} A reference to this instance.
   */
  copy(e) {
    return this.array = new e.array.constructor(e.array), this.count = e.count, this.stride = e.stride, this.usage = e.usage, this;
  }
  /**
   * Copies a vector from the given interleaved buffer to this one. The start
   * and destination position in the attribute buffers are represented by the
   * given indices.
   *
   * @param {number} index1 - The destination index into this interleaved buffer.
   * @param {InterleavedBuffer} interleavedBuffer - The interleaved buffer to copy from.
   * @param {number} index2 - The source index into the given interleaved buffer.
   * @return {InterleavedBuffer} A reference to this instance.
   */
  copyAt(e, t, s) {
    e *= this.stride, s *= t.stride;
    for (let i = 0, a = this.stride; i < a; i++)
      this.array[e + i] = t.array[s + i];
    return this;
  }
  /**
   * Sets the given array data in the interleaved buffer.
   *
   * @param {(TypedArray|Array)} value - The array data to set.
   * @param {number} [offset=0] - The offset in this interleaved buffer's array.
   * @return {InterleavedBuffer} A reference to this instance.
   */
  set(e, t = 0) {
    return this.array.set(e, t), this;
  }
  /**
   * Returns a new interleaved buffer with copied values from this instance.
   *
   * @param {Object} [data] - An object with shared array buffers that allows to retain shared structures.
   * @return {InterleavedBuffer} A clone of this instance.
   */
  clone(e) {
    e.arrayBuffers === void 0 && (e.arrayBuffers = {}), this.array.buffer._uuid === void 0 && (this.array.buffer._uuid = cs()), e.arrayBuffers[this.array.buffer._uuid] === void 0 && (e.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer);
    const t = new this.array.constructor(e.arrayBuffers[this.array.buffer._uuid]), s = new this.constructor(t, this.stride);
    return s.setUsage(this.usage), s;
  }
  /**
   * Sets the given callback function that is executed after the Renderer has transferred
   * the array data to the GPU. Can be used to perform clean-up operations after
   * the upload when data are not needed anymore on the CPU side.
   *
   * @param {Function} callback - The `onUpload()` callback.
   * @return {InterleavedBuffer} A reference to this instance.
   */
  onUpload(e) {
    return this.onUploadCallback = e, this;
  }
  /**
   * Serializes the interleaved buffer into JSON.
   *
   * @param {Object} [data] - An optional value holding meta information about the serialization.
   * @return {Object} A JSON object representing the serialized interleaved buffer.
   */
  toJSON(e) {
    return e.arrayBuffers === void 0 && (e.arrayBuffers = {}), this.array.buffer._uuid === void 0 && (this.array.buffer._uuid = cs()), e.arrayBuffers[this.array.buffer._uuid] === void 0 && (e.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer))), {
      uuid: this.uuid,
      buffer: this.array.buffer._uuid,
      type: this.array.constructor.name,
      stride: this.stride
    };
  }
}
const Ze = /* @__PURE__ */ new M();
class $o {
  /**
   * Constructs a new interleaved buffer attribute.
   *
   * @param {InterleavedBuffer} interleavedBuffer - The buffer holding the interleaved data.
   * @param {number} itemSize - The item size.
   * @param {number} offset - The attribute offset into the buffer.
   * @param {boolean} [normalized=false] - Whether the data are normalized or not.
   */
  constructor(e, t, s, i = !1) {
    this.isInterleavedBufferAttribute = !0, this.name = "", this.data = e, this.itemSize = t, this.offset = s, this.normalized = i;
  }
  /**
   * The item count of this buffer attribute.
   *
   * @type {number}
   * @readonly
   */
  get count() {
    return this.data.count;
  }
  /**
   * The array holding the interleaved buffer attribute data.
   *
   * @type {TypedArray}
   */
  get array() {
    return this.data.array;
  }
  /**
   * Flag to indicate that this attribute has changed and should be re-sent to
   * the GPU. Set this to `true` when you modify the value of the array.
   *
   * @type {number}
   * @default false
   * @param {boolean} value
   */
  set needsUpdate(e) {
    this.data.needsUpdate = e;
  }
  /**
   * Applies the given 4x4 matrix to the given attribute. Only works with
   * item size `3`.
   *
   * @param {Matrix4} m - The matrix to apply.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  applyMatrix4(e) {
    for (let t = 0, s = this.data.count; t < s; t++)
      Ze.fromBufferAttribute(this, t), Ze.applyMatrix4(e), this.setXYZ(t, Ze.x, Ze.y, Ze.z);
    return this;
  }
  /**
   * Applies the given 3x3 normal matrix to the given attribute. Only works with
   * item size `3`.
   *
   * @param {Matrix3} m - The normal matrix to apply.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  applyNormalMatrix(e) {
    for (let t = 0, s = this.count; t < s; t++)
      Ze.fromBufferAttribute(this, t), Ze.applyNormalMatrix(e), this.setXYZ(t, Ze.x, Ze.y, Ze.z);
    return this;
  }
  /**
   * Applies the given 4x4 matrix to the given attribute. Only works with
   * item size `3` and with direction vectors.
   *
   * @param {Matrix4} m - The matrix to apply.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  transformDirection(e) {
    for (let t = 0, s = this.count; t < s; t++)
      Ze.fromBufferAttribute(this, t), Ze.transformDirection(e), this.setXYZ(t, Ze.x, Ze.y, Ze.z);
    return this;
  }
  /**
   * Returns the given component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} component - The component index.
   * @return {number} The returned value.
   */
  getComponent(e, t) {
    let s = this.array[e * this.data.stride + this.offset + t];
    return this.normalized && (s = Et(s, this.array)), s;
  }
  /**
   * Sets the given value to the given component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} component - The component index.
   * @param {number} value - The value to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  setComponent(e, t, s) {
    return this.normalized && (s = oe(s, this.array)), this.data.array[e * this.data.stride + this.offset + t] = s, this;
  }
  /**
   * Sets the x component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  setX(e, t) {
    return this.normalized && (t = oe(t, this.array)), this.data.array[e * this.data.stride + this.offset] = t, this;
  }
  /**
   * Sets the y component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} y - The value to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  setY(e, t) {
    return this.normalized && (t = oe(t, this.array)), this.data.array[e * this.data.stride + this.offset + 1] = t, this;
  }
  /**
   * Sets the z component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} z - The value to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  setZ(e, t) {
    return this.normalized && (t = oe(t, this.array)), this.data.array[e * this.data.stride + this.offset + 2] = t, this;
  }
  /**
   * Sets the w component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} w - The value to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  setW(e, t) {
    return this.normalized && (t = oe(t, this.array)), this.data.array[e * this.data.stride + this.offset + 3] = t, this;
  }
  /**
   * Returns the x component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The x component.
   */
  getX(e) {
    let t = this.data.array[e * this.data.stride + this.offset];
    return this.normalized && (t = Et(t, this.array)), t;
  }
  /**
   * Returns the y component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The y component.
   */
  getY(e) {
    let t = this.data.array[e * this.data.stride + this.offset + 1];
    return this.normalized && (t = Et(t, this.array)), t;
  }
  /**
   * Returns the z component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The z component.
   */
  getZ(e) {
    let t = this.data.array[e * this.data.stride + this.offset + 2];
    return this.normalized && (t = Et(t, this.array)), t;
  }
  /**
   * Returns the w component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The w component.
   */
  getW(e) {
    let t = this.data.array[e * this.data.stride + this.offset + 3];
    return this.normalized && (t = Et(t, this.array)), t;
  }
  /**
   * Sets the x and y component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value for the x component to set.
   * @param {number} y - The value for the y component to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  setXY(e, t, s) {
    return e = e * this.data.stride + this.offset, this.normalized && (t = oe(t, this.array), s = oe(s, this.array)), this.data.array[e + 0] = t, this.data.array[e + 1] = s, this;
  }
  /**
   * Sets the x, y and z component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value for the x component to set.
   * @param {number} y - The value for the y component to set.
   * @param {number} z - The value for the z component to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  setXYZ(e, t, s, i) {
    return e = e * this.data.stride + this.offset, this.normalized && (t = oe(t, this.array), s = oe(s, this.array), i = oe(i, this.array)), this.data.array[e + 0] = t, this.data.array[e + 1] = s, this.data.array[e + 2] = i, this;
  }
  /**
   * Sets the x, y, z and w component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value for the x component to set.
   * @param {number} y - The value for the y component to set.
   * @param {number} z - The value for the z component to set.
   * @param {number} w - The value for the w component to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  setXYZW(e, t, s, i, a) {
    return e = e * this.data.stride + this.offset, this.normalized && (t = oe(t, this.array), s = oe(s, this.array), i = oe(i, this.array), a = oe(a, this.array)), this.data.array[e + 0] = t, this.data.array[e + 1] = s, this.data.array[e + 2] = i, this.data.array[e + 3] = a, this;
  }
  /**
   * Returns a new buffer attribute with copied values from this instance.
   *
   * If no parameter is provided, cloning an interleaved buffer attribute will de-interleave buffer data.
   *
   * @param {Object} [data] - An object with interleaved buffers that allows to retain the interleaved property.
   * @return {BufferAttribute|InterleavedBufferAttribute} A clone of this instance.
   */
  clone(e) {
    if (e === void 0) {
      bo("InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.");
      const t = [];
      for (let s = 0; s < this.count; s++) {
        const i = s * this.data.stride + this.offset;
        for (let a = 0; a < this.itemSize; a++)
          t.push(this.data.array[i + a]);
      }
      return new wt(new this.array.constructor(t), this.itemSize, this.normalized);
    } else
      return e.interleavedBuffers === void 0 && (e.interleavedBuffers = {}), e.interleavedBuffers[this.data.uuid] === void 0 && (e.interleavedBuffers[this.data.uuid] = this.data.clone(e)), new $o(e.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
  }
  /**
   * Serializes the buffer attribute into JSON.
   *
   * If no parameter is provided, cloning an interleaved buffer attribute will de-interleave buffer data.
   *
   * @param {Object} [data] - An optional value holding meta information about the serialization.
   * @return {Object} A JSON object representing the serialized buffer attribute.
   */
  toJSON(e) {
    if (e === void 0) {
      bo("InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.");
      const t = [];
      for (let s = 0; s < this.count; s++) {
        const i = s * this.data.stride + this.offset;
        for (let a = 0; a < this.itemSize; a++)
          t.push(this.data.array[i + a]);
      }
      return {
        itemSize: this.itemSize,
        type: this.array.constructor.name,
        array: t,
        normalized: this.normalized
      };
    } else
      return e.interleavedBuffers === void 0 && (e.interleavedBuffers = {}), e.interleavedBuffers[this.data.uuid] === void 0 && (e.interleavedBuffers[this.data.uuid] = this.data.toJSON(e)), {
        isInterleavedBufferAttribute: !0,
        itemSize: this.itemSize,
        data: this.data.uuid,
        offset: this.offset,
        normalized: this.normalized
      };
  }
}
let lf = 0;
class vo extends Ps {
  /**
   * Constructs a new material.
   */
  constructor() {
    super(), this.isMaterial = !0, Object.defineProperty(this, "id", { value: lf++ }), this.uuid = cs(), this.name = "", this.type = "Material", this.blending = co, this.side = ho, this.vertexColors = !1, this.opacity = 1, this.transparent = !1, this.alphaHash = !1, this.blendSrc = mo, this.blendDst = go, this.blendEquation = po, this.blendSrcAlpha = null, this.blendDstAlpha = null, this.blendEquationAlpha = null, this.blendColor = new Yt(0, 0, 0), this.blendAlpha = 0, this.depthFunc = mu, this.depthTest = !0, this.depthWrite = !0, this.stencilWriteMask = 255, this.stencilFunc = xu, this.stencilRef = 0, this.stencilFuncMask = 255, this.stencilFail = mr, this.stencilZFail = mr, this.stencilZPass = mr, this.stencilWrite = !1, this.clippingPlanes = null, this.clipIntersection = !1, this.clipShadows = !1, this.shadowSide = null, this.colorWrite = !0, this.precision = null, this.polygonOffset = !1, this.polygonOffsetFactor = 0, this.polygonOffsetUnits = 0, this.dithering = !1, this.alphaToCoverage = !1, this.premultipliedAlpha = !1, this.forceSinglePass = !1, this.allowOverride = !0, this.visible = !0, this.toneMapped = !0, this.userData = {}, this.version = 0, this._alphaTest = 0;
  }
  /**
   * Sets the alpha value to be used when running an alpha test. The material
   * will not be rendered if the opacity is lower than this value.
   *
   * @type {number}
   * @readonly
   * @default 0
   */
  get alphaTest() {
    return this._alphaTest;
  }
  set alphaTest(e) {
    this._alphaTest > 0 != e > 0 && this.version++, this._alphaTest = e;
  }
  /**
   * An optional callback that is executed immediately before the material is used to render a 3D object.
   *
   * This method can only be used when rendering with {@link WebGLRenderer}.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Scene} scene - The scene.
   * @param {Camera} camera - The camera that is used to render the scene.
   * @param {BufferGeometry} geometry - The 3D object's geometry.
   * @param {Object3D} object - The 3D object.
   * @param {Object} group - The geometry group data.
   */
  onBeforeRender() {
  }
  /**
   * An optional callback that is executed immediately before the shader
   * program is compiled. This function is called with the shader source code
   * as a parameter. Useful for the modification of built-in materials.
   *
   * This method can only be used when rendering with {@link WebGLRenderer}. The
   * recommended approach when customizing materials is to use `WebGPURenderer` with the new
   * Node Material system and [TSL](https://github.com/mrdoob/three.js/wiki/Three.js-Shading-Language).
   *
   * @param {{vertexShader:string,fragmentShader:string,uniforms:Object}} shaderobject - The object holds the uniforms and the vertex and fragment shader source.
   * @param {WebGLRenderer} renderer - A reference to the renderer.
   */
  onBeforeCompile() {
  }
  /**
   * In case {@link Material#onBeforeCompile} is used, this callback can be used to identify
   * values of settings used in `onBeforeCompile()`, so three.js can reuse a cached
   * shader or recompile the shader for this material as needed.
   *
   * This method can only be used when rendering with {@link WebGLRenderer}.
   *
   * @return {string} The custom program cache key.
   */
  customProgramCacheKey() {
    return this.onBeforeCompile.toString();
  }
  /**
   * This method can be used to set default values from parameter objects.
   * It is a generic implementation so it can be used with different types
   * of materials.
   *
   * @param {Object} [values] - The material values to set.
   */
  setValues(e) {
    if (e !== void 0)
      for (const t in e) {
        const s = e[t];
        if (s === void 0) {
          X(`Material: parameter '${t}' has value of undefined.`);
          continue;
        }
        const i = this[t];
        if (i === void 0) {
          X(`Material: '${t}' is not a property of THREE.${this.type}.`);
          continue;
        }
        i && i.isColor ? i.set(s) : i && i.isVector2 && s && s.isVector2 || i && i.isEuler && s && s.isEuler || i && i.isVector3 && s && s.isVector3 ? i.copy(s) : this[t] = s;
      }
  }
  /**
   * Serializes the material into JSON.
   *
   * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
   * @return {Object} A JSON object representing the serialized material.
   * @see {@link ObjectLoader#parse}
   */
  toJSON(e) {
    const t = e === void 0 || typeof e == "string";
    t && (e = {
      textures: {},
      images: {}
    });
    const s = {
      metadata: {
        version: 4.7,
        type: "Material",
        generator: "Material.toJSON"
      }
    };
    s.uuid = this.uuid, s.type = this.type, this.name !== "" && (s.name = this.name), this.color && this.color.isColor && (s.color = this.color.getHex()), this.roughness !== void 0 && (s.roughness = this.roughness), this.metalness !== void 0 && (s.metalness = this.metalness), this.sheen !== void 0 && (s.sheen = this.sheen), this.sheenColor && this.sheenColor.isColor && (s.sheenColor = this.sheenColor.getHex()), this.sheenRoughness !== void 0 && (s.sheenRoughness = this.sheenRoughness), this.emissive && this.emissive.isColor && (s.emissive = this.emissive.getHex()), this.emissiveIntensity !== void 0 && this.emissiveIntensity !== 1 && (s.emissiveIntensity = this.emissiveIntensity), this.specular && this.specular.isColor && (s.specular = this.specular.getHex()), this.specularIntensity !== void 0 && (s.specularIntensity = this.specularIntensity), this.specularColor && this.specularColor.isColor && (s.specularColor = this.specularColor.getHex()), this.shininess !== void 0 && (s.shininess = this.shininess), this.clearcoat !== void 0 && (s.clearcoat = this.clearcoat), this.clearcoatRoughness !== void 0 && (s.clearcoatRoughness = this.clearcoatRoughness), this.clearcoatMap && this.clearcoatMap.isTexture && (s.clearcoatMap = this.clearcoatMap.toJSON(e).uuid), this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture && (s.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(e).uuid), this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture && (s.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(e).uuid, s.clearcoatNormalScale = this.clearcoatNormalScale.toArray()), this.sheenColorMap && this.sheenColorMap.isTexture && (s.sheenColorMap = this.sheenColorMap.toJSON(e).uuid), this.sheenRoughnessMap && this.sheenRoughnessMap.isTexture && (s.sheenRoughnessMap = this.sheenRoughnessMap.toJSON(e).uuid), this.dispersion !== void 0 && (s.dispersion = this.dispersion), this.iridescence !== void 0 && (s.iridescence = this.iridescence), this.iridescenceIOR !== void 0 && (s.iridescenceIOR = this.iridescenceIOR), this.iridescenceThicknessRange !== void 0 && (s.iridescenceThicknessRange = this.iridescenceThicknessRange), this.iridescenceMap && this.iridescenceMap.isTexture && (s.iridescenceMap = this.iridescenceMap.toJSON(e).uuid), this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture && (s.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(e).uuid), this.anisotropy !== void 0 && (s.anisotropy = this.anisotropy), this.anisotropyRotation !== void 0 && (s.anisotropyRotation = this.anisotropyRotation), this.anisotropyMap && this.anisotropyMap.isTexture && (s.anisotropyMap = this.anisotropyMap.toJSON(e).uuid), this.map && this.map.isTexture && (s.map = this.map.toJSON(e).uuid), this.matcap && this.matcap.isTexture && (s.matcap = this.matcap.toJSON(e).uuid), this.alphaMap && this.alphaMap.isTexture && (s.alphaMap = this.alphaMap.toJSON(e).uuid), this.lightMap && this.lightMap.isTexture && (s.lightMap = this.lightMap.toJSON(e).uuid, s.lightMapIntensity = this.lightMapIntensity), this.aoMap && this.aoMap.isTexture && (s.aoMap = this.aoMap.toJSON(e).uuid, s.aoMapIntensity = this.aoMapIntensity), this.bumpMap && this.bumpMap.isTexture && (s.bumpMap = this.bumpMap.toJSON(e).uuid, s.bumpScale = this.bumpScale), this.normalMap && this.normalMap.isTexture && (s.normalMap = this.normalMap.toJSON(e).uuid, s.normalMapType = this.normalMapType, s.normalScale = this.normalScale.toArray()), this.displacementMap && this.displacementMap.isTexture && (s.displacementMap = this.displacementMap.toJSON(e).uuid, s.displacementScale = this.displacementScale, s.displacementBias = this.displacementBias), this.roughnessMap && this.roughnessMap.isTexture && (s.roughnessMap = this.roughnessMap.toJSON(e).uuid), this.metalnessMap && this.metalnessMap.isTexture && (s.metalnessMap = this.metalnessMap.toJSON(e).uuid), this.emissiveMap && this.emissiveMap.isTexture && (s.emissiveMap = this.emissiveMap.toJSON(e).uuid), this.specularMap && this.specularMap.isTexture && (s.specularMap = this.specularMap.toJSON(e).uuid), this.specularIntensityMap && this.specularIntensityMap.isTexture && (s.specularIntensityMap = this.specularIntensityMap.toJSON(e).uuid), this.specularColorMap && this.specularColorMap.isTexture && (s.specularColorMap = this.specularColorMap.toJSON(e).uuid), this.envMap && this.envMap.isTexture && (s.envMap = this.envMap.toJSON(e).uuid, this.combine !== void 0 && (s.combine = this.combine)), this.envMapRotation !== void 0 && (s.envMapRotation = this.envMapRotation.toArray()), this.envMapIntensity !== void 0 && (s.envMapIntensity = this.envMapIntensity), this.reflectivity !== void 0 && (s.reflectivity = this.reflectivity), this.refractionRatio !== void 0 && (s.refractionRatio = this.refractionRatio), this.gradientMap && this.gradientMap.isTexture && (s.gradientMap = this.gradientMap.toJSON(e).uuid), this.transmission !== void 0 && (s.transmission = this.transmission), this.transmissionMap && this.transmissionMap.isTexture && (s.transmissionMap = this.transmissionMap.toJSON(e).uuid), this.thickness !== void 0 && (s.thickness = this.thickness), this.thicknessMap && this.thicknessMap.isTexture && (s.thicknessMap = this.thicknessMap.toJSON(e).uuid), this.attenuationDistance !== void 0 && this.attenuationDistance !== 1 / 0 && (s.attenuationDistance = this.attenuationDistance), this.attenuationColor !== void 0 && (s.attenuationColor = this.attenuationColor.getHex()), this.size !== void 0 && (s.size = this.size), this.shadowSide !== null && (s.shadowSide = this.shadowSide), this.sizeAttenuation !== void 0 && (s.sizeAttenuation = this.sizeAttenuation), this.blending !== co && (s.blending = this.blending), this.side !== ho && (s.side = this.side), this.vertexColors === !0 && (s.vertexColors = !0), this.opacity < 1 && (s.opacity = this.opacity), this.transparent === !0 && (s.transparent = !0), this.blendSrc !== mo && (s.blendSrc = this.blendSrc), this.blendDst !== go && (s.blendDst = this.blendDst), this.blendEquation !== po && (s.blendEquation = this.blendEquation), this.blendSrcAlpha !== null && (s.blendSrcAlpha = this.blendSrcAlpha), this.blendDstAlpha !== null && (s.blendDstAlpha = this.blendDstAlpha), this.blendEquationAlpha !== null && (s.blendEquationAlpha = this.blendEquationAlpha), this.blendColor && this.blendColor.isColor && (s.blendColor = this.blendColor.getHex()), this.blendAlpha !== 0 && (s.blendAlpha = this.blendAlpha), this.depthFunc !== mu && (s.depthFunc = this.depthFunc), this.depthTest === !1 && (s.depthTest = this.depthTest), this.depthWrite === !1 && (s.depthWrite = this.depthWrite), this.colorWrite === !1 && (s.colorWrite = this.colorWrite), this.stencilWriteMask !== 255 && (s.stencilWriteMask = this.stencilWriteMask), this.stencilFunc !== xu && (s.stencilFunc = this.stencilFunc), this.stencilRef !== 0 && (s.stencilRef = this.stencilRef), this.stencilFuncMask !== 255 && (s.stencilFuncMask = this.stencilFuncMask), this.stencilFail !== mr && (s.stencilFail = this.stencilFail), this.stencilZFail !== mr && (s.stencilZFail = this.stencilZFail), this.stencilZPass !== mr && (s.stencilZPass = this.stencilZPass), this.stencilWrite === !0 && (s.stencilWrite = this.stencilWrite), this.rotation !== void 0 && this.rotation !== 0 && (s.rotation = this.rotation), this.polygonOffset === !0 && (s.polygonOffset = !0), this.polygonOffsetFactor !== 0 && (s.polygonOffsetFactor = this.polygonOffsetFactor), this.polygonOffsetUnits !== 0 && (s.polygonOffsetUnits = this.polygonOffsetUnits), this.linewidth !== void 0 && this.linewidth !== 1 && (s.linewidth = this.linewidth), this.dashSize !== void 0 && (s.dashSize = this.dashSize), this.gapSize !== void 0 && (s.gapSize = this.gapSize), this.scale !== void 0 && (s.scale = this.scale), this.dithering === !0 && (s.dithering = !0), this.alphaTest > 0 && (s.alphaTest = this.alphaTest), this.alphaHash === !0 && (s.alphaHash = !0), this.alphaToCoverage === !0 && (s.alphaToCoverage = !0), this.premultipliedAlpha === !0 && (s.premultipliedAlpha = !0), this.forceSinglePass === !0 && (s.forceSinglePass = !0), this.allowOverride === !1 && (s.allowOverride = !1), this.wireframe === !0 && (s.wireframe = !0), this.wireframeLinewidth > 1 && (s.wireframeLinewidth = this.wireframeLinewidth), this.wireframeLinecap !== "round" && (s.wireframeLinecap = this.wireframeLinecap), this.wireframeLinejoin !== "round" && (s.wireframeLinejoin = this.wireframeLinejoin), this.flatShading === !0 && (s.flatShading = !0), this.visible === !1 && (s.visible = !1), this.toneMapped === !1 && (s.toneMapped = !1), this.fog === !1 && (s.fog = !1), Object.keys(this.userData).length > 0 && (s.userData = this.userData);
    function i(a) {
      const n = [];
      for (const o in a) {
        const l = a[o];
        delete l.metadata, n.push(l);
      }
      return n;
    }
    if (t) {
      const a = i(e.textures), n = i(e.images);
      a.length > 0 && (s.textures = a), n.length > 0 && (s.images = n);
    }
    return s;
  }
  /**
   * Deserializes the material from the given JSON.
   *
   * @param {Object} json - The JSON holding the serialized material.
   * @param {Object<string,Texture>} textures - A dictionary holding textures referenced by the material.
   * @return {Material} A reference to this material.
   */
  fromJSON(e, t) {
    if (e.uuid !== void 0 && (this.uuid = e.uuid), e.name !== void 0 && (this.name = e.name), e.color !== void 0 && this.color !== void 0 && this.color.setHex(e.color), e.roughness !== void 0 && (this.roughness = e.roughness), e.metalness !== void 0 && (this.metalness = e.metalness), e.sheen !== void 0 && (this.sheen = e.sheen), e.sheenColor !== void 0 && (this.sheenColor = new Yt().setHex(e.sheenColor)), e.sheenRoughness !== void 0 && (this.sheenRoughness = e.sheenRoughness), e.emissive !== void 0 && this.emissive !== void 0 && this.emissive.setHex(e.emissive), e.specular !== void 0 && this.specular !== void 0 && this.specular.setHex(e.specular), e.specularIntensity !== void 0 && (this.specularIntensity = e.specularIntensity), e.specularColor !== void 0 && this.specularColor !== void 0 && this.specularColor.setHex(e.specularColor), e.shininess !== void 0 && (this.shininess = e.shininess), e.clearcoat !== void 0 && (this.clearcoat = e.clearcoat), e.clearcoatRoughness !== void 0 && (this.clearcoatRoughness = e.clearcoatRoughness), e.dispersion !== void 0 && (this.dispersion = e.dispersion), e.iridescence !== void 0 && (this.iridescence = e.iridescence), e.iridescenceIOR !== void 0 && (this.iridescenceIOR = e.iridescenceIOR), e.iridescenceThicknessRange !== void 0 && (this.iridescenceThicknessRange = e.iridescenceThicknessRange), e.transmission !== void 0 && (this.transmission = e.transmission), e.thickness !== void 0 && (this.thickness = e.thickness), e.attenuationDistance !== void 0 && (this.attenuationDistance = e.attenuationDistance), e.attenuationColor !== void 0 && this.attenuationColor !== void 0 && this.attenuationColor.setHex(e.attenuationColor), e.anisotropy !== void 0 && (this.anisotropy = e.anisotropy), e.anisotropyRotation !== void 0 && (this.anisotropyRotation = e.anisotropyRotation), e.fog !== void 0 && (this.fog = e.fog), e.flatShading !== void 0 && (this.flatShading = e.flatShading), e.blending !== void 0 && (this.blending = e.blending), e.combine !== void 0 && (this.combine = e.combine), e.side !== void 0 && (this.side = e.side), e.shadowSide !== void 0 && (this.shadowSide = e.shadowSide), e.opacity !== void 0 && (this.opacity = e.opacity), e.transparent !== void 0 && (this.transparent = e.transparent), e.alphaTest !== void 0 && (this.alphaTest = e.alphaTest), e.alphaHash !== void 0 && (this.alphaHash = e.alphaHash), e.depthFunc !== void 0 && (this.depthFunc = e.depthFunc), e.depthTest !== void 0 && (this.depthTest = e.depthTest), e.depthWrite !== void 0 && (this.depthWrite = e.depthWrite), e.colorWrite !== void 0 && (this.colorWrite = e.colorWrite), e.blendSrc !== void 0 && (this.blendSrc = e.blendSrc), e.blendDst !== void 0 && (this.blendDst = e.blendDst), e.blendEquation !== void 0 && (this.blendEquation = e.blendEquation), e.blendSrcAlpha !== void 0 && (this.blendSrcAlpha = e.blendSrcAlpha), e.blendDstAlpha !== void 0 && (this.blendDstAlpha = e.blendDstAlpha), e.blendEquationAlpha !== void 0 && (this.blendEquationAlpha = e.blendEquationAlpha), e.blendColor !== void 0 && this.blendColor !== void 0 && this.blendColor.setHex(e.blendColor), e.blendAlpha !== void 0 && (this.blendAlpha = e.blendAlpha), e.stencilWriteMask !== void 0 && (this.stencilWriteMask = e.stencilWriteMask), e.stencilFunc !== void 0 && (this.stencilFunc = e.stencilFunc), e.stencilRef !== void 0 && (this.stencilRef = e.stencilRef), e.stencilFuncMask !== void 0 && (this.stencilFuncMask = e.stencilFuncMask), e.stencilFail !== void 0 && (this.stencilFail = e.stencilFail), e.stencilZFail !== void 0 && (this.stencilZFail = e.stencilZFail), e.stencilZPass !== void 0 && (this.stencilZPass = e.stencilZPass), e.stencilWrite !== void 0 && (this.stencilWrite = e.stencilWrite), e.wireframe !== void 0 && (this.wireframe = e.wireframe), e.wireframeLinewidth !== void 0 && (this.wireframeLinewidth = e.wireframeLinewidth), e.wireframeLinecap !== void 0 && (this.wireframeLinecap = e.wireframeLinecap), e.wireframeLinejoin !== void 0 && (this.wireframeLinejoin = e.wireframeLinejoin), e.rotation !== void 0 && (this.rotation = e.rotation), e.linewidth !== void 0 && (this.linewidth = e.linewidth), e.dashSize !== void 0 && (this.dashSize = e.dashSize), e.gapSize !== void 0 && (this.gapSize = e.gapSize), e.scale !== void 0 && (this.scale = e.scale), e.polygonOffset !== void 0 && (this.polygonOffset = e.polygonOffset), e.polygonOffsetFactor !== void 0 && (this.polygonOffsetFactor = e.polygonOffsetFactor), e.polygonOffsetUnits !== void 0 && (this.polygonOffsetUnits = e.polygonOffsetUnits), e.dithering !== void 0 && (this.dithering = e.dithering), e.alphaToCoverage !== void 0 && (this.alphaToCoverage = e.alphaToCoverage), e.premultipliedAlpha !== void 0 && (this.premultipliedAlpha = e.premultipliedAlpha), e.forceSinglePass !== void 0 && (this.forceSinglePass = e.forceSinglePass), e.allowOverride !== void 0 && (this.allowOverride = e.allowOverride), e.visible !== void 0 && (this.visible = e.visible), e.toneMapped !== void 0 && (this.toneMapped = e.toneMapped), e.userData !== void 0 && (this.userData = e.userData), e.vertexColors !== void 0 && (typeof e.vertexColors == "number" ? this.vertexColors = e.vertexColors > 0 : this.vertexColors = e.vertexColors), e.size !== void 0 && (this.size = e.size), e.sizeAttenuation !== void 0 && (this.sizeAttenuation = e.sizeAttenuation), e.map !== void 0 && (this.map = t[e.map] || null), e.matcap !== void 0 && (this.matcap = t[e.matcap] || null), e.alphaMap !== void 0 && (this.alphaMap = t[e.alphaMap] || null), e.bumpMap !== void 0 && (this.bumpMap = t[e.bumpMap] || null), e.bumpScale !== void 0 && (this.bumpScale = e.bumpScale), e.normalMap !== void 0 && (this.normalMap = t[e.normalMap] || null), e.normalMapType !== void 0 && (this.normalMapType = e.normalMapType), e.normalScale !== void 0) {
      let s = e.normalScale;
      Array.isArray(s) === !1 && (s = [s, s]), this.normalScale = new _e().fromArray(s);
    }
    return e.displacementMap !== void 0 && (this.displacementMap = t[e.displacementMap] || null), e.displacementScale !== void 0 && (this.displacementScale = e.displacementScale), e.displacementBias !== void 0 && (this.displacementBias = e.displacementBias), e.roughnessMap !== void 0 && (this.roughnessMap = t[e.roughnessMap] || null), e.metalnessMap !== void 0 && (this.metalnessMap = t[e.metalnessMap] || null), e.emissiveMap !== void 0 && (this.emissiveMap = t[e.emissiveMap] || null), e.emissiveIntensity !== void 0 && (this.emissiveIntensity = e.emissiveIntensity), e.specularMap !== void 0 && (this.specularMap = t[e.specularMap] || null), e.specularIntensityMap !== void 0 && (this.specularIntensityMap = t[e.specularIntensityMap] || null), e.specularColorMap !== void 0 && (this.specularColorMap = t[e.specularColorMap] || null), e.envMap !== void 0 && (this.envMap = t[e.envMap] || null), e.envMapRotation !== void 0 && this.envMapRotation.fromArray(e.envMapRotation), e.envMapIntensity !== void 0 && (this.envMapIntensity = e.envMapIntensity), e.reflectivity !== void 0 && (this.reflectivity = e.reflectivity), e.refractionRatio !== void 0 && (this.refractionRatio = e.refractionRatio), e.lightMap !== void 0 && (this.lightMap = t[e.lightMap] || null), e.lightMapIntensity !== void 0 && (this.lightMapIntensity = e.lightMapIntensity), e.aoMap !== void 0 && (this.aoMap = t[e.aoMap] || null), e.aoMapIntensity !== void 0 && (this.aoMapIntensity = e.aoMapIntensity), e.gradientMap !== void 0 && (this.gradientMap = t[e.gradientMap] || null), e.clearcoatMap !== void 0 && (this.clearcoatMap = t[e.clearcoatMap] || null), e.clearcoatRoughnessMap !== void 0 && (this.clearcoatRoughnessMap = t[e.clearcoatRoughnessMap] || null), e.clearcoatNormalMap !== void 0 && (this.clearcoatNormalMap = t[e.clearcoatNormalMap] || null), e.clearcoatNormalScale !== void 0 && (this.clearcoatNormalScale = new _e().fromArray(e.clearcoatNormalScale)), e.iridescenceMap !== void 0 && (this.iridescenceMap = t[e.iridescenceMap] || null), e.iridescenceThicknessMap !== void 0 && (this.iridescenceThicknessMap = t[e.iridescenceThicknessMap] || null), e.transmissionMap !== void 0 && (this.transmissionMap = t[e.transmissionMap] || null), e.thicknessMap !== void 0 && (this.thicknessMap = t[e.thicknessMap] || null), e.anisotropyMap !== void 0 && (this.anisotropyMap = t[e.anisotropyMap] || null), e.sheenColorMap !== void 0 && (this.sheenColorMap = t[e.sheenColorMap] || null), e.sheenRoughnessMap !== void 0 && (this.sheenRoughnessMap = t[e.sheenRoughnessMap] || null), this;
  }
  /**
   * Returns a new material with copied values from this instance.
   *
   * @return {Material} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
  /**
   * Copies the values of the given material to this instance.
   *
   * @param {Material} source - The material to copy.
   * @return {Material} A reference to this instance.
   */
  copy(e) {
    this.name = e.name, this.blending = e.blending, this.side = e.side, this.vertexColors = e.vertexColors, this.opacity = e.opacity, this.transparent = e.transparent, this.blendSrc = e.blendSrc, this.blendDst = e.blendDst, this.blendEquation = e.blendEquation, this.blendSrcAlpha = e.blendSrcAlpha, this.blendDstAlpha = e.blendDstAlpha, this.blendEquationAlpha = e.blendEquationAlpha, this.blendColor.copy(e.blendColor), this.blendAlpha = e.blendAlpha, this.depthFunc = e.depthFunc, this.depthTest = e.depthTest, this.depthWrite = e.depthWrite, this.stencilWriteMask = e.stencilWriteMask, this.stencilFunc = e.stencilFunc, this.stencilRef = e.stencilRef, this.stencilFuncMask = e.stencilFuncMask, this.stencilFail = e.stencilFail, this.stencilZFail = e.stencilZFail, this.stencilZPass = e.stencilZPass, this.stencilWrite = e.stencilWrite;
    const t = e.clippingPlanes;
    let s = null;
    if (t !== null) {
      const i = t.length;
      s = new Array(i);
      for (let a = 0; a !== i; ++a)
        s[a] = t[a].clone();
    }
    return this.clippingPlanes = s, this.clipIntersection = e.clipIntersection, this.clipShadows = e.clipShadows, this.shadowSide = e.shadowSide, this.colorWrite = e.colorWrite, this.precision = e.precision, this.polygonOffset = e.polygonOffset, this.polygonOffsetFactor = e.polygonOffsetFactor, this.polygonOffsetUnits = e.polygonOffsetUnits, this.dithering = e.dithering, this.alphaTest = e.alphaTest, this.alphaHash = e.alphaHash, this.alphaToCoverage = e.alphaToCoverage, this.premultipliedAlpha = e.premultipliedAlpha, this.forceSinglePass = e.forceSinglePass, this.allowOverride = e.allowOverride, this.visible = e.visible, this.toneMapped = e.toneMapped, this.userData = JSON.parse(JSON.stringify(e.userData)), this;
  }
  /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever this instance is no longer used in your app.
   *
   * @fires Material#dispose
   */
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
  /**
   * Setting this property to `true` indicates the engine the material
   * needs to be recompiled.
   *
   * @type {boolean}
   * @default false
   * @param {boolean} value
   */
  set needsUpdate(e) {
    e === !0 && this.version++;
  }
}
const os = /* @__PURE__ */ new M(), In = /* @__PURE__ */ new M(), Ui = /* @__PURE__ */ new M(), Ns = /* @__PURE__ */ new M(), On = /* @__PURE__ */ new M(), ki = /* @__PURE__ */ new M(), Pn = /* @__PURE__ */ new M();
class uf {
  /**
   * Constructs a new ray.
   *
   * @param {Vector3} [origin=(0,0,0)] - The origin of the ray.
   * @param {Vector3} [direction=(0,0,-1)] - The (normalized) direction of the ray.
   */
  constructor(e = new M(), t = new M(0, 0, -1)) {
    this.origin = e, this.direction = t;
  }
  /**
   * Sets the ray's components by copying the given values.
   *
   * @param {Vector3} origin - The origin.
   * @param {Vector3} direction - The direction.
   * @return {Ray} A reference to this ray.
   */
  set(e, t) {
    return this.origin.copy(e), this.direction.copy(t), this;
  }
  /**
   * Copies the values of the given ray to this instance.
   *
   * @param {Ray} ray - The ray to copy.
   * @return {Ray} A reference to this ray.
   */
  copy(e) {
    return this.origin.copy(e.origin), this.direction.copy(e.direction), this;
  }
  /**
   * Returns a vector that is located at a given distance along this ray.
   *
   * @param {number} t - The distance along the ray to retrieve a position for.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} A position on the ray.
   */
  at(e, t) {
    return t.copy(this.origin).addScaledVector(this.direction, e);
  }
  /**
   * Adjusts the direction of the ray to point at the given vector in world space.
   *
   * @param {Vector3} v - The target position.
   * @return {Ray} A reference to this ray.
   */
  lookAt(e) {
    return this.direction.copy(e).sub(this.origin).normalize(), this;
  }
  /**
   * Shift the origin of this ray along its direction by the given distance.
   *
   * @param {number} t - The distance along the ray to interpolate.
   * @return {Ray} A reference to this ray.
   */
  recast(e) {
    return this.origin.copy(this.at(e, os)), this;
  }
  /**
   * Returns the point along this ray that is closest to the given point.
   *
   * @param {Vector3} point - A point in 3D space to get the closet location on the ray for.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The closest point on this ray.
   */
  closestPointToPoint(e, t) {
    t.subVectors(e, this.origin);
    const s = t.dot(this.direction);
    return s < 0 ? t.copy(this.origin) : t.copy(this.origin).addScaledVector(this.direction, s);
  }
  /**
   * Returns the distance of the closest approach between this ray and the given point.
   *
   * @param {Vector3} point - A point in 3D space to compute the distance to.
   * @return {number} The distance.
   */
  distanceToPoint(e) {
    return Math.sqrt(this.distanceSqToPoint(e));
  }
  /**
   * Returns the squared distance of the closest approach between this ray and the given point.
   *
   * @param {Vector3} point - A point in 3D space to compute the distance to.
   * @return {number} The squared distance.
   */
  distanceSqToPoint(e) {
    const t = os.subVectors(e, this.origin).dot(this.direction);
    return t < 0 ? this.origin.distanceToSquared(e) : (os.copy(this.origin).addScaledVector(this.direction, t), os.distanceToSquared(e));
  }
  /**
   * Returns the squared distance between this ray and the given line segment.
   *
   * @param {Vector3} v0 - The start point of the line segment.
   * @param {Vector3} v1 - The end point of the line segment.
   * @param {Vector3} [optionalPointOnRay] - When provided, it receives the point on this ray that is closest to the segment.
   * @param {Vector3} [optionalPointOnSegment] - When provided, it receives the point on the line segment that is closest to this ray.
   * @return {number} The squared distance.
   */
  distanceSqToSegment(e, t, s, i) {
    In.copy(e).add(t).multiplyScalar(0.5), Ui.copy(t).sub(e).normalize(), Ns.copy(this.origin).sub(In);
    const a = e.distanceTo(t) * 0.5, n = -this.direction.dot(Ui), o = Ns.dot(this.direction), l = -Ns.dot(Ui), u = Ns.lengthSq(), h = Math.abs(1 - n * n);
    let d, p, m, g;
    if (h > 0)
      if (d = n * l - o, p = n * o - l, g = a * h, d >= 0)
        if (p >= -g)
          if (p <= g) {
            const y = 1 / h;
            d *= y, p *= y, m = d * (d + n * p + 2 * o) + p * (n * d + p + 2 * l) + u;
          } else
            p = a, d = Math.max(0, -(n * p + o)), m = -d * d + p * (p + 2 * l) + u;
        else
          p = -a, d = Math.max(0, -(n * p + o)), m = -d * d + p * (p + 2 * l) + u;
      else
        p <= -g ? (d = Math.max(0, -(-n * a + o)), p = d > 0 ? -a : Math.min(Math.max(-a, -l), a), m = -d * d + p * (p + 2 * l) + u) : p <= g ? (d = 0, p = Math.min(Math.max(-a, -l), a), m = p * (p + 2 * l) + u) : (d = Math.max(0, -(n * a + o)), p = d > 0 ? a : Math.min(Math.max(-a, -l), a), m = -d * d + p * (p + 2 * l) + u);
    else
      p = n > 0 ? -a : a, d = Math.max(0, -(n * p + o)), m = -d * d + p * (p + 2 * l) + u;
    return s && s.copy(this.origin).addScaledVector(this.direction, d), i && i.copy(In).addScaledVector(Ui, p), m;
  }
  /**
   * Intersects this ray with the given sphere, returning the intersection
   * point or `null` if there is no intersection.
   *
   * @param {Sphere} sphere - The sphere to intersect.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The intersection point.
   */
  intersectSphere(e, t) {
    os.subVectors(e.center, this.origin);
    const s = os.dot(this.direction), i = os.dot(os) - s * s, a = e.radius * e.radius;
    if (i > a) return null;
    const n = Math.sqrt(a - i), o = s - n, l = s + n;
    return l < 0 ? null : o < 0 ? this.at(l, t) : this.at(o, t);
  }
  /**
   * Returns `true` if this ray intersects with the given sphere.
   *
   * @param {Sphere} sphere - The sphere to intersect.
   * @return {boolean} Whether this ray intersects with the given sphere or not.
   */
  intersectsSphere(e) {
    return e.radius < 0 ? !1 : this.distanceSqToPoint(e.center) <= e.radius * e.radius;
  }
  /**
   * Computes the distance from the ray's origin to the given plane. Returns `null` if the ray
   * does not intersect with the plane.
   *
   * @param {Plane} plane - The plane to compute the distance to.
   * @return {?number} Whether this ray intersects with the given sphere or not.
   */
  distanceToPlane(e) {
    const t = e.normal.dot(this.direction);
    if (t === 0)
      return e.distanceToPoint(this.origin) === 0 ? 0 : null;
    const s = -(this.origin.dot(e.normal) + e.constant) / t;
    return s >= 0 ? s : null;
  }
  /**
   * Intersects this ray with the given plane, returning the intersection
   * point or `null` if there is no intersection.
   *
   * @param {Plane} plane - The plane to intersect.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The intersection point.
   */
  intersectPlane(e, t) {
    const s = this.distanceToPlane(e);
    return s === null ? null : this.at(s, t);
  }
  /**
   * Returns `true` if this ray intersects with the given plane.
   *
   * @param {Plane} plane - The plane to intersect.
   * @return {boolean} Whether this ray intersects with the given plane or not.
   */
  intersectsPlane(e) {
    const t = e.distanceToPoint(this.origin);
    return t === 0 || e.normal.dot(this.direction) * t < 0;
  }
  /**
   * Intersects this ray with the given bounding box, returning the intersection
   * point or `null` if there is no intersection.
   *
   * @param {Box3} box - The box to intersect.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The intersection point.
   */
  intersectBox(e, t) {
    let s, i, a, n, o, l;
    const u = 1 / this.direction.x, h = 1 / this.direction.y, d = 1 / this.direction.z, p = this.origin;
    return u >= 0 ? (s = (e.min.x - p.x) * u, i = (e.max.x - p.x) * u) : (s = (e.max.x - p.x) * u, i = (e.min.x - p.x) * u), h >= 0 ? (a = (e.min.y - p.y) * h, n = (e.max.y - p.y) * h) : (a = (e.max.y - p.y) * h, n = (e.min.y - p.y) * h), s > n || a > i || ((a > s || isNaN(s)) && (s = a), (n < i || isNaN(i)) && (i = n), d >= 0 ? (o = (e.min.z - p.z) * d, l = (e.max.z - p.z) * d) : (o = (e.max.z - p.z) * d, l = (e.min.z - p.z) * d), s > l || o > i) || ((o > s || s !== s) && (s = o), (l < i || i !== i) && (i = l), i < 0) ? null : this.at(s >= 0 ? s : i, t);
  }
  /**
   * Returns `true` if this ray intersects with the given box.
   *
   * @param {Box3} box - The box to intersect.
   * @return {boolean} Whether this ray intersects with the given box or not.
   */
  intersectsBox(e) {
    return this.intersectBox(e, os) !== null;
  }
  /**
   * Intersects this ray with the given triangle, returning the intersection
   * point or `null` if there is no intersection.
   *
   * @param {Vector3} a - The first vertex of the triangle.
   * @param {Vector3} b - The second vertex of the triangle.
   * @param {Vector3} c - The third vertex of the triangle.
   * @param {boolean} backfaceCulling - Whether to use backface culling or not.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The intersection point.
   */
  intersectTriangle(e, t, s, i, a) {
    On.subVectors(t, e), ki.subVectors(s, e), Pn.crossVectors(On, ki);
    let n = this.direction.dot(Pn), o;
    if (n > 0) {
      if (i) return null;
      o = 1;
    } else if (n < 0)
      o = -1, n = -n;
    else
      return null;
    Ns.subVectors(this.origin, e);
    const l = o * this.direction.dot(ki.crossVectors(Ns, ki));
    if (l < 0)
      return null;
    const u = o * this.direction.dot(On.cross(Ns));
    if (u < 0 || l + u > n)
      return null;
    const h = -o * Ns.dot(Pn);
    return h < 0 ? null : this.at(h / n, a);
  }
  /**
   * Transforms this ray with the given 4x4 transformation matrix.
   *
   * @param {Matrix4} matrix4 - The transformation matrix.
   * @return {Ray} A reference to this ray.
   */
  applyMatrix4(e) {
    return this.origin.applyMatrix4(e), this.direction.transformDirection(e), this;
  }
  /**
   * Returns `true` if this ray is equal with the given one.
   *
   * @param {Ray} ray - The ray to test for equality.
   * @return {boolean} Whether this ray is equal with the given one.
   */
  equals(e) {
    return e.origin.equals(this.origin) && e.direction.equals(this.direction);
  }
  /**
   * Returns a new ray with copied values from this instance.
   *
   * @return {Ray} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
}
class Gh extends vo {
  /**
   * Constructs a new mesh basic material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */
  constructor(e) {
    super(), this.isMeshBasicMaterial = !0, this.type = "MeshBasicMaterial", this.color = new Yt(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.envMapRotation = new wi(), this.combine = yg, this.reflectivity = 1, this.refractionRatio = 0.98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.fog = !0, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.color.copy(e.color), this.map = e.map, this.lightMap = e.lightMap, this.lightMapIntensity = e.lightMapIntensity, this.aoMap = e.aoMap, this.aoMapIntensity = e.aoMapIntensity, this.specularMap = e.specularMap, this.alphaMap = e.alphaMap, this.envMap = e.envMap, this.envMapRotation.copy(e.envMapRotation), this.combine = e.combine, this.reflectivity = e.reflectivity, this.refractionRatio = e.refractionRatio, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.wireframeLinecap = e.wireframeLinecap, this.wireframeLinejoin = e.wireframeLinejoin, this.fog = e.fog, this;
  }
}
const Iu = /* @__PURE__ */ new de(), qs = /* @__PURE__ */ new uf(), Di = /* @__PURE__ */ new Xo(), Ou = /* @__PURE__ */ new M(), Wi = /* @__PURE__ */ new M(), qi = /* @__PURE__ */ new M(), ji = /* @__PURE__ */ new M(), Fn = /* @__PURE__ */ new M(), Gi = /* @__PURE__ */ new M(), Pu = /* @__PURE__ */ new M(), Hi = /* @__PURE__ */ new M();
class Sa extends Pt {
  /**
   * Constructs a new mesh.
   *
   * @param {BufferGeometry} [geometry] - The mesh geometry.
   * @param {Material|Array<Material>} [material] - The mesh material.
   */
  constructor(e = new ar(), t = new Gh()) {
    super(), this.isMesh = !0, this.type = "Mesh", this.geometry = e, this.material = t, this.morphTargetDictionary = void 0, this.morphTargetInfluences = void 0, this.count = 1, this.updateMorphTargets();
  }
  copy(e, t) {
    return super.copy(e, t), e.morphTargetInfluences !== void 0 && (this.morphTargetInfluences = e.morphTargetInfluences.slice()), e.morphTargetDictionary !== void 0 && (this.morphTargetDictionary = Object.assign({}, e.morphTargetDictionary)), this.material = Array.isArray(e.material) ? e.material.slice() : e.material, this.geometry = e.geometry, this;
  }
  /**
   * Sets the values of {@link Mesh#morphTargetDictionary} and {@link Mesh#morphTargetInfluences}
   * to make sure existing morph targets can influence this 3D object.
   */
  updateMorphTargets() {
    const e = this.geometry.morphAttributes, t = Object.keys(e);
    if (t.length > 0) {
      const s = e[t[0]];
      if (s !== void 0) {
        this.morphTargetInfluences = [], this.morphTargetDictionary = {};
        for (let i = 0, a = s.length; i < a; i++) {
          const n = s[i].name || String(i);
          this.morphTargetInfluences.push(0), this.morphTargetDictionary[n] = i;
        }
      }
    }
  }
  /**
   * Returns the local-space position of the vertex at the given index, taking into
   * account the current animation state of both morph targets and skinning.
   *
   * @param {number} index - The vertex index.
   * @param {Vector3} target - The target object that is used to store the method's result.
   * @return {Vector3} The vertex position in local space.
   */
  getVertexPosition(e, t) {
    const s = this.geometry, i = s.attributes.position, a = s.morphAttributes.position, n = s.morphTargetsRelative;
    t.fromBufferAttribute(i, e);
    const o = this.morphTargetInfluences;
    if (a && o) {
      Gi.set(0, 0, 0);
      for (let l = 0, u = a.length; l < u; l++) {
        const h = o[l], d = a[l];
        h !== 0 && (Fn.fromBufferAttribute(d, e), n ? Gi.addScaledVector(Fn, h) : Gi.addScaledVector(Fn.sub(t), h));
      }
      t.add(Gi);
    }
    return t;
  }
  /**
   * Computes intersection points between a casted ray and this line.
   *
   * @param {Raycaster} raycaster - The raycaster.
   * @param {Array<Object>} intersects - The target array that holds the intersection points.
   */
  raycast(e, t) {
    const s = this.geometry, i = this.material, a = this.matrixWorld;
    i !== void 0 && (s.boundingSphere === null && s.computeBoundingSphere(), Di.copy(s.boundingSphere), Di.applyMatrix4(a), qs.copy(e.ray).recast(e.near), !(Di.containsPoint(qs.origin) === !1 && (qs.intersectSphere(Di, Ou) === null || qs.origin.distanceToSquared(Ou) > (e.far - e.near) ** 2)) && (Iu.copy(a).invert(), qs.copy(e.ray).applyMatrix4(Iu), !(s.boundingBox !== null && qs.intersectsBox(s.boundingBox) === !1) && this._computeIntersections(e, t, qs)));
  }
  _computeIntersections(e, t, s) {
    let i;
    const a = this.geometry, n = this.material, o = a.index, l = a.attributes.position, u = a.attributes.uv, h = a.attributes.uv1, d = a.attributes.normal, p = a.groups, m = a.drawRange;
    if (o !== null)
      if (Array.isArray(n))
        for (let g = 0, y = p.length; g < y; g++) {
          const v = p[g], w = n[v.materialIndex], _ = Math.max(v.start, m.start), C = Math.min(o.count, Math.min(v.start + v.count, m.start + m.count));
          for (let V = _, P = C; V < P; V += 3) {
            const z = o.getX(V), R = o.getX(V + 1), I = o.getX(V + 2);
            i = Xi(this, w, e, s, u, h, d, z, R, I), i && (i.faceIndex = Math.floor(V / 3), i.face.materialIndex = v.materialIndex, t.push(i));
          }
        }
      else {
        const g = Math.max(0, m.start), y = Math.min(o.count, m.start + m.count);
        for (let v = g, w = y; v < w; v += 3) {
          const _ = o.getX(v), C = o.getX(v + 1), V = o.getX(v + 2);
          i = Xi(this, n, e, s, u, h, d, _, C, V), i && (i.faceIndex = Math.floor(v / 3), t.push(i));
        }
      }
    else if (l !== void 0)
      if (Array.isArray(n))
        for (let g = 0, y = p.length; g < y; g++) {
          const v = p[g], w = n[v.materialIndex], _ = Math.max(v.start, m.start), C = Math.min(l.count, Math.min(v.start + v.count, m.start + m.count));
          for (let V = _, P = C; V < P; V += 3) {
            const z = V, R = V + 1, I = V + 2;
            i = Xi(this, w, e, s, u, h, d, z, R, I), i && (i.faceIndex = Math.floor(V / 3), i.face.materialIndex = v.materialIndex, t.push(i));
          }
        }
      else {
        const g = Math.max(0, m.start), y = Math.min(l.count, m.start + m.count);
        for (let v = g, w = y; v < w; v += 3) {
          const _ = v, C = v + 1, V = v + 2;
          i = Xi(this, n, e, s, u, h, d, _, C, V), i && (i.faceIndex = Math.floor(v / 3), t.push(i));
        }
      }
  }
}
function hf(r, e, t, s, i, a, n, o) {
  let l;
  if (e.side === vi ? l = s.intersectTriangle(n, a, i, !0, o) : l = s.intersectTriangle(i, a, n, e.side === ho, o), l === null) return null;
  Hi.copy(o), Hi.applyMatrix4(r.matrixWorld);
  const u = t.ray.origin.distanceTo(Hi);
  return u < t.near || u > t.far ? null : {
    distance: u,
    point: Hi.clone(),
    object: r
  };
}
function Xi(r, e, t, s, i, a, n, o, l, u) {
  r.getVertexPosition(o, Wi), r.getVertexPosition(l, qi), r.getVertexPosition(u, ji);
  const h = hf(r, e, t, s, Wi, qi, ji, Pu);
  if (h) {
    const d = new M();
    Lt.getBarycoord(Pu, Wi, qi, ji, d), i && (h.uv = Lt.getInterpolatedAttribute(i, o, l, u, d, new _e())), a && (h.uv1 = Lt.getInterpolatedAttribute(a, o, l, u, d, new _e())), n && (h.normal = Lt.getInterpolatedAttribute(n, o, l, u, d, new M()), h.normal.dot(s.direction) > 0 && h.normal.multiplyScalar(-1));
    const p = {
      a: o,
      b: l,
      c: u,
      normal: new M(),
      materialIndex: 0
    };
    Lt.getNormal(Wi, qi, ji, p.normal), h.face = p, h.barycoord = d;
  }
  return h;
}
class cf extends Ke {
  /**
   * Constructs a new data texture.
   *
   * @param {?TypedArray} [data=null] - The buffer data.
   * @param {number} [width=1] - The width of the texture.
   * @param {number} [height=1] - The height of the texture.
   * @param {number} [format=RGBAFormat] - The texture format.
   * @param {number} [type=UnsignedByteType] - The texture type.
   * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
   * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
   * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
   * @param {number} [magFilter=NearestFilter] - The mag filter value.
   * @param {number} [minFilter=NearestFilter] - The min filter value.
   * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
   * @param {string} [colorSpace=NoColorSpace] - The color space.
   */
  constructor(e = null, t = 1, s = 1, i, a, n, o, l, u = at, h = at, d, p) {
    super(null, n, o, l, u, h, i, a, d, p), this.isDataTexture = !0, this.image = { data: e, width: t, height: s }, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
  }
}
class Or extends wt {
  /**
   * Constructs a new instanced buffer attribute.
   *
   * @param {TypedArray} array - The array holding the attribute data.
   * @param {number} itemSize - The item size.
   * @param {boolean} [normalized=false] - Whether the data are normalized or not.
   * @param {number} [meshPerAttribute=1] - How often a value of this buffer attribute should be repeated.
   */
  constructor(e, t, s, i = 1) {
    super(e, t, s), this.isInstancedBufferAttribute = !0, this.meshPerAttribute = i;
  }
  copy(e) {
    return super.copy(e), this.meshPerAttribute = e.meshPerAttribute, this;
  }
  toJSON() {
    const e = super.toJSON();
    return e.meshPerAttribute = this.meshPerAttribute, e.isInstancedBufferAttribute = !0, e;
  }
}
const Bn = /* @__PURE__ */ new M(), df = /* @__PURE__ */ new M(), pf = /* @__PURE__ */ new Kt();
class mf {
  /**
   * Constructs a new plane.
   *
   * @param {Vector3} [normal=(1,0,0)] - A unit length vector defining the normal of the plane.
   * @param {number} [constant=0] - The signed distance from the origin to the plane.
   */
  constructor(e = new M(1, 0, 0), t = 0) {
    this.isPlane = !0, this.normal = e, this.constant = t;
  }
  /**
   * Sets the plane components by copying the given values.
   *
   * @param {Vector3} normal - The normal.
   * @param {number} constant - The constant.
   * @return {Plane} A reference to this plane.
   */
  set(e, t) {
    return this.normal.copy(e), this.constant = t, this;
  }
  /**
   * Sets the plane components by defining `x`, `y`, `z` as the
   * plane normal and `w` as the constant.
   *
   * @param {number} x - The value for the normal's x component.
   * @param {number} y - The value for the normal's y component.
   * @param {number} z - The value for the normal's z component.
   * @param {number} w - The constant value.
   * @return {Plane} A reference to this plane.
   */
  setComponents(e, t, s, i) {
    return this.normal.set(e, t, s), this.constant = i, this;
  }
  /**
   * Sets the plane from the given normal and coplanar point (that is a point
   * that lies onto the plane).
   *
   * @param {Vector3} normal - The normal.
   * @param {Vector3} point - A coplanar point.
   * @return {Plane} A reference to this plane.
   */
  setFromNormalAndCoplanarPoint(e, t) {
    return this.normal.copy(e), this.constant = -t.dot(this.normal), this;
  }
  /**
   * Sets the plane from three coplanar points. The winding order is
   * assumed to be counter-clockwise, and determines the direction of
   * the plane normal.
   *
   * @param {Vector3} a - The first coplanar point.
   * @param {Vector3} b - The second coplanar point.
   * @param {Vector3} c - The third coplanar point.
   * @return {Plane} A reference to this plane.
   */
  setFromCoplanarPoints(e, t, s) {
    const i = Bn.subVectors(s, t).cross(df.subVectors(e, t)).normalize();
    return this.setFromNormalAndCoplanarPoint(i, e), this;
  }
  /**
   * Copies the values of the given plane to this instance.
   *
   * @param {Plane} plane - The plane to copy.
   * @return {Plane} A reference to this plane.
   */
  copy(e) {
    return this.normal.copy(e.normal), this.constant = e.constant, this;
  }
  /**
   * Normalizes the plane normal and adjusts the constant accordingly.
   *
   * @return {Plane} A reference to this plane.
   */
  normalize() {
    const e = 1 / this.normal.length();
    return this.normal.multiplyScalar(e), this.constant *= e, this;
  }
  /**
   * Negates both the plane normal and the constant.
   *
   * @return {Plane} A reference to this plane.
   */
  negate() {
    return this.constant *= -1, this.normal.negate(), this;
  }
  /**
   * Returns the signed distance from the given point to this plane.
   *
   * @param {Vector3} point - The point to compute the distance for.
   * @return {number} The signed distance.
   */
  distanceToPoint(e) {
    return this.normal.dot(e) + this.constant;
  }
  /**
   * Returns the signed distance from the given sphere to this plane.
   *
   * @param {Sphere} sphere - The sphere to compute the distance for.
   * @return {number} The signed distance.
   */
  distanceToSphere(e) {
    return this.distanceToPoint(e.center) - e.radius;
  }
  /**
   * Projects a the given point onto the plane.
   *
   * @param {Vector3} point - The point to project.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The projected point on the plane.
   */
  projectPoint(e, t) {
    return t.copy(e).addScaledVector(this.normal, -this.distanceToPoint(e));
  }
  /**
   * Returns the intersection point of the passed line and the plane. Returns
   * `null` if the line does not intersect. Returns the line's starting point if
   * the line is coplanar with the plane.
   *
   * @param {Line3} line - The line to compute the intersection for.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @param {boolean} [clampToLine=true] - Whether to clamp the intersection to the line segment.
   * @return {?Vector3} The intersection point. Returns `null` if no intersection is detected.
   */
  intersectLine(e, t, s = !0) {
    const i = e.delta(Bn), a = this.normal.dot(i);
    if (a === 0)
      return this.distanceToPoint(e.start) === 0 ? t.copy(e.start) : null;
    const n = -(e.start.dot(this.normal) + this.constant) / a;
    return s === !0 && (n < 0 || n > 1) ? null : t.copy(e.start).addScaledVector(i, n);
  }
  /**
   * Returns `true` if the given line segment intersects with (passes through) the plane.
   *
   * @param {Line3} line - The line to test.
   * @return {boolean} Whether the given line segment intersects with the plane or not.
   */
  intersectsLine(e) {
    const t = this.distanceToPoint(e.start), s = this.distanceToPoint(e.end);
    return t < 0 && s > 0 || s < 0 && t > 0;
  }
  /**
   * Returns `true` if the given bounding box intersects with the plane.
   *
   * @param {Box3} box - The bounding box to test.
   * @return {boolean} Whether the given bounding box intersects with the plane or not.
   */
  intersectsBox(e) {
    return e.intersectsPlane(this);
  }
  /**
   * Returns `true` if the given bounding sphere intersects with the plane.
   *
   * @param {Sphere} sphere - The bounding sphere to test.
   * @return {boolean} Whether the given bounding sphere intersects with the plane or not.
   */
  intersectsSphere(e) {
    return e.intersectsPlane(this);
  }
  /**
   * Returns a coplanar vector to the plane, by calculating the
   * projection of the normal at the origin onto the plane.
   *
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The coplanar point.
   */
  coplanarPoint(e) {
    return e.copy(this.normal).multiplyScalar(-this.constant);
  }
  /**
   * Apply a 4x4 matrix to the plane. The matrix must be an affine, homogeneous transform.
   *
   * The optional normal matrix can be pre-computed like so:
   * ```js
   * const optionalNormalMatrix = new THREE.Matrix3().getNormalMatrix( matrix );
   * ```
   *
   * @param {Matrix4} matrix - The transformation matrix.
   * @param {Matrix4} [optionalNormalMatrix] - A pre-computed normal matrix.
   * @return {Plane} A reference to this plane.
   */
  applyMatrix4(e, t) {
    const s = t || pf.getNormalMatrix(e), i = this.coplanarPoint(Bn).applyMatrix4(e), a = this.normal.applyMatrix3(s).normalize();
    return this.constant = -i.dot(a), this;
  }
  /**
   * Translates the plane by the distance defined by the given offset vector.
   * Note that this only affects the plane constant and will not affect the normal vector.
   *
   * @param {Vector3} offset - The offset vector.
   * @return {Plane} A reference to this plane.
   */
  translate(e) {
    return this.constant -= e.dot(this.normal), this;
  }
  /**
   * Returns `true` if this plane is equal with the given one.
   *
   * @param {Plane} plane - The plane to test for equality.
   * @return {boolean} Whether this plane is equal with the given one.
   */
  equals(e) {
    return e.normal.equals(this.normal) && e.constant === this.constant;
  }
  /**
   * Returns a new plane with copied values from this instance.
   *
   * @return {Plane} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
}
class Hh extends Ke {
  /**
   * Constructs a new framebuffer texture.
   *
   * @param {number} [width] - The width of the texture.
   * @param {number} [height] - The height of the texture.
   */
  constructor(e, t) {
    super({ width: e, height: t }), this.isFramebufferTexture = !0, this.magFilter = at, this.minFilter = at, this.generateMipmaps = !1, this.needsUpdate = !0;
  }
}
class gf extends Ke {
  /**
   * Constructs a new cube texture.
   *
   * @param {Array<Image>} [images=[]] - An array holding a image for each side of a cube.
   * @param {number} [mapping=CubeReflectionMapping] - The texture mapping.
   * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
   * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
   * @param {number} [magFilter=LinearFilter] - The mag filter value.
   * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
   * @param {number} [format=RGBAFormat] - The texture format.
   * @param {number} [type=UnsignedByteType] - The texture type.
   * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
   * @param {string} [colorSpace=NoColorSpace] - The color space value.
   */
  constructor(e = [], t = yi, s, i, a, n, o, l, u, h) {
    super(e, t, s, i, a, n, o, l, u, h), this.isCubeTexture = !0, this.flipY = !1;
  }
  /**
   * Alias for {@link CubeTexture#image}.
   *
   * @type {Array<Image>}
   */
  get images() {
    return this.image;
  }
  set images(e) {
    this.image = e;
  }
}
class Hr extends Ke {
  /**
   * Constructs a new depth texture.
   *
   * @param {number} width - The width of the texture.
   * @param {number} height - The height of the texture.
   * @param {number} [type=UnsignedIntType] - The texture type.
   * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
   * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
   * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
   * @param {number} [magFilter=LinearFilter] - The mag filter value.
   * @param {number} [minFilter=LinearFilter] - The min filter value.
   * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
   * @param {number} [format=DepthFormat] - The texture format.
   * @param {number} [depth=1] - The depth of the texture.
   */
  constructor(e, t, s = Wo, i, a, n, o = at, l = at, u, h = xo, d = 1) {
    if (h !== xo && h !== Tg)
      throw new Error("THREE.DepthTexture: format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
    const p = { width: e, height: t, depth: d };
    super(p, i, a, n, o, l, h, s, u), this.isDepthTexture = !0, this.flipY = !1, this.generateMipmaps = !1, this.compareFunction = null;
  }
  copy(e) {
    return super.copy(e), this.source = new Ho(Object.assign({}, e.image)), this.compareFunction = e.compareFunction, this;
  }
  toJSON(e) {
    const t = super.toJSON(e);
    return this.compareFunction !== null && (t.compareFunction = this.compareFunction), t;
  }
}
class ff extends Hr {
  /**
   * Constructs a new cube depth texture.
   *
   * @param {number} size - The size (width and height) of each cube face.
   * @param {number} [type=UnsignedIntType] - The texture type.
   * @param {number} [mapping=CubeReflectionMapping] - The texture mapping.
   * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
   * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
   * @param {number} [magFilter=NearestFilter] - The mag filter value.
   * @param {number} [minFilter=NearestFilter] - The min filter value.
   * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
   * @param {number} [format=DepthFormat] - The texture format.
   */
  constructor(e, t = Wo, s = yi, i, a, n = at, o = at, l, u = xo) {
    const h = { width: e, height: e, depth: 1 }, d = [h, h, h, h, h, h];
    super(e, e, t, s, i, a, n, o, l, u), this.image = d, this.isCubeDepthTexture = !0, this.isCubeTexture = !0;
  }
  /**
   * Alias for {@link CubeDepthTexture#image}.
   *
   * @type {Array<Image>}
   */
  get images() {
    return this.image;
  }
  set images(e) {
    this.image = e;
  }
}
class Yo extends ar {
  /**
   * Constructs a new box geometry.
   *
   * @param {number} [width=1] - The width. That is, the length of the edges parallel to the X axis.
   * @param {number} [height=1] - The height. That is, the length of the edges parallel to the Y axis.
   * @param {number} [depth=1] - The depth. That is, the length of the edges parallel to the Z axis.
   * @param {number} [widthSegments=1] - Number of segmented rectangular faces along the width of the sides.
   * @param {number} [heightSegments=1] - Number of segmented rectangular faces along the height of the sides.
   * @param {number} [depthSegments=1] - Number of segmented rectangular faces along the depth of the sides.
   */
  constructor(e = 1, t = 1, s = 1, i = 1, a = 1, n = 1) {
    super(), this.type = "BoxGeometry", this.parameters = {
      width: e,
      height: t,
      depth: s,
      widthSegments: i,
      heightSegments: a,
      depthSegments: n
    };
    const o = this;
    i = Math.floor(i), a = Math.floor(a), n = Math.floor(n);
    const l = [], u = [], h = [], d = [];
    let p = 0, m = 0;
    g("z", "y", "x", -1, -1, s, t, e, n, a, 0), g("z", "y", "x", 1, -1, s, t, -e, n, a, 1), g("x", "z", "y", 1, 1, e, s, t, i, n, 2), g("x", "z", "y", 1, -1, e, s, -t, i, n, 3), g("x", "y", "z", 1, -1, e, t, s, i, a, 4), g("x", "y", "z", -1, -1, e, t, -s, i, a, 5), this.setIndex(l), this.setAttribute("position", new Ir(u, 3)), this.setAttribute("normal", new Ir(h, 3)), this.setAttribute("uv", new Ir(d, 2));
    function g(y, v, w, _, C, V, P, z, R, I, G) {
      const $ = V / R, Z = P / I, Ve = V / 2, ue = P / 2, Ye = z / 2, se = R + 1, ss = I + 1;
      let ks = 0, xs = 0;
      const ke = new M();
      for (let We = 0; We < ss; We++) {
        const nt = We * Z - ue;
        for (let pr = 0; pr < se; pr++) {
          const zi = pr * $ - Ve;
          ke[y] = zi * _, ke[v] = nt * C, ke[w] = Ye, u.push(ke.x, ke.y, ke.z), ke[y] = 0, ke[v] = 0, ke[w] = z > 0 ? 1 : -1, h.push(ke.x, ke.y, ke.z), d.push(pr / R), d.push(1 - We / I), ks += 1;
        }
      }
      for (let We = 0; We < I; We++)
        for (let nt = 0; nt < R; nt++) {
          const pr = p + nt + se * We, zi = p + nt + se * (We + 1), ag = p + (nt + 1) + se * (We + 1), cu = p + (nt + 1) + se * We;
          l.push(pr, zi, cu), l.push(zi, ag, cu), xs += 6;
        }
      o.addGroup(m, xs, G), m += xs, p += ks;
    }
  }
  copy(e) {
    return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
  }
  /**
   * Factory method for creating an instance of this class from the given
   * JSON object.
   *
   * @param {Object} data - A JSON object representing the serialized geometry.
   * @return {BoxGeometry} A new instance.
   */
  static fromJSON(e) {
    return new Yo(e.width, e.height, e.depth, e.widthSegments, e.heightSegments, e.depthSegments);
  }
}
const $i = /* @__PURE__ */ new M(), Yi = /* @__PURE__ */ new Gr(), kt = /* @__PURE__ */ new M();
class Xh extends Pt {
  /**
   * Constructs a new camera.
   */
  constructor() {
    super(), this.isCamera = !0, this.type = "Camera", this.matrixWorldInverse = new de(), this.projectionMatrix = new de(), this.projectionMatrixInverse = new de(), this.coordinateSystem = Vs, this._reversedDepth = !1;
  }
  /**
   * The flag that indicates whether the camera uses a reversed depth buffer.
   *
   * @type {boolean}
   * @default false
   */
  get reversedDepth() {
    return this._reversedDepth;
  }
  copy(e, t) {
    return super.copy(e, t), this.matrixWorldInverse.copy(e.matrixWorldInverse), this.projectionMatrix.copy(e.projectionMatrix), this.projectionMatrixInverse.copy(e.projectionMatrixInverse), this.coordinateSystem = e.coordinateSystem, this;
  }
  /**
   * Returns a vector representing the ("look") direction of the 3D object in world space.
   *
   * This method is overwritten since cameras have a different forward vector compared to other
   * 3D objects. A camera looks down its local, negative z-axis by default.
   *
   * @param {Vector3} target - The target vector the result is stored to.
   * @return {Vector3} The 3D object's direction in world space.
   */
  getWorldDirection(e) {
    return super.getWorldDirection(e).negate();
  }
  updateMatrixWorld(e) {
    super.updateMatrixWorld(e), this.matrixWorld.decompose($i, Yi, kt), kt.x === 1 && kt.y === 1 && kt.z === 1 ? this.matrixWorldInverse.copy(this.matrixWorld).invert() : this.matrixWorldInverse.compose($i, Yi, kt.set(1, 1, 1)).invert();
  }
  updateWorldMatrix(e, t, s = !1) {
    super.updateWorldMatrix(e, t, s), this.matrixWorld.decompose($i, Yi, kt), kt.x === 1 && kt.y === 1 && kt.z === 1 ? this.matrixWorldInverse.copy(this.matrixWorld).invert() : this.matrixWorldInverse.compose($i, Yi, kt.set(1, 1, 1)).invert();
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
const Ms = /* @__PURE__ */ new M(), Fu = /* @__PURE__ */ new _e(), Bu = /* @__PURE__ */ new _e();
class yf extends Xh {
  /**
   * Constructs a new perspective camera.
   *
   * @param {number} [fov=50] - The vertical field of view.
   * @param {number} [aspect=1] - The aspect ratio.
   * @param {number} [near=0.1] - The camera's near plane.
   * @param {number} [far=2000] - The camera's far plane.
   */
  constructor(e = 50, t = 1, s = 0.1, i = 2e3) {
    super(), this.isPerspectiveCamera = !0, this.type = "PerspectiveCamera", this.fov = e, this.zoom = 1, this.near = s, this.far = i, this.focus = 10, this.aspect = t, this.view = null, this.filmGauge = 35, this.filmOffset = 0, this.updateProjectionMatrix();
  }
  copy(e, t) {
    return super.copy(e, t), this.fov = e.fov, this.zoom = e.zoom, this.near = e.near, this.far = e.far, this.focus = e.focus, this.aspect = e.aspect, this.view = e.view === null ? null : Object.assign({}, e.view), this.filmGauge = e.filmGauge, this.filmOffset = e.filmOffset, this;
  }
  /**
   * Sets the FOV by focal length in respect to the current {@link PerspectiveCamera#filmGauge}.
   *
   * The default film gauge is 35, so that the focal length can be specified for
   * a 35mm (full frame) camera.
   *
   * @param {number} focalLength - Values for focal length and film gauge must have the same unit.
   */
  setFocalLength(e) {
    const t = 0.5 * this.getFilmHeight() / e;
    this.fov = Ma * 2 * Math.atan(t), this.updateProjectionMatrix();
  }
  /**
   * Returns the focal length from the current {@link PerspectiveCamera#fov} and
   * {@link PerspectiveCamera#filmGauge}.
   *
   * @return {number} The computed focal length.
   */
  getFocalLength() {
    const e = Math.tan(pi * 0.5 * this.fov);
    return 0.5 * this.getFilmHeight() / e;
  }
  /**
   * Returns the current vertical field of view angle in degrees considering {@link PerspectiveCamera#zoom}.
   *
   * @return {number} The effective FOV.
   */
  getEffectiveFOV() {
    return Ma * 2 * Math.atan(
      Math.tan(pi * 0.5 * this.fov) / this.zoom
    );
  }
  /**
   * Returns the width of the image on the film. If {@link PerspectiveCamera#aspect} is greater than or
   * equal to one (landscape format), the result equals {@link PerspectiveCamera#filmGauge}.
   *
   * @return {number} The film width.
   */
  getFilmWidth() {
    return this.filmGauge * Math.min(this.aspect, 1);
  }
  /**
   * Returns the height of the image on the film. If {@link PerspectiveCamera#aspect} is greater than or
   * equal to one (landscape format), the result equals {@link PerspectiveCamera#filmGauge}.
   *
   * @return {number} The film width.
   */
  getFilmHeight() {
    return this.filmGauge / Math.max(this.aspect, 1);
  }
  /**
   * Computes the 2D bounds of the camera's viewable rectangle at a given distance along the viewing direction.
   * Sets `minTarget` and `maxTarget` to the coordinates of the lower-left and upper-right corners of the view rectangle.
   *
   * @param {number} distance - The viewing distance.
   * @param {Vector2} minTarget - The lower-left corner of the view rectangle is written into this vector.
   * @param {Vector2} maxTarget - The upper-right corner of the view rectangle is written into this vector.
   */
  getViewBounds(e, t, s) {
    Ms.set(-1, -1, 0.5).applyMatrix4(this.projectionMatrixInverse), t.set(Ms.x, Ms.y).multiplyScalar(-e / Ms.z), Ms.set(1, 1, 0.5).applyMatrix4(this.projectionMatrixInverse), s.set(Ms.x, Ms.y).multiplyScalar(-e / Ms.z);
  }
  /**
   * Computes the width and height of the camera's viewable rectangle at a given distance along the viewing direction.
   *
   * @param {number} distance - The viewing distance.
   * @param {Vector2} target - The target vector that is used to store result where x is width and y is height.
   * @returns {Vector2} The view size.
   */
  getViewSize(e, t) {
    return this.getViewBounds(e, Fu, Bu), t.subVectors(Bu, Fu);
  }
  /**
   * Sets an offset in a larger frustum. This is useful for multi-window or
   * multi-monitor/multi-machine setups.
   *
   * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
   * the monitors are in grid like this
   *```
   *   +---+---+---+
   *   | A | B | C |
   *   +---+---+---+
   *   | D | E | F |
   *   +---+---+---+
   *```
   * then for each monitor you would call it like this:
   *```js
   * const w = 1920;
   * const h = 1080;
   * const fullWidth = w * 3;
   * const fullHeight = h * 2;
   *
   * // --A--
   * camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
   * // --B--
   * camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
   * // --C--
   * camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
   * // --D--
   * camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
   * // --E--
   * camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
   * // --F--
   * camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
   * ```
   *
   * Note there is no reason monitors have to be the same size or in a grid.
   *
   * @param {number} fullWidth - The full width of multiview setup.
   * @param {number} fullHeight - The full height of multiview setup.
   * @param {number} x - The horizontal offset of the subcamera.
   * @param {number} y - The vertical offset of the subcamera.
   * @param {number} width - The width of subcamera.
   * @param {number} height - The height of subcamera.
   */
  setViewOffset(e, t, s, i, a, n) {
    this.aspect = e / t, this.view === null && (this.view = {
      enabled: !0,
      fullWidth: 1,
      fullHeight: 1,
      offsetX: 0,
      offsetY: 0,
      width: 1,
      height: 1
    }), this.view.enabled = !0, this.view.fullWidth = e, this.view.fullHeight = t, this.view.offsetX = s, this.view.offsetY = i, this.view.width = a, this.view.height = n, this.updateProjectionMatrix();
  }
  /**
   * Removes the view offset from the projection matrix.
   */
  clearViewOffset() {
    this.view !== null && (this.view.enabled = !1), this.updateProjectionMatrix();
  }
  /**
   * Updates the camera's projection matrix. Must be called after any change of
   * camera properties.
   */
  updateProjectionMatrix() {
    const e = this.near;
    let t = e * Math.tan(pi * 0.5 * this.fov) / this.zoom, s = 2 * t, i = this.aspect * s, a = -0.5 * i;
    const n = this.view;
    if (this.view !== null && this.view.enabled) {
      const l = n.fullWidth, u = n.fullHeight;
      a += n.offsetX * i / l, t -= n.offsetY * s / u, i *= n.width / l, s *= n.height / u;
    }
    const o = this.filmOffset;
    o !== 0 && (a += e * o / this.getFilmWidth()), this.projectionMatrix.makePerspective(a, a + i, t, t - s, e, this.far, this.coordinateSystem, this.reversedDepth), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
  }
  toJSON(e) {
    const t = super.toJSON(e);
    return t.object.fov = this.fov, t.object.zoom = this.zoom, t.object.near = this.near, t.object.far = this.far, t.object.focus = this.focus, t.object.aspect = this.aspect, this.view !== null && (t.object.view = Object.assign({}, this.view)), t.object.filmGauge = this.filmGauge, t.object.filmOffset = this.filmOffset, t;
  }
}
class $h extends Xh {
  /**
   * Constructs a new orthographic camera.
   *
   * @param {number} [left=-1] - The left plane of the camera's frustum.
   * @param {number} [right=1] - The right plane of the camera's frustum.
   * @param {number} [top=1] - The top plane of the camera's frustum.
   * @param {number} [bottom=-1] - The bottom plane of the camera's frustum.
   * @param {number} [near=0.1] - The camera's near plane.
   * @param {number} [far=2000] - The camera's far plane.
   */
  constructor(e = -1, t = 1, s = 1, i = -1, a = 0.1, n = 2e3) {
    super(), this.isOrthographicCamera = !0, this.type = "OrthographicCamera", this.zoom = 1, this.view = null, this.left = e, this.right = t, this.top = s, this.bottom = i, this.near = a, this.far = n, this.updateProjectionMatrix();
  }
  copy(e, t) {
    return super.copy(e, t), this.left = e.left, this.right = e.right, this.top = e.top, this.bottom = e.bottom, this.near = e.near, this.far = e.far, this.zoom = e.zoom, this.view = e.view === null ? null : Object.assign({}, e.view), this;
  }
  /**
   * Sets an offset in a larger frustum. This is useful for multi-window or
   * multi-monitor/multi-machine setups.
   *
   * @param {number} fullWidth - The full width of multiview setup.
   * @param {number} fullHeight - The full height of multiview setup.
   * @param {number} x - The horizontal offset of the subcamera.
   * @param {number} y - The vertical offset of the subcamera.
   * @param {number} width - The width of subcamera.
   * @param {number} height - The height of subcamera.
   * @see {@link PerspectiveCamera#setViewOffset}
   */
  setViewOffset(e, t, s, i, a, n) {
    this.view === null && (this.view = {
      enabled: !0,
      fullWidth: 1,
      fullHeight: 1,
      offsetX: 0,
      offsetY: 0,
      width: 1,
      height: 1
    }), this.view.enabled = !0, this.view.fullWidth = e, this.view.fullHeight = t, this.view.offsetX = s, this.view.offsetY = i, this.view.width = a, this.view.height = n, this.updateProjectionMatrix();
  }
  /**
   * Removes the view offset from the projection matrix.
   */
  clearViewOffset() {
    this.view !== null && (this.view.enabled = !1), this.updateProjectionMatrix();
  }
  /**
   * Updates the camera's projection matrix. Must be called after any change of
   * camera properties.
   */
  updateProjectionMatrix() {
    const e = (this.right - this.left) / (2 * this.zoom), t = (this.top - this.bottom) / (2 * this.zoom), s = (this.right + this.left) / 2, i = (this.top + this.bottom) / 2;
    let a = s - e, n = s + e, o = i + t, l = i - t;
    if (this.view !== null && this.view.enabled) {
      const u = (this.right - this.left) / this.view.fullWidth / this.zoom, h = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
      a += u * this.view.offsetX, n = a + u * this.view.width, o -= h * this.view.offsetY, l = o - h * this.view.height;
    }
    this.projectionMatrix.makeOrthographic(a, n, o, l, this.near, this.far, this.coordinateSystem, this.reversedDepth), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
  }
  toJSON(e) {
    const t = super.toJSON(e);
    return t.object.zoom = this.zoom, t.object.left = this.left, t.object.right = this.right, t.object.top = this.top, t.object.bottom = this.bottom, t.object.near = this.near, t.object.far = this.far, this.view !== null && (t.object.view = Object.assign({}, this.view)), t;
  }
}
class xf extends jh {
  /**
   * Constructs a new instanced interleaved buffer.
   *
   * @param {TypedArray} array - A typed array with a shared buffer storing attribute data.
   * @param {number} stride - The number of typed-array elements per vertex.
   * @param {number} [meshPerAttribute=1] - Defines how often a value of this interleaved buffer should be repeated.
   */
  constructor(e, t, s = 1) {
    super(e, t), this.isInstancedInterleavedBuffer = !0, this.meshPerAttribute = s;
  }
  copy(e) {
    return super.copy(e), this.meshPerAttribute = e.meshPerAttribute, this;
  }
  clone(e) {
    const t = super.clone(e);
    return t.meshPerAttribute = this.meshPerAttribute, t;
  }
  toJSON(e) {
    const t = super.toJSON(e);
    return t.isInstancedInterleavedBuffer = !0, t.meshPerAttribute = this.meshPerAttribute, t;
  }
}
const Yh = class {
  /**
   * Constructs a new 2x2 matrix. The arguments are supposed to be
   * in row-major order. If no arguments are provided, the constructor
   * initializes the matrix as an identity matrix.
   *
   * @param {number} [n11] - 1-1 matrix element.
   * @param {number} [n12] - 1-2 matrix element.
   * @param {number} [n21] - 2-1 matrix element.
   * @param {number} [n22] - 2-2 matrix element.
   */
  constructor(e, t, s, i) {
    this.elements = [
      1,
      0,
      0,
      1
    ], e !== void 0 && this.set(e, t, s, i);
  }
  /**
   * Sets this matrix to the 2x2 identity matrix.
   *
   * @return {Matrix2} A reference to this matrix.
   */
  identity() {
    return this.set(
      1,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets the elements of the matrix from the given array.
   *
   * @param {Array<number>} array - The matrix elements in column-major order.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Matrix2} A reference to this matrix.
   */
  fromArray(e, t = 0) {
    for (let s = 0; s < 4; s++)
      this.elements[s] = e[s + t];
    return this;
  }
  /**
   * Sets the elements of the matrix.The arguments are supposed to be
   * in row-major order.
   *
   * @param {number} n11 - 1-1 matrix element.
   * @param {number} n12 - 1-2 matrix element.
   * @param {number} n21 - 2-1 matrix element.
   * @param {number} n22 - 2-2 matrix element.
   * @return {Matrix2} A reference to this matrix.
   */
  set(e, t, s, i) {
    const a = this.elements;
    return a[0] = e, a[2] = t, a[1] = s, a[3] = i, this;
  }
};
Yh.prototype.isMatrix2 = !0;
let bf = Yh;
typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", { detail: {
  revision: Ch
} }));
typeof window < "u" && (window.__THREE__ ? X("WARNING: Multiple instances of Three.js being imported.") : window.__THREE__ = Ch);
const vf = [
  "alphaMap",
  "alphaTest",
  "anisotropy",
  "anisotropyMap",
  "anisotropyRotation",
  "aoMap",
  "aoMapIntensity",
  "attenuationColor",
  "attenuationDistance",
  "bumpMap",
  "clearcoat",
  "clearcoatMap",
  "clearcoatNormalMap",
  "clearcoatNormalScale",
  "clearcoatRoughness",
  "color",
  "dispersion",
  "displacementMap",
  "emissive",
  "emissiveIntensity",
  "emissiveMap",
  "envMap",
  "envMapIntensity",
  "envMapRotation",
  "gradientMap",
  "ior",
  "iridescence",
  "iridescenceIOR",
  "iridescenceMap",
  "iridescenceThicknessMap",
  "lightMap",
  "lightMapIntensity",
  "map",
  "matcap",
  "metalness",
  "metalnessMap",
  "normalMap",
  "normalScale",
  "opacity",
  "roughness",
  "roughnessMap",
  "sheen",
  "sheenColor",
  "sheenColorMap",
  "sheenRoughnessMap",
  "shininess",
  "specular",
  "specularColor",
  "specularColorMap",
  "specularIntensity",
  "specularIntensityMap",
  "specularMap",
  "thickness",
  "transmission",
  "transmissionMap"
], Uu = /* @__PURE__ */ new WeakMap(), ku = /* @__PURE__ */ new WeakMap(), Du = /* @__PURE__ */ new WeakMap();
class Tf {
  /**
   * Constructs a new node material observer.
   *
   * @param {NodeBuilder} builder - The node builder.
   */
  constructor(e) {
    this.renderObjects = /* @__PURE__ */ new WeakMap(), this.hasNode = this.containsNode(e), this.hasAnimation = e.object.isSkinnedMesh === !0, this.refreshUniforms = vf, this.renderId = 0;
  }
  /**
   * Returns `true` if the given render object is verified for the first time of this observer.
   *
   * @param {RenderObject} renderObject - The render object.
   * @return {boolean} Whether the given render object is verified for the first time of this observer.
   */
  firstInitialization(e) {
    return this.renderObjects.has(e) === !1 ? (this.getRenderObjectData(e), !0) : !1;
  }
  /**
   * Returns `true` if the current rendering produces motion vectors.
   *
   * @param {Renderer} renderer - The renderer.
   * @return {boolean} Whether the current rendering produces motion vectors or not.
   */
  needsVelocity(e) {
    const t = e.getMRT();
    return t !== null && t.has("velocity");
  }
  /**
   * Returns monitoring data for the given render object.
   *
   * @param {RenderObject} renderObject - The render object.
   * @return {Object} The monitoring data.
   */
  getRenderObjectData(e) {
    let t = this.renderObjects.get(e);
    if (t === void 0) {
      const { geometry: s, object: i } = e;
      if (t = {
        geometryId: s.id,
        worldMatrix: i.matrixWorld.clone()
      }, i.center && (t.center = i.center.clone()), i.morphTargetInfluences && (t.morphTargetInfluences = i.morphTargetInfluences.slice()), e.bundle !== null && (t.version = e.bundle.version), e.material.transmission > 0) {
        const { width: o, height: l } = e.context;
        t.bufferWidth = o, t.bufferHeight = l;
      }
      const { environmentIntensity: a, environmentRotation: n } = e.scene;
      t.environmentIntensity = a, t.environmentRotation = n.clone(), t.lights = this.getLightsData(e.lightsNode.getLights(), []), this.renderObjects.set(e, t);
    }
    return t;
  }
  /**
   * Returns an attribute data structure holding the attributes versions for
   * monitoring.
   *
   * @param {Object} attributes - The geometry attributes.
   * @return {Object} An object for monitoring the versions of attributes.
   */
  getAttributesData(e) {
    const t = {};
    for (const s in e) {
      const i = e[s];
      t[s] = {
        id: i.isInterleavedBufferAttribute ? i.data.uuid : i.id,
        version: i.isInterleavedBufferAttribute ? i.data.version : i.version
      };
    }
    return t;
  }
  /**
   * Returns `true` if the node builder's material uses
   * node properties.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {boolean} Whether the node builder's material uses node properties or not.
   */
  containsNode(e) {
    const t = e.material;
    for (const s in t)
      if (t[s] && t[s].isNode)
        return !0;
    return !!(e.context.modelViewMatrix || e.context.modelNormalViewMatrix || e.context.getAO || e.context.getShadow);
  }
  /**
   * Returns a geometry data structure holding the geometry property values for
   * monitoring.
   *
   * @param {BufferGeometry} geometry - The geometry.
   * @return {Object} An object for monitoring geometry properties.
   */
  getGeometryData(e) {
    let t = Du.get(e);
    return t === void 0 && (t = {
      _renderId: -1,
      _equal: !1,
      attributes: this.getAttributesData(e.attributes),
      indexId: e.index ? e.index.id : null,
      indexVersion: e.index ? e.index.version : null,
      drawRange: { start: e.drawRange.start, count: e.drawRange.count }
    }, Du.set(e, t)), t;
  }
  /**
   * Returns a material data structure holding the material property values for
   * monitoring.
   *
   * @param {Material} material - The material.
   * @return {Object} An object for monitoring material properties.
   */
  getMaterialData(e) {
    let t = ku.get(e);
    if (t === void 0) {
      t = { _renderId: -1, _equal: !1 };
      for (const s of this.refreshUniforms) {
        const i = e[s];
        i != null && (typeof i == "object" && i.clone !== void 0 ? i.isTexture === !0 ? t[s] = { id: i.id, version: 0 } : t[s] = i.clone() : t[s] = i);
      }
      ku.set(e, t);
    }
    return t;
  }
  /**
   * Returns `true` if the given render object has not changed its state.
   *
   * @param {RenderObject} renderObject - The render object.
   * @param {Array<Light>} lightsData - The current material lights.
   * @param {number} renderId - The current render ID.
   * @return {boolean} Whether the given render object is equal to its cached state or not.
   */
  equals(e, t, s) {
    const { object: i, material: a, geometry: n } = e, o = this.getRenderObjectData(e);
    if (o.worldMatrix.equals(i.matrixWorld) !== !0)
      return o.worldMatrix.copy(i.matrixWorld), !1;
    const l = this.getMaterialData(e.material);
    if (l._renderId !== s) {
      l._renderId = s;
      for (const d in l) {
        const p = l[d], m = a[d];
        if (d !== "_renderId" && d !== "_equal") {
          if (p.equals !== void 0) {
            if (p.equals(m) === !1)
              return p.copy(m), l._equal = !1, !1;
          } else if (m.isTexture === !0) {
            if (p.id !== m.id || p.version !== m.version)
              return p.id = m.id, p.version = m.version, l._equal = !1, !1;
          } else if (p !== m)
            return l[d] = m, l._equal = !1, !1;
        }
      }
      if (l.transmission > 0) {
        const { width: d, height: p } = e.context;
        if (o.bufferWidth !== d || o.bufferHeight !== p)
          return o.bufferWidth = d, o.bufferHeight = p, l._equal = !1, !1;
      }
      l._equal = !0;
    } else if (l._equal === !1) return !1;
    if (o.geometryId !== n.id)
      return o.geometryId = n.id, !1;
    const u = this.getGeometryData(e.geometry);
    if (u._renderId !== s) {
      u._renderId = s;
      const d = n.attributes, p = u.attributes;
      let m = 0, g = 0;
      for (const V in d) m++;
      for (const V in p) {
        g++;
        const P = p[V], z = d[V];
        if (z === void 0)
          return delete p[V], u._equal = !1, !1;
        const R = z.isInterleavedBufferAttribute ? z.data.uuid : z.id, I = z.isInterleavedBufferAttribute ? z.data.version : z.version;
        if (P.id !== R || P.version !== I)
          return P.id = R, P.version = I, u._equal = !1, !1;
      }
      if (g !== m)
        return u.attributes = this.getAttributesData(d), u._equal = !1, !1;
      const y = n.index, v = u.indexId, w = u.indexVersion, _ = y ? y.id : null, C = y ? y.version : null;
      if (v !== _ || w !== C)
        return u.indexId = _, u.indexVersion = C, u._equal = !1, !1;
      if (u.drawRange.start !== n.drawRange.start || u.drawRange.count !== n.drawRange.count)
        return u.drawRange.start = n.drawRange.start, u.drawRange.count = n.drawRange.count, u._equal = !1, !1;
      u._equal = !0;
    } else if (u._equal === !1) return !1;
    if (o.morphTargetInfluences) {
      let d = !1;
      for (let p = 0; p < o.morphTargetInfluences.length; p++)
        o.morphTargetInfluences[p] !== i.morphTargetInfluences[p] && (o.morphTargetInfluences[p] = i.morphTargetInfluences[p], d = !0);
      if (d) return !1;
    }
    if (o.lights) {
      for (let d = 0; d < t.length; d++)
        if (o.lights[d].map !== t[d].map)
          return !1;
    }
    const h = e.scene;
    return h.environment !== null && a.envMap === null && (o.environmentIntensity !== h.environmentIntensity || o.environmentRotation.equals(h.environmentRotation) === !1) ? (o.environmentIntensity = h.environmentIntensity, o.environmentRotation.copy(h.environmentRotation), !1) : o.center && o.center.equals(i.center) === !1 ? (o.center.copy(i.center), !1) : (e.bundle !== null && (o.version = e.bundle.version), !0);
  }
  /**
   * Returns the lights data for the given material lights.
   *
   * @param {Array<Light>} materialLights - The material lights.
   * @return {Array<Object>} The lights data for the given material lights.
   */
  getLightsData(e, t) {
    t.length = 0;
    for (const s of e)
      s.isSpotLight === !0 && s.map !== null && t.push({ map: s.map.version });
    return t;
  }
  /**
   * Returns the lights for the given lights node and render ID.
   *
   * @param {LightsNode} lightsNode - The lights node.
   * @param {number} renderId - The render ID.
   * @return {Array<Object>} The lights for the given lights node and render ID.
   */
  getLights(e, t) {
    let s = Uu.get(e);
    return s === void 0 && (s = { renderId: -1, lightsData: [] }, Uu.set(e, s)), s.renderId === t || (s.renderId = t, this.getLightsData(e.getLights(), s.lightsData)), s.lightsData;
  }
  /**
   * Checks if the given render object requires a refresh.
   *
   * @param {RenderObject} renderObject - The render object.
   * @param {NodeFrame} nodeFrame - The current node frame.
   * @return {boolean} Whether the given render object requires a refresh or not.
   */
  needsRefresh(e, t) {
    if (this.hasNode || this.hasAnimation || this.firstInitialization(e) || this.needsVelocity(t.renderer))
      return !0;
    const { renderId: s } = t;
    if (this.renderId !== s)
      return this.renderId = s, !0;
    const i = e.object.static === !0, a = e.bundle !== null && e.bundle.static === !0 && this.getRenderObjectData(e).version === e.bundle.version;
    if (i || a)
      return !1;
    const n = this.getLights(e.lightsNode, s);
    return this.equals(e, n, s) !== !0;
  }
}
const wf = [
  /^StackTrace\.js$/,
  /^TSLCore\.js$/,
  /^.*Node\.js$/,
  /^three\.webgpu.*\.js$/
];
function Nf(r) {
  const e = /(?:at\s+(.+?)\s+\()?(?:(.+?)@)?([^@\s()]+):(\d+):(\d+)/;
  return r.split(`
`).map((t) => {
    const s = t.match(e);
    if (!s) return null;
    const i = s[1] || s[2] || "", a = s[3].split("?")[0], n = parseInt(s[4], 10), o = parseInt(s[5], 10), l = a.split("/").pop();
    return {
      fn: i,
      file: l,
      line: n,
      column: o
    };
  }).filter((t) => t && !wf.some((s) => s.test(t.file)));
}
class Re {
  /**
   * Creates a StackTrace instance by capturing and filtering the current stack trace.
   *
   * @param {Error|string|null} stackMessage - An optional stack trace to use instead of capturing a new one.
   */
  constructor(e = null) {
    this.isStackTrace = !0, this.stack = Nf(e || new Error().stack);
  }
  /**
   * Returns a formatted location string of the top stack frame.
   *
   * @returns {string} The formatted stack trace message.
   */
  getLocation() {
    if (this.stack.length === 0)
      return "[Unknown location]";
    const e = this.stack[0], t = e.fn;
    return `${t ? `"${t}()" at ` : ""}"${e.file}:${e.line}"`;
  }
  /**
   * Returns the full error message including the stack trace.
   *
   * @param {string} message - The error message.
   * @returns {string} The full error message with stack trace.
   */
  getError(e) {
    if (this.stack.length === 0)
      return e;
    const t = this.stack.map((s) => {
      const i = `${s.file}:${s.line}:${s.column}`;
      return s.fn ? `    at ${s.fn} (${i})` : `    at ${i}`;
    }).join(`
`);
    return `${e}
${t}`;
  }
}
function Zo(r, e = 0) {
  let t = 3735928559 ^ e, s = 1103547991 ^ e;
  if (Array.isArray(r))
    for (let i = 0, a; i < r.length; i++)
      a = r[i], t = Math.imul(t ^ a, 2654435761), s = Math.imul(s ^ a, 1597334677);
  else
    for (let i = 0, a; i < r.length; i++)
      a = r.charCodeAt(i), t = Math.imul(t ^ a, 2654435761), s = Math.imul(s ^ a, 1597334677);
  return t = Math.imul(t ^ t >>> 16, 2246822507), t ^= Math.imul(s ^ s >>> 13, 3266489909), s = Math.imul(s ^ s >>> 16, 2246822507), s ^= Math.imul(t ^ t >>> 13, 3266489909), 4294967296 * (2097151 & s) + (t >>> 0);
}
const Jo = (r) => Zo(r), Qo = (r) => Zo(r), Zh = (...r) => Zo(r), Mf = /* @__PURE__ */ new Map([
  [1, "float"],
  [2, "vec2"],
  [3, "vec3"],
  [4, "vec4"],
  [9, "mat3"],
  [16, "mat4"]
]), Wu = /* @__PURE__ */ new WeakMap();
function Sf(r) {
  return Mf.get(r);
}
function _a(r) {
  if (/[iu]?vec\d/.test(r))
    return r.startsWith("ivec") ? Int32Array : r.startsWith("uvec") ? Uint32Array : Float32Array;
  if (/mat\d/.test(r) || /float/.test(r)) return Float32Array;
  if (/uint/.test(r)) return Uint32Array;
  if (/int/.test(r)) return Int32Array;
  throw new Error(`THREE.NodeUtils: Unsupported type: ${r}`);
}
function Jh(r) {
  if (/float|int|uint|bool/.test(r)) return 1;
  if (/vec2/.test(r)) return 2;
  if (/vec3/.test(r)) return 3;
  if (/vec4/.test(r) || /mat2/.test(r)) return 4;
  if (/mat3/.test(r)) return 9;
  if (/mat4/.test(r)) return 16;
  te(`TSL: Unsupported type: ${r}`, new Re());
}
function _f(r) {
  if (/float|int|uint|bool/.test(r)) return 1;
  if (/vec2/.test(r)) return 2;
  if (/vec3/.test(r)) return 3;
  if (/vec4/.test(r) || /mat2/.test(r)) return 4;
  if (/mat3/.test(r)) return 12;
  if (/mat4/.test(r)) return 16;
  te(`TSL: Unsupported type: ${r}`, new Re());
}
function Af(r) {
  if (/float|int|uint|bool/.test(r)) return 1;
  if (/vec2/.test(r)) return 2;
  if (/vec3/.test(r) || /vec4/.test(r)) return 4;
  if (/mat2/.test(r)) return 2;
  if (/mat3/.test(r) || /mat4/.test(r)) return 4;
  te(`TSL: Unsupported type: ${r}`, new Re());
}
function Cs(r) {
  if (r == null) return null;
  const e = typeof r;
  return r.isNode === !0 ? "node" : e === "number" ? "float" : e === "boolean" ? "bool" : e === "string" ? "string" : e === "function" ? "shader" : r.isVector2 === !0 ? "vec2" : r.isVector3 === !0 ? "vec3" : r.isVector4 === !0 ? "vec4" : r.isMatrix2 === !0 ? "mat2" : r.isMatrix3 === !0 ? "mat3" : r.isMatrix4 === !0 ? "mat4" : r.isColor === !0 ? "color" : r instanceof ArrayBuffer ? "ArrayBuffer" : null;
}
function Ko(r, ...e) {
  const t = r ? r.slice(-4) : void 0;
  return e.length === 1 && (t === "vec2" ? e = [e[0], e[0]] : t === "vec3" ? e = [e[0], e[0], e[0]] : t === "vec4" && (e = [e[0], e[0], e[0], e[0]])), r === "color" ? new Yt(...e) : t === "vec2" ? new _e(...e) : t === "vec3" ? new M(...e) : t === "vec4" ? new tt(...e) : t === "mat2" ? new bf(...e) : t === "mat3" ? new Kt(...e) : t === "mat4" ? new de(...e) : r === "bool" ? e[0] || !1 : r === "float" || r === "int" || r === "uint" ? e[0] || 0 : r === "string" ? e[0] || "" : r === "ArrayBuffer" ? zf(e[0]) : null;
}
function Vf(r) {
  let e = Wu.get(r);
  return e === void 0 && (e = {}, Wu.set(r, e)), e;
}
function Cf(r) {
  let e = "";
  const t = new Uint8Array(r);
  for (let s = 0; s < t.length; s++)
    e += String.fromCharCode(t[s]);
  return btoa(e);
}
function zf(r) {
  return Uint8Array.from(atob(r), (e) => e.charCodeAt(0)).buffer;
}
const Vr = {
  VERTEX: "vertex",
  FRAGMENT: "fragment"
}, Q = {
  NONE: "none",
  FRAME: "frame",
  RENDER: "render",
  OBJECT: "object"
}, Rf = {
  BOOLEAN: "bool",
  INTEGER: "int",
  FLOAT: "float",
  VECTOR2: "vec2",
  VECTOR3: "vec3",
  VECTOR4: "vec4",
  MATRIX2: "mat2",
  MATRIX3: "mat3",
  MATRIX4: "mat4"
}, Ht = {
  READ_ONLY: "readOnly",
  WRITE_ONLY: "writeOnly",
  READ_WRITE: "readWrite"
}, Qh = ["fragment", "vertex"], Ef = ["setup", "analyze", "generate"], Lf = [...Qh, "compute"], Xr = ["x", "y", "z", "w"], If = {
  analyze: "setup",
  generate: "analyze"
};
let Of = 0;
class k extends Ps {
  static get type() {
    return "Node";
  }
  /**
   * Constructs a new node.
   *
   * @param {?string} nodeType - The node type.
   */
  constructor(e = null) {
    super(), this.nodeType = e, this.updateType = Q.NONE, this.updateBeforeType = Q.NONE, this.updateAfterType = Q.NONE, this.version = 0, this.name = "", this.global = !1, this.parents = !1, this.isNode = !0, this._beforeNodes = null, this._cacheKey = null, this._uuid = null, this._cacheKeyVersion = 0, this.id = Of++, this.stackTrace = null, k.captureStackTrace === !0 && (this.stackTrace = new Re());
  }
  /**
   * Set this property to `true` when the node should be regenerated.
   *
   * @type {boolean}
   * @default false
   * @param {boolean} value
   */
  set needsUpdate(e) {
    e === !0 && this.version++;
  }
  /**
   * The UUID of the node.
   *
   * @type {string}
   * @readonly
   */
  get uuid() {
    return this._uuid === null && (this._uuid = Ph.generateUUID()), this._uuid;
  }
  /**
   * The type of the class. The value is usually the constructor name.
   *
   * @type {string}
  	 * @readonly
   */
  get type() {
    return this.constructor.type;
  }
  /**
   * Convenient method for defining {@link Node#update}.
   *
   * @param {Function} callback - The update method.
   * @param {string} updateType - The update type.
   * @return {Node} A reference to this node.
   */
  onUpdate(e, t) {
    return this.updateType = t, this.update = e.bind(this), this;
  }
  /**
   * Convenient method for defining {@link Node#update}. Similar to {@link Node#onUpdate}, but
   * this method automatically sets the update type to `FRAME`.
   *
   * @param {Function} callback - The update method.
   * @return {Node} A reference to this node.
   */
  onFrameUpdate(e) {
    return this.onUpdate(e, Q.FRAME);
  }
  /**
   * Convenient method for defining {@link Node#update}. Similar to {@link Node#onUpdate}, but
   * this method automatically sets the update type to `RENDER`.
   *
   * @param {Function} callback - The update method.
   * @return {Node} A reference to this node.
   */
  onRenderUpdate(e) {
    return this.onUpdate(e, Q.RENDER);
  }
  /**
   * Convenient method for defining {@link Node#update}. Similar to {@link Node#onUpdate}, but
   * this method automatically sets the update type to `OBJECT`.
   *
   * @param {Function} callback - The update method.
   * @return {Node} A reference to this node.
   */
  onObjectUpdate(e) {
    return this.onUpdate(e, Q.OBJECT);
  }
  /**
   * Convenient method for defining {@link Node#updateReference}.
   *
   * @param {Function} callback - The update method.
   * @return {Node} A reference to this node.
   */
  onReference(e) {
    return this.updateReference = e.bind(this), this;
  }
  /**
   * Nodes might refer to other objects like materials. This method allows to dynamically update the reference
   * to such objects based on a given state (e.g. the current node frame or builder).
   *
   * @param {any} state - This method can be invocated in different contexts so `state` can refer to any object type.
   * @return {any} The updated reference.
   */
  updateReference() {
    return this;
  }
  /**
   * By default this method returns the value of the {@link Node#global} flag. This method
   * can be overwritten in derived classes if an analytical way is required to determine the
   * global cache referring to the current shader-stage.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {boolean} Whether this node is global or not.
   */
  isGlobal() {
    return this.global;
  }
  /**
   * Generator function that can be used to iterate over the child nodes.
   *
   * @generator
   * @yields {Node} A child node.
   */
  *getChildren() {
    for (const { childNode: e } of this._getChildren())
      yield e;
  }
  /**
   * Calling this method dispatches the `dispose` event. This event can be used
   * to register event listeners for clean up tasks.
   */
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
  /**
   * Callback for {@link Node#traverse}.
   *
   * @callback traverseCallback
   * @param {Node} node - The current node.
   */
  /**
   * Can be used to traverse through the node's hierarchy.
   *
   * @param {traverseCallback} callback - A callback that is executed per node.
   */
  traverse(e) {
    e(this);
    for (const t of this.getChildren())
      t.traverse(e);
  }
  /**
   * Returns the child nodes of this node.
   *
   * @private
   * @param {Set<Node>} [ignores=new Set()] - A set of nodes to ignore during the search to avoid circular references.
   * @returns {Array<Object>} An array of objects describing the child nodes.
   */
  _getChildren(e = /* @__PURE__ */ new Set()) {
    const t = [];
    e.add(this);
    for (const s of Object.getOwnPropertyNames(this)) {
      const i = this[s];
      if (!(s.startsWith("_") === !0 || e.has(i))) {
        if (Array.isArray(i) === !0)
          for (let a = 0; a < i.length; a++) {
            const n = i[a];
            n && n.isNode === !0 && t.push({ property: s, index: a, childNode: n });
          }
        else if (i && i.isNode === !0)
          t.push({ property: s, childNode: i });
        else if (i && Object.getPrototypeOf(i) === Object.prototype)
          for (const a in i) {
            if (a.startsWith("_") === !0) continue;
            const n = i[a];
            n && n.isNode === !0 && t.push({ property: s, index: a, childNode: n });
          }
      }
    }
    return t;
  }
  /**
   * Returns the cache key for this node.
   *
   * @param {boolean} [force=false] - When set to `true`, a recomputation of the cache key is forced.
   * @param {Set<Node>} [ignores=null] - A set of nodes to ignore during the computation of the cache key.
   * @return {number} The cache key of the node.
   */
  getCacheKey(e = !1, t = null) {
    if (e = e || this.version !== this._cacheKeyVersion, e === !0 || this._cacheKey === null) {
      t === null && (t = /* @__PURE__ */ new Set());
      const s = [];
      for (const { property: i, childNode: a } of this._getChildren(t))
        s.push(Jo(i.slice(0, -4)), a.getCacheKey(e, t));
      this._cacheKey = Zh(Qo(s), this.customCacheKey()), this._cacheKeyVersion = this.version;
    }
    return this._cacheKey;
  }
  /**
   * Generate a custom cache key for this node.
   *
   * @return {number} The cache key of the node.
   */
  customCacheKey() {
    return this.id;
  }
  /**
   * Returns the references to this node which is by default `this`.
   *
   * @return {Node} A reference to this node.
   */
  getScope() {
    return this;
  }
  /**
   * Returns the hash of the node which is used to identify the node. By default it's
   * the {@link Node#uuid} however derived node classes might have to overwrite this method
   * depending on their implementation.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The hash.
   */
  getHash() {
    return String(this.id);
  }
  /**
   * Returns the update type of {@link Node#update}.
   *
   * @return {NodeUpdateType} The update type.
   */
  getUpdateType() {
    return this.updateType;
  }
  /**
   * Returns the update type of {@link Node#updateBefore}.
   *
   * @return {NodeUpdateType} The update type.
   */
  getUpdateBeforeType() {
    return this.updateBeforeType;
  }
  /**
   * Returns the update type of {@link Node#updateAfter}.
   *
   * @return {NodeUpdateType} The update type.
   */
  getUpdateAfterType() {
    return this.updateAfterType;
  }
  /**
   * Certain types are composed of multiple elements. For example a `vec3`
   * is composed of three `float` values. This method returns the type of
   * these elements.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The type of the node.
   */
  getElementType(e) {
    const t = this.getNodeType(e);
    return e.getElementType(t);
  }
  /**
   * Returns the node member type for the given name.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {string} name - The name of the member.
   * @return {string} The type of the node.
   */
  getMemberType() {
    return "void";
  }
  /**
   * Returns the node's type.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {string} [output=null] - The output of the node.
   * @return {string} The type of the node.
   */
  getNodeType(e, t = null) {
    const s = e.getDataFromNode(this);
    let i;
    return t !== null ? (s.typeFromOutput = s.typeFromOutput || {}, i = s.typeFromOutput[t], i === void 0 && (i = this.generateNodeType(e, t), s.typeFromOutput[t] = i)) : (i = s.type, i === void 0 && (i = this.generateNodeType(e), s.type = i)), i;
  }
  /**
   * Returns the node's type.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {string} [output=null] - The output of the node.
   * @return {string} The type of the node.
   */
  generateNodeType(e, t = null) {
    const s = e.getNodeProperties(this);
    return s.outputNode ? s.outputNode.getNodeType(e, t) : this.nodeType;
  }
  /**
   * This method is used during the build process of a node and ensures
   * equal nodes are not built multiple times but just once. For example if
   * `attribute( 'uv' )` is used multiple times by the user, the build
   * process makes sure to process just the first node. It also handles
   * node overrides if an override context is set.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Node} The shared node if possible. Otherwise `this` is returned.
   */
  getShared(e) {
    const t = this.getHash(e), s = e.getNodeFromHash(t);
    let i = null;
    if (s && s !== this)
      i = s;
    else if (e.context.overrideNodes) {
      const a = e.context.overrideNodes.get(this);
      if (a) {
        const n = e.getDataFromNode(this);
        n.isOverwritten !== !0 ? (n.isOverwritten = !0, i = a(e).overrideNode(this, null), n.sharedNode = i) : i = n.sharedNode;
      }
    }
    return i || this;
  }
  /**
   * Returns the number of elements in the node array.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {?number} The number of elements in the node array.
   */
  getArrayCount() {
    return null;
  }
  /**
   * Represents the setup stage which is the first step of the build process, see {@link Node#build} method.
   * This method is often overwritten in derived modules to prepare the node which is used as a node's output/result.
   * If an output node is prepared, then it must be returned in the `return` statement of the derived module's setup function.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {?Node} The output node.
   */
  setup(e) {
    const t = e.getNodeProperties(this);
    let s = 0;
    for (const i of this.getChildren())
      t["node" + s++] = i;
    return t.outputNode || null;
  }
  /**
   * Represents the analyze stage which is the second step of the build process, see {@link Node#build} method.
   * This stage analyzes the node hierarchy and ensures descendent nodes are built.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {?Node} output - The target output node.
   */
  analyze(e, t = null) {
    const s = e.increaseUsage(this);
    if (this.parents === !0) {
      const i = e.getDataFromNode(this, "any");
      i.stages = i.stages || {}, i.stages[e.shaderStage] = i.stages[e.shaderStage] || [], i.stages[e.shaderStage].push(t);
    }
    if (s === 1) {
      const i = e.getNodeProperties(this);
      for (const a of Object.values(i))
        a && a.isNode === !0 && a.build(e, this);
    }
  }
  /**
   * Represents the generate stage which is the third step of the build process, see {@link Node#build} method.
   * This state builds the output node and returns the resulting shader string.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {?string} [output] - Can be used to define the output type.
   * @return {?string} The generated shader string.
   */
  generate(e, t) {
    const { outputNode: s } = e.getNodeProperties(this);
    if (s && s.isNode === !0)
      return s.build(e, t);
  }
  /**
   * The method can be implemented to update the node's internal state before it is used to render an object.
   * The {@link Node#updateBeforeType} property defines how often the update is executed.
   *
   * @abstract
   * @param {NodeFrame} frame - A reference to the current node frame.
   * @return {?boolean} An optional bool that indicates whether the implementation actually performed an update or not (e.g. due to caching).
   */
  updateBefore() {
    X("Abstract function.");
  }
  /**
   * The method can be implemented to update the node's internal state after it was used to render an object.
   * The {@link Node#updateAfterType} property defines how often the update is executed.
   *
   * @abstract
   * @param {NodeFrame} frame - A reference to the current node frame.
   * @return {?boolean} An optional bool that indicates whether the implementation actually performed an update or not (e.g. due to caching).
   */
  updateAfter() {
    X("Abstract function.");
  }
  /**
   * The method can be implemented to update the node's internal state when it is used to render an object.
   * The {@link Node#updateType} property defines how often the update is executed.
   *
   * @abstract
   * @param {NodeFrame} frame - A reference to the current node frame.
   * @return {?boolean} An optional bool that indicates whether the implementation actually performed an update or not (e.g. due to caching).
   */
  update() {
    X("Abstract function.");
  }
  before(e) {
    return this._beforeNodes === null && (this._beforeNodes = []), this._beforeNodes.push(e), this;
  }
  /**
   * This method performs the build of a node. The behavior and return value depend on the current build stage:
   * - **setup**: Prepares the node and its children for the build process. This process can also create new nodes. Returns the node itself or a variant.
   * - **analyze**: Analyzes the node hierarchy for optimizations in the code generation stage. Returns `null`.
   * - **generate**: Generates the shader code for the node. Returns the generated shader string.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {?(string|Node)} [output=null] - Can be used to define the output type.
   * @return {?(Node|string)} The result of the build process, depending on the build stage.
   */
  build(e, t = null) {
    const s = this.getShared(e);
    if (this !== s)
      return s.build(e, t);
    if (this._beforeNodes !== null) {
      const l = this._beforeNodes;
      this._beforeNodes = null;
      for (const u of l)
        u.build(e, t);
      this._beforeNodes = l;
    }
    const i = e.getDataFromNode(this);
    i.buildStages = i.buildStages || {}, i.buildStages[e.buildStage] = !0;
    const a = If[e.buildStage];
    if (a && i.buildStages[a] !== !0) {
      const l = e.getBuildStage();
      e.setBuildStage(a), this.build(e), e.setBuildStage(l);
    }
    e.addChain(this);
    let n = null;
    const o = e.getBuildStage();
    if (o === "setup") {
      e.addNode(this), this.updateReference(e);
      const l = e.getNodeProperties(this);
      if (l.initialized !== !0) {
        l.initialized = !0, l.outputNode = this.setup(e) || l.outputNode || null;
        for (const u of Object.values(l))
          if (u && u.isNode === !0) {
            if (u.parents === !0) {
              const h = e.getNodeProperties(u);
              h.parents = h.parents || [], h.parents.push(this);
            }
            u.build(e);
          }
        e.addSequentialNode(this);
      }
      n = l.outputNode;
    } else if (o === "analyze")
      this.analyze(e, t);
    else if (o === "generate") {
      if (this.generate.length < 2) {
        const l = this.getNodeType(e), u = e.getDataFromNode(this);
        n = u.snippet, n === void 0 ? u.generated === void 0 ? (u.generated = !0, n = this.generate(e) || "", u.snippet = n) : (X("Node: Recursion detected.", this), n = "/* Recursion detected. */") : u.flowCodes !== void 0 && e.context.nodeBlock !== void 0 && e.addFlowCodeHierarchy(this, e.context.nodeBlock), n = e.format(n, l, t);
      } else
        n = this.generate(e, t) || "";
      n === "" && t !== null && t !== "void" && t !== "OutputType" && (te(`TSL: Invalid generated code, expected a "${t}".`), n = e.generateConst(t));
    }
    return e.removeChain(this), n;
  }
  /**
   * Returns the child nodes as a JSON object.
   *
   * @return {Generator<Object>} An iterable list of serialized child objects as JSON.
   */
  getSerializeChildren() {
    return this._getChildren();
  }
  /**
   * Serializes the node to JSON.
   *
   * @param {Object} json - The output JSON object.
   */
  serialize(e) {
    const t = this.getSerializeChildren(), s = {};
    for (const { property: i, index: a, childNode: n } of t)
      a !== void 0 ? (s[i] === void 0 && (s[i] = Number.isInteger(a) ? [] : {}), s[i][a] = n.toJSON(e.meta).uuid) : s[i] = n.toJSON(e.meta).uuid;
    Object.keys(s).length > 0 && (e.inputNodes = s);
  }
  /**
   * Deserializes the node from the given JSON.
   *
   * @param {Object} json - The JSON object.
   */
  deserialize(e) {
    if (e.inputNodes !== void 0) {
      const t = e.meta.nodes;
      for (const s in e.inputNodes)
        if (Array.isArray(e.inputNodes[s])) {
          const i = [];
          for (const a of e.inputNodes[s])
            i.push(t[a]);
          this[s] = i;
        } else if (typeof e.inputNodes[s] == "object") {
          const i = {};
          for (const a in e.inputNodes[s]) {
            const n = e.inputNodes[s][a];
            i[a] = t[n];
          }
          this[s] = i;
        } else {
          const i = e.inputNodes[s];
          this[s] = t[i];
        }
    }
  }
  /**
   * Serializes the node into the three.js JSON Object/Scene format.
   *
   * @param {?Object} meta - An optional JSON object that already holds serialized data from other scene objects.
   * @return {Object} The serialized node.
   */
  toJSON(e) {
    const { uuid: t, type: s } = this, i = e === void 0 || typeof e == "string";
    i && (e = {
      textures: {},
      images: {},
      nodes: {}
    });
    let a = e.nodes[t];
    a === void 0 && (a = {
      uuid: t,
      type: s,
      meta: e,
      metadata: {
        version: 4.7,
        type: "Node",
        generator: "Node.toJSON"
      }
    }, i !== !0 && (e.nodes[a.uuid] = a), this.serialize(a), delete a.meta);
    function n(o) {
      const l = [];
      for (const u in o) {
        const h = o[u];
        delete h.metadata, l.push(h);
      }
      return l;
    }
    if (i) {
      const o = n(e.textures), l = n(e.images), u = n(e.nodes);
      o.length > 0 && (a.textures = o), l.length > 0 && (a.images = l), u.length > 0 && (a.nodes = u);
    }
    return a;
  }
}
k.captureStackTrace = !1;
class nr extends k {
  // @TODO: If extending from TempNode it breaks webgpu_compute
  static get type() {
    return "ArrayElementNode";
  }
  /**
   * Constructs an array element node.
   *
   * @param {Node} node - The array-like node.
   * @param {Node} indexNode - The index node that defines the element access.
   */
  constructor(e, t) {
    super(), this.node = e, this.indexNode = t, this.isArrayElementNode = !0;
  }
  /**
   * This method is overwritten since the node type is inferred from the array-like node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The node type.
   */
  generateNodeType(e) {
    return this.node.getElementType(e);
  }
  /**
   * This method is overwritten since the member type is inferred from the array-like node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {string} name - The member name.
   * @return {string} The member type.
   */
  getMemberType(e, t) {
    return this.node.getMemberType(e, t);
  }
  generate(e) {
    const t = this.indexNode.getNodeType(e), s = this.node.build(e), i = this.indexNode.build(e, !e.isVector(t) && e.isInteger(t) ? t : "uint");
    return `${s}[ ${i} ]`;
  }
}
class Kh extends k {
  static get type() {
    return "ConvertNode";
  }
  /**
   * Constructs a new convert node.
   *
   * @param {Node} node - The node which type should be converted.
   * @param {string} convertTo - The target node type. Multiple types can be defined by separating them with a `|` sign.
   */
  constructor(e, t) {
    super(), this.node = e, this.convertTo = t;
  }
  /**
   * This method is overwritten since the implementation tries to infer the best
   * matching type from the {@link ConvertNode#convertTo} property.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The node type.
   */
  generateNodeType(e) {
    const t = this.node.getNodeType(e);
    let s = null;
    for (const i of this.convertTo.split("|"))
      (s === null || e.getTypeLength(t) === e.getTypeLength(i)) && (s = i);
    return s;
  }
  serialize(e) {
    super.serialize(e), e.convertTo = this.convertTo;
  }
  deserialize(e) {
    super.deserialize(e), this.convertTo = e.convertTo;
  }
  generate(e, t) {
    const s = this.node, i = this.getNodeType(e), a = s.build(e, i);
    return e.format(a, i, t);
  }
}
class we extends k {
  static get type() {
    return "TempNode";
  }
  /**
   * Constructs a temp node.
   *
   * @param {?string} nodeType - The node type.
   */
  constructor(e = null) {
    super(e), this.isTempNode = !0;
  }
  /**
   * Whether this node is used more than once in context of other nodes.
   *
   * @param {NodeBuilder} builder - The node builder.
   * @return {boolean} A flag that indicates if there is more than one dependency to other nodes.
   */
  hasDependencies(e) {
    return e.getDataFromNode(this).usageCount > 1;
  }
  build(e, t) {
    if (e.getBuildStage() === "generate") {
      const s = e.getVectorType(this.getNodeType(e, t)), i = e.getDataFromNode(this);
      if (i.propertyName !== void 0)
        return e.format(i.propertyName, s, t);
      if (s !== "void" && t !== "void" && this.hasDependencies(e)) {
        const a = super.build(e, s), n = e.getVarFromNode(this, null, s), o = e.getPropertyName(n);
        return e.addLineFlowCode(`${o} = ${a}`, this), i.snippet = a, i.propertyName = o, e.format(i.propertyName, s, t);
      }
    }
    return super.build(e, t);
  }
}
class Pf extends we {
  static get type() {
    return "JoinNode";
  }
  /**
   * Constructs a new join node.
   *
   * @param {Array<Node>} nodes - An array of nodes that should be joined.
   * @param {?string} [nodeType=null] - The node type.
   */
  constructor(e = [], t = null) {
    super(t), this.nodes = e;
  }
  /**
   * This method is overwritten since the node type must be inferred from the
   * joined data length if not explicitly defined.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The node type.
   */
  generateNodeType(e) {
    return this.nodeType !== null ? e.getVectorType(this.nodeType) : e.getTypeFromLength(this.nodes.reduce((t, s) => t + e.getTypeLength(s.getNodeType(e)), 0));
  }
  generate(e, t) {
    const s = this.getNodeType(e), i = e.getTypeLength(s), a = this.nodes, n = e.getComponentType(s), o = [];
    let l = 0;
    for (const h of a) {
      if (l >= i) {
        te(`TSL: Length of parameters exceeds maximum length of function '${s}()' type.`, this.stackTrace);
        break;
      }
      let d = h.getNodeType(e), p = e.getTypeLength(d), m;
      if (l + p > i && (te(`TSL: Length of '${s}()' data exceeds maximum length of output type.`, this.stackTrace), p = i - l, d = e.getTypeFromLength(p)), l += p, m = h.build(e, d), e.getComponentType(d) !== n) {
        const g = e.getTypeFromLength(p, n);
        m = e.format(m, d, g);
      }
      o.push(m);
    }
    const u = `${e.getType(s)}( ${o.join(", ")} )`;
    return e.format(u, s, t);
  }
}
const Ff = Xr.join("");
class ec extends k {
  static get type() {
    return "SplitNode";
  }
  /**
   * Constructs a new split node.
   *
   * @param {Node} node - The node that should be accessed.
   * @param {string} [components='x'] - The components that should be accessed.
   */
  constructor(e, t = "x") {
    super(), this.node = e, this.components = t, this.isSplitNode = !0;
  }
  /**
   * Returns the vector length which is computed based on the requested components.
   *
   * @return {number} The vector length.
   */
  getVectorLength() {
    let e = this.components.length;
    for (const t of this.components)
      e = Math.max(Xr.indexOf(t) + 1, e);
    return e;
  }
  /**
   * Returns the component type of the node's type.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The component type.
   */
  getComponentType(e) {
    return e.getComponentType(this.node.getNodeType(e));
  }
  /**
   * This method is overwritten since the node type is inferred from requested components.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The node type.
   */
  generateNodeType(e) {
    return e.getTypeFromLength(this.components.length, this.getComponentType(e));
  }
  /**
   * Returns the scope of the node.
   *
   * @return {Node} The scope of the node.
   */
  getScope() {
    return this.node.getScope();
  }
  generate(e, t) {
    const s = this.node, i = e.getTypeLength(s.getNodeType(e));
    let a = null;
    if (i > 1) {
      let n = null;
      this.getVectorLength() >= i && (n = e.getTypeFromLength(this.getVectorLength(), this.getComponentType(e)));
      const o = s.build(e, n);
      this.components.length === i && this.components === Ff.slice(0, this.components.length) ? a = e.format(o, n, t) : a = e.format(`${o}.${this.components}`, this.getNodeType(e), t);
    } else
      a = s.build(e, t);
    return a;
  }
  serialize(e) {
    super.serialize(e), e.components = this.components;
  }
  deserialize(e) {
    super.deserialize(e), this.components = e.components;
  }
}
class Bf extends we {
  static get type() {
    return "SetNode";
  }
  /**
   * Constructs a new set node.
   *
   * @param {Node} sourceNode - The node that should be updated.
   * @param {string} components - The components that should be updated.
   * @param {Node} targetNode - The value node.
   */
  constructor(e, t, s) {
    super(), this.sourceNode = e, this.components = t, this.targetNode = s;
  }
  /**
   * This method is overwritten since the node type is inferred from {@link SetNode#sourceNode}.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The node type.
   */
  generateNodeType(e) {
    return this.sourceNode.getNodeType(e);
  }
  generate(e) {
    const { sourceNode: t, components: s, targetNode: i } = this, a = this.getNodeType(e), n = e.getComponentType(i.getNodeType(e)), o = e.getTypeFromLength(s.length, n), l = i.build(e, o), u = t.build(e, a), h = e.getTypeLength(a), d = [];
    for (let p = 0; p < h; p++) {
      const m = Xr[p];
      m === s[0] ? (d.push(l), p += s.length - 1) : d.push(u + "." + m);
    }
    return `${e.getType(a)}( ${d.join(", ")} )`;
  }
}
class Uf extends we {
  static get type() {
    return "FlipNode";
  }
  /**
   * Constructs a new flip node.
   *
   * @param {Node} sourceNode - The node which component(s) should be flipped.
   * @param {string} components - The components that should be flipped e.g. `'x'` or `'xy'`.
   */
  constructor(e, t) {
    super(), this.sourceNode = e, this.components = t;
  }
  /**
   * This method is overwritten since the node type is inferred from the source node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The node type.
   */
  generateNodeType(e) {
    return this.sourceNode.getNodeType(e);
  }
  generate(e) {
    const { components: t, sourceNode: s } = this, i = this.getNodeType(e), a = s.build(e), n = e.getVarFromNode(this), o = e.getPropertyName(n);
    e.addLineFlowCode(o + " = " + a, this);
    const l = e.getTypeLength(i), u = [];
    let h = 0;
    for (let d = 0; d < l; d++) {
      const p = Xr[d];
      p === t[h] ? (u.push("1.0 - " + (o + "." + p)), h++) : u.push(o + "." + p);
    }
    return `${e.getType(i)}( ${u.join(", ")} )`;
  }
}
class el extends k {
  static get type() {
    return "InputNode";
  }
  /**
   * Constructs a new input node.
   *
   * @param {any} value - The value of this node. This can be any JS primitive, functions, array buffers or even three.js objects (vector, matrices, colors).
   * @param {?string} nodeType - The node type. If no explicit type is defined, the node tries to derive the type from its value.
   */
  constructor(e, t = null) {
    super(t), this.isInputNode = !0, this.value = e, this.precision = null;
  }
  generateNodeType() {
    return this.nodeType === null ? Cs(this.value) : this.nodeType;
  }
  /**
   * Returns the input type of the node which is by default the node type. Derived modules
   * might overwrite this method and use a fixed type or compute one analytically.
   *
   * A typical example for different input and node types are textures. The input type of a
   * normal RGBA texture is `texture` whereas its node type is `vec4`.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The input type.
   */
  getInputType(e) {
    return this.getNodeType(e);
  }
  /**
   * Sets the precision to the given value. The method can be
   * overwritten in derived classes if the final precision must be computed
   * analytically.
   *
   * @param {('low'|'medium'|'high')} precision - The precision of the input value in the shader.
   * @return {InputNode} A reference to this node.
   */
  setPrecision(e) {
    return this.precision = e, this;
  }
  serialize(e) {
    super.serialize(e), e.value = this.value, this.value && this.value.toArray && (e.value = this.value.toArray()), e.valueType = Cs(this.value), e.nodeType = this.nodeType, e.valueType === "ArrayBuffer" && (e.value = Cf(e.value)), e.precision = this.precision;
  }
  deserialize(e) {
    super.deserialize(e), this.nodeType = e.nodeType, this.value = Array.isArray(e.value) ? Ko(e.valueType, ...e.value) : e.value, this.precision = e.precision || null, this.value && this.value.fromArray && (this.value = this.value.fromArray(e.value));
  }
  generate() {
    X("Abstract function.");
  }
}
const qu = /float|u?int/;
class es extends el {
  static get type() {
    return "ConstNode";
  }
  /**
   * Constructs a new input node.
   *
   * @param {any} value - The value of this node. Usually a JS primitive or three.js object (vector, matrix, color).
   * @param {?string} nodeType - The node type. If no explicit type is defined, the node tries to derive the type from its value.
   */
  constructor(e, t = null) {
    super(e, t), this.isConstNode = !0;
  }
  /**
   * Generates the shader string of the value with the current node builder.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The generated value as a shader string.
   */
  generateConst(e) {
    return e.generateConst(this.getNodeType(e), this.value);
  }
  generate(e, t) {
    const s = this.getNodeType(e);
    return qu.test(s) && qu.test(t) ? e.generateConst(t, this.value) : e.format(this.generateConst(e), s, t);
  }
}
class kf extends k {
  static get type() {
    return "MemberNode";
  }
  /**
   * Constructs a member node.
   *
   * @param {Node} structNode - The struct node.
   * @param {string} property - The property name.
   */
  constructor(e, t) {
    super(), this.structNode = e, this.property = t, this.isMemberNode = !0;
  }
  hasMember(e) {
    return this.structNode.isMemberNode && this.structNode.hasMember(e) === !1 ? !1 : this.structNode.getMemberType(e, this.property) !== "void";
  }
  generateNodeType(e) {
    return this.hasMember(e) === !1 ? "float" : this.structNode.getMemberType(e, this.property);
  }
  getMemberType(e, t) {
    if (this.hasMember(e) === !1)
      return "float";
    const s = this.getNodeType(e);
    return e.getStructTypeNode(s).getMemberType(e, t);
  }
  generate(e) {
    if (this.hasMember(e) === !1) {
      X(`TSL: Member "${this.property}" does not exist in struct.`, this.stackTrace);
      const t = this.getNodeType(e);
      return e.generateConst(t);
    }
    return this.structNode.build(e) + "." + this.property;
  }
}
let Is = null;
const To = /* @__PURE__ */ new Map();
function S(r, e) {
  if (To.has(r)) {
    X(`TSL: Redefinition of method chaining '${r}'.`);
    return;
  }
  if (typeof e != "function") throw new Error(`THREE.TSL: Node element ${r} is not a function`);
  To.set(r, e), r !== "assign" && (k.prototype[r] = function(...t) {
    return this.isStackNode ? this.addToStack(e(...t)) : e(this, ...t);
  }, k.prototype[r + "Assign"] = function(...t) {
    return this.isStackNode ? this.assign(t[0], e(...t)) : this.assign(e(this, ...t));
  });
}
const Df = (r) => r.replace(/r|s/g, "x").replace(/g|t/g, "y").replace(/b|p/g, "z").replace(/a|q/g, "w"), ju = (r) => Df(r).split("").sort().join("");
k.prototype.assign = function(...r) {
  if (this.isStackNode !== !0)
    return Is !== null ? Is.assign(this, ...r) : te("TSL: No stack defined for assign operation. Make sure the assign is inside a Fn().", new Re()), this;
  {
    const e = To.get("assign");
    return this.addToStack(e(...r));
  }
};
k.prototype.toVarIntent = function() {
  return this;
};
k.prototype.get = function(r) {
  return new kf(this, r);
};
const gi = {};
function Zi(r, e, t) {
  gi[r] = gi[e] = gi[t] = {
    get() {
      this._cache = this._cache || {};
      let n = this._cache[r];
      return n === void 0 && (n = new ec(this, r), this._cache[r] = n), n;
    },
    set(n) {
      this[r].assign(U(n));
    }
  };
  const s = r.toUpperCase(), i = e.toUpperCase(), a = t.toUpperCase();
  k.prototype["set" + s] = k.prototype["set" + i] = k.prototype["set" + a] = function(n) {
    const o = ju(r);
    return new Bf(this, o, U(n));
  }, k.prototype["flip" + s] = k.prototype["flip" + i] = k.prototype["flip" + a] = function() {
    const n = ju(r);
    return new Uf(this, n);
  };
}
const Dt = ["x", "y", "z", "w"], Wt = ["r", "g", "b", "a"], qt = ["s", "t", "p", "q"];
for (let r = 0; r < 4; r++) {
  let e = Dt[r], t = Wt[r], s = qt[r];
  Zi(e, t, s);
  for (let i = 0; i < 4; i++) {
    e = Dt[r] + Dt[i], t = Wt[r] + Wt[i], s = qt[r] + qt[i], Zi(e, t, s);
    for (let a = 0; a < 4; a++) {
      e = Dt[r] + Dt[i] + Dt[a], t = Wt[r] + Wt[i] + Wt[a], s = qt[r] + qt[i] + qt[a], Zi(e, t, s);
      for (let n = 0; n < 4; n++)
        e = Dt[r] + Dt[i] + Dt[a] + Dt[n], t = Wt[r] + Wt[i] + Wt[a] + Wt[n], s = qt[r] + qt[i] + qt[a] + qt[n], Zi(e, t, s);
    }
  }
}
for (let r = 0; r < 32; r++)
  gi[r] = {
    get() {
      this._cache = this._cache || {};
      let e = this._cache[r];
      return e === void 0 && (e = new nr(this, new es(r, "uint")), this._cache[r] = e), e;
    },
    set(e) {
      this[r].assign(U(e));
    }
  };
Object.defineProperties(k.prototype, gi);
const Wf = function(r, e = null) {
  const t = Cs(r);
  return t === "node" ? r : e === null && (t === "float" || t === "boolean") || t && t !== "shader" && t !== "string" ? U(wo(r, e)) : t === "shader" ? r.isFn ? r : b(r) : r;
}, qf = function(r, e = null) {
  for (const t in r)
    r[t] = U(r[t], e);
  return r;
}, jf = function(r, e = null) {
  const t = r.length;
  for (let s = 0; s < t; s++)
    r[s] = U(r[s], e);
  return r;
}, tc = function(r, e = null, t = null, s = null) {
  function i(h) {
    return s !== null ? (h = U(Object.assign(h, s)), s.intent === !0 && (h = h.toVarIntent())) : h = U(h), h;
  }
  let a, n = e, o, l;
  function u(h) {
    let d;
    return n ? d = /[a-z]/i.test(n) ? n + "()" : n : d = r.type, o !== void 0 && h.length < o ? (te(`TSL: "${d}" parameter length is less than minimum required.`, new Re()), h.concat(new Array(o - h.length).fill(0))) : l !== void 0 && h.length > l ? (te(`TSL: "${d}" parameter length exceeds limit.`, new Re()), h.slice(0, l)) : h;
  }
  return e === null ? a = (...h) => i(new r(...Qs(u(h)))) : t !== null ? (t = U(t), a = (...h) => i(new r(e, ...Qs(u(h)), t))) : a = (...h) => i(new r(e, ...Qs(u(h)))), a.setParameterLength = (...h) => (h.length === 1 ? o = l = h[0] : h.length === 2 && ([o, l] = h), a), a.setName = (h) => (n = h, a), a;
}, Gf = function(r, ...e) {
  return new r(...Qs(e));
};
class Hf extends k {
  constructor(e, t) {
    super(), this.shaderNode = e, this.rawInputs = t, this.isShaderCallNodeInternal = !0;
  }
  generateNodeType(e) {
    return this.shaderNode.nodeType || this.getOutputNode(e).getNodeType(e);
  }
  getElementType(e) {
    return this.getOutputNode(e).getElementType(e);
  }
  getMemberType(e, t) {
    return this.getOutputNode(e).getMemberType(e, t);
  }
  call(e) {
    const { shaderNode: t, rawInputs: s } = this, i = e.getNodeProperties(t), a = e.getClosestSubBuild(t.subBuilds) || "", n = a || "default";
    if (i[n])
      return i[n];
    const o = e.subBuildFn, l = e.fnCall;
    e.subBuildFn = a, e.fnCall = this;
    let u = null;
    if (t.layout) {
      if (s) {
        const p = t.layout.inputs;
        if (sc(s)) {
          const m = s;
          for (let g = 0; g < p.length; g++) {
            const y = m[g];
            y && y.isNode && y.build(e);
          }
        } else {
          const m = s[0];
          for (const g of p) {
            const y = m[g.name];
            y && y.isNode && y.build(e);
          }
        }
      }
      const h = e.buildFunctionNode(t);
      e.addInclude(h);
      const d = s ? Xf(s) : null;
      u = h.call(d);
    } else {
      const h = new Proxy(e, {
        get: (y, v, w) => {
          let _;
          return Symbol.iterator === v ? _ = function* () {
            yield void 0;
          } : _ = Reflect.get(y, v, w), _;
        }
      }), d = s ? $f(s) : null, p = Array.isArray(s) ? s.length > 0 : s !== null, m = t.jsFunc, g = p || m.length > 1 ? m(d, h) : m(h);
      u = U(g);
    }
    return e.subBuildFn = o, e.fnCall = l, t.once && (i[n] = u), u;
  }
  setupOutput(e) {
    return e.addStack(), e.stack.outputNode = this.call(e), e.removeStack();
  }
  getOutputNode(e) {
    const t = e.getNodeProperties(this), s = e.getSubBuildOutput(this);
    return t[s] = t[s] || this.setupOutput(e), t[s].subBuild = e.getClosestSubBuild(this), t[s];
  }
  build(e, t = null) {
    let s = null;
    const i = e.getBuildStage(), a = e.getNodeProperties(this), n = e.getSubBuildOutput(this), o = this.getOutputNode(e), l = e.fnCall;
    if (e.fnCall = this, i === "setup") {
      const u = e.getSubBuildProperty("initialized", this);
      if (a[u] !== !0 && (a[u] = !0, a[n] = this.getOutputNode(e), a[n].build(e), this.shaderNode.subBuilds))
        for (const h of e.chaining) {
          const d = e.getDataFromNode(h, "any");
          d.subBuilds = d.subBuilds || /* @__PURE__ */ new Set();
          for (const p of this.shaderNode.subBuilds)
            d.subBuilds.add(p);
        }
      s = a[n];
    } else i === "analyze" ? o.build(e, t) : i === "generate" && (s = o.build(e, t) || "");
    return e.fnCall = l, s;
  }
}
function sc(r) {
  return r[0] && (r[0].isNode || Object.getPrototypeOf(r[0]) !== Object.prototype);
}
function Xf(r) {
  let e;
  return ja(r), sc(r) ? e = [...r] : e = r[0], e;
}
function $f(r) {
  let e = 0;
  return ja(r), new Proxy(r, {
    get: (t, s, i) => {
      let a;
      if (s === "length")
        return a = r.length, a;
      if (Symbol.iterator === s)
        a = function* () {
          for (const n of r)
            yield U(n);
        };
      else {
        if (r.length > 0)
          if (Object.getPrototypeOf(r[0]) === Object.prototype) {
            const n = r[0];
            n[s] === void 0 ? a = n[e++] : a = Reflect.get(n, s, i);
          } else r[0] instanceof k && (r[s] === void 0 ? a = r[e++] : a = Reflect.get(r, s, i));
        else
          a = Reflect.get(t, s, i);
        a = U(a);
      }
      return a;
    }
  });
}
class Yf extends k {
  constructor(e, t) {
    super(t), this.jsFunc = e, this.layout = null, this.global = !0, this.once = !1;
  }
  setLayout(e) {
    return this.layout = e, this;
  }
  getLayout() {
    return this.layout;
  }
  call(e = null) {
    return new Hf(this, e);
  }
  setup() {
    return this.call();
  }
}
const Zf = [!1, !0], Jf = [0, 1, 2, 3], Qf = [-1, -2], rc = [0.5, 1.5, 1 / 3, 1e-6, 1e6, Math.PI, Math.PI * 2, 1 / Math.PI, 2 / Math.PI, 1 / (Math.PI * 2), Math.PI / 2], tl = /* @__PURE__ */ new Map();
for (const r of Zf) tl.set(r, new es(r));
const sl = /* @__PURE__ */ new Map();
for (const r of Jf) sl.set(r, new es(r, "uint"));
const rl = new Map([...sl].map((r) => new es(r.value, "int")));
for (const r of Qf) rl.set(r, new es(r, "int"));
const Wa = new Map([...rl].map((r) => new es(r.value)));
for (const r of rc) Wa.set(r, new es(r));
for (const r of rc) Wa.set(-r, new es(-r));
const qa = { bool: tl, uint: sl, ints: rl, float: Wa }, Gu = new Map([...tl, ...Wa]), wo = (r, e) => Gu.has(r) ? Gu.get(r) : r.isNode === !0 ? r : new es(r, e), Le = function(r, e = null) {
  return (...t) => {
    for (const i of t)
      if (i === void 0)
        return te(`TSL: Invalid parameter for the type "${r}".`, new Re()), new es(0, r);
    if ((t.length === 0 || !["bool", "float", "int", "uint"].includes(r) && t.every((i) => {
      const a = typeof i;
      return a !== "object" && a !== "function";
    })) && (t = [Ko(r, ...t)]), t.length === 1 && e !== null && e.has(t[0]))
      return ci(e.get(t[0]));
    if (t.length === 1) {
      const i = wo(t[0], r);
      return i.nodeType === r ? ci(i) : ci(new Kh(i, r));
    }
    const s = t.map((i) => wo(i));
    return ci(new Pf(s, r));
  };
};
function Dr(r) {
  return r && r.isNode && r.traverse((e) => {
    e.isConstNode && (r = e.value);
  }), !!r;
}
const ic = (r) => r != null ? r.nodeType || r.convertTo || (typeof r == "string" ? r : null) : null;
function Er(r, e) {
  return new Yf(r, e);
}
const U = (r, e = null) => (
  /* new */
  Wf(r, e)
), ci = (r, e = null) => (
  /* new */
  U(r, e).toVarIntent()
), ja = (r, e = null) => new qf(r, e), Qs = (r, e = null) => new jf(r, e), Y = (r, e = null, t = null, s = null) => new tc(r, e, t, s), O = (r, ...e) => new Gf(r, ...e), L = (r, e = null, t = null, s = {}) => new tc(r, e, t, { ...s, intent: !0 }), il = (r, e) => new Proxy(r, {
  get(t, s, i) {
    return Reflect.get(e, s, i);
  },
  set(t, s, i) {
    return Reflect.set(e, s, i);
  }
});
let Kf = 0;
class ey extends k {
  constructor(e, t = null) {
    super();
    let s = null;
    t !== null && (typeof t == "object" ? s = t.return : (typeof t == "string" ? s = t : te("TSL: Invalid layout type.", new Re()), t = null)), this.shaderNode = new Er(e, s), t !== null && this.setLayout(t), this.isFn = !0;
  }
  setLayout(e) {
    const t = this.shaderNode.nodeType;
    if (typeof e.inputs != "object") {
      const s = {
        name: "fn" + Kf++,
        type: t,
        inputs: []
      };
      for (const i in e)
        i !== "return" && s.inputs.push({
          name: i,
          type: e[i]
        });
      e = s;
    }
    return this.shaderNode.setLayout(e), this;
  }
  generateNodeType(e) {
    return this.shaderNode.getNodeType(e) || "float";
  }
  call(...e) {
    const t = this.shaderNode.call(e);
    return this.shaderNode.nodeType === "void" && t.toStack(), t.toVarIntent();
  }
  once(e = null) {
    return this.shaderNode.once = !0, this.shaderNode.subBuilds = e, this;
  }
  generate(e) {
    const t = this.getNodeType(e);
    return te('TSL: "Fn()" was declared but not invoked. Try calling it like "Fn()( ...params )".', this.stackTrace), e.generateConst(t);
  }
}
function b(r, e = null) {
  const t = new ey(r, e);
  return new Proxy(() => {
  }, {
    apply(s, i, a) {
      return t.call(...a);
    },
    get(s, i, a) {
      return Reflect.get(t, i, a);
    },
    set(s, i, a, n) {
      return Reflect.set(t, i, a, n);
    }
  });
}
const No = (r) => {
  Is = r;
}, ac = () => Is, W = (...r) => Is.If(...r), ty = (...r) => Is.Switch(...r);
function Ga(r) {
  return Is && Is.addToStack(r), r;
}
S("toStack", Ga);
const nc = new Le("color"), f = new Le("float", qa.float), x = new Le("int", qa.ints), E = new Le("uint", qa.uint), mt = new Le("bool", qa.bool), B = new Le("vec2"), ye = new Le("ivec2"), al = new Le("uvec2"), oc = new Le("bvec2"), N = new Le("vec3"), nl = new Le("ivec3"), or = new Le("uvec3"), ol = new Le("bvec3"), D = new Le("vec4"), ll = new Le("ivec4"), ul = new Le("uvec4"), lc = new Le("bvec4"), Ha = new Le("mat2"), gt = new Le("mat3"), Rs = new Le("mat4");
S("toColor", nc);
S("toFloat", f);
S("toInt", x);
S("toUint", E);
S("toBool", mt);
S("toVec2", B);
S("toIVec2", ye);
S("toUVec2", al);
S("toBVec2", oc);
S("toVec3", N);
S("toIVec3", nl);
S("toUVec3", or);
S("toBVec3", ol);
S("toVec4", D);
S("toIVec4", ll);
S("toUVec4", ul);
S("toBVec4", lc);
S("toMat2", Ha);
S("toMat3", gt);
S("toMat4", Rs);
const uc = /* @__PURE__ */ Y(nr).setParameterLength(2), hc = (r, e) => new Kh(U(r), e), sy = (r, e) => new ec(U(r), e);
S("element", uc);
S("convert", hc);
const ry = (r) => (X("TSL: append() has been renamed to Stack().", new Re()), Ga(r));
S("append", (r) => (X("TSL: .append() has been renamed to .toStack().", new Re()), Ga(r)));
class re extends k {
  static get type() {
    return "PropertyNode";
  }
  /**
   * Constructs a new property node.
   *
   * @param {string} nodeType - The type of the node.
   * @param {?string} [name=null] - The name of the property in the shader.
   * @param {boolean} [varying=false] - Whether this property is a varying or not.
   * @param {?Node} [placeholderNode=null] - The placeholder node if not assigned.
   */
  constructor(e, t = null, s = !1, i = null) {
    super(e), this.name = t, this.varying = s, this.placeholderNode = U(i), this.isPropertyNode = !0, this.global = !0;
  }
  getNodeType(e) {
    const t = super.getNodeType(e);
    return t === "output" ? e.getOutputType() : t;
  }
  customCacheKey() {
    return Jo(this.type + ":" + (this.name || "") + ":" + (this.varying ? "1" : "0"));
  }
  getHash(e) {
    return this.name || super.getHash(e);
  }
  generate(e) {
    let t;
    if (this.varying === !0)
      t = e.getVaryingFromNode(this, this.name), t.needsInterpolation = !0;
    else if (t = e.getVarFromNode(this, this.name), this.placeholderNode !== null && e.hasWriteUsage(this) === !1) {
      const s = this.placeholderNode.build(e, this.getNodeType(e));
      e.addLineFlowCode(`${e.getPropertyName(t)} = ${s}`, this);
    }
    return e.getPropertyName(t);
  }
}
const ys = (r, e, t = null) => new re(r, e, !1, t), lr = (r, e, t = null) => new re(r, e, !0, t), Je = /* @__PURE__ */ O(re, "vec4", "DiffuseColor"), iy = /* @__PURE__ */ O(re, "vec3", "DiffuseContribution"), Mo = /* @__PURE__ */ O(re, "vec3", "EmissiveColor"), cc = /* @__PURE__ */ O(re, "float", "Roughness"), ay = /* @__PURE__ */ O(re, "float", "Metalness"), ny = /* @__PURE__ */ O(re, "float", "Clearcoat"), oy = /* @__PURE__ */ O(re, "float", "ClearcoatRoughness"), ly = /* @__PURE__ */ O(re, "vec3", "Sheen"), uy = /* @__PURE__ */ O(re, "float", "SheenRoughness"), dc = /* @__PURE__ */ O(re, "float", "Iridescence"), hy = /* @__PURE__ */ O(re, "float", "IridescenceIOR"), cy = /* @__PURE__ */ O(re, "float", "IridescenceThickness"), So = /* @__PURE__ */ O(re, "float", "AlphaT"), pc = /* @__PURE__ */ O(re, "float", "Anisotropy"), xa = /* @__PURE__ */ O(re, "vec3", "AnisotropyT"), Pr = /* @__PURE__ */ O(re, "vec3", "AnisotropyB"), dy = /* @__PURE__ */ O(re, "color", "SpecularColor"), py = /* @__PURE__ */ O(re, "color", "SpecularColorBlended"), my = /* @__PURE__ */ O(re, "float", "SpecularF90"), gy = /* @__PURE__ */ O(re, "float", "Shininess"), Fr = /* @__PURE__ */ O(re, "output", "Output"), ba = /* @__PURE__ */ O(re, "float", "dashSize"), _o = /* @__PURE__ */ O(re, "float", "gapSize"), fy = /* @__PURE__ */ O(re, "float", "pointWidth"), yy = /* @__PURE__ */ O(re, "float", "IOR"), xy = /* @__PURE__ */ O(re, "float", "Transmission"), by = /* @__PURE__ */ O(re, "float", "Thickness"), vy = /* @__PURE__ */ O(re, "float", "AttenuationDistance"), Ty = /* @__PURE__ */ O(re, "color", "AttenuationColor"), wy = /* @__PURE__ */ O(re, "float", "Dispersion"), Ao = /* @__PURE__ */ O(re, "float", "AmbientOcclusion", !1, 1);
class mc extends k {
  static get type() {
    return "UniformGroupNode";
  }
  /**
   * Constructs a new uniform group node.
   *
   * @param {string} name - The name of the uniform group node.
   * @param {boolean} [shared=false] - Whether this uniform group node is shared or not.
   * @param {number} [order=1] - Influences the internal sorting.
   * @param {string|null} [updateType=null] - The update type of the uniform group node.
   */
  constructor(e, t = !1, s = 1, i = null) {
    super("string"), this.name = e, this.shared = t, this.order = s, this.updateType = i, this.isUniformGroup = !0;
  }
  /**
   * Marks the uniform group node as needing an update.
   * This will trigger the necessary updates in the rendering process.
   */
  update() {
    this.needsUpdate = !0;
  }
  /**
   * Serializes the uniform group node to a JSON object.
   *
   * @param {Object} data - The object to store the serialized data.
   */
  serialize(e) {
    super.serialize(e), e.name = this.name, e.version = this.version, e.shared = this.shared;
  }
  /**
   * Deserializes the uniform group node from a JSON object.
   *
   * @param {Object} data - The object containing the serialized data.
   */
  deserialize(e) {
    super.deserialize(e), this.name = e.name, this.version = e.version, this.shared = e.shared;
  }
}
const gc = (r, e = 1, t = null) => new mc(r, !1, e, t), Xa = (r, e = 0, t = null) => new mc(r, !0, e, t), Ny = /* @__PURE__ */ Xa("frame", 0, Q.FRAME), H = /* @__PURE__ */ Xa("render", 0, Q.RENDER), fc = /* @__PURE__ */ gc("object", 1, Q.OBJECT);
class Mi extends el {
  static get type() {
    return "UniformNode";
  }
  /**
   * Constructs a new uniform node.
   *
   * @param {any} value - The value of this node. Usually a JS primitive or three.js object (vector, matrix, color, texture).
   * @param {?string} nodeType - The node type. If no explicit type is defined, the node tries to derive the type from its value.
   */
  constructor(e, t = null) {
    super(e, t), this.isUniformNode = !0, this.name = "", this.groupNode = fc;
  }
  /**
   * Sets the {@link UniformNode#name} property.
   *
   * @param {string} name - The name of the uniform.
   * @return {UniformNode} A reference to this node.
   */
  setName(e) {
    return this.name = e, this;
  }
  /**
   * Sets the {@link UniformNode#name} property.
   *
   * @deprecated
   * @param {string} name - The name of the uniform.
   * @return {UniformNode} A reference to this node.
   */
  label(e) {
    return X('TSL: "label()" has been deprecated. Use "setName()" instead.', new Re()), this.setName(e);
  }
  /**
   * Sets the {@link UniformNode#groupNode} property.
   *
   * @param {UniformGroupNode} group - The uniform group.
   * @return {UniformNode} A reference to this node.
   */
  setGroup(e) {
    return this.groupNode = e, this;
  }
  /**
   * Returns the {@link UniformNode#groupNode}.
   *
   * @return {UniformGroupNode} The uniform group.
   */
  getGroup() {
    return this.groupNode;
  }
  /**
   * By default, this method returns the result of {@link Node#getHash} but derived
   * classes might overwrite this method with a different implementation.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The uniform hash.
   */
  getUniformHash(e) {
    return this.getHash(e);
  }
  onUpdate(e, t) {
    return e = e.bind(this), super.onUpdate((s) => {
      const i = e(s, this);
      i !== void 0 && (this.value = i);
    }, t);
  }
  getInputType(e) {
    let t = super.getInputType(e);
    return t === "bool" && (t = "uint"), t;
  }
  generate(e, t) {
    const s = this.getNodeType(e), i = this.getUniformHash(e);
    let a = e.getNodeFromHash(i);
    a === void 0 && (e.setHashNode(this, i), a = this);
    const n = a.getInputType(e), o = e.getUniformFromNode(a, n, e.shaderStage, this.name || e.context.nodeName), l = e.getPropertyName(o);
    e.context.nodeName !== void 0 && delete e.context.nodeName;
    let u = l;
    if (s === "bool") {
      const h = e.getDataFromNode(this);
      let d = h.propertyName;
      if (d === void 0) {
        const p = e.getVarFromNode(this, null, "bool");
        d = e.getPropertyName(p), h.propertyName = d, u = e.format(l, n, s), e.addLineFlowCode(`${d} = ${u}`, this);
      }
      u = d;
    }
    return e.format(u, s, t);
  }
}
const q = (r, e) => {
  const t = ic(e || r);
  if (t === r && (r = Ko(t)), r && r.isNode === !0) {
    let s = r.value;
    r.traverse((i) => {
      i.isConstNode === !0 && (s = i.value);
    }), r = s;
  }
  return new Mi(r, t);
};
class Hu extends we {
  static get type() {
    return "ArrayNode";
  }
  /**
   * Constructs a new array node.
   *
   * @param {?string} nodeType - The data type of the elements.
   * @param {number} count - Size of the array.
   * @param {?Array<Node>} [values=null] - Array default values.
   */
  constructor(e, t, s = null) {
    super(e), this.count = t, this.values = s, this.isArrayNode = !0;
  }
  /**
   * Returns the number of elements in the node array.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {number} The number of elements in the node array.
   */
  getArrayCount() {
    return this.count;
  }
  /**
   * Returns the node's type.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The type of the node.
   */
  generateNodeType(e) {
    return this.nodeType === null ? this.values[0].getNodeType(e) : this.nodeType;
  }
  /**
   * Returns the node's type.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The type of the node.
   */
  getElementType(e) {
    return this.getNodeType(e);
  }
  /**
   * Returns the type of a member variable.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {string} name - The name of the member variable.
   * @return {string} The type of the member variable.
   */
  getMemberType(e, t) {
    return this.nodeType === null ? this.values[0].getMemberType(e, t) : super.getMemberType(e, t);
  }
  /**
   * This method builds the output node and returns the resulting array as a shader string.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The generated shader string.
   */
  generate(e) {
    const t = this.getNodeType(e);
    return e.generateArray(t, this.count, this.values);
  }
}
const yc = (...r) => {
  let e;
  if (r.length === 1) {
    const t = r[0];
    e = new Hu(null, t.length, t);
  } else {
    const t = r[0], s = r[1];
    e = new Hu(t, s);
  }
  return U(e);
};
S("toArray", (r, e) => yc(Array(e).fill(r)));
class My extends we {
  static get type() {
    return "AssignNode";
  }
  /**
   * Constructs a new assign node.
   *
   * @param {Node} targetNode - The target node.
   * @param {Node} sourceNode - The source type.
   */
  constructor(e, t) {
    super(), this.targetNode = e, this.sourceNode = t, this.isAssignNode = !0;
  }
  /**
   * Whether this node is used more than once in context of other nodes. This method
   * is overwritten since it always returns `false` (assigns are unique).
   *
   * @return {boolean} A flag that indicates if there is more than one dependency to other nodes. Always `false`.
   */
  hasDependencies() {
    return !1;
  }
  generateNodeType(e, t) {
    return t !== "void" ? this.targetNode.getNodeType(e) : "void";
  }
  /**
   * Whether a split is required when assigning source to target. This can happen when the component length of
   * target and source data type does not match.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {boolean} Whether a split is required when assigning source to target.
   */
  needsSplitAssign(e) {
    const { targetNode: t } = this;
    if (e.isAvailable("swizzleAssign") === !1 && t.isSplitNode && t.components.length > 1) {
      const s = e.getTypeLength(t.node.getNodeType(e));
      return Xr.join("").slice(0, s) !== t.components;
    }
    return !1;
  }
  setup(e) {
    const { targetNode: t, sourceNode: s } = this, i = t.getScope(), a = e.getDataFromNode(i);
    a.assign = !0;
    const n = e.getNodeProperties(this);
    n.sourceNode = s, n.targetNode = t.context({ assign: !0 });
  }
  generate(e, t) {
    const { targetNode: s, sourceNode: i } = e.getNodeProperties(this), a = this.needsSplitAssign(e), n = s.build(e), o = s.getNodeType(e), l = i.build(e, o), u = i.getNodeType(e), h = e.getDataFromNode(this);
    let d;
    if (h.initialized === !0)
      t !== "void" && (d = n);
    else if (a) {
      const p = e.getVarFromNode(this, null, o), m = e.getPropertyName(p);
      e.addLineFlowCode(`${m} = ${l}`, this);
      const g = s.node, y = g.node.context({ assign: !0 }).build(e);
      for (let v = 0; v < g.components.length; v++) {
        const w = g.components[v];
        e.addLineFlowCode(`${y}.${w} = ${m}[ ${v} ]`, this);
      }
      t !== "void" && (d = n);
    } else
      d = `${n} = ${l}`, (t === "void" || u === "void") && (e.addLineFlowCode(d, this), t !== "void" && (d = n));
    return h.initialized = !0, e.format(d, o, t);
  }
}
const xc = /* @__PURE__ */ Y(My).setParameterLength(2);
S("assign", xc);
class Sy extends we {
  static get type() {
    return "FunctionCallNode";
  }
  /**
   * Constructs a new function call node.
   *
   * @param {?FunctionNode} functionNode - The function node.
   * @param {Object<string, Node>} [parameters={}] - The parameters for the function call.
   */
  constructor(e = null, t = {}) {
    super(), this.functionNode = e, this.parameters = t;
  }
  /**
   * Sets the parameters of the function call node.
   *
   * @param {Object<string, Node>} parameters - The parameters to set.
   * @return {FunctionCallNode} A reference to this node.
   */
  setParameters(e) {
    return this.parameters = e, this;
  }
  /**
   * Returns the parameters of the function call node.
   *
   * @return {Object<string, Node>} The parameters of this node.
   */
  getParameters() {
    return this.parameters;
  }
  /**
   * Returns the type of this function call node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @returns {string} The type of this node.
   */
  generateNodeType(e) {
    return this.functionNode.getNodeType(e);
  }
  /**
   * Returns the function node of this function call node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {string} [name] - The name of the member.
   * @returns {string} The type of the member.
   */
  getMemberType(e, t) {
    return this.functionNode.getMemberType(e, t);
  }
  generate(e) {
    const t = [], s = this.functionNode, i = s.getInputs(e), a = this.parameters, n = (o, l) => {
      const u = l.type, h = u === "pointer";
      let d;
      return h ? d = "&" + o.build(e) : d = o.build(e, u), d;
    };
    if (Array.isArray(a)) {
      if (a.length > i.length)
        te("TSL: The number of provided parameters exceeds the expected number of inputs in 'Fn()'."), a.length = i.length;
      else if (a.length < i.length)
        for (te("TSL: The number of provided parameters is less than the expected number of inputs in 'Fn()'."); a.length < i.length; )
          a.push(f(0));
      for (let o = 0; o < a.length; o++)
        t.push(n(a[o], i[o]));
    } else
      for (const o of i) {
        const l = a[o.name];
        l !== void 0 ? t.push(n(l, o)) : (te(`TSL: Input '${o.name}' not found in 'Fn()'.`), t.push(n(f(0), o)));
      }
    return `${s.build(e, "property")}( ${t.join(", ")} )`;
  }
}
const bc = (r, ...e) => (e = e.length > 1 || e[0] && e[0].isNode === !0 ? Qs(e) : ja(e[0]), new Sy(U(r), e));
S("call", bc);
const _y = {
  "==": "equal",
  "!=": "notEqual",
  "<": "lessThan",
  ">": "greaterThan",
  "<=": "lessThanEqual",
  ">=": "greaterThanEqual",
  "%": "mod"
};
class be extends we {
  static get type() {
    return "OperatorNode";
  }
  /**
   * Constructs a new operator node.
   *
   * @param {string} op - The operator.
   * @param {Node} aNode - The first input.
   * @param {Node} bNode - The second input.
   * @param {...Node} params - Additional input parameters.
   */
  constructor(e, t, s, ...i) {
    if (super(), i.length > 0) {
      let a = new be(e, t, s);
      for (let n = 0; n < i.length - 1; n++)
        a = new be(e, a, i[n]);
      t = a, s = i[i.length - 1];
    }
    this.op = e, this.aNode = t, this.bNode = s, this.isOperatorNode = !0;
  }
  /**
   * Returns the operator method name.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {string} output - The output type.
   * @returns {string} The operator method name.
   */
  getOperatorMethod(e, t) {
    return e.getMethod(_y[this.op], t);
  }
  /**
   * This method is overwritten since the node type is inferred from the operator
   * and the input node types.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {?string} [output=null] - The output type.
   * @return {string} The node type.
   */
  generateNodeType(e, t = null) {
    const s = this.op, i = this.aNode, a = this.bNode, n = i.getNodeType(e), o = a ? a.getNodeType(e) : null;
    if (n === "void" || o === "void")
      return t || "void";
    if (s === "%")
      return n;
    if (s === "~" || s === "&" || s === "|" || s === "^" || s === ">>" || s === "<<")
      return e.getIntegerType(n);
    if (s === "&&" || s === "||" || s === "^^")
      return "bool";
    if (s === "!") {
      const l = e.getTypeLength(n);
      return l > 1 ? `bvec${l}` : "bool";
    } else if (s === "==" || s === "!=" || s === "<" || s === ">" || s === "<=" || s === ">=") {
      const l = Math.max(e.getTypeLength(n), e.getTypeLength(o));
      return l > 1 ? `bvec${l}` : "bool";
    } else {
      if (e.isMatrix(n)) {
        if (o === "float")
          return n;
        if (e.isVector(o))
          return e.getVectorFromMatrix(n);
        if (e.isMatrix(o))
          return n;
      } else if (e.isMatrix(o)) {
        if (n === "float")
          return o;
        if (e.isVector(n))
          return e.getVectorFromMatrix(o);
      }
      return e.getTypeLength(o) > e.getTypeLength(n) ? o : n;
    }
  }
  generate(e, t) {
    const s = this.op, { aNode: i, bNode: a } = this, n = this.getNodeType(e, t);
    let o = null, l = null;
    n !== "void" ? (o = i.getNodeType(e), l = a ? a.getNodeType(e) : null, s === "<" || s === ">" || s === "<=" || s === ">=" || s === "==" || s === "!=" ? e.isVector(o) ? l = o : e.isVector(l) ? o = l : o !== l && (o = l = "float") : s === ">>" || s === "<<" ? (o = n, l = e.changeComponentType(l, "uint")) : s === "%" ? (o = n, l = e.isInteger(o) && e.isInteger(l) ? l : o) : e.isMatrix(o) ? l === "float" ? l = "float" : e.isVector(l) ? l = e.getVectorFromMatrix(o) : e.isMatrix(l) || (o = l = n) : e.isMatrix(l) ? o === "float" ? o = "float" : e.isVector(o) ? o = e.getVectorFromMatrix(l) : o = l = n : o = l = n) : o = l = n;
    const u = i.build(e, o), h = a ? a.build(e, l) : null, d = e.getFunctionOperator(s);
    if (t !== "void") {
      const p = e.renderer.coordinateSystem === Vs;
      if (s === "==" || s === "!=" || s === "<" || s === ">" || s === "<=" || s === ">=")
        return p ? e.isVector(o) ? e.format(`${this.getOperatorMethod(e, t)}( ${u}, ${h} )`, n, t) : e.format(`( ${u} ${s} ${h} )`, n, t) : e.format(`( ${u} ${s} ${h} )`, n, t);
      if (s === "%")
        return e.isInteger(l) ? e.format(`( ${u} % ${h} )`, n, t) : e.format(`${this.getOperatorMethod(e, n)}( ${u}, ${h} )`, n, t);
      if (s === "!")
        return p && e.isVector(o) ? e.format(`not( ${u} )`, t) : e.format(`( ${s} ${u} )`, o, t);
      if (s === "~")
        return e.format(`( ${s} ${u} )`, o, t);
      if (d)
        return e.format(`${d}( ${u}, ${h} )`, n, t);
      if (e.isMatrix(o) && l === "float")
        return e.format(`( ${h} ${s} ${u} )`, n, t);
      if (o === "float" && e.isMatrix(l))
        return e.format(`${u} ${s} ${h}`, n, t);
      {
        let m = `( ${u} ${s} ${h} )`;
        return !p && n === "bool" && e.isVector(o) && e.isVector(l) && (m = `all${m}`), e.format(m, n, t);
      }
    } else if (o !== "void")
      return d ? e.format(`${d}( ${u}, ${h} )`, n, t) : e.isMatrix(o) && l === "float" ? e.format(`${h} ${s} ${u}`, n, t) : e.format(`${u} ${s} ${h}`, n, t);
  }
  serialize(e) {
    super.serialize(e), e.op = this.op;
  }
  deserialize(e) {
    super.deserialize(e), this.op = e.op;
  }
}
const Ae = /* @__PURE__ */ L(be, "+").setParameterLength(2, 1 / 0).setName("add"), K = /* @__PURE__ */ L(be, "-").setParameterLength(2, 1 / 0).setName("sub"), j = /* @__PURE__ */ L(be, "*").setParameterLength(2, 1 / 0).setName("mul"), Zt = /* @__PURE__ */ L(be, "/").setParameterLength(2, 1 / 0).setName("div"), $a = /* @__PURE__ */ L(be, "%").setParameterLength(2).setName("mod"), vc = /* @__PURE__ */ L(be, "==").setParameterLength(2).setName("equal"), Tc = /* @__PURE__ */ L(be, "!=").setParameterLength(2).setName("notEqual"), wc = /* @__PURE__ */ L(be, "<").setParameterLength(2).setName("lessThan"), hl = /* @__PURE__ */ L(be, ">").setParameterLength(2).setName("greaterThan"), Nc = /* @__PURE__ */ L(be, "<=").setParameterLength(2).setName("lessThanEqual"), Mc = /* @__PURE__ */ L(be, ">=").setParameterLength(2).setName("greaterThanEqual"), Sc = /* @__PURE__ */ L(be, "&&").setParameterLength(2, 1 / 0).setName("and"), _c = /* @__PURE__ */ L(be, "||").setParameterLength(2, 1 / 0).setName("or"), Ac = /* @__PURE__ */ L(be, "!").setParameterLength(1).setName("not"), Vc = /* @__PURE__ */ L(be, "^^").setParameterLength(2).setName("xor"), Cc = /* @__PURE__ */ L(be, "&").setParameterLength(2).setName("bitAnd"), zc = /* @__PURE__ */ L(be, "~").setParameterLength(1).setName("bitNot"), Rc = /* @__PURE__ */ L(be, "|").setParameterLength(2).setName("bitOr"), Ec = /* @__PURE__ */ L(be, "^").setParameterLength(2).setName("bitXor"), Lc = /* @__PURE__ */ L(be, "<<").setParameterLength(2).setName("shiftLeft"), Ic = /* @__PURE__ */ L(be, ">>").setParameterLength(2).setName("shiftRight"), Oc = b(([r]) => (r.addAssign(1), r)), Pc = b(([r]) => (r.subAssign(1), r)), Fc = /* @__PURE__ */ b(([r]) => {
  const e = x(r).toConst();
  return r.addAssign(1), e;
}), Bc = /* @__PURE__ */ b(([r]) => {
  const e = x(r).toConst();
  return r.subAssign(1), e;
});
S("add", Ae);
S("sub", K);
S("mul", j);
S("div", Zt);
S("mod", $a);
S("equal", vc);
S("notEqual", Tc);
S("lessThan", wc);
S("greaterThan", hl);
S("lessThanEqual", Nc);
S("greaterThanEqual", Mc);
S("and", Sc);
S("or", _c);
S("not", Ac);
S("xor", Vc);
S("bitAnd", Cc);
S("bitNot", zc);
S("bitOr", Rc);
S("bitXor", Ec);
S("shiftLeft", Lc);
S("shiftRight", Ic);
S("incrementBefore", Oc);
S("decrementBefore", Pc);
S("increment", Fc);
S("decrement", Bc);
class T extends we {
  static get type() {
    return "MathNode";
  }
  /**
   * Constructs a new math node.
   *
   * @param {string} method - The method name.
   * @param {Node} aNode - The first input.
   * @param {?Node} [bNode=null] - The second input.
   * @param {?Node} [cNode=null] - The third input.
   */
  constructor(e, t, s = null, i = null) {
    if (super(), (e === T.MAX || e === T.MIN) && arguments.length > 3) {
      let a = new T(e, t, s);
      for (let n = 3; n < arguments.length - 1; n++)
        a = new T(e, a, arguments[n]);
      t = a, s = arguments[arguments.length - 1], i = null;
    }
    this.method = e, this.aNode = t, this.bNode = s, this.cNode = i, this.isMathNode = !0;
  }
  /**
   * The input type is inferred from the node types of the input nodes.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The input type.
   */
  getInputType(e) {
    const t = this.aNode.getNodeType(e), s = this.bNode ? this.bNode.getNodeType(e) : null, i = this.cNode ? this.cNode.getNodeType(e) : null, a = e.isMatrix(t) ? 0 : e.getTypeLength(t), n = e.isMatrix(s) ? 0 : e.getTypeLength(s), o = e.isMatrix(i) ? 0 : e.getTypeLength(i);
    return a > n && a > o ? t : n > o ? s : o > a ? i : t;
  }
  /**
   * The selected method as well as the input type determine the node type of this node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The node type.
   */
  generateNodeType(e) {
    const t = this.method;
    return t === T.LENGTH || t === T.DISTANCE || t === T.DOT ? "float" : t === T.CROSS ? "vec3" : t === T.ALL || t === T.ANY ? "bool" : t === T.EQUALS ? e.changeComponentType(this.aNode.getNodeType(e), "bool") : this.getInputType(e);
  }
  setup(e) {
    const { aNode: t, bNode: s, method: i } = this;
    let a = null;
    if (i === T.ONE_MINUS)
      a = K(1, t);
    else if (i === T.RECIPROCAL)
      a = Zt(1, t);
    else if (i === T.DIFFERENCE)
      a = he(K(t, s));
    else if (i === T.TRANSFORM_DIRECTION) {
      let n, o;
      e.isMatrix(t.getNodeType(e)) ? (n = t, o = s) : (n = s, o = t), a = it(j(n, D(N(o), 0)).xyz);
    }
    return a !== null ? a : super.setup(e);
  }
  generate(e, t) {
    if (e.getNodeProperties(this).outputNode)
      return super.generate(e, t);
    let s = this.method;
    const i = this.getNodeType(e), a = this.getInputType(e), n = this.aNode, o = this.bNode, l = this.cNode, u = e.renderer.coordinateSystem;
    if (s === T.NEGATE)
      return e.format("( - " + n.build(e, a) + " )", i, t);
    {
      const h = [];
      return s === T.CROSS ? h.push(
        n.build(e, i),
        o.build(e, i)
      ) : u === Vs && s === T.STEP ? h.push(
        n.build(e, e.getTypeLength(n.getNodeType(e)) === 1 ? "float" : a),
        o.build(e, a)
      ) : u === Vs && (s === T.MIN || s === T.MAX) ? h.push(
        n.build(e, a),
        o.build(e, e.getTypeLength(o.getNodeType(e)) === 1 ? "float" : a)
      ) : s === T.REFRACT ? h.push(
        n.build(e, a),
        o.build(e, a),
        l.build(e, "float")
      ) : s === T.MIX ? h.push(
        n.build(e, a),
        o.build(e, a),
        l.build(e, e.getTypeLength(l.getNodeType(e)) === 1 ? "float" : a)
      ) : (u === Ls && s === T.ATAN && o !== null && (s = "atan2"), e.shaderStage !== "fragment" && (s === T.DFDX || s === T.DFDY) && (X(`TSL: '${s}' is not supported in the ${e.shaderStage} stage.`, this.stackTrace), s = "/*" + s + "*/"), h.push(n.build(e, a)), o !== null && h.push(o.build(e, a)), l !== null && h.push(l.build(e, a))), e.format(`${e.getMethod(s, i)}( ${h.join(", ")} )`, i, t);
    }
  }
  serialize(e) {
    super.serialize(e), e.method = this.method;
  }
  deserialize(e) {
    super.deserialize(e), this.method = e.method;
  }
}
T.ALL = "all";
T.ANY = "any";
T.RADIANS = "radians";
T.DEGREES = "degrees";
T.EXP = "exp";
T.EXP2 = "exp2";
T.LOG = "log";
T.LOG2 = "log2";
T.SQRT = "sqrt";
T.INVERSE_SQRT = "inversesqrt";
T.FLOOR = "floor";
T.CEIL = "ceil";
T.NORMALIZE = "normalize";
T.FRACT = "fract";
T.SIN = "sin";
T.SINH = "sinh";
T.COS = "cos";
T.COSH = "cosh";
T.TAN = "tan";
T.TANH = "tanh";
T.ASIN = "asin";
T.ASINH = "asinh";
T.ACOS = "acos";
T.ACOSH = "acosh";
T.ATAN = "atan";
T.ATANH = "atanh";
T.ABS = "abs";
T.SIGN = "sign";
T.LENGTH = "length";
T.NEGATE = "negate";
T.ONE_MINUS = "oneMinus";
T.DFDX = "dFdx";
T.DFDY = "dFdy";
T.ROUND = "round";
T.RECIPROCAL = "reciprocal";
T.TRUNC = "trunc";
T.FWIDTH = "fwidth";
T.TRANSPOSE = "transpose";
T.DETERMINANT = "determinant";
T.INVERSE = "inverse";
T.EQUALS = "equals";
T.MIN = "min";
T.MAX = "max";
T.STEP = "step";
T.REFLECT = "reflect";
T.DISTANCE = "distance";
T.DIFFERENCE = "difference";
T.DOT = "dot";
T.CROSS = "cross";
T.POW = "pow";
T.TRANSFORM_DIRECTION = "transformDirection";
T.MIX = "mix";
T.CLAMP = "clamp";
T.REFRACT = "refract";
T.SMOOTHSTEP = "smoothstep";
T.FACEFORWARD = "faceforward";
const cl = /* @__PURE__ */ f(1e-6), Ay = /* @__PURE__ */ f(1e6), Aa = /* @__PURE__ */ f(Math.PI), Vy = /* @__PURE__ */ f(Math.PI * 2), Cy = /* @__PURE__ */ f(Math.PI * 2), zy = /* @__PURE__ */ f(Math.PI * 0.5), Uc = /* @__PURE__ */ L(T, T.ALL).setParameterLength(1), kc = /* @__PURE__ */ L(T, T.ANY).setParameterLength(1), Dc = /* @__PURE__ */ L(T, T.RADIANS).setParameterLength(1), Wc = /* @__PURE__ */ L(T, T.DEGREES).setParameterLength(1), qc = /* @__PURE__ */ L(T, T.EXP).setParameterLength(1), Wr = /* @__PURE__ */ L(T, T.EXP2).setParameterLength(1), dl = /* @__PURE__ */ L(T, T.LOG).setParameterLength(1), ps = /* @__PURE__ */ L(T, T.LOG2).setParameterLength(1), et = /* @__PURE__ */ L(T, T.SQRT).setParameterLength(1), pl = /* @__PURE__ */ L(T, T.INVERSE_SQRT).setParameterLength(1), Xt = /* @__PURE__ */ L(T, T.FLOOR).setParameterLength(1), Ya = /* @__PURE__ */ L(T, T.CEIL).setParameterLength(1), it = /* @__PURE__ */ L(T, T.NORMALIZE).setParameterLength(1), Bt = /* @__PURE__ */ L(T, T.FRACT).setParameterLength(1), Qe = /* @__PURE__ */ L(T, T.SIN).setParameterLength(1), jc = /* @__PURE__ */ L(T, T.SINH).setParameterLength(1), Rt = /* @__PURE__ */ L(T, T.COS).setParameterLength(1), Gc = /* @__PURE__ */ L(T, T.COSH).setParameterLength(1), Hc = /* @__PURE__ */ L(T, T.TAN).setParameterLength(1), Xc = /* @__PURE__ */ L(T, T.TANH).setParameterLength(1), $c = /* @__PURE__ */ L(T, T.ASIN).setParameterLength(1), Yc = /* @__PURE__ */ L(T, T.ASINH).setParameterLength(1), Zc = /* @__PURE__ */ L(T, T.ACOS).setParameterLength(1), Jc = /* @__PURE__ */ L(T, T.ACOSH).setParameterLength(1), ml = /* @__PURE__ */ L(T, T.ATAN).setParameterLength(1, 2), Qc = /* @__PURE__ */ L(T, T.ATANH).setParameterLength(1), he = /* @__PURE__ */ L(T, T.ABS).setParameterLength(1), gl = /* @__PURE__ */ L(T, T.SIGN).setParameterLength(1), Va = /* @__PURE__ */ L(T, T.LENGTH).setParameterLength(1), fl = /* @__PURE__ */ L(T, T.NEGATE).setParameterLength(1), Kc = /* @__PURE__ */ L(T, T.ONE_MINUS).setParameterLength(1), yl = /* @__PURE__ */ L(T, T.DFDX).setParameterLength(1), xl = /* @__PURE__ */ L(T, T.DFDY).setParameterLength(1), ed = /* @__PURE__ */ L(T, T.ROUND).setParameterLength(1), td = /* @__PURE__ */ L(T, T.RECIPROCAL).setParameterLength(1), bl = /* @__PURE__ */ L(T, T.TRUNC).setParameterLength(1), vl = /* @__PURE__ */ L(T, T.FWIDTH).setParameterLength(1), sd = /* @__PURE__ */ L(T, T.TRANSPOSE).setParameterLength(1), rd = /* @__PURE__ */ L(T, T.DETERMINANT).setParameterLength(1), id = /* @__PURE__ */ L(T, T.INVERSE).setParameterLength(1), Mt = /* @__PURE__ */ L(T, T.MIN).setParameterLength(2, 1 / 0), Ee = /* @__PURE__ */ L(T, T.MAX).setParameterLength(2, 1 / 0), tr = /* @__PURE__ */ L(T, T.STEP).setParameterLength(2), ad = /* @__PURE__ */ L(T, T.REFLECT).setParameterLength(2), nd = /* @__PURE__ */ L(T, T.DISTANCE).setParameterLength(2), od = /* @__PURE__ */ L(T, T.DIFFERENCE).setParameterLength(2), St = /* @__PURE__ */ L(T, T.DOT).setParameterLength(2), gs = /* @__PURE__ */ L(T, T.CROSS).setParameterLength(2), vt = /* @__PURE__ */ L(T, T.POW).setParameterLength(2), ld = (r) => j(r, r), ud = (r) => j(r, r, r), hd = (r) => j(r, r, r, r), cd = /* @__PURE__ */ L(T, T.TRANSFORM_DIRECTION).setParameterLength(2), dd = (r, e) => it(j(e, D(N(r), 0)).xyz), pd = (r, e) => it(D(N(r), 0).mul(e).xyz), md = (r) => j(gl(r), vt(he(r), 1 / 3)), Tl = (r) => St(r, r), pe = /* @__PURE__ */ L(T, T.MIX).setParameterLength(3), Jt = (r, e = 0, t = 1) => new T(T.CLAMP, U(r), U(e), U(t)), wl = (r) => Jt(r), gd = /* @__PURE__ */ L(T, T.REFRACT).setParameterLength(3), Qt = /* @__PURE__ */ L(T, T.SMOOTHSTEP).setParameterLength(3), Nl = /* @__PURE__ */ L(T, T.FACEFORWARD).setParameterLength(3), fd = /* @__PURE__ */ b(([r]) => {
  const e = 43758.5453, t = St(r.xy, B(12.9898, 78.233)), s = $a(t, Aa);
  return Bt(Qe(s).mul(e));
}), yd = (r, e, t) => pe(e, t, r), xd = (r, e, t) => Qt(e, t, r), bd = (r, e) => tr(e, r), Ry = Nl, Ey = pl;
S("all", Uc);
S("any", kc);
S("radians", Dc);
S("degrees", Wc);
S("exp", qc);
S("exp2", Wr);
S("log", dl);
S("log2", ps);
S("sqrt", et);
S("inverseSqrt", pl);
S("floor", Xt);
S("ceil", Ya);
S("normalize", it);
S("fract", Bt);
S("sin", Qe);
S("sinh", jc);
S("cos", Rt);
S("cosh", Gc);
S("tan", Hc);
S("tanh", Xc);
S("asin", $c);
S("asinh", Yc);
S("acos", Zc);
S("acosh", Jc);
S("atan", ml);
S("atanh", Qc);
S("abs", he);
S("sign", gl);
S("length", Va);
S("lengthSq", Tl);
S("negate", fl);
S("oneMinus", Kc);
S("dFdx", yl);
S("dFdy", xl);
S("round", ed);
S("reciprocal", td);
S("trunc", bl);
S("fwidth", vl);
S("min", Mt);
S("max", Ee);
S("step", bd);
S("reflect", ad);
S("distance", nd);
S("dot", St);
S("cross", gs);
S("pow", vt);
S("pow2", ld);
S("pow3", ud);
S("pow4", hd);
S("transformDirection", cd);
S("transformNormalByViewMatrix", dd);
S("transformNormalByInverseViewMatrix", pd);
S("mix", yd);
S("clamp", Jt);
S("refract", gd);
S("smoothstep", xd);
S("faceForward", Nl);
S("difference", od);
S("saturate", wl);
S("cbrt", md);
S("transpose", sd);
S("determinant", rd);
S("inverse", id);
S("rand", fd);
class Ly extends k {
  static get type() {
    return "ConditionalNode";
  }
  /**
   * Constructs a new conditional node.
   *
   * @param {Node} condNode - The node that defines the condition.
   * @param {Node} ifNode - The node that is evaluate when the condition ends up `true`.
   * @param {?Node} [elseNode=null] - The node that is evaluate when the condition ends up `false`.
   */
  constructor(e, t, s = null) {
    super(), this.condNode = e, this.ifNode = t, this.elseNode = s;
  }
  /**
   * This method is overwritten since the node type is inferred from the if/else
   * nodes.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The node type.
   */
  generateNodeType(e) {
    const { ifNode: t, elseNode: s } = e.getNodeProperties(this);
    if (t === void 0)
      return e.flowBuildStage(this, "setup"), this.getNodeType(e);
    const i = t.getNodeType(e);
    if (s !== null) {
      const a = s.getNodeType(e);
      if (e.getTypeLength(a) > e.getTypeLength(i))
        return a;
    }
    return i;
  }
  setup(e) {
    const t = this.condNode, s = this.ifNode.isolate(), i = this.elseNode ? this.elseNode.isolate() : null, a = e.context.nodeBlock;
    e.getDataFromNode(s).parentNodeBlock = a, i !== null && (e.getDataFromNode(i).parentNodeBlock = a);
    const n = e.context.uniformFlow, o = e.getNodeProperties(this);
    o.condNode = t, o.ifNode = n ? s : s.context({ nodeBlock: s }), o.elseNode = i ? n ? i : i.context({ nodeBlock: i }) : null;
  }
  generate(e, t) {
    const s = this.getNodeType(e), i = e.getDataFromNode(this);
    if (i.nodeProperty !== void 0)
      return i.nodeProperty;
    const { condNode: a, ifNode: n, elseNode: o } = e.getNodeProperties(this), l = e.currentFunctionNode, u = t !== "void", h = u ? ys(s).build(e) : "";
    i.nodeProperty = h;
    const d = a.build(e, "bool");
    if (e.context.uniformFlow && o !== null) {
      const m = n.build(e, s), g = o.build(e, s), y = e.getTernary(d, m, g);
      return e.format(y, s, t);
    }
    e.addFlowCode(`
${e.tab}if ( ${d} ) {

`).addFlowTab();
    let p = n.build(e, s);
    if (p && (u ? p = h + " = " + p + ";" : (p = "return " + p + ";", l === null && (X("TSL: Return statement used in an inline 'Fn()'. Define a layout struct to allow return values.", this.stackTrace), p = "// " + p))), e.removeFlowTab().addFlowCode(e.tab + "	" + p + `

` + e.tab + "}"), o !== null) {
      e.addFlowCode(` else {

`).addFlowTab();
      let m = o.build(e, s);
      m && (u ? m = h + " = " + m + ";" : (m = "return " + m + ";", l === null && (X("TSL: Return statement used in an inline 'Fn()'. Define a layout struct to allow return values.", this.stackTrace), m = "// " + m))), e.removeFlowTab().addFlowCode(e.tab + "	" + m + `

` + e.tab + `}

`);
    } else
      e.addFlowCode(`

`);
    return e.format(h, s, t);
  }
}
const He = /* @__PURE__ */ Y(Ly).setParameterLength(2, 3);
S("select", He);
class Ml extends k {
  static get type() {
    return "ContextNode";
  }
  /**
   * Constructs a new context node.
   *
   * @param {Node} node - The node whose context should be modified.
   * @param {Object} [value={}] - The modified context data.
   */
  constructor(e = null, t = {}) {
    super(), this.isContextNode = !0, this.node = e, this.value = t;
  }
  /**
   * This method is overwritten to ensure it returns the reference to {@link ContextNode#node}.
   *
   * @return {Node} A reference to {@link ContextNode#node}.
   */
  getScope() {
    return this.node.getScope();
  }
  /**
   * This method is overwritten to ensure it returns the type of {@link ContextNode#node}.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The node type.
   */
  generateNodeType(e) {
    return this.node.getNodeType(e);
  }
  /**
   * Gathers the context data from all parent context nodes.
   *
   * @return {Object} The gathered context data.
   */
  getFlowContextData() {
    const e = [];
    return this.traverse((t) => {
      t.isContextNode === !0 && e.push(t.value);
    }), Object.assign({}, ...e);
  }
  /**
   * This method is overwritten to ensure it returns the member type of {@link ContextNode#node}.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {string} name - The member name.
   * @returns {string} The member type.
   */
  getMemberType(e, t) {
    return this.node.getMemberType(e, t);
  }
  analyze(e) {
    const t = e.addContext(this.value);
    this.node.build(e), e.setContext(t);
  }
  setup(e) {
    const t = e.addContext(this.value);
    this.node.build(e), e.setContext(t);
  }
  generate(e, t) {
    const s = e.addContext(this.value), i = this.node.build(e, t);
    return e.setContext(s), i;
  }
}
const Fs = (r = null, e = {}) => {
  let t = r;
  return (t === null || t.isNode !== !0) && (e = t || e, t = null), new Ml(t, e);
}, vd = (r) => Fs(r, { uniformFlow: !0 }), Sl = (r, e) => Fs(r, { nodeName: e });
function Td(r, e, t = null) {
  return Fs(t, {
    getShadow: ({ light: s, shadowColorNode: i }) => e === s ? i.mul(r) : i
  });
}
function wd(r, e = null) {
  return Fs(e, {
    getAO: (t, { material: s }) => s.transparent === !0 ? t : t !== null ? t.mul(r) : r
  });
}
function Nd(r, e) {
  return X('TSL: "label()" has been deprecated. Use "setName()" instead.'), Sl(r, e);
}
S("context", Fs);
S("label", Nd);
S("uniformFlow", vd);
S("setName", Sl);
S("builtinShadowContext", (r, e, t) => Td(e, t, r));
S("builtinAOContext", (r, e) => wd(e, r));
class Iy extends k {
  static get type() {
    return "VarNode";
  }
  /**
   * Constructs a new variable node.
   *
   * @param {Node} node - The node for which a variable should be created.
   * @param {?string} [name=null] - The name of the variable in the shader.
   * @param {boolean} [readOnly=false] - The read-only flag.
   */
  constructor(e, t = null, s = !1) {
    super(), this.node = e, this.name = t, this.global = !0, this.isVarNode = !0, this.readOnly = s, this.parents = !0, this.intent = !1;
  }
  /**
   * Sets the intent flag for this node.
   *
   * This flag is used to indicate that this node is used for intent
   * and should not be built directly. Instead, it is used to indicate that
   * the node should be treated as a variable intent.
   *
   * It's useful for assigning variables without needing creating a new variable node.
   *
   * @param {boolean} value - The value to set for the intent flag.
   * @returns {VarNode} This node.
   */
  setIntent(e) {
    return this.intent = e, this;
  }
  /**
   * Checks if this node is used for intent.
   *
   * @param {NodeBuilder} builder - The node builder.
   * @returns {boolean} Whether this node is used for intent.
   */
  isIntent(e) {
    return e.getDataFromNode(this).forceDeclaration === !0 ? !1 : this.intent;
  }
  /**
   * Returns the intent flag of this node.
   *
   * @return {boolean} The intent flag.
   */
  getIntent() {
    return this.intent;
  }
  getMemberType(e, t) {
    return this.node.getMemberType(e, t);
  }
  getElementType(e) {
    return this.node.getElementType(e);
  }
  generateNodeType(e) {
    return this.node.getNodeType(e);
  }
  getArrayCount(e) {
    return this.node.getArrayCount(e);
  }
  isAssign(e) {
    return e.getDataFromNode(this).assign;
  }
  build(...e) {
    const t = e[0], s = this.getShared(t);
    if (this !== s)
      return s.build(...e);
    if (this._hasStack(t) === !1 && t.buildStage === "setup" && (t.context.nodeLoop || t.context.nodeBlock)) {
      let i = !1;
      if (this.node.isShaderCallNodeInternal && this.node.shaderNode.getLayout() === null && t.fnCall && t.fnCall.shaderNode && t.getDataFromNode(this.node.shaderNode).hasLoop) {
        const n = t.getDataFromNode(this);
        n.forceDeclaration = !0, i = !0;
      }
      const a = t.getBaseStack();
      i ? a.addToStackBefore(this) : a.addToStack(this);
    }
    return this.isIntent(t) && this.isAssign(t) !== !0 ? this.node.build(...e) : super.build(...e);
  }
  generate(e) {
    const { node: t, name: s, readOnly: i } = this, { renderer: a } = e, n = a.backend.isWebGPUBackend === !0;
    let o = !1, l = !1;
    i && (o = e.isDeterministic(t), l = n ? i : o);
    const u = this.getNodeType(e);
    if (u == "void")
      return this.isIntent(e) !== !0 && te('TSL: ".toVar()" can not be used with void type.', this.stackTrace), t.build(e);
    const h = e.getVectorType(u), d = t.build(e, h), p = e.getVarFromNode(this, s, h, void 0, l), m = e.getPropertyName(p);
    let g = m;
    if (l)
      if (n)
        g = o ? `const ${m}` : `let ${m}`;
      else {
        const y = t.getArrayCount(e);
        g = `const ${e.getVar(p.type, m, y)}`;
      }
    return e.addLineFlowCode(`${g} = ${d}`, this), m;
  }
  _hasStack(e) {
    return e.getDataFromNode(this).stack !== void 0;
  }
}
const _l = /* @__PURE__ */ Y(Iy), Md = (r, e = null) => _l(r, e).toStack(), Sd = (r, e = null) => _l(r, e, !0).toStack(), _d = (r) => _l(r).setIntent(!0).toStack();
S("toVar", Md);
S("toConst", Sd);
S("toVarIntent", _d);
class Oy extends k {
  static get type() {
    return "SubBuild";
  }
  constructor(e, t, s = null) {
    super(s), this.node = e, this.name = t, this.isSubBuildNode = !0;
  }
  generateNodeType(e) {
    if (this.nodeType !== null) return this.nodeType;
    e.addSubBuild(this.name);
    const t = this.node.getNodeType(e);
    return e.removeSubBuild(), t;
  }
  build(e, ...t) {
    e.addSubBuild(this.name);
    const s = this.node.build(e, ...t);
    return e.removeSubBuild(), s;
  }
}
const Br = (r, e, t = null) => new Oy(U(r), e, t);
class Py extends k {
  static get type() {
    return "VaryingNode";
  }
  /**
   * Constructs a new varying node.
   *
   * @param {Node} node - The node for which a varying should be created.
   * @param {?string} name - The name of the varying in the shader.
   */
  constructor(e, t = null) {
    super(), this.node = Br(e, "VERTEX"), this.name = t, this.isVaryingNode = !0, this.interpolationType = null, this.interpolationSampling = null, this.global = !0;
  }
  /**
   * Defines the interpolation type of the varying.
   *
   * @param {string} type - The interpolation type.
   * @param {?string} sampling - The interpolation sampling type
   * @return {VaryingNode} A reference to this node.
   */
  setInterpolation(e, t = null) {
    return this.interpolationType = e, this.interpolationSampling = t, this;
  }
  getHash(e) {
    return this.name || super.getHash(e);
  }
  generateNodeType(e) {
    return this.node.getNodeType(e);
  }
  /**
   * This method performs the setup of a varying node with the current node builder.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {NodeVarying} The node varying from the node builder.
   */
  setupVarying(e) {
    const t = e.getNodeProperties(this);
    let s = t.varying;
    if (s === void 0) {
      const i = this.name, a = this.getNodeType(e), n = this.interpolationType, o = this.interpolationSampling;
      t.varying = s = e.getVaryingFromNode(this, i, a, n, o), t.node = Br(this.node, "VERTEX");
    }
    return s.needsInterpolation || (s.needsInterpolation = e.shaderStage === "fragment"), s;
  }
  setup(e) {
    this.setupVarying(e), e.flowNodeFromShaderStage(Vr.VERTEX, this.node);
  }
  analyze(e) {
    this.setupVarying(e), e.flowNodeFromShaderStage(Vr.VERTEX, this.node);
  }
  generate(e) {
    const t = e.getSubBuildProperty("property", e.currentStack), s = e.getNodeProperties(this), i = this.setupVarying(e);
    if (s[t] === void 0) {
      const a = this.getNodeType(e), n = e.getPropertyName(i, Vr.VERTEX);
      if (e.shaderStage === Vr.VERTEX) {
        const o = s.node.build(e, a);
        e.addLineFlowCode(`${n} = ${o}`, this);
      } else
        e.flowNodeFromShaderStage(Vr.VERTEX, s.node, a, n);
      s[t] = n;
    }
    return e.getPropertyName(i);
  }
}
const ur = /* @__PURE__ */ Y(Py).setParameterLength(1, 2), Ad = (r) => ur(r);
S("toVarying", ur);
S("toVertexStage", Ad);
const Vd = /* @__PURE__ */ b(([r]) => {
  const e = r.mul(0.9478672986).add(0.0521327014).pow(2.4), t = r.mul(0.0773993808), s = r.lessThanEqual(0.04045);
  return pe(e, t, s);
}).setLayout({
  name: "sRGBTransferEOTF",
  type: "vec3",
  inputs: [
    { name: "color", type: "vec3" }
  ]
}), Cd = /* @__PURE__ */ b(([r]) => {
  const e = r.pow(0.41666).mul(1.055).sub(0.055), t = r.mul(12.92), s = r.lessThanEqual(31308e-7);
  return pe(e, t, s);
}).setLayout({
  name: "sRGBTransferOETF",
  type: "vec3",
  inputs: [
    { name: "color", type: "vec3" }
  ]
}), Al = "WorkingColorSpace", Fy = "OutputColorSpace";
class Vl extends we {
  static get type() {
    return "ColorSpaceNode";
  }
  /**
   * Constructs a new color space node.
   *
   * @param {Node} colorNode - Represents the color to convert.
   * @param {string} source - The source color space.
   * @param {string} target - The target color space.
   */
  constructor(e, t, s) {
    super("vec4"), this.colorNode = e, this.source = t, this.target = s;
  }
  /**
   * This method resolves the constants `WORKING_COLOR_SPACE` and
   * `OUTPUT_COLOR_SPACE` based on the current configuration of the
   * color management and renderer.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {string} colorSpace - The color space to resolve.
   * @return {string} The resolved color space.
   */
  resolveColorSpace(e, t) {
    return t === Al ? Ne.workingColorSpace : t === Fy ? e.context.outputColorSpace || e.renderer.outputColorSpace : t;
  }
  setup(e) {
    const { colorNode: t } = this, s = this.resolveColorSpace(e, this.source), i = this.resolveColorSpace(e, this.target);
    let a = t;
    return Ne.enabled === !1 || s === i || !s || !i || (Ne.getTransfer(s) === di && (a = D(Vd(a.rgb), a.a)), Ne.getPrimaries(s) !== Ne.getPrimaries(i) && (a = D(
      gt(Ne._getMatrix(new Kt(), s, i)).mul(a.rgb),
      a.a
    )), Ne.getTransfer(i) === di && (a = D(Cd(a.rgb), a.a))), a;
  }
}
const zd = (r, e) => new Vl(U(r), Al, e), Cl = (r, e) => new Vl(U(r), e, Al), By = (r, e, t) => new Vl(U(r), e, t);
S("workingToColorSpace", zd);
S("colorSpaceToWorking", Cl);
let Uy = class extends nr {
  static get type() {
    return "ReferenceElementNode";
  }
  /**
   * Constructs a new reference element node.
   *
   * @param {ReferenceBaseNode} referenceNode - The reference node.
   * @param {Node} indexNode - The index node that defines the element access.
   */
  constructor(r, e) {
    super(r, e), this.referenceNode = r, this.isReferenceElementNode = !0;
  }
  /**
   * This method is overwritten since the node type is inferred from
   * the uniform type of the reference node.
   *
   * @return {string} The node type.
   */
  generateNodeType() {
    return this.referenceNode.uniformType;
  }
  generate(r) {
    const e = super.generate(r), t = this.referenceNode.getNodeType(), s = this.getNodeType();
    return r.format(e, t, s);
  }
};
class ky extends k {
  static get type() {
    return "ReferenceBaseNode";
  }
  /**
   * Constructs a new reference base node.
   *
   * @param {string} property - The name of the property the node refers to.
   * @param {string} uniformType - The uniform type that should be used to represent the property value.
   * @param {?Object} [object=null] - The object the property belongs to.
   * @param {?number} [count=null] - When the linked property is an array-like, this parameter defines its length.
   */
  constructor(e, t, s = null, i = null) {
    super(), this.property = e, this.uniformType = t, this.object = s, this.count = i, this.properties = e.split("."), this.reference = s, this.node = null, this.group = null, this.updateType = Q.OBJECT;
  }
  /**
   * Sets the uniform group for this reference node.
   *
   * @param {UniformGroupNode} group - The uniform group to set.
   * @return {ReferenceBaseNode} A reference to this node.
   */
  setGroup(e) {
    return this.group = e, this;
  }
  /**
   * When the referred property is array-like, this method can be used
   * to access elements via an index node.
   *
   * @param {IndexNode} indexNode - indexNode.
   * @return {ReferenceElementNode} A reference to an element.
   */
  element(e) {
    return new Uy(this, U(e));
  }
  /**
   * Sets the node type which automatically defines the internal
   * uniform type.
   *
   * @param {string} uniformType - The type to set.
   */
  setNodeType(e) {
    const t = q(null, e);
    this.group !== null && t.setGroup(this.group), this.node = t;
  }
  /**
   * This method is overwritten since the node type is inferred from
   * the type of the reference node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The node type.
   */
  generateNodeType(e) {
    return this.node === null && (this.updateReference(e), this.updateValue()), this.node.getNodeType(e);
  }
  /**
   * Returns the property value from the given referred object.
   *
   * @param {Object} [object=this.reference] - The object to retrieve the property value from.
   * @return {any} The value.
   */
  getValueFromReference(e = this.reference) {
    const { properties: t } = this;
    let s = e[t[0]];
    for (let i = 1; i < t.length; i++)
      s = s[t[i]];
    return s;
  }
  /**
   * Allows to update the reference based on the given state. The state is only
   * evaluated {@link ReferenceBaseNode#object} is not set.
   *
   * @param {(NodeFrame|NodeBuilder)} state - The current state.
   * @return {Object} The updated reference.
   */
  updateReference(e) {
    return this.reference = this.object !== null ? this.object : e.object, this.reference;
  }
  /**
   * The output of the reference node is the internal uniform node.
   *
   * @return {UniformNode} The output node.
   */
  setup() {
    return this.updateValue(), this.node;
  }
  /**
   * Overwritten to update the internal uniform value.
   *
   * @param {NodeFrame} frame - A reference to the current node frame.
   */
  update() {
    this.updateValue();
  }
  /**
   * Retrieves the value from the referred object property and uses it
   * to updated the internal uniform.
   */
  updateValue() {
    this.node === null && this.setNodeType(this.uniformType);
    const e = this.getValueFromReference();
    Array.isArray(e) ? this.node.array = e : this.node.value = e;
  }
}
class Dy extends ky {
  static get type() {
    return "RendererReferenceNode";
  }
  /**
   * Constructs a new renderer reference node.
   *
   * @param {string} property - The name of the property the node refers to.
   * @param {string} inputType - The uniform type that should be used to represent the property value.
   * @param {?Renderer} [renderer=null] - The renderer the property belongs to. When no renderer is set,
   * the node refers to the renderer of the current state.
   */
  constructor(e, t, s = null) {
    super(e, t, s), this.renderer = s, this.setGroup(H);
  }
  /**
   * Updates the reference based on the given state. The state is only evaluated
   * {@link RendererReferenceNode#renderer} is not set.
   *
   * @param {(NodeFrame|NodeBuilder)} state - The current state.
   * @return {Object} The updated reference.
   */
  updateReference(e) {
    return this.reference = this.renderer !== null ? this.renderer : e.renderer, this.reference;
  }
}
const Rd = (r, e, t = null) => new Dy(r, e, t);
class Wy extends we {
  static get type() {
    return "ToneMappingNode";
  }
  /**
   * Constructs a new tone mapping node.
   *
   * @param {number} toneMapping - The tone mapping type.
   * @param {Node} exposureNode - The tone mapping exposure.
   * @param {Node} [colorNode=null] - The color node to process.
   */
  constructor(e, t = Ld, s = null) {
    super("vec3"), this._toneMapping = e, this.exposureNode = t, this.colorNode = s;
  }
  /**
   * Overwrites the default `customCacheKey()` implementation by including the tone
   * mapping type into the cache key.
   *
   * @return {number} The hash.
   */
  customCacheKey() {
    return Zh(this._toneMapping);
  }
  /**
   * Sets the tone mapping type.
   *
   * @param {number} value - The tone mapping type.
   * @return {ToneMappingNode} A reference to this node.
   */
  setToneMapping(e) {
    return this._toneMapping = e, this;
  }
  /**
   * Gets the tone mapping type.
   *
   * @returns {number} The tone mapping type.
   */
  getToneMapping() {
    return this._toneMapping;
  }
  setup(e) {
    const t = this.colorNode || e.context.color, s = this._toneMapping;
    if (s === fo) return t;
    let i = null;
    const a = e.renderer.library.getToneMappingFunction(s);
    return a !== null ? i = D(a(t.rgb, this.exposureNode), t.a) : (te("ToneMappingNode: Unsupported Tone Mapping configuration.", s), i = t), i;
  }
}
const Ed = (r, e, t) => new Wy(r, U(e), U(t)), Ld = /* @__PURE__ */ Rd("toneMappingExposure", "float");
S("toneMapping", (r, e, t) => Ed(e, t, r));
const Xu = /* @__PURE__ */ new WeakMap();
function $u(r, e) {
  let t = Xu.get(r);
  return t === void 0 && (t = new jh(r, e), Xu.set(r, t)), t;
}
class Ss extends el {
  static get type() {
    return "BufferAttributeNode";
  }
  /**
   * Constructs a new buffer attribute node.
   *
   * @param {BufferAttribute|InterleavedBuffer|TypedArray} value - The attribute data.
   * @param {?string} [bufferType=null] - The buffer type (e.g. `'vec3'`).
   * @param {number} [bufferStride=0] - The buffer stride.
   * @param {number} [bufferOffset=0] - The buffer offset.
   */
  constructor(e, t = null, s = 0, i = 0) {
    super(e, t), this.isBufferNode = !0, this.bufferType = t, this.bufferStride = s, this.bufferOffset = i, this.usage = kr, this.instanced = !1, this.attribute = null, this.global = !0, e && e.isBufferAttribute === !0 && e.itemSize <= 4 && (this.attribute = e, this.usage = e.usage, this.instanced = e.isInstancedBufferAttribute);
  }
  /**
   * This method is overwritten since the attribute data might be shared
   * and thus the hash should be shared as well.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The hash.
   */
  getHash(e) {
    let t;
    if (this.bufferStride === 0 && this.bufferOffset === 0) {
      let s = e.globalCache.getData(this.value);
      s === void 0 && (s = {
        node: this
      }, e.globalCache.setData(this.value, s)), t = s.node.id;
    } else
      t = this.id;
    return String(t);
  }
  /**
   * This method is overwritten since the node type is inferred from
   * the buffer attribute.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The node type.
   */
  generateNodeType(e) {
    return this.bufferType === null && (this.bufferType = e.getTypeFromAttribute(this.attribute)), this.bufferType;
  }
  /**
   * Depending on which value was passed to the node, `setup()` behaves
   * differently. If no instance of `BufferAttribute` was passed, the method
   * creates an internal attribute and configures it respectively.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */
  setup(e) {
    if (this.attribute !== null) return;
    const t = this.getNodeType(e), s = e.getTypeLength(t), i = this.value, a = this.bufferStride || s, n = this.bufferOffset;
    let o;
    i.isInterleavedBuffer === !0 ? o = i : i.isBufferAttribute === !0 ? o = $u(i.array, a) : o = $u(i, a);
    const l = new $o(o, s, n);
    o.setUsage(this.usage), this.attribute = l, this.attribute.isInstancedBufferAttribute = this.instanced;
  }
  /**
   * Generates the code snippet of the buffer attribute node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The generated code snippet.
   */
  generate(e) {
    const t = this.getNodeType(e), s = e.context.nodeName;
    s !== void 0 && delete e.context.nodeName;
    const i = e.getBufferAttributeFromNode(this, t, s), a = e.getPropertyName(i);
    let n = null;
    if (e.shaderStage === "vertex" || e.shaderStage === "compute")
      this.name = a, n = a;
    else {
      let o;
      s && (o = s + "Varying"), n = ur(this, o).build(e, t);
    }
    return n;
  }
  /**
   * Overwrites the default implementation to return a fixed value `'bufferAttribute'`.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The input type.
   */
  getInputType() {
    return "bufferAttribute";
  }
  /**
   * Sets the `usage` property to the given value.
   *
   * @param {number} value - The usage to set.
   * @return {BufferAttributeNode} A reference to this node.
   */
  setUsage(e) {
    return this.usage = e, this.attribute && this.attribute.isBufferAttribute === !0 && (this.attribute.usage = e), this;
  }
  /**
   * Sets the `instanced` property to the given value.
   *
   * @param {boolean} value - The value to set.
   * @return {BufferAttributeNode} A reference to this node.
   */
  setInstanced(e) {
    return this.instanced = e, this;
  }
}
function Za(r, e = null, t = 0, s = 0, i = kr, a = !1) {
  return e === "mat3" || e === null && r.itemSize === 9 ? gt(
    new Ss(r, "vec3", 9, 0).setUsage(i).setInstanced(a),
    new Ss(r, "vec3", 9, 3).setUsage(i).setInstanced(a),
    new Ss(r, "vec3", 9, 6).setUsage(i).setInstanced(a)
  ) : e === "mat4" || e === null && r.itemSize === 16 ? Rs(
    new Ss(r, "vec4", 16, 0).setUsage(i).setInstanced(a),
    new Ss(r, "vec4", 16, 4).setUsage(i).setInstanced(a),
    new Ss(r, "vec4", 16, 8).setUsage(i).setInstanced(a),
    new Ss(r, "vec4", 16, 12).setUsage(i).setInstanced(a)
  ) : new Ss(r, e, t, s).setUsage(i);
}
const zl = (r, e = null, t = 0, s = 0) => Za(r, e, t, s), qy = (r, e = null, t = 0, s = 0) => Za(r, e, t, s, Da), Ja = (r, e = null, t = 0, s = 0) => Za(r, e, t, s, kr, !0), Rl = (r, e = null, t = 0, s = 0) => Za(r, e, t, s, Da, !0);
S("toAttribute", (r) => zl(r.value));
class ge extends k {
  static get type() {
    return "IndexNode";
  }
  /**
   * Constructs a new index node.
   *
   * @param {('vertex'|'instance'|'subgroup'|'invocationLocal'|'invocationGlobal'|'invocationSubgroup'|'draw')} scope - The scope of the index node.
   */
  constructor(e) {
    super("uint"), this.scope = e, this.isIndexNode = !0;
  }
  generate(e) {
    const t = this.getNodeType(e), s = this.scope;
    let i;
    if (s === ge.VERTEX)
      i = e.getVertexIndex();
    else if (s === ge.INSTANCE)
      i = e.getInstanceIndex();
    else if (s === ge.DRAW)
      i = e.getDrawIndex();
    else if (s === ge.INVOCATION_LOCAL)
      i = e.getInvocationLocalIndex();
    else if (s === ge.INVOCATION_SUBGROUP)
      i = e.getInvocationSubgroupIndex();
    else if (s === ge.SUBGROUP)
      i = e.getSubgroupIndex();
    else
      throw new Error("THREE.IndexNode: Unknown scope: " + s);
    let a;
    return e.shaderStage === "vertex" || e.shaderStage === "compute" ? a = i : a = ur(this).build(e, t), a;
  }
}
ge.VERTEX = "vertex";
ge.INSTANCE = "instance";
ge.SUBGROUP = "subgroup";
ge.INVOCATION_LOCAL = "invocationLocal";
ge.INVOCATION_SUBGROUP = "invocationSubgroup";
ge.DRAW = "draw";
const Id = /* @__PURE__ */ O(ge, ge.VERTEX), Ft = /* @__PURE__ */ O(ge, ge.INSTANCE), jy = /* @__PURE__ */ O(ge, ge.SUBGROUP), Gy = /* @__PURE__ */ O(ge, ge.INVOCATION_SUBGROUP), Hy = /* @__PURE__ */ O(ge, ge.INVOCATION_LOCAL), Od = /* @__PURE__ */ O(ge, ge.DRAW);
class Xy extends k {
  static get type() {
    return "ComputeNode";
  }
  /**
   * Constructs a new compute node.
   *
   * @param {Node} computeNode - The node that defines the compute shader logic.
   * @param {Array<number>} workgroupSize - An array defining the X, Y, and Z dimensions of the workgroup for compute shader execution.
   */
  constructor(e, t) {
    super("void"), this.isComputeNode = !0, this.computeNode = e, this.workgroupSize = t, this.count = null, this.dispatchSize = null, this.version = 1, this.name = "", this.updateBeforeType = Q.OBJECT, this.onInitFunction = null, this.countNode = null;
  }
  /**
   * Executes the `dispose` event for this node.
   */
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
  /**
   * Sets the {@link ComputeNode#name} property.
   *
   * @param {string} name - The name of the uniform.
   * @return {ComputeNode} A reference to this node.
   */
  setName(e) {
    return this.name = e, this;
  }
  /**
   * Sets the {@link ComputeNode#name} property.
   *
   * @deprecated
   * @param {string} name - The name of the uniform.
   * @return {ComputeNode} A reference to this node.
   */
  label(e) {
    return X('TSL: "label()" has been deprecated. Use "setName()" instead.', new Re()), this.setName(e);
  }
  /**
   * Sets the callback to run during initialization.
   *
   * @param {Function} callback - The callback function.
   * @return {ComputeNode} A reference to this node.
   */
  onInit(e) {
    return this.onInitFunction = e, this;
  }
  /**
   * The method execute the compute for this node.
   *
   * @param {NodeFrame} frame - A reference to the current node frame.
   */
  updateBefore({ renderer: e }) {
    e.compute(this);
  }
  setup(e) {
    this.count !== null && this.countNode === null && (this.countNode = q(this.count, "uint").onObjectUpdate(() => this.count));
    const t = this.computeNode.build(e);
    if (t) {
      const s = e.getNodeProperties(this);
      s.outputComputeNode = t.outputNode, t.outputNode = null;
    }
    return t;
  }
  generate(e, t) {
    const { shaderStage: s } = e;
    if (s === "compute") {
      const i = this.computeNode.build(e, "void");
      if (i !== "" && e.addLineFlowCode(i, this), this.count !== null && e.allowEarlyReturns === !0) {
        const a = this.countNode.build(e, "uint"), n = Ft.build(e, "uint");
        e.flow.code = `${e.tab}if ( ${n} >= ${a} ) { return; }

${e.flow.code}`;
      }
    } else {
      const i = e.getNodeProperties(this).outputComputeNode;
      if (i)
        return i.build(e, t);
    }
  }
}
const El = (r, e = [64]) => {
  (e.length === 0 || e.length > 3) && te("TSL: compute() workgroupSize must have 1, 2, or 3 elements", new Re());
  for (let t = 0; t < e.length; t++) {
    const s = e[t];
    (typeof s != "number" || s <= 0 || !Number.isInteger(s)) && te(`TSL: compute() workgroupSize element at index [ ${t} ] must be a positive integer`, new Re());
  }
  for (; e.length < 3; ) e.push(1);
  return new Xy(U(r), e);
}, Pd = (r, e, t) => {
  const s = El(r, t);
  return typeof e == "number" ? s.count = e : s.dispatchSize = e, s;
};
S("compute", Pd);
S("computeKernel", El);
class $y extends k {
  static get type() {
    return "IsolateNode";
  }
  /**
   * Constructs a new cache node.
   *
   * @param {Node} node - The node that should be cached.
   * @param {boolean} [parent=true] - Whether this node refers to a shared parent cache or not.
   */
  constructor(e, t = !0) {
    super(), this.node = e, this.parent = t, this.isIsolateNode = !0;
  }
  generateNodeType(e) {
    const t = e.getCache(), s = e.getCacheFromNode(this, this.parent);
    e.setCache(s);
    const i = this.node.getNodeType(e);
    return e.setCache(t), i;
  }
  build(e, ...t) {
    const s = e.getCache(), i = e.getCacheFromNode(this, this.parent);
    e.setCache(i);
    const a = this.node.build(e, ...t);
    return e.setCache(s), a;
  }
  setParent(e) {
    return this.parent = e, this;
  }
  getParent() {
    return this.parent;
  }
}
const Ll = (r) => new $y(U(r));
function Fd(r, e = !0) {
  return X('TSL: "cache()" has been deprecated. Use "isolate()" instead.'), Ll(r).setParent(e);
}
S("cache", Fd);
S("isolate", Ll);
class Yy extends k {
  static get type() {
    return "BypassNode";
  }
  /**
   * Constructs a new bypass node.
   *
   * @param {Node} outputNode - The output node.
   * @param {Node} callNode - The call node.
   */
  constructor(e, t) {
    super(), this.isBypassNode = !0, this.outputNode = e, this.callNode = t;
  }
  generateNodeType(e) {
    return this.outputNode.getNodeType(e);
  }
  generate(e) {
    const t = this.callNode.build(e, "void");
    return t !== "" && e.addLineFlowCode(t, this), this.outputNode.build(e);
  }
}
const Bd = /* @__PURE__ */ Y(Yy).setParameterLength(2);
S("bypass", Bd);
const Il = /* @__PURE__ */ b(([r, e, t, s = f(0), i = f(1), a = mt(!1)]) => {
  let n = r.sub(e).div(t.sub(e));
  return Dr(a) && (n = n.clamp()), n.mul(i.sub(s)).add(s);
});
function Ud(r, e, t, s = f(0), i = f(1)) {
  return Il(r, e, t, s, i, !0);
}
S("remap", Il);
S("remapClamp", Ud);
class Zy extends k {
  static get type() {
    return "ExpressionNode";
  }
  /**
   * Constructs a new expression node.
   *
   * @param {string} [snippet=''] - The native code snippet.
   * @param {string} [nodeType='void'] - The node type.
   */
  constructor(e = "", t = "void") {
    super(t), this.snippet = e;
  }
  generate(e, t) {
    const s = this.getNodeType(e), i = this.snippet;
    if (s === "void")
      e.addLineFlowCode(i, this);
    else
      return e.format(i, s, t);
  }
}
const ct = /* @__PURE__ */ Y(Zy).setParameterLength(1, 2), kd = (r) => (r ? He(r, ct("discard")) : ct("discard")).toStack(), Jy = () => ct("return").toStack();
S("discard", kd);
const Ol = /* @__PURE__ */ b(([r]) => D(r.rgb.mul(r.a), r.a), { color: "vec4", return: "vec4" }), Dd = /* @__PURE__ */ b(([r]) => r.a.equal(0).select(D(0), D(r.rgb.div(r.a), r.a)), { color: "vec4", return: "vec4" });
class Qy extends we {
  static get type() {
    return "RenderOutputNode";
  }
  /**
   * Constructs a new render output node.
   *
   * @param {Node} colorNode - The color node to process.
   * @param {?number} toneMapping - The tone mapping type.
   * @param {?string} outputColorSpace - The output color space.
   */
  constructor(e, t, s) {
    super("vec4"), this.colorNode = e, this._toneMapping = t, this.outputColorSpace = s, this.isRenderOutputNode = !0;
  }
  /**
   * Sets the tone mapping type.
   *
   * @param {number} value - The tone mapping type.
   * @return {ToneMappingNode} A reference to this node.
   */
  setToneMapping(e) {
    return this._toneMapping = e, this;
  }
  /**
   * Gets the tone mapping type.
   *
   * @returns {number} The tone mapping type.
   */
  getToneMapping() {
    return this._toneMapping;
  }
  setup({ context: e }) {
    let t = this.colorNode || e.color;
    t = D(t.rgb, t.a.clamp(0, 1)), t = Dd(t);
    const s = (this._toneMapping !== null ? this._toneMapping : e.toneMapping) || fo, i = (this.outputColorSpace !== null ? this.outputColorSpace : e.outputColorSpace) || Ta;
    return s !== fo && (t = t.toneMapping(s)), i !== Ta && i !== Ne.workingColorSpace && (t = t.workingToColorSpace(i)), t = Ol(t), t;
  }
}
const Wd = (r, e = null, t = null) => new Qy(U(r), e, t);
S("renderOutput", Wd);
class Ky extends we {
  static get type() {
    return "DebugNode";
  }
  constructor(e, t = null) {
    super(), this.node = e, this.callback = t;
  }
  generateNodeType(e) {
    return this.node.getNodeType(e);
  }
  setup(e) {
    return this.node.build(e);
  }
  analyze(e) {
    return this.node.build(e);
  }
  generate(e) {
    const t = this.callback, s = this.node.build(e);
    if (t !== null)
      t(e, s);
    else {
      const i = "--- TSL debug - " + e.shaderStage + " shader ---", a = "-".repeat(i.length);
      let n = "";
      n += "// #" + i + `#
`, n += e.flow.code.replace(/^\t/mg, "") + `
`, n += "/* ... */ " + s + ` /* ... */
`, n += "// #" + a + `#
`, bo(n);
    }
    return s;
  }
}
const qd = (r, e = null) => new Ky(U(r), e).toStack();
S("debug", qd);
class e0 extends Ps {
  /**
   * Creates a new InspectorBase.
   */
  constructor() {
    super(), this._renderer = null, this.currentFrame = null;
  }
  /**
   * Returns the node frame for the current renderer.
   *
   * @return {Object} The node frame.
   */
  get nodeFrame() {
    return this._renderer._nodes.nodeFrame;
  }
  /**
   * Sets the renderer for this inspector.
   *
   * @param {WebGLRenderer} renderer - The renderer to associate with this inspector.
   * @return {InspectorBase} This inspector instance.
   */
  setRenderer(e) {
    return this._renderer = e, this;
  }
  /**
   * Returns the renderer associated with this inspector.
   *
   * @return {WebGLRenderer} The associated renderer.
   */
  getRenderer() {
    return this._renderer;
  }
  /**
   * Initializes the inspector.
   */
  init() {
  }
  /**
   * Called when a frame begins.
   */
  begin() {
  }
  /**
   * Called when a frame ends.
   */
  finish() {
  }
  /**
   * Inspects a node.
   *
   * @param {Node} node - The node to inspect.
   */
  inspect() {
  }
  /**
   * When a compute operation is performed.
   *
   * @param {ComputeNode} computeNode - The compute node being executed.
   * @param {number|Array<number>} dispatchSizeOrCount - The dispatch size or count.
   */
  computeAsync() {
  }
  /**
   * Called when a compute operation begins.
   *
   * @param {string} uid - A unique identifier for the render context.
   * @param {ComputeNode} computeNode - The compute node being executed.
   */
  beginCompute() {
  }
  /**
   * Called when a compute operation ends.
   *
   * @param {string} uid - A unique identifier for the render context.
   * @param {ComputeNode} computeNode - The compute node being executed.
   */
  finishCompute() {
  }
  /**
   * Called when a render operation begins.
   *
   * @param {string} uid - A unique identifier for the render context.
   * @param {Scene} scene - The scene being rendered.
   * @param {Camera} camera - The camera being used for rendering.
   * @param {?WebGLRenderTarget} renderTarget - The render target, if any.
   */
  beginRender() {
  }
  /**
   * Called when an animation loop ends.
   *
   * @param {string} uid - A unique identifier for the render context.
   */
  finishRender() {
  }
  /**
   * Called when a texture copy operation is performed.
   *
   * @param {Texture} srcTexture - The source texture.
   * @param {Texture} dstTexture - The destination texture.
   */
  copyTextureToTexture() {
  }
  /**
   * Called when a framebuffer copy operation is performed.
   *
   * @param {Texture} framebufferTexture - The texture associated with the framebuffer.
   */
  copyFramebufferToTexture() {
  }
}
class t0 extends k {
  /**
   * Returns the type of the node.
   *
   * @returns {string}
   */
  static get type() {
    return "InspectorNode";
  }
  /**
   * Creates an InspectorNode.
   *
   * @param {Node} node - The node to inspect.
   * @param {string} [name=''] - Optional name for the inspector node.
   * @param {Function|null} [callback=null] - Optional callback to modify the node during setup.
   */
  constructor(e, t = "", s = null) {
    super(), this.node = e, this.name = t, this.callback = s, this.updateType = Q.FRAME, this.isInspectorNode = !0;
  }
  /**
   * Returns the name of the inspector node.
   *
   * @returns {string}
   */
  getName() {
    return this.name || this.node.name;
  }
  /**
   * Updates the inspector node, allowing inspection of the wrapped node.
   *
   * @param {NodeFrame} frame - A reference to the current node frame.
   */
  update(e) {
    e.renderer.inspector.inspect(this);
  }
  /**
   * Returns the type of the wrapped node.
   *
   * @param {NodeBuilder} builder - The node builder.
   * @returns {string}
   */
  generateNodeType(e) {
    return this.node.getNodeType(e);
  }
  /**
   * Sets up the inspector node.
   *
   * @param {NodeBuilder} builder - The node builder.
   * @returns {Node} The setup node.
   */
  setup(e) {
    let t = this.node;
    return e.context.inspector === !0 && this.callback !== null && (t = this.callback(t)), e.renderer.backend.isWebGPUBackend !== !0 && e.renderer.inspector.constructor !== e0 && Be('TSL: ".toInspector()" is only available with WebGPU.'), t;
  }
}
function jd(r, e = "", t = null) {
  return r = U(r), r.before(new t0(r, e, t));
}
S("toInspector", jd);
function s0(r) {
  X("TSL: AddNodeElement has been removed in favor of tree-shaking. Trying add", r);
}
class Gd extends k {
  static get type() {
    return "AttributeNode";
  }
  /**
   * Constructs a new attribute node.
   *
   * @param {string} attributeName - The name of the attribute.
   * @param {?string} nodeType - The node type.
   */
  constructor(e, t = null) {
    super(t), this.global = !0, this._attributeName = e;
  }
  getHash(e) {
    return this.getAttributeName(e);
  }
  generateNodeType(e) {
    let t = this.nodeType;
    if (t === null) {
      const s = this.getAttributeName(e);
      if (e.hasGeometryAttribute(s)) {
        const i = e.geometry.getAttribute(s);
        t = e.getTypeFromAttribute(i);
      } else
        t = "float";
    }
    return t;
  }
  /**
   * Sets the attribute name to the given value. The method can be
   * overwritten in derived classes if the final name must be computed
   * analytically.
   *
   * @param {string} attributeName - The name of the attribute.
   * @return {AttributeNode} A reference to this node.
   */
  setAttributeName(e) {
    return this._attributeName = e, this;
  }
  /**
   * Returns the attribute name of this node. The method can be
   * overwritten in derived classes if the final name must be computed
   * analytically.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The attribute name.
   */
  getAttributeName() {
    return this._attributeName;
  }
  generate(e) {
    const t = this.getAttributeName(e), s = this.getNodeType(e);
    if (e.hasGeometryAttribute(t) === !0) {
      const i = e.geometry.getAttribute(t), a = e.getTypeFromAttribute(i), n = e.getAttribute(t, a);
      return e.shaderStage === "vertex" ? e.format(n.name, a, s) : ur(this).build(e, s);
    } else
      return X(`AttributeNode: Vertex attribute "${t}" not found on geometry.`), e.generateConst(s);
  }
  serialize(e) {
    super.serialize(e), e.global = this.global, e._attributeName = this._attributeName;
  }
  deserialize(e) {
    super.deserialize(e), this.global = e.global, this._attributeName = e._attributeName;
  }
}
const Tt = (r, e = null) => new Gd(r, e), ae = (r = 0) => Tt("uv" + (r > 0 ? r : ""), "vec2");
class r0 extends k {
  static get type() {
    return "TextureSizeNode";
  }
  /**
   * Constructs a new texture size node.
   *
   * @param {TextureNode} textureNode - A texture node which size should be retrieved.
   * @param {?Node<int>} [levelNode=null] - A level node which defines the requested mip.
   */
  constructor(e, t = null) {
    super("uvec2"), this.isTextureSizeNode = !0, this.textureNode = e, this.levelNode = t;
  }
  generate(e, t) {
    const s = this.textureNode.build(e, "property"), i = this.levelNode === null ? "0" : this.levelNode.build(e, "int");
    return e.format(`${e.getMethod("textureDimensions")}( ${s}, ${i} )`, this.getNodeType(e), t);
  }
}
const sr = /* @__PURE__ */ Y(r0).setParameterLength(1, 2);
class i0 extends Mi {
  static get type() {
    return "MaxMipLevelNode";
  }
  /**
   * Constructs a new max mip level node.
   *
   * @param {TextureNode} textureNode - The texture node to compute the max mip level for.
   */
  constructor(e) {
    super(0), this._textureNode = e, this.updateType = Q.FRAME;
  }
  /**
   * The texture node to compute the max mip level for.
   *
   * @readonly
   * @type {TextureNode}
   */
  get textureNode() {
    return this._textureNode;
  }
  /**
   * The texture.
   *
   * @readonly
   * @type {Texture}
   */
  get texture() {
    return this._textureNode.value;
  }
  update() {
    const e = this.texture, t = e.images, s = t && t.length > 0 ? t[0] && t[0].image || t[0] : e.image;
    if (s && s.width !== void 0) {
      const { width: i, height: a } = s;
      this.value = Math.log2(Math.max(i, a));
    }
  }
}
const Pl = /* @__PURE__ */ Y(i0).setParameterLength(1);
class Hd extends Error {
  constructor(e, t = null) {
    super(e), this.name = "NodeError", this.stackTrace = t;
  }
}
const Fl = /* @__PURE__ */ new Ke();
class fs extends Mi {
  static get type() {
    return "TextureNode";
  }
  /**
   * Constructs a new texture node.
   *
   * @param {Texture} [value=EmptyTexture] - The texture.
   * @param {?Node<vec2|vec3>} [uvNode=null] - The uv node.
   * @param {?Node<int>} [levelNode=null] - The level node.
   * @param {?Node<float>} [biasNode=null] - The bias node.
   */
  constructor(e = Fl, t = null, s = null, i = null) {
    super(e), this.isTextureNode = !0, this.uvNode = t, this.levelNode = s, this.biasNode = i, this.compareNode = null, this.depthNode = null, this.gradNode = null, this.gatherNode = null, this.offsetNode = null, this.sampler = !0, this.updateMatrix = !1, this.updateType = Q.NONE, this.referenceNode = null, this._value = e, this._matrixUniform = null, this._flipYUniform = null, this.setUpdateMatrix(t === null);
  }
  set value(e) {
    this.referenceNode ? this.referenceNode.value = e : this._value = e;
  }
  /**
   * The texture value.
   *
   * @type {Texture}
   */
  get value() {
    return this.referenceNode ? this.referenceNode.value : this._value;
  }
  /**
   * Overwritten since the uniform hash is defined by the texture's UUID.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The uniform hash.
   */
  getUniformHash() {
    return this.value.uuid;
  }
  /**
   * Overwritten since the node type is inferred from the texture type.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The node type.
   */
  generateNodeType() {
    return this.value.isDepthTexture === !0 ? this.gatherNode === null ? "float" : "vec4" : this.value.type === Wo ? "uvec4" : this.value.type === vg ? "ivec4" : "vec4";
  }
  /**
   * Overwrites the default implementation to return a fixed value `'texture'`.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The input type.
   */
  getInputType() {
    return "texture";
  }
  /**
   * Returns a default uvs based on the current texture's channel.
   *
   * @return {AttributeNode<vec2>} The default uvs.
   */
  getDefaultUV() {
    return ae(this.value.channel);
  }
  /**
   * Overwritten to always return the texture reference of the node.
   *
   * @param {any} state - This method can be invocated in different contexts so `state` can refer to any object type.
   * @return {Texture} The texture reference.
   */
  updateReference() {
    return this.value;
  }
  /**
   * Transforms the given uv node with the texture transformation matrix.
   *
   * @param {Node} uvNode - The uv node to transform.
   * @return {Node} The transformed uv node.
   */
  getTransformedUV(e) {
    return this._matrixUniform === null && (this._matrixUniform = q(this.value.matrix)), this._matrixUniform.mul(N(e, 1)).xy;
  }
  /**
   * Defines whether the uv transformation matrix should automatically be updated or not.
   *
   * @param {boolean} value - The update toggle.
   * @return {TextureNode} A reference to this node.
   */
  setUpdateMatrix(e) {
    return this.updateMatrix = e, this;
  }
  /**
   * Setups the uv node. Depending on the backend as well as texture's image and type, it might be necessary
   * to modify the uv node for correct sampling.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {Node} uvNode - The uv node to setup.
   * @return {Node} The updated uv node.
   */
  setupUV(e, t) {
    return e.isFlipY() && (this._flipYUniform === null && (this._flipYUniform = q(!1)), t = t.toVar(), this.sampler ? t = this._flipYUniform.select(t.flipY(), t) : t = this._flipYUniform.select(t.setY(x(sr(this, this.levelNode).y).sub(t.y).sub(1)), t)), t;
  }
  /**
   * Setups texture node by preparing the internal nodes for code generation.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */
  setup(e) {
    const t = e.getNodeProperties(this);
    t.referenceNode = this.referenceNode;
    const s = this.value;
    if (!s || s.isTexture !== !0)
      throw new Hd("THREE.TSL: `texture( value )` function expects a valid instance of THREE.Texture().", this.stackTrace);
    const i = b(() => {
      let l = this.uvNode;
      return (l === null || e.context.forceUVContext === !0) && e.context.getUV && (l = e.context.getUV(this, e)), l || (l = this.getDefaultUV()), this.updateMatrix === !0 && (l = this.getTransformedUV(l)), l = this.setupUV(e, l), this.updateType = this._matrixUniform !== null || this._flipYUniform !== null ? Q.OBJECT : Q.NONE, l;
    })();
    let a = this.levelNode;
    a === null && e.context.getTextureLevel && (a = e.context.getTextureLevel(this));
    let n = null, o = null;
    if (this.compareNode !== null)
      if (e.renderer.hasCompatibility(Ih.TEXTURE_COMPARE))
        n = this.compareNode;
      else {
        const l = s.compareFunction;
        l === null || l === _g || l === jo || l === bu || l === Na ? o = this.compareNode : (n = this.compareNode, Be('TSL: Only "LessCompare", "LessEqualCompare", "GreaterCompare" and "GreaterEqualCompare" are supported for depth texture comparison fallback.'));
      }
    t.uvNode = i, t.levelNode = a, t.biasNode = this.biasNode, t.compareNode = n, t.compareStepNode = o, t.gradNode = this.gradNode, t.gatherNode = this.gatherNode, t.depthNode = this.depthNode, t.offsetNode = this.offsetNode;
  }
  /**
   * Generates the uv code snippet.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {Node} uvNode - The uv node to generate code for.
   * @return {string} The generated code snippet.
   */
  generateUV(e, t) {
    return t.build(e, this.sampler === !0 ? "vec2" : "ivec2");
  }
  /**
   * Generates the offset code snippet.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {Node} offsetNode - The offset node to generate code for.
   * @return {string} The generated code snippet.
   */
  generateOffset(e, t) {
    return t.build(e, "ivec2");
  }
  /**
   * Generates the snippet for the texture sampling.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {string} textureProperty - The texture property.
   * @param {string} uvSnippet - The uv snippet.
   * @param {?string} levelSnippet - The level snippet.
   * @param {?string} biasSnippet - The bias snippet.
   * @param {?string} depthSnippet - The depth snippet.
   * @param {?string} compareSnippet - The compare snippet.
   * @param {?Array<string>} gradSnippet - The grad snippet.
   * @param {?string} gatherSnippet - The gather snippet.
   * @param {?string} offsetSnippet - The offset snippet.
   * @param {?string} flipYSnippet - The y-flip snippet. Only used for WebGL.
   * @return {string} The generated code snippet.
   */
  generateSnippet(e, t, s, i, a, n, o, l, u, h, d) {
    const p = this.value;
    let m;
    return a ? m = e.generateTextureBias(p, t, s, a, n, h) : l ? m = e.generateTextureGrad(p, t, s, l, n, h) : u ? o ? m = e.generateTextureGatherCompare(p, t, s, o, n, h, d) : m = e.generateTextureGather(p, t, s, u, n, h, d) : o ? m = e.generateTextureCompare(p, t, s, o, n, h) : this.sampler === !1 ? m = e.generateTextureLoad(p, t, s, i, n, h) : i ? m = e.generateTextureLevel(p, t, s, i, n, h) : m = e.generateTexture(p, t, s, n, h), m;
  }
  /**
   * Generates the code snippet of the texture node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {string} output - The current output.
   * @return {string} The generated code snippet.
   */
  generate(e, t) {
    const s = this.value, i = e.getNodeProperties(this), a = super.generate(e, "property");
    if (/^sampler/.test(t))
      return a + "_sampler";
    if (e.isReference(t))
      return a;
    {
      const n = e.getDataFromNode(this);
      let o = this.getNodeType(e), l = n.propertyName;
      if (l === void 0) {
        const { uvNode: h, levelNode: d, biasNode: p, compareNode: m, compareStepNode: g, depthNode: y, gradNode: v, gatherNode: w, offsetNode: _ } = i, C = this.generateUV(e, h), V = d ? d.build(e, "float") : null, P = p ? p.build(e, "float") : null, z = y ? y.build(e, "int") : null, R = m ? m.build(e, "float") : null, I = g ? g.build(e, "float") : null, G = v ? [v[0].build(e, "vec2"), v[1].build(e, "vec2")] : null, $ = w ? w.build(e, "int") : null, Z = _ ? this.generateOffset(e, _) : null, Ve = this._flipYUniform ? this._flipYUniform.build(e, "bool") : null;
        $ && (o = "vec4");
        let ue = z;
        ue === null && s.isArrayTexture && this.isTexture3DNode !== !0 && (ue = "0");
        const Ye = e.getVarFromNode(this);
        l = e.getPropertyName(Ye);
        let se = this.generateSnippet(e, a, C, V, P, ue, R, G, $, Z, Ve);
        if (I !== null) {
          const ss = s.compareFunction;
          ss === bu || ss === Na ? se = tr(ct(se, o), ct(I, "float")).build(e, o) : se = tr(ct(I, "float"), ct(se, o)).build(e, o);
        }
        e.addLineFlowCode(`${l} = ${se}`, this), n.snippet = se, n.propertyName = l;
      }
      let u = l;
      return e.needsToWorkingColorSpace(s) && (u = Cl(ct(u, o), s.colorSpace).setup(e).build(e, o)), e.format(u, o, t);
    }
  }
  /**
   * Sets the sampler value.
   *
   * @param {boolean} value - The sampler value to set.
   * @return {TextureNode} A reference to this texture node.
   */
  setSampler(e) {
    return this.sampler = e, this;
  }
  /**
   * Returns the sampler value.
   *
   * @return {boolean} The sampler value.
   */
  getSampler() {
    return this.sampler;
  }
  // @TODO: Move to TSL
  /**
   * Samples the texture with the given uv node.
   *
   * @param {Node} uvNode - The uv node.
   * @return {TextureNode} A texture node representing the texture sample.
   */
  sample(e) {
    const t = this.clone();
    return t.uvNode = U(e), t.referenceNode = this.getBase(), U(t);
  }
  /**
   * TSL function for creating a texture node that fetches/loads texels without interpolation.
   *
   * @param {Node<uvec2>} uvNode - The uv node.
   * @returns {TextureNode} A texture node representing the texture load.
   */
  load(e) {
    return this.sample(e).setSampler(!1);
  }
  /**
   * Samples a blurred version of the texture by defining an internal bias.
   *
   * @param {Node<float>} amountNode - How blurred the texture should be.
   * @return {TextureNode} A texture node representing the texture sample.
   */
  blur(e) {
    const t = this.clone();
    t.biasNode = U(e).mul(Pl(t)), t.referenceNode = this.getBase();
    const s = t.value;
    return t.generateMipmaps === !1 && (s && s.generateMipmaps === !1 || s.minFilter === at || s.magFilter === at) && (X("TSL: texture().blur() requires mipmaps and sampling. Use .generateMipmaps=true and .minFilter/.magFilter=THREE.LinearFilter in the Texture."), t.biasNode = null), U(t);
  }
  /**
   * Samples a specific mip of the texture.
   *
   * @param {Node<int>} levelNode - The mip level to sample.
   * @return {TextureNode} A texture node representing the texture sample.
   */
  level(e) {
    const t = this.clone();
    return t.levelNode = U(e), t.referenceNode = this.getBase(), U(t);
  }
  /**
   * Returns the texture size of the requested level.
   *
   * @param {Node<int>} levelNode - The level to compute the size for.
   * @return {TextureSizeNode} The texture size.
   */
  size(e) {
    return sr(this, e);
  }
  /**
   * Samples the texture with the given bias.
   *
   * @param {Node<float>} biasNode - The bias node.
   * @return {TextureNode} A texture node representing the texture sample.
   */
  bias(e) {
    const t = this.clone();
    return t.biasNode = U(e), t.referenceNode = this.getBase(), U(t);
  }
  /**
   * Returns the base texture of this node.
   * @return {TextureNode} The base texture node.
   */
  getBase() {
    return this.referenceNode ? this.referenceNode.getBase() : this;
  }
  /**
   * Samples the texture by executing a compare operation.
   *
   * @param {Node<float>} compareNode - The node that defines the compare value.
   * @return {TextureNode} A texture node representing the texture sample.
   */
  compare(e) {
    const t = this.clone();
    return t.compareNode = U(e), t.referenceNode = this.getBase(), U(t);
  }
  /**
   * Samples the texture using an explicit gradient.
   *
   * @param {Node<vec2>} gradNodeX - The gradX node.
   * @param {Node<vec2>} gradNodeY - The gradY node.
   * @return {TextureNode} A texture node representing the texture sample.
   */
  grad(e, t) {
    const s = this.clone();
    return s.gradNode = [U(e), U(t)], s.referenceNode = this.getBase(), U(s);
  }
  /**
   * Gathers four texels from the texture.
   *
   * @param {Node<int>} gatherNode - The index of the channel to read. This must be in range [0, 3] and a compile-time constant.
   * @return {TextureNode} A texture node representing the texture sample.
   */
  gather(e = 0) {
    const t = this.clone();
    return t.gatherNode = U(e), t.referenceNode = this.getBase(), U(t);
  }
  /**
   * Samples the texture by defining a depth node.
   *
   * @param {Node<int>} depthNode - The depth node.
   * @return {TextureNode} A texture node representing the texture sample.
   */
  depth(e) {
    const t = this.clone();
    return t.depthNode = U(e), t.referenceNode = this.getBase(), U(t);
  }
  /**
   * Samples the texture by defining an offset node.
   *
   * @param {Node<ivec2>} offsetNode - The offset node.
   * @return {TextureNode} A texture node representing the texture sample.
   */
  offset(e) {
    const t = this.clone();
    return t.offsetNode = U(e), t.referenceNode = this.getBase(), U(t);
  }
  // --
  serialize(e) {
    super.serialize(e), e.value = this.value.toJSON(e.meta).uuid, e.sampler = this.sampler, e.updateMatrix = this.updateMatrix, e.updateType = this.updateType;
  }
  deserialize(e) {
    super.deserialize(e), this.value = e.meta.textures[e.value], this.sampler = e.sampler, this.updateMatrix = e.updateMatrix, this.updateType = e.updateType;
  }
  /**
   * The update is used to implement the update of the uv transformation matrix.
   */
  update() {
    const e = this.value, t = this._matrixUniform;
    t !== null && (t.value = e.matrix), e.matrixAutoUpdate === !0 && e.updateMatrix();
    const s = this._flipYUniform;
    s !== null && (s.value = e.image instanceof ImageBitmap && e.flipY === !0 || e.isRenderTargetTexture === !0 || e.isFramebufferTexture === !0 || e.isDepthTexture === !0);
  }
  /**
   * Clones the texture node.
   *
   * @return {TextureNode} The cloned texture node.
   */
  clone() {
    const e = new this.constructor(this.value, this.uvNode, this.levelNode, this.biasNode);
    return e.sampler = this.sampler, e.depthNode = this.depthNode, e.compareNode = this.compareNode, e.gradNode = this.gradNode, e.gatherNode = this.gatherNode, e.offsetNode = this.offsetNode, e;
  }
}
const a0 = /* @__PURE__ */ Y(fs).setParameterLength(1, 4).setName("texture"), xe = (r = Fl, e = null, t = null, s = null) => {
  let i;
  return r && r.isTextureNode === !0 ? (i = U(r.clone()), i.referenceNode = r.getBase(), e !== null && (i.uvNode = U(e)), t !== null && (i.levelNode = U(t)), s !== null && (i.biasNode = U(s))) : i = a0(r, e, t, s), i;
}, n0 = (r = Fl) => xe(r), ve = (...r) => xe(...r).setSampler(!1), o0 = (r, e, t) => xe(r, e).level(t), l0 = (r) => (r.isNode === !0 ? r : xe(r)).convert("sampler"), u0 = (r) => (r.isNode === !0 ? r : xe(r)).convert("samplerComparison");
class Bl extends Mi {
  static get type() {
    return "BufferNode";
  }
  /**
   * Constructs a new buffer node.
   *
   * @param {Array<number>} value - Array-like buffer data.
   * @param {string} bufferType - The data type of the buffer.
   * @param {number} [bufferCount=0] - The count of buffer elements.
   */
  constructor(e, t, s = 0) {
    super(e, t), this.isBufferNode = !0, this.bufferType = t, this.bufferCount = s, this.updateRanges = [];
  }
  /**
   * Adds a range of data in the data array to be updated on the GPU.
   *
   * @param {number} start - Position at which to start update.
   * @param {number} count - The number of components to update.
   */
  addUpdateRange(e, t) {
    this.updateRanges.push({ start: e, count: t });
  }
  /**
   * Clears the update ranges.
   */
  clearUpdateRanges() {
    this.updateRanges.length = 0;
  }
  /**
   * The data type of the buffer elements.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The element type.
   */
  getElementType(e) {
    return this.getNodeType(e);
  }
  /**
   * Overwrites the default implementation to return a fixed value `'buffer'`.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The input type.
   */
  getInputType() {
    return "buffer";
  }
}
const $r = (r, e, t) => new Bl(r, e, t);
class h0 extends nr {
  static get type() {
    return "UniformArrayElementNode";
  }
  /**
   * Constructs a new buffer node.
   *
   * @param {UniformArrayNode} uniformArrayNode - The uniform array node to access.
   * @param {IndexNode} indexNode - The index data that define the position of the accessed element in the array.
   */
  constructor(e, t) {
    super(e, t), this.isArrayBufferElementNode = !0;
  }
  generate(e) {
    const t = super.generate(e), s = this.getNodeType(e), i = this.node.getPaddedType();
    return e.format(t, i, s);
  }
}
class c0 extends Bl {
  static get type() {
    return "UniformArrayNode";
  }
  /**
   * Constructs a new uniform array node.
   *
   * @param {Array<any>} value - Array holding the buffer data.
   * @param {?string} [elementType=null] - The data type of a buffer element.
   */
  constructor(e, t = null) {
    super(null), this.array = e, this.elementType = t === null ? Cs(e[0]) : t, this.paddedType = this.getPaddedType(), this.updateType = Q.RENDER, this.isArrayBufferNode = !0;
  }
  /**
   * This method is overwritten since the node type is inferred from the
   * {@link UniformArrayNode#paddedType}.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The node type.
   */
  generateNodeType() {
    return this.paddedType;
  }
  /**
   * The data type of the array elements.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The element type.
   */
  getElementType() {
    return this.elementType;
  }
  /**
   * Returns the padded type based on the element type.
   *
   * @return {string} The padded type.
   */
  getPaddedType() {
    const e = this.elementType;
    let t = "vec4";
    return e === "mat2" ? t = "mat2" : /mat/.test(e) === !0 ? t = "mat4" : e.charAt(0) === "i" ? t = "ivec4" : e.charAt(0) === "u" && (t = "uvec4"), t;
  }
  /**
   * The update makes sure to correctly transfer the data from the (complex) objects
   * in the array to the internal, correctly padded value buffer.
   *
   * @param {NodeFrame} frame - A reference to the current node frame.
   */
  update() {
    const { array: e, value: t } = this, s = this.elementType;
    if (s === "float" || s === "int" || s === "uint")
      for (let i = 0; i < e.length; i++) {
        const a = i * 4;
        t[a] = e[i];
      }
    else if (s === "color")
      for (let i = 0; i < e.length; i++) {
        const a = i * 4, n = e[i];
        t[a] = n.r, t[a + 1] = n.g, t[a + 2] = n.b || 0;
      }
    else if (s === "mat2")
      for (let i = 0; i < e.length; i++) {
        const a = i * 4, n = e[i];
        t[a] = n.elements[0], t[a + 1] = n.elements[1], t[a + 2] = n.elements[2], t[a + 3] = n.elements[3];
      }
    else if (s === "mat3")
      for (let i = 0; i < e.length; i++) {
        const a = i * 16, n = e[i];
        t[a] = n.elements[0], t[a + 1] = n.elements[1], t[a + 2] = n.elements[2], t[a + 4] = n.elements[3], t[a + 5] = n.elements[4], t[a + 6] = n.elements[5], t[a + 8] = n.elements[6], t[a + 9] = n.elements[7], t[a + 10] = n.elements[8], t[a + 15] = 1;
      }
    else if (s === "mat4")
      for (let i = 0; i < e.length; i++) {
        const a = i * 16, n = e[i];
        for (let o = 0; o < n.elements.length; o++)
          t[a + o] = n.elements[o];
      }
    else
      for (let i = 0; i < e.length; i++) {
        const a = i * 4, n = e[i];
        t[a] = n.x, t[a + 1] = n.y, t[a + 2] = n.z || 0, t[a + 3] = n.w || 0;
      }
  }
  /**
   * Implement the value buffer creation based on the array data.
   *
   * @param {NodeBuilder} builder - A reference to the current node builder.
   * @return {null}
   */
  setup(e) {
    const t = this.array.length, s = this.elementType;
    let i = Float32Array;
    const a = this.paddedType, n = e.getTypeLength(a);
    return s.charAt(0) === "i" && (i = Int32Array), s.charAt(0) === "u" && (i = Uint32Array), this.value = new i(t * n), this.bufferCount = t, this.bufferType = a, this.update(), super.setup(e);
  }
  /**
   * Overwrites the default `element()` method to provide element access
   * based on {@link UniformArrayNode}.
   *
   * @param {IndexNode} indexNode - The index node.
   * @return {UniformArrayElementNode}
   */
  element(e) {
    return new h0(this, U(e));
  }
}
const Ge = (r, e) => new c0(r, e);
class d0 extends k {
  /**
   * Constructs a new builtin node.
   *
   * @param {string} name - The name of the built-in shader variable.
   */
  constructor(e) {
    super("float"), this.name = e, this.isBuiltinNode = !0;
  }
  /**
   * Generates the code snippet of the builtin node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The generated code snippet.
   */
  generate() {
    return this.name;
  }
}
const Bs = Y(d0).setParameterLength(1);
let ri, ii;
class ce extends k {
  static get type() {
    return "ScreenNode";
  }
  /**
   * Constructs a new screen node.
   *
   * @param {('coordinate'|'viewport'|'size'|'uv'|'dpr')} scope - The node's scope.
   */
  constructor(e) {
    super(), this.scope = e, this._output = null, this.isViewportNode = !0;
  }
  /**
   * This method is overwritten since the node type depends on the selected scope.
   *
   * @return {('float'|'vec2'|'vec4')} The node type.
   */
  generateNodeType() {
    return this.scope === ce.DPR ? "float" : this.scope === ce.VIEWPORT ? "vec4" : "vec2";
  }
  /**
   * This method is overwritten since the node's update type depends on the selected scope.
   *
   * @return {NodeUpdateType} The update type.
   */
  getUpdateType() {
    let e = Q.NONE;
    return (this.scope === ce.SIZE || this.scope === ce.VIEWPORT || this.scope === ce.DPR) && (e = Q.RENDER), this.updateType = e, e;
  }
  /**
   * `ScreenNode` implements {@link Node#update} to retrieve viewport and size information
   * from the current renderer.
   *
   * @param {NodeFrame} frame - A reference to the current node frame.
   */
  update({ renderer: e }) {
    const t = e.getRenderTarget();
    this.scope === ce.VIEWPORT ? t !== null ? ii.copy(t.viewport) : (e.getViewport(ii), ii.multiplyScalar(e.getPixelRatio())) : this.scope === ce.DPR ? this._output.value = e.getPixelRatio() : t !== null ? (ri.width = t.width, ri.height = t.height) : e.getDrawingBufferSize(ri);
  }
  setup() {
    const e = this.scope;
    let t = null;
    return e === ce.SIZE ? t = q(ri || (ri = new _e())) : e === ce.VIEWPORT ? t = q(ii || (ii = new tt())) : e === ce.DPR ? t = q(1) : t = B(cr.div(qr)), this._output = t, t;
  }
  generate(e) {
    if (this.scope === ce.COORDINATE) {
      let t = e.getFragCoord();
      if (e.isFlipY()) {
        const s = e.getNodeProperties(qr).outputNode.build(e);
        t = `${e.getType("vec2")}( ${t}.x, ${s}.y - ${t}.y )`;
      }
      return t;
    }
    return super.generate(e);
  }
}
ce.COORDINATE = "coordinate";
ce.VIEWPORT = "viewport";
ce.SIZE = "size";
ce.UV = "uv";
ce.DPR = "dpr";
const Xd = /* @__PURE__ */ O(ce, ce.DPR), hr = /* @__PURE__ */ O(ce, ce.UV), qr = /* @__PURE__ */ O(ce, ce.SIZE), cr = /* @__PURE__ */ O(ce, ce.COORDINATE), Ur = /* @__PURE__ */ O(ce, ce.VIEWPORT), $d = Ur.zw, Yd = /* @__PURE__ */ cr.sub(Ur.xy), p0 = /* @__PURE__ */ Yd.div($d), m0 = /* @__PURE__ */ b(() => (X('TSL: "viewportResolution" is deprecated. Use "screenSize" instead.', new Re()), qr), "vec2").once()();
let Un = null, Ji = null, kn = null, Qi = null, Dn = null, Ki = null, Wn = null, ea = null, qn = null, ta = null, jn = null, sa = null, Gn = null, ra = null;
const Us = /* @__PURE__ */ q(0, "uint").setName("u_cameraIndex").setGroup(Xa("cameraIndex")).toVarying("v_cameraIndex"), _s = /* @__PURE__ */ q("float").setName("cameraNear").setGroup(H).onRenderUpdate(({ camera: r }) => r.near), As = /* @__PURE__ */ q("float").setName("cameraFar").setGroup(H).onRenderUpdate(({ camera: r }) => r.far), Ot = /* @__PURE__ */ b(({ camera: r }) => {
  let e;
  if (r.isArrayCamera && r.cameras.length > 0) {
    const t = [];
    for (const s of r.cameras)
      t.push(s.projectionMatrix);
    Ji === null ? Ji = Ge(t).setGroup(H).setName("cameraProjectionMatrices") : Ji.array = t, e = Ji.element(r.isMultiViewCamera ? Bs("gl_ViewID_OVR") : Us);
  } else
    Un === null && (Un = q(r.projectionMatrix).setName("cameraProjectionMatrix").setGroup(H).onRenderUpdate(({ camera: t }) => t.projectionMatrix)), e = Un;
  return e;
}).once()(), Zd = /* @__PURE__ */ b(({ camera: r }) => {
  let e;
  if (r.isArrayCamera && r.cameras.length > 0) {
    const t = [];
    for (const s of r.cameras)
      t.push(s.projectionMatrixInverse);
    Qi === null ? Qi = Ge(t).setGroup(H).setName("cameraProjectionMatricesInverse") : Qi.array = t, e = Qi.element(r.isMultiViewCamera ? Bs("gl_ViewID_OVR") : Us);
  } else
    kn === null && (kn = q(r.projectionMatrixInverse).setName("cameraProjectionMatrixInverse").setGroup(H).onRenderUpdate(({ camera: t }) => t.projectionMatrixInverse)), e = kn;
  return e;
}).once()(), dr = /* @__PURE__ */ b(({ camera: r }) => {
  let e;
  if (r.isArrayCamera && r.cameras.length > 0) {
    const t = [];
    for (const s of r.cameras)
      t.push(s.matrixWorldInverse);
    Ki === null ? Ki = Ge(t).setGroup(H).setName("cameraViewMatrices") : Ki.array = t, e = Ki.element(r.isMultiViewCamera ? Bs("gl_ViewID_OVR") : Us);
  } else
    Dn === null && (Dn = q(r.matrixWorldInverse).setName("cameraViewMatrix").setGroup(H).onRenderUpdate(({ camera: t }) => t.matrixWorldInverse)), e = Dn;
  return e;
}).once()(), Qa = /* @__PURE__ */ b(({ camera: r }) => {
  let e;
  if (r.isArrayCamera && r.cameras.length > 0) {
    const t = [];
    for (const s of r.cameras)
      t.push(s.matrixWorld);
    ea === null ? ea = Ge(t).setGroup(H).setName("cameraWorldMatrices") : ea.array = t, e = ea.element(r.isMultiViewCamera ? Bs("gl_ViewID_OVR") : Us);
  } else
    Wn === null && (Wn = q(r.matrixWorld).setName("cameraWorldMatrix").setGroup(H).onRenderUpdate(({ camera: t }) => t.matrixWorld)), e = Wn;
  return e;
}).once()(), g0 = /* @__PURE__ */ b(({ camera: r }) => {
  let e;
  if (r.isArrayCamera && r.cameras.length > 0) {
    const t = [];
    for (const s of r.cameras)
      t.push(s.normalMatrix);
    ta === null ? ta = Ge(t).setGroup(H).setName("cameraNormalMatrices") : ta.array = t, e = ta.element(r.isMultiViewCamera ? Bs("gl_ViewID_OVR") : Us);
  } else
    qn === null && (qn = q(r.normalMatrix).setName("cameraNormalMatrix").setGroup(H).onRenderUpdate(({ camera: t }) => t.normalMatrix)), e = qn;
  return e;
}).once()(), f0 = /* @__PURE__ */ b(({ camera: r }) => {
  let e;
  if (r.isArrayCamera && r.cameras.length > 0) {
    const t = [];
    for (let s = 0, i = r.cameras.length; s < i; s++)
      t.push(new M());
    sa === null ? sa = Ge(t).setGroup(H).setName("cameraPositions").onRenderUpdate(({ camera: s }, i) => {
      const a = s.cameras, n = i.array;
      for (let o = 0, l = a.length; o < l; o++)
        n[o].setFromMatrixPosition(a[o].matrixWorld);
    }) : sa.array = t, e = sa.element(r.isMultiViewCamera ? Bs("gl_ViewID_OVR") : Us);
  } else
    jn === null && (jn = q(new M()).setName("cameraPosition").setGroup(H).onRenderUpdate(({ camera: t }, s) => s.value.setFromMatrixPosition(t.matrixWorld))), e = jn;
  return e;
}).once()(), y0 = /* @__PURE__ */ b(({ camera: r }) => {
  let e;
  if (r.isArrayCamera && r.cameras.length > 0) {
    const t = [];
    for (const s of r.cameras)
      t.push(s.viewport);
    ra === null ? ra = Ge(t, "vec4").setGroup(H).setName("cameraViewports") : ra.array = t, e = ra.element(Us);
  } else
    Gn === null && (Gn = D(0, 0, qr.x, qr.y).toConst("cameraViewport")), e = Gn;
  return e;
}).once()(), Yu = /* @__PURE__ */ new Xo();
class J extends k {
  static get type() {
    return "Object3DNode";
  }
  /**
   * Constructs a new object 3D node.
   *
   * @param {('position'|'viewPosition'|'direction'|'scale'|'worldMatrix')} scope - The node represents a different type of transformation depending on the scope.
   * @param {?Object3D} [object3d=null] - The 3D object.
   */
  constructor(e, t = null) {
    super(), this.scope = e, this.object3d = t, this.updateType = Q.OBJECT, this.uniformNode = new Mi(null);
  }
  /**
   * Overwritten since the node type is inferred from the scope.
   *
   * @return {('mat4'|'vec3'|'float')} The node type.
   */
  generateNodeType() {
    const e = this.scope;
    if (e === J.WORLD_MATRIX)
      return "mat4";
    if (e === J.POSITION || e === J.VIEW_POSITION || e === J.DIRECTION || e === J.SCALE)
      return "vec3";
    if (e === J.RADIUS)
      return "float";
  }
  /**
   * Updates the uniform value depending on the scope.
   *
   * @param {NodeFrame} frame - The current node frame.
   */
  update(e) {
    const t = this.object3d, s = this.uniformNode, i = this.scope;
    if (i === J.WORLD_MATRIX)
      s.value = t.matrixWorld;
    else if (i === J.POSITION)
      s.value = s.value || new M(), s.value.setFromMatrixPosition(t.matrixWorld);
    else if (i === J.SCALE)
      s.value = s.value || new M(), s.value.setFromMatrixScale(t.matrixWorld);
    else if (i === J.DIRECTION)
      s.value = s.value || new M(), t.getWorldDirection(s.value);
    else if (i === J.VIEW_POSITION) {
      const a = e.camera;
      s.value = s.value || new M(), s.value.setFromMatrixPosition(t.matrixWorld), s.value.applyMatrix4(a.matrixWorldInverse);
    } else if (i === J.RADIUS) {
      const a = e.object.geometry;
      a.boundingSphere === null && a.computeBoundingSphere(), Yu.copy(a.boundingSphere).applyMatrix4(t.matrixWorld), s.value = Yu.radius;
    }
  }
  /**
   * Generates the code snippet of the uniform node. The node type of the uniform
   * node also depends on the selected scope.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The generated code snippet.
   */
  generate(e) {
    const t = this.scope;
    return t === J.WORLD_MATRIX ? this.uniformNode.nodeType = "mat4" : t === J.POSITION || t === J.VIEW_POSITION || t === J.DIRECTION || t === J.SCALE ? this.uniformNode.nodeType = "vec3" : t === J.RADIUS && (this.uniformNode.nodeType = "float"), this.uniformNode.build(e);
  }
  serialize(e) {
    super.serialize(e), e.scope = this.scope;
  }
  deserialize(e) {
    super.deserialize(e), this.scope = e.scope;
  }
}
J.WORLD_MATRIX = "worldMatrix";
J.POSITION = "position";
J.SCALE = "scale";
J.VIEW_POSITION = "viewPosition";
J.DIRECTION = "direction";
J.RADIUS = "radius";
const x0 = /* @__PURE__ */ Y(J, J.DIRECTION).setParameterLength(1), b0 = /* @__PURE__ */ Y(J, J.WORLD_MATRIX).setParameterLength(1), v0 = /* @__PURE__ */ Y(J, J.POSITION).setParameterLength(1), T0 = /* @__PURE__ */ Y(J, J.SCALE).setParameterLength(1), w0 = /* @__PURE__ */ Y(J, J.VIEW_POSITION).setParameterLength(1), N0 = /* @__PURE__ */ Y(J, J.RADIUS).setParameterLength(1);
class _t extends J {
  static get type() {
    return "ModelNode";
  }
  /**
   * Constructs a new object model node.
   *
   * @param {('position'|'viewPosition'|'direction'|'scale'|'worldMatrix')} scope - The node represents a different type of transformation depending on the scope.
   */
  constructor(e) {
    super(e);
  }
  /**
   * Extracts the model reference from the frame state and then
   * updates the uniform value depending on the scope.
   *
   * @param {NodeFrame} frame - The current node frame.
   */
  update(e) {
    this.object3d = e.object, super.update(e);
  }
}
const M0 = /* @__PURE__ */ O(_t, _t.DIRECTION), hs = /* @__PURE__ */ O(_t, _t.WORLD_MATRIX), S0 = /* @__PURE__ */ O(_t, _t.POSITION), _0 = /* @__PURE__ */ O(_t, _t.SCALE), A0 = /* @__PURE__ */ O(_t, _t.VIEW_POSITION), V0 = /* @__PURE__ */ O(_t, _t.RADIUS), Jd = /* @__PURE__ */ q(new Kt()).onObjectUpdate(({ object: r }, e) => e.value.getNormalMatrix(r.matrixWorld)), C0 = /* @__PURE__ */ q(new de()).onObjectUpdate(({ object: r }, e) => e.value.copy(r.matrixWorld).invert()), rr = /* @__PURE__ */ b((r) => r.context.modelViewMatrix || Qd).once()().toVar("modelViewMatrix"), Qd = /* @__PURE__ */ dr.mul(hs), z0 = /* @__PURE__ */ b((r) => (r.context.isHighPrecisionModelViewMatrix = !0, q("mat4").onObjectUpdate(({ object: e, camera: t }) => e.modelViewMatrix.multiplyMatrices(t.matrixWorldInverse, e.matrixWorld)))).once()().toVar("highpModelViewMatrix"), R0 = /* @__PURE__ */ b((r) => {
  const e = r.context.isHighPrecisionModelViewMatrix;
  return q("mat3").onObjectUpdate(({ object: t, camera: s }) => (e !== !0 && t.modelViewMatrix.multiplyMatrices(s.matrixWorldInverse, t.matrixWorld), t.normalMatrix.getNormalMatrix(t.modelViewMatrix)));
}).once()().toVar("highpModelNormalViewMatrix"), Kd = /* @__PURE__ */ b((r) => r.shaderStage !== "fragment" ? (Be("TSL: `clipSpace` is only available in fragment stage."), D()) : r.context.clipSpace.toVarying("v_clipSpace")).once()(), st = /* @__PURE__ */ Tt("position", "vec3"), Te = /* @__PURE__ */ st.toVarying("positionLocal"), ir = /* @__PURE__ */ st.toVarying("positionPrevious"), Ks = /* @__PURE__ */ b((r) => hs.mul(Te).xyz.toVarying(r.getSubBuildProperty("v_positionWorld")), "vec3").once(["POSITION"])(), ep = /* @__PURE__ */ b(() => Te.transformDirection(hs).toVarying("v_positionWorldDirection").normalize().toVar("positionWorldDirection"), "vec3").once(["POSITION"])(), Ie = /* @__PURE__ */ b((r) => {
  if (r.shaderStage === "fragment" && r.material.vertexNode) {
    const e = Zd.mul(Kd);
    return e.xyz.div(e.w).toVar("positionView");
  }
  return r.context.setupPositionView().toVarying("v_positionView");
}, "vec3").once(["POSITION", "VERTEX"])(), dt = /* @__PURE__ */ b((r) => {
  let e;
  return r.camera.isOrthographicCamera ? e = N(0, 0, 1) : e = Ie.negate().toVarying("v_positionViewDirection").normalize(), e.toVar("positionViewDirection");
}, "vec3").once(["POSITION"])();
class E0 extends k {
  static get type() {
    return "FrontFacingNode";
  }
  /**
   * Constructs a new front facing node.
   */
  constructor() {
    super("bool"), this.isFrontFacingNode = !0;
  }
  generate(e) {
    if (e.shaderStage !== "fragment") return "true";
    const { material: t } = e;
    return t.side === vi ? "false" : e.getFrontFacing();
  }
}
const tp = /* @__PURE__ */ O(E0), Ul = /* @__PURE__ */ f(tp).mul(2).sub(1), Yr = /* @__PURE__ */ b(([r], { material: e }) => {
  const t = e.side;
  return t === vi ? r = r.mul(-1) : t === gg && (r = r.mul(Ul)), r;
}), L0 = (r) => (Be('TSL: "directionToFaceDirection()" has been renamed to "negateOnBackSide()".'), Yr(r)), kl = /* @__PURE__ */ Tt("normal", "vec3"), $e = /* @__PURE__ */ b((r) => r.geometry.hasAttribute("normal") === !1 ? (X('TSL: Vertex attribute "normal" not found on geometry.'), N(0, 1, 0)) : kl, "vec3").once()().toVar("normalLocal"), sp = /* @__PURE__ */ Ie.dFdx().cross(Ie.dFdy()).normalize().toVar("normalFlat"), xi = /* @__PURE__ */ b((r) => {
  let e;
  return r.isFlatShading() ? e = sp : e = Wl($e).toVarying("v_normalViewGeometry").normalize(), e;
}, "vec3").once()().toVar("normalViewGeometry"), I0 = /* @__PURE__ */ b((r) => {
  let e = xi.transformNormalByInverseViewMatrix(dr);
  return r.isFlatShading() !== !0 && (e = e.toVarying("v_normalWorldGeometry")), e.normalize().toVar("normalWorldGeometry");
}, "vec3").once()(), Ue = /* @__PURE__ */ b((r) => {
  let e;
  return r.subBuildFn === "NORMAL" || r.subBuildFn === "VERTEX" ? (e = xi, r.isFlatShading() !== !0 && (e = Yr(e))) : e = r.context.setupNormal().context({ getUV: null, getTextureLevel: null }), e;
}, "vec3").once(["NORMAL", "VERTEX"])().toVar("normalView"), Ka = /* @__PURE__ */ Ue.transformNormalByInverseViewMatrix(dr).toVar("normalWorld"), rp = /* @__PURE__ */ b(({ subBuildFn: r, context: e }) => {
  let t;
  return r === "NORMAL" || r === "VERTEX" ? t = Ue : t = e.setupClearcoatNormal().context({ getUV: null, getTextureLevel: null }), t;
}, "vec3").once(["NORMAL", "VERTEX"])().toVar("clearcoatNormalView"), Dl = /* @__PURE__ */ b(([r, e = hs]) => gt(e).inverse().transpose().mul(r).normalize());
S("transformNormal", Dl);
const Wl = /* @__PURE__ */ b(([r], e) => {
  const t = e.context.modelNormalViewMatrix;
  return t ? r.transformNormalByViewMatrix(t) : Jd.mul(r).transformNormalByViewMatrix(dr);
}), O0 = b(() => (X('TSL: "transformedNormalView" is deprecated. Use "normalView" instead.'), Ue)).once(["NORMAL", "VERTEX"])(), P0 = b(() => (X('TSL: "transformedNormalWorld" is deprecated. Use "normalWorld" instead.'), Ka)).once(["NORMAL", "VERTEX"])(), F0 = b(() => (X('TSL: "transformedClearcoatNormalView" is deprecated. Use "clearcoatNormalView" instead.'), rp)).once(["NORMAL", "VERTEX"])(), Hn = /* @__PURE__ */ new de(), ip = /* @__PURE__ */ q(0).onReference(({ material: r }) => r).onObjectUpdate(({ material: r }) => r.refractionRatio), B0 = /* @__PURE__ */ q(1).onReference(({ material: r }) => r).onObjectUpdate(function({ material: r, scene: e }) {
  return r.envMap ? r.envMapIntensity : e.environmentIntensity;
}), Ca = /* @__PURE__ */ q(new de()).onReference(function(r) {
  return r.material;
}).onObjectUpdate(function({ material: r, scene: e }) {
  const t = (e.environment !== null || e.environmentNode && e.environmentNode.isNode) && r.envMap === null ? e.environmentRotation : r.envMapRotation;
  return t ? Hn.makeRotationFromEuler(t).transpose() : Hn.identity(), Hn;
}), ap = /* @__PURE__ */ dt.negate().reflect(Ue), np = /* @__PURE__ */ dt.negate().refract(Ue, ip), op = /* @__PURE__ */ ap.transformDirection(Qa).toVar("reflectVector"), lp = /* @__PURE__ */ np.transformDirection(Qa).toVar("refractVector"), up = /* @__PURE__ */ new gf();
class U0 extends fs {
  static get type() {
    return "CubeTextureNode";
  }
  /**
   * Constructs a new cube texture node.
   *
   * @param {CubeTexture} value - The cube texture.
   * @param {?Node<vec3>} [uvNode=null] - The uv node.
   * @param {?Node<int>} [levelNode=null] - The level node.
   * @param {?Node<float>} [biasNode=null] - The bias node.
   */
  constructor(e, t = null, s = null, i = null) {
    super(e, t, s, i), this.isCubeTextureNode = !0;
  }
  /**
   * Overwrites the default implementation to return the appropriate cube texture type.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The input type.
   */
  getInputType() {
    return this.value.isDepthTexture === !0 ? "cubeDepthTexture" : "cubeTexture";
  }
  /**
   * Returns a default uvs based on the mapping type of the cube texture.
   *
   * @return {Node<vec3>} The default uv attribute.
   */
  getDefaultUV() {
    const e = this.value;
    return e.mapping === yi ? op : e.mapping === yo ? lp : (te('CubeTextureNode: Mapping "%s" not supported.', e.mapping), N(0, 0, 0));
  }
  /**
   * Overwritten with an empty implementation since the `updateMatrix` flag is ignored
   * for cube textures. The uv transformation matrix is not applied to cube textures.
   *
   * @param {boolean} value - The update toggle.
   */
  setUpdateMatrix() {
  }
  // Ignore .updateMatrix for CubeTextureNode
  /**
   * Setups the uv node. Depending on the backend as well as the texture type, it might be necessary
   * to modify the uv node for correct sampling.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {Node} uvNode - The uv node to setup.
   * @return {Node} The updated uv node.
   */
  setupUV(e, t) {
    const s = this.value;
    return s.isDepthTexture === !0 ? e.renderer.coordinateSystem === Ls ? N(t.x, t.y.negate(), t.z) : t : (t = Ca.mul(t), (e.renderer.coordinateSystem === Ls || !s.isRenderTargetTexture) && (t = N(t.x.negate(), t.yz)), t);
  }
  /**
   * Generates the uv code snippet.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {Node} cubeUV - The uv node to generate code for.
   * @return {string} The generated code snippet.
   */
  generateUV(e, t) {
    return t.build(e, this.sampler === !0 ? "vec3" : "ivec3");
  }
}
const ql = /* @__PURE__ */ Y(U0).setParameterLength(1, 4).setName("cubeTexture"), bt = (r = up, e = null, t = null, s = null) => {
  let i;
  return r && r.isCubeTextureNode === !0 ? (i = U(r.clone()), i.referenceNode = r, e !== null && (i.uvNode = U(e)), t !== null && (i.levelNode = U(t)), s !== null && (i.biasNode = U(s))) : i = ql(r, e, t, s), i;
}, k0 = (r = up) => ql(r);
class D0 extends nr {
  static get type() {
    return "ReferenceElementNode";
  }
  /**
   * Constructs a new reference element node.
   *
   * @param {?ReferenceNode} referenceNode - The reference node.
   * @param {Node} indexNode - The index node that defines the element access.
   */
  constructor(e, t) {
    super(e, t), this.referenceNode = e, this.isReferenceElementNode = !0;
  }
  /**
   * This method is overwritten since the node type is inferred from
   * the uniform type of the reference node.
   *
   * @return {string} The node type.
   */
  generateNodeType() {
    return this.referenceNode.uniformType;
  }
  generate(e) {
    const t = super.generate(e), s = this.referenceNode.getNodeType(e), i = this.getNodeType(e);
    return e.format(t, s, i);
  }
}
class en extends k {
  static get type() {
    return "ReferenceNode";
  }
  /**
   * Constructs a new reference node.
   *
   * @param {string} property - The name of the property the node refers to.
   * @param {string} uniformType - The uniform type that should be used to represent the property value.
   * @param {?Object} [object=null] - The object the property belongs to.
   * @param {?number} [count=null] - When the linked property is an array-like, this parameter defines its length.
   */
  constructor(e, t, s = null, i = null) {
    super(), this.property = e, this.uniformType = t, this.object = s, this.count = i, this.properties = e.split("."), this.reference = s, this.node = null, this.group = null, this.name = null, this.updateType = Q.OBJECT;
  }
  /**
   * When the referred property is array-like, this method can be used
   * to access elements via an index node.
   *
   * @param {IndexNode} indexNode - indexNode.
   * @return {ReferenceElementNode} A reference to an element.
   */
  element(e) {
    return new D0(this, U(e));
  }
  /**
   * Sets the uniform group for this reference node.
   *
   * @param {UniformGroupNode} group - The uniform group to set.
   * @return {ReferenceNode} A reference to this node.
   */
  setGroup(e) {
    return this.group = e, this;
  }
  /**
   * Sets the name for the internal uniform.
   *
   * @param {string} name - The label to set.
   * @return {ReferenceNode} A reference to this node.
   */
  setName(e) {
    return this.name = e, this;
  }
  /**
   * Sets the label for the internal uniform.
   *
   * @deprecated
   * @param {string} name - The label to set.
   * @return {ReferenceNode} A reference to this node.
   */
  label(e) {
    return X('TSL: "label()" has been deprecated. Use "setName()" instead.'), this.setName(e);
  }
  /**
   * Sets the node type which automatically defines the internal
   * uniform type.
   *
   * @param {string} uniformType - The type to set.
   */
  setNodeType(e) {
    let t = null;
    this.count !== null ? t = $r(null, e, this.count) : Array.isArray(this.getValueFromReference()) ? (t = Ge(null, e), t.updateType = Q.OBJECT) : e === "texture" ? t = xe(null) : e === "cubeTexture" ? t = bt(null) : t = q(null, e), this.group !== null && t.setGroup(this.group), this.name !== null && t.setName(this.name), this.node = t;
  }
  /**
   * This method is overwritten since the node type is inferred from
   * the type of the reference node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The node type.
   */
  generateNodeType(e) {
    return this.node === null && (this.updateReference(e), this.updateValue()), this.node.getNodeType(e);
  }
  /**
   * Returns the property value from the given referred object.
   *
   * @param {Object} [object=this.reference] - The object to retrieve the property value from.
   * @return {any} The value.
   */
  getValueFromReference(e = this.reference) {
    const { properties: t } = this;
    let s = e[t[0]];
    for (let i = 1; i < t.length; i++)
      s = s[t[i]];
    return s;
  }
  /**
   * Allows to update the reference based on the given state. The state is only
   * evaluated {@link ReferenceNode#object} is not set.
   *
   * @param {(NodeFrame|NodeBuilder)} state - The current state.
   * @return {Object} The updated reference.
   */
  updateReference(e) {
    return this.reference = this.object !== null ? this.object : e.object, this.reference;
  }
  /**
   * The output of the reference node is the internal uniform node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {UniformNode} The output node.
   */
  setup() {
    return this.updateValue(), this.node;
  }
  /**
   * Overwritten to update the internal uniform value.
   *
   * @param {NodeFrame} frame - A reference to the current node frame.
   */
  update() {
    this.updateValue();
  }
  /**
   * Retrieves the value from the referred object property and uses it
   * to updated the internal uniform.
   */
  updateValue() {
    this.node === null && this.setNodeType(this.uniformType);
    const e = this.getValueFromReference();
    Array.isArray(e) ? this.node.array = e : this.node.value = e;
  }
}
const Me = (r, e, t) => new en(r, e, t), hp = (r, e, t, s) => new en(r, e, s, t);
class W0 extends en {
  static get type() {
    return "MaterialReferenceNode";
  }
  /**
   * Constructs a new material reference node.
   *
   * @param {string} property - The name of the property the node refers to.
   * @param {string} inputType - The uniform type that should be used to represent the property value.
   * @param {?Material} [material=null] - The material the property belongs to. When no material is set,
   * the node refers to the material of the current rendered object.
   */
  constructor(e, t, s = null) {
    super(e, t, s), this.material = s, this.isMaterialReferenceNode = !0;
  }
  /**
   * Updates the reference based on the given state. The state is only evaluated
   * {@link MaterialReferenceNode#material} is not set.
   *
   * @param {(NodeFrame|NodeBuilder)} state - The current state.
   * @return {Object} The updated reference.
   */
  updateReference(e) {
    return this.reference = this.material !== null ? this.material : e.material, this.reference;
  }
}
const Ys = (r, e, t = null) => new W0(r, e, t), cp = ae(), q0 = Ie.dFdx(), j0 = Ie.dFdy(), dp = cp.dFdx(), pp = cp.dFdy(), mp = Ue, gp = j0.cross(mp), fp = mp.cross(q0), Vo = gp.mul(dp.x).add(fp.mul(pp.x)), Co = gp.mul(dp.y).add(fp.mul(pp.y)), Zu = Vo.dot(Vo).max(Co.dot(Co)), yp = Zu.equal(0).select(0, Zu.inverseSqrt()), G0 = /* @__PURE__ */ Vo.mul(yp).toVar("tangentViewFrame"), H0 = /* @__PURE__ */ Co.mul(yp).toVar("bitangentViewFrame"), tn = /* @__PURE__ */ Tt("tangent", "vec4"), Os = /* @__PURE__ */ tn.xyz.toVar("tangentLocal"), sn = /* @__PURE__ */ b((r) => {
  let e;
  return r.subBuildFn === "VERTEX" || r.geometry.hasAttribute("tangent") ? e = rr.mul(D(Os, 0)).xyz.toVarying("v_tangentView").normalize() : e = G0, r.isFlatShading() !== !0 && (e = Yr(e)), e;
}, "vec3").once(["NORMAL", "VERTEX"])().toVar("tangentView"), xp = /* @__PURE__ */ sn.transformDirection(Qa).toVarying("v_tangentWorld").normalize().toVar("tangentWorld"), rn = /* @__PURE__ */ b(([r, e], t) => {
  let s = r.mul(tn.w).xyz;
  return t.subBuildFn === "NORMAL" && t.isFlatShading() !== !0 && (s = s.toVarying(e)), s;
}).once(["NORMAL"]), X0 = /* @__PURE__ */ rn(kl.cross(tn), "v_bitangentGeometry").normalize().toVar("bitangentGeometry"), $0 = /* @__PURE__ */ rn($e.cross(Os), "v_bitangentLocal").normalize().toVar("bitangentLocal"), bp = /* @__PURE__ */ b((r) => {
  let e;
  return r.subBuildFn === "VERTEX" || r.geometry.hasAttribute("tangent") ? e = rn(Ue.cross(sn), "v_bitangentView").normalize() : e = H0, r.isFlatShading() !== !0 && (e = Yr(e)), e;
}, "vec3").once(["NORMAL", "VERTEX"])().toVar("bitangentView"), Y0 = /* @__PURE__ */ rn(Ka.cross(xp), "v_bitangentWorld").normalize().toVar("bitangentWorld"), jl = /* @__PURE__ */ gt(sn, bp, Ue).toVar("TBNViewMatrix"), vp = /* @__PURE__ */ dt.mul(jl), Z0 = (r, e) => r.sub(vp.mul(e)), J0 = /* @__PURE__ */ b(() => {
  let r = Pr.cross(dt);
  return r = r.cross(Pr).normalize(), r = pe(r, Ue, pc.mul(cc.oneMinus()).oneMinus().pow2().pow2()).normalize(), r;
}).once()(), Tp = (r) => U(r).mul(0.5).add(0.5), wp = (r) => U(r).mul(2).sub(1), zo = (r) => N(r, et(wl(f(1).sub(St(r, r))))), Q0 = (r) => (Be('TSL: "directionToColor()" has been renamed to "packNormalToRGB()".'), Tp(r)), K0 = (r) => (Be('TSL: "colorToDirection()" has been renamed to "unpackRGBToNormal()".'), wp(r));
class ex extends we {
  static get type() {
    return "NormalMapNode";
  }
  /**
   * Constructs a new normal map node.
   *
   * @param {Node<vec3>} node - Represents the normal map data.
   * @param {?Node<vec2>} [scaleNode=null] - Controls the intensity of the effect.
   */
  constructor(e, t = null) {
    super("vec3"), this.node = e, this.scaleNode = t, this.normalMapType = fn, this.unpackNormalMode = yn;
  }
  setup(e) {
    const { normalMapType: t, scaleNode: s, unpackNormalMode: i } = this;
    let a = this.node.mul(2).sub(1);
    if (t === fn ? i === Lh ? a = zo(a.xy) : i === Sg ? a = zo(a.yw) : i !== yn && te(`THREE.NodeMaterial: Unexpected unpack normal mode: ${i}`) : i !== yn && te(`THREE.NodeMaterial: Normal map type '${t}' is not compatible with unpack normal mode '${i}'`), s !== null) {
      let o = s;
      e.isFlatShading() === !0 && (o = Yr(o)), a = N(a.xy.mul(o), a.z);
    }
    let n = null;
    return t === Mg ? n = Wl(a) : t === fn ? n = jl.mul(a).normalize() : (te(`NodeMaterial: Unsupported normal map type: ${t}`), n = Ue), n;
  }
}
const Ro = /* @__PURE__ */ Y(ex).setParameterLength(1, 2), tx = b(({ textureNode: r, bumpScale: e }) => {
  const t = (i) => r.isolate().context({ getUV: (a) => i(a.uvNode || ae()), forceUVContext: !0 }), s = f(t((i) => i));
  return B(
    f(t((i) => i.add(i.dFdx()))).sub(s),
    f(t((i) => i.add(i.dFdy()))).sub(s)
  ).mul(e);
}), sx = b((r) => {
  const { surf_pos: e, surf_norm: t, dHdxy: s } = r, i = e.dFdx().normalize(), a = e.dFdy().normalize(), n = t, o = a.cross(n), l = n.cross(i), u = i.dot(o).mul(Ul), h = u.sign().mul(s.x.mul(o).add(s.y.mul(l)));
  return u.abs().mul(t).sub(h).normalize();
});
class rx extends we {
  static get type() {
    return "BumpMapNode";
  }
  /**
   * Constructs a new bump map node.
   *
   * @param {Node<float>} textureNode - Represents the bump map data.
   * @param {?Node<float>} [scaleNode=null] - Controls the intensity of the bump effect.
   */
  constructor(e, t = null) {
    super("vec3"), this.textureNode = e, this.scaleNode = t;
  }
  setup(e) {
    if (e.material.wireframe === !0) return Ue;
    const t = this.scaleNode !== null ? this.scaleNode : 1, s = tx({ textureNode: this.textureNode, bumpScale: t });
    return sx({
      surf_pos: Ie,
      surf_norm: Ue,
      dHdxy: s
    });
  }
}
const Gl = /* @__PURE__ */ Y(rx).setParameterLength(1, 2), Ju = /* @__PURE__ */ new Map();
class A extends k {
  static get type() {
    return "MaterialNode";
  }
  /**
   * Constructs a new material node.
   *
   * @param {string} scope - The scope defines what kind of material property is referred by the node.
   */
  constructor(e) {
    super(), this.scope = e;
  }
  /**
   * Returns a cached reference node for the given property and type.
   *
   * @param {string} property - The name of the material property.
   * @param {string} type - The uniform type of the property.
   * @return {MaterialReferenceNode} A material reference node representing the property access.
   */
  getCache(e, t) {
    let s = Ju.get(e);
    return s === void 0 && (s = Ys(e, t), Ju.set(e, s)), s;
  }
  /**
   * Returns a float-typed material reference node for the given property name.
   *
   * @param {string} property - The name of the material property.
   * @return {MaterialReferenceNode<float>} A material reference node representing the property access.
   */
  getFloat(e) {
    return this.getCache(e, "float");
  }
  /**
   * Returns a color-typed material reference node for the given property name.
   *
   * @param {string} property - The name of the material property.
   * @return {MaterialReferenceNode<color>} A material reference node representing the property access.
   */
  getColor(e) {
    return this.getCache(e, "color");
  }
  /**
   * Returns a texture-typed material reference node for the given property name.
   *
   * @param {string} property - The name of the material property.
   * @return {MaterialReferenceNode} A material reference node representing the property access.
   */
  getTexture(e) {
    return this.getCache(e === "map" ? "map" : e + "Map", "texture");
  }
  /**
   * The node setup is done depending on the selected scope. Multiple material properties
   * might be grouped into a single node composition if they logically belong together.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Node} The node representing the selected scope.
   */
  setup(e) {
    const t = e.context.material, s = this.scope;
    let i = null;
    if (s === A.COLOR) {
      const a = t.color !== void 0 ? this.getColor(s) : N();
      t.map && t.map.isTexture === !0 ? i = a.mul(this.getTexture("map")) : i = a;
    } else if (s === A.OPACITY) {
      const a = this.getFloat(s);
      t.alphaMap && t.alphaMap.isTexture === !0 ? i = a.mul(this.getTexture("alpha")) : i = a;
    } else if (s === A.SPECULAR_STRENGTH)
      t.specularMap && t.specularMap.isTexture === !0 ? i = this.getTexture("specular").r : i = f(1);
    else if (s === A.SPECULAR_INTENSITY) {
      const a = this.getFloat(s);
      t.specularIntensityMap && t.specularIntensityMap.isTexture === !0 ? i = a.mul(this.getTexture(s).a) : i = a;
    } else if (s === A.SPECULAR_COLOR) {
      const a = this.getColor(s);
      t.specularColorMap && t.specularColorMap.isTexture === !0 ? i = a.mul(this.getTexture(s).rgb) : i = a;
    } else if (s === A.ROUGHNESS) {
      const a = this.getFloat(s);
      t.roughnessMap && t.roughnessMap.isTexture === !0 ? i = a.mul(this.getTexture(s).g) : i = a;
    } else if (s === A.METALNESS) {
      const a = this.getFloat(s);
      t.metalnessMap && t.metalnessMap.isTexture === !0 ? i = a.mul(this.getTexture(s).b) : i = a;
    } else if (s === A.EMISSIVE) {
      const a = this.getFloat("emissiveIntensity"), n = this.getColor(s).mul(a);
      t.emissiveMap && t.emissiveMap.isTexture === !0 ? i = n.mul(this.getTexture(s)) : i = n;
    } else if (s === A.NORMAL)
      t.normalMap ? (i = Ro(this.getTexture("normal"), this.getCache("normalScale", "vec2")), i.normalMapType = t.normalMapType, (t.normalMap.format == Rr || t.normalMap.format == Ng || t.normalMap.format == wg) && (i.unpackNormalMode = Lh)) : t.bumpMap ? i = Gl(this.getTexture("bump").r, this.getFloat("bumpScale")) : i = Ue;
    else if (s === A.CLEARCOAT) {
      const a = this.getFloat(s);
      t.clearcoatMap && t.clearcoatMap.isTexture === !0 ? i = a.mul(this.getTexture(s).r) : i = a;
    } else if (s === A.CLEARCOAT_ROUGHNESS) {
      const a = this.getFloat(s);
      t.clearcoatRoughnessMap && t.clearcoatRoughnessMap.isTexture === !0 ? i = a.mul(this.getTexture(s).r) : i = a;
    } else if (s === A.CLEARCOAT_NORMAL)
      t.clearcoatNormalMap ? i = Ro(this.getTexture(s), this.getCache(s + "Scale", "vec2")) : i = Ue;
    else if (s === A.SHEEN) {
      const a = this.getColor("sheenColor").mul(this.getFloat("sheen"));
      t.sheenColorMap && t.sheenColorMap.isTexture === !0 ? i = a.mul(this.getTexture("sheenColor").rgb) : i = a;
    } else if (s === A.SHEEN_ROUGHNESS) {
      const a = this.getFloat(s);
      t.sheenRoughnessMap && t.sheenRoughnessMap.isTexture === !0 ? i = a.mul(this.getTexture(s).a) : i = a, i = i.clamp(1e-4, 1);
    } else if (s === A.ANISOTROPY)
      if (t.anisotropyMap && t.anisotropyMap.isTexture === !0) {
        const a = this.getTexture(s);
        i = Ha(Cr.x, Cr.y, Cr.y.negate(), Cr.x).mul(a.rg.mul(2).sub(B(1)).normalize().mul(a.b));
      } else
        i = Cr;
    else if (s === A.IRIDESCENCE_THICKNESS) {
      const a = Me("1", "float", t.iridescenceThicknessRange);
      if (t.iridescenceThicknessMap) {
        const n = Me("0", "float", t.iridescenceThicknessRange);
        i = a.sub(n).mul(this.getTexture(s).g).add(n);
      } else
        i = a;
    } else if (s === A.TRANSMISSION) {
      const a = this.getFloat(s);
      t.transmissionMap ? i = a.mul(this.getTexture(s).r) : i = a;
    } else if (s === A.THICKNESS) {
      const a = this.getFloat(s);
      t.thicknessMap ? i = a.mul(this.getTexture(s).g) : i = a;
    } else if (s === A.IOR)
      i = this.getFloat(s);
    else if (s === A.LIGHT_MAP)
      t.lightMap ? i = this.getTexture(s).rgb.mul(this.getFloat("lightMapIntensity")) : i = N(0);
    else if (s === A.AO)
      t.aoMap ? i = this.getTexture(s).r.sub(1).mul(this.getFloat("aoMapIntensity")).add(1) : i = f(1);
    else if (s === A.LINE_DASH_OFFSET)
      i = t.dashOffset ? this.getFloat(s) : f(0);
    else {
      const a = this.getNodeType(e);
      i = this.getCache(s, a);
    }
    return i;
  }
}
A.ALPHA_TEST = "alphaTest";
A.COLOR = "color";
A.OPACITY = "opacity";
A.SHININESS = "shininess";
A.SPECULAR = "specular";
A.SPECULAR_STRENGTH = "specularStrength";
A.SPECULAR_INTENSITY = "specularIntensity";
A.SPECULAR_COLOR = "specularColor";
A.REFLECTIVITY = "reflectivity";
A.ROUGHNESS = "roughness";
A.METALNESS = "metalness";
A.NORMAL = "normal";
A.CLEARCOAT = "clearcoat";
A.CLEARCOAT_ROUGHNESS = "clearcoatRoughness";
A.CLEARCOAT_NORMAL = "clearcoatNormal";
A.EMISSIVE = "emissive";
A.ROTATION = "rotation";
A.SHEEN = "sheen";
A.SHEEN_ROUGHNESS = "sheenRoughness";
A.ANISOTROPY = "anisotropy";
A.IRIDESCENCE = "iridescence";
A.IRIDESCENCE_IOR = "iridescenceIOR";
A.IRIDESCENCE_THICKNESS = "iridescenceThickness";
A.IOR = "ior";
A.TRANSMISSION = "transmission";
A.THICKNESS = "thickness";
A.ATTENUATION_DISTANCE = "attenuationDistance";
A.ATTENUATION_COLOR = "attenuationColor";
A.LINE_SCALE = "scale";
A.LINE_DASH_SIZE = "dashSize";
A.LINE_GAP_SIZE = "gapSize";
A.LINE_WIDTH = "linewidth";
A.LINE_DASH_OFFSET = "dashOffset";
A.POINT_SIZE = "size";
A.DISPERSION = "dispersion";
A.LIGHT_MAP = "light";
A.AO = "ao";
const Np = /* @__PURE__ */ O(A, A.ALPHA_TEST), Mp = /* @__PURE__ */ O(A, A.COLOR), ix = /* @__PURE__ */ O(A, A.SHININESS), Sp = /* @__PURE__ */ O(A, A.EMISSIVE), _p = /* @__PURE__ */ O(A, A.OPACITY), ax = /* @__PURE__ */ O(A, A.SPECULAR), nx = /* @__PURE__ */ O(A, A.SPECULAR_INTENSITY), ox = /* @__PURE__ */ O(A, A.SPECULAR_COLOR), lx = /* @__PURE__ */ O(A, A.SPECULAR_STRENGTH), ux = /* @__PURE__ */ O(A, A.REFLECTIVITY), hx = /* @__PURE__ */ O(A, A.ROUGHNESS), cx = /* @__PURE__ */ O(A, A.METALNESS), Ap = /* @__PURE__ */ O(A, A.NORMAL), dx = /* @__PURE__ */ O(A, A.CLEARCOAT), px = /* @__PURE__ */ O(A, A.CLEARCOAT_ROUGHNESS), mx = /* @__PURE__ */ O(A, A.CLEARCOAT_NORMAL), gx = /* @__PURE__ */ O(A, A.ROTATION), fx = /* @__PURE__ */ O(A, A.SHEEN), yx = /* @__PURE__ */ O(A, A.SHEEN_ROUGHNESS), xx = /* @__PURE__ */ O(A, A.ANISOTROPY), bx = /* @__PURE__ */ O(A, A.IRIDESCENCE), vx = /* @__PURE__ */ O(A, A.IRIDESCENCE_IOR), Tx = /* @__PURE__ */ O(A, A.IRIDESCENCE_THICKNESS), wx = /* @__PURE__ */ O(A, A.TRANSMISSION), Nx = /* @__PURE__ */ O(A, A.THICKNESS), Mx = /* @__PURE__ */ O(A, A.IOR), Sx = /* @__PURE__ */ O(A, A.ATTENUATION_DISTANCE), _x = /* @__PURE__ */ O(A, A.ATTENUATION_COLOR), Vp = /* @__PURE__ */ O(A, A.LINE_SCALE), Cp = /* @__PURE__ */ O(A, A.LINE_DASH_SIZE), zp = /* @__PURE__ */ O(A, A.LINE_GAP_SIZE), za = /* @__PURE__ */ O(A, A.LINE_WIDTH), Rp = /* @__PURE__ */ O(A, A.LINE_DASH_OFFSET), Ax = /* @__PURE__ */ O(A, A.POINT_SIZE), Vx = /* @__PURE__ */ O(A, A.DISPERSION), Ep = /* @__PURE__ */ O(A, A.LIGHT_MAP), Lp = /* @__PURE__ */ O(A, A.AO), Cr = /* @__PURE__ */ q(new _e()).onReference(function(r) {
  return r.material;
}).onRenderUpdate(function({ material: r }) {
  this.value.set(r.anisotropy * Math.cos(r.anisotropyRotation), r.anisotropy * Math.sin(r.anisotropyRotation));
}), Ip = /* @__PURE__ */ b((r) => r.context.setupModelViewProjection(), "vec4").once()().toVarying("v_modelViewProjection");
class ze extends k {
  static get type() {
    return "EventNode";
  }
  /**
   * Creates an EventNode.
   *
   * @param {string} eventType - The type of event
   * @param {Function} callback - The callback to execute on update.
   */
  constructor(e, t) {
    super("void"), this.eventType = e, this.callback = t, e === ze.OBJECT ? this.updateType = Q.OBJECT : e === ze.MATERIAL ? this.updateType = Q.RENDER : e === ze.FRAME ? this.updateType = Q.FRAME : e === ze.BEFORE_OBJECT ? this.updateBeforeType = Q.OBJECT : e === ze.BEFORE_MATERIAL ? this.updateBeforeType = Q.RENDER : e === ze.BEFORE_FRAME && (this.updateBeforeType = Q.FRAME);
  }
  update(e) {
    this.callback(e);
  }
  updateBefore(e) {
    this.callback(e);
  }
}
ze.OBJECT = "object";
ze.MATERIAL = "material";
ze.FRAME = "frame";
ze.BEFORE_OBJECT = "beforeObject";
ze.BEFORE_MATERIAL = "beforeMaterial";
ze.BEFORE_FRAME = "beforeFrame";
const Zr = (r, e) => new ze(r, e).toStack(), Si = (r) => Zr(ze.OBJECT, r), Cx = (r) => Zr(ze.MATERIAL, r), Op = (r) => Zr(ze.FRAME, r), zx = (r) => Zr(ze.BEFORE_OBJECT, r), Rx = (r) => Zr(ze.BEFORE_MATERIAL, r), Ex = (r) => Zr(ze.BEFORE_FRAME, r);
class Lx extends nr {
  static get type() {
    return "StorageArrayElementNode";
  }
  /**
   * Constructs storage buffer element node.
   *
   * @param {StorageBufferNode} storageBufferNode - The storage buffer node.
   * @param {Node} indexNode - The index node that defines the element access.
   */
  constructor(e, t) {
    super(e, t), this.isStorageArrayElementNode = !0;
  }
  /**
   * The storage buffer node.
   *
   * @param {Node} value
   * @type {StorageBufferNode}
   */
  set storageBufferNode(e) {
    this.node = e;
  }
  get storageBufferNode() {
    return this.node;
  }
  getMemberType(e, t) {
    const s = this.storageBufferNode.structTypeNode;
    return s ? s.getMemberType(e, t) : "void";
  }
  setup(e) {
    return e.isAvailable("storageBuffer") === !1 && this.node.isPBO === !0 && e.setupPBO(this.node), super.setup(e);
  }
  generate(e, t) {
    let s;
    const i = e.isContextAssign();
    if (e.isAvailable("storageBuffer") === !1 ? this.node.isPBO === !0 && i !== !0 && (this.node.value.isInstancedBufferAttribute || e.shaderStage !== "compute") ? s = e.generatePBO(this) : s = this.node.build(e) : s = super.generate(e), i !== !0) {
      const a = this.getNodeType(e);
      s = e.format(s, a, t);
    }
    return s;
  }
}
const Ix = /* @__PURE__ */ Y(Lx).setParameterLength(2);
class Ox extends Bl {
  static get type() {
    return "StorageBufferNode";
  }
  /**
   * Constructs a new storage buffer node.
   *
   * @param {StorageBufferAttribute|StorageInstancedBufferAttribute|BufferAttribute} value - The buffer data.
   * @param {?(string|Struct)} [bufferType=null] - The buffer type (e.g. `'vec3'`).
   * @param {number} [bufferCount=0] - The buffer count.
   */
  constructor(e, t = null, s = 0) {
    let i, a = null;
    t && t.isStructTypeNode ? (i = "struct", a = t, (e.isStorageBufferAttribute || e.isStorageInstancedBufferAttribute) && (s = e.count)) : t === null && (e.isStorageBufferAttribute || e.isStorageInstancedBufferAttribute) ? (i = Sf(e.itemSize), s = e.count) : i = t, super(e, i, s), this.isStorageBufferNode = !0, this.structTypeNode = a, this.access = Ht.READ_WRITE, this.isAtomic = !1, this.isPBO = !1, this._attribute = null, this._varying = null, this.global = !0, e.isStorageBufferAttribute !== !0 && e.isStorageInstancedBufferAttribute !== !0 && (e.isInstancedBufferAttribute ? e.isStorageInstancedBufferAttribute = !0 : e.isStorageBufferAttribute = !0);
  }
  /**
   * This method is overwritten since the buffer data might be shared
   * and thus the hash should be shared as well.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The hash.
   */
  getHash(e) {
    let t;
    if (this.bufferCount === 0) {
      let s = e.globalCache.getData(this.value);
      s === void 0 && (s = {
        node: this
      }, e.globalCache.setData(this.value, s)), t = s.node.id;
    } else
      t = this.id;
    return String(t);
  }
  /**
   * Overwrites the default implementation to return a fixed value `'indirectStorageBuffer'` or `'storageBuffer'`.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The input type.
   */
  getInputType() {
    return this.value.isIndirectStorageBufferAttribute ? "indirectStorageBuffer" : "storageBuffer";
  }
  /**
   * Enables element access with the given index node.
   *
   * @param {IndexNode} indexNode - The index node.
   * @return {StorageArrayElementNode} A node representing the element access.
   */
  element(e) {
    return Ix(this, e);
  }
  /**
   * Defines whether this node is a PBO or not. Only relevant for WebGL.
   *
   * @param {boolean} value - The value so set.
   * @return {StorageBufferNode} A reference to this node.
   */
  setPBO(e) {
    return this.isPBO = e, this;
  }
  /**
   * Returns the `isPBO` value.
   *
   * @return {boolean} Whether the node represents a PBO or not.
   */
  getPBO() {
    return this.isPBO;
  }
  /**
   * Defines the node access.
   *
   * @param {string} value - The node access.
   * @return {StorageBufferNode} A reference to this node.
   */
  setAccess(e) {
    return this.access = e, this;
  }
  /**
   * Convenience method for configuring a read-only node access.
   *
   * @return {StorageBufferNode} A reference to this node.
   */
  toReadOnly() {
    return this.setAccess(Ht.READ_ONLY);
  }
  /**
   * Defines whether the node is atomic or not.
   *
   * @param {boolean} value - The atomic flag.
   * @return {StorageBufferNode} A reference to this node.
   */
  setAtomic(e) {
    return this.isAtomic = e, this;
  }
  /**
   * Convenience method for making this node atomic.
   *
   * @return {StorageBufferNode} A reference to this node.
   */
  toAtomic() {
    return this.setAtomic(!0);
  }
  /**
   * Returns attribute data for this storage buffer node.
   *
   * @return {{attribute: BufferAttributeNode, varying: VaryingNode}} The attribute data.
   */
  getAttributeData() {
    return this._attribute === null && (this._attribute = zl(this.value), this._varying = ur(this._attribute)), {
      attribute: this._attribute,
      varying: this._varying
    };
  }
  /**
   * This method is overwritten since the node type from the availability of storage buffers
   * and the attribute data.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The node type.
   */
  generateNodeType(e) {
    if (this.structTypeNode !== null)
      return this.structTypeNode.getNodeType(e);
    if (e.isAvailable("storageBuffer") || e.isAvailable("indirectStorageBuffer"))
      return super.generateNodeType(e);
    const { attribute: t } = this.getAttributeData();
    return t.getNodeType(e);
  }
  /**
   * Returns the type of a member of the struct.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {string} name - The name of the member.
   * @return {string} The type of the member.
   */
  getMemberType(e, t) {
    return this.structTypeNode !== null ? this.structTypeNode.getMemberType(e, t) : "void";
  }
  /**
   * Generates the code snippet of the storage buffer node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The generated code snippet.
   */
  generate(e) {
    if (this.structTypeNode !== null && this.structTypeNode.build(e), e.isAvailable("storageBuffer") || e.isAvailable("indirectStorageBuffer"))
      return super.generate(e);
    const { attribute: t, varying: s } = this.getAttributeData(), i = s.build(e);
    return e.registerTransform(i, t), i;
  }
}
const Es = (r, e = null, t = 0) => new Ox(r, e, t), Eo = /* @__PURE__ */ new WeakMap(), Qu = /* @__PURE__ */ new WeakMap(), Lo = /* @__PURE__ */ new WeakMap();
function Pp(r, e) {
  let t;
  const s = Math.max(e.count, 1);
  if (e.isStorageInstancedBufferAttribute === !0)
    t = Es(e, "mat4", s).element(Ft);
  else if (s * 16 * 4 <= r.getUniformBufferLimit())
    t = $r(e.array, "mat4", s).element(Ft);
  else {
    let i = Eo.get(e);
    i || (i = new xf(e.array, 16, 1), Eo.set(e, i));
    const a = e.usage === Da ? Rl : Ja, n = [
      a(i, "vec4", 16, 0),
      a(i, "vec4", 16, 4),
      a(i, "vec4", 16, 8),
      a(i, "vec4", 16, 12)
    ];
    t = Rs(...n);
  }
  return t;
}
function Px(r, e, t) {
  let s = Lo.get(r);
  if (s === void 0) {
    const i = e.clone();
    s = {
      previousInstanceMatrix: i,
      node: Pp(t, i)
    }, Lo.set(r, s);
  }
  return s.node;
}
const Hl = /* @__PURE__ */ lr("vec3", "vInstanceColor"), Fp = /* @__PURE__ */ b(([r, e = null], t) => {
  const s = r.isStorageInstancedBufferAttribute === !0, i = e && e.isStorageInstancedBufferAttribute === !0, a = Pp(t, r);
  let n = null;
  s || Math.max(r.count, 1) * 16 * 4 > t.getUniformBufferLimit() && (n = Eo.get(r));
  let o = null, l = null;
  if (e)
    if (i)
      o = Es(e, "vec3", Math.max(e.count, 1)).element(Ft);
    else {
      let h = Qu.get(e);
      h || (h = new Or(e.array, 3), Qu.set(e, h)), l = h;
      const d = e.usage === Da ? Rl : Ja;
      o = N(d(h, "vec3", 3, 0));
    }
  (n !== null || l !== null) && Op(() => {
    n !== null && (n.clearUpdateRanges(), n.updateRanges.push(...r.updateRanges), r.version !== n.version && (n.version = r.version)), e && l !== null && (l.clearUpdateRanges(), l.updateRanges.push(...e.updateRanges), e.version !== l.version && (l.version = e.version));
  });
  const u = a.mul(Te).xyz;
  if (Te.assign(u), t.needsPreviousData()) {
    const h = t.object;
    Si(({ object: p }) => {
      Lo.get(p).previousInstanceMatrix.array.set(r.array);
    });
    const d = Px(h, r, t);
    ir.assign(d.mul(ir).xyz);
  }
  if (t.hasGeometryAttribute("normal")) {
    const h = Dl($e, a);
    $e.assign(h);
  }
  o !== null && Hl.assign(o);
}, "void"), Bp = /* @__PURE__ */ b(([r]) => {
  const { instanceMatrix: e, instanceColor: t } = r;
  Fp(e, t);
}, "void"), Fx = /* @__PURE__ */ b(([r, e]) => {
  const t = x(sr(ve(r), 0).x).toConst(), s = x(e), i = s.mod(t).toConst(), a = s.div(t).toConst();
  return ve(r, ye(i, a));
}), Bx = /* @__PURE__ */ b(([r, e]) => {
  const t = x(sr(ve(r), 0).x).toConst(), s = x(e).mod(t).toConst(), i = x(e).div(t).toConst();
  return ve(r, ye(s, i)).x;
}), Xl = /* @__PURE__ */ lr("vec4", "vBatchColor"), Up = /* @__PURE__ */ b(([r], e) => {
  const t = e.getDrawIndex() === null ? Ft : Od, s = Bx(r._indirectTexture, x(t)), i = r._matricesTexture, a = x(sr(ve(i), 0).x).toConst(), n = f(s).mul(4).toInt().toConst(), o = n.mod(a).toConst(), l = n.div(a).toConst(), u = Rs(
    ve(i, ye(o, l)),
    ve(i, ye(o.add(1), l)),
    ve(i, ye(o.add(2), l)),
    ve(i, ye(o.add(3), l))
  ), h = r._colorsTexture;
  if (h !== null) {
    const g = Fx(h, s);
    Xl.assign(g);
  }
  const d = gt(u);
  Te.assign(u.mul(Te));
  const p = $e.div(N(d[0].dot(d[0]), d[1].dot(d[1]), d[2].dot(d[2]))), m = d.mul(p).xyz;
  $e.assign(m), e.hasGeometryAttribute("tangent") && Os.mulAssign(d);
}, "void"), Ra = /* @__PURE__ */ new WeakMap(), Ea = /* @__PURE__ */ new WeakMap();
function $l(r, e, t, s, i, a) {
  const n = r.element(i.x), o = r.element(i.y), l = r.element(i.z), u = r.element(i.w), h = t.mul(e), d = Ae(
    n.mul(a.x).mul(h),
    o.mul(a.y).mul(h),
    l.mul(a.z).mul(h),
    u.mul(a.w).mul(h)
  );
  return s.mul(d).xyz;
}
function kp(r, e, t, s, i, a, n) {
  const o = r.element(a.x), l = r.element(a.y), u = r.element(a.z), h = r.element(a.w);
  let d = Ae(
    n.x.mul(o),
    n.y.mul(l),
    n.z.mul(u),
    n.w.mul(h)
  );
  d = i.mul(d).mul(s);
  const p = d.transformDirection(e).xyz, m = d.transformDirection(t).xyz;
  return { skinNormal: p, skinTangent: m };
}
function Dp(r, e, t, s, i) {
  const a = r.skeleton;
  let n = Ea.get(a);
  if (n === void 0) {
    a.update();
    const o = new Float32Array(a.boneMatrices);
    n = {
      previousBoneMatrices: o,
      node: $r(o, "mat4", a.bones.length)
    }, Ea.set(a, n);
  }
  return $l(n.node, ir, e, t, s, i);
}
const Wp = /* @__PURE__ */ b(([r], e) => {
  const t = Tt("skinIndex", "uvec4"), s = Tt("skinWeight", "vec4"), i = Me("bindMatrix", "mat4"), a = Me("bindMatrixInverse", "mat4"), n = hp("skeleton.boneMatrices", "mat4", r.skeleton.bones.length);
  if (Si(({ object: l, frameId: u }) => {
    const h = l.skeleton;
    if (Ra.get(h) !== u) {
      Ra.set(h, u);
      const d = Ea.get(h);
      d !== void 0 && d.previousBoneMatrices.set(h.boneMatrices), h.update();
    }
  }), e.needsPreviousData()) {
    const l = Dp(r, i, a, t, s);
    ir.assign(l);
  }
  const o = $l(n, Te, i, a, t, s);
  if (Te.assign(o), e.hasGeometryAttribute("normal")) {
    const { skinNormal: l, skinTangent: u } = kp(n, $e, Os, i, a, t, s);
    $e.assign(l), e.hasGeometryAttribute("tangent") && Os.assign(u);
  }
}, "void"), Ux = /* @__PURE__ */ b(([r, e = null], t) => {
  const s = Es(new Or(r.geometry.getAttribute("position").array, 3), "vec3").setPBO(!0).toReadOnly().element(Ft).toVar(), i = Es(new Or(new Uint32Array(r.geometry.getAttribute("skinIndex").array), 4), "uvec4").setPBO(!0).toReadOnly().element(Ft).toVar(), a = Es(new Or(r.geometry.getAttribute("skinWeight").array, 4), "vec4").setPBO(!0).toReadOnly().element(Ft).toVar(), n = q(r.bindMatrix, "mat4"), o = q(r.bindMatrixInverse, "mat4"), l = $r(r.skeleton.boneMatrices, "mat4", r.skeleton.bones.length), u = r.skeleton;
  if (Si(({ frameId: d }) => {
    if (Ra.get(u) !== d) {
      Ra.set(u, d);
      const p = Ea.get(u);
      p !== void 0 && p.previousBoneMatrices.set(u.boneMatrices), u.update();
    }
  }), t.needsPreviousData()) {
    const d = Dp(r, n, o, i, a);
    ir.assign(d);
  }
  const h = $l(l, s, n, o, i, a);
  if (e !== null && e.assign(h), t.hasGeometryAttribute("normal")) {
    const { skinNormal: d, skinTangent: p } = kp(l, $e, Os, n, o, i, a);
    $e.assign(d), t.hasGeometryAttribute("tangent") && Os.assign(p);
  }
  return h;
});
class kx extends k {
  static get type() {
    return "LoopNode";
  }
  /**
   * Constructs a new loop node.
   *
   * @param {Array<any>} params - Depending on the loop type, array holds different parameterization values for the loop.
   */
  constructor(e = []) {
    super("void"), this.params = e;
  }
  /**
   * Returns a loop variable name based on an index. The pattern is
   * `0` = `i`, `1`= `j`, `2`= `k` and so on.
   *
   * @param {number} index - The index.
   * @return {string} The loop variable name.
   */
  getVarName(e) {
    return String.fromCharCode(105 + e);
  }
  /**
   * Returns properties about this node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Object} The node properties.
   */
  getProperties(e) {
    const t = e.getNodeProperties(this);
    if (t.stackNode !== void 0) return t;
    const s = {};
    for (let o = 0, l = this.params.length - 1; o < l; o++) {
      const u = this.params[o], h = u.isNode !== !0 && u.name || this.getVarName(o), d = u.isNode !== !0 && u.type || "int";
      s[h] = ct(h, d);
    }
    const i = e.addStack(), a = this.params[this.params.length - 1](s);
    t.returnsNode = a.context({ nodeLoop: a }), t.stackNode = i;
    const n = this.params[0];
    if (n.isNode !== !0 && typeof n.update == "function") {
      const o = b(this.params[0].update)(s);
      t.updateNode = o.context({ nodeLoop: o });
    }
    return e.removeStack(), t;
  }
  setup(e) {
    if (this.getProperties(e), e.fnCall) {
      const t = e.getDataFromNode(e.fnCall.shaderNode);
      t.hasLoop = !0;
    }
  }
  generate(e) {
    const t = this.getProperties(e), s = this.params, i = t.stackNode;
    for (let n = 0, o = s.length - 1; n < o; n++) {
      const l = s[n];
      let u = !1, h = null, d = null, p = null, m = null, g = null, y = null;
      l.isNode ? l.getNodeType(e) === "bool" ? (u = !0, m = "bool", d = l.build(e, m)) : (m = "int", p = this.getVarName(n), h = "0", d = l.build(e, m), g = "<") : (m = l.type || "int", p = l.name || this.getVarName(n), h = l.start, d = l.end, g = l.condition, y = l.update, typeof h == "number" ? h = e.generateConst(m, h) : h && h.isNode && (h = h.build(e, m)), typeof d == "number" ? d = e.generateConst(m, d) : d && d.isNode && (d = d.build(e, m)), h !== void 0 && d === void 0 ? (h = h + " - 1", d = "0", g = ">=") : d !== void 0 && h === void 0 && (h = "0", g = "<"), g === void 0 && (Number(h) > Number(d) ? g = ">=" : g = "<"));
      let v;
      if (u)
        v = `while ( ${d} )`;
      else {
        const w = { start: h, end: d }, _ = w.start, C = w.end;
        let V;
        const P = () => g.includes("<") ? "+=" : "-=";
        if (y != null)
          switch (typeof y) {
            case "function":
              V = e.flowStagesNode(t.updateNode, "void").code.replace(/\t|;/g, "");
              break;
            case "number":
              V = p + " " + P() + " " + e.generateConst(m, y);
              break;
            case "string":
              V = p + " " + y;
              break;
            default:
              y.isNode ? V = p + " " + P() + " " + y.build(e) : (te("TSL: 'Loop( { update: ... } )' is not a function, string or number.", this.stackTrace), V = "break /* invalid update */");
          }
        else
          m === "int" || m === "uint" ? y = g.includes("<") ? "++" : "--" : y = P() + " 1.", V = p + " " + y;
        const z = e.getVar(m, p) + " = " + _, R = p + " " + g + " " + C;
        v = `for ( ${z}; ${R}; ${V} )`;
      }
      e.addFlowCode((n === 0 ? `
` : "") + e.tab + v + ` {

`).addFlowTab();
    }
    const a = i.build(e, "void");
    t.returnsNode.build(e, "void"), e.removeFlowTab().addFlowCode(`
` + e.tab + a);
    for (let n = 0, o = this.params.length - 1; n < o; n++)
      e.addFlowCode((n === 0 ? "" : e.tab) + `}

`).removeFlowTab();
    e.addFlowTab();
  }
}
const le = (...r) => new kx(Qs(r, "int")).toStack(), Dx = () => ct("continue").toStack(), qp = () => ct("break").toStack(), Xn = /* @__PURE__ */ new WeakMap(), ut = /* @__PURE__ */ new tt(), Ku = /* @__PURE__ */ new WeakMap(), eh = /* @__PURE__ */ b(({ bufferMap: r, influence: e, stride: t, width: s, depth: i, offset: a }) => {
  const n = x(Id).mul(t).add(a), o = n.div(s), l = n.sub(o.mul(s));
  return ve(r, ye(l, o)).depth(i).xyz.mul(e);
});
function Wx(r) {
  const e = r.morphAttributes.position !== void 0, t = r.morphAttributes.normal !== void 0, s = r.morphAttributes.color !== void 0, i = r.morphAttributes.position || r.morphAttributes.normal || r.morphAttributes.color, a = i !== void 0 ? i.length : 0;
  let n = Xn.get(r);
  if (n === void 0 || n.count !== a) {
    let o = function() {
      v.dispose(), Xn.delete(r), r.removeEventListener("dispose", o);
    };
    n !== void 0 && n.texture.dispose();
    const l = r.morphAttributes.position || [], u = r.morphAttributes.normal || [], h = r.morphAttributes.color || [];
    let d = 0;
    e === !0 && (d = 1), t === !0 && (d = 2), s === !0 && (d = 3);
    let p = r.attributes.position.count * d, m = 1;
    const g = 4096;
    p > g && (m = Math.ceil(p / g), p = g);
    const y = new Float32Array(p * m * 4 * a), v = new $g(y, p, m, a);
    v.type = qo, v.needsUpdate = !0;
    const w = d * 4;
    for (let _ = 0; _ < a; _++) {
      const C = l[_], V = u[_], P = h[_], z = p * m * 4 * _;
      for (let R = 0; R < C.count; R++) {
        const I = R * w;
        e === !0 && (ut.fromBufferAttribute(C, R), y[z + I + 0] = ut.x, y[z + I + 1] = ut.y, y[z + I + 2] = ut.z, y[z + I + 3] = 0), t === !0 && (ut.fromBufferAttribute(V, R), y[z + I + 4] = ut.x, y[z + I + 5] = ut.y, y[z + I + 6] = ut.z, y[z + I + 7] = 0), s === !0 && (ut.fromBufferAttribute(P, R), y[z + I + 8] = ut.x, y[z + I + 9] = ut.y, y[z + I + 10] = ut.z, y[z + I + 11] = P.itemSize === 4 ? ut.w : 1);
      }
    }
    n = {
      count: a,
      texture: v,
      stride: d,
      size: new _e(p, m)
    }, Xn.set(r, n), r.addEventListener("dispose", o);
  }
  return n;
}
const jp = /* @__PURE__ */ b(([r]) => {
  const { geometry: e } = r, t = e.morphAttributes.position !== void 0, s = e.hasAttribute("normal") && e.morphAttributes.normal !== void 0, i = e.morphAttributes.position || e.morphAttributes.normal || e.morphAttributes.color, a = i !== void 0 ? i.length : 0;
  if (a === 0) return;
  let n = Ku.get(r);
  (n === void 0 || n.count !== a) && (n = {
    base: q(1),
    influences: r.morphTargetInfluences ? Ge(r.morphTargetInfluences, "float") : null,
    count: a
  }, Ku.set(r, n));
  const { base: o, influences: l } = n, { texture: u, stride: h, size: d } = Wx(e);
  t === !0 && Te.mulAssign(o), s === !0 && $e.mulAssign(o);
  const p = x(d.width);
  le(a, ({ i: m }) => {
    const g = f(0).toVar();
    r.count > 1 && r.morphTexture !== null && r.morphTexture !== void 0 ? g.assign(ve(r.morphTexture, ye(x(m).add(1), x(Ft))).r) : g.assign(l.element(m).toVar()), W(g.notEqual(0), () => {
      t === !0 && Te.addAssign(eh({
        bufferMap: u,
        influence: g,
        stride: h,
        width: p,
        depth: m,
        offset: x(0)
      })), s === !0 && $e.addAssign(eh({
        bufferMap: u,
        influence: g,
        stride: h,
        width: p,
        depth: m,
        offset: x(1)
      }));
    });
  }), Si(({ object: m }) => {
    const { base: g, influences: y } = n;
    m.geometry.morphTargetsRelative ? g.value = 1 : g.value = 1 - m.morphTargetInfluences.reduce((v, w) => v + w, 0), y && (y.array = m.morphTargetInfluences, y.update());
  });
}, "void");
class Gp extends k {
  static get type() {
    return "LightingNode";
  }
  /**
   * Constructs a new lighting node.
   */
  constructor() {
    super("vec3"), this.isLightingNode = !0;
  }
}
class qx extends Gp {
  static get type() {
    return "AONode";
  }
  /**
   * Constructs a new AO node.
   *
   * @param {?Node<float>} [aoNode=null] - The ambient occlusion node.
   */
  constructor(e = null) {
    super(), this.aoNode = e;
  }
  setup(e) {
    e.context.ambientOcclusion.mulAssign(this.aoNode);
  }
}
class jx extends Ml {
  static get type() {
    return "LightingContextNode";
  }
  /**
   * Constructs a new lighting context node.
   *
   * @param {LightsNode} lightsNode - The lights node.
   * @param {?LightingModel} [lightingModel=null] - The current lighting model.
   * @param {?Array<LightingNode>} materialLightings - The material lightings nodes.
   * @param {?Node<vec3>} [backdropNode=null] - A backdrop node.
   * @param {?Node<float>} [backdropAlphaNode=null] - A backdrop alpha node.
   */
  constructor(e, t = null, s = [], i = null, a = null) {
    super(e), this.lightingModel = t, this.materialLightings = s, this.backdropNode = i, this.backdropAlphaNode = a, this._value = null;
  }
  /**
   * Returns a lighting context object.
   *
   * @return {{
   * radiance: Node<vec3>,
   * irradiance: Node<vec3>,
   * iblIrradiance: Node<vec3>,
   * ambientOcclusion: Node<float>,
   * reflectedLight: {directDiffuse: Node<vec3>, directSpecular: Node<vec3>, indirectDiffuse: Node<vec3>, indirectSpecular: Node<vec3>},
   * backdrop: Node<vec3>,
   * backdropAlpha: Node<float>
   * }} The lighting context object.
   */
  getContext() {
    const { materialLightings: e, backdropNode: t, backdropAlphaNode: s } = this, i = N().toVar("directDiffuse"), a = N().toVar("directSpecular"), n = N().toVar("indirectDiffuse"), o = N().toVar("indirectSpecular"), l = {
      directDiffuse: i,
      directSpecular: a,
      indirectDiffuse: n,
      indirectSpecular: o
    };
    return {
      radiance: N().toVar("radiance"),
      irradiance: N().toVar("irradiance"),
      iblIrradiance: N().toVar("iblIrradiance"),
      ambientOcclusion: f(1).toVar("ambientOcclusion"),
      reflectedLight: l,
      materialLightings: e,
      backdrop: t,
      backdropAlpha: s
    };
  }
  setup(e) {
    return this.value = this._value || (this._value = this.getContext()), this.value.lightingModel = this.lightingModel || e.context.lightingModel, super.setup(e);
  }
}
const Hp = /* @__PURE__ */ Y(jx);
class Gx extends Gp {
  static get type() {
    return "IrradianceNode";
  }
  /**
   * Constructs a new irradiance node.
   *
   * @param {Node<vec3>} node - A node contributing irradiance.
   */
  constructor(e) {
    super(), this.node = e;
  }
  setup(e) {
    e.context.irradiance.addAssign(this.node);
  }
}
const js = /* @__PURE__ */ new _e();
class an extends fs {
  static get type() {
    return "ViewportTextureNode";
  }
  /**
   * Constructs a new viewport texture node.
   *
   * @param {Node} [uvNode=screenUV] - The uv node.
   * @param {?Node} [levelNode=null] - The level node.
   * @param {?Texture} [framebufferTexture=null] - A framebuffer texture holding the viewport data. If not provided, a framebuffer texture is created automatically.
   */
  constructor(e = hr, t = null, s = null) {
    let i = null;
    s === null ? (i = new Hh(), i.minFilter = Rh, s = i) : i = s, super(s, e, t), this.generateMipmaps = !1, this.defaultFramebuffer = i, this.isOutputTextureNode = !0, this.updateBeforeType = Q.RENDER, this._cacheTextures = /* @__PURE__ */ new WeakMap();
  }
  /**
   * This methods returns a texture for the given render target or canvas target reference.
   *
   * To avoid rendering errors, `ViewportTextureNode` must use unique framebuffer textures
   * for different render contexts.
   *
   * @param {?(RenderTarget|CanvasTarget)} [reference=null] - The render target or canvas target reference.
   * @return {Texture} The framebuffer texture.
   */
  getTextureForReference(e = null) {
    let t, s;
    if (this.referenceNode ? (t = this.referenceNode.defaultFramebuffer, s = this.referenceNode._cacheTextures) : (t = this.defaultFramebuffer, s = this._cacheTextures), e === null)
      return t;
    if (s.has(e) === !1) {
      const i = t.clone();
      s.set(e, i);
    }
    return s.get(e);
  }
  updateReference(e) {
    const t = e.renderer, s = t.getRenderTarget(), i = t.getCanvasTarget(), a = s || i;
    return this.value = this.getTextureForReference(a), this.value;
  }
  updateBefore(e) {
    const t = e.renderer, s = t.getRenderTarget(), i = t.getCanvasTarget(), a = s || i;
    a === null ? t.getDrawingBufferSize(js) : a.getDrawingBufferSize ? a.getDrawingBufferSize(js) : js.set(a.width, a.height);
    const n = this.getTextureForReference(a);
    (n.image.width !== js.width || n.image.height !== js.height) && (n.image.width = js.width, n.image.height = js.height, n.needsUpdate = !0);
    const o = n.generateMipmaps;
    n.generateMipmaps = this.generateMipmaps, t.copyFramebufferToTexture(n), n.generateMipmaps = o;
  }
  clone() {
    const e = new this.constructor(this.uvNode, this.levelNode, this.value);
    return e.generateMipmaps = this.generateMipmaps, e;
  }
}
const Hx = /* @__PURE__ */ Y(an).setParameterLength(0, 3), Xp = /* @__PURE__ */ Y(an, null, null, { generateMipmaps: !0 }).setParameterLength(0, 3), Xx = /* @__PURE__ */ Xp(), $x = (r = hr, e = null) => Xx.sample(r, e);
let $n = null;
class Yx extends an {
  static get type() {
    return "ViewportDepthTextureNode";
  }
  /**
   * Constructs a new viewport depth texture node.
   *
   * @param {Node} [uvNode=screenUV] - The uv node.
   * @param {?Node} [levelNode=null] - The level node.
   * @param {?DepthTexture} [depthTexture=null] - A depth texture. If not provided, uses a shared depth texture.
   */
  constructor(e = hr, t = null, s = null) {
    s === null && ($n === null && ($n = new Hr()), s = $n), super(e, t, s);
  }
}
const Yl = /* @__PURE__ */ Y(Yx).setParameterLength(0, 3);
class rt extends k {
  static get type() {
    return "ViewportDepthNode";
  }
  /**
   * Constructs a new viewport depth node.
   *
   * @param {('depth'|'depthBase'|'linearDepth')} scope - The node's scope.
   * @param {?Node} [valueNode=null] - The value node.
   */
  constructor(e, t = null) {
    super("float"), this.scope = e, this.valueNode = t, this.isViewportDepthNode = !0;
  }
  generate(e) {
    const { scope: t } = this;
    return t === rt.DEPTH_BASE ? e.getFragDepth() : super.generate(e);
  }
  setup({ camera: e }) {
    const { scope: t } = this, s = this.valueNode;
    let i = null;
    if (t === rt.DEPTH_BASE)
      s !== null && (i = Zp().assign(s));
    else if (t === rt.DEPTH)
      e.isPerspectiveCamera ? i = Zl(Ie.z, _s, As) : i = er(Ie.z, _s, As);
    else if (t === rt.LINEAR_DEPTH)
      if (s !== null)
        if (e.isPerspectiveCamera) {
          const a = nn(s, _s, As);
          i = er(a, _s, As);
        } else
          i = s;
      else
        i = er(Ie.z, _s, As);
    return i;
  }
}
rt.DEPTH_BASE = "depthBase";
rt.DEPTH = "depth";
rt.LINEAR_DEPTH = "linearDepth";
const er = (r, e, t) => r.add(e).div(e.sub(t)), Zx = (r, e, t) => r.add(t).div(t.sub(e)), $p = /* @__PURE__ */ b(([r, e, t], s) => s.renderer.reversedDepthBuffer === !0 ? t.sub(e).mul(r).sub(t) : e.sub(t).mul(r).sub(e)), Zl = (r, e, t) => e.add(r).mul(t).div(t.sub(e).mul(r)), Yp = (r, e, t) => e.mul(r.add(t)).div(r.mul(e.sub(t))), nn = /* @__PURE__ */ b(([r, e, t], s) => s.renderer.reversedDepthBuffer === !0 ? e.mul(t).div(e.sub(t).mul(r).sub(e)) : e.mul(t).div(t.sub(e).mul(r).sub(t))), on = (r, e, t) => {
  e = e.max(1e-6).toVar();
  const s = ps(r.negate().div(e)), i = ps(t.div(e));
  return s.div(i);
}, Jx = (r, e, t) => {
  const s = r.mul(dl(t.div(e)));
  return f(Math.E).pow(s).mul(e).negate();
}, Zp = /* @__PURE__ */ Y(rt, rt.DEPTH_BASE), Jl = /* @__PURE__ */ O(rt, rt.DEPTH), La = /* @__PURE__ */ Y(rt, rt.LINEAR_DEPTH).setParameterLength(0, 1), Qx = /* @__PURE__ */ La(Yl());
Jl.assign = (r) => Zp(r);
class Nt extends k {
  static get type() {
    return "ClippingNode";
  }
  /**
   * Constructs a new clipping node.
   *
   * @param {('default'|'hardware'|'alphaToCoverage')} [scope='default'] - The node's scope. Similar to other nodes,
   * the selected scope influences the behavior of the node and what type of code is generated.
   */
  constructor(e = Nt.DEFAULT) {
    super(), this.scope = e;
  }
  /**
   * Setups the node depending on the selected scope.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Node} The result node.
   */
  setup(e) {
    super.setup(e);
    const t = e.clippingContext, { intersectionPlanes: s, unionPlanes: i } = t;
    return this.hardwareClipping = e.hardwareClipping, this.scope === Nt.ALPHA_TO_COVERAGE ? this.setupAlphaToCoverage(s, i) : this.scope === Nt.HARDWARE ? this.setupHardwareClipping(i, e) : this.setupDefault(s, i);
  }
  /**
   * Setups alpha to coverage.
   *
   * @param {Array<Vector4>} intersectionPlanes - The intersection planes.
   * @param {Array<Vector4>} unionPlanes - The union planes.
   * @return {Node} The result node.
   */
  setupAlphaToCoverage(e, t) {
    return b(() => {
      const s = f().toVar("distanceToPlane"), i = f().toVar("distanceToGradient"), a = f(1).toVar("clipOpacity"), n = t.length;
      if (this.hardwareClipping === !1 && n > 0) {
        const l = Ge(t).setGroup(H);
        le(n, ({ i: u }) => {
          const h = l.element(u);
          s.assign(Ie.dot(h.xyz).negate().add(h.w)), i.assign(s.fwidth().div(2)), a.mulAssign(Qt(i.negate(), i, s));
        });
      }
      const o = e.length;
      if (o > 0) {
        const l = Ge(e).setGroup(H), u = f(1).toVar("intersectionClipOpacity");
        le(o, ({ i: h }) => {
          const d = l.element(h);
          s.assign(Ie.dot(d.xyz).negate().add(d.w)), i.assign(s.fwidth().div(2)), u.mulAssign(Qt(i.negate(), i, s).oneMinus());
        }), a.mulAssign(u.oneMinus());
      }
      Je.a.mulAssign(a), Je.a.equal(0).discard();
    })();
  }
  /**
   * Setups the default clipping.
   *
   * @param {Array<Vector4>} intersectionPlanes - The intersection planes.
   * @param {Array<Vector4>} unionPlanes - The union planes.
   * @return {Node} The result node.
   */
  setupDefault(e, t) {
    return b(() => {
      const s = t.length;
      if (this.hardwareClipping === !1 && s > 0) {
        const a = Ge(t).setGroup(H);
        le(s, ({ i: n }) => {
          const o = a.element(n);
          Ie.dot(o.xyz).greaterThan(o.w).discard();
        });
      }
      const i = e.length;
      if (i > 0) {
        const a = Ge(e).setGroup(H), n = mt(!0).toVar("clipped");
        le(i, ({ i: o }) => {
          const l = a.element(o);
          n.assign(Ie.dot(l.xyz).greaterThan(l.w).and(n));
        }), n.discard();
      }
    })();
  }
  /**
   * Setups hardware clipping.
   *
   * @param {Array<Vector4>} unionPlanes - The union planes.
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Node} The result node.
   */
  setupHardwareClipping(e, t) {
    const s = e.length;
    return t.enableHardwareClipping(s), b(() => {
      const i = Ge(e).setGroup(H), a = Bs(t.getClipDistance());
      le(s, ({ i: n }) => {
        const o = i.element(n), l = Ie.dot(o.xyz).sub(o.w).negate();
        a.element(n).assign(l);
      });
    })();
  }
}
Nt.ALPHA_TO_COVERAGE = "alphaToCoverage";
Nt.DEFAULT = "default";
Nt.HARDWARE = "hardware";
const Kx = () => new Nt(), e1 = () => new Nt(Nt.ALPHA_TO_COVERAGE), t1 = () => new Nt(Nt.HARDWARE), s1 = 0.05, th = /* @__PURE__ */ b(([r]) => Bt(j(1e4, Qe(j(17, r.x).add(j(0.1, r.y)))).mul(Ae(0.1, he(Qe(j(13, r.y).add(r.x))))))), sh = /* @__PURE__ */ b(([r]) => th(B(th(r.xy), r.z))), r1 = /* @__PURE__ */ b(([r]) => {
  const e = Ee(
    Va(yl(r.xyz)),
    Va(xl(r.xyz))
  ), t = f(1).div(f(s1).mul(e)).toVar("pixScale"), s = B(
    Wr(Xt(ps(t))),
    Wr(Ya(ps(t)))
  ), i = B(
    sh(Xt(s.x.mul(r.xyz))),
    sh(Xt(s.y.mul(r.xyz)))
  ), a = Bt(ps(t)), n = Ae(j(a.oneMinus(), i.x), j(a, i.y)), o = Mt(a, a.oneMinus()), l = N(
    n.mul(n).div(j(2, o).mul(K(1, o))),
    n.sub(j(0.5, o)).div(K(1, o)),
    K(1, K(1, n).mul(K(1, n)).div(j(2, o).mul(K(1, o))))
  ), u = n.lessThan(o.oneMinus()).select(n.lessThan(o).select(l.x, l.y), l.z);
  return Jt(u, 1e-6, 1);
}).setLayout({
  name: "getAlphaHashThreshold",
  type: "float",
  inputs: [
    { name: "position", type: "vec3" }
  ]
});
class i1 extends Gd {
  static get type() {
    return "VertexColorNode";
  }
  /**
   * Constructs a new vertex color node.
   *
   * @param {number} index - The attribute index.
   */
  constructor(e) {
    super(null, "vec4"), this.isVertexColorNode = !0, this.index = e;
  }
  /**
   * Overwrites the default implementation by honoring the attribute index.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The attribute name.
   */
  getAttributeName() {
    const e = this.index;
    return "color" + (e > 0 ? e : "");
  }
  generate(e) {
    const t = this.getAttributeName(e), s = e.hasGeometryAttribute(t);
    let i;
    return s === !0 ? i = super.generate(e) : i = e.generateConst(this.nodeType, new tt(1, 1, 1, 1)), i;
  }
  serialize(e) {
    super.serialize(e), e.index = this.index;
  }
  deserialize(e) {
    super.deserialize(e), this.index = e.index;
  }
}
const Jp = (r = 0) => new i1(r);
class jr extends vo {
  static get type() {
    return "NodeMaterial";
  }
  /**
   * Represents the type of the node material.
   *
   * @type {string}
   */
  get type() {
    return this.constructor.type;
  }
  set type(e) {
  }
  /**
   * Constructs a new node material.
   */
  constructor() {
    super(), this.isNodeMaterial = !0, this.fog = !0, this.lights = !1, this.lightsNode = null, this.envNode = null, this.aoNode = null, this.colorNode = null, this.normalNode = null, this.opacityNode = null, this.backdropNode = null, this.backdropAlphaNode = null, this.alphaTestNode = null, this.maskNode = null, this.maskShadowNode = null, this.positionNode = null, this.geometryNode = null, this.depthNode = null, this.receivedShadowPositionNode = null, this.castShadowPositionNode = null, this.receivedShadowNode = null, this.castShadowNode = null, this.outputNode = null, this.mrtNode = null, this.fragmentNode = null, this.vertexNode = null, this.contextNode = null;
  }
  /**
   * Returns an array of child nodes for this material.
   *
   * @private
   * @returns {Array<{property: string, childNode: Node}>}
   */
  _getNodeChildren() {
    const e = [];
    for (const t of Object.getOwnPropertyNames(this)) {
      if (t.startsWith("_") === !0) continue;
      const s = this[t];
      s && s.isNode === !0 && e.push({ property: t, childNode: s });
    }
    return e;
  }
  /**
   * Allows to define a custom cache key that influence the material key computation
   * for render objects.
   *
   * @return {string} The custom cache key.
   */
  customProgramCacheKey() {
    const e = [];
    for (const { property: t, childNode: s } of this._getNodeChildren())
      e.push(Jo(t.slice(0, -4)), s.getCacheKey());
    return this.type + Qo(e);
  }
  /**
   * Builds this material with the given node builder.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */
  build(e) {
    this.setup(e);
  }
  /**
   * Setups a node material observer with the given builder.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {NodeMaterialObserver} The node material observer.
   */
  setupObserver(e) {
    return new Tf(e);
  }
  /**
   * Setups the vertex and fragment stage of this node material.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */
  setup(e) {
    e.context.setupNormal = () => Br(this.setupNormal(e), "NORMAL", "vec3"), e.context.setupPositionView = () => this.setupPositionView(e), e.context.setupModelViewProjection = () => this.setupModelViewProjection(e);
    const t = e.renderer, s = t.getRenderTarget();
    e.addStack();
    const i = this.setupVertex(e), a = Br(this.vertexNode || i, "VERTEX");
    e.context.clipSpace = a, e.stack.outputNode = a, this.setupHardwareClipping(e), this.geometryNode !== null && (e.stack.outputNode = e.stack.outputNode.bypass(this.geometryNode)), e.addFlow("vertex", e.removeStack()), e.addStack();
    let n;
    const o = this.setupClipping(e);
    if ((this.depthWrite === !0 || this.depthTest === !0) && (s !== null ? s.depthBuffer === !0 && this.setupDepth(e) : t.depth === !0 && this.setupDepth(e)), this.fragmentNode === null) {
      this.setupDiffuseColor(e), this.setupAmbientOcclusion(e), this.setupVariants(e);
      const l = this.setupLighting(e);
      o !== null && e.stack.addToStack(o);
      const u = D(l, Je.a).max(0);
      n = this.setupOutput(e, u), Fr.assign(n);
      const h = this.outputNode !== null;
      if (h && (n = this.outputNode), e.context.getOutput && (n = e.context.getOutput(n, e)), s !== null) {
        const d = t.getMRT(), p = this.mrtNode;
        d !== null ? (h && Fr.assign(n), n = d, p !== null && (n = d.merge(p))) : p !== null && (n = p);
      }
    } else {
      let l = this.fragmentNode;
      l.isOutputStructNode !== !0 && (l = l.convert(e.getOutputType())), n = this.setupOutput(e, l);
    }
    e.stack.outputNode = n, e.addFlow("fragment", e.removeStack()), e.observer = this.setupObserver(e);
  }
  /**
   * Setups the clipping node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {ClippingNode} The clipping node.
   */
  setupClipping(e) {
    if (e.clippingContext === null) return null;
    const { unionPlanes: t, intersectionPlanes: s } = e.clippingContext;
    let i = null;
    if (t.length > 0 || s.length > 0) {
      const a = e.renderer.currentSamples;
      this.alphaToCoverage && a > 1 ? i = e1() : e.stack.addToStack(Kx());
    }
    return i;
  }
  /**
   * Setups the hardware clipping if available on the current device.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */
  setupHardwareClipping(e) {
    if (e.hardwareClipping = !1, e.clippingContext === null) return;
    const t = e.clippingContext.unionPlanes.length;
    t > 0 && t <= 8 && e.isAvailable("clipDistance") && (e.stack.addToStack(t1()), e.hardwareClipping = !0);
  }
  /**
   * Setups the depth of this material.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */
  setupDepth(e) {
    const { renderer: t, camera: s } = e;
    let i = this.depthNode;
    if (i === null) {
      const a = t.getMRT();
      a && a.has("depth") ? i = a.get("depth") : t.logarithmicDepthBuffer === !0 && (s.isPerspectiveCamera ? i = on(Ie.z, _s, As) : i = er(Ie.z, _s, As));
    }
    i !== null && Jl.assign(i).toStack();
  }
  /**
   * Setups the position node in view space. This method exists
   * so derived node materials can modify the implementation e.g. sprite materials.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Node<vec3>} The position in view space.
   */
  setupPositionView() {
    return rr.mul(Te).xyz;
  }
  /**
   * Setups the position in clip space.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Node<vec4>} The position in view space.
   */
  setupModelViewProjection() {
    return Ot.mul(Ie);
  }
  /**
   * Setups the logic for the vertex stage.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Node<vec4>} The position in clip space.
   */
  setupVertex(e) {
    return e.addStack(), this.setupPosition(e), e.context.position = e.removeStack(), Ip;
  }
  /**
   * Setups the computation of the position in local space.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Node<vec3>} The position in local space.
   */
  setupPosition(e) {
    const { object: t, geometry: s } = e;
    if ((s.morphAttributes.position || s.morphAttributes.normal || s.morphAttributes.color) && jp(t), t.isSkinnedMesh === !0 && Wp(t), this.displacementMap) {
      const i = Ys("displacementMap", "texture"), a = Ys("displacementScale", "float"), n = Ys("displacementBias", "float");
      Te.addAssign($e.normalize().mul(i.x.mul(a).add(n)));
    }
    return t.isBatchedMesh && Up(t), t.isInstancedMesh && t.instanceMatrix && t.instanceMatrix.isInstancedBufferAttribute === !0 && Bp(t), this.positionNode !== null && Te.assign(Br(this.positionNode, "POSITION", "vec3")), Te;
  }
  /**
   * Setups the computation of the material's diffuse color.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {BufferGeometry} geometry - The geometry.
   */
  setupDiffuseColor(e) {
    const { object: t, geometry: s } = e;
    this.maskNode !== null && mt(this.maskNode).not().discard();
    let i = this.colorNode ? D(this.colorNode) : Mp;
    this.vertexColors === !0 && s.hasAttribute("color") && (i = i.mul(Jp())), t.instanceColor && (i = Hl.mul(i)), t.isBatchedMesh && t._colorsTexture && (i = Xl.mul(i)), Je.assign(i);
    const a = this.opacityNode ? f(this.opacityNode) : _p;
    Je.a.assign(Je.a.mul(a));
    let n = null;
    (this.alphaTestNode !== null || this.alphaTest > 0) && (n = this.alphaTestNode !== null ? f(this.alphaTestNode) : Np, this.alphaToCoverage === !0 ? (Je.a = Qt(n, n.add(vl(Je.a)), Je.a), Je.a.lessThanEqual(0).discard()) : Je.a.lessThanEqual(n).discard()), this.alphaHash === !0 && Je.a.lessThan(r1(Te)).discard(), e.isOpaque() && Je.a.assign(1);
  }
  /**
   * Abstract interface method that can be implemented by derived materials
   * to setup material-specific node variables.
   *
   * @abstract
   * @param {NodeBuilder} builder - The current node builder.
   */
  setupVariants() {
  }
  /**
   * Setups the outgoing light node variable
   *
   * @return {Node<vec3>} The outgoing light node.
   */
  setupOutgoingLight() {
    return this.lights === !0 ? N(0) : Je.rgb;
  }
  /**
   * Setups the normal node from the material.
   *
   * @return {Node<vec3>} The normal node.
   */
  setupNormal() {
    return this.normalNode ? N(this.normalNode) : Ap;
  }
  /**
   * Setups the environment node from the material.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Node<vec4>} The environment node.
   */
  setupEnvironment() {
    let e = null;
    return this.envNode ? e = this.envNode : this.envMap && (e = this.envMap.isCubeTexture ? Ys("envMap", "cubeTexture") : Ys("envMap", "texture")), e;
  }
  /**
   * Setups the light map node from the material.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Node<vec3>} The light map node.
   */
  setupLightMap(e) {
    let t = null;
    return e.material.lightMap && (t = new Gx(Ep)), t;
  }
  /**
   * Setups the lights node based on the scene, environment and material.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {LightingNode<Array>} The lights node.
   */
  setupMaterialLightings(e) {
    const t = [];
    if (e.renderer.lighting.enabled === !1)
      return t;
    const s = this.setupEnvironment(e);
    s && s.isLightingNode && t.push(s);
    const i = this.setupLightMap(e);
    return i && i.isLightingNode && t.push(i), e.context.ambientOcclusion && t.push(new qx(e.context.ambientOcclusion)), t;
  }
  /**
   * Setups the ambient occlusion node from the material.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Node} The ambient occlusion node.
   */
  setupAmbientOcclusion(e) {
    let t = this.aoNode;
    t === null && e.material.aoMap && (t = Lp), e.context.getAO && (t = e.context.getAO(t, e)), t !== null && (Ao.assign(t), e.context.ambientOcclusion = Ao);
  }
  /**
   * This method should be implemented by most derived materials
   * since it defines the material's lighting model.
   *
   * @abstract
   * @param {NodeBuilder} builder - The current node builder.
   * @return {LightingModel} The lighting model.
   */
  setupLightingModel() {
  }
  /**
   * Setups the outgoing light node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Node<vec3>} The outgoing light node.
   */
  setupLighting(e) {
    const { material: t } = e, { backdropNode: s, backdropAlphaNode: i, emissiveNode: a } = this, n = this.lights === !0 || this.lightsNode !== null, o = this.lights === !0 ? this.setupMaterialLightings(e) : [], l = n ? this.lightsNode || e.lightsNode : null;
    let u = this.setupOutgoingLight(e);
    if (l && (o.length > 0 || l.getScope().hasLights)) {
      const h = this.setupLightingModel(e) || null;
      u = Hp(l, h, o, s, i);
    } else s !== null && (u = N(i !== null ? pe(u, s, i) : s));
    return (a && a.isNode === !0 || t.emissive && t.emissive.isColor === !0) && (Mo.assign(N(a || Sp)), u = u.add(Mo)), u;
  }
  /**
   * Setup the fog.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {Node<vec4>} outputNode - The existing output node.
   * @return {Node<vec4>} The output node.
   */
  setupFog(e, t) {
    const s = e.fogNode;
    return s && (Fr.assign(t), t = D(s.toVar())), t;
  }
  /**
   * Setups premultiplied alpha.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {Node<vec4>} outputNode - The existing output node.
   * @return {Node<vec4>} The output node.
   */
  setupPremultipliedAlpha(e, t) {
    return Ol(t);
  }
  /**
   * Setups the output node.
   *
   * This method can be implemented by derived materials to extend the functionality
   * of the material's output or replace it altogether.
   *
   * ```js
   * class ColoredShadowMaterial extends MeshPhongNodeMaterial {
   *   constructor( parameters ) {
   *     super( parameters );
   *     this._shadeColor = uniform( new Color( parameters.shadeColor ?? 0xff0000 ) );
   *   }
   *
   *   setupOutput( builder, outputNode ) {
   *	   // Modify the native output of the MeshPhongNodeMaterial fragment shader
   *     const brightness = min( outputNode.r, 1.0 );
   *     const mixedColor = mix( this._shadeColor, diffuseColor.rgb, brightness );
   *	   // Return new output back into NodeMaterial flow
   *     return super.setupOutput( builder, vec4( mixedColor, outputNode.a ) );
   *   }
   * }
   * ```
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {Node<vec4>} outputNode - The existing output node.
   * @return {Node<vec4>} The output node.
   */
  setupOutput(e, t) {
    return this.fog === !0 && (t = this.setupFog(e, t)), this.premultipliedAlpha === !0 && (t = this.setupPremultipliedAlpha(e, t)), t;
  }
  /**
   * Most classic material types have a node pendant e.g. for `MeshBasicMaterial`
   * there is `MeshBasicNodeMaterial`. This utility method is intended for
   * defining all material properties of the classic type in the node type.
   *
   * @param {Material} material - The material to copy properties with their values to this node material.
   */
  setDefaultValues(e) {
    for (const s in e) {
      const i = e[s];
      this[s] === void 0 && (this[s] = i, i && i.clone && (this[s] = i.clone()));
    }
    const t = Object.getOwnPropertyDescriptors(e.constructor.prototype);
    for (const s in t)
      Object.getOwnPropertyDescriptor(this.constructor.prototype, s) === void 0 && t[s].get !== void 0 && Object.defineProperty(this.constructor.prototype, s, t[s]);
  }
  /**
   * Serializes this material to JSON.
   *
   * @param {?(Object|string)} meta - The meta information for serialization.
   * @return {Object} The serialized node.
   */
  toJSON(e) {
    const t = e === void 0 || typeof e == "string";
    t && (e = {
      textures: {},
      images: {},
      nodes: {}
    });
    const s = vo.prototype.toJSON.call(this, e);
    s.inputNodes = {};
    for (const { property: a, childNode: n } of this._getNodeChildren())
      s.inputNodes[a] = n.toJSON(e).uuid;
    function i(a) {
      const n = [];
      for (const o in a) {
        const l = a[o];
        delete l.metadata, n.push(l);
      }
      return n;
    }
    if (t) {
      const a = i(e.textures), n = i(e.images), o = i(e.nodes);
      a.length > 0 && (s.textures = a), n.length > 0 && (s.images = n), o.length > 0 && (s.nodes = o);
    }
    return s;
  }
  /**
   * Copies the common properties of the given material to this instance.
   *
   * @param {Material} source - The material to copy.
   * @return {NodeMaterial} A reference to this node material.
   */
  copy(e) {
    const t = Object.getOwnPropertyDescriptors(this.constructor.prototype);
    for (const s in t)
      if (t[s].set !== void 0 && e[s] !== void 0) {
        const i = e[s];
        this[s] && this[s].copy !== void 0 ? this[s].copy(i) : this[s] = i;
      }
    for (const s in this)
      if (!/^(?:is[A-Z]|_)|^(?:id|uuid|version|type|userData|clippingPlanes)$/.test(s) && this[s] !== void 0 && e[s] !== void 0) {
        const i = e[s];
        this[s] && this[s].copy !== void 0 ? this[s].copy(i) : this[s] = i;
      }
    return this.clippingPlanes = e.clippingPlanes ? e.clippingPlanes.map((s) => s.clone()) : null, this.userData = JSON.parse(JSON.stringify(e.userData)), this;
  }
}
const va = lr("vec3", "worldStart"), Io = lr("vec3", "worldEnd"), Qp = lr("float", "lineDistance"), $s = lr("vec4", "worldPos"), rh = b(({ start: r, end: e }) => {
  const t = Ot.element(2).element(2), s = Ot.element(3).element(2);
  return t.greaterThan(0).select(s.negate().div(t.add(1)), s.mul(-0.5).div(t)).sub(r.z).div(e.z.sub(r.z));
}, { start: "vec4", end: "vec4", return: "float" }), a1 = b(({ p1: r, p2: e, p3: t, p4: s }) => {
  const i = r.sub(t), a = s.sub(t), n = e.sub(r), o = i.dot(a), l = a.dot(n), u = i.dot(n), h = a.dot(a), d = n.dot(n).mul(h).sub(l.mul(l)), p = o.mul(l).sub(u.mul(h)).div(d).clamp(), m = o.add(l.mul(p)).div(h).clamp();
  return B(p, m);
}, { p1: "vec3", p2: "vec3", p3: "vec3", p4: "vec3", return: "vec2" });
b(({ material: r }) => {
  const e = r._useDash, t = r._useWorldUnits, s = Tt("instanceStart"), i = Tt("instanceEnd"), a = D(rr.mul(D(s, 1))).toVar("start"), n = D(rr.mul(D(i, 1))).toVar("end");
  let o, l;
  e && (o = f(Tt("instanceDistanceStart")).toVar("distanceStart"), l = f(Tt("instanceDistanceEnd")).toVar("distanceEnd")), t && (va.assign(a.xyz), Io.assign(n.xyz));
  const u = Ur.z.div(Ur.w), h = Ot.element(2).element(3).equal(-1);
  if (W(h, () => {
    W(a.z.lessThan(0).and(n.z.greaterThan(0)), () => {
      const w = rh({ start: a, end: n });
      n.assign(D(pe(a.xyz, n.xyz, w), n.w)), e && l.assign(pe(o, l, w));
    }).ElseIf(n.z.lessThan(0).and(a.z.greaterThanEqual(0)), () => {
      const w = rh({ start: n, end: a });
      a.assign(D(pe(n.xyz, a.xyz, w), a.w)), e && o.assign(pe(l, o, w));
    });
  }), e) {
    const w = r.dashScaleNode ? f(r.dashScaleNode) : Vp, _ = r.offsetNode ? f(r.offsetNode) : Rp;
    let C = st.y.lessThan(0.5).select(w.mul(o), w.mul(l));
    C = C.add(_), Qp.assign(C);
  }
  const d = Ot.mul(a), p = Ot.mul(n), m = d.xyz.div(d.w), g = p.xyz.div(p.w), y = g.xy.sub(m.xy).toVar();
  y.x.assign(y.x.mul(u)), y.assign(y.normalize());
  const v = D().toVar();
  if (t) {
    const w = n.xyz.sub(a.xyz).normalize(), _ = pe(a.xyz, n.xyz, 0.5).normalize(), C = w.cross(_).normalize(), V = w.cross(C);
    $s.assign(st.y.lessThan(0.5).select(a, n));
    const P = za.mul(0.5);
    $s.addAssign(D(st.x.lessThan(0).select(C.mul(P), C.mul(P).negate()), 0)), e || ($s.addAssign(D(st.y.lessThan(0.5).select(w.mul(P).negate(), w.mul(P)), 0)), $s.addAssign(D(V.mul(P), 0)), W(st.y.greaterThan(1).or(st.y.lessThan(0)), () => {
      $s.subAssign(D(V.mul(2).mul(P), 0));
    })), v.assign(Ot.mul($s));
    const z = N().toVar();
    z.assign(st.y.lessThan(0.5).select(m, g)), v.z.assign(z.z.mul(v.w));
  } else {
    const w = B(y.y, y.x.negate()).toVar("offset");
    y.x.assign(y.x.div(u)), w.x.assign(w.x.div(u)), w.assign(st.x.lessThan(0).select(w.negate(), w)), W(st.y.lessThan(0), () => {
      w.assign(w.sub(y));
    }).ElseIf(st.y.greaterThan(1), () => {
      w.assign(w.add(y));
    }), w.assign(w.mul(za)), w.assign(w.div(Ur.w.div(Xd))), v.assign(st.y.lessThan(0.5).select(d, p)), w.assign(w.mul(v.w)), v.assign(v.add(D(w, 0, 0)));
  }
  return v;
})();
b(({ material: r, renderer: e }) => {
  const t = r._useAlphaToCoverage, s = r._useDash, i = r._useWorldUnits, a = ae();
  if (s) {
    const o = r.dashSizeNode ? f(r.dashSizeNode) : Cp, l = r.gapSizeNode ? f(r.gapSizeNode) : zp;
    ba.assign(o), _o.assign(l), a.y.lessThan(-1).or(a.y.greaterThan(1)).discard(), Qp.mod(ba.add(_o)).greaterThan(ba).discard();
  }
  const n = f(1).toVar("alpha");
  if (i) {
    const o = $s.xyz.normalize().mul(1e5), l = Io.sub(va), u = a1({ p1: va, p2: Io, p3: N(0, 0, 0), p4: o }), h = va.add(l.mul(u.x)), d = o.mul(u.y), p = h.sub(d).length().div(za);
    if (!s)
      if (t && e.currentSamples > 0) {
        const m = p.fwidth();
        n.assign(Qt(m.negate().add(0.5), m.add(0.5), p).oneMinus());
      } else
        p.greaterThan(0.5).discard();
  } else if (t && e.currentSamples > 0) {
    const o = a.x, l = a.y.greaterThan(0).select(a.y.sub(1), a.y.add(1)), u = o.mul(o).add(l.mul(l)), h = f(u.fwidth()).toVar("dlen");
    W(a.y.abs().greaterThan(1), () => {
      n.assign(Qt(h.oneMinus(), h.add(1), u).oneMinus());
    });
  } else
    W(a.y.abs().greaterThan(1), () => {
      const o = a.x, l = a.y.greaterThan(0).select(a.y.sub(1), a.y.add(1));
      o.mul(o).add(l.mul(l)).greaterThan(1).discard();
    });
  return n;
})();
const Kp = /* @__PURE__ */ b(([r = ep]) => {
  const e = r.z.atan(r.x).mul(1 / (Math.PI * 2)).add(0.5), t = r.y.clamp(-1, 1).asin().mul(1 / Math.PI).add(0.5);
  return B(e, t);
}), Oo = /* @__PURE__ */ b(([r = ae()]) => {
  const e = r.x.sub(0.5).mul(Math.PI * 2), t = r.y.sub(0.5).mul(Math.PI), s = t.cos(), i = s.mul(e.cos()), a = t.sin(), n = s.mul(e.sin());
  return N(i, a, n);
}), em = /* @__PURE__ */ b(({ f0: r, f90: e, dotVH: t }) => {
  const s = t.mul(-5.55473).sub(6.98316).mul(t).exp2();
  return r.mul(s.oneMinus()).add(e.mul(s));
}), n1 = /* @__PURE__ */ b((r) => r.diffuseColor.mul(1 / Math.PI)), tm = /* @__PURE__ */ b((r) => {
  if (r.geometry.hasAttribute("normal") === !1)
    return f(0);
  const e = xi.dFdx().abs().max(xi.dFdy().abs());
  return e.x.max(e.y).max(e.z);
}), o1 = /* @__PURE__ */ b((r) => {
  const { roughness: e } = r, t = tm();
  let s = e.max(0.0525);
  return s = s.add(t), s = s.min(1), s;
}), sm = /* @__PURE__ */ b(({ alpha: r, dotNL: e, dotNV: t }) => {
  const s = r.pow2(), i = e.mul(s.add(s.oneMinus().mul(t.pow2())).sqrt()), a = t.mul(s.add(s.oneMinus().mul(e.pow2())).sqrt());
  return Zt(0.5, i.add(a).max(cl));
}).setLayout({
  name: "V_GGX_SmithCorrelated",
  type: "float",
  inputs: [
    { name: "alpha", type: "float" },
    { name: "dotNL", type: "float" },
    { name: "dotNV", type: "float" }
  ]
}), l1 = /* @__PURE__ */ b(({ alphaT: r, alphaB: e, dotTV: t, dotBV: s, dotTL: i, dotBL: a, dotNV: n, dotNL: o }) => {
  const l = o.mul(N(r.mul(t), e.mul(s), n).length()), u = n.mul(N(r.mul(i), e.mul(a), o).length());
  return Zt(0.5, l.add(u).max(cl));
}).setLayout({
  name: "V_GGX_SmithCorrelated_Anisotropic",
  type: "float",
  inputs: [
    { name: "alphaT", type: "float", qualifier: "in" },
    { name: "alphaB", type: "float", qualifier: "in" },
    { name: "dotTV", type: "float", qualifier: "in" },
    { name: "dotBV", type: "float", qualifier: "in" },
    { name: "dotTL", type: "float", qualifier: "in" },
    { name: "dotBL", type: "float", qualifier: "in" },
    { name: "dotNV", type: "float", qualifier: "in" },
    { name: "dotNL", type: "float", qualifier: "in" }
  ]
}), rm = /* @__PURE__ */ b(({ alpha: r, dotNH: e }) => {
  const t = r.pow2(), s = e.pow2().mul(t.oneMinus()).oneMinus();
  return t.div(s.pow2()).mul(1 / Math.PI);
}).setLayout({
  name: "D_GGX",
  type: "float",
  inputs: [
    { name: "alpha", type: "float" },
    { name: "dotNH", type: "float" }
  ]
}), u1 = /* @__PURE__ */ f(1 / Math.PI), h1 = /* @__PURE__ */ b(({ alphaT: r, alphaB: e, dotNH: t, dotTH: s, dotBH: i }) => {
  const a = r.mul(e), n = N(e.mul(s), r.mul(i), a.mul(t)), o = n.dot(n), l = a.div(o);
  return u1.mul(a.mul(l.pow2()));
}).setLayout({
  name: "D_GGX_Anisotropic",
  type: "float",
  inputs: [
    { name: "alphaT", type: "float", qualifier: "in" },
    { name: "alphaB", type: "float", qualifier: "in" },
    { name: "dotNH", type: "float", qualifier: "in" },
    { name: "dotTH", type: "float", qualifier: "in" },
    { name: "dotBH", type: "float", qualifier: "in" }
  ]
}), c1 = /* @__PURE__ */ b(({ lightDirection: r, f0: e, f90: t, roughness: s, f: i, normalView: a = Ue, USE_IRIDESCENCE: n, USE_ANISOTROPY: o }) => {
  const l = s.pow2(), u = r.add(dt).normalize(), h = a.dot(r).clamp(), d = a.dot(dt).clamp(), p = a.dot(u).clamp(), m = dt.dot(u).clamp();
  let g = em({ f0: e, f90: t, dotVH: m }), y, v;
  if (Dr(n) && (g = dc.mix(g, i)), Dr(o)) {
    const w = xa.dot(r), _ = xa.dot(dt), C = xa.dot(u), V = Pr.dot(r), P = Pr.dot(dt), z = Pr.dot(u);
    y = l1({ alphaT: So, alphaB: l, dotTV: _, dotBV: P, dotTL: w, dotBL: V, dotNV: d, dotNL: h }), v = h1({ alphaT: So, alphaB: l, dotNH: p, dotTH: C, dotBH: z });
  } else
    y = sm({ alpha: l, dotNL: h, dotNV: d }), v = rm({ alpha: l, dotNH: p });
  return g.mul(y).mul(v);
}), d1 = new Uint16Array([
  12469,
  15057,
  12620,
  14925,
  13266,
  14620,
  13807,
  14376,
  14323,
  13990,
  14545,
  13625,
  14713,
  13328,
  14840,
  12882,
  14931,
  12528,
  14996,
  12233,
  15039,
  11829,
  15066,
  11525,
  15080,
  11295,
  15085,
  10976,
  15082,
  10705,
  15073,
  10495,
  13880,
  14564,
  13898,
  14542,
  13977,
  14430,
  14158,
  14124,
  14393,
  13732,
  14556,
  13410,
  14702,
  12996,
  14814,
  12596,
  14891,
  12291,
  14937,
  11834,
  14957,
  11489,
  14958,
  11194,
  14943,
  10803,
  14921,
  10506,
  14893,
  10278,
  14858,
  9960,
  14484,
  14039,
  14487,
  14025,
  14499,
  13941,
  14524,
  13740,
  14574,
  13468,
  14654,
  13106,
  14743,
  12678,
  14818,
  12344,
  14867,
  11893,
  14889,
  11509,
  14893,
  11180,
  14881,
  10751,
  14852,
  10428,
  14812,
  10128,
  14765,
  9754,
  14712,
  9466,
  14764,
  13480,
  14764,
  13475,
  14766,
  13440,
  14766,
  13347,
  14769,
  13070,
  14786,
  12713,
  14816,
  12387,
  14844,
  11957,
  14860,
  11549,
  14868,
  11215,
  14855,
  10751,
  14825,
  10403,
  14782,
  10044,
  14729,
  9651,
  14666,
  9352,
  14599,
  9029,
  14967,
  12835,
  14966,
  12831,
  14963,
  12804,
  14954,
  12723,
  14936,
  12564,
  14917,
  12347,
  14900,
  11958,
  14886,
  11569,
  14878,
  11247,
  14859,
  10765,
  14828,
  10401,
  14784,
  10011,
  14727,
  9600,
  14660,
  9289,
  14586,
  8893,
  14508,
  8533,
  15111,
  12234,
  15110,
  12234,
  15104,
  12216,
  15092,
  12156,
  15067,
  12010,
  15028,
  11776,
  14981,
  11500,
  14942,
  11205,
  14902,
  10752,
  14861,
  10393,
  14812,
  9991,
  14752,
  9570,
  14682,
  9252,
  14603,
  8808,
  14519,
  8445,
  14431,
  8145,
  15209,
  11449,
  15208,
  11451,
  15202,
  11451,
  15190,
  11438,
  15163,
  11384,
  15117,
  11274,
  15055,
  10979,
  14994,
  10648,
  14932,
  10343,
  14871,
  9936,
  14803,
  9532,
  14729,
  9218,
  14645,
  8742,
  14556,
  8381,
  14461,
  8020,
  14365,
  7603,
  15273,
  10603,
  15272,
  10607,
  15267,
  10619,
  15256,
  10631,
  15231,
  10614,
  15182,
  10535,
  15118,
  10389,
  15042,
  10167,
  14963,
  9787,
  14883,
  9447,
  14800,
  9115,
  14710,
  8665,
  14615,
  8318,
  14514,
  7911,
  14411,
  7507,
  14279,
  7198,
  15314,
  9675,
  15313,
  9683,
  15309,
  9712,
  15298,
  9759,
  15277,
  9797,
  15229,
  9773,
  15166,
  9668,
  15084,
  9487,
  14995,
  9274,
  14898,
  8910,
  14800,
  8539,
  14697,
  8234,
  14590,
  7790,
  14479,
  7409,
  14367,
  7067,
  14178,
  6621,
  15337,
  8619,
  15337,
  8631,
  15333,
  8677,
  15325,
  8769,
  15305,
  8871,
  15264,
  8940,
  15202,
  8909,
  15119,
  8775,
  15022,
  8565,
  14916,
  8328,
  14804,
  8009,
  14688,
  7614,
  14569,
  7287,
  14448,
  6888,
  14321,
  6483,
  14088,
  6171,
  15350,
  7402,
  15350,
  7419,
  15347,
  7480,
  15340,
  7613,
  15322,
  7804,
  15287,
  7973,
  15229,
  8057,
  15148,
  8012,
  15046,
  7846,
  14933,
  7611,
  14810,
  7357,
  14682,
  7069,
  14552,
  6656,
  14421,
  6316,
  14251,
  5948,
  14007,
  5528,
  15356,
  5942,
  15356,
  5977,
  15353,
  6119,
  15348,
  6294,
  15332,
  6551,
  15302,
  6824,
  15249,
  7044,
  15171,
  7122,
  15070,
  7050,
  14949,
  6861,
  14818,
  6611,
  14679,
  6349,
  14538,
  6067,
  14398,
  5651,
  14189,
  5311,
  13935,
  4958,
  15359,
  4123,
  15359,
  4153,
  15356,
  4296,
  15353,
  4646,
  15338,
  5160,
  15311,
  5508,
  15263,
  5829,
  15188,
  6042,
  15088,
  6094,
  14966,
  6001,
  14826,
  5796,
  14678,
  5543,
  14527,
  5287,
  14377,
  4985,
  14133,
  4586,
  13869,
  4257,
  15360,
  1563,
  15360,
  1642,
  15358,
  2076,
  15354,
  2636,
  15341,
  3350,
  15317,
  4019,
  15273,
  4429,
  15203,
  4732,
  15105,
  4911,
  14981,
  4932,
  14836,
  4818,
  14679,
  4621,
  14517,
  4386,
  14359,
  4156,
  14083,
  3795,
  13808,
  3437,
  15360,
  122,
  15360,
  137,
  15358,
  285,
  15355,
  636,
  15344,
  1274,
  15322,
  2177,
  15281,
  2765,
  15215,
  3223,
  15120,
  3451,
  14995,
  3569,
  14846,
  3567,
  14681,
  3466,
  14511,
  3305,
  14344,
  3121,
  14037,
  2800,
  13753,
  2467,
  15360,
  0,
  15360,
  1,
  15359,
  21,
  15355,
  89,
  15346,
  253,
  15325,
  479,
  15287,
  796,
  15225,
  1148,
  15133,
  1492,
  15008,
  1749,
  14856,
  1882,
  14685,
  1886,
  14506,
  1783,
  14324,
  1608,
  13996,
  1398,
  13702,
  1183
]);
let jt = null;
const p1 = /* @__PURE__ */ b(({ roughness: r, dotNV: e }) => {
  jt === null && (jt = new cf(d1, 16, 16, Rr, us), jt.name = "DFG_LUT", jt.minFilter = ms, jt.magFilter = ms, jt.wrapS = Js, jt.wrapT = Js, jt.generateMipmaps = !1, jt.needsUpdate = !0);
  const t = B(r, e);
  return xe(jt, t).rg;
}), m1 = /* @__PURE__ */ b(({ f: r, f90: e, dotVH: t }) => {
  const s = t.oneMinus().saturate(), i = s.mul(s), a = s.mul(i, i).clamp(0, 0.9999);
  return r.sub(N(e).mul(a)).div(a.oneMinus());
}).setLayout({
  name: "Schlick_to_F0",
  type: "vec3",
  inputs: [
    { name: "f", type: "vec3" },
    { name: "f90", type: "float" },
    { name: "dotVH", type: "float" }
  ]
}), ln = 1 / 6, im = (r) => j(ln, j(r, j(r, r.negate().add(3)).sub(3)).add(1)), Po = (r) => j(ln, j(r, j(r, j(3, r).sub(6))).add(4)), am = (r) => j(ln, j(r, j(r, j(-3, r).add(3)).add(3)).add(1)), Fo = (r) => j(ln, vt(r, 3)), ih = (r) => im(r).add(Po(r)), ah = (r) => am(r).add(Fo(r)), nh = (r) => Ae(-1, Po(r).div(im(r).add(Po(r)))), oh = (r) => Ae(1, Fo(r).div(am(r).add(Fo(r)))), lh = (r, e, t) => {
  const s = r.uvNode, i = j(s, e.zw).add(0.5), a = Xt(i), n = Bt(i), o = ih(n.x), l = ah(n.x), u = nh(n.x), h = oh(n.x), d = nh(n.y), p = oh(n.y), m = B(a.x.add(u), a.y.add(d)).sub(0.5).mul(e.xy), g = B(a.x.add(h), a.y.add(d)).sub(0.5).mul(e.xy), y = B(a.x.add(u), a.y.add(p)).sub(0.5).mul(e.xy), v = B(a.x.add(h), a.y.add(p)).sub(0.5).mul(e.xy), w = ih(n.y).mul(Ae(o.mul(r.sample(m).level(t)), l.mul(r.sample(g).level(t)))), _ = ah(n.y).mul(Ae(o.mul(r.sample(y).level(t)), l.mul(r.sample(v).level(t))));
  return w.add(_);
}, nm = /* @__PURE__ */ b(([r, e]) => {
  const t = B(r.size(x(e))), s = B(r.size(x(e.add(1)))), i = Zt(1, t), a = Zt(1, s), n = lh(r, D(i, t), Xt(e)), o = lh(r, D(a, s), Ya(e));
  return Bt(e).mix(n, o);
}), g1 = /* @__PURE__ */ b(([r, e]) => {
  const t = e.mul(Pl(r));
  return nm(r, t);
});
N(0.04);
f(1);
const uh = /* @__PURE__ */ f(1), Bo = /* @__PURE__ */ f(-2), ia = /* @__PURE__ */ f(0.8), Yn = /* @__PURE__ */ f(-1), aa = /* @__PURE__ */ f(0.4), Zn = /* @__PURE__ */ f(2), na = /* @__PURE__ */ f(0.305), Jn = /* @__PURE__ */ f(3), hh = /* @__PURE__ */ f(0.21), f1 = /* @__PURE__ */ f(4), ch = /* @__PURE__ */ f(4), y1 = /* @__PURE__ */ f(16), x1 = /* @__PURE__ */ b(([r]) => {
  const e = N(he(r)).toVar(), t = f(-1).toVar();
  return W(e.x.greaterThan(e.z), () => {
    W(e.x.greaterThan(e.y), () => {
      t.assign(He(r.x.greaterThan(0), 0, 3));
    }).Else(() => {
      t.assign(He(r.y.greaterThan(0), 1, 4));
    });
  }).Else(() => {
    W(e.z.greaterThan(e.y), () => {
      t.assign(He(r.z.greaterThan(0), 2, 5));
    }).Else(() => {
      t.assign(He(r.y.greaterThan(0), 1, 4));
    });
  }), t;
}).setLayout({
  name: "getFace",
  type: "float",
  inputs: [
    { name: "direction", type: "vec3" }
  ]
}), b1 = /* @__PURE__ */ b(([r, e]) => {
  const t = B().toVar();
  return W(e.equal(0), () => {
    t.assign(B(r.z, r.y).div(he(r.x)));
  }).ElseIf(e.equal(1), () => {
    t.assign(B(r.x.negate(), r.z.negate()).div(he(r.y)));
  }).ElseIf(e.equal(2), () => {
    t.assign(B(r.x.negate(), r.y).div(he(r.z)));
  }).ElseIf(e.equal(3), () => {
    t.assign(B(r.z.negate(), r.y).div(he(r.x)));
  }).ElseIf(e.equal(4), () => {
    t.assign(B(r.x.negate(), r.z).div(he(r.y)));
  }).Else(() => {
    t.assign(B(r.x, r.y).div(he(r.z)));
  }), j(0.5, t.add(1));
}).setLayout({
  name: "getUV",
  type: "vec2",
  inputs: [
    { name: "direction", type: "vec3" },
    { name: "face", type: "float" }
  ]
}), v1 = /* @__PURE__ */ b(([r]) => {
  const e = f(0).toVar();
  return W(r.greaterThanEqual(ia), () => {
    e.assign(uh.sub(r).mul(Yn.sub(Bo)).div(uh.sub(ia)).add(Bo));
  }).ElseIf(r.greaterThanEqual(aa), () => {
    e.assign(ia.sub(r).mul(Zn.sub(Yn)).div(ia.sub(aa)).add(Yn));
  }).ElseIf(r.greaterThanEqual(na), () => {
    e.assign(aa.sub(r).mul(Jn.sub(Zn)).div(aa.sub(na)).add(Zn));
  }).ElseIf(r.greaterThanEqual(hh), () => {
    e.assign(na.sub(r).mul(f1.sub(Jn)).div(na.sub(hh)).add(Jn));
  }).Else(() => {
    e.assign(f(-2).mul(ps(j(1.16, r))));
  }), e;
}).setLayout({
  name: "roughnessToMip",
  type: "float",
  inputs: [
    { name: "roughness", type: "float" }
  ]
}), om = /* @__PURE__ */ b(([r, e]) => {
  const t = r.toVar();
  t.assign(j(2, t).sub(1));
  const s = N(t, 1).toVar();
  return W(e.equal(0), () => {
    s.assign(s.zyx);
  }).ElseIf(e.equal(1), () => {
    s.assign(s.xzy), s.xz.mulAssign(-1);
  }).ElseIf(e.equal(2), () => {
    s.x.mulAssign(-1);
  }).ElseIf(e.equal(3), () => {
    s.assign(s.zyx), s.xz.mulAssign(-1);
  }).ElseIf(e.equal(4), () => {
    s.assign(s.xzy), s.xy.mulAssign(-1);
  }).ElseIf(e.equal(5), () => {
    s.z.mulAssign(-1);
  }), s;
}).setLayout({
  name: "getDirection",
  type: "vec3",
  inputs: [
    { name: "uv", type: "vec2" },
    { name: "face", type: "float" }
  ]
}), lm = /* @__PURE__ */ b(([r, e, t, s, i, a]) => {
  const n = f(t), o = N(e), l = Jt(v1(n), Bo, a), u = Bt(l), h = Xt(l), d = N(bi(r, o, h, s, i, a)).toVar();
  return W(u.notEqual(0), () => {
    const p = N(bi(r, o, h.add(1), s, i, a)).toVar();
    d.assign(pe(d, p, u));
  }), d;
}), bi = /* @__PURE__ */ b(([r, e, t, s, i, a]) => {
  const n = f(t).toVar(), o = N(e), l = f(x1(o)).toVar(), u = f(Ee(ch.sub(n), 0)).toVar();
  n.assign(Ee(n, ch));
  const h = f(Wr(n)).toVar(), d = B(b1(o, l).mul(h.sub(2)).add(1)).toVar();
  return W(l.greaterThan(2), () => {
    d.y.addAssign(h), l.subAssign(3);
  }), d.x.addAssign(l.mul(h)), d.x.addAssign(u.mul(j(3, y1))), d.y.addAssign(j(4, Wr(a).sub(h))), d.x.mulAssign(s), d.y.mulAssign(i), r.sample(d).grad(B(), B());
}), Qn = /* @__PURE__ */ b(({ envMap: r, mipInt: e, outputDirection: t, theta: s, axis: i, CUBEUV_TEXEL_WIDTH: a, CUBEUV_TEXEL_HEIGHT: n, CUBEUV_MAX_MIP: o }) => {
  const l = Rt(s), u = t.mul(l).add(i.cross(t).mul(Qe(s))).add(i.mul(i.dot(t).mul(l.oneMinus())));
  return bi(r, u, e, a, n, o);
}), um = /* @__PURE__ */ b(({ n: r, latitudinal: e, poleAxis: t, outputDirection: s, weights: i, samples: a, dTheta: n, mipInt: o, envMap: l, CUBEUV_TEXEL_WIDTH: u, CUBEUV_TEXEL_HEIGHT: h, CUBEUV_MAX_MIP: d }) => {
  const p = N(He(e, t, gs(t, s))).toVar();
  W(p.equal(N(0)), () => {
    p.assign(N(s.z, 0, s.x.negate()));
  }), p.assign(it(p));
  const m = N().toVar();
  return m.addAssign(i.element(0).mul(Qn({ theta: 0, axis: p, outputDirection: s, mipInt: o, envMap: l, CUBEUV_TEXEL_WIDTH: u, CUBEUV_TEXEL_HEIGHT: h, CUBEUV_MAX_MIP: d }))), le({ start: x(1), end: r }, ({ i: g }) => {
    W(g.greaterThanEqual(a), () => {
      qp();
    });
    const y = f(n.mul(f(g))).toVar();
    m.addAssign(i.element(g).mul(Qn({ theta: y.mul(-1), axis: p, outputDirection: s, mipInt: o, envMap: l, CUBEUV_TEXEL_WIDTH: u, CUBEUV_TEXEL_HEIGHT: h, CUBEUV_MAX_MIP: d }))), m.addAssign(i.element(g).mul(Qn({ theta: y, axis: p, outputDirection: s, mipInt: o, envMap: l, CUBEUV_TEXEL_WIDTH: u, CUBEUV_TEXEL_HEIGHT: h, CUBEUV_MAX_MIP: d })));
  }), D(m, 1);
}), T1 = /* @__PURE__ */ b(([r]) => {
  const e = E(r).toVar();
  return e.assign(e.shiftLeft(E(16)).bitOr(e.shiftRight(E(16)))), e.assign(e.bitAnd(E(1431655765)).shiftLeft(E(1)).bitOr(e.bitAnd(E(2863311530)).shiftRight(E(1)))), e.assign(e.bitAnd(E(858993459)).shiftLeft(E(2)).bitOr(e.bitAnd(E(3435973836)).shiftRight(E(2)))), e.assign(e.bitAnd(E(252645135)).shiftLeft(E(4)).bitOr(e.bitAnd(E(4042322160)).shiftRight(E(4)))), e.assign(e.bitAnd(E(16711935)).shiftLeft(E(8)).bitOr(e.bitAnd(E(4278255360)).shiftRight(E(8)))), f(e).mul(23283064365386963e-26);
}), w1 = /* @__PURE__ */ b(([r, e]) => B(f(r).div(f(e)), T1(r))), N1 = /* @__PURE__ */ b(([r, e, t]) => {
  const s = t.mul(t).toConst(), i = N(1, 0, 0).toConst(), a = gs(e, i).toConst(), n = et(r.x).toConst(), o = j(2, 3.14159265359).mul(r.y).toConst(), l = n.mul(Rt(o)).toConst(), u = n.mul(Qe(o)).toVar(), h = j(0.5, e.z.add(1)).toConst();
  u.assign(h.oneMinus().mul(et(l.mul(l).oneMinus())).add(h.mul(u)));
  const d = i.mul(l).add(a.mul(u)).add(e.mul(et(Ee(0, l.mul(l).add(u.mul(u)).oneMinus()))));
  return it(N(s.mul(d.x), s.mul(d.y), Ee(0, d.z)));
}), hm = /* @__PURE__ */ b(({ roughness: r, mipInt: e, envMap: t, N_immutable: s, GGX_SAMPLES: i, CUBEUV_TEXEL_WIDTH: a, CUBEUV_TEXEL_HEIGHT: n, CUBEUV_MAX_MIP: o }) => {
  const l = N(s).toVar(), u = N(0).toVar(), h = f(0).toVar();
  return W(r.lessThan(1e-3), () => {
    u.assign(bi(t, l, e, a, n, o));
  }).Else(() => {
    const d = He(he(l.z).lessThan(0.999), N(0, 0, 1), N(1, 0, 0)), p = it(gs(d, l)).toVar(), m = gs(l, p).toVar();
    le({ start: E(0), end: i }, ({ i: g }) => {
      const y = w1(g, i), v = N1(y, N(0, 0, 1), r), w = it(p.mul(v.x).add(m.mul(v.y)).add(l.mul(v.z))), _ = it(w.mul(St(l, w).mul(2)).sub(l)), C = Ee(St(l, _), 0);
      W(C.greaterThan(0), () => {
        const V = bi(t, _, e, a, n, o);
        u.addAssign(V.mul(C)), h.addAssign(C);
      });
    }), W(h.greaterThan(0), () => {
      u.assign(u.div(h));
    });
  }), D(u, 1);
}), zs = 4, dh = [0.125, 0.215, 0.35, 0.446, 0.526, 0.582], Zs = 20, M1 = 512, ai = /* @__PURE__ */ new $h(-1, 1, 1, -1, 0, 1), S1 = /* @__PURE__ */ new yf(90, 1), ph = /* @__PURE__ */ new Yt();
let Kn = null, eo = 0, to = 0;
const _1 = /* @__PURE__ */ new M(), Ia = /* @__PURE__ */ new WeakMap(), A1 = [
  3,
  1,
  5,
  0,
  4,
  2
], so = /* @__PURE__ */ om(ae(), Tt("faceIndex")).normalize(), un = /* @__PURE__ */ N(so.x, so.y, so.z);
class V1 {
  /**
   * Constructs a new PMREM generator.
   *
   * @param {Renderer} renderer - The renderer.
   */
  constructor(e) {
    this._renderer = e, this._pingPongRenderTarget = null, this._lodMax = 0, this._cubeSize = 0, this._sizeLods = [], this._sigmas = [], this._lodMeshes = [], this._blurMaterial = null, this._ggxMaterial = null, this._cubemapMaterial = null, this._equirectMaterial = null, this._backgroundBox = null;
  }
  get _hasInitialized() {
    return this._renderer.hasInitialized();
  }
  /**
   * Generates a PMREM from a supplied Scene, which can be faster than using an
   * image if networking bandwidth is low. Optional sigma specifies a blur radius
   * in radians to be applied to the scene before PMREM generation. Optional near
   * and far planes ensure the scene is rendered in its entirety.
   *
   * @param {Scene} scene - The scene to be captured.
   * @param {number} [sigma=0] - The blur radius in radians.
   * @param {number} [near=0.1] - The near plane distance.
   * @param {number} [far=100] - The far plane distance.
   * @param {Object} [options={}] - The configuration options.
   * @param {number} [options.size=256] - The texture size of the PMREM.
   * @param {Vector3} [options.renderTarget=origin] - The position of the internal cube camera that renders the scene.
   * @param {?RenderTarget} [options.renderTarget=null] - The render target to use.
   * @return {RenderTarget} The resulting PMREM.
   * @see {@link PMREMGenerator#fromScene}
   */
  fromScene(e, t = 0, s = 0.1, i = 100, a = {}) {
    const {
      size: n = 256,
      position: o = _1,
      renderTarget: l = null
    } = a;
    if (this._setSize(n), this._hasInitialized === !1)
      throw new Error('THREE.PMREMGenerator: .fromScene() called before the backend is initialized. Use "await renderer.init();" before using this method.');
    Kn = this._renderer.getRenderTarget(), eo = this._renderer.getActiveCubeFace(), to = this._renderer.getActiveMipmapLevel();
    const u = l || this._allocateTarget(!0);
    return this._init(u), this._sceneToCubeUV(e, s, i, u, o), t > 0 && this._blur(u, 0, 0, t), this._applyPMREM(u), this._cleanup(u), u;
  }
  /**
   * Generates a PMREM from a supplied Scene, which can be faster than using an
   * image if networking bandwidth is low. Optional sigma specifies a blur radius
   * in radians to be applied to the scene before PMREM generation. Optional near
   * and far planes ensure the scene is rendered in its entirety (the cubeCamera
   * is placed at the origin).
   *
   * @deprecated
   * @param {Scene} scene - The scene to be captured.
   * @param {number} [sigma=0] - The blur radius in radians.
   * @param {number} [near=0.1] - The near plane distance.
   * @param {number} [far=100] - The far plane distance.
   * @param {Object} [options={}] - The configuration options.
   * @param {number} [options.size=256] - The texture size of the PMREM.
   * @param {Vector3} [options.position=origin] - The position of the internal cube camera that renders the scene.
   * @param {?RenderTarget} [options.renderTarget=null] - The render target to use.
   * @return {Promise<RenderTarget>} A Promise that resolve with the PMREM when the generation has been finished.
   * @see {@link PMREMGenerator#fromScene}
   */
  async fromSceneAsync(e, t = 0, s = 0.1, i = 100, a = {}) {
    return Be('PMREMGenerator: ".fromSceneAsync()" is deprecated. Use "await renderer.init()" instead.'), await this._renderer.init(), this.fromScene(e, t, s, i, a);
  }
  /**
   * Generates a PMREM from an equirectangular texture, which can be either LDR
   * or HDR. The ideal input image size is 1k (1024 x 512), as this matches best
   * with the 256 x 256 cubemap output. The minimum supported input image size
   * is 64 x 32.
   *
   * @param {Texture} equirectangular - The equirectangular texture to be converted.
   * @param {?RenderTarget} [renderTarget=null] - The render target to use.
   * @return {RenderTarget} The resulting PMREM.
   * @see {@link PMREMGenerator#fromEquirectangularAsync}
   */
  fromEquirectangular(e, t = null) {
    if (this._hasInitialized === !1)
      throw new Error('THREE.PMREMGenerator: .fromEquirectangular() called before the backend is initialized. Use "await renderer.init();" before using this method.');
    return this._fromTexture(e, t);
  }
  /**
   * Generates a PMREM from an equirectangular texture, which can be either LDR
   * or HDR. The ideal input image size is 1k (1024 x 512),
   * as this matches best with the 256 x 256 cubemap output.
   *
   * @deprecated
   * @param {Texture} equirectangular - The equirectangular texture to be converted.
   * @param {?RenderTarget} [renderTarget=null] - The render target to use.
   * @return {Promise<RenderTarget>} The resulting PMREM.
   * @see {@link PMREMGenerator#fromEquirectangular}
   */
  async fromEquirectangularAsync(e, t = null) {
    return Be('PMREMGenerator: ".fromEquirectangularAsync()" is deprecated. Use "await renderer.init()" instead.'), await this._renderer.init(), this._fromTexture(e, t);
  }
  /**
   * Generates a PMREM from an cubemap texture, which can be either LDR
   * or HDR. The ideal input cube size is 256 x 256, as this matches best
   * with the 256 x 256 cubemap output. The minimum supported input cube
   * size is 16 x 16 per face.
   *
   * @param {Texture} cubemap - The cubemap texture to be converted.
   * @param {?RenderTarget} [renderTarget=null] - The render target to use.
   * @return {RenderTarget} The resulting PMREM.
   * @see {@link PMREMGenerator#fromCubemapAsync}
   */
  fromCubemap(e, t = null) {
    if (this._hasInitialized === !1)
      throw new Error('THREE.PMREMGenerator: .fromCubemap() called before the backend is initialized. Use "await renderer.init();" before using this method.');
    return this._fromTexture(e, t);
  }
  /**
   * Generates a PMREM from an cubemap texture, which can be either LDR
   * or HDR. The ideal input cube size is 256 x 256,
   * with the 256 x 256 cubemap output.
   *
   * @deprecated
   * @param {Texture} cubemap - The cubemap texture to be converted.
   * @param {?RenderTarget} [renderTarget=null] - The render target to use.
   * @return {Promise<RenderTarget>} The resulting PMREM.
   * @see {@link PMREMGenerator#fromCubemap}
   */
  async fromCubemapAsync(e, t = null) {
    return Be('PMREMGenerator: ".fromCubemapAsync()" is deprecated. Use "await renderer.init()" instead.'), await this._renderer.init(), this._fromTexture(e, t);
  }
  /**
   * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
   * your texture's network fetch for increased concurrency.
   *
   * @returns {Promise}
   */
  async compileCubemapShader() {
    this._cubemapMaterial === null && (this._cubemapMaterial = gh(), await this._compileMaterial(this._cubemapMaterial));
  }
  /**
   * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
   * your texture's network fetch for increased concurrency.
   *
   * @returns {Promise}
   */
  async compileEquirectangularShader() {
    this._equirectMaterial === null && (this._equirectMaterial = fh(), await this._compileMaterial(this._equirectMaterial));
  }
  /**
   * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
   * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
   * one of them will cause any others to also become unusable.
   */
  dispose() {
    this._dispose(), this._cubemapMaterial !== null && this._cubemapMaterial.dispose(), this._equirectMaterial !== null && this._equirectMaterial.dispose(), this._backgroundBox !== null && (this._backgroundBox.geometry.dispose(), this._backgroundBox.material.dispose());
  }
  // private interface
  _setSizeFromTexture(e) {
    e.mapping === yi || e.mapping === yo ? this._setSize(e.image.length === 0 ? 16 : e.image[0].width || e.image[0].image.width) : this._setSize(e.image.width / 4);
  }
  _setSize(e) {
    this._lodMax = Math.floor(Math.log2(e)), this._cubeSize = Math.pow(2, this._lodMax);
  }
  _dispose() {
    this._blurMaterial !== null && this._blurMaterial.dispose(), this._ggxMaterial !== null && this._ggxMaterial.dispose(), this._pingPongRenderTarget !== null && this._pingPongRenderTarget.dispose();
    for (let e = 0; e < this._lodMeshes.length; e++)
      this._lodMeshes[e].geometry.dispose();
  }
  _cleanup(e) {
    this._renderer.setRenderTarget(Kn, eo, to), e.scissorTest = !1, this._setViewport(e, 0, 0, e.width, e.height);
  }
  _fromTexture(e, t) {
    this._setSizeFromTexture(e), Kn = this._renderer.getRenderTarget(), eo = this._renderer.getActiveCubeFace(), to = this._renderer.getActiveMipmapLevel();
    const s = t || this._allocateTarget(!1);
    return this._init(s), this._textureToCubeUV(e, s), this._applyPMREM(s), this._cleanup(s), s;
  }
  _allocateTarget(e) {
    const t = 3 * Math.max(this._cubeSize, 112), s = 4 * this._cubeSize;
    return mh(t, s, e);
  }
  _init(e) {
    if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== e.width || this._pingPongRenderTarget.height !== e.height) {
      this._pingPongRenderTarget !== null && this._dispose(), this._pingPongRenderTarget = mh(e.width, e.height);
      const { _lodMax: t } = this;
      ({ lodMeshes: this._lodMeshes, sizeLods: this._sizeLods, sigmas: this._sigmas } = C1(t)), this._blurMaterial = z1(t, e.width, e.height), this._ggxMaterial = R1(t, e.width, e.height);
    }
  }
  async _compileMaterial(e) {
    const t = new Sa(new ar(), e);
    await this._renderer.compile(t, ai);
  }
  _sceneToCubeUV(e, t, s, i, a) {
    const n = S1;
    n.near = t, n.far = s;
    const o = [1, 1, 1, 1, -1, 1], l = [1, -1, 1, -1, 1, -1], u = this._renderer, h = u.autoClear;
    u.getClearColor(ph), u.autoClear = !1, this._backgroundBox === null && (this._backgroundBox = new Sa(
      new Yo(),
      new Gh({
        name: "PMREM.Background",
        side: vi,
        depthWrite: !1,
        depthTest: !1
      })
    ));
    const d = this._backgroundBox, p = d.material;
    let m = !1;
    const g = e.background;
    g ? g.isColor && (p.color.copy(g), e.background = null, m = !0) : (p.color.copy(ph), m = !0), u.setRenderTarget(i), u.clear(), m && u.render(d, n);
    for (let y = 0; y < 6; y++) {
      const v = y % 3;
      v === 0 ? (n.up.set(0, o[y], 0), n.position.set(a.x, a.y, a.z), n.lookAt(a.x + l[y], a.y, a.z)) : v === 1 ? (n.up.set(0, 0, o[y]), n.position.set(a.x, a.y, a.z), n.lookAt(a.x, a.y + l[y], a.z)) : (n.up.set(0, o[y], 0), n.position.set(a.x, a.y, a.z), n.lookAt(a.x, a.y, a.z + l[y]));
      const w = this._cubeSize;
      this._setViewport(i, v * w, y > 2 ? w : 0, w, w), u.render(e, n);
    }
    u.autoClear = h, e.background = g;
  }
  _textureToCubeUV(e, t) {
    const s = this._renderer, i = e.mapping === yi || e.mapping === yo;
    i ? this._cubemapMaterial === null && (this._cubemapMaterial = gh(e)) : this._equirectMaterial === null && (this._equirectMaterial = fh(e));
    const a = i ? this._cubemapMaterial : this._equirectMaterial;
    a.fragmentNode.value = e;
    const n = this._lodMeshes[0];
    n.material = a;
    const o = this._cubeSize;
    this._setViewport(t, 0, 0, 3 * o, 2 * o), s.setRenderTarget(t), s.render(n, ai);
  }
  _applyPMREM(e) {
    const t = this._renderer, s = t.autoClear;
    t.autoClear = !1;
    const i = this._lodMeshes.length;
    for (let a = 1; a < i; a++)
      this._applyGGXFilter(e, a - 1, a);
    t.autoClear = s;
  }
  /**
   * Applies GGX VNDF importance sampling filter to generate a prefiltered environment map.
   * Uses Monte Carlo integration with VNDF importance sampling to accurately represent the
   * GGX BRDF for physically-based rendering. Reads from the previous LOD level and
   * applies incremental roughness filtering to avoid over-blurring.
   *
   * @private
   * @param {RenderTarget} cubeUVRenderTarget
   * @param {number} lodIn - Source LOD level to read from
   * @param {number} lodOut - Target LOD level to write to
   */
  _applyGGXFilter(e, t, s) {
    const i = this._renderer, a = this._pingPongRenderTarget, n = this._ggxMaterial, o = this._lodMeshes[s];
    o.material = n;
    const l = Ia.get(n), u = s / (this._lodMeshes.length - 1), h = t / (this._lodMeshes.length - 1), d = Math.sqrt(u * u - h * h), p = 0 + u * 1.25, m = d * p, { _lodMax: g } = this, y = this._sizeLods[s], v = 3 * y * (s > g - zs ? s - g + zs : 0), w = 4 * (this._cubeSize - y);
    e.texture.frame = (e.texture.frame || 0) + 1, l.envMap.value = e.texture, l.roughness.value = m, l.mipInt.value = g - t, this._setViewport(a, v, w, 3 * y, 2 * y), i.setRenderTarget(a), i.render(o, ai), a.texture.frame = (a.texture.frame || 0) + 1, l.envMap.value = a.texture, l.roughness.value = 0, l.mipInt.value = g - s, this._setViewport(e, v, w, 3 * y, 2 * y), i.setRenderTarget(e), i.render(o, ai);
  }
  /**
   * This is a two-pass Gaussian blur for a cubemap. Normally this is done
   * vertically and horizontally, but this breaks down on a cube. Here we apply
   * the blur latitudinally (around the poles), and then longitudinally (towards
   * the poles) to approximate the orthogonally-separable blur. It is least
   * accurate at the poles, but still does a decent job.
   *
   * Used for initial scene blur in fromScene() method when sigma > 0.
   *
   * @private
   * @param {RenderTarget} cubeUVRenderTarget - The cubemap render target.
   * @param {number} lodIn - The input level-of-detail.
   * @param {number} lodOut - The output level-of-detail.
   * @param {number} sigma - The blur radius in radians.
   * @param {Vector3} [poleAxis] - The pole axis.
   */
  _blur(e, t, s, i, a) {
    const n = this._pingPongRenderTarget;
    this._halfBlur(
      e,
      n,
      t,
      s,
      i,
      "latitudinal",
      a
    ), this._halfBlur(
      n,
      e,
      s,
      s,
      i,
      "longitudinal",
      a
    );
  }
  _halfBlur(e, t, s, i, a, n, o) {
    const l = this._renderer, u = this._blurMaterial;
    n !== "latitudinal" && n !== "longitudinal" && te("blur direction must be either latitudinal or longitudinal!");
    const h = 3, d = this._lodMeshes[i];
    d.material = u;
    const p = Ia.get(u), m = this._sizeLods[s] - 1, g = isFinite(a) ? Math.PI / (2 * m) : 2 * Math.PI / (2 * Zs - 1), y = a / g, v = isFinite(a) ? 1 + Math.floor(h * y) : Zs;
    v > Zs && X(`sigmaRadians, ${a}, is too large and will clip, as it requested ${v} samples when the maximum is set to ${Zs}`);
    const w = [];
    let _ = 0;
    for (let R = 0; R < Zs; ++R) {
      const I = R / y, G = Math.exp(-I * I / 2);
      w.push(G), R === 0 ? _ += G : R < v && (_ += 2 * G);
    }
    for (let R = 0; R < w.length; R++)
      w[R] = w[R] / _;
    e.texture.frame = (e.texture.frame || 0) + 1, p.envMap.value = e.texture, p.samples.value = v, p.weights.array = w, p.latitudinal.value = n === "latitudinal" ? 1 : 0, o && (p.poleAxis.value = o);
    const { _lodMax: C } = this;
    p.dTheta.value = g, p.mipInt.value = C - s;
    const V = this._sizeLods[i], P = 3 * V * (i > C - zs ? i - C + zs : 0), z = 4 * (this._cubeSize - V);
    this._setViewport(t, P, z, 3 * V, 2 * V), l.setRenderTarget(t), l.render(d, ai);
  }
  _setViewport(e, t, s, i, a) {
    this._renderer.isWebGLRenderer ? (e.viewport.set(t, e.height - a - s, i, a), e.scissor.set(t, e.height - a - s, i, a)) : (e.viewport.set(t, s, i, a), e.scissor.set(t, s, i, a));
  }
}
function C1(r) {
  const e = [], t = [], s = [];
  let i = r;
  const a = r - zs + 1 + dh.length;
  for (let n = 0; n < a; n++) {
    const o = Math.pow(2, i);
    e.push(o);
    let l = 1 / o;
    n > r - zs ? l = dh[n - r + zs - 1] : n === 0 && (l = 0), t.push(l);
    const u = 1 / (o - 2), h = -u, d = 1 + u, p = [h, h, d, h, d, d, h, h, d, d, h, d], m = 6, g = 6, y = 3, v = 2, w = 1, _ = new Float32Array(y * g * m), C = new Float32Array(v * g * m), V = new Float32Array(w * g * m);
    for (let z = 0; z < m; z++) {
      const R = z % 3 * 2 / 3 - 1, I = z > 2 ? 0 : -1, G = [
        R,
        I,
        0,
        R + 2 / 3,
        I,
        0,
        R + 2 / 3,
        I + 1,
        0,
        R,
        I,
        0,
        R + 2 / 3,
        I + 1,
        0,
        R,
        I + 1,
        0
      ], $ = A1[z];
      _.set(G, y * g * $), C.set(p, v * g * $);
      const Z = [$, $, $, $, $, $];
      V.set(Z, w * g * $);
    }
    const P = new ar();
    P.setAttribute("position", new wt(_, y)), P.setAttribute("uv", new wt(C, v)), P.setAttribute("faceIndex", new wt(V, w)), s.push(new Sa(P, null)), i > zs && i--;
  }
  return { lodMeshes: s, sizeLods: e, sigmas: t };
}
function mh(r, e, t) {
  const s = {
    magFilter: ms,
    minFilter: ms,
    generateMipmaps: !1,
    type: us,
    format: Eh,
    colorSpace: wa,
    depthBuffer: t
  }, i = new Ti(r, e, s);
  return i.texture.mapping = zh, i.texture.name = "PMREM.cubeUv", i.texture.isPMREMTexture = !0, i.scissorTest = !0, i;
}
function hn(r) {
  const e = new jr();
  return e.depthTest = !1, e.depthWrite = !1, e.blending = ko, e.name = `PMREM_${r}`, e;
}
function z1(r, e, t) {
  const s = Ge(new Array(Zs).fill(0)), i = q(new M(0, 1, 0)), a = q(0), n = f(Zs), o = q(0), l = q(1), u = xe(), h = q(0), d = f(1 / e), p = f(1 / t), m = f(r), g = {
    n,
    latitudinal: o,
    weights: s,
    poleAxis: i,
    outputDirection: un,
    dTheta: a,
    samples: l,
    envMap: u,
    mipInt: h,
    CUBEUV_TEXEL_WIDTH: d,
    CUBEUV_TEXEL_HEIGHT: p,
    CUBEUV_MAX_MIP: m
  }, y = hn("blur");
  return y.fragmentNode = um({ ...g, latitudinal: o.equal(1) }), Ia.set(y, g), y;
}
function R1(r, e, t) {
  const s = xe(), i = q(0), a = q(0), n = f(1 / e), o = f(1 / t), l = f(r), u = {
    envMap: s,
    roughness: i,
    mipInt: a,
    CUBEUV_TEXEL_WIDTH: n,
    CUBEUV_TEXEL_HEIGHT: o,
    CUBEUV_MAX_MIP: l
  }, h = hn("ggx");
  return h.fragmentNode = hm({
    ...u,
    N_immutable: un,
    GGX_SAMPLES: E(M1)
  }), Ia.set(h, u), h;
}
function gh(r) {
  const e = hn("cubemap");
  return e.fragmentNode = bt(r, un), e;
}
function fh(r) {
  const e = hn("equirect");
  return e.fragmentNode = xe(r, Kp(un), 0), e;
}
const yh = /* @__PURE__ */ new WeakMap();
function E1(r) {
  const e = Math.log2(r) - 2, t = 1 / r;
  return { texelWidth: 1 / (3 * Math.max(Math.pow(2, e), 112)), texelHeight: t, maxMip: e };
}
function L1(r, e, t) {
  const s = I1(e);
  let i = s.get(r);
  if ((i !== void 0 ? i.pmremVersion : -1) !== r.pmremVersion) {
    const a = r.image;
    if (r.isCubeTexture)
      if (P1(a))
        i = t.fromCubemap(r, i);
      else
        return null;
    else if (F1(a))
      i = t.fromEquirectangular(r, i);
    else
      return null;
    if (i.pmremVersion = r.pmremVersion, s.has(r) === !1) {
      const n = () => {
        r.removeEventListener("dispose", n);
        const o = s.get(r);
        o !== void 0 && (o.dispose(), s.delete(r));
      };
      r.addEventListener("dispose", n);
    }
    s.set(r, i);
  }
  return i.texture;
}
function I1(r) {
  let e = yh.get(r);
  return e === void 0 && (e = /* @__PURE__ */ new WeakMap(), yh.set(r, e)), e;
}
class O1 extends we {
  static get type() {
    return "PMREMNode";
  }
  /**
   * Constructs a new function overloading node.
   *
   * @param {Texture} value - The input texture.
   * @param {Node<vec2>} [uvNode=null] - The uv node.
   * @param {Node<float>} [levelNode=null] - The level node.
   */
  constructor(e, t = null, s = null) {
    super("vec3"), this._value = e, this._pmrem = null, this.uvNode = t, this.levelNode = s, this._generator = null;
    const i = new Ke();
    i.isRenderTargetTexture = !0, this._texture = xe(i), this._width = q(0), this._height = q(0), this._maxMip = q(0), this.updateBeforeType = Q.RENDER;
  }
  set value(e) {
    this._value = e, this._pmrem = null;
  }
  /**
   * The node's texture value.
   *
   * @type {Texture}
   */
  get value() {
    return this._value;
  }
  /**
   * Uses the given PMREM texture to update internal values.
   *
   * @param {Texture} texture - The PMREM texture.
   */
  updateFromTexture(e) {
    const t = E1(e.image.height);
    this._texture.value = e, this._width.value = t.texelWidth, this._height.value = t.texelHeight, this._maxMip.value = t.maxMip;
  }
  updateBefore(e) {
    let t = this._pmrem;
    const s = t ? t.pmremVersion : -1, i = this._value;
    s !== i.pmremVersion && (i.isPMREMTexture === !0 || i.mapping === zh ? t = i : t = L1(i, e.renderer, this._generator), t !== null && (this._pmrem = t, this.updateFromTexture(t)));
  }
  setup(e) {
    this._generator === null && (this._generator = new V1(e.renderer)), this.updateBefore(e);
    let t = this.uvNode;
    t === null && e.context.getUV && (t = e.context.getUV(this, e)), t = this._pmrem.isRenderTargetTexture ? Ca.mul(N(t.x, t.y.negate(), t.z)) : Ca.mul(t);
    let s = this.levelNode;
    return s === null && e.context.getTextureLevel && (s = e.context.getTextureLevel(this)), lm(this._texture, t, s, this._width, this._height, this._maxMip);
  }
  dispose() {
    super.dispose(), this._generator !== null && this._generator.dispose();
  }
}
function P1(r) {
  if (r == null) return !1;
  let e = 0;
  const t = 6;
  for (let s = 0; s < t; s++)
    r[s] !== void 0 && e++;
  return e === t;
}
function F1(r) {
  return r == null ? !1 : r.height > 0;
}
const B1 = /* @__PURE__ */ Y(O1).setParameterLength(1, 3), U1 = /* @__PURE__ */ b(() => {
  const r = N(dt.z, 0, dt.x.negate()).normalize(), e = dt.cross(r);
  return B(r.dot(Ue), e.dot(Ue)).mul(0.495).add(0.5);
}).once(["NORMAL", "VERTEX"])().toVar("matcapUV");
class k1 extends we {
  static get type() {
    return "RotateNode";
  }
  /**
   * Constructs a new rotate node.
   *
   * @param {Node} positionNode - The position node.
   * @param {Node} rotationNode - Represents the rotation that is applied to the position node. Depending
   * on whether the position data are 2D or 3D, the rotation is expressed a single float value or an Euler value.
   */
  constructor(e, t) {
    super(), this.positionNode = e, this.rotationNode = t;
  }
  /**
   * The type of the {@link RotateNode#positionNode} defines the node's type.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The node's type.
   */
  generateNodeType(e) {
    return this.positionNode.getNodeType(e);
  }
  setup(e) {
    const { rotationNode: t, positionNode: s } = this;
    if (this.getNodeType(e) === "vec2") {
      const i = t.cos(), a = t.sin();
      return Ha(
        i,
        a,
        a.negate(),
        i
      ).mul(s);
    } else {
      const i = t, a = Rs(D(1, 0, 0, 0), D(0, Rt(i.x), Qe(i.x).negate(), 0), D(0, Qe(i.x), Rt(i.x), 0), D(0, 0, 0, 1)), n = Rs(D(Rt(i.y), 0, Qe(i.y), 0), D(0, 1, 0, 0), D(Qe(i.y).negate(), 0, Rt(i.y), 0), D(0, 0, 0, 1)), o = Rs(D(Rt(i.z), Qe(i.z).negate(), 0, 0), D(Qe(i.z), Rt(i.z), 0, 0), D(0, 0, 1, 0), D(0, 0, 0, 1));
      return a.mul(n).mul(o).mul(D(s, 1)).xyz;
    }
  }
}
const Ql = /* @__PURE__ */ Y(k1).setParameterLength(2);
ys("vec3");
ys("vec3");
ys("vec3");
class D1 {
  /**
   * Constructs a new Chain Map.
   */
  constructor() {
    this.weakMaps = {};
  }
  /**
   * Returns the Weak Map for the given keys.
   *
   * @param {Array<Object>} keys - List of keys.
   * @return {WeakMap} The weak map.
   */
  _getWeakMap(e) {
    const t = e.length;
    let s = this.weakMaps[t];
    return s === void 0 && (s = /* @__PURE__ */ new WeakMap(), this.weakMaps[t] = s), s;
  }
  /**
   * Returns the value for the given array of keys.
   *
   * @param {Array<Object>} keys - List of keys.
   * @return {any} The value. Returns `undefined` if no value was found.
   */
  get(e) {
    let t = this._getWeakMap(e);
    for (let s = 0; s < e.length - 1; s++)
      if (t = t.get(e[s]), t === void 0) return;
    return t.get(e[e.length - 1]);
  }
  /**
   * Sets the value for the given keys.
   *
   * @param {Array<Object>} keys - List of keys.
   * @param {any} value - The value to set.
   * @return {ChainMap} A reference to this Chain Map.
   */
  set(e, t) {
    let s = this._getWeakMap(e);
    for (let i = 0; i < e.length - 1; i++) {
      const a = e[i];
      s.has(a) === !1 && s.set(a, /* @__PURE__ */ new WeakMap()), s = s.get(a);
    }
    return s.set(e[e.length - 1], t), this;
  }
  /**
   * Deletes a value for the given keys.
   *
   * @param {Array<Object>} keys - The keys.
   * @return {boolean} Returns `true` if the value has been removed successfully and `false` if the value has not be found.
   */
  delete(e) {
    let t = this._getWeakMap(e);
    for (let s = 0; s < e.length - 1; s++)
      if (t = t.get(e[s]), t === void 0) return !1;
    return t.delete(e[e.length - 1]);
  }
}
class cm extends Ml {
  /**
   * Returns the type of the node.
   *
   * @type {string}
   * @readonly
   * @static
   */
  static get type() {
    return "OverrideContextNode";
  }
  /**
   * Constructs a new override context node.
   *
   * @param {Map<Node, Function>} overrideNodes - A map mapping target nodes to their respective override callback functions.
   * @param {Node|null} [flowNode=null] - The node whose context should be modified.
   */
  constructor(e, t = null) {
    super(t, {
      overrideNodes: e
    }), this.isOverrideContextNode = !0;
  }
  /**
   * Gathers the context data from all parent context nodes by traversing the hierarchy,
   * merging the `overrideNodes` maps from all encountered `OverrideContextNode` instances.
   *
   * @return {Object} The gathered context data, containing the merged `overrideNodes` map.
   */
  getFlowContextData() {
    const e = [];
    this.traverse((i) => {
      i.isOverrideContextNode === !0 && e.push(i.value.overrideNodes);
    });
    const t = new Map(e.flatMap((i) => Array.from(i.entries()))), s = super.getFlowContextData();
    return s.overrideNodes = t, s;
  }
}
function dm(r, e = null, t = null) {
  if (e && e.isNode) {
    const s = e;
    e = () => s;
  }
  return new cm(/* @__PURE__ */ new Map([[r, e]]), t);
}
S("overrideNode", (r, e, t) => dm(e, t, r));
function pm(r, e = null) {
  const t = /* @__PURE__ */ new Map();
  for (const [s, i] of r) {
    const a = i !== null ? typeof i == "function" ? i : () => i : null;
    t.set(s, a);
  }
  return new cm(t, e);
}
S("overrideNodes", (r, e) => pm(e, r));
class W1 extends re {
  static get type() {
    return "ParameterNode";
  }
  /**
   * Constructs a new parameter node.
   *
   * @param {string} nodeType - The type of the node.
   * @param {?string} [name=null] - The name of the parameter in the shader.
   */
  constructor(e, t = null) {
    super(e, t), this.isParameterNode = !0;
  }
  /**
   * Gets the type of a member variable in the parameter node.
   *
   * @param {NodeBuilder} builder - The node builder.
   * @param {string} name - The name of the member variable.
   * @returns {string}
   */
  getMemberType(e, t) {
    const s = this.getNodeType(e), i = e.getStructTypeNode(s);
    let a;
    return i !== null ? a = i.getMemberType(e, t) : (te(`TSL: Member "${t}" not found in struct "${s}".`, new Re()), a = "float"), a;
  }
  getHash() {
    return String(this.id);
  }
  generate() {
    return this.name;
  }
}
const q1 = (r, e) => new W1(r, e);
class j1 extends k {
  static get type() {
    return "StackNode";
  }
  /**
   * Constructs a new stack node.
   *
   * @param {?StackNode} [parent=null] - The parent stack node.
   */
  constructor(e = null) {
    super(), this.nodes = [], this.outputNode = null, this.parent = e, this._currentCond = null, this._expressionNode = null, this._currentNode = null, this._nodeDataLibrary = /* @__PURE__ */ new Map(), this.isStackNode = !0;
  }
  getElementType(e) {
    return this.outputNode ? this.outputNode.getElementType(e) : "void";
  }
  generateNodeType(e) {
    return this.outputNode ? this.outputNode.getNodeType(e) : "void";
  }
  getMemberType(e, t) {
    return this.outputNode ? this.outputNode.getMemberType(e, t) : "void";
  }
  /**
   * Adds a node to this stack.
   *
   * @param {Node} node - The node to add.
   * @param {number} [index=-1] - The index of the node. If not specified, the node will be added to the end of the stack.
   * @return {StackNode} A reference to this stack node.
   */
  addToStack(e, t = -1) {
    if (e.isNode !== !0)
      return te("TSL: Invalid node added to stack.", new Re()), this;
    if (t === -1)
      if (this._currentNode) {
        let s = this._nodeDataLibrary.get(this._currentNode);
        s === void 0 && (s = {
          delta: 0
        }, this._nodeDataLibrary.set(this._currentNode, s)), s.delta++, t = this.nodes.indexOf(this._currentNode) + s.delta;
      } else
        t = this.nodes.length;
    return this.nodes.splice(t, 0, e), this;
  }
  /**
   * Adds a node to the stack before the current node.
   *
   * @param {Node} node - The node to add.
   * @return {StackNode} A reference to this stack node.
   */
  addToStackBefore(e) {
    const t = this._currentNode ? this.nodes.indexOf(this._currentNode) : 0;
    return this.addToStack(e, t);
  }
  /**
   * Represent an `if` statement in TSL.
   *
   * @param {Node} boolNode - Represents the condition.
   * @param {Function} method - TSL code which is executed if the condition evaluates to `true`.
   * @return {StackNode} A reference to this stack node.
   */
  If(e, t) {
    const s = new Er(t);
    return this._currentCond = He(e, s), this.addToStack(this._currentCond);
  }
  /**
   * Represent an `elseif` statement in TSL.
   *
   * @param {Node} boolNode - Represents the condition.
   * @param {Function} method - TSL code which is executed if the condition evaluates to `true`.
   * @return {StackNode} A reference to this stack node.
   */
  ElseIf(e, t) {
    const s = new Er(t), i = He(e, s);
    return this._currentCond.elseNode = i, this._currentCond = i, this;
  }
  /**
   * Represent an `else` statement in TSL.
   *
   * @param {Function} method - TSL code which is executed in the `else` case.
   * @return {StackNode} A reference to this stack node.
   */
  Else(e) {
    return this._currentCond.elseNode = new Er(e), this;
  }
  /**
   * Represents a `switch` statement in TSL.
   *
   * @param {any} expression - Represents the expression.
   * @param {Function} method - TSL code which is executed if the condition evaluates to `true`.
   * @return {StackNode} A reference to this stack node.
   */
  Switch(e) {
    return this._expressionNode = U(e), this;
  }
  /**
   * Represents a `case` statement in TSL. The TSL version accepts an arbitrary numbers of values.
   * The last parameter must be the callback method that should be executed in the `true` case.
   *
   * @param {...any} params - The values of the `Case()` statement as well as the callback method.
   * @return {StackNode} A reference to this stack node.
   */
  Case(...e) {
    const t = [];
    if (e.length >= 2)
      for (let o = 0; o < e.length - 1; o++)
        t.push(this._expressionNode.equal(U(e[o])));
    else
      te("TSL: Invalid parameter length. Case() requires at least two parameters.", new Re());
    const s = e[e.length - 1], i = new Er(s);
    let a = t[0];
    for (let o = 1; o < t.length; o++)
      a = a.or(t[o]);
    const n = He(a, i);
    return this._currentCond === null ? (this._currentCond = n, this.addToStack(this._currentCond)) : (this._currentCond.elseNode = n, this._currentCond = n, this);
  }
  /**
   * Represents the default code block of a Switch/Case statement.
   *
   * @param {Function} method - TSL code which is executed in the `else` case.
   * @return {StackNode} A reference to this stack node.
   */
  Default(e) {
    return this.Else(e), this;
  }
  setup(e) {
    const t = e.getNodeProperties(this);
    let s = 0;
    for (const i of this.getChildren())
      i.isVarNode && i.isIntent(e) && i.isAssign(e) !== !0 || (t["node" + s++] = i);
    return t.outputNode || null;
  }
  build(e, ...t) {
    const s = ac(), i = e.buildStage;
    No(this), e.setActiveStack(this);
    for (let n = 0; n < this.nodes.length; n++) {
      const o = this.nodes[n], l = this._currentNode;
      if (this._currentNode = o, !(o.isVarNode && o.isIntent(e) && o.isAssign(e) !== !0)) {
        if (i === "setup")
          o.build(e);
        else if (i === "analyze")
          o.build(e, this);
        else if (i === "generate") {
          const u = e.getDataFromNode(o, "any").stages, h = u && u[e.shaderStage];
          if (o.isVarNode && h && h.length === 1 && h[0] && h[0].isStackNode)
            continue;
          o.build(e, "void");
        }
        this._currentNode = l;
      }
    }
    let a;
    if (this.outputNode) {
      const n = this.outputNode.build(e, ...t);
      (e.buildStage !== "generate" || this.outputNode.getNodeType(e) !== "void") && (a = n);
    } else
      a = super.build(e, ...t);
    return No(s), e.removeActiveStack(this), a;
  }
}
const G1 = /* @__PURE__ */ Y(j1).setParameterLength(0, 1);
function H1(r) {
  return Object.entries(r).map(([e, t]) => typeof t == "string" ? { name: e, type: t, atomic: !1 } : { name: e, type: t.type, atomic: t.atomic || !1 });
}
class X1 extends k {
  static get type() {
    return "StructTypeNode";
  }
  /**
   * Creates an instance of StructTypeNode.
   *
   * @param {Object} membersLayout - The layout of the members for the struct.
   * @param {?string} [name=null] - The optional name of the struct.
   */
  constructor(e, t = null) {
    super("struct"), this.membersLayout = H1(e), this.name = t, this.isStructTypeNode = !0;
  }
  /**
   * Returns the length of the struct in 4-byte elements (e.g. float or int components).
   * The length is calculated by summing the lengths of the struct's members, accounting for memory alignment.
   * To get the size in bytes, multiply the returned value by 4.
   *
   * @returns {number} The length of the struct in 4-byte elements.
   */
  getLength() {
    let e = 1, t = 0;
    for (const s of this.membersLayout) {
      const i = s.type, a = _f(i), n = Af(i);
      e = Math.max(e, n);
      const o = t % e % n;
      o !== 0 && (t += n - o), t += a;
    }
    return Math.ceil(t / e) * e;
  }
  getMemberType(e, t) {
    const s = this.membersLayout.find((i) => i.name === t);
    return s ? s.type : "void";
  }
  generateNodeType(e) {
    return e.getStructTypeFromNode(this, this.membersLayout, this.name).name;
  }
  setup(e) {
    e.getStructTypeFromNode(this, this.membersLayout, this.name), e.addInclude(this);
  }
  generate(e) {
    return this.getNodeType(e);
  }
}
class $1 extends k {
  static get type() {
    return "StructNode";
  }
  constructor(e, t) {
    super("vec3"), this.structTypeNode = e, this.values = t, this.isStructNode = !0;
  }
  generateNodeType(e) {
    return this.structTypeNode.getNodeType(e);
  }
  getMemberType(e, t) {
    return this.structTypeNode.getMemberType(e, t);
  }
  _getChildren() {
    const e = super._getChildren(), t = e.find((s) => s.childNode === this.structTypeNode);
    return e.splice(e.indexOf(t), 1), e.push(t), e;
  }
  generate(e) {
    const t = e.getVarFromNode(this), s = t.type, i = e.getPropertyName(t);
    return e.addLineFlowCode(`${i} = ${e.generateStruct(s, this.structTypeNode.membersLayout, this.values)}`, this), t.name;
  }
}
const Y1 = (r, e = null) => {
  const t = new X1(r, e);
  return il((...s) => {
    let i = null;
    if (s.length > 0)
      if (s[0].isNode) {
        i = {};
        const a = Object.keys(r);
        for (let n = 0; n < s.length; n++)
          i[a[n]] = s[n];
      } else
        i = s[0];
    return new $1(t, i);
  }, t);
};
class mm extends k {
  static get type() {
    return "OutputStructNode";
  }
  /**
   * Constructs a new output struct node. The constructor can be invoked with an
   * arbitrary number of nodes representing the members.
   *
   * @param {...Node} members - A parameter list of nodes.
   */
  constructor(...e) {
    super(), this.members = e, this.isOutputStructNode = !0;
  }
  generateNodeType() {
    return "OutputType";
  }
  generate(e) {
    const t = e.getDataFromNode(this);
    if (t.membersLayout === void 0) {
      const n = this.members, o = [];
      for (let l = 0; l < n.length; l++) {
        const u = "m" + l, h = n[l].getNodeType(e);
        o.push({ name: u, type: h, index: l });
      }
      t.membersLayout = o, t.structType = e.getOutputStructTypeFromNode(this, t.membersLayout);
    }
    const s = e.getOutputStructName(), i = this.members, a = s !== "" ? s + "." : "";
    for (let n = 0; n < i.length; n++) {
      const o = i[n].build(e, t.membersLayout[n].type);
      e.addLineFlowCode(`${a}m${n} = ${o}`, this);
    }
    return s;
  }
}
const Z1 = /* @__PURE__ */ Y(mm);
class gm {
  /**
   * Constructs a new blending configuration.
   *
   * @param {(NoBlending|NormalBlending|AdditiveBlending|SubtractiveBlending|MultiplyBlending|CustomBlending|MaterialBlending)} [blending=NormalBlending] - The blending mode.
   */
  constructor(e = co) {
    this.blending = e, this.blendSrc = mo, this.blendDst = go, this.blendEquation = po, this.blendSrcAlpha = null, this.blendDstAlpha = null, this.blendEquationAlpha = null, this.premultiplyAlpha = !1;
  }
  /**
   * Copies the blending properties from the given source to this instance.
   *
   * @param {BlendMode} source - The blending configuration to copy from.
   * @return {BlendMode} A reference to this instance.
   */
  copy(e) {
    return this.blending = e.blending, this.blendSrc = e.blendSrc, this.blendDst = e.blendDst, this.blendEquation = e.blendEquation, this.blendSrcAlpha = e.blendSrcAlpha, this.blendDstAlpha = e.blendDstAlpha, this.blendEquationAlpha = e.blendEquationAlpha, this.premultiplyAlpha = e.premultiplyAlpha, this;
  }
  /**
   * Returns a clone of this blending configuration.
   *
   * @return {BlendMode} A new Blending instance with the same properties.
   */
  clone() {
    return new this.constructor().copy(this);
  }
}
const J1 = /* @__PURE__ */ new gm(ko), Q1 = /* @__PURE__ */ new gm(fg);
function fm(r, e) {
  for (let t = 0; t < r.length; t++)
    if (r[t].name === e)
      return t;
  return -1;
}
class K1 extends mm {
  static get type() {
    return "MRTNode";
  }
  /**
   * Constructs a new output struct node.
   *
   * @param {Object<string, Node>} outputNodes - The MRT outputs.
   */
  constructor(e) {
    super(), this.outputNodes = e, this.blendModes = {
      output: Q1
    }, this.isMRTNode = !0;
  }
  /**
   * Sets the blend mode for the given output name.
   *
   * @param {string} name - The name of the output.
   * @param {BlendMode} blend - The blending mode.
   * @return {MRTNode} The current MRT node.
   */
  setBlendMode(e, t) {
    return this.blendModes[e] = t, this;
  }
  /**
   * Returns the blend mode for the given output name.
   *
   * @param {string} name - The name of the output.
   * @return {BlendMode} The blend mode.
   */
  getBlendMode(e) {
    return this.blendModes[e] || J1;
  }
  /**
   * Returns `true` if the MRT node has an output with the given name.
   *
   * @param {string} name - The name of the output.
   * @return {NodeBuilder} Whether the MRT node has an output for the given name or not.
   */
  has(e) {
    return this.outputNodes[e] !== void 0;
  }
  /**
   * Returns the output node for the given name.
   *
   * @param {string} name - The name of the output.
   * @return {Node} The output node.
   */
  get(e) {
    return this.outputNodes[e];
  }
  /**
   * Merges the outputs of the given MRT node with the outputs of this node.
   *
   * @param {MRTNode} mrtNode - The MRT to merge.
   * @return {MRTNode} A new MRT node with merged outputs..
   */
  merge(e) {
    const t = { ...this.outputNodes, ...e.outputNodes }, s = { ...this.blendModes, ...e.blendModes }, i = ym(t);
    return i.blendings = s, i;
  }
  setup(e) {
    const t = this.outputNodes, s = e.renderer.getRenderTarget(), i = [], a = s.textures;
    for (const n in t) {
      const o = fm(a, n);
      if (o === -1) continue;
      const l = e.getOutputType(o);
      i[o] = t[n].convert(l);
    }
    return this.members = i, super.setup(e);
  }
}
const ym = /* @__PURE__ */ Y(K1);
class _i extends we {
  static get type() {
    return "BitcastNode";
  }
  /**
   * Constructs a new bitcast node.
   *
   * @param {Node} valueNode - The value to convert.
   * @param {string} conversionType - The type to convert to.
   * @param {?string} [inputType = null] - The expected input data type of the bitcast operation.
   */
  constructor(e, t, s = null) {
    super(), this.valueNode = e, this.conversionType = t, this.inputType = s, this.isBitcastNode = !0;
  }
  generateNodeType(e) {
    if (this.inputType !== null) {
      const t = this.valueNode.getNodeType(e), s = e.getTypeLength(t);
      return e.getTypeFromLength(s, this.conversionType);
    }
    return this.conversionType;
  }
  generate(e) {
    const t = this.getNodeType(e);
    let s = "";
    if (this.inputType !== null) {
      const i = this.valueNode.getNodeType(e);
      s = e.getTypeLength(i) === 1 ? this.inputType : e.changeComponentType(i, this.inputType);
    } else
      s = this.valueNode.getNodeType(e);
    return `${e.getBitcastMethod(t, s)}( ${this.valueNode.build(e, s)} )`;
  }
}
const xm = /* @__PURE__ */ L(_i).setParameterLength(2), eb = (r) => new _i(r, "int", "float"), bm = (r) => new _i(r, "uint", "float"), tb = (r) => new _i(r, "float", "int"), sb = (r) => new _i(r, "float", "uint"), oa = {};
class pt extends T {
  static get type() {
    return "BitcountNode";
  }
  /**
   * Constructs a new math node.
   *
   * @param {'countTrailingZeros'|'countLeadingZeros'|'countOneBits'} method - The method name.
   * @param {Node} aNode - The first input.
   */
  constructor(e, t) {
    super(e, t), this.isBitcountNode = !0;
  }
  /**
   * Casts the input value of the function to an integer if necessary.
   *
   * @private
   * @param {Node<uint>|Node<int>} inputNode - The input value.
   * @param {Node<uint>} outputNode - The output value.
   * @param {string} elementType - The type of the input value.
   */
  _resolveElementType(e, t, s) {
    s === "int" ? t.assign(xm(e, "uint")) : t.assign(e);
  }
  _returnDataNode(e) {
    switch (e) {
      case "uint":
        return E;
      case "int":
        return x;
      case "uvec2":
        return al;
      case "uvec3":
        return or;
      case "uvec4":
        return ul;
      case "ivec2":
        return ye;
      case "ivec3":
        return nl;
      case "ivec4":
        return ll;
    }
  }
  /**
   * Creates and registers a reusable GLSL function that emulates the behavior of countTrailingZeros.
   *
   * @private
   * @param {string} method - The name of the function to create.
   * @param {string} elementType - The type of the input value.
   * @returns {Function} - The generated function
   */
  _createTrailingZerosBaseLayout(e, t) {
    const s = this._returnDataNode(t);
    return b(([i]) => {
      const a = E(0);
      this._resolveElementType(i, a, t);
      const n = f(a.bitAnd(fl(a))), o = bm(n).shiftRight(23).sub(127);
      return s(o);
    }).setLayout({
      name: e,
      type: t,
      inputs: [
        { name: "value", type: t }
      ]
    });
  }
  /**
   * Creates and registers a reusable GLSL function that emulates the behavior of countLeadingZeros.
   *
   * @private
   * @param {string} method - The name of the function to create.
   * @param {string} elementType - The type of the input value.
   * @returns {Function} - The generated function
   */
  _createLeadingZerosBaseLayout(e, t) {
    const s = this._returnDataNode(t);
    return b(([i]) => {
      W(i.equal(E(0)), () => E(32));
      const a = E(0), n = E(0);
      return this._resolveElementType(i, a, t), W(a.shiftRight(16).equal(0), () => {
        n.addAssign(16), a.shiftLeftAssign(16);
      }), W(a.shiftRight(24).equal(0), () => {
        n.addAssign(8), a.shiftLeftAssign(8);
      }), W(a.shiftRight(28).equal(0), () => {
        n.addAssign(4), a.shiftLeftAssign(4);
      }), W(a.shiftRight(30).equal(0), () => {
        n.addAssign(2), a.shiftLeftAssign(2);
      }), W(a.shiftRight(31).equal(0), () => {
        n.addAssign(1);
      }), s(n);
    }).setLayout({
      name: e,
      type: t,
      inputs: [
        { name: "value", type: t }
      ]
    });
  }
  /**
   * Creates and registers a reusable GLSL function that emulates the behavior of countOneBits.
   *
   * @private
   * @param {string} method - The name of the function to create.
   * @param {string} elementType - The type of the input value.
   * @returns {Function} - The generated function
   */
  _createOneBitsBaseLayout(e, t) {
    const s = this._returnDataNode(t);
    return b(([i]) => {
      const a = E(0);
      this._resolveElementType(i, a, t), a.assign(a.sub(a.shiftRight(E(1)).bitAnd(E(1431655765)))), a.assign(a.bitAnd(E(858993459)).add(a.shiftRight(E(2)).bitAnd(E(858993459))));
      const n = a.add(a.shiftRight(E(4))).bitAnd(E(252645135)).mul(E(16843009)).shiftRight(E(24));
      return s(n);
    }).setLayout({
      name: e,
      type: t,
      inputs: [
        { name: "value", type: t }
      ]
    });
  }
  /**
   * Creates and registers a reusable GLSL function that emulates the behavior of the specified bitcount function.
   * including considerations for component-wise bitcounts on vector type inputs.
   *
   * @private
   * @param {string} method - The name of the function to create.
   * @param {string} inputType - The type of the input value.
   * @param {number} typeLength - The vec length of the input value.
   * @param {Function} baseFn - The base function that operates on an individual component of the vector.
   * @returns {Function} - The alias function for the specified bitcount method.
   */
  _createMainLayout(e, t, s, i) {
    const a = this._returnDataNode(t);
    return b(([n]) => {
      if (s === 1)
        return a(i(n));
      {
        const o = a(0), l = ["x", "y", "z", "w"];
        for (let u = 0; u < s; u++) {
          const h = l[u];
          o[h].assign(i(n[h]));
        }
        return o;
      }
    }).setLayout({
      name: e,
      type: t,
      inputs: [
        { name: "value", type: t }
      ]
    });
  }
  setup(e) {
    const { method: t, aNode: s } = this, { renderer: i } = e;
    if (i.backend.isWebGPUBackend)
      return super.setup(e);
    const a = this.getInputType(e), n = e.getElementType(a), o = e.getTypeLength(a), l = `${t}_base_${n}`, u = `${t}_${a}`;
    let h = oa[l];
    if (h === void 0) {
      switch (t) {
        case pt.COUNT_LEADING_ZEROS: {
          h = this._createLeadingZerosBaseLayout(l, n);
          break;
        }
        case pt.COUNT_TRAILING_ZEROS: {
          h = this._createTrailingZerosBaseLayout(l, n);
          break;
        }
        case pt.COUNT_ONE_BITS: {
          h = this._createOneBitsBaseLayout(l, n);
          break;
        }
      }
      oa[l] = h;
    }
    let d = oa[u];
    return d === void 0 && (d = this._createMainLayout(u, a, o, h), oa[u] = d), b(() => d(
      s
    ))();
  }
}
pt.COUNT_TRAILING_ZEROS = "countTrailingZeros";
pt.COUNT_LEADING_ZEROS = "countLeadingZeros";
pt.COUNT_ONE_BITS = "countOneBits";
const rb = /* @__PURE__ */ L(pt, pt.COUNT_TRAILING_ZEROS).setParameterLength(1), ib = /* @__PURE__ */ L(pt, pt.COUNT_LEADING_ZEROS).setParameterLength(1), ab = /* @__PURE__ */ L(pt, pt.COUNT_ONE_BITS).setParameterLength(1), nb = /* @__PURE__ */ b(([r]) => {
  const e = r.toUint().mul(747796405).add(2891336453), t = e.shiftRight(e.shiftRight(28).add(4)).bitXor(e).mul(277803737);
  return t.shiftRight(22).bitXor(t).toFloat().mul(1 / 2 ** 32);
}), Uo = (r, e) => vt(j(4, r.mul(K(1, r))), e), ob = (r, e) => r.lessThan(0.5) ? Uo(r.mul(2), e).div(2) : K(1, Uo(j(K(1, r), 2), e).div(2)), lb = (r, e, t) => vt(Zt(vt(r, e), Ae(vt(r, e), vt(K(1, r), t))), 1 / e), ub = (r, e) => Qe(Aa.mul(e.mul(r).sub(1))).div(Aa.mul(e.mul(r).sub(1)));
class Kl extends we {
  static get type() {
    return "PackFloatNode";
  }
  /**
   *
   * @param {'snorm' | 'unorm' | 'float16'} encoding - The numeric encoding that describes how the float values are mapped to the integer range.
   * @param {Node} vectorNode - The vector node to be packed
   */
  constructor(e, t) {
    super(), this.vectorNode = t, this.encoding = e, this.isPackFloatNode = !0;
  }
  generateNodeType() {
    return "uint";
  }
  generate(e) {
    const t = this.vectorNode.getNodeType(e);
    return `${e.getFloatPackingMethod(this.encoding)}(${this.vectorNode.build(e, t)})`;
  }
}
const hb = /* @__PURE__ */ L(Kl, "snorm").setParameterLength(1), cb = /* @__PURE__ */ L(Kl, "unorm").setParameterLength(1), db = /* @__PURE__ */ L(Kl, "float16").setParameterLength(1);
class eu extends we {
  static get type() {
    return "UnpackFloatNode";
  }
  /**
   *
   * @param {'snorm' | 'unorm' | 'float16'} encoding - The numeric encoding that describes how the integer values are mapped to the float range
   * @param {Node} uintNode - The uint node to be unpacked
   */
  constructor(e, t) {
    super(), this.uintNode = t, this.encoding = e, this.isUnpackFloatNode = !0;
  }
  generateNodeType() {
    return "vec2";
  }
  generate(e) {
    const t = this.uintNode.getNodeType(e);
    return `${e.getFloatUnpackingMethod(this.encoding)}(${this.uintNode.build(e, t)})`;
  }
}
const pb = /* @__PURE__ */ L(eu, "snorm").setParameterLength(1), mb = /* @__PURE__ */ L(eu, "unorm").setParameterLength(1), gb = /* @__PURE__ */ L(eu, "float16").setParameterLength(1), ls = /* @__PURE__ */ b(([r]) => r.fract().sub(0.5).abs()).setLayout({
  name: "tri",
  type: "float",
  inputs: [
    { name: "x", type: "float" }
  ]
}), fb = /* @__PURE__ */ b(([r]) => N(ls(r.z.add(ls(r.y.mul(1)))), ls(r.z.add(ls(r.x.mul(1)))), ls(r.y.add(ls(r.x.mul(1)))))).setLayout({
  name: "tri3",
  type: "vec3",
  inputs: [
    { name: "p", type: "vec3" }
  ]
}), yb = /* @__PURE__ */ b(([r, e, t]) => {
  const s = N(r).toVar(), i = f(1.4).toVar(), a = f(0).toVar(), n = N(s).toVar();
  return le({ start: f(0), end: f(3), type: "float", condition: "<=" }, () => {
    const o = N(fb(n.mul(2))).toVar();
    s.addAssign(o.add(t.mul(f(0.1).mul(e)))), n.mulAssign(1.8), i.mulAssign(1.5), s.mulAssign(1.2);
    const l = f(ls(s.z.add(ls(s.x.add(ls(s.y)))))).toVar();
    a.addAssign(l.div(i)), n.addAssign(0.14);
  }), a;
}).setLayout({
  name: "triNoise3D",
  type: "float",
  inputs: [
    { name: "position", type: "vec3" },
    { name: "speed", type: "float" },
    { name: "time", type: "float" }
  ]
});
class xb extends k {
  static get type() {
    return "FunctionOverloadingNode";
  }
  /**
   * Constructs a new function overloading node.
   *
   * @param {Array<Function>} functionNodes - Array of `Fn` function definitions.
   * @param {...Node} parametersNodes - A list of parameter nodes.
   */
  constructor(e = [], ...t) {
    super(), this.functionNodes = e, this.parametersNodes = t, this._candidateFn = null, this.global = !0;
  }
  /**
   * This method is overwritten since the node type is inferred from
   * the function's return type.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The node type.
   */
  generateNodeType(e) {
    return this.getCandidateFn(e).shaderNode.layout.type;
  }
  /**
   * Returns the candidate function for the current parameters.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {FunctionNode} The candidate function.
   */
  getCandidateFn(e) {
    const t = this.parametersNodes;
    let s = this._candidateFn;
    if (s === null) {
      let i = null, a = -1;
      for (const n of this.functionNodes) {
        const o = n.shaderNode.layout;
        if (o === null)
          throw new Error("THREE.FunctionOverloadingNode: FunctionNode must be a layout.");
        const l = o.inputs;
        if (t.length === l.length) {
          let u = 0;
          for (let h = 0; h < t.length; h++) {
            const d = t[h], p = l[h];
            d.getNodeType(e) === p.type && u++;
          }
          u > a && (i = n, a = u);
        }
      }
      this._candidateFn = s = i;
    }
    return s;
  }
  /**
   * Sets up the node for the current parameters.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Node} The setup node.
   */
  setup(e) {
    return this.getCandidateFn(e)(...this.parametersNodes);
  }
}
const bb = /* @__PURE__ */ Y(xb), De = (r) => (...e) => bb(r, ...e), Jr = /* @__PURE__ */ q(0).setGroup(H).onRenderUpdate((r) => r.time), vb = /* @__PURE__ */ q(0).setGroup(H).onRenderUpdate((r) => r.deltaTime), vm = /* @__PURE__ */ q(0, "uint").setGroup(H).onRenderUpdate((r) => r.frameId), Tb = (r = Jr) => r.add(0.75).mul(Math.PI * 2).sin().mul(0.5).add(0.5), wb = (r = Jr) => r.fract().round(), Nb = (r = Jr) => r.add(0.5).fract().mul(2).sub(1).abs(), Mb = (r = Jr) => r.fract();
function Sb(r, e = null) {
  return Fs(e, { getUV: typeof r == "function" ? r : () => r });
}
const _b = /* @__PURE__ */ b(([r, e, t = B(0.5)]) => Ql(r.sub(t), e).add(t)), Ab = /* @__PURE__ */ b(([r, e, t = B(0.5)]) => {
  const s = r.sub(t), i = s.dot(s), a = i.mul(i).mul(e);
  return r.add(s.mul(a));
}), Vb = /* @__PURE__ */ b(({ position: r = null, horizontal: e = !0, vertical: t = !1 }) => {
  let s;
  r !== null ? (s = hs.toVar(), s[3][0] = r.x, s[3][1] = r.y, s[3][2] = r.z) : s = hs;
  const i = dr.mul(s);
  return Dr(e) && (i[0][0] = hs[0].length(), i[0][1] = 0, i[0][2] = 0), Dr(t) && (i[1][0] = 0, i[1][1] = hs[1].length(), i[1][2] = 0), i[2][0] = 0, i[2][1] = 0, i[2][2] = 1, Ot.mul(i).mul(Te);
}), Cb = /* @__PURE__ */ b(([r = null]) => {
  const e = La();
  return La(Yl(r)).sub(e).lessThan(0).select(hr, r);
}), zb = /* @__PURE__ */ b(([r, e = ae(), t = f(0)]) => {
  const s = r.x, i = r.y, a = t.mod(s.mul(i)).floor(), n = a.mod(s), o = i.sub(a.add(1).div(s).ceil()), l = r.reciprocal(), u = B(n, o);
  return e.add(u).mul(l);
}), Tm = /* @__PURE__ */ b(([r, e = null, t = null, s = f(1), i = Te, a = $e]) => {
  let n = a.abs().normalize();
  n = n.div(n.dot(N(1)));
  const o = i.yz.mul(s), l = i.zx.mul(s), u = i.xy.mul(s), h = r.value, d = e !== null ? e.value : h, p = t !== null ? t.value : h, m = xe(h, o).mul(n.x), g = xe(d, l).mul(n.y), y = xe(p, u).mul(n.z);
  return Ae(m, g, y);
}), Rb = (...r) => Tm(...r), Sr = new mf(), Gs = new M(), _r = new M(), ro = new M(), ni = new de(), la = new M(0, 0, -1), Gt = new tt(), oi = new M(), ua = new M(), li = new tt(), ha = new _e(), Oa = new Ti(), Eb = hr.flipX();
Oa.depthTexture = new Hr(1, 1);
let ca = !1;
class tu extends fs {
  static get type() {
    return "ReflectorNode";
  }
  /**
   * Constructs a new reflector node.
   *
   * @param {Object} [parameters={}] - An object holding configuration parameters.
   * @param {Object3D} [parameters.target=new Object3D()] - The 3D object the reflector is linked to.
   * @param {number} [parameters.resolutionScale=1] - The resolution scale.
   * @param {boolean} [parameters.generateMipmaps=false] - Whether mipmaps should be generated or not.
   * @param {boolean} [parameters.bounces=true] - Whether reflectors can render other reflector nodes or not.
   * @param {boolean} [parameters.depth=false] - Whether depth data should be generated or not.
   * @param {number} [parameters.samples] - Anti-Aliasing samples of the internal render-target.
   * @param {TextureNode} [parameters.defaultTexture] - The default texture node.
   * @param {ReflectorBaseNode} [parameters.reflector] - The reflector base node.
   */
  constructor(e = {}) {
    super(e.defaultTexture || Oa.texture, Eb), this._reflectorBaseNode = e.reflector || new Lb(this, e), this._depthNode = null, this.setUpdateMatrix(!1);
  }
  /**
   * A reference to the internal reflector node.
   *
   * @type {ReflectorBaseNode}
   */
  get reflector() {
    return this._reflectorBaseNode;
  }
  /**
   * A reference to 3D object the reflector is linked to.
   *
   * @type {Object3D}
   */
  get target() {
    return this._reflectorBaseNode.target;
  }
  /**
   * Returns a node representing the mirror's depth. That can be used
   * to implement more advanced reflection effects like distance attenuation.
   *
   * @return {Node} The depth node.
   */
  getDepthNode() {
    if (this._depthNode === null) {
      if (this._reflectorBaseNode.depth !== !0)
        throw new Error("THREE.ReflectorNode: Depth node can only be requested when the reflector is created with { depth: true }. ");
      this._depthNode = new tu({
        defaultTexture: Oa.depthTexture,
        reflector: this._reflectorBaseNode
      });
    }
    return this._depthNode;
  }
  setup(e) {
    return e.object.isQuadMesh || this._reflectorBaseNode.build(e), super.setup(e);
  }
  clone() {
    const e = new this.constructor(this.reflectorNode);
    return e.uvNode = this.uvNode, e.levelNode = this.levelNode, e.biasNode = this.biasNode, e.sampler = this.sampler, e.depthNode = this.depthNode, e.compareNode = this.compareNode, e.gradNode = this.gradNode, e.gatherNode = this.gatherNode, e.offsetNode = this.offsetNode, e._reflectorBaseNode = this._reflectorBaseNode, e;
  }
  /**
   * Frees internal resources. Should be called when the node is no longer in use.
   */
  dispose() {
    super.dispose(), this._reflectorBaseNode.dispose();
  }
}
class Lb extends k {
  static get type() {
    return "ReflectorBaseNode";
  }
  /**
   * Constructs a new reflector base node.
   *
   * @param {TextureNode} textureNode - Represents the rendered reflections as a texture node.
   * @param {Object} [parameters={}] - An object holding configuration parameters.
   * @param {Object3D} [parameters.target=new Object3D()] - The 3D object the reflector is linked to.
   * @param {number} [parameters.resolutionScale=1] - The resolution scale.
   * @param {boolean} [parameters.generateMipmaps=false] - Whether mipmaps should be generated or not.
   * @param {boolean} [parameters.bounces=true] - Whether reflectors can render other reflector nodes or not.
   * @param {boolean} [parameters.depth=false] - Whether depth data should be generated or not.
   * @param {number} [parameters.samples] - Anti-Aliasing samples of the internal render-target.
   */
  constructor(e, t = {}) {
    super();
    const {
      target: s = new Pt(),
      resolutionScale: i = 1,
      generateMipmaps: a = !1,
      bounces: n = !0,
      depth: o = !1,
      samples: l = 0
    } = t;
    this.textureNode = e, this.target = s, this.resolutionScale = i, t.resolution !== void 0 && (Be('ReflectorNode: The "resolution" parameter has been renamed to "resolutionScale".'), this.resolutionScale = t.resolution), this.generateMipmaps = a, this.bounces = n, this.depth = o, this.samples = l, this.updateBeforeType = n ? Q.RENDER : Q.FRAME, this.virtualCameras = /* @__PURE__ */ new WeakMap(), this.renderTargets = /* @__PURE__ */ new Map(), this.forceUpdate = !1, this.hasOutput = !1;
  }
  /**
   * Updates the resolution of the internal render target.
   *
   * @private
   * @param {RenderTarget} renderTarget - The render target to resize.
   * @param {Renderer} renderer - The renderer that is used to determine the new size.
   */
  _updateResolution(e, t) {
    const s = this.resolutionScale;
    t.getDrawingBufferSize(ha), e.setSize(Math.round(ha.width * s), Math.round(ha.height * s));
  }
  setup(e) {
    return this._updateResolution(Oa, e.renderer), super.setup(e);
  }
  /**
   * Frees internal resources. Should be called when the node is no longer in use.
   */
  dispose() {
    super.dispose();
    for (const e of this.renderTargets.values())
      e.dispose();
  }
  /**
   * Returns a virtual camera for the given camera. The virtual camera is used to
   * render the scene from the reflector's view so correct reflections can be produced.
   *
   * @param {Camera} camera - The scene's camera.
   * @return {Camera} The corresponding virtual camera.
   */
  getVirtualCamera(e) {
    let t = this.virtualCameras.get(e);
    return t === void 0 && (t = e.clone(), this.virtualCameras.set(e, t)), t;
  }
  /**
   * Returns a render target for the given camera. The reflections are rendered
   * into this render target.
   *
   * @param {Camera} camera - The scene's camera.
   * @return {RenderTarget} The render target.
   */
  getRenderTarget(e) {
    let t = this.renderTargets.get(e);
    return t === void 0 && (t = new Ti(0, 0, { type: us, samples: this.samples }), this.generateMipmaps === !0 && (t.texture.minFilter = xg, t.texture.generateMipmaps = !0), this.depth === !0 && (t.depthTexture = new Hr()), this.renderTargets.set(e, t)), t;
  }
  updateBefore(e) {
    if (this.bounces === !1 && ca) return !1;
    ca = !0;
    const { scene: t, camera: s, renderer: i, material: a } = e, { target: n } = this, o = this.getVirtualCamera(s), l = this.getRenderTarget(o);
    i.getDrawingBufferSize(ha), this._updateResolution(l, i), _r.setFromMatrixPosition(n.matrixWorld), ro.setFromMatrixPosition(s.matrixWorld), ni.extractRotation(n.matrixWorld), Gs.set(0, 0, 1), Gs.applyMatrix4(ni), oi.subVectors(_r, ro);
    const u = oi.dot(Gs) > 0;
    let h = !1;
    if (u === !0 && this.forceUpdate === !1) {
      if (this.hasOutput === !1) {
        ca = !1;
        return;
      }
      h = !0;
    }
    oi.reflect(Gs).negate(), oi.add(_r), ni.extractRotation(s.matrixWorld), la.set(0, 0, -1), la.applyMatrix4(ni), la.add(ro), ua.subVectors(_r, la), ua.reflect(Gs).negate(), ua.add(_r), o.coordinateSystem = s.coordinateSystem, o.position.copy(oi), o.up.set(0, 1, 0), o.up.applyMatrix4(ni), o.up.reflect(Gs), o.lookAt(ua), o.near = s.near, o.far = s.far, o.updateMatrixWorld(), o.projectionMatrix.copy(s.projectionMatrix), Sr.setFromNormalAndCoplanarPoint(Gs, _r), Sr.applyMatrix4(o.matrixWorldInverse), Gt.set(Sr.normal.x, Sr.normal.y, Sr.normal.z, Sr.constant);
    const d = o.projectionMatrix;
    li.x = (Math.sign(Gt.x) + d.elements[8]) / d.elements[0], li.y = (Math.sign(Gt.y) + d.elements[9]) / d.elements[5], li.z = -1, li.w = (1 + d.elements[10]) / d.elements[14], Gt.multiplyScalar(1 / Gt.dot(li));
    const p = 0;
    d.elements[2] = Gt.x, d.elements[6] = Gt.y, d.elements[10] = i.coordinateSystem === Ls ? Gt.z - p : Gt.z + 1 - p, d.elements[14] = Gt.w, this.textureNode.value = l.texture, this.depth === !0 && (this.textureNode.getDepthNode().value = l.depthTexture), a.visible = !1;
    const m = i.getRenderTarget(), g = i.getMRT(), y = i.autoClear;
    i.setMRT(null), i.setRenderTarget(l), i.autoClear = !0;
    const v = t.name;
    t.name = (t.name || "Scene") + " [ Reflector ]", h ? (i.clear(), this.hasOutput = !1) : (i.render(t, o), this.hasOutput = !0), t.name = v, i.setMRT(g), i.setRenderTarget(m), i.autoClear = y, a.visible = !0, ca = !1, this.forceUpdate = !1;
  }
  /**
   * The resolution scale.
   *
   * @deprecated
   * @type {number}
   * @default {1}
   */
  get resolution() {
    return Be('ReflectorNode: The "resolution" property has been renamed to "resolutionScale".'), this.resolutionScale;
  }
  set resolution(e) {
    Be('ReflectorNode: The "resolution" property has been renamed to "resolutionScale".'), this.resolutionScale = e;
  }
}
const Ib = (r) => new tu(r), io = /* @__PURE__ */ new $h(-1, 1, 1, -1, 0, 1);
class Ob extends ar {
  /**
   * Constructs a new quad geometry.
   *
   * @param {boolean} [flipY=false] - Whether the uv coordinates should be flipped along the vertical axis or not.
   */
  constructor(e = !1) {
    super();
    const t = e === !1 ? [0, -1, 0, 1, 2, 1] : [0, 2, 0, 0, 2, 0];
    this.setAttribute("position", new Ir([-1, 3, 0, -1, -1, 0, 3, -1, 0], 3)), this.setAttribute("uv", new Ir(t, 2));
  }
}
const Pb = /* @__PURE__ */ new Ob();
class wm extends Sa {
  /**
   * Constructs a new quad mesh.
   *
   * @param {?Material} [material=null] - The material to render the quad mesh with.
   */
  constructor(e = null) {
    super(Pb, e), this.camera = io, this.isQuadMesh = !0;
  }
  /**
   * Async version of `render()`.
   *
   * @async
   * @deprecated
   * @param {Renderer} renderer - The renderer.
   * @return {Promise} A Promise that resolves when the render has been finished.
   */
  async renderAsync(e) {
    Be('QuadMesh: "renderAsync()" has been deprecated. Use "render()" and "await renderer.init();" when creating the renderer.'), await e.init(), e.render(this, io);
  }
  /**
   * Renders the quad mesh
   *
   * @param {Renderer} renderer - The renderer.
   */
  render(e) {
    e.render(this, io);
  }
}
const Fb = /* @__PURE__ */ new _e();
class Bb extends fs {
  static get type() {
    return "RTTNode";
  }
  /**
   * Constructs a new RTT node.
   *
   * @param {Node} node - The node to render a texture with.
   * @param {?number} [width=null] - The width of the internal render target. If not width is applied, the render target is automatically resized.
   * @param {?number} [height=null] - The height of the internal render target.
   * @param {Object} [options={type:HalfFloatType}] - The options for the internal render target.
   */
  constructor(e, t = null, s = null, i = { type: us }) {
    const a = new Ti(t, s, i);
    super(a.texture, ae()), this.isRTTNode = !0, this.node = e, this.width = t, this.height = s, this.renderTarget = a, this.textureNeedsUpdate = !0, this.autoUpdate = !0, this._resolutionScale = 1, this._rttNode = null, this._quadMesh = new wm(new jr()), this.updateBeforeType = Q.RENDER;
  }
  /**
   * Whether the internal render target should automatically be resized or not.
   *
   * @type {boolean}
   * @readonly
   * @default true
   */
  get autoResize() {
    return this.width === null;
  }
  setup(e) {
    return this._rttNode = this.node.context(e.getSharedContext()), this._quadMesh.material.name = "RTT", this._quadMesh.material.needsUpdate = !0, super.setup(e);
  }
  /**
   * Sets the size of the internal render target
   *
   * @param {number} width - The width to set.
   * @param {number} height - The width to set.
   */
  setSize(e, t) {
    const s = Math.floor(e * this._resolutionScale), i = Math.floor(t * this._resolutionScale);
    this.renderTarget.setSize(s, i), this.textureNeedsUpdate = !0;
  }
  /**
   * Sets the resolution scale.
   * The resolution scale is a factor that is multiplied with the renderer's width and height.
   *
   * @param {number} resolutionScale - The resolution scale to set. A value of `1` means full resolution.
   * @returns {RTTNode} A reference to this node.
   */
  setResolutionScale(e) {
    return this._resolutionScale = e, this.autoResize === !1 && this.setSize(this.width, this.height), this;
  }
  /**
   * Gets the resolution scale.
   *
   * @returns {number} The resolution scale.
   */
  getResolutionScale() {
    return this._resolutionScale;
  }
  updateBefore({ renderer: e }) {
    if (this.textureNeedsUpdate === !1 && this.autoUpdate === !1) return;
    this.textureNeedsUpdate = !1;
    const t = e.getRenderTarget();
    if (this.autoResize === !0) {
      const i = e.getDrawingBufferSize(Fb), a = Math.floor(i.width * this._resolutionScale), n = Math.floor(i.height * this._resolutionScale);
      (a !== this.renderTarget.width || n !== this.renderTarget.height) && (this.renderTarget.setSize(a, n), this.textureNeedsUpdate = !0);
    }
    let s = "RTT";
    this.node.name && (s = this.node.name + " [ " + s + " ]"), this._quadMesh.material.fragmentNode = this._rttNode, this._quadMesh.name = s, e.setRenderTarget(this.renderTarget), this._quadMesh.render(e), e.setRenderTarget(t);
  }
  clone() {
    const e = new fs(this.value, this.uvNode, this.levelNode);
    return e.sampler = this.sampler, e.referenceNode = this, e;
  }
}
const Nm = (r, ...e) => new Bb(U(r), ...e), Ub = (r, ...e) => r.isSampleNode || r.isTextureNode ? r : r.isPassNode ? r.getTextureNode() : Nm(r, ...e), zr = /* @__PURE__ */ b(([r, e, t], s) => {
  let i;
  s.renderer.coordinateSystem === Ls ? (r = B(r.x, r.y.oneMinus()).mul(2).sub(1), i = D(N(r, e), 1)) : i = D(N(r.x, r.y.oneMinus(), e).mul(2).sub(1), 1);
  const a = D(t.mul(i));
  return a.xyz.div(a.w);
}), kb = /* @__PURE__ */ b(([r, e]) => {
  const t = e.mul(D(r, 1)), s = t.xy.div(t.w).mul(0.5).add(0.5).toVar();
  return B(s.x, s.y.oneMinus());
}), Db = /* @__PURE__ */ b(([r, e, t]) => {
  const s = sr(ve(e)), i = ye(r.mul(s)).toVar(), a = ve(e, i).toVar(), n = ve(e, i.sub(ye(2, 0))).toVar(), o = ve(e, i.sub(ye(1, 0))).toVar(), l = ve(e, i.add(ye(1, 0))).toVar(), u = ve(e, i.add(ye(2, 0))).toVar(), h = ve(e, i.add(ye(0, 2))).toVar(), d = ve(e, i.add(ye(0, 1))).toVar(), p = ve(e, i.sub(ye(0, 1))).toVar(), m = ve(e, i.sub(ye(0, 2))).toVar(), g = he(K(f(2).mul(o).sub(n), a)).toVar(), y = he(K(f(2).mul(l).sub(u), a)).toVar(), v = he(K(f(2).mul(d).sub(h), a)).toVar(), w = he(K(f(2).mul(p).sub(m), a)).toVar(), _ = zr(r, a, t).toVar(), C = g.lessThan(y).select(_.sub(zr(r.sub(B(f(1).div(s.x), 0)), o, t)), _.negate().add(zr(r.add(B(f(1).div(s.x), 0)), l, t))), V = v.lessThan(w).select(_.sub(zr(r.add(B(0, f(1).div(s.y))), d, t)), _.negate().add(zr(r.sub(B(0, f(1).div(s.y))), p, t)));
  return it(gs(C, V));
}), su = b(([r]) => Bt(f(52.9829189).mul(Bt(St(r, B(0.06711056, 583715e-8)))))).setLayout({
  name: "interleavedGradientNoise",
  type: "float",
  inputs: [
    { name: "position", type: "vec2" }
  ]
}), It = b(([r, e, t]) => {
  const s = f(2.399963229728653), i = et(f(r).add(0.5).div(f(e))), a = f(r).mul(s).add(t);
  return B(Rt(a), Qe(a)).mul(i);
}).setLayout({
  name: "vogelDiskSample",
  type: "vec2",
  inputs: [
    { name: "sampleIndex", type: "int" },
    { name: "samplesCount", type: "int" },
    { name: "phi", type: "float" }
  ]
});
class Wb extends k {
  /**
   * Returns the type of the node.
   *
   * @type {string}
   * @readonly
   * @static
   */
  static get type() {
    return "SampleNode";
  }
  /**
   * Creates an instance of SampleNode.
   *
   * @param {Function} callback - The function to be called when sampling. Should accept a UV node and return a value.
   * @param {?Node<vec2>} [uvNode=null] - The UV node to be used in the texture sampling.
   */
  constructor(e, t = null) {
    super(), this.callback = e, this.uvNode = t, this.isSampleNode = !0;
  }
  /**
   * Sets up the node by sampling with the default UV accessor.
   *
   * @returns {Node} The result of the callback function when called with the UV node.
   */
  setup() {
    return this.sample(ae());
  }
  /**
   * Calls the callback function with the provided UV node.
   *
   * @param {Node<vec2>} uv - The UV node or value to be passed to the callback.
   * @returns {Node} The result of the callback function.
   */
  sample(e) {
    return this.callback(e);
  }
}
const qb = (r, e = null) => new Wb(r, U(e));
class jb extends Or {
  /**
   * Constructs a new storage instanced buffer attribute.
   *
   * @param {number|TypedArray} count - The item count. It is also valid to pass a typed array as an argument.
   * The subsequent parameters are then obsolete.
   * @param {number} itemSize - The item size.
   * @param {TypedArray.constructor} [typeClass=Float32Array] - A typed array constructor.
   */
  constructor(e, t, s = Float32Array) {
    const i = ArrayBuffer.isView(e) ? e : new s(e * t);
    super(i, t), this.isStorageInstancedBufferAttribute = !0;
  }
}
class Gb extends wt {
  /**
   * Constructs a new storage buffer attribute.
   *
   * @param {number|TypedArray} count - The item count. It is also valid to pass a typed array as an argument.
   * The subsequent parameters are then obsolete.
   * @param {number} itemSize - The item size.
   * @param {TypedArray.constructor} [typeClass=Float32Array] - A typed array constructor.
   */
  constructor(e, t, s = Float32Array) {
    const i = ArrayBuffer.isView(e) ? e : new s(e * t);
    super(i, t), this.isStorageBufferAttribute = !0;
  }
}
const Hb = (r, e = "float") => {
  let t, s;
  e.isStructTypeNode === !0 ? (t = e.getLength(), s = _a("float")) : (t = Jh(e), s = _a(e));
  const i = new Gb(r, t, s);
  return Es(i, e, r);
}, Xb = (r, e = "float") => {
  let t, s;
  e.isStructTypeNode === !0 ? (t = e.getLength(), s = _a("float")) : (t = Jh(e), s = _a(e));
  const i = new jb(r, t, s);
  return Es(i, e, i.count);
};
class $b extends k {
  static get type() {
    return "PointUVNode";
  }
  /**
   * Constructs a new point uv node.
   */
  constructor() {
    super("vec2"), this.isPointUVNode = !0;
  }
  generate() {
    return "vec2( gl_PointCoord.x, 1.0 - gl_PointCoord.y )";
  }
}
const Yb = /* @__PURE__ */ O($b), ao = /* @__PURE__ */ new de(), Zb = /* @__PURE__ */ q(0).setGroup(H).onRenderUpdate(({ scene: r }) => r.backgroundBlurriness), Jb = /* @__PURE__ */ q(1).setGroup(H).onRenderUpdate(({ scene: r }) => r.backgroundIntensity), Qb = /* @__PURE__ */ q(new de()).setGroup(H).onRenderUpdate(({ scene: r }) => {
  const e = r.background;
  return e !== null && e.isTexture && e.mapping !== Do || r.backgroundNode && r.backgroundNode.isNode ? ao.makeRotationFromEuler(r.backgroundRotation).transpose() : ao.identity(), ao;
});
class Mm extends fs {
  static get type() {
    return "StorageTextureNode";
  }
  /**
   * Constructs a new storage texture node.
   *
   * @param {StorageTexture} value - The storage texture.
   * @param {Node<vec2|vec3>} uvNode - The uv node.
   * @param {?Node} [storeNode=null] - The value node that should be stored in the texture.
   */
  constructor(e, t, s = null) {
    super(e, t), this.storeNode = s, this.mipLevel = 0, this.isStorageTextureNode = !0, this.access = Ht.WRITE_ONLY;
  }
  /**
   * Overwrites the default implementation to return a fixed value `'storageTexture'`.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The input type.
   */
  getInputType() {
    return "storageTexture";
  }
  /**
   * Overwrites the default implementation since storage texture
   * coordinates are texel coordinates and should not be transformed
   * by the texture uv matrix.
   *
   * @param {Node} uvNode - The uv node.
   * @return {Node} The unmodified uv node.
   */
  getTransformedUV(e) {
    return e;
  }
  setup(e) {
    super.setup(e);
    const t = e.getNodeProperties(this);
    return t.storeNode = this.storeNode, t;
  }
  /**
   * Defines the node access.
   *
   * @param {string} value - The node access.
   * @return {StorageTextureNode} A reference to this node.
   */
  setAccess(e) {
    return this.access = e, this;
  }
  /**
   * Sets the mip level to write to.
   *
   * @param {number} level - The mip level.
   * @return {StorageTextureNode} A reference to this node.
   */
  setMipLevel(e) {
    return this.mipLevel = e, this;
  }
  /**
   * Generates the code snippet of the storage node. If no `storeNode`
   * is defined, the texture node is generated as normal texture.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {string} output - The current output.
   * @return {string} The generated code snippet.
   */
  generate(e, t) {
    return this.storeNode !== null ? (this.generateStore(e), "") : super.generate(e, t);
  }
  /**
   * Generates the snippet for the storage texture.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {string} textureProperty - The texture property.
   * @param {string} uvSnippet - The uv snippet.
   * @param {?string} levelSnippet - The level snippet.
   * @param {?string} biasSnippet - The bias snippet.
   * @param {?string} depthSnippet - The depth snippet.
   * @param {?string} compareSnippet - The compare snippet.
   * @param {?Array<string>} gradSnippet - The grad snippet.
   * @param {?string} offsetSnippet - The offset snippet.
   * @return {string} The generated code snippet.
   */
  generateSnippet(e, t, s, i, a, n, o, l, u) {
    const h = this.value;
    return e.generateStorageTextureLoad(h, t, s, i, n, u);
  }
  /**
   * Convenience method for configuring a read/write node access.
   *
   * @return {StorageTextureNode} A reference to this node.
   */
  toReadWrite() {
    return this.setAccess(Ht.READ_WRITE);
  }
  /**
   * Convenience method for configuring a read-only node access.
   *
   * @return {StorageTextureNode} A reference to this node.
   */
  toReadOnly() {
    return this.setAccess(Ht.READ_ONLY);
  }
  /**
   * Convenience method for configuring a write-only node access.
   *
   * @return {StorageTextureNode} A reference to this node.
   */
  toWriteOnly() {
    return this.setAccess(Ht.WRITE_ONLY);
  }
  /**
   * Stores a value in this storage texture at the given coordinates.
   *
   * @param {Node<vec2|vec3>} uvNode - The storage texture coordinates.
   * @param {?Node} [storeNode=null] - The value node that should be stored in the texture.
   * @return {StorageTextureNode} A storage texture node representing the store operation.
   */
  store(e, t) {
    const s = this.clone();
    return s.referenceNode = this.getBase(), s.uvNode = e, s.storeNode = t, t !== null && s.toStack(), s;
  }
  /**
   * Generates the code snippet of the storage texture node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */
  generateStore(e) {
    const t = e.getNodeProperties(this), { uvNode: s, storeNode: i, depthNode: a } = t, n = super.generate(e, "property"), o = s.build(e, this.value.is3DTexture === !0 ? "uvec3" : "uvec2"), l = i.build(e, "vec4"), u = a ? a.build(e, "int") : null, h = e.generateTextureStore(this.value, n, o, u, l);
    e.addLineFlowCode(h, this);
  }
  clone() {
    const e = super.clone();
    return e.storeNode = this.storeNode, e.mipLevel = this.mipLevel, e.access = this.access, e;
  }
}
const Sm = /* @__PURE__ */ Y(Mm).setParameterLength(1, 3), Kb = (r, e, t) => {
  let s;
  return r.isStorageTextureNode === !0 ? s = r.store(e, t) : (s = Sm(r, e, t), t !== null && s.toStack()), s;
};
class ev extends Mm {
  static get type() {
    return "StorageTexture3DNode";
  }
  /**
   * Constructs a new 3D storage texture node.
   *
   * @param {Storage3DTexture} value - The 3D storage texture.
   * @param {Node<vec3>} uvNode - The uv node.
   * @param {?Node} [storeNode=null] - The value node that should be stored in the texture.
   */
  constructor(e, t, s = null) {
    super(e, t, s), this.isStorageTexture3DNode = !0;
  }
  /**
   * Returns a default uv node which is in context of 3D textures a three-dimensional
   * uv node.
   *
   * @return {Node<vec3>} The default uv node.
   */
  getDefaultUV() {
    return N(0.5, 0.5, 0.5);
  }
  /**
   * Overwritten with an empty implementation since the `updateMatrix` flag is ignored
   * for 3D textures. The uv transformation matrix is not applied to 3D textures.
   *
   * @param {boolean} value - The update toggle.
   */
  setUpdateMatrix() {
  }
  // Ignore .updateMatrix for 3d TextureNode
  /**
   * Generates the uv code snippet.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {Node} uvNode - The uv node to generate code for.
   * @return {string} The generated code snippet.
   */
  generateUV(e, t) {
    return t.build(e, this.sampler === !0 ? "vec3" : "ivec3");
  }
  /**
   * Generates the offset code snippet.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {Node} offsetNode - The offset node to generate code for.
   * @return {string} The generated code snippet.
   */
  generateOffset(e, t) {
    return t.build(e, "ivec3");
  }
}
const tv = /* @__PURE__ */ Y(ev).setParameterLength(1, 3), sv = b(({ texture: r, uv: e }) => {
  const t = N().toVar();
  return W(e.x.lessThan(1e-4), () => {
    t.assign(N(1, 0, 0));
  }).ElseIf(e.y.lessThan(1e-4), () => {
    t.assign(N(0, 1, 0));
  }).ElseIf(e.z.lessThan(1e-4), () => {
    t.assign(N(0, 0, 1));
  }).ElseIf(e.x.greaterThan(1 - 1e-4), () => {
    t.assign(N(-1, 0, 0));
  }).ElseIf(e.y.greaterThan(1 - 1e-4), () => {
    t.assign(N(0, -1, 0));
  }).ElseIf(e.z.greaterThan(1 - 1e-4), () => {
    t.assign(N(0, 0, -1));
  }).Else(() => {
    const s = r.sample(e.add(N(-0.01, 0, 0))).r.sub(r.sample(e.add(N(0.01, 0, 0))).r), i = r.sample(e.add(N(0, -0.01, 0))).r.sub(r.sample(e.add(N(0, 0.01, 0))).r), a = r.sample(e.add(N(0, 0, -0.01))).r.sub(r.sample(e.add(N(0, 0, 0.01))).r);
    t.assign(N(s, i, a));
  }), t.normalize();
});
class rv extends fs {
  static get type() {
    return "Texture3DNode";
  }
  /**
   * Constructs a new 3D texture node.
   *
   * @param {Data3DTexture} value - The 3D texture.
   * @param {?Node<vec2|vec3>} [uvNode=null] - The uv node.
   * @param {?Node<int>} [levelNode=null] - The level node.
   */
  constructor(e, t = null, s = null) {
    super(e, t, s), this.isTexture3DNode = !0;
  }
  /**
   * Overwrites the default implementation to return a fixed value `'texture3D'`.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The input type.
   */
  getInputType() {
    return "texture3D";
  }
  /**
   * Returns a default uv node which is in context of 3D textures a three-dimensional
   * uv node.
   *
   * @return {Node<vec3>} The default uv node.
   */
  getDefaultUV() {
    return N(0.5, 0.5, 0.5);
  }
  /**
   * Overwritten with an empty implementation since the `updateMatrix` flag is ignored
   * for 3D textures. The uv transformation matrix is not applied to 3D textures.
   *
   * @param {boolean} value - The update toggle.
   */
  setUpdateMatrix() {
  }
  // Ignore .updateMatrix for 3d TextureNode
  /**
   * Generates the uv code snippet.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {Node} uvNode - The uv node to generate code for.
   * @return {string} The generated code snippet.
   */
  generateUV(e, t) {
    return t.build(e, this.sampler === !0 ? "vec3" : "ivec3");
  }
  /**
   * Generates the offset code snippet.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {Node} offsetNode - The offset node to generate code for.
   * @return {string} The generated code snippet.
   */
  generateOffset(e, t) {
    return t.build(e, "ivec3");
  }
  /**
   * Computes the normal for the given uv. These texture coordiantes represent a
   * position inside the 3D texture. Unlike geometric normals, this normal
   * represents a slope or gradient of scalar data inside the 3D texture.
   *
   * @param {Node<vec3>} uvNode - The uv node that defines a position in the 3D texture.
   * @return {Node<vec3>} The normal representing the slope/gradient in the data.
   */
  normal(e) {
    return sv({ texture: this, uv: e });
  }
}
const ru = /* @__PURE__ */ Y(rv).setParameterLength(1, 3), iv = (...r) => ru(...r).setSampler(!1), av = (r, e, t) => ru(r, e).level(t);
class nv extends en {
  static get type() {
    return "UserDataNode";
  }
  /**
   * Constructs a new user data node.
   *
   * @param {string} property - The property name that should be referenced by the node.
   * @param {string} inputType - The node data type of the reference.
   * @param {?Object} [userData=null] - A reference to the `userData` object. If not provided, the `userData` property of the 3D object that uses the node material is evaluated.
   */
  constructor(e, t, s = null) {
    super(e, t, s), this.userData = s;
  }
  /**
   * Overwritten to make sure {@link ReferenceNode#reference} points to the correct
   * `userData` field.
   *
   * @param {(NodeFrame|NodeBuilder)} state - The current state to evaluate.
   * @return {Object} A reference to the `userData` field.
   */
  updateReference(e) {
    return this.reference = this.userData !== null ? this.userData : e.object.userData, this.reference;
  }
}
const ov = (r, e, t) => new nv(r, e, t), xh = /* @__PURE__ */ new WeakMap();
class lv extends we {
  static get type() {
    return "VelocityNode";
  }
  /**
   * Constructs a new vertex color node.
   */
  constructor() {
    super("vec2"), this.projectionMatrix = null, this.updateType = Q.OBJECT, this.updateAfterType = Q.OBJECT, this.previousModelWorldMatrix = q(new de()), this.previousProjectionMatrix = q(new de()).setGroup(H), this.previousCameraViewMatrix = q(new de());
  }
  /**
   * Sets the given projection matrix.
   *
   * @param {Matrix4} projectionMatrix - The projection matrix to set.
   */
  setProjectionMatrix(e) {
    this.projectionMatrix = e;
  }
  /**
   * Updates velocity specific uniforms.
   *
   * @param {NodeFrame} frame - A reference to the current node frame.
   */
  update({ frameId: e, camera: t, object: s }) {
    const i = bh(s);
    this.previousModelWorldMatrix.value.copy(i);
    const a = _m(t);
    a.frameId !== e && (a.frameId = e, a.previousProjectionMatrix === void 0 ? (a.previousProjectionMatrix = new de(), a.previousCameraViewMatrix = new de(), a.currentProjectionMatrix = new de(), a.currentCameraViewMatrix = new de(), a.previousProjectionMatrix.copy(this.projectionMatrix || t.projectionMatrix), a.previousCameraViewMatrix.copy(t.matrixWorldInverse)) : (a.previousProjectionMatrix.copy(a.currentProjectionMatrix), a.previousCameraViewMatrix.copy(a.currentCameraViewMatrix)), a.currentProjectionMatrix.copy(this.projectionMatrix || t.projectionMatrix), a.currentCameraViewMatrix.copy(t.matrixWorldInverse), this.previousProjectionMatrix.value.copy(a.previousProjectionMatrix), this.previousCameraViewMatrix.value.copy(a.previousCameraViewMatrix));
  }
  /**
   * Overwritten to updated velocity specific uniforms.
   *
   * @param {NodeFrame} frame - A reference to the current node frame.
   */
  updateAfter({ object: e }) {
    bh(e).copy(e.matrixWorld);
  }
  /**
   * Implements the velocity computation based on the previous and current vertex data.
   *
   * @param {NodeBuilder} builder - A reference to the current node builder.
   * @return {Node<vec2>} The motion vector.
   */
  setup() {
    const e = this.projectionMatrix === null ? Ot : q(this.projectionMatrix), t = this.previousCameraViewMatrix.mul(this.previousModelWorldMatrix), s = e.mul(rr).mul(Te), i = this.previousProjectionMatrix.mul(t).mul(ir), a = s.xy.div(s.w), n = i.xy.div(i.w);
    return K(a, n);
  }
}
function _m(r) {
  let e = xh.get(r);
  return e === void 0 && (e = {}, xh.set(r, e)), e;
}
function bh(r, e = 0) {
  const t = _m(r);
  let s = t[e];
  return s === void 0 && (t[e] = s = new de(), t[e].copy(r.matrixWorld)), s;
}
const uv = /* @__PURE__ */ O(lv), hv = /* @__PURE__ */ b(([r, e]) => Mt(1, r.oneMinus().div(e)).oneMinus()).setLayout({
  name: "blendBurn",
  type: "vec3",
  inputs: [
    { name: "base", type: "vec3" },
    { name: "blend", type: "vec3" }
  ]
}), cv = /* @__PURE__ */ b(([r, e]) => Mt(r.div(e.oneMinus()), 1)).setLayout({
  name: "blendDodge",
  type: "vec3",
  inputs: [
    { name: "base", type: "vec3" },
    { name: "blend", type: "vec3" }
  ]
}), dv = /* @__PURE__ */ b(([r, e]) => r.oneMinus().mul(e.oneMinus()).oneMinus()).setLayout({
  name: "blendScreen",
  type: "vec3",
  inputs: [
    { name: "base", type: "vec3" },
    { name: "blend", type: "vec3" }
  ]
}), pv = /* @__PURE__ */ b(([r, e]) => pe(r.mul(2).mul(e), r.oneMinus().mul(2).mul(e.oneMinus()).oneMinus(), tr(0.5, r))).setLayout({
  name: "blendOverlay",
  type: "vec3",
  inputs: [
    { name: "base", type: "vec3" },
    { name: "blend", type: "vec3" }
  ]
}), mv = /* @__PURE__ */ b(([r, e]) => {
  const t = e.a.add(r.a.mul(e.a.oneMinus()));
  return D(e.rgb.mul(e.a).add(r.rgb.mul(r.a).mul(e.a.oneMinus())).div(t), t);
}).setLayout({
  name: "blendColor",
  type: "vec4",
  inputs: [
    { name: "base", type: "vec4" },
    { name: "blend", type: "vec4" }
  ]
}), gv = /* @__PURE__ */ b(([r]) => iu(r.rgb)), fv = /* @__PURE__ */ b(([r, e = f(1)]) => e.mix(iu(r.rgb), r.rgb).max(0)), yv = /* @__PURE__ */ b(([r, e = f(0)]) => {
  const t = Ae(r.r, r.g, r.b).div(3), s = r.r.max(r.g.max(r.b)), i = s.sub(t).mul(e).mul(-3);
  return pe(r.rgb, s, i).max(0);
}), xv = /* @__PURE__ */ b(([r, e = f(1)]) => {
  const t = N(0.57735, 0.57735, 0.57735), s = e.cos();
  return N(r.rgb.mul(s).add(t.cross(r.rgb).mul(e.sin()).add(t.mul(St(t, r.rgb).mul(s.oneMinus()))))).max(0);
}), iu = (r, e = N(Ne.getLuminanceCoefficients(new M()))) => St(r, e), bv = /* @__PURE__ */ b(([
  r,
  e = N(1),
  t = N(0),
  s = N(1),
  i = f(1),
  // ASC CDL v1.2 explicitly requires Rec. 709 luminance coefficients.
  a = N(Ne.getLuminanceCoefficients(new M(), wa))
]) => {
  const n = r.rgb.dot(N(a)), o = Ee(r.rgb.mul(e).add(t), 0), l = o.pow(s);
  return W(o.r.greaterThan(0), () => {
    o.r.assign(l.r);
  }), W(o.g.greaterThan(0), () => {
    o.g.assign(l.g);
  }), W(o.b.greaterThan(0), () => {
    o.b.assign(l.b);
  }), o.assign(n.add(o.sub(n).mul(i)).max(0)), D(o.rgb, r.a);
}), vv = b(([r, e]) => r.mul(e).floor().div(e));
let da = null;
class Tv extends an {
  static get type() {
    return "ViewportSharedTextureNode";
  }
  /**
   * Constructs a new viewport shared texture node.
   *
   * @param {Node} [uvNode=screenUV] - The uv node.
   * @param {?Node} [levelNode=null] - The level node.
   */
  constructor(e = hr, t = null) {
    da === null && (da = new Hh()), super(e, t, da);
  }
  /**
   * Overwritten so the method always returns the unique shared
   * framebuffer texture.
   *
   * @return {FramebufferTexture} The shared framebuffer texture.
   */
  getTextureForReference() {
    return da;
  }
  updateReference() {
    return this;
  }
}
const wv = /* @__PURE__ */ Y(Tv).setParameterLength(0, 2), pa = /* @__PURE__ */ new _e();
class Am extends fs {
  static get type() {
    return "PassTextureNode";
  }
  /**
   * Constructs a new pass texture node.
   *
   * @param {PassNode} passNode - The pass node.
   * @param {Texture} texture - The output texture.
   */
  constructor(e, t) {
    super(t), this.passNode = e, this.isPassTextureNode = !0, this.setUpdateMatrix(!1);
  }
  setup(e) {
    const t = e.getNodeProperties(this);
    return t.passNode = this.passNode, super.setup(e);
  }
  clone() {
    return new this.constructor(this.passNode, this.value);
  }
}
class vh extends Am {
  static get type() {
    return "PassMultipleTextureNode";
  }
  /**
   * Constructs a new pass texture node.
   *
   * @param {PassNode} passNode - The pass node.
   * @param {string} textureName - The output texture name.
   * @param {boolean} [previousTexture=false] - Whether previous frame data should be used or not.
   */
  constructor(e, t, s = !1) {
    super(e, null), this.textureName = t, this.previousTexture = s, this.isPassMultipleTextureNode = !0;
  }
  /**
   * Updates the texture reference of this node.
   */
  updateTexture() {
    this.value = this.previousTexture ? this.passNode.getPreviousTexture(this.textureName) : this.passNode.getTexture(this.textureName);
  }
  setup(e) {
    return this.updateTexture(), super.setup(e);
  }
  clone() {
    const e = new this.constructor(this.passNode, this.textureName, this.previousTexture);
    return e.uvNode = this.uvNode, e.levelNode = this.levelNode, e.biasNode = this.biasNode, e.sampler = this.sampler, e.depthNode = this.depthNode, e.compareNode = this.compareNode, e.gradNode = this.gradNode, e.gatherNode = this.gatherNode, e.offsetNode = this.offsetNode, e;
  }
}
class Ut extends we {
  static get type() {
    return "PassNode";
  }
  /**
   * Constructs a new pass node.
   *
   * @param {('color'|'depth')} scope - The scope of the pass. The scope determines whether the node outputs color or depth.
   * @param {Scene} scene - A reference to the scene.
   * @param {Camera} camera - A reference to the camera.
   * @param {Object} options - Options for the internal render target.
   */
  constructor(e, t, s, i = {}) {
    super("vec4"), this.scope = e, this.scene = t, this.camera = s, this.options = i, this._width = 1, this._height = 1;
    const a = new Ti(this._width, this._height, { type: us, ...i });
    a.texture.name = "output";
    let n = null;
    (this.scope === Ut.DEPTH || i.depthBuffer !== !1) && (n = new Hr(), n.isRenderTargetTexture = !0, n.name = "depth", a.depthTexture = n), this.renderTarget = a, this.overrideMaterial = null, this.transparent = !0, this.opaque = !0, this.contextNode = null, this._contextNodeCache = null, this._textures = {
      output: a.texture
    }, n !== null && (this._textures.depth = n), this._textureNodes = {}, this._linearDepthNodes = {}, this._viewZNodes = {}, this._previousTextures = {}, this._previousTextureNodes = {}, this._cameraNear = q(0), this._cameraFar = q(0), this._mrt = null, this._layers = null, this._resolutionScale = 1, this._viewport = null, this._scissor = null, this.isPassNode = !0, this.updateBeforeType = Q.FRAME, this.global = !0;
  }
  /**
   * Sets the resolution scale for the pass.
   * The resolution scale is a factor that is multiplied with the renderer's width and height.
   *
   * @param {number} resolutionScale - The resolution scale to set. A value of `1` means full resolution.
   * @return {PassNode} A reference to this pass.
   */
  setResolutionScale(e) {
    return this._resolutionScale = e, this;
  }
  /**
   * Gets the current resolution scale of the pass.
   *
   * @return {number} The current resolution scale. A value of `1` means full resolution.
   */
  getResolutionScale() {
    return this._resolutionScale;
  }
  /**
   * Sets the resolution for the pass.
   * The resolution is a factor that is multiplied with the renderer's width and height.
   *
   * @param {number} resolution - The resolution to set. A value of `1` means full resolution.
   * @return {PassNode} A reference to this pass.
   * @deprecated since r181. Use {@link PassNode#setResolutionScale `setResolutionScale()`} instead.
   */
  setResolution(e) {
    return X("PassNode: .setResolution() is deprecated. Use .setResolutionScale() instead."), this.setResolutionScale(e);
  }
  /**
   * Gets the current resolution of the pass.
   *
   * @return {number} The current resolution. A value of `1` means full resolution.
   * @deprecated since r181. Use {@link PassNode#getResolutionScale `getResolutionScale()`} instead.
   */
  getResolution() {
    return X("PassNode: .getResolution() is deprecated. Use .getResolutionScale() instead."), this.getResolutionScale();
  }
  /**
   * Sets the layer configuration that should be used when rendering the pass.
   *
   * @param {Layers} layers - The layers object to set.
   * @return {PassNode} A reference to this pass.
   */
  setLayers(e) {
    return this._layers = e, this;
  }
  /**
   * Gets the current layer configuration of the pass.
   *
   * @return {?Layers} .
   */
  getLayers() {
    return this._layers;
  }
  /**
   * Sets the given MRT node to setup MRT for this pass.
   *
   * @param {MRTNode} mrt - The MRT object.
   * @return {PassNode} A reference to this pass.
   */
  setMRT(e) {
    return this._mrt = e, this;
  }
  /**
   * Returns the current MRT node.
   *
   * @return {MRTNode} The current MRT node.
   */
  getMRT() {
    return this._mrt;
  }
  /**
   * Returns the texture for the given output name.
   *
   * @param {string} name - The output name to get the texture for.
   * @return {Texture} The texture.
   */
  getTexture(e) {
    let t = this._textures[e];
    if (t === void 0) {
      if (e === "depth")
        throw new Error("THREE.PassNode: Depth texture is not available for this pass.");
      t = this.renderTarget.texture.clone(), t.name = e, this._textures[e] = t, this.renderTarget.textures.push(t);
    }
    return t;
  }
  /**
   * Returns the texture holding the data of the previous frame for the given output name.
   *
   * @param {string} name - The output name to get the texture for.
   * @return {Texture} The texture holding the data of the previous frame.
   */
  getPreviousTexture(e) {
    let t = this._previousTextures[e];
    return t === void 0 && (t = this.getTexture(e).clone(), this._previousTextures[e] = t), t;
  }
  /**
   * Switches current and previous textures for the given output name.
   *
   * @param {string} name - The output name.
   */
  toggleTexture(e) {
    const t = this._previousTextures[e];
    if (t !== void 0) {
      const s = this._textures[e], i = this.renderTarget.textures.indexOf(s);
      this.renderTarget.textures[i] = t, this._textures[e] = t, this._previousTextures[e] = s, this._textureNodes[e].updateTexture(), this._previousTextureNodes[e].updateTexture();
    }
  }
  /**
   * Returns the texture node for the given output name.
   *
   * @param {string} [name='output'] - The output name to get the texture node for.
   * @return {TextureNode} The texture node.
   */
  getTextureNode(e = "output") {
    let t = this._textureNodes[e];
    return t === void 0 && (t = new vh(this, e), t.updateTexture(), this._textureNodes[e] = t), t;
  }
  /**
   * Returns the previous texture node for the given output name.
   *
   * @param {string} [name='output'] - The output name to get the previous texture node for.
   * @return {TextureNode} The previous texture node.
   */
  getPreviousTextureNode(e = "output") {
    let t = this._previousTextureNodes[e];
    return t === void 0 && (this._textureNodes[e] === void 0 && this.getTextureNode(e), t = new vh(this, e, !0), t.updateTexture(), this._previousTextureNodes[e] = t), t;
  }
  /**
   * Returns a viewZ node of this pass.
   *
   * @param {string} [name='depth'] - The output name to get the viewZ node for. In most cases the default `'depth'` can be used however the parameter exists for custom depth outputs.
   * @return {Node} The viewZ node.
   */
  getViewZNode(e = "depth") {
    let t = this._viewZNodes[e];
    if (t === void 0) {
      const s = this._cameraNear, i = this._cameraFar;
      this._viewZNodes[e] = t = nn(this.getTextureNode(e), s, i);
    }
    return t;
  }
  /**
   * Returns a linear depth node of this pass.
   *
   * @param {string} [name='depth'] - The output name to get the linear depth node for. In most cases the default `'depth'` can be used however the parameter exists for custom depth outputs.
   * @return {Node} The linear depth node.
   */
  getLinearDepthNode(e = "depth") {
    let t = this._linearDepthNodes[e];
    if (t === void 0) {
      const s = this._cameraNear, i = this._cameraFar, a = this.getViewZNode(e);
      this._linearDepthNodes[e] = t = er(a, s, i);
    }
    return t;
  }
  /**
   * Precompiles the pass.
   *
   * Note that this method must be called after the pass configuration is complete.
   * So calls like `setMRT()` and `getTextureNode()` must proceed the precompilation.
   *
   * @async
   * @param {Renderer} renderer - The renderer.
   * @return {Promise} A Promise that resolves when the compile has been finished.
   * @see {@link Renderer#compileAsync}
   */
  async compileAsync(e) {
    const t = e.getRenderTarget(), s = e.getMRT();
    e.setRenderTarget(this.renderTarget), e.setMRT(this._mrt), await e.compileAsync(this.scene, this.camera), e.setRenderTarget(t), e.setMRT(s);
  }
  setup({ renderer: e }) {
    return this.renderTarget.samples = this.options.samples === void 0 ? e.samples : this.options.samples, this.renderTarget.texture.type = e.getOutputBufferType(), e.reversedDepthBuffer === !0 && this.renderTarget.depthTexture !== null && (this.renderTarget.depthTexture.type = qo), this.scope === Ut.COLOR ? this.getTextureNode() : this.getLinearDepthNode();
  }
  updateBefore(e) {
    const { renderer: t } = e, { scene: s } = this;
    let i;
    const a = t.getOutputRenderTarget();
    a && a.isXRRenderTarget === !0 ? (i = t.xr.getCamera(), t.xr.updateCamera(i), pa.set(a.width, a.height)) : (i = this.camera, t.getDrawingBufferSize(pa)), this.setSize(pa.width, pa.height);
    const n = t.getRenderTarget(), o = t.getMRT(), l = t.autoClear, u = t.transparent, h = t.opaque, d = i.layers.mask, p = t.contextNode, m = s.overrideMaterial;
    this._cameraNear.value = i.near, this._cameraFar.value = i.far, this._layers !== null && (i.layers.mask = this._layers.mask);
    for (const y in this._previousTextures)
      this.toggleTexture(y);
    this.overrideMaterial !== null && (s.overrideMaterial = this.overrideMaterial), t.setRenderTarget(this.renderTarget), t.setMRT(this._mrt), t.autoClear = !0, t.transparent = this.transparent, t.opaque = this.opaque, this.contextNode !== null && ((this._contextNodeCache === null || this._contextNodeCache.version !== this.version) && (this._contextNodeCache = {
      version: this.version,
      context: Fs({ ...t.contextNode.getFlowContextData(), ...this.contextNode.getFlowContextData() })
    }), t.contextNode = this._contextNodeCache.context);
    const g = s.name;
    s.name = this.name ? this.name : s.name, t.render(s, i), s.name = g, s.overrideMaterial = m, t.setRenderTarget(n), t.setMRT(o), t.autoClear = l, t.transparent = u, t.opaque = h, t.contextNode = p, i.layers.mask = d;
  }
  /**
   * Sets the size of the pass's render target. Honors the pixel ratio.
   *
   * @param {number} width - The width to set.
   * @param {number} height - The height to set.
   */
  setSize(e, t) {
    this._width = e, this._height = t;
    const s = Math.floor(this._width * this._resolutionScale), i = Math.floor(this._height * this._resolutionScale);
    this.renderTarget.setSize(s, i), this._scissor !== null ? (this.renderTarget.scissor.copy(this._scissor).multiplyScalar(this._resolutionScale).floor(), this.renderTarget.scissorTest = !0) : this.renderTarget.scissorTest = !1, this._viewport !== null && this.renderTarget.viewport.copy(this._viewport).multiplyScalar(this._resolutionScale).floor();
  }
  /**
   * This method allows to define the pass's scissor rectangle. By default, the scissor rectangle is kept
   * in sync with the pass's dimensions. To reverse the process and use auto-sizing again, call the method
   * with `null` as the single argument.
   *
   * @param {?(number | Vector4)} x - The horizontal coordinate for the lower left corner of the box in logical pixel unit.
   * Instead of passing four arguments, the method also works with a single four-dimensional vector.
   * @param {number} y - The vertical coordinate for the lower left corner of the box in logical pixel unit.
   * @param {number} width - The width of the scissor box in logical pixel unit.
   * @param {number} height - The height of the scissor box in logical pixel unit.
   */
  setScissor(e, t, s, i) {
    e === null ? this._scissor = null : (this._scissor === null && (this._scissor = new tt()), e.isVector4 ? this._scissor.copy(e) : this._scissor.set(e, t, s, i));
  }
  /**
   * This method allows to define the pass's viewport. By default, the viewport is kept in sync
   * with the pass's dimensions. To reverse the process and use auto-sizing again, call the method
   * with `null` as the single argument.
   *
   * @param {number | Vector4} x - The horizontal coordinate for the lower left corner of the viewport origin in logical pixel unit.
   * @param {number} y - The vertical coordinate for the lower left corner of the viewport origin  in logical pixel unit.
   * @param {number} width - The width of the viewport in logical pixel unit.
   * @param {number} height - The height of the viewport in logical pixel unit.
   */
  setViewport(e, t, s, i) {
    e === null ? this._viewport = null : (this._viewport === null && (this._viewport = new tt()), e.isVector4 ? this._viewport.copy(e) : this._viewport.set(e, t, s, i));
  }
  /**
   * Frees internal resources. Should be called when the node is no longer in use.
   */
  dispose() {
    this.renderTarget.dispose();
  }
}
Ut.COLOR = "color";
Ut.DEPTH = "depth";
const Nv = (r, e, t) => new Ut(Ut.COLOR, r, e, t), Mv = (r, e) => new Am(r, e), Sv = (r, e, t) => new Ut(Ut.DEPTH, r, e, t);
class _v extends Ut {
  static get type() {
    return "ToonOutlinePassNode";
  }
  /**
   * Constructs a new outline pass node.
   *
   * @param {Scene} scene - A reference to the scene.
   * @param {Camera} camera - A reference to the camera.
   * @param {Node} colorNode - Defines the outline's color.
   * @param {Node} thicknessNode - Defines the outline's thickness.
   * @param {Node} alphaNode - Defines the outline's alpha.
   */
  constructor(e, t, s, i, a) {
    super(Ut.COLOR, e, t), this.colorNode = s, this.thicknessNode = i, this.alphaNode = a, this._materialCache = /* @__PURE__ */ new WeakMap(), this.name = "Outline Pass";
  }
  updateBefore(e) {
    const { renderer: t } = e, s = t.getRenderObjectFunction();
    t.setRenderObjectFunction((i, a, n, o, l, u, h, d) => {
      if ((l.isMeshToonMaterial || l.isMeshToonNodeMaterial) && l.wireframe === !1) {
        const p = this._getOutlineMaterial(l);
        t.renderObject(i, a, n, o, p, u, h, d);
      }
      t.renderObject(i, a, n, o, l, u, h, d);
    }), super.updateBefore(e), t.setRenderObjectFunction(s);
  }
  /**
   * Creates the material used for outline rendering.
   *
   * @private
   * @return {NodeMaterial} The outline material.
   */
  _createMaterial() {
    const e = new jr();
    e.isMeshToonOutlineMaterial = !0, e.name = "Toon_Outline", e.side = vi;
    const t = $e.negate(), s = Ot.mul(rr), i = f(1), a = s.mul(D(Te, 1)), n = s.mul(D(Te.add(t), 1)), o = it(a.sub(n));
    return e.vertexNode = a.add(o.mul(this.thicknessNode).mul(a.w).mul(i)), e.colorNode = D(this.colorNode, this.alphaNode), e;
  }
  /**
   * For the given toon material, this method returns a corresponding
   * outline material.
   *
   * @private
   * @param {(MeshToonMaterial|MeshToonNodeMaterial)} originalMaterial - The toon material.
   * @return {NodeMaterial} The outline material.
   */
  _getOutlineMaterial(e) {
    let t = this._materialCache.get(e);
    return t === void 0 && (t = this._createMaterial(), this._materialCache.set(e, t)), t;
  }
}
const Av = (r, e, t = new Yt(0, 0, 0), s = 3e-3, i = 1) => new _v(r, e, U(t), U(s), U(i)), Vv = /* @__PURE__ */ b(([r, e]) => r.mul(e).clamp()).setLayout({
  name: "linearToneMapping",
  type: "vec3",
  inputs: [
    { name: "color", type: "vec3" },
    { name: "exposure", type: "float" }
  ]
}), Cv = /* @__PURE__ */ b(([r, e]) => (r = r.mul(e), r.div(r.add(1)).clamp())).setLayout({
  name: "reinhardToneMapping",
  type: "vec3",
  inputs: [
    { name: "color", type: "vec3" },
    { name: "exposure", type: "float" }
  ]
}), zv = /* @__PURE__ */ b(([r, e]) => {
  r = r.mul(e), r = r.sub(4e-3).max(0);
  const t = r.mul(r.mul(6.2).add(0.5)), s = r.mul(r.mul(6.2).add(1.7)).add(0.06);
  return t.div(s).pow(2.2);
}).setLayout({
  name: "cineonToneMapping",
  type: "vec3",
  inputs: [
    { name: "color", type: "vec3" },
    { name: "exposure", type: "float" }
  ]
}), Rv = /* @__PURE__ */ b(([r]) => {
  const e = r.mul(r.add(0.0245786)).sub(90537e-9), t = r.mul(r.add(0.432951).mul(0.983729)).add(0.238081);
  return e.div(t);
}), Ev = /* @__PURE__ */ b(([r, e]) => {
  const t = gt(
    0.59719,
    0.35458,
    0.04823,
    0.076,
    0.90834,
    0.01566,
    0.0284,
    0.13383,
    0.83777
  ), s = gt(
    1.60475,
    -0.53108,
    -0.07367,
    -0.10208,
    1.10813,
    -605e-5,
    -327e-5,
    -0.07276,
    1.07602
  );
  return r = r.mul(e).div(0.6), r = t.mul(r), r = Rv(r), r = s.mul(r), r.clamp();
}).setLayout({
  name: "acesFilmicToneMapping",
  type: "vec3",
  inputs: [
    { name: "color", type: "vec3" },
    { name: "exposure", type: "float" }
  ]
}), Lv = /* @__PURE__ */ gt(N(1.6605, -0.1246, -0.0182), N(-0.5876, 1.1329, -0.1006), N(-0.0728, -83e-4, 1.1187)), Iv = /* @__PURE__ */ gt(N(0.6274, 0.0691, 0.0164), N(0.3293, 0.9195, 0.088), N(0.0433, 0.0113, 0.8956)), Ov = /* @__PURE__ */ b(([r]) => {
  const e = N(r).toVar(), t = N(e.mul(e)).toVar(), s = N(t.mul(t)).toVar();
  return f(15.5).mul(s.mul(t)).sub(j(40.14, s.mul(e))).add(j(31.96, s).sub(j(6.868, t.mul(e))).add(j(0.4298, t).add(j(0.1191, e).sub(232e-5))));
}), Pv = /* @__PURE__ */ b(([r, e]) => {
  const t = N(r).toVar(), s = gt(N(0.856627153315983, 0.137318972929847, 0.11189821299995), N(0.0951212405381588, 0.761241990602591, 0.0767994186031903), N(0.0482516061458583, 0.101439036467562, 0.811302368396859)), i = gt(N(1.1271005818144368, -0.1413297634984383, -0.14132976349843826), N(-0.11060664309660323, 1.157823702216272, -0.11060664309660294), N(-0.016493938717834573, -0.016493938717834257, 1.2519364065950405)), a = f(-12.47393), n = f(4.026069);
  return t.mulAssign(e), t.assign(Iv.mul(t)), t.assign(s.mul(t)), t.assign(Ee(t, 1e-10)), t.assign(ps(t)), t.assign(t.sub(a).div(n.sub(a))), t.assign(Jt(t, 0, 1)), t.assign(Ov(t)), t.assign(i.mul(t)), t.assign(vt(Ee(N(0), t), N(2.2))), t.assign(Lv.mul(t)), t.assign(Jt(t, 0, 1)), t;
}).setLayout({
  name: "agxToneMapping",
  type: "vec3",
  inputs: [
    { name: "color", type: "vec3" },
    { name: "exposure", type: "float" }
  ]
}), Fv = /* @__PURE__ */ b(([r, e]) => {
  const t = f(0.76), s = f(0.15);
  r = r.mul(e);
  const i = Mt(r.r, Mt(r.g, r.b)), a = He(i.lessThan(0.08), i.sub(j(6.25, i.mul(i))), 0.04);
  r.subAssign(a);
  const n = Ee(r.r, Ee(r.g, r.b));
  W(n.lessThan(t), () => r);
  const o = K(1, t), l = K(1, o.mul(o).div(n.add(o.sub(t))));
  r.mulAssign(l.div(n));
  const u = K(1, Zt(1, s.mul(n.sub(l)).add(1)));
  return pe(r, N(l), u);
}).setLayout({
  name: "neutralToneMapping",
  type: "vec3",
  inputs: [
    { name: "color", type: "vec3" },
    { name: "exposure", type: "float" }
  ]
});
class me extends k {
  static get type() {
    return "CodeNode";
  }
  /**
   * Constructs a new code node.
   *
   * @param {string} [code=''] - The native code.
   * @param {Array<Node>} [includes=[]] - An array of includes.
   * @param {('js'|'wgsl'|'glsl')} [language=''] - The used language.
   */
  constructor(e = "", t = [], s = "") {
    super("code"), this.isCodeNode = !0, this.global = !0, this.code = e, this.includes = t, this.language = s;
  }
  /**
   * Sets the includes of this code node.
   *
   * @param {Array<Node>} includes - The includes to set.
   * @return {CodeNode} A reference to this node.
   */
  setIncludes(e) {
    return this.includes = e, this;
  }
  /**
   * Returns the includes of this code node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Array<Node>} The includes.
   */
  getIncludes() {
    return this.includes;
  }
  generate(e) {
    const t = this.getIncludes(e);
    for (const i of t)
      i.build(e);
    const s = e.getCodeFromNode(this, this.getNodeType(e));
    return s.code = this.code, s.code;
  }
  serialize(e) {
    super.serialize(e), e.code = this.code, e.language = this.language;
  }
  deserialize(e) {
    super.deserialize(e), this.code = e.code, this.language = e.language;
  }
}
const cn = /* @__PURE__ */ Y(me).setParameterLength(1, 3), Bv = (r, e) => cn(r, e, "js"), Uv = (r, e) => cn(r, e, "wgsl"), kv = (r, e) => cn(r, e, "glsl");
class Dv extends me {
  static get type() {
    return "FunctionNode";
  }
  /**
   * Constructs a new function node.
   *
   * @param {string} [code=''] - The native code.
   * @param {Array<Node>} [includes=[]] - An array of includes.
   * @param {('js'|'wgsl'|'glsl')} [language=''] - The used language.
   */
  constructor(e = "", t = [], s = "") {
    super(e, t, s);
  }
  /**
   * Returns the type of this function node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The type.
   */
  generateNodeType(e) {
    return this.getNodeFunction(e).type;
  }
  /**
   * Returns the type of a member of this function node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {string} name - The name of the member.
   * @return {string} The type of the member.
   */
  getMemberType(e, t) {
    const s = this.getNodeType(e);
    return e.getStructTypeNode(s).getMemberType(e, t);
  }
  /**
   * Returns the inputs of this function node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Array<NodeFunctionInput>} The inputs.
   */
  getInputs(e) {
    return this.getNodeFunction(e).inputs;
  }
  /**
   * Returns the node function for this function node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {NodeFunction} The node function.
   */
  getNodeFunction(e) {
    const t = e.getDataFromNode(this);
    let s = t.nodeFunction;
    return s === void 0 && (s = e.parser.parseFunction(this.code), t.nodeFunction = s), s;
  }
  generate(e, t) {
    super.generate(e);
    const s = this.getNodeFunction(e), i = s.name, a = s.type, n = e.getCodeFromNode(this, a);
    i !== "" && (n.name = i);
    const o = e.getPropertyName(n), l = this.getNodeFunction(e).getCode(o);
    return n.code = l + `
`, t === "property" ? o : e.format(`${o}()`, a, t);
  }
}
const Vm = (r, e = [], t = "") => {
  const s = new Dv(r, e, t);
  return il((...i) => s.call(...i), s);
}, Wv = (r, e) => Vm(r, e, "glsl"), qv = (r, e) => Vm(r, e, "wgsl");
function au(r) {
  let e;
  const t = r.context.getViewZ;
  return t !== void 0 && (e = t(this)), (e || Ie.z).negate();
}
const jv = b(([r, e], t) => {
  const s = au(t);
  return Qt(r, e, s);
}), Gv = b(([r], e) => {
  const t = au(e);
  return r.mul(r, t, t).negate().exp().oneMinus();
}), Hv = b(([r, e], t) => {
  const s = au(t), i = e.sub(Ks.y).max(0).toConst().mul(s).toConst();
  return r.mul(r, i, i).negate().exp().oneMinus();
}), Xv = b(([r, e]) => D(e.toFloat().mix(Fr.rgb, r.toVec3()), Fr.a));
let Hs = null, Xs = null;
class $v extends k {
  static get type() {
    return "RangeNode";
  }
  /**
   * Constructs a new range node.
   *
   * @param {Node<any>} [minNode=float()] - A node defining the lower bound of the range.
   * @param {Node<any>} [maxNode=float()] - A node defining the upper bound of the range.
   */
  constructor(e = f(), t = f()) {
    super(), this.minNode = e, this.maxNode = t;
  }
  /**
   * Returns the vector length which is computed based on the range definition.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {number} The vector length.
   */
  getVectorLength(e) {
    const t = this.getConstNode(this.minNode), s = this.getConstNode(this.maxNode), i = e.getTypeLength(Cs(t.value)), a = e.getTypeLength(Cs(s.value));
    return i > a ? i : a;
  }
  /**
   * This method is overwritten since the node type is inferred from range definition.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The node type.
   */
  generateNodeType(e) {
    return e.object.count > 1 ? e.getTypeFromLength(this.getVectorLength(e)) : "float";
  }
  /**
   * Returns a constant node from the given node by traversing it.
   *
   * @param {Node} node - The node to traverse.
   * @returns {Node} The constant node, if found.
   */
  getConstNode(e) {
    let t = null;
    if (e.traverse((s) => {
      s.isConstNode === !0 && (t = s);
    }), t === null)
      throw new Hd('THREE.TSL: No "ConstNode" found in node graph.', this.stackTrace);
    return t;
  }
  setup(e) {
    const t = e.object;
    let s = null;
    if (t.count > 1) {
      const i = this.getConstNode(this.minNode), a = this.getConstNode(this.maxNode), n = i.value, o = a.value, l = e.getTypeLength(Cs(n)), u = e.getTypeLength(Cs(o));
      Hs = Hs || new tt(), Xs = Xs || new tt(), Hs.setScalar(0), Xs.setScalar(0), l === 1 ? Hs.setScalar(n) : n.isColor ? Hs.set(n.r, n.g, n.b, 1) : Hs.set(n.x, n.y, n.z || 0, n.w || 0), u === 1 ? Xs.setScalar(o) : o.isColor ? Xs.set(o.r, o.g, o.b, 1) : Xs.set(o.x, o.y, o.z || 0, o.w || 0);
      const h = 4, d = h * t.count, p = new Float32Array(d);
      for (let g = 0; g < d; g++) {
        const y = g % h, v = Hs.getComponent(y), w = Xs.getComponent(y);
        p[g] = Ph.lerp(v, w, Math.random());
      }
      const m = this.getNodeType(e);
      if (t.count * 4 * 4 <= e.getUniformBufferLimit())
        s = $r(p, "vec4", t.count).element(Ft).convert(m);
      else {
        const g = new Or(p, 4);
        e.geometry.setAttribute("__range" + this.id, g), s = Ja(g).convert(m);
      }
    } else
      s = f(0);
    return s;
  }
}
const Yv = /* @__PURE__ */ Y($v).setParameterLength(2);
class Zv extends k {
  static get type() {
    return "ComputeBuiltinNode";
  }
  /**
   * Constructs a new compute builtin node.
   *
   * @param {string} builtinName - The built-in name.
   * @param {string} nodeType - The node type.
   */
  constructor(e, t) {
    super(t), this._builtinName = e;
  }
  /**
   * This method is overwritten since hash is derived from the built-in name.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The hash.
   */
  getHash(e) {
    return this.getBuiltinName(e);
  }
  /**
   * This method is overwritten since the node type is simply derived from `nodeType`..
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The node type.
   */
  generateNodeType() {
    return this.nodeType;
  }
  /**
   * Sets the builtin name.
   *
   * @param {string} builtinName - The built-in name.
   * @return {ComputeBuiltinNode} A reference to this node.
   */
  setBuiltinName(e) {
    return this._builtinName = e, this;
  }
  /**
   * Returns the builtin name.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The builtin name.
   */
  getBuiltinName() {
    return this._builtinName;
  }
  /**
   * Whether the current node builder has the builtin or not.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {boolean} Whether the builder has the builtin or not.
   */
  hasBuiltin(e) {
    return e.hasBuiltin(this._builtinName);
  }
  generate(e, t) {
    const s = this.getBuiltinName(e), i = this.getNodeType(e);
    return e.shaderStage === "compute" ? e.format(s, i, t) : (X(`ComputeBuiltinNode: Compute built-in value ${s} can not be accessed in the ${e.shaderStage} stage`), e.generateConst(i));
  }
  serialize(e) {
    super.serialize(e), e.global = this.global, e._builtinName = this._builtinName;
  }
  deserialize(e) {
    super.deserialize(e), this.global = e.global, this._builtinName = e._builtinName;
  }
}
const Ai = (r, e) => new Zv(r, e), Jv = /* @__PURE__ */ Ai("numWorkgroups", "uvec3"), Qv = /* @__PURE__ */ Ai("workgroupId", "uvec3"), Kv = /* @__PURE__ */ Ai("globalId", "uvec3"), eT = /* @__PURE__ */ Ai("localId", "uvec3"), tT = /* @__PURE__ */ Ai("subgroupSize", "uint");
class sT extends k {
  /**
   * Constructs a new barrier node.
   *
   * @param {string} scope - The scope defines the behavior of the node.
   */
  constructor(e) {
    super(), this.scope = e, this.isBarrierNode = !0;
  }
  setup(e) {
    e.allowEarlyReturns = !1, e.allowGlobalVariables = !1;
  }
  generate(e) {
    const { scope: t } = this, { renderer: s } = e;
    s.backend.isWebGLBackend === !0 ? e.addFlowCode(`	// ${t}Barrier 
`) : e.addLineFlowCode(`${t}Barrier()`, this);
  }
}
const nu = Y(sT), rT = () => nu("workgroup").toStack(), iT = () => nu("storage").toStack(), aT = () => nu("texture").toStack();
class nT extends nr {
  /**
   * Constructs a new workgroup info element node.
   *
   * @param {Node} workgroupInfoNode - The workgroup info node.
   * @param {Node} indexNode - The index node that defines the element access.
   */
  constructor(e, t) {
    super(e, t), this.isWorkgroupInfoElementNode = !0;
  }
  generate(e, t) {
    let s;
    const i = e.isContextAssign();
    if (s = super.generate(e), i !== !0) {
      const a = this.getNodeType(e);
      s = e.format(s, a, t);
    }
    return s;
  }
}
class oT extends k {
  /**
   * Constructs a new buffer scoped to type scope.
   *
   * @param {string} scope - TODO.
   * @param {string} bufferType - The data type of a 'workgroup' scoped buffer element.
   * @param {number} [bufferCount=0] - The number of elements in the buffer.
   */
  constructor(e, t, s = 0) {
    super(t), this.bufferType = t, this.bufferCount = s, this.isWorkgroupInfoNode = !0, this.elementType = t, this.scope = e, this.name = "";
  }
  /**
   * Sets the name of this node.
   *
   * @param {string} name - The name to set.
   * @return {WorkgroupInfoNode} A reference to this node.
   */
  setName(e) {
    return this.name = e, this;
  }
  /**
   * Sets the name/label of this node.
   *
   * @deprecated
   * @param {string} name - The name to set.
   * @return {WorkgroupInfoNode} A reference to this node.
   */
  label(e) {
    return X('TSL: "label()" has been deprecated. Use "setName()" instead.', new Re()), this.setName(e);
  }
  /**
   * Sets the scope of this node.
   *
   * @param {string} scope - The scope to set.
   * @return {WorkgroupInfoNode} A reference to this node.
   */
  setScope(e) {
    return this.scope = e, this;
  }
  /**
   * The data type of the array buffer.
   *
   * @return {string} The element type.
   */
  getElementType() {
    return this.elementType;
  }
  /**
   * Overwrites the default implementation since the input type
   * is inferred from the scope.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The input type.
   */
  getInputType() {
    return `${this.scope}Array`;
  }
  /**
   * This method can be used to access elements via an index node.
   *
   * @param {IndexNode} indexNode - indexNode.
   * @return {WorkgroupInfoElementNode} A reference to an element.
   */
  element(e) {
    return new nT(this, e);
  }
  generate(e) {
    const t = this.name !== "" ? this.name : `${this.scope}Array_${this.id}`;
    return e.getScopedArray(t, this.scope.toLowerCase(), this.bufferType, this.bufferCount);
  }
}
const lT = (r, e) => new oT("Workgroup", r, e);
class Oe extends k {
  static get type() {
    return "AtomicFunctionNode";
  }
  /**
   * Constructs a new atomic function node.
   *
   * @param {string} method - The signature of the atomic function to construct.
   * @param {Node} pointerNode - An atomic variable or element of an atomic buffer.
   * @param {Node} valueNode - The value that mutates the atomic variable.
   */
  constructor(e, t, s) {
    super("uint"), this.method = e, this.pointerNode = t, this.valueNode = s, this.parents = !0;
  }
  /**
   * Overwrites the default implementation to return the type of
   * the pointer node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The input type.
   */
  getInputType(e) {
    return this.pointerNode.getNodeType(e);
  }
  /**
   * Overwritten since the node type is inferred from the input type.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {string} The node type.
   */
  generateNodeType(e) {
    return this.getInputType(e);
  }
  generate(e) {
    const t = e.getNodeProperties(this), s = t.parents, i = this.method, a = this.getNodeType(e), n = this.getInputType(e), o = this.pointerNode, l = this.valueNode, u = [];
    u.push(`&${o.build(e, n)}`), l !== null && u.push(l.build(e, n));
    const h = `${e.getMethod(i, a)}( ${u.join(", ")} )`;
    if (s && s.length === 1 && s[0].isStackNode === !0)
      e.addLineFlowCode(h, this);
    else
      return t.constNode === void 0 && (t.constNode = ct(h, a).toConst()), t.constNode.build(e);
  }
}
Oe.ATOMIC_LOAD = "atomicLoad";
Oe.ATOMIC_STORE = "atomicStore";
Oe.ATOMIC_ADD = "atomicAdd";
Oe.ATOMIC_SUB = "atomicSub";
Oe.ATOMIC_MAX = "atomicMax";
Oe.ATOMIC_MIN = "atomicMin";
Oe.ATOMIC_AND = "atomicAnd";
Oe.ATOMIC_OR = "atomicOr";
Oe.ATOMIC_XOR = "atomicXor";
const uT = Y(Oe), ts = (r, e, t) => uT(r, e, t).toStack(), hT = (r) => ts(Oe.ATOMIC_LOAD, r, null), cT = (r, e) => ts(Oe.ATOMIC_STORE, r, e), dT = (r, e) => ts(Oe.ATOMIC_ADD, r, e), pT = (r, e) => ts(Oe.ATOMIC_SUB, r, e), mT = (r, e) => ts(Oe.ATOMIC_MAX, r, e), gT = (r, e) => ts(Oe.ATOMIC_MIN, r, e), fT = (r, e) => ts(Oe.ATOMIC_AND, r, e), yT = (r, e) => ts(Oe.ATOMIC_OR, r, e), xT = (r, e) => ts(Oe.ATOMIC_XOR, r, e);
class F extends we {
  static get type() {
    return "SubgroupFunctionNode";
  }
  /**
   * Constructs a new function node.
   *
   * @param {string} method - The subgroup/wave intrinsic method to construct.
   * @param {Node} [aNode=null] - The method's first argument.
   * @param {Node} [bNode=null] - The method's second argument.
   */
  constructor(e, t = null, s = null) {
    super(), this.method = e, this.aNode = t, this.bNode = s;
  }
  getInputType(e) {
    const t = this.aNode ? this.aNode.getNodeType(e) : null, s = this.bNode ? this.bNode.getNodeType(e) : null, i = e.isMatrix(t) ? 0 : e.getTypeLength(t), a = e.isMatrix(s) ? 0 : e.getTypeLength(s);
    return i > a ? t : s;
  }
  generateNodeType(e) {
    const t = this.method;
    return t === F.SUBGROUP_ELECT ? "bool" : t === F.SUBGROUP_BALLOT ? "uvec4" : this.getInputType(e);
  }
  generate(e, t) {
    const s = this.method, i = this.getNodeType(e), a = this.getInputType(e), n = this.aNode, o = this.bNode, l = [];
    if (s === F.SUBGROUP_BROADCAST || s === F.SUBGROUP_SHUFFLE || s === F.QUAD_BROADCAST) {
      const h = o.getNodeType(e);
      l.push(
        n.build(e, i),
        o.build(e, h === "float" ? "int" : i)
      );
    } else s === F.SUBGROUP_SHUFFLE_XOR || s === F.SUBGROUP_SHUFFLE_DOWN || s === F.SUBGROUP_SHUFFLE_UP ? l.push(
      n.build(e, i),
      o.build(e, "uint")
    ) : (n !== null && l.push(n.build(e, a)), o !== null && l.push(o.build(e, a)));
    const u = l.length === 0 ? "()" : `( ${l.join(", ")} )`;
    return e.format(`${e.getMethod(s, i)}${u}`, i, t);
  }
  serialize(e) {
    super.serialize(e), e.method = this.method;
  }
  deserialize(e) {
    super.deserialize(e), this.method = e.method;
  }
}
F.SUBGROUP_ELECT = "subgroupElect";
F.SUBGROUP_BALLOT = "subgroupBallot";
F.SUBGROUP_ADD = "subgroupAdd";
F.SUBGROUP_INCLUSIVE_ADD = "subgroupInclusiveAdd";
F.SUBGROUP_EXCLUSIVE_AND = "subgroupExclusiveAdd";
F.SUBGROUP_MUL = "subgroupMul";
F.SUBGROUP_INCLUSIVE_MUL = "subgroupInclusiveMul";
F.SUBGROUP_EXCLUSIVE_MUL = "subgroupExclusiveMul";
F.SUBGROUP_AND = "subgroupAnd";
F.SUBGROUP_OR = "subgroupOr";
F.SUBGROUP_XOR = "subgroupXor";
F.SUBGROUP_MIN = "subgroupMin";
F.SUBGROUP_MAX = "subgroupMax";
F.SUBGROUP_ALL = "subgroupAll";
F.SUBGROUP_ANY = "subgroupAny";
F.SUBGROUP_BROADCAST_FIRST = "subgroupBroadcastFirst";
F.QUAD_SWAP_X = "quadSwapX";
F.QUAD_SWAP_Y = "quadSwapY";
F.QUAD_SWAP_DIAGONAL = "quadSwapDiagonal";
F.SUBGROUP_BROADCAST = "subgroupBroadcast";
F.SUBGROUP_SHUFFLE = "subgroupShuffle";
F.SUBGROUP_SHUFFLE_XOR = "subgroupShuffleXor";
F.SUBGROUP_SHUFFLE_UP = "subgroupShuffleUp";
F.SUBGROUP_SHUFFLE_DOWN = "subgroupShuffleDown";
F.QUAD_BROADCAST = "quadBroadcast";
const bT = /* @__PURE__ */ L(F, F.SUBGROUP_ELECT).setParameterLength(0), vT = /* @__PURE__ */ L(F, F.SUBGROUP_BALLOT).setParameterLength(1), TT = /* @__PURE__ */ L(F, F.SUBGROUP_ADD).setParameterLength(1), wT = /* @__PURE__ */ L(F, F.SUBGROUP_INCLUSIVE_ADD).setParameterLength(1), NT = /* @__PURE__ */ L(F, F.SUBGROUP_EXCLUSIVE_AND).setParameterLength(1), MT = /* @__PURE__ */ L(F, F.SUBGROUP_MUL).setParameterLength(1), ST = /* @__PURE__ */ L(F, F.SUBGROUP_INCLUSIVE_MUL).setParameterLength(1), _T = /* @__PURE__ */ L(F, F.SUBGROUP_EXCLUSIVE_MUL).setParameterLength(1), AT = /* @__PURE__ */ L(F, F.SUBGROUP_AND).setParameterLength(1), VT = /* @__PURE__ */ L(F, F.SUBGROUP_OR).setParameterLength(1), CT = /* @__PURE__ */ L(F, F.SUBGROUP_XOR).setParameterLength(1), zT = /* @__PURE__ */ L(F, F.SUBGROUP_MIN).setParameterLength(1), RT = /* @__PURE__ */ L(F, F.SUBGROUP_MAX).setParameterLength(1), ET = /* @__PURE__ */ L(F, F.SUBGROUP_ALL).setParameterLength(0), LT = /* @__PURE__ */ L(F, F.SUBGROUP_ANY).setParameterLength(0), IT = /* @__PURE__ */ L(F, F.SUBGROUP_BROADCAST_FIRST).setParameterLength(2), OT = /* @__PURE__ */ L(F, F.QUAD_SWAP_X).setParameterLength(1), PT = /* @__PURE__ */ L(F, F.QUAD_SWAP_Y).setParameterLength(1), FT = /* @__PURE__ */ L(F, F.QUAD_SWAP_DIAGONAL).setParameterLength(1), BT = /* @__PURE__ */ L(F, F.SUBGROUP_BROADCAST).setParameterLength(2), UT = /* @__PURE__ */ L(F, F.SUBGROUP_SHUFFLE).setParameterLength(2), kT = /* @__PURE__ */ L(F, F.SUBGROUP_SHUFFLE_XOR).setParameterLength(2), DT = /* @__PURE__ */ L(F, F.SUBGROUP_SHUFFLE_UP).setParameterLength(2), WT = /* @__PURE__ */ L(F, F.SUBGROUP_SHUFFLE_DOWN).setParameterLength(2), qT = /* @__PURE__ */ L(F, F.QUAD_BROADCAST).setParameterLength(1);
let ma;
function dn(r) {
  ma = ma || /* @__PURE__ */ new WeakMap();
  let e = ma.get(r);
  return e === void 0 && ma.set(r, e = {}), e;
}
function ou(r) {
  const e = dn(r);
  return e.shadowMatrix || (e.shadowMatrix = q("mat4").setGroup(H).onRenderUpdate((t) => ((r.castShadow !== !0 || t.renderer.shadowMap.enabled === !1) && (r.shadow.camera.coordinateSystem !== t.camera.coordinateSystem && (r.shadow.camera.coordinateSystem = t.camera.coordinateSystem, r.shadow.camera.updateProjectionMatrix()), r.shadow.updateMatrices(r)), r.shadow.matrix)));
}
function jT(r, e = Ks) {
  const t = ou(r).mul(e);
  return t.xyz.div(t.w);
}
function Cm(r) {
  const e = dn(r);
  return e.position || (e.position = q(new M()).setGroup(H).onRenderUpdate((t, s) => s.value.setFromMatrixPosition(r.matrixWorld)));
}
function zm(r) {
  const e = dn(r);
  return e.targetPosition || (e.targetPosition = q(new M()).setGroup(H).onRenderUpdate((t, s) => s.value.setFromMatrixPosition(r.target.matrixWorld)));
}
function GT(r) {
  const e = dn(r);
  return e.viewPosition || (e.viewPosition = q(new M()).setGroup(H).onRenderUpdate(({ camera: t }, s) => {
    s.value = s.value || new M(), s.value.setFromMatrixPosition(r.matrixWorld), s.value.applyMatrix4(t.matrixWorldInverse);
  }));
}
const HT = (r) => dr.transformDirection(Cm(r).sub(zm(r))), XT = ys("vec3", "totalDiffuse"), $T = ys("vec3", "totalSpecular"), YT = ys("vec3", "outgoingLight"), ZT = (r) => r.sort((e, t) => e.id - t.id), JT = (r, e) => {
  for (const t of e)
    if (t.isAnalyticLightNode && t.light.id === r)
      return t;
  return null;
}, no = /* @__PURE__ */ new WeakMap(), ui = [];
class QT extends k {
  static get type() {
    return "LightsNode";
  }
  /**
   * Constructs a new lights node.
   */
  constructor() {
    super("vec3"), this.totalDiffuseNode = XT, this.totalSpecularNode = $T, this.outgoingLightNode = YT, this._lights = [], this.global = !0;
  }
  /**
   * Overwrites the default {@link Node#customCacheKey} implementation by including
   * light data into the cache key.
   *
   * @return {number} The custom cache key.
   */
  customCacheKey() {
    const e = this._lights;
    for (let s = 0; s < e.length; s++) {
      const i = e[s];
      if (ui.push(i.id), ui.push(i.castShadow ? 1 : 0), i.isSpotLight === !0) {
        const a = i.map !== null ? i.map.id : -1, n = i.colorNode ? i.colorNode.getCacheKey() : -1;
        ui.push(a, n);
      }
    }
    const t = Qo(ui);
    return ui.length = 0, t;
  }
  /**
   * Computes a hash value for identifying the current light nodes setup.
   *
   * @param {NodeBuilder} builder - A reference to the current node builder.
   * @return {string} The computed hash.
   */
  getHash(e) {
    const t = e.getDataFromNode(this);
    if (t.lightNodesHash === void 0) {
      const s = this.setupLightsNode(e);
      t.lightNodes = s;
      const i = [];
      for (const a of s)
        i.push(a.getHash());
      t.lightNodesHash = "lights-" + i.join(",");
    }
    return t.lightNodesHash;
  }
  /**
   * Analyzes the node's dependencies by building all nested light nodes
   * and the output node.
   *
   * @param {NodeBuilder} builder - A reference to the current node builder.
   */
  analyze(e) {
    const t = e.getNodeProperties(this);
    for (const s of t.nodes)
      s.build(e);
    t.outputNode.build(e);
  }
  /**
   * Creates lighting nodes for each scene light. This makes it possible to further
   * process lights in the node system.
   *
   * @param {NodeBuilder} builder - A reference to the current node builder.
   * @return {Array<LightingNode>} The array of lighting nodes.
   */
  setupLightsNode(e) {
    const t = e.getDataFromNode(this), s = [], i = t.lightNodes || null, a = e.context.materialLightings, n = ZT([...a, ...this._lights]), o = e.renderer.library;
    for (const l of n)
      if (l.isNode)
        s.push(l);
      else {
        let u = null;
        if (i !== null && (u = JT(l.id, i)), u === null) {
          const h = o.getLightNodeClass(l.constructor);
          if (h === null) {
            X(`LightsNode.setupNodeLights: Light node not found for ${l.constructor.name}`);
            continue;
          }
          no.has(l) === !1 && no.set(l, new h(l)), u = no.get(l);
        }
        s.push(u);
      }
    return s;
  }
  /**
   * Sets up a direct light in the lighting model.
   *
   * @param {Object} builder - The builder object containing the context and stack.
   * @param {Object} lightNode - The light node.
   * @param {Object} lightData - The light object containing color and direction properties.
   */
  setupDirectLight(e, t, s) {
    const { lightingModel: i, reflectedLight: a } = e.context;
    i.direct({
      ...s,
      lightNode: t,
      reflectedLight: a
    }, e);
  }
  /**
   * Sets up a direct rect area light in the lighting model.
   *
   * @param {Object} builder - The builder object containing the context and stack.
   * @param {Object} lightNode - The light node.
   * @param {Object} lightData - The light object containing color and area light properties.
   */
  setupDirectRectAreaLight(e, t, s) {
    const { lightingModel: i, reflectedLight: a } = e.context;
    i.directRectArea({
      ...s,
      lightNode: t,
      reflectedLight: a
    }, e);
  }
  /**
   * Setups the internal lights by building all respective
   * light nodes.
   *
   * @param {NodeBuilder} builder - A reference to the current node builder.
   * @param {Array<LightingNode>} lightNodes - An array of lighting nodes.
   */
  setupLights(e, t) {
    for (const s of t)
      s.build(e);
  }
  getLightNodes(e) {
    const t = e.getDataFromNode(this);
    return t.lightNodes === void 0 && (t.lightNodes = this.setupLightsNode(e)), t.lightNodes;
  }
  /**
   * The implementation makes sure that for each light in the scene
   * there is a corresponding light node. By building the light nodes
   * and evaluating the lighting model the outgoing light is computed.
   *
   * @param {NodeBuilder} builder - A reference to the current node builder.
   * @return {Node<vec3>} A node representing the outgoing light.
   */
  setup(e) {
    const t = e.lightsNode;
    e.lightsNode = this;
    let s = this.outgoingLightNode;
    const i = e.context, a = i.lightingModel, n = e.getNodeProperties(this);
    if (a) {
      const { totalDiffuseNode: o, totalSpecularNode: l } = this;
      i.outgoingLight = s;
      const u = e.addStack();
      n.nodes = u.nodes, a.start(e);
      const { backdrop: h, backdropAlpha: d } = i, { directDiffuse: p, directSpecular: m, indirectDiffuse: g, indirectSpecular: y } = i.reflectedLight;
      let v = p.add(g);
      h !== null && (d !== null ? v = N(d.mix(v, h)) : v = N(h)), o.assign(v), l.assign(m.add(y)), s.assign(o.add(l)), a.finish(e), s = s.bypass(e.removeStack());
    } else
      n.nodes = [];
    return e.lightsNode = t, s;
  }
  /**
   * Configures this node with an array of lights.
   *
   * @param {Array<Light>} lights - An array of lights.
   * @return {LightsNode} A reference to this node.
   */
  setLights(e) {
    return this._lights = e, this;
  }
  /**
   * Returns an array of the scene's lights.
   *
   * @return {Array<Light>} The scene's lights.
   */
  getLights() {
    return this._lights;
  }
  /**
   * Whether the scene has lights or not.
   *
   * @type {boolean}
   */
  get hasLights() {
    return this._lights.length > 0;
  }
}
const KT = (r = []) => new QT().setLights(r);
class ew extends k {
  static get type() {
    return "ShadowBaseNode";
  }
  /**
   * Constructs a new shadow base node.
   *
   * @param {Light} light - The shadow casting light.
   */
  constructor(e) {
    super(), this.light = e, this.updateBeforeType = Q.RENDER, this.isShadowBaseNode = !0;
  }
  /**
   * Setups the shadow position node which is by default the predefined TSL node object `shadowPositionWorld`.
   *
   * @param {NodeBuilder} object - A configuration object that must at least hold a material reference.
   */
  setupShadowPosition({ context: e, material: t }) {
    lu.assign(t.receivedShadowPositionNode || e.shadowPositionWorld || Ks);
  }
}
const lu = /* @__PURE__ */ ys("vec3", "shadowPositionWorld");
function tw(r, e = {}) {
  return e.toneMapping = r.toneMapping, e.toneMappingExposure = r.toneMappingExposure, e.outputColorSpace = r.outputColorSpace, e.renderTarget = r.getRenderTarget(), e.activeCubeFace = r.getActiveCubeFace(), e.activeMipmapLevel = r.getActiveMipmapLevel(), e.renderObjectFunction = r.getRenderObjectFunction(), e.pixelRatio = r.getPixelRatio(), e.mrt = r.getMRT(), e.clearColor = r.getClearColor(e.clearColor || new Yt()), e.clearAlpha = r.getClearAlpha(), e.autoClear = r.autoClear, e.scissorTest = r.getScissorTest(), e;
}
function sw(r, e) {
  return e = tw(r, e), r.setMRT(null), r.setRenderObjectFunction(null), r.setClearColor(0, 1), r.autoClear = !0, e;
}
function rw(r, e) {
  r.toneMapping = e.toneMapping, r.toneMappingExposure = e.toneMappingExposure, r.outputColorSpace = e.outputColorSpace, r.setRenderTarget(e.renderTarget, e.activeCubeFace, e.activeMipmapLevel), r.setRenderObjectFunction(e.renderObjectFunction), r.setPixelRatio(e.pixelRatio), r.setMRT(e.mrt), r.setClearColor(e.clearColor, e.clearAlpha), r.autoClear = e.autoClear, r.setScissorTest(e.scissorTest);
}
function iw(r, e = {}) {
  return e.background = r.background, e.backgroundNode = r.backgroundNode, e.overrideMaterial = r.overrideMaterial, e;
}
function aw(r, e) {
  return e = iw(r, e), r.background = null, r.backgroundNode = null, r.overrideMaterial = null, e;
}
function nw(r, e) {
  r.background = e.background, r.backgroundNode = e.backgroundNode, r.overrideMaterial = e.overrideMaterial;
}
function ow(r, e, t) {
  return t = sw(r, t), t = aw(e, t), t;
}
function lw(r, e, t) {
  rw(r, t), nw(e, t);
}
const Pa = /* @__PURE__ */ new WeakMap(), Rm = /* @__PURE__ */ b(({ depthTexture: r, shadowCoord: e, depthLayer: t }) => {
  let s = xe(r, e.xy).setName("t_basic");
  return r.isArrayTexture && (s = s.depth(t)), s.compare(e.z);
}), Em = /* @__PURE__ */ b(({ depthTexture: r, shadowCoord: e, shadow: t, depthLayer: s }) => {
  const i = (h, d) => {
    let p = xe(r, h);
    return r.isArrayTexture && (p = p.depth(s)), p.compare(d);
  }, a = Me("mapSize", "vec2", t).setGroup(H), n = Me("radius", "float", t).setGroup(H), o = B(1).div(a), l = n.mul(o.x), u = su(cr.xy).mul(6.28318530718);
  return Ae(
    i(e.xy.add(It(0, 5, u).mul(l)), e.z),
    i(e.xy.add(It(1, 5, u).mul(l)), e.z),
    i(e.xy.add(It(2, 5, u).mul(l)), e.z),
    i(e.xy.add(It(3, 5, u).mul(l)), e.z),
    i(e.xy.add(It(4, 5, u).mul(l)), e.z)
  ).mul(1 / 5);
}), Lm = /* @__PURE__ */ b(({ depthTexture: r, shadowCoord: e, shadow: t, depthLayer: s }) => {
  const i = Me("mapSize", "vec2", t).setGroup(H), a = B(1).div(i), n = e.xy, o = Bt(n.mul(i).add(0.5)).toConst();
  n.subAssign(o.sub(0.5).mul(a));
  const l = (m) => {
    let g = xe(r, n).offset(m).gather();
    return r.isArrayTexture && (g = g.depth(s)), g.compare(e.z);
  }, u = l(ye(-1, 1)).toConst(), h = l(ye(1, 1)).toConst(), d = l(ye(-1, -1)).toConst(), p = l(ye(1, -1)).toConst();
  return Ae(
    pe(u.x, h.y, o.x).add(u.y).add(h.x).mul(o.y),
    pe(u.w, h.z, o.x).add(u.z).add(h.w),
    pe(d.x, p.y, o.x).add(d.y).add(p.x),
    pe(d.w, p.z, o.x).add(d.z).add(p.w).mul(o.y.oneMinus())
  ).mul(1 / 9);
}), Im = /* @__PURE__ */ b(({ depthTexture: r, shadowCoord: e, depthLayer: t }, s) => {
  let i = xe(r).sample(e.xy);
  r.isArrayTexture && (i = i.depth(t)), i = i.rg;
  const a = i.x, n = Ee(1e-7, i.y.mul(i.y)), o = s.renderer.reversedDepthBuffer ? tr(a, e.z) : tr(e.z, a), l = f(1).toVar();
  return W(o.notEqual(1), () => {
    const u = e.z.sub(a);
    let h = n.div(n.add(u.mul(u)));
    h = Jt(K(h, 0.3).div(0.65)), l.assign(Ee(o, h));
  }), l;
}), Om = (r) => {
  let e = Pa.get(r);
  return e === void 0 && (e = new jr(), e.colorNode = D(0, 0, 0, 1), e.isShadowPassMaterial = !0, e.name = "ShadowMaterial", e.blending = ko, e.fog = !1, Pa.set(r, e)), e;
}, Pm = (r) => {
  const e = Pa.get(r);
  e !== void 0 && (e.dispose(), Pa.delete(r));
}, Th = /* @__PURE__ */ new D1(), Ar = [], Fm = (r, e, t, s) => {
  Ar[0] = r, Ar[1] = e;
  let i = Th.get(Ar);
  return (i === void 0 || i.shadowType !== t || i.useVelocity !== s) && (i = (a, n, o, l, u, h, d, p, m) => {
    (a.castShadow === !0 || a.receiveShadow && t === ya) && (s && (Vf(a).useVelocity = !0), a.onBeforeShadow(r, a, o, e.camera, l, n.overrideMaterial, h), r.renderObject(a, n, o, l, u, h, d, p, m), a.onAfterShadow(r, a, o, e.camera, l, n.overrideMaterial, h));
  }, i.shadowType = t, i.useVelocity = s, Th.set(Ar, i)), Ar[0] = null, Ar[1] = null, i;
}, uw = /* @__PURE__ */ b(({ samples: r, radius: e, size: t, shadowPass: s, depthLayer: i }) => {
  const a = f(0).toVar("meanVertical"), n = f(0).toVar("squareMeanVertical"), o = r.lessThanEqual(f(1)).select(f(0), f(2).div(r.sub(1))), l = r.lessThanEqual(f(1)).select(f(0), f(-1));
  le({ start: x(0), end: x(r), type: "int", condition: "<" }, ({ i: h }) => {
    const d = l.add(f(h).mul(o));
    let p = s.sample(Ae(cr.xy, B(0, d).mul(e)).div(t));
    s.value.isArrayTexture && (p = p.depth(i)), p = p.x, a.addAssign(p), n.addAssign(p.mul(p));
  }), a.divAssign(r), n.divAssign(r);
  const u = et(n.sub(a.mul(a)).max(0));
  return B(a, u);
}), hw = /* @__PURE__ */ b(({ samples: r, radius: e, size: t, shadowPass: s, depthLayer: i }) => {
  const a = f(0).toVar("meanHorizontal"), n = f(0).toVar("squareMeanHorizontal"), o = r.lessThanEqual(f(1)).select(f(0), f(2).div(r.sub(1))), l = r.lessThanEqual(f(1)).select(f(0), f(-1));
  le({ start: x(0), end: x(r), type: "int", condition: "<" }, ({ i: h }) => {
    const d = l.add(f(h).mul(o));
    let p = s.sample(Ae(cr.xy, B(d, 0).mul(e)).div(t));
    s.value.isArrayTexture && (p = p.depth(i)), a.addAssign(p.x), n.addAssign(Ae(p.y.mul(p.y), p.x.mul(p.x)));
  }), a.divAssign(r), n.divAssign(r);
  const u = et(n.sub(a.mul(a)).max(0));
  return B(a, u);
}), cw = [Rm, Em, Lm, Im];
let oo;
const ga = /* @__PURE__ */ new wm();
class Bm extends ew {
  static get type() {
    return "ShadowNode";
  }
  /**
   * Constructs a new shadow node.
   *
   * @param {Light} light - The shadow casting light.
   * @param {?LightShadow} [shadow=null] - An optional light shadow.
   */
  constructor(e, t = null) {
    super(e), this.shadow = t || e.shadow, this.shadowMap = null, this.vsmShadowMapVertical = null, this.vsmShadowMapHorizontal = null, this.vsmMaterialVertical = null, this.vsmMaterialHorizontal = null, this._node = null, this._currentShadowType = null, this._cameraFrameId = /* @__PURE__ */ new WeakMap(), this.isShadowNode = !0, this.depthLayer = 0;
  }
  /**
   * Setups the shadow filtering.
   *
   * @param {NodeBuilder} builder - A reference to the current node builder.
   * @param {Object} inputs - A configuration object that defines the shadow filtering.
   * @param {Function} inputs.filterFn - This function defines the filtering type of the shadow map e.g. PCF.
   * @param {DepthTexture} inputs.depthTexture - A reference to the shadow map's texture data.
   * @param {Node<vec3>} inputs.shadowCoord - Shadow coordinates which are used to sample from the shadow map.
   * @param {LightShadow} inputs.shadow - The light shadow.
   * @return {Node<float>} The result node of the shadow filtering.
   */
  setupShadowFilter(e, { filterFn: t, depthTexture: s, shadowCoord: i, shadow: a, depthLayer: n }) {
    const o = i.x.greaterThanEqual(0).and(i.x.lessThanEqual(1)).and(i.y.greaterThanEqual(0)).and(i.y.lessThanEqual(1)).and(i.z.lessThanEqual(1)), l = t({ depthTexture: s, shadowCoord: i, shadow: a, depthLayer: n });
    return o.select(l, f(1));
  }
  /**
   * Setups the shadow coordinates.
   *
   * @param {NodeBuilder} builder - A reference to the current node builder.
   * @param {Node<vec3>} shadowPosition - A node representing the shadow position.
   * @return {Node<vec3>} The shadow coordinates.
   */
  setupShadowCoord(e, t) {
    const { shadow: s } = this, { renderer: i } = e, a = s.biasNode || Me("bias", "float", s).setGroup(H);
    let n = t, o;
    if (s.camera.isOrthographicCamera || i.logarithmicDepthBuffer !== !0)
      n = n.xyz.div(n.w), o = n.z;
    else {
      const l = n.w;
      n = n.xy.div(l);
      const u = Me("near", "float", s.camera).setGroup(H), h = Me("far", "float", s.camera).setGroup(H);
      o = on(l.negate(), u, h);
    }
    return n = N(
      n.x,
      n.y.oneMinus(),
      // follow webgpu standards
      i.reversedDepthBuffer ? o.sub(a) : o.add(a)
    ), n;
  }
  /**
   * Returns the shadow filtering function for the given shadow type.
   *
   * @param {number} type - The shadow type.
   * @return {Function} The filtering function.
   */
  getShadowFilterFn(e) {
    return cw[e];
  }
  setupRenderTarget(e, t) {
    const s = new Hr(e.mapSize.width, e.mapSize.height);
    s.name = "ShadowDepthTexture", s.compareFunction = t.renderer.reversedDepthBuffer ? Na : jo;
    const i = t.createRenderTarget(e.mapSize.width, e.mapSize.height);
    return i.texture.name = "ShadowMap", i.texture.type = e.mapType, i.depthTexture = s, { shadowMap: i, depthTexture: s };
  }
  /**
   * Setups the shadow output node.
   *
   * @param {NodeBuilder} builder - A reference to the current node builder.
   * @return {Node<vec3>} The shadow output node.
   */
  setupShadow(e) {
    const { renderer: t, camera: s } = e, { light: i, shadow: a } = this, { depthTexture: n, shadowMap: o } = this.setupRenderTarget(a, e), l = t.shadowMap.type, u = t.hasCompatibility(Ih.TEXTURE_COMPARE);
    if ((l === pg || l === mg) && u ? (n.minFilter = ms, n.magFilter = ms) : (n.minFilter = at, n.magFilter = at), a.camera.coordinateSystem = s.coordinateSystem, a.camera.updateProjectionMatrix(), l === ya && a.isPointLightShadow !== !0) {
      n.compareFunction = null, o.depth > 1 ? (o._vsmShadowMapVertical || (o._vsmShadowMapVertical = e.createRenderTarget(a.mapSize.width, a.mapSize.height, { format: Rr, type: us, depth: o.depth, depthBuffer: !1 }), o._vsmShadowMapVertical.texture.name = "VSMVertical"), this.vsmShadowMapVertical = o._vsmShadowMapVertical, o._vsmShadowMapHorizontal || (o._vsmShadowMapHorizontal = e.createRenderTarget(a.mapSize.width, a.mapSize.height, { format: Rr, type: us, depth: o.depth, depthBuffer: !1 }), o._vsmShadowMapHorizontal.texture.name = "VSMHorizontal"), this.vsmShadowMapHorizontal = o._vsmShadowMapHorizontal) : (this.vsmShadowMapVertical = e.createRenderTarget(a.mapSize.width, a.mapSize.height, { format: Rr, type: us, depthBuffer: !1 }), this.vsmShadowMapHorizontal = e.createRenderTarget(a.mapSize.width, a.mapSize.height, { format: Rr, type: us, depthBuffer: !1 }));
      let z = xe(n);
      n.isArrayTexture && (z = z.depth(this.depthLayer));
      let R = xe(this.vsmShadowMapVertical.texture);
      n.isArrayTexture && (R = R.depth(this.depthLayer));
      const I = Me("blurSamples", "float", a).setGroup(H), G = Me("radius", "float", a).setGroup(H), $ = Me("mapSize", "vec2", a).setGroup(H);
      let Z = this.vsmMaterialVertical || (this.vsmMaterialVertical = new jr());
      Z.fragmentNode = uw({ samples: I, radius: G, size: $, shadowPass: z, depthLayer: this.depthLayer }).context(e.getSharedContext()), Z.name = "VSMVertical", Z = this.vsmMaterialHorizontal || (this.vsmMaterialHorizontal = new jr()), Z.fragmentNode = hw({ samples: I, radius: G, size: $, shadowPass: R, depthLayer: this.depthLayer }).context(e.getSharedContext()), Z.name = "VSMHorizontal";
    }
    const h = Me("intensity", "float", a).setGroup(H), d = Me("normalBias", "float", a).setGroup(H), p = ou(i), m = Ka.mul(d);
    let g;
    !t.highPrecision || e.material.receivedShadowPositionNode || e.context.shadowPositionWorld ? g = p.mul(lu.add(m)) : g = q("mat4").onObjectUpdate(({ object: z }, R) => R.value.multiplyMatrices(p.value, z.matrixWorld)).mul(Te).add(p.mul(D(m, 0)));
    const y = this.setupShadowCoord(e, g), v = a.filterNode || this.getShadowFilterFn(t.shadowMap.type) || null;
    if (v === null)
      throw new Error("THREE.WebGPURenderer: Shadow map type not supported yet.");
    const w = l === ya && a.isPointLightShadow !== !0 ? this.vsmShadowMapHorizontal.texture : n, _ = this.setupShadowFilter(e, { filterFn: v, shadowTexture: o.texture, depthTexture: w, shadowCoord: y, shadow: a, depthLayer: this.depthLayer });
    let C;
    t.shadowMap.transmitted === !0 && (o.texture.isCubeTexture ? C = bt(o.texture, y.xyz) : (C = xe(o.texture, y), n.isArrayTexture && (C = C.depth(this.depthLayer))));
    let V;
    C ? V = pe(1, _.rgb.mix(C, 1), h.mul(C.a)).toVar() : V = pe(1, _, h).toVar(), this.shadowMap = o, this.shadow.map = o;
    const P = `${this.light.type} Shadow [ ${this.light.name || "ID: " + this.light.id} ]`;
    return C && V.toInspector(`${P} / Color`, () => this.shadowMap.texture.isCubeTexture ? bt(this.shadowMap.texture, Oo()) : xe(this.shadowMap.texture)), V.toInspector(`${P} / Depth`, () => {
      const z = Me("near", "float", this.shadow.camera), R = Me("far", "float", this.shadow.camera);
      let I;
      this.shadowMap.texture.isCubeTexture ? I = bt(this.shadowMap.depthTexture, Oo()).r : I = xe(this.shadowMap.depthTexture).r;
      let G;
      return this.shadow.camera.isPerspectiveCamera ? G = nn(I, z, R) : G = $p(I, z, R), G = er(G, z, R), G.oneMinus();
    });
  }
  /**
   * The implementation performs the setup of the output node. An output is only
   * produces if shadow mapping is globally enabled in the renderer.
   *
   * @param {NodeBuilder} builder - A reference to the current node builder.
   * @return {ShaderCallNodeInternal} The output node.
   */
  setup(e) {
    if (e.renderer.shadowMap.enabled !== !1)
      return b(() => {
        const t = e.renderer.shadowMap.type;
        this._currentShadowType !== t && (this._reset(), this._node = null);
        let s = this._node;
        return this.setupShadowPosition(e), s === null && (this._node = s = this.setupShadow(e), this._currentShadowType = t), e.material.receivedShadowNode && (s = e.material.receivedShadowNode(s)), s;
      })();
  }
  /**
   * Renders the shadow. The logic of this function could be included
   * into {@link ShadowNode#updateShadow} however more specialized shadow
   * nodes might require a custom shadow map rendering. By having a
   * dedicated method, it's easier to overwrite the default behavior.
   *
   * @param {NodeFrame} frame - A reference to the current node frame.
   */
  renderShadow(e) {
    const { shadow: t, shadowMap: s, light: i } = this, { renderer: a, scene: n } = e;
    t.updateMatrices(i), s.setSize(t.mapSize.width, t.mapSize.height, s.depth);
    const o = n.name;
    n.name = `Shadow Map [ ${i.name || "ID: " + i.id} ]`, a.render(n, t.camera), n.name = o;
  }
  /**
   * Updates the shadow.
   *
   * @param {NodeFrame} frame - A reference to the current node frame.
   */
  updateShadow(e) {
    const { shadowMap: t, light: s, shadow: i } = this, { renderer: a, scene: n, camera: o } = e, l = a.shadowMap.type, u = t.depthTexture.version;
    this._depthVersionCached = u;
    const h = i.camera.layers.mask;
    (i.camera.layers.mask & 4294967294) === 0 && (i.camera.layers.mask = o.layers.mask);
    const d = a.getRenderObjectFunction(), p = a.getMRT(), m = p ? p.has("velocity") : !1;
    oo = ow(a, n, oo), n.overrideMaterial = Om(s), a.setRenderObjectFunction(Fm(a, i, l, m)), a.setClearColor(0, 0), a.setRenderTarget(t), this.renderShadow(e), a.setRenderObjectFunction(d), l === ya && i.isPointLightShadow !== !0 && this.vsmPass(a), i.camera.layers.mask = h, lw(a, n, oo);
  }
  /**
   * For VSM additional render passes are required.
   *
   * @param {Renderer} renderer - A reference to the current renderer.
   */
  vsmPass(e) {
    const { shadow: t } = this, s = this.shadowMap.depth;
    this.vsmShadowMapVertical.setSize(t.mapSize.width, t.mapSize.height, s), this.vsmShadowMapHorizontal.setSize(t.mapSize.width, t.mapSize.height, s), e.setRenderTarget(this.vsmShadowMapVertical), ga.material = this.vsmMaterialVertical, ga.render(e), e.setRenderTarget(this.vsmShadowMapHorizontal), ga.material = this.vsmMaterialHorizontal, ga.render(e);
  }
  /**
   * Frees the internal resources of this shadow node.
   */
  dispose() {
    this._reset(), super.dispose();
  }
  /**
   * Resets the resouce state of this shadow node.
   *
   * @private
   */
  _reset() {
    this._currentShadowType = null, Pm(this.light), this.shadowMap && (this.shadowMap.dispose(), this.shadowMap = null), this.vsmShadowMapVertical !== null && (this.vsmShadowMapVertical.dispose(), this.vsmShadowMapVertical = null, this.vsmMaterialVertical.dispose(), this.vsmMaterialVertical = null), this.vsmShadowMapHorizontal !== null && (this.vsmShadowMapHorizontal.dispose(), this.vsmShadowMapHorizontal = null, this.vsmMaterialHorizontal.dispose(), this.vsmMaterialHorizontal = null);
  }
  /**
   * The implementation performs the update of the shadow map if necessary.
   *
   * @param {NodeFrame} frame - A reference to the current node frame.
   */
  updateBefore(e) {
    const { shadow: t } = this;
    let s = t.needsUpdate || t.autoUpdate;
    s && (this._cameraFrameId[e.camera] === e.frameId && (s = !1), this._cameraFrameId[e.camera] = e.frameId), s && (this.updateShadow(e), this.shadowMap.depthTexture.version === this._depthVersionCached && (t.needsUpdate = !1));
  }
}
const dw = (r, e) => new Bm(r, e), pw = /* @__PURE__ */ new Yt(), wh = /* @__PURE__ */ new de(), hi = /* @__PURE__ */ new M(), lo = /* @__PURE__ */ new M(), mw = [
  /* @__PURE__ */ new M(1, 0, 0),
  /* @__PURE__ */ new M(-1, 0, 0),
  /* @__PURE__ */ new M(0, -1, 0),
  /* @__PURE__ */ new M(0, 1, 0),
  /* @__PURE__ */ new M(0, 0, 1),
  /* @__PURE__ */ new M(0, 0, -1)
], gw = [
  /* @__PURE__ */ new M(0, -1, 0),
  /* @__PURE__ */ new M(0, -1, 0),
  /* @__PURE__ */ new M(0, 0, -1),
  /* @__PURE__ */ new M(0, 0, 1),
  /* @__PURE__ */ new M(0, -1, 0),
  /* @__PURE__ */ new M(0, -1, 0)
], fw = [
  /* @__PURE__ */ new M(1, 0, 0),
  /* @__PURE__ */ new M(-1, 0, 0),
  /* @__PURE__ */ new M(0, 1, 0),
  /* @__PURE__ */ new M(0, -1, 0),
  /* @__PURE__ */ new M(0, 0, 1),
  /* @__PURE__ */ new M(0, 0, -1)
], yw = [
  /* @__PURE__ */ new M(0, -1, 0),
  /* @__PURE__ */ new M(0, -1, 0),
  /* @__PURE__ */ new M(0, 0, 1),
  /* @__PURE__ */ new M(0, 0, -1),
  /* @__PURE__ */ new M(0, -1, 0),
  /* @__PURE__ */ new M(0, -1, 0)
], Um = /* @__PURE__ */ b(({ depthTexture: r, bd3D: e, dp: t }) => bt(r, e).compare(t)), km = /* @__PURE__ */ b(({ depthTexture: r, bd3D: e, dp: t, shadow: s }) => {
  const i = Me("radius", "float", s).setGroup(H), a = Me("mapSize", "vec2", s).setGroup(H), n = i.div(a.x), o = he(e), l = it(gs(e, o.x.greaterThan(o.z).select(N(0, 1, 0), N(1, 0, 0)))), u = gs(e, l), h = su(cr.xy).mul(6.28318530718), d = It(0, 5, h), p = It(1, 5, h), m = It(2, 5, h), g = It(3, 5, h), y = It(4, 5, h);
  return bt(r, e.add(l.mul(d.x).add(u.mul(d.y)).mul(n))).compare(t).add(bt(r, e.add(l.mul(p.x).add(u.mul(p.y)).mul(n))).compare(t)).add(bt(r, e.add(l.mul(m.x).add(u.mul(m.y)).mul(n))).compare(t)).add(bt(r, e.add(l.mul(g.x).add(u.mul(g.y)).mul(n))).compare(t)).add(bt(r, e.add(l.mul(y.x).add(u.mul(y.y)).mul(n))).compare(t)).mul(1 / 5);
}), xw = /* @__PURE__ */ b(({ filterFn: r, depthTexture: e, shadowCoord: t, shadow: s }, i) => {
  const a = t.xyz.toConst(), n = a.abs().toConst(), o = n.x.max(n.y).max(n.z), l = q("float").setGroup(H).onRenderUpdate(() => s.camera.near), u = q("float").setGroup(H).onRenderUpdate(() => s.camera.far), h = Me("bias", "float", s).setGroup(H), d = f(1).toVar();
  return W(o.sub(u).lessThanEqual(0).and(o.sub(l).greaterThanEqual(0)), () => {
    let p;
    i.renderer.reversedDepthBuffer ? (p = Yp(o.negate(), l, u), p.subAssign(h)) : i.renderer.logarithmicDepthBuffer ? (p = on(o.negate(), l, u), p.addAssign(h)) : (p = Zl(o.negate(), l, u), p.addAssign(h));
    const m = a.normalize();
    d.assign(r({ depthTexture: e, bd3D: m, dp: p, shadow: s }));
  }), d;
});
class bw extends Bm {
  static get type() {
    return "PointShadowNode";
  }
  /**
   * Constructs a new point shadow node.
   *
   * @param {PointLight} light - The shadow casting point light.
   * @param {?PointLightShadow} [shadow=null] - An optional point light shadow.
   */
  constructor(e, t = null) {
    super(e, t);
  }
  /**
   * Overwrites the default implementation to return point light shadow specific
   * filtering functions.
   *
   * @param {number} type - The shadow type.
   * @return {Function} The filtering function.
   */
  getShadowFilterFn(e) {
    return e === dg ? Um : km;
  }
  /**
   * Overwrites the default implementation so the unaltered shadow position is used.
   *
   * @param {NodeBuilder} builder - A reference to the current node builder.
   * @param {Node<vec3>} shadowPosition - A node representing the shadow position.
   * @return {Node<vec3>} The shadow coordinates.
   */
  setupShadowCoord(e, t) {
    return t;
  }
  /**
   * Overwrites the default implementation to only use point light specific
   * shadow filter functions.
   *
   * @param {NodeBuilder} builder - A reference to the current node builder.
   * @param {Object} inputs - A configuration object that defines the shadow filtering.
   * @param {Function} inputs.filterFn - This function defines the filtering type of the shadow map e.g. PCF.
   * @param {DepthTexture} inputs.depthTexture - A reference to the shadow map's depth texture.
   * @param {Node<vec3>} inputs.shadowCoord - Shadow coordinates which are used to sample from the shadow map.
   * @param {LightShadow} inputs.shadow - The light shadow.
   * @return {Node<float>} The result node of the shadow filtering.
   */
  setupShadowFilter(e, { filterFn: t, depthTexture: s, shadowCoord: i, shadow: a }) {
    return xw({ filterFn: t, depthTexture: s, shadowCoord: i, shadow: a });
  }
  /**
   * Overwrites the default implementation to create a CubeRenderTarget with CubeDepthTexture.
   *
   * @param {LightShadow} shadow - The light shadow object.
   * @param {NodeBuilder} builder - A reference to the current node builder.
   * @return {Object} An object containing the shadow map and depth texture.
   */
  setupRenderTarget(e, t) {
    const s = new ff(e.mapSize.width);
    s.name = "PointShadowDepthTexture", s.compareFunction = t.renderer.reversedDepthBuffer ? Na : jo;
    const i = t.createCubeRenderTarget(e.mapSize.width);
    return i.texture.name = "PointShadowMap", i.depthTexture = s, { shadowMap: i, depthTexture: s };
  }
  /**
   * Overwrites the default implementation with point light specific
   * rendering code.
   *
   * @param {NodeFrame} frame - A reference to the current node frame.
   */
  renderShadow(e) {
    const { shadow: t, shadowMap: s, light: i } = this, { renderer: a, scene: n } = e, o = t.camera, l = t.matrix, u = a.coordinateSystem === Ls, h = u ? mw : fw, d = u ? gw : yw;
    s.setSize(t.mapSize.width, t.mapSize.width);
    const p = a.autoClear, m = a.getClearColor(pw), g = a.getClearAlpha();
    a.autoClear = !1, a.setClearColor(t.clearColor, t.clearAlpha);
    for (let y = 0; y < 6; y++) {
      a.setRenderTarget(s, y), a.clear();
      const v = i.distance || o.far;
      v !== o.far && (o.far = v, o.updateProjectionMatrix()), hi.setFromMatrixPosition(i.matrixWorld), o.position.copy(hi), lo.copy(o.position), lo.add(h[y]), o.up.copy(d[y]), o.lookAt(lo), o.updateMatrixWorld(), l.makeTranslation(-hi.x, -hi.y, -hi.z), wh.multiplyMatrices(o.projectionMatrix, o.matrixWorldInverse), t._frustum.setFromProjectionMatrix(wh, o.coordinateSystem, o.reversedDepth);
      const w = n.name;
      n.name = `Point Light Shadow [ ${i.name || "ID: " + i.id} ] - Face ${y + 1}`, a.render(n, o), n.name = w;
    }
    a.autoClear = p, a.setClearColor(m, g);
  }
}
const vw = (r, e) => new bw(r, e), Dm = /* @__PURE__ */ b(({ lightDistance: r, cutoffDistance: e, decayExponent: t }) => {
  const s = r.pow(t).max(0.01).reciprocal();
  return e.greaterThan(0).select(
    s.mul(r.div(e).pow4().oneMinus().clamp().pow2()),
    s
  );
}), Tw = ({ color: r, lightVector: e, cutoffDistance: t, decayExponent: s }) => {
  const i = e.normalize(), a = e.length(), n = Dm({
    lightDistance: a,
    cutoffDistance: t,
    decayExponent: s
  }), o = r.mul(n);
  return { lightDirection: i, lightColor: o };
}, ww = /* @__PURE__ */ b(([r = ae()]) => {
  const e = r.mul(2), t = e.x.floor(), s = e.y.floor();
  return t.add(s).mod(2).sign();
}), Nw = b(([r = ae()], { renderer: e, material: t }) => {
  const s = Tl(r.mul(2).sub(1));
  let i;
  if (t.alphaToCoverage && e.currentSamples > 0) {
    const a = f(s.fwidth()).toVar();
    i = Qt(a.oneMinus(), a.add(1), s).oneMinus();
  } else
    i = He(s.greaterThan(1), 0, 1);
  return i;
}), fi = /* @__PURE__ */ b(([r, e, t]) => {
  const s = f(t).toVar(), i = f(e).toVar(), a = mt(r).toVar();
  return He(a, i, s).uniformFlow();
}).setLayout({
  name: "mx_select",
  type: "float",
  inputs: [
    { name: "b", type: "bool" },
    { name: "t", type: "float" },
    { name: "f", type: "float" }
  ]
}), Fa = /* @__PURE__ */ b(([r, e]) => {
  const t = mt(e).toVar(), s = f(r).toVar();
  return He(t, s.negate(), s).uniformFlow();
}).setLayout({
  name: "mx_negate_if",
  type: "float",
  inputs: [
    { name: "val", type: "float" },
    { name: "b", type: "bool" }
  ]
}), Se = /* @__PURE__ */ b(([r]) => {
  const e = f(r).toVar();
  return x(Xt(e));
}).setLayout({
  name: "mx_floor",
  type: "int",
  inputs: [
    { name: "x", type: "float" }
  ]
}), fe = /* @__PURE__ */ b(([r, e]) => {
  const t = f(r).toVar();
  return e.assign(Se(t)), t.sub(f(e));
}), Mw = /* @__PURE__ */ b(([r, e, t, s, i, a]) => {
  const n = f(a).toVar(), o = f(i).toVar(), l = f(s).toVar(), u = f(t).toVar(), h = f(e).toVar(), d = f(r).toVar(), p = f(K(1, o)).toVar();
  return K(1, n).mul(d.mul(p).add(h.mul(o))).add(n.mul(u.mul(p).add(l.mul(o))));
}).setLayout({
  name: "mx_bilerp_0",
  type: "float",
  inputs: [
    { name: "v0", type: "float" },
    { name: "v1", type: "float" },
    { name: "v2", type: "float" },
    { name: "v3", type: "float" },
    { name: "s", type: "float" },
    { name: "t", type: "float" }
  ]
}), Sw = /* @__PURE__ */ b(([r, e, t, s, i, a]) => {
  const n = f(a).toVar(), o = f(i).toVar(), l = N(s).toVar(), u = N(t).toVar(), h = N(e).toVar(), d = N(r).toVar(), p = f(K(1, o)).toVar();
  return K(1, n).mul(d.mul(p).add(h.mul(o))).add(n.mul(u.mul(p).add(l.mul(o))));
}).setLayout({
  name: "mx_bilerp_1",
  type: "vec3",
  inputs: [
    { name: "v0", type: "vec3" },
    { name: "v1", type: "vec3" },
    { name: "v2", type: "vec3" },
    { name: "v3", type: "vec3" },
    { name: "s", type: "float" },
    { name: "t", type: "float" }
  ]
}), Wm = /* @__PURE__ */ De([Mw, Sw]), _w = /* @__PURE__ */ b(([r, e, t, s, i, a, n, o, l, u, h]) => {
  const d = f(h).toVar(), p = f(u).toVar(), m = f(l).toVar(), g = f(o).toVar(), y = f(n).toVar(), v = f(a).toVar(), w = f(i).toVar(), _ = f(s).toVar(), C = f(t).toVar(), V = f(e).toVar(), P = f(r).toVar(), z = f(K(1, m)).toVar(), R = f(K(1, p)).toVar();
  return f(K(1, d)).toVar().mul(R.mul(P.mul(z).add(V.mul(m))).add(p.mul(C.mul(z).add(_.mul(m))))).add(d.mul(R.mul(w.mul(z).add(v.mul(m))).add(p.mul(y.mul(z).add(g.mul(m))))));
}).setLayout({
  name: "mx_trilerp_0",
  type: "float",
  inputs: [
    { name: "v0", type: "float" },
    { name: "v1", type: "float" },
    { name: "v2", type: "float" },
    { name: "v3", type: "float" },
    { name: "v4", type: "float" },
    { name: "v5", type: "float" },
    { name: "v6", type: "float" },
    { name: "v7", type: "float" },
    { name: "s", type: "float" },
    { name: "t", type: "float" },
    { name: "r", type: "float" }
  ]
}), Aw = /* @__PURE__ */ b(([r, e, t, s, i, a, n, o, l, u, h]) => {
  const d = f(h).toVar(), p = f(u).toVar(), m = f(l).toVar(), g = N(o).toVar(), y = N(n).toVar(), v = N(a).toVar(), w = N(i).toVar(), _ = N(s).toVar(), C = N(t).toVar(), V = N(e).toVar(), P = N(r).toVar(), z = f(K(1, m)).toVar(), R = f(K(1, p)).toVar();
  return f(K(1, d)).toVar().mul(R.mul(P.mul(z).add(V.mul(m))).add(p.mul(C.mul(z).add(_.mul(m))))).add(d.mul(R.mul(w.mul(z).add(v.mul(m))).add(p.mul(y.mul(z).add(g.mul(m))))));
}).setLayout({
  name: "mx_trilerp_1",
  type: "vec3",
  inputs: [
    { name: "v0", type: "vec3" },
    { name: "v1", type: "vec3" },
    { name: "v2", type: "vec3" },
    { name: "v3", type: "vec3" },
    { name: "v4", type: "vec3" },
    { name: "v5", type: "vec3" },
    { name: "v6", type: "vec3" },
    { name: "v7", type: "vec3" },
    { name: "s", type: "float" },
    { name: "t", type: "float" },
    { name: "r", type: "float" }
  ]
}), qm = /* @__PURE__ */ De([_w, Aw]), Vw = /* @__PURE__ */ b(([r, e, t]) => {
  const s = f(t).toVar(), i = f(e).toVar(), a = E(r).toVar(), n = E(a.bitAnd(E(7))).toVar(), o = f(fi(n.lessThan(E(4)), i, s)).toVar(), l = f(j(2, fi(n.lessThan(E(4)), s, i))).toVar();
  return Fa(o, mt(n.bitAnd(E(1)))).add(Fa(l, mt(n.bitAnd(E(2)))));
}).setLayout({
  name: "mx_gradient_float_0",
  type: "float",
  inputs: [
    { name: "hash", type: "uint" },
    { name: "x", type: "float" },
    { name: "y", type: "float" }
  ]
}), Cw = /* @__PURE__ */ b(([r, e, t, s]) => {
  const i = f(s).toVar(), a = f(t).toVar(), n = f(e).toVar(), o = E(r).toVar(), l = E(o.bitAnd(E(15))).toVar(), u = f(fi(l.lessThan(E(8)), n, a)).toVar(), h = f(fi(l.lessThan(E(4)), a, fi(l.equal(E(12)).or(l.equal(E(14))), n, i))).toVar();
  return Fa(u, mt(l.bitAnd(E(1)))).add(Fa(h, mt(l.bitAnd(E(2)))));
}).setLayout({
  name: "mx_gradient_float_1",
  type: "float",
  inputs: [
    { name: "hash", type: "uint" },
    { name: "x", type: "float" },
    { name: "y", type: "float" },
    { name: "z", type: "float" }
  ]
}), Fe = /* @__PURE__ */ De([Vw, Cw]), zw = /* @__PURE__ */ b(([r, e, t]) => {
  const s = f(t).toVar(), i = f(e).toVar(), a = or(r).toVar();
  return N(Fe(a.x, i, s), Fe(a.y, i, s), Fe(a.z, i, s));
}).setLayout({
  name: "mx_gradient_vec3_0",
  type: "vec3",
  inputs: [
    { name: "hash", type: "uvec3" },
    { name: "x", type: "float" },
    { name: "y", type: "float" }
  ]
}), Rw = /* @__PURE__ */ b(([r, e, t, s]) => {
  const i = f(s).toVar(), a = f(t).toVar(), n = f(e).toVar(), o = or(r).toVar();
  return N(Fe(o.x, n, a, i), Fe(o.y, n, a, i), Fe(o.z, n, a, i));
}).setLayout({
  name: "mx_gradient_vec3_1",
  type: "vec3",
  inputs: [
    { name: "hash", type: "uvec3" },
    { name: "x", type: "float" },
    { name: "y", type: "float" },
    { name: "z", type: "float" }
  ]
}), yt = /* @__PURE__ */ De([zw, Rw]), Ew = /* @__PURE__ */ b(([r]) => {
  const e = f(r).toVar();
  return j(0.6616, e);
}).setLayout({
  name: "mx_gradient_scale2d_0",
  type: "float",
  inputs: [
    { name: "v", type: "float" }
  ]
}), Lw = /* @__PURE__ */ b(([r]) => {
  const e = f(r).toVar();
  return j(0.982, e);
}).setLayout({
  name: "mx_gradient_scale3d_0",
  type: "float",
  inputs: [
    { name: "v", type: "float" }
  ]
}), Iw = /* @__PURE__ */ b(([r]) => {
  const e = N(r).toVar();
  return j(0.6616, e);
}).setLayout({
  name: "mx_gradient_scale2d_1",
  type: "vec3",
  inputs: [
    { name: "v", type: "vec3" }
  ]
}), jm = /* @__PURE__ */ De([Ew, Iw]), Ow = /* @__PURE__ */ b(([r]) => {
  const e = N(r).toVar();
  return j(0.982, e);
}).setLayout({
  name: "mx_gradient_scale3d_1",
  type: "vec3",
  inputs: [
    { name: "v", type: "vec3" }
  ]
}), Gm = /* @__PURE__ */ De([Lw, Ow]), ht = /* @__PURE__ */ b(([r, e]) => {
  const t = x(e).toVar(), s = E(r).toVar();
  return s.shiftLeft(t).bitOr(s.shiftRight(x(32).sub(t)));
}).setLayout({
  name: "mx_rotl32",
  type: "uint",
  inputs: [
    { name: "x", type: "uint" },
    { name: "k", type: "int" }
  ]
}), Hm = /* @__PURE__ */ b(([r, e, t]) => {
  r.subAssign(t), r.bitXorAssign(ht(t, x(4))), t.addAssign(e), e.subAssign(r), e.bitXorAssign(ht(r, x(6))), r.addAssign(t), t.subAssign(e), t.bitXorAssign(ht(e, x(8))), e.addAssign(r), r.subAssign(t), r.bitXorAssign(ht(t, x(16))), t.addAssign(e), e.subAssign(r), e.bitXorAssign(ht(r, x(19))), r.addAssign(t), t.subAssign(e), t.bitXorAssign(ht(e, x(4))), e.addAssign(r);
}), Vi = /* @__PURE__ */ b(([r, e, t]) => {
  const s = E(t).toVar(), i = E(e).toVar(), a = E(r).toVar();
  return s.bitXorAssign(i), s.subAssign(ht(i, x(14))), a.bitXorAssign(s), a.subAssign(ht(s, x(11))), i.bitXorAssign(a), i.subAssign(ht(a, x(25))), s.bitXorAssign(i), s.subAssign(ht(i, x(16))), a.bitXorAssign(s), a.subAssign(ht(s, x(4))), i.bitXorAssign(a), i.subAssign(ht(a, x(14))), s.bitXorAssign(i), s.subAssign(ht(i, x(24))), s;
}).setLayout({
  name: "mx_bjfinal",
  type: "uint",
  inputs: [
    { name: "a", type: "uint" },
    { name: "b", type: "uint" },
    { name: "c", type: "uint" }
  ]
}), Xe = /* @__PURE__ */ b(([r]) => {
  const e = E(r).toVar();
  return f(e).div(f(E(x(4294967295))));
}).setLayout({
  name: "mx_bits_to_01",
  type: "float",
  inputs: [
    { name: "bits", type: "uint" }
  ]
}), $t = /* @__PURE__ */ b(([r]) => {
  const e = f(r).toVar();
  return e.mul(e).mul(e).mul(e.mul(e.mul(6).sub(15)).add(10));
}).setLayout({
  name: "mx_fade",
  type: "float",
  inputs: [
    { name: "t", type: "float" }
  ]
}), Pw = /* @__PURE__ */ b(([r]) => {
  const e = x(r).toVar(), t = E(E(1)).toVar(), s = E(E(x(3735928559)).add(t.shiftLeft(E(2))).add(E(13))).toVar();
  return Vi(s.add(E(e)), s, s);
}).setLayout({
  name: "mx_hash_int_0",
  type: "uint",
  inputs: [
    { name: "x", type: "int" }
  ]
}), Fw = /* @__PURE__ */ b(([r, e]) => {
  const t = x(e).toVar(), s = x(r).toVar(), i = E(E(2)).toVar(), a = E().toVar(), n = E().toVar(), o = E().toVar();
  return a.assign(n.assign(o.assign(E(x(3735928559)).add(i.shiftLeft(E(2))).add(E(13))))), a.addAssign(E(s)), n.addAssign(E(t)), Vi(a, n, o);
}).setLayout({
  name: "mx_hash_int_1",
  type: "uint",
  inputs: [
    { name: "x", type: "int" },
    { name: "y", type: "int" }
  ]
}), Bw = /* @__PURE__ */ b(([r, e, t]) => {
  const s = x(t).toVar(), i = x(e).toVar(), a = x(r).toVar(), n = E(E(3)).toVar(), o = E().toVar(), l = E().toVar(), u = E().toVar();
  return o.assign(l.assign(u.assign(E(x(3735928559)).add(n.shiftLeft(E(2))).add(E(13))))), o.addAssign(E(a)), l.addAssign(E(i)), u.addAssign(E(s)), Vi(o, l, u);
}).setLayout({
  name: "mx_hash_int_2",
  type: "uint",
  inputs: [
    { name: "x", type: "int" },
    { name: "y", type: "int" },
    { name: "z", type: "int" }
  ]
}), Uw = /* @__PURE__ */ b(([r, e, t, s]) => {
  const i = x(s).toVar(), a = x(t).toVar(), n = x(e).toVar(), o = x(r).toVar(), l = E(E(4)).toVar(), u = E().toVar(), h = E().toVar(), d = E().toVar();
  return u.assign(h.assign(d.assign(E(x(3735928559)).add(l.shiftLeft(E(2))).add(E(13))))), u.addAssign(E(o)), h.addAssign(E(n)), d.addAssign(E(a)), Hm(u, h, d), u.addAssign(E(i)), Vi(u, h, d);
}).setLayout({
  name: "mx_hash_int_3",
  type: "uint",
  inputs: [
    { name: "x", type: "int" },
    { name: "y", type: "int" },
    { name: "z", type: "int" },
    { name: "xx", type: "int" }
  ]
}), kw = /* @__PURE__ */ b(([r, e, t, s, i]) => {
  const a = x(i).toVar(), n = x(s).toVar(), o = x(t).toVar(), l = x(e).toVar(), u = x(r).toVar(), h = E(E(5)).toVar(), d = E().toVar(), p = E().toVar(), m = E().toVar();
  return d.assign(p.assign(m.assign(E(x(3735928559)).add(h.shiftLeft(E(2))).add(E(13))))), d.addAssign(E(u)), p.addAssign(E(l)), m.addAssign(E(o)), Hm(d, p, m), d.addAssign(E(n)), p.addAssign(E(a)), Vi(d, p, m);
}).setLayout({
  name: "mx_hash_int_4",
  type: "uint",
  inputs: [
    { name: "x", type: "int" },
    { name: "y", type: "int" },
    { name: "z", type: "int" },
    { name: "xx", type: "int" },
    { name: "yy", type: "int" }
  ]
}), ne = /* @__PURE__ */ De([Pw, Fw, Bw, Uw, kw]), Dw = /* @__PURE__ */ b(([r, e]) => {
  const t = x(e).toVar(), s = x(r).toVar(), i = E(ne(s, t)).toVar(), a = or().toVar();
  return a.x.assign(i.bitAnd(x(255))), a.y.assign(i.shiftRight(x(8)).bitAnd(x(255))), a.z.assign(i.shiftRight(x(16)).bitAnd(x(255))), a;
}).setLayout({
  name: "mx_hash_vec3_0",
  type: "uvec3",
  inputs: [
    { name: "x", type: "int" },
    { name: "y", type: "int" }
  ]
}), Ww = /* @__PURE__ */ b(([r, e, t]) => {
  const s = x(t).toVar(), i = x(e).toVar(), a = x(r).toVar(), n = E(ne(a, i, s)).toVar(), o = or().toVar();
  return o.x.assign(n.bitAnd(x(255))), o.y.assign(n.shiftRight(x(8)).bitAnd(x(255))), o.z.assign(n.shiftRight(x(16)).bitAnd(x(255))), o;
}).setLayout({
  name: "mx_hash_vec3_1",
  type: "uvec3",
  inputs: [
    { name: "x", type: "int" },
    { name: "y", type: "int" },
    { name: "z", type: "int" }
  ]
}), xt = /* @__PURE__ */ De([Dw, Ww]), qw = /* @__PURE__ */ b(([r]) => {
  const e = B(r).toVar(), t = x().toVar(), s = x().toVar(), i = f(fe(e.x, t)).toVar(), a = f(fe(e.y, s)).toVar(), n = f($t(i)).toVar(), o = f($t(a)).toVar(), l = f(Wm(Fe(ne(t, s), i, a), Fe(ne(t.add(x(1)), s), i.sub(1), a), Fe(ne(t, s.add(x(1))), i, a.sub(1)), Fe(ne(t.add(x(1)), s.add(x(1))), i.sub(1), a.sub(1)), n, o)).toVar();
  return jm(l);
}).setLayout({
  name: "mx_perlin_noise_float_0",
  type: "float",
  inputs: [
    { name: "p", type: "vec2" }
  ]
}), jw = /* @__PURE__ */ b(([r]) => {
  const e = N(r).toVar(), t = x().toVar(), s = x().toVar(), i = x().toVar(), a = f(fe(e.x, t)).toVar(), n = f(fe(e.y, s)).toVar(), o = f(fe(e.z, i)).toVar(), l = f($t(a)).toVar(), u = f($t(n)).toVar(), h = f($t(o)).toVar(), d = f(qm(Fe(ne(t, s, i), a, n, o), Fe(ne(t.add(x(1)), s, i), a.sub(1), n, o), Fe(ne(t, s.add(x(1)), i), a, n.sub(1), o), Fe(ne(t.add(x(1)), s.add(x(1)), i), a.sub(1), n.sub(1), o), Fe(ne(t, s, i.add(x(1))), a, n, o.sub(1)), Fe(ne(t.add(x(1)), s, i.add(x(1))), a.sub(1), n, o.sub(1)), Fe(ne(t, s.add(x(1)), i.add(x(1))), a, n.sub(1), o.sub(1)), Fe(ne(t.add(x(1)), s.add(x(1)), i.add(x(1))), a.sub(1), n.sub(1), o.sub(1)), l, u, h)).toVar();
  return Gm(d);
}).setLayout({
  name: "mx_perlin_noise_float_1",
  type: "float",
  inputs: [
    { name: "p", type: "vec3" }
  ]
}), uu = /* @__PURE__ */ De([qw, jw]), Gw = /* @__PURE__ */ b(([r]) => {
  const e = B(r).toVar(), t = x().toVar(), s = x().toVar(), i = f(fe(e.x, t)).toVar(), a = f(fe(e.y, s)).toVar(), n = f($t(i)).toVar(), o = f($t(a)).toVar(), l = N(Wm(yt(xt(t, s), i, a), yt(xt(t.add(x(1)), s), i.sub(1), a), yt(xt(t, s.add(x(1))), i, a.sub(1)), yt(xt(t.add(x(1)), s.add(x(1))), i.sub(1), a.sub(1)), n, o)).toVar();
  return jm(l);
}).setLayout({
  name: "mx_perlin_noise_vec3_0",
  type: "vec3",
  inputs: [
    { name: "p", type: "vec2" }
  ]
}), Hw = /* @__PURE__ */ b(([r]) => {
  const e = N(r).toVar(), t = x().toVar(), s = x().toVar(), i = x().toVar(), a = f(fe(e.x, t)).toVar(), n = f(fe(e.y, s)).toVar(), o = f(fe(e.z, i)).toVar(), l = f($t(a)).toVar(), u = f($t(n)).toVar(), h = f($t(o)).toVar(), d = N(qm(yt(xt(t, s, i), a, n, o), yt(xt(t.add(x(1)), s, i), a.sub(1), n, o), yt(xt(t, s.add(x(1)), i), a, n.sub(1), o), yt(xt(t.add(x(1)), s.add(x(1)), i), a.sub(1), n.sub(1), o), yt(xt(t, s, i.add(x(1))), a, n, o.sub(1)), yt(xt(t.add(x(1)), s, i.add(x(1))), a.sub(1), n, o.sub(1)), yt(xt(t, s.add(x(1)), i.add(x(1))), a, n.sub(1), o.sub(1)), yt(xt(t.add(x(1)), s.add(x(1)), i.add(x(1))), a.sub(1), n.sub(1), o.sub(1)), l, u, h)).toVar();
  return Gm(d);
}).setLayout({
  name: "mx_perlin_noise_vec3_1",
  type: "vec3",
  inputs: [
    { name: "p", type: "vec3" }
  ]
}), Ci = /* @__PURE__ */ De([Gw, Hw]), Xw = /* @__PURE__ */ b(([r]) => {
  const e = f(r).toVar(), t = x(Se(e)).toVar();
  return Xe(ne(t));
}).setLayout({
  name: "mx_cell_noise_float_0",
  type: "float",
  inputs: [
    { name: "p", type: "float" }
  ]
}), $w = /* @__PURE__ */ b(([r]) => {
  const e = B(r).toVar(), t = x(Se(e.x)).toVar(), s = x(Se(e.y)).toVar();
  return Xe(ne(t, s));
}).setLayout({
  name: "mx_cell_noise_float_1",
  type: "float",
  inputs: [
    { name: "p", type: "vec2" }
  ]
}), Yw = /* @__PURE__ */ b(([r]) => {
  const e = N(r).toVar(), t = x(Se(e.x)).toVar(), s = x(Se(e.y)).toVar(), i = x(Se(e.z)).toVar();
  return Xe(ne(t, s, i));
}).setLayout({
  name: "mx_cell_noise_float_2",
  type: "float",
  inputs: [
    { name: "p", type: "vec3" }
  ]
}), Zw = /* @__PURE__ */ b(([r]) => {
  const e = D(r).toVar(), t = x(Se(e.x)).toVar(), s = x(Se(e.y)).toVar(), i = x(Se(e.z)).toVar(), a = x(Se(e.w)).toVar();
  return Xe(ne(t, s, i, a));
}).setLayout({
  name: "mx_cell_noise_float_3",
  type: "float",
  inputs: [
    { name: "p", type: "vec4" }
  ]
}), Jw = /* @__PURE__ */ De([Xw, $w, Yw, Zw]), Qw = /* @__PURE__ */ b(([r]) => {
  const e = f(r).toVar(), t = x(Se(e)).toVar();
  return N(Xe(ne(t, x(0))), Xe(ne(t, x(1))), Xe(ne(t, x(2))));
}).setLayout({
  name: "mx_cell_noise_vec3_0",
  type: "vec3",
  inputs: [
    { name: "p", type: "float" }
  ]
}), Kw = /* @__PURE__ */ b(([r]) => {
  const e = B(r).toVar(), t = x(Se(e.x)).toVar(), s = x(Se(e.y)).toVar();
  return N(Xe(ne(t, s, x(0))), Xe(ne(t, s, x(1))), Xe(ne(t, s, x(2))));
}).setLayout({
  name: "mx_cell_noise_vec3_1",
  type: "vec3",
  inputs: [
    { name: "p", type: "vec2" }
  ]
}), eN = /* @__PURE__ */ b(([r]) => {
  const e = N(r).toVar(), t = x(Se(e.x)).toVar(), s = x(Se(e.y)).toVar(), i = x(Se(e.z)).toVar();
  return N(Xe(ne(t, s, i, x(0))), Xe(ne(t, s, i, x(1))), Xe(ne(t, s, i, x(2))));
}).setLayout({
  name: "mx_cell_noise_vec3_2",
  type: "vec3",
  inputs: [
    { name: "p", type: "vec3" }
  ]
}), tN = /* @__PURE__ */ b(([r]) => {
  const e = D(r).toVar(), t = x(Se(e.x)).toVar(), s = x(Se(e.y)).toVar(), i = x(Se(e.z)).toVar(), a = x(Se(e.w)).toVar();
  return N(Xe(ne(t, s, i, a, x(0))), Xe(ne(t, s, i, a, x(1))), Xe(ne(t, s, i, a, x(2))));
}).setLayout({
  name: "mx_cell_noise_vec3_3",
  type: "vec3",
  inputs: [
    { name: "p", type: "vec4" }
  ]
}), pn = /* @__PURE__ */ De([Qw, Kw, eN, tN]), Ba = /* @__PURE__ */ b(([r, e, t, s]) => {
  const i = f(s).toVar(), a = f(t).toVar(), n = x(e).toVar(), o = N(r).toVar(), l = f(0).toVar(), u = f(1).toVar();
  return le(n, () => {
    l.addAssign(u.mul(uu(o))), u.mulAssign(i), o.mulAssign(a);
  }), l;
}).setLayout({
  name: "mx_fractal_noise_float",
  type: "float",
  inputs: [
    { name: "p", type: "vec3" },
    { name: "octaves", type: "int" },
    { name: "lacunarity", type: "float" },
    { name: "diminish", type: "float" }
  ]
}), mn = /* @__PURE__ */ b(([r, e, t, s]) => {
  const i = f(s).toVar(), a = f(t).toVar(), n = x(e).toVar(), o = N(r).toVar(), l = N(0).toVar(), u = f(1).toVar();
  return le(n, () => {
    l.addAssign(u.mul(Ci(o))), u.mulAssign(i), o.mulAssign(a);
  }), l;
}).setLayout({
  name: "mx_fractal_noise_vec3",
  type: "vec3",
  inputs: [
    { name: "p", type: "vec3" },
    { name: "octaves", type: "int" },
    { name: "lacunarity", type: "float" },
    { name: "diminish", type: "float" }
  ]
}), sN = /* @__PURE__ */ b(([r, e, t, s]) => {
  const i = f(s).toVar(), a = f(t).toVar(), n = x(e).toVar(), o = N(r).toVar();
  return B(Ba(o, n, a, i), Ba(o.add(N(x(19), x(193), x(17))), n, a, i));
}).setLayout({
  name: "mx_fractal_noise_vec2",
  type: "vec2",
  inputs: [
    { name: "p", type: "vec3" },
    { name: "octaves", type: "int" },
    { name: "lacunarity", type: "float" },
    { name: "diminish", type: "float" }
  ]
}), rN = /* @__PURE__ */ b(([r, e, t, s]) => {
  const i = f(s).toVar(), a = f(t).toVar(), n = x(e).toVar(), o = N(r).toVar(), l = N(mn(o, n, a, i)).toVar(), u = f(Ba(o.add(N(x(19), x(193), x(17))), n, a, i)).toVar();
  return D(l, u);
}).setLayout({
  name: "mx_fractal_noise_vec4",
  type: "vec4",
  inputs: [
    { name: "p", type: "vec3" },
    { name: "octaves", type: "int" },
    { name: "lacunarity", type: "float" },
    { name: "diminish", type: "float" }
  ]
}), iN = /* @__PURE__ */ b(([r, e, t, s, i, a, n]) => {
  const o = x(n).toVar(), l = f(a).toVar(), u = x(i).toVar(), h = x(s).toVar(), d = x(t).toVar(), p = x(e).toVar(), m = B(r).toVar(), g = N(pn(B(p.add(h), d.add(u)))).toVar(), y = B(g.x, g.y).toVar();
  y.subAssign(0.5), y.mulAssign(l), y.addAssign(0.5);
  const v = B(B(f(p), f(d)).add(y)).toVar(), w = B(v.sub(m)).toVar();
  return W(o.equal(x(2)), () => he(w.x).add(he(w.y))), W(o.equal(x(3)), () => Ee(he(w.x), he(w.y))), St(w, w);
}).setLayout({
  name: "mx_worley_distance_0",
  type: "float",
  inputs: [
    { name: "p", type: "vec2" },
    { name: "x", type: "int" },
    { name: "y", type: "int" },
    { name: "xoff", type: "int" },
    { name: "yoff", type: "int" },
    { name: "jitter", type: "float" },
    { name: "metric", type: "int" }
  ]
}), aN = /* @__PURE__ */ b(([r, e, t, s, i, a, n, o, l]) => {
  const u = x(l).toVar(), h = f(o).toVar(), d = x(n).toVar(), p = x(a).toVar(), m = x(i).toVar(), g = x(s).toVar(), y = x(t).toVar(), v = x(e).toVar(), w = N(r).toVar(), _ = N(pn(N(v.add(m), y.add(p), g.add(d)))).toVar();
  _.subAssign(0.5), _.mulAssign(h), _.addAssign(0.5);
  const C = N(N(f(v), f(y), f(g)).add(_)).toVar(), V = N(C.sub(w)).toVar();
  return W(u.equal(x(2)), () => he(V.x).add(he(V.y)).add(he(V.z))), W(u.equal(x(3)), () => Ee(he(V.x), he(V.y), he(V.z))), St(V, V);
}).setLayout({
  name: "mx_worley_distance_1",
  type: "float",
  inputs: [
    { name: "p", type: "vec3" },
    { name: "x", type: "int" },
    { name: "y", type: "int" },
    { name: "z", type: "int" },
    { name: "xoff", type: "int" },
    { name: "yoff", type: "int" },
    { name: "zoff", type: "int" },
    { name: "jitter", type: "float" },
    { name: "metric", type: "int" }
  ]
}), Qr = /* @__PURE__ */ De([iN, aN]), nN = /* @__PURE__ */ b(([r, e, t]) => {
  const s = x(t).toVar(), i = f(e).toVar(), a = B(r).toVar(), n = x().toVar(), o = x().toVar(), l = B(fe(a.x, n), fe(a.y, o)).toVar(), u = f(1e6).toVar();
  return le({ start: -1, end: x(1), name: "x", condition: "<=" }, ({ x: h }) => {
    le({ start: -1, end: x(1), name: "y", condition: "<=" }, ({ y: d }) => {
      const p = f(Qr(l, h, d, n, o, i, s)).toVar();
      u.assign(Mt(u, p));
    });
  }), W(s.equal(x(0)), () => {
    u.assign(et(u));
  }), u;
}).setLayout({
  name: "mx_worley_noise_float_0",
  type: "float",
  inputs: [
    { name: "p", type: "vec2" },
    { name: "jitter", type: "float" },
    { name: "metric", type: "int" }
  ]
}), oN = /* @__PURE__ */ b(([r, e, t]) => {
  const s = x(t).toVar(), i = f(e).toVar(), a = B(r).toVar(), n = x().toVar(), o = x().toVar(), l = B(fe(a.x, n), fe(a.y, o)).toVar(), u = B(1e6, 1e6).toVar();
  return le({ start: -1, end: x(1), name: "x", condition: "<=" }, ({ x: h }) => {
    le({ start: -1, end: x(1), name: "y", condition: "<=" }, ({ y: d }) => {
      const p = f(Qr(l, h, d, n, o, i, s)).toVar();
      W(p.lessThan(u.x), () => {
        u.y.assign(u.x), u.x.assign(p);
      }).ElseIf(p.lessThan(u.y), () => {
        u.y.assign(p);
      });
    });
  }), W(s.equal(x(0)), () => {
    u.assign(et(u));
  }), u;
}).setLayout({
  name: "mx_worley_noise_vec2_0",
  type: "vec2",
  inputs: [
    { name: "p", type: "vec2" },
    { name: "jitter", type: "float" },
    { name: "metric", type: "int" }
  ]
}), lN = /* @__PURE__ */ b(([r, e, t]) => {
  const s = x(t).toVar(), i = f(e).toVar(), a = B(r).toVar(), n = x().toVar(), o = x().toVar(), l = B(fe(a.x, n), fe(a.y, o)).toVar(), u = N(1e6, 1e6, 1e6).toVar();
  return le({ start: -1, end: x(1), name: "x", condition: "<=" }, ({ x: h }) => {
    le({ start: -1, end: x(1), name: "y", condition: "<=" }, ({ y: d }) => {
      const p = f(Qr(l, h, d, n, o, i, s)).toVar();
      W(p.lessThan(u.x), () => {
        u.z.assign(u.y), u.y.assign(u.x), u.x.assign(p);
      }).ElseIf(p.lessThan(u.y), () => {
        u.z.assign(u.y), u.y.assign(p);
      }).ElseIf(p.lessThan(u.z), () => {
        u.z.assign(p);
      });
    });
  }), W(s.equal(x(0)), () => {
    u.assign(et(u));
  }), u;
}).setLayout({
  name: "mx_worley_noise_vec3_0",
  type: "vec3",
  inputs: [
    { name: "p", type: "vec2" },
    { name: "jitter", type: "float" },
    { name: "metric", type: "int" }
  ]
}), uN = /* @__PURE__ */ b(([r, e, t]) => {
  const s = x(t).toVar(), i = f(e).toVar(), a = N(r).toVar(), n = x().toVar(), o = x().toVar(), l = x().toVar(), u = N(fe(a.x, n), fe(a.y, o), fe(a.z, l)).toVar(), h = f(1e6).toVar();
  return le({ start: -1, end: x(1), name: "x", condition: "<=" }, ({ x: d }) => {
    le({ start: -1, end: x(1), name: "y", condition: "<=" }, ({ y: p }) => {
      le({ start: -1, end: x(1), name: "z", condition: "<=" }, ({ z: m }) => {
        const g = f(Qr(u, d, p, m, n, o, l, i, s)).toVar();
        h.assign(Mt(h, g));
      });
    });
  }), W(s.equal(x(0)), () => {
    h.assign(et(h));
  }), h;
}).setLayout({
  name: "mx_worley_noise_float_1",
  type: "float",
  inputs: [
    { name: "p", type: "vec3" },
    { name: "jitter", type: "float" },
    { name: "metric", type: "int" }
  ]
}), hN = /* @__PURE__ */ De([nN, uN]), cN = /* @__PURE__ */ b(([r, e, t]) => {
  const s = x(t).toVar(), i = f(e).toVar(), a = N(r).toVar(), n = x().toVar(), o = x().toVar(), l = x().toVar(), u = N(fe(a.x, n), fe(a.y, o), fe(a.z, l)).toVar(), h = B(1e6, 1e6).toVar();
  return le({ start: -1, end: x(1), name: "x", condition: "<=" }, ({ x: d }) => {
    le({ start: -1, end: x(1), name: "y", condition: "<=" }, ({ y: p }) => {
      le({ start: -1, end: x(1), name: "z", condition: "<=" }, ({ z: m }) => {
        const g = f(Qr(u, d, p, m, n, o, l, i, s)).toVar();
        W(g.lessThan(h.x), () => {
          h.y.assign(h.x), h.x.assign(g);
        }).ElseIf(g.lessThan(h.y), () => {
          h.y.assign(g);
        });
      });
    });
  }), W(s.equal(x(0)), () => {
    h.assign(et(h));
  }), h;
}).setLayout({
  name: "mx_worley_noise_vec2_1",
  type: "vec2",
  inputs: [
    { name: "p", type: "vec3" },
    { name: "jitter", type: "float" },
    { name: "metric", type: "int" }
  ]
}), dN = /* @__PURE__ */ De([oN, cN]), pN = /* @__PURE__ */ b(([r, e, t]) => {
  const s = x(t).toVar(), i = f(e).toVar(), a = N(r).toVar(), n = x().toVar(), o = x().toVar(), l = x().toVar(), u = N(fe(a.x, n), fe(a.y, o), fe(a.z, l)).toVar(), h = N(1e6, 1e6, 1e6).toVar();
  return le({ start: -1, end: x(1), name: "x", condition: "<=" }, ({ x: d }) => {
    le({ start: -1, end: x(1), name: "y", condition: "<=" }, ({ y: p }) => {
      le({ start: -1, end: x(1), name: "z", condition: "<=" }, ({ z: m }) => {
        const g = f(Qr(u, d, p, m, n, o, l, i, s)).toVar();
        W(g.lessThan(h.x), () => {
          h.z.assign(h.y), h.y.assign(h.x), h.x.assign(g);
        }).ElseIf(g.lessThan(h.y), () => {
          h.z.assign(h.y), h.y.assign(g);
        }).ElseIf(g.lessThan(h.z), () => {
          h.z.assign(g);
        });
      });
    });
  }), W(s.equal(x(0)), () => {
    h.assign(et(h));
  }), h;
}).setLayout({
  name: "mx_worley_noise_vec3_1",
  type: "vec3",
  inputs: [
    { name: "p", type: "vec3" },
    { name: "jitter", type: "float" },
    { name: "metric", type: "int" }
  ]
}), hu = /* @__PURE__ */ De([lN, pN]), mN = /* @__PURE__ */ b(([
  r,
  e,
  t,
  s,
  i,
  a,
  n,
  o,
  l,
  u,
  h
]) => {
  const d = x(r).toVar(), p = B(e).toVar(), m = B(t).toVar(), g = B(s).toVar(), y = f(i).toVar(), v = f(a).toVar(), w = f(n).toVar(), _ = mt(o).toVar(), C = x(l).toVar(), V = f(u).toVar(), P = f(h).toVar(), z = p.mul(m).add(g), R = f(0).toVar();
  return W(d.equal(x(0)), () => {
    R.assign(Ci(z));
  }), W(d.equal(x(1)), () => {
    R.assign(pn(z));
  }), W(d.equal(x(2)), () => {
    R.assign(hu(z, y, x(0)));
  }), W(d.equal(x(3)), () => {
    R.assign(mn(N(z, 0), C, V, P));
  }), R.assign(R.mul(w.sub(v)).add(v)), W(_, () => {
    R.assign(Jt(R, v, w));
  }), R;
}).setLayout({
  name: "mx_unifiednoise2d",
  type: "float",
  inputs: [
    { name: "noiseType", type: "int" },
    { name: "texcoord", type: "vec2" },
    { name: "freq", type: "vec2" },
    { name: "offset", type: "vec2" },
    { name: "jitter", type: "float" },
    { name: "outmin", type: "float" },
    { name: "outmax", type: "float" },
    { name: "clampoutput", type: "bool" },
    { name: "octaves", type: "int" },
    { name: "lacunarity", type: "float" },
    { name: "diminish", type: "float" }
  ]
}), gN = /* @__PURE__ */ b(([
  r,
  e,
  t,
  s,
  i,
  a,
  n,
  o,
  l,
  u,
  h
]) => {
  const d = x(r).toVar(), p = N(e).toVar(), m = N(t).toVar(), g = N(s).toVar(), y = f(i).toVar(), v = f(a).toVar(), w = f(n).toVar(), _ = mt(o).toVar(), C = x(l).toVar(), V = f(u).toVar(), P = f(h).toVar(), z = p.mul(m).add(g), R = f(0).toVar();
  return W(d.equal(x(0)), () => {
    R.assign(Ci(z));
  }), W(d.equal(x(1)), () => {
    R.assign(pn(z));
  }), W(d.equal(x(2)), () => {
    R.assign(hu(z, y, x(0)));
  }), W(d.equal(x(3)), () => {
    R.assign(mn(z, C, V, P));
  }), R.assign(R.mul(w.sub(v)).add(v)), W(_, () => {
    R.assign(Jt(R, v, w));
  }), R;
}).setLayout({
  name: "mx_unifiednoise3d",
  type: "float",
  inputs: [
    { name: "noiseType", type: "int" },
    { name: "position", type: "vec3" },
    { name: "freq", type: "vec3" },
    { name: "offset", type: "vec3" },
    { name: "jitter", type: "float" },
    { name: "outmin", type: "float" },
    { name: "outmax", type: "float" },
    { name: "clampoutput", type: "bool" },
    { name: "octaves", type: "int" },
    { name: "lacunarity", type: "float" },
    { name: "diminish", type: "float" }
  ]
}), fN = /* @__PURE__ */ b(([r]) => {
  const e = r.y, t = r.z, s = N().toVar();
  return W(e.lessThan(1e-4), () => {
    s.assign(N(t, t, t));
  }).Else(() => {
    let i = r.x;
    i = i.sub(Xt(i)).mul(6).toVar();
    const a = x(bl(i)), n = i.sub(f(a)), o = t.mul(e.oneMinus()), l = t.mul(e.mul(n).oneMinus()), u = t.mul(e.mul(n.oneMinus()).oneMinus());
    W(a.equal(x(0)), () => {
      s.assign(N(t, u, o));
    }).ElseIf(a.equal(x(1)), () => {
      s.assign(N(l, t, o));
    }).ElseIf(a.equal(x(2)), () => {
      s.assign(N(o, t, u));
    }).ElseIf(a.equal(x(3)), () => {
      s.assign(N(o, l, t));
    }).ElseIf(a.equal(x(4)), () => {
      s.assign(N(u, o, t));
    }).Else(() => {
      s.assign(N(t, o, l));
    });
  }), s;
}).setLayout({
  name: "mx_hsvtorgb",
  type: "vec3",
  inputs: [
    { name: "hsv", type: "vec3" }
  ]
}), yN = /* @__PURE__ */ b(([r]) => {
  const e = N(r).toVar(), t = f(e.x).toVar(), s = f(e.y).toVar(), i = f(e.z).toVar(), a = f(Mt(t, Mt(s, i))).toVar(), n = f(Ee(t, Ee(s, i))).toVar(), o = f(n.sub(a)).toVar(), l = f().toVar(), u = f().toVar(), h = f().toVar();
  return h.assign(n), W(n.greaterThan(0), () => {
    u.assign(o.div(n));
  }).Else(() => {
    u.assign(0);
  }), W(u.lessThanEqual(0), () => {
    l.assign(0);
  }).Else(() => {
    W(t.greaterThanEqual(n), () => {
      l.assign(s.sub(i).div(o));
    }).ElseIf(s.greaterThanEqual(n), () => {
      l.assign(Ae(2, i.sub(t).div(o)));
    }).Else(() => {
      l.assign(Ae(4, t.sub(s).div(o)));
    }), l.mulAssign(1 / 6), W(l.lessThan(0), () => {
      l.addAssign(1);
    });
  }), N(l, u, h);
}).setLayout({
  name: "mx_rgbtohsv",
  type: "vec3",
  inputs: [
    { name: "c", type: "vec3" }
  ]
}), xN = /* @__PURE__ */ b(([r]) => {
  const e = N(r).toVar(), t = ol(hl(e, N(0.04045))).toVar(), s = N(e.div(12.92)).toVar(), i = N(vt(Ee(e.add(N(0.055)), N(0)).div(1.055), N(2.4))).toVar();
  return pe(s, i, t);
}).setLayout({
  name: "mx_srgb_texture_to_lin_rec709",
  type: "vec3",
  inputs: [
    { name: "color", type: "vec3" }
  ]
}), Xm = (r, e) => {
  r = f(r), e = f(e);
  const t = B(e.dFdx(), e.dFdy()).length().mul(0.7071067811865476);
  return Qt(r.sub(t), r.add(t), e);
}, $m = (r, e, t, s) => pe(r, e, t[s].clamp()), bN = (r, e, t = ae()) => $m(r, e, t, "x"), vN = (r, e, t = ae()) => $m(r, e, t, "y"), TN = (r, e, t, s, i = ae()) => {
  const a = i.x.clamp(), n = i.y.clamp(), o = pe(r, e, a), l = pe(t, s, a);
  return pe(o, l, n);
}, Ym = (r, e, t, s, i) => pe(r, e, Xm(t, s[i])), wN = (r, e, t, s = ae()) => Ym(r, e, t, s, "x"), NN = (r, e, t, s = ae()) => Ym(r, e, t, s, "y"), MN = (r = 1, e = 0, t = ae()) => t.mul(r).add(e), SN = (r, e = 1) => (r = f(r), r.abs().pow(e).mul(r.sign())), _N = (r, e = 1, t = 0.5) => f(r).sub(t).mul(e).add(t), AN = (r = ae(), e = 1, t = 0) => uu(r.convert("vec2|vec3")).mul(e).add(t), VN = (r = ae(), e = 1, t = 0) => Ci(r.convert("vec2|vec3")).mul(e).add(t), CN = (r = ae(), e = 1, t = 0) => (r = r.convert("vec2|vec3"), D(Ci(r), uu(r.add(B(19, 73)))).mul(e).add(t)), zN = (r, e = ae(), t = B(1, 1), s = B(0, 0), i = 1, a = 0, n = 1, o = !1, l = 1, u = 2, h = 0.5) => mN(r, e.convert("vec2|vec3"), t, s, i, a, n, o, l, u, h), RN = (r, e = ae(), t = B(1, 1), s = B(0, 0), i = 1, a = 0, n = 1, o = !1, l = 1, u = 2, h = 0.5) => gN(r, e.convert("vec2|vec3"), t, s, i, a, n, o, l, u, h), EN = (r = ae(), e = 1) => hN(r.convert("vec2|vec3"), e, x(1)), LN = (r = ae(), e = 1) => dN(r.convert("vec2|vec3"), e, x(1)), IN = (r = ae(), e = 1) => hu(r.convert("vec2|vec3"), e, x(1)), ON = (r = ae()) => Jw(r.convert("vec2|vec3")), PN = (r = ae(), e = 3, t = 2, s = 0.5, i = 1) => Ba(r, x(e), t, s).mul(i), FN = (r = ae(), e = 3, t = 2, s = 0.5, i = 1) => sN(r, x(e), t, s).mul(i), BN = (r = ae(), e = 3, t = 2, s = 0.5, i = 1) => mn(r, x(e), t, s).mul(i), UN = (r = ae(), e = 3, t = 2, s = 0.5, i = 1) => rN(r, x(e), t, s).mul(i), kN = (r, e = f(0)) => Ae(r, e), DN = (r, e = f(0)) => K(r, e), WN = (r, e = f(1)) => j(r, e), qN = (r, e = f(1)) => Zt(r, e), jN = (r, e = f(1)) => $a(r, e), GN = (r, e = f(1)) => vt(r, e), HN = (r = f(0), e = f(1)) => ml(r, e), XN = () => Jr, $N = () => vm, YN = (r, e = f(1)) => K(e, r), ZN = (r, e, t, s) => r.greaterThan(e).mix(t, s), JN = (r, e, t, s) => r.greaterThanEqual(e).mix(t, s), QN = (r, e, t, s) => r.equal(e).mix(t, s), KN = (r, e = null) => {
  if (typeof e == "string") {
    const t = { x: 0, r: 0, y: 1, g: 1, z: 2, b: 2, w: 3, a: 3 }, s = e.replace(/^out/, "").toLowerCase();
    if (t[s] !== void 0) return r.element(t[s]);
  }
  if (typeof e == "number")
    return r.element(e);
  if (typeof e == "string" && e.length === 1) {
    const t = { x: 0, r: 0, y: 1, g: 1, z: 2, b: 2, w: 3, a: 3 };
    if (t[e] !== void 0) return r.element(t[e]);
  }
  return r;
}, eM = (r, e = B(0.5, 0.5), t = B(1, 1), s = f(0), i = B(0, 0)) => {
  let a = r;
  if (e && (a = a.sub(e)), t && (a = a.mul(t)), s) {
    const n = s.mul(Math.PI / 180), o = n.cos(), l = n.sin();
    a = B(
      a.x.mul(o).sub(a.y.mul(l)),
      a.x.mul(l).add(a.y.mul(o))
    );
  }
  return e && (a = a.add(e)), i && (a = a.add(i)), a;
}, tM = (r, e) => {
  r = B(r), e = f(e);
  const t = e.mul(Math.PI / 180);
  return Ql(r, t);
}, sM = (r, e, t) => {
  r = N(r), e = f(e), t = N(t);
  const s = e.mul(Math.PI / 180), i = t.normalize(), a = s.cos(), n = s.sin(), o = f(1).sub(a);
  return r.mul(a).add(i.cross(r).mul(n)).add(i.mul(i.dot(r)).mul(o));
}, rM = (r, e) => (r = N(r), e = f(e), Gl(r, e)), iM = /* @__PURE__ */ b(([r, e, t]) => {
  const s = it(r).toVar(), i = K(f(0.5).mul(e.sub(t)), Ks).div(s).toVar(), a = K(f(-0.5).mul(e.sub(t)), Ks).div(s).toVar(), n = N().toVar();
  n.x = s.x.greaterThan(f(0)).select(i.x, a.x), n.y = s.y.greaterThan(f(0)).select(i.y, a.y), n.z = s.z.greaterThan(f(0)).select(i.z, a.z);
  const o = Mt(n.x, n.y, n.z).toVar();
  return Ks.add(s.mul(o)).toVar().sub(t);
}), aM = /* @__PURE__ */ b(([r, e]) => {
  const t = r.x, s = r.y, i = r.z;
  let a = e.element(0).mul(0.886227);
  return a = a.add(e.element(1).mul(2 * 0.511664).mul(s)), a = a.add(e.element(2).mul(2 * 0.511664).mul(i)), a = a.add(e.element(3).mul(2 * 0.511664).mul(t)), a = a.add(e.element(4).mul(2 * 0.429043).mul(t).mul(s)), a = a.add(e.element(5).mul(2 * 0.429043).mul(s).mul(i)), a = a.add(e.element(6).mul(i.mul(i).mul(0.743125).sub(0.247708))), a = a.add(e.element(7).mul(2 * 0.429043).mul(t).mul(i)), a = a.add(e.element(8).mul(0.429043).mul(j(t, t).sub(j(s, s)))), a;
});
var c = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  BRDF_GGX: c1,
  BRDF_Lambert: n1,
  BasicPointShadowFilter: Um,
  BasicShadowFilter: Rm,
  Break: qp,
  Const: Sd,
  Continue: Dx,
  DFGLUT: p1,
  D_GGX: rm,
  Discard: kd,
  EPSILON: cl,
  F_Schlick: em,
  Fn: b,
  HALF_PI: zy,
  INFINITY: Ay,
  If: W,
  Loop: le,
  NodeAccess: Ht,
  NodeShaderStage: Vr,
  NodeType: Rf,
  NodeUpdateType: Q,
  OnBeforeFrameUpdate: Ex,
  OnBeforeMaterialUpdate: Rx,
  OnBeforeObjectUpdate: zx,
  OnFrameUpdate: Op,
  OnMaterialUpdate: Cx,
  OnObjectUpdate: Si,
  PCFShadowFilter: Em,
  PCFSoftShadowFilter: Lm,
  PI: Aa,
  PI2: Vy,
  PointShadowFilter: km,
  Return: Jy,
  Schlick_to_F0: m1,
  ShaderNode: Er,
  Stack: Ga,
  Switch: ty,
  TBNViewMatrix: jl,
  TWO_PI: Cy,
  VSMShadowFilter: Im,
  V_GGX_SmithCorrelated: sm,
  Var: Md,
  VarIntent: _d,
  abs: he,
  acesFilmicToneMapping: Ev,
  acos: Zc,
  acosh: Jc,
  add: Ae,
  addMethodChaining: S,
  addNodeElement: s0,
  agxToneMapping: Pv,
  all: Uc,
  alphaT: So,
  ambientOcclusion: Ao,
  and: Sc,
  anisotropy: pc,
  anisotropyB: Pr,
  anisotropyT: xa,
  any: kc,
  append: ry,
  array: yc,
  asin: $c,
  asinh: Yc,
  assign: xc,
  atan: ml,
  atanh: Qc,
  atomicAdd: dT,
  atomicAnd: fT,
  atomicFunc: ts,
  atomicLoad: hT,
  atomicMax: mT,
  atomicMin: gT,
  atomicOr: yT,
  atomicStore: cT,
  atomicSub: pT,
  atomicXor: xT,
  attenuationColor: Ty,
  attenuationDistance: vy,
  attribute: Tt,
  attributeArray: Hb,
  backgroundBlurriness: Zb,
  backgroundIntensity: Jb,
  backgroundRotation: Qb,
  batch: Up,
  batchColor: Xl,
  bentNormalView: J0,
  billboarding: Vb,
  bitAnd: Cc,
  bitNot: zc,
  bitOr: Rc,
  bitXor: Ec,
  bitangentGeometry: X0,
  bitangentLocal: $0,
  bitangentView: bp,
  bitangentWorld: Y0,
  bitcast: xm,
  blendBurn: hv,
  blendColor: mv,
  blendDodge: cv,
  blendOverlay: pv,
  blendScreen: dv,
  blur: um,
  bool: mt,
  buffer: $r,
  bufferAttribute: zl,
  builtin: Bs,
  builtinAOContext: wd,
  builtinShadowContext: Td,
  bumpMap: Gl,
  bvec2: oc,
  bvec3: ol,
  bvec4: lc,
  bypass: Bd,
  cache: Fd,
  call: bc,
  cameraFar: As,
  cameraIndex: Us,
  cameraNear: _s,
  cameraNormalMatrix: g0,
  cameraPosition: f0,
  cameraProjectionMatrix: Ot,
  cameraProjectionMatrixInverse: Zd,
  cameraViewMatrix: dr,
  cameraViewport: y0,
  cameraWorldMatrix: Qa,
  cbrt: md,
  cdl: bv,
  ceil: Ya,
  checker: ww,
  cineonToneMapping: zv,
  clamp: Jt,
  clearcoat: ny,
  clearcoatNormalView: rp,
  clearcoatRoughness: oy,
  clipSpace: Kd,
  code: cn,
  color: nc,
  colorSpaceToWorking: Cl,
  colorToDirection: K0,
  compute: Pd,
  computeKernel: El,
  computeSkinning: Ux,
  context: Fs,
  convert: hc,
  convertColorSpace: By,
  convertToTexture: Ub,
  cos: Rt,
  cosh: Gc,
  countLeadingZeros: ib,
  countOneBits: ab,
  countTrailingZeros: rb,
  cross: gs,
  cubeTexture: bt,
  cubeTextureBase: ql,
  dFdx: yl,
  dFdy: xl,
  dashSize: ba,
  debug: qd,
  decrement: Bc,
  decrementBefore: Pc,
  defaultBuildStages: Ef,
  defaultShaderStages: Qh,
  defined: Dr,
  degrees: Wc,
  deltaTime: vb,
  densityFogFactor: Gv,
  depth: Jl,
  depthPass: Sv,
  determinant: rd,
  difference: od,
  diffuseColor: Je,
  diffuseContribution: iy,
  directPointLight: Tw,
  directionToColor: Q0,
  directionToFaceDirection: L0,
  dispersion: wy,
  disposeShadowMaterial: Pm,
  distance: nd,
  div: Zt,
  dot: St,
  drawIndex: Od,
  dynamicBufferAttribute: qy,
  element: uc,
  emissive: Mo,
  equal: vc,
  equirectDirection: Oo,
  equirectUV: Kp,
  exp: qc,
  exp2: Wr,
  exponentialHeightFogFactor: Hv,
  expression: ct,
  faceDirection: Ul,
  faceForward: Nl,
  faceforward: Ry,
  float: f,
  floatBitsToInt: eb,
  floatBitsToUint: bm,
  floor: Xt,
  fog: Xv,
  fract: Bt,
  frameGroup: Ny,
  frameId: vm,
  frontFacing: tp,
  fwidth: vl,
  gain: ob,
  gapSize: _o,
  getConstNodeType: ic,
  getCurrentStack: ac,
  getDirection: om,
  getDistanceAttenuation: Dm,
  getGeometryRoughness: tm,
  getNormalFromDepth: Db,
  getParallaxCorrectNormal: iM,
  getRoughness: o1,
  getScreenPosition: kb,
  getShIrradianceAt: aM,
  getShadowMaterial: Om,
  getShadowRenderObjectFunction: Fm,
  getTextureIndex: fm,
  getViewPosition: zr,
  ggxConvolution: hm,
  globalId: Kv,
  glsl: kv,
  glslFn: Wv,
  grayscale: gv,
  greaterThan: hl,
  greaterThanEqual: Mc,
  hash: nb,
  highpModelNormalViewMatrix: R0,
  highpModelViewMatrix: z0,
  hue: xv,
  increment: Fc,
  incrementBefore: Oc,
  inspector: jd,
  instance: Fp,
  instanceColor: Hl,
  instanceIndex: Ft,
  instancedArray: Xb,
  instancedBufferAttribute: Ja,
  instancedDynamicBufferAttribute: Rl,
  instancedMesh: Bp,
  int: x,
  intBitsToFloat: tb,
  interleavedGradientNoise: su,
  inverse: id,
  inverseSqrt: pl,
  inversesqrt: Ey,
  invocationLocalIndex: Hy,
  invocationSubgroupIndex: Gy,
  ior: yy,
  iridescence: dc,
  iridescenceIOR: hy,
  iridescenceThickness: cy,
  isolate: Ll,
  ivec2: ye,
  ivec3: nl,
  ivec4: ll,
  js: Bv,
  label: Nd,
  length: Va,
  lengthSq: Tl,
  lessThan: wc,
  lessThanEqual: Nc,
  lightPosition: Cm,
  lightProjectionUV: jT,
  lightShadowMatrix: ou,
  lightTargetDirection: HT,
  lightTargetPosition: zm,
  lightViewPosition: GT,
  lightingContext: Hp,
  lights: KT,
  linearDepth: La,
  linearToneMapping: Vv,
  localId: eT,
  log: dl,
  log2: ps,
  logarithmicDepthToViewZ: Jx,
  luminance: iu,
  mat2: Ha,
  mat3: gt,
  mat4: Rs,
  matcapUV: U1,
  materialAO: Lp,
  materialAlphaTest: Np,
  materialAnisotropy: xx,
  materialAnisotropyVector: Cr,
  materialAttenuationColor: _x,
  materialAttenuationDistance: Sx,
  materialClearcoat: dx,
  materialClearcoatNormal: mx,
  materialClearcoatRoughness: px,
  materialColor: Mp,
  materialDispersion: Vx,
  materialEmissive: Sp,
  materialEnvIntensity: B0,
  materialEnvRotation: Ca,
  materialIOR: Mx,
  materialIridescence: bx,
  materialIridescenceIOR: vx,
  materialIridescenceThickness: Tx,
  materialLightMap: Ep,
  materialLineDashOffset: Rp,
  materialLineDashSize: Cp,
  materialLineGapSize: zp,
  materialLineScale: Vp,
  materialLineWidth: za,
  materialMetalness: cx,
  materialNormal: Ap,
  materialOpacity: _p,
  materialPointSize: Ax,
  materialReference: Ys,
  materialReflectivity: ux,
  materialRefractionRatio: ip,
  materialRotation: gx,
  materialRoughness: hx,
  materialSheen: fx,
  materialSheenRoughness: yx,
  materialShininess: ix,
  materialSpecular: ax,
  materialSpecularColor: ox,
  materialSpecularIntensity: nx,
  materialSpecularStrength: lx,
  materialThickness: Nx,
  materialTransmission: wx,
  max: Ee,
  maxMipLevel: Pl,
  mediumpModelViewMatrix: Qd,
  metalness: ay,
  min: Mt,
  mix: pe,
  mixElement: yd,
  mod: $a,
  modelDirection: M0,
  modelNormalMatrix: Jd,
  modelPosition: S0,
  modelRadius: V0,
  modelScale: _0,
  modelViewMatrix: rr,
  modelViewPosition: A0,
  modelViewProjection: Ip,
  modelWorldMatrix: hs,
  modelWorldMatrixInverse: C0,
  morphReference: jp,
  mrt: ym,
  mul: j,
  mx_aastep: Xm,
  mx_add: kN,
  mx_atan2: HN,
  mx_cell_noise_float: ON,
  mx_contrast: _N,
  mx_divide: qN,
  mx_fractal_noise_float: PN,
  mx_fractal_noise_vec2: FN,
  mx_fractal_noise_vec3: BN,
  mx_fractal_noise_vec4: UN,
  mx_frame: $N,
  mx_heighttonormal: rM,
  mx_hsvtorgb: fN,
  mx_ifequal: QN,
  mx_ifgreater: ZN,
  mx_ifgreatereq: JN,
  mx_invert: YN,
  mx_modulo: jN,
  mx_multiply: WN,
  mx_noise_float: AN,
  mx_noise_vec3: VN,
  mx_noise_vec4: CN,
  mx_place2d: eM,
  mx_power: GN,
  mx_ramp4: TN,
  mx_ramplr: bN,
  mx_ramptb: vN,
  mx_rgbtohsv: yN,
  mx_rotate2d: tM,
  mx_rotate3d: sM,
  mx_safepower: SN,
  mx_separate: KN,
  mx_splitlr: wN,
  mx_splittb: NN,
  mx_srgb_texture_to_lin_rec709: xN,
  mx_subtract: DN,
  mx_timer: XN,
  mx_transform_uv: MN,
  mx_unifiednoise2d: zN,
  mx_unifiednoise3d: RN,
  mx_worley_noise_float: EN,
  mx_worley_noise_vec2: LN,
  mx_worley_noise_vec3: IN,
  negate: fl,
  negateOnBackSide: Yr,
  neutralToneMapping: Fv,
  nodeArray: Qs,
  nodeImmutable: O,
  nodeObject: U,
  nodeObjectIntent: ci,
  nodeObjects: ja,
  nodeProxy: Y,
  nodeProxyConstructor: il,
  nodeProxyIntent: L,
  normalFlat: sp,
  normalGeometry: kl,
  normalLocal: $e,
  normalMap: Ro,
  normalView: Ue,
  normalViewGeometry: xi,
  normalWorld: Ka,
  normalWorldGeometry: I0,
  normalize: it,
  not: Ac,
  notEqual: Tc,
  numWorkgroups: Jv,
  objectDirection: x0,
  objectGroup: fc,
  objectPosition: v0,
  objectRadius: N0,
  objectScale: T0,
  objectViewPosition: w0,
  objectWorldMatrix: b0,
  oneMinus: Kc,
  or: _c,
  orthographicDepthToViewZ: $p,
  oscSawtooth: Mb,
  oscSine: Tb,
  oscSquare: wb,
  oscTriangle: Nb,
  output: Fr,
  outputStruct: Z1,
  overloadingFn: De,
  overrideNode: dm,
  overrideNodes: pm,
  packHalf2x16: db,
  packNormalToRGB: Tp,
  packSnorm2x16: hb,
  packUnorm2x16: cb,
  parabola: Uo,
  parallaxDirection: vp,
  parallaxUV: Z0,
  parameter: q1,
  pass: Nv,
  passTexture: Mv,
  pcurve: lb,
  perspectiveDepthToViewZ: nn,
  pmremTexture: B1,
  pointShadow: vw,
  pointUV: Yb,
  pointWidth: fy,
  positionGeometry: st,
  positionLocal: Te,
  positionPrevious: ir,
  positionView: Ie,
  positionViewDirection: dt,
  positionWorld: Ks,
  positionWorldDirection: ep,
  posterize: vv,
  pow: vt,
  pow2: ld,
  pow3: ud,
  pow4: hd,
  premultiplyAlpha: Ol,
  property: ys,
  quadBroadcast: qT,
  quadSwapDiagonal: FT,
  quadSwapX: OT,
  quadSwapY: PT,
  radians: Dc,
  rand: fd,
  range: Yv,
  rangeFogFactor: jv,
  reciprocal: td,
  reference: Me,
  referenceBuffer: hp,
  reflect: ad,
  reflectVector: op,
  reflectView: ap,
  reflector: Ib,
  refract: gd,
  refractVector: lp,
  refractView: np,
  reinhardToneMapping: Cv,
  remap: Il,
  remapClamp: Ud,
  renderGroup: H,
  renderOutput: Wd,
  rendererReference: Rd,
  replaceDefaultUV: Sb,
  rotate: Ql,
  rotateUV: _b,
  roughness: cc,
  round: ed,
  rtt: Nm,
  sRGBTransferEOTF: Vd,
  sRGBTransferOETF: Cd,
  sample: qb,
  sampler: l0,
  samplerComparison: u0,
  saturate: wl,
  saturation: fv,
  screenCoordinate: cr,
  screenDPR: Xd,
  screenSize: qr,
  screenUV: hr,
  select: He,
  setCurrentStack: No,
  setName: Sl,
  shaderStages: Lf,
  shadow: dw,
  shadowPositionWorld: lu,
  shapeCircle: Nw,
  sharedUniformGroup: Xa,
  sheen: ly,
  sheenRoughness: uy,
  shiftLeft: Lc,
  shiftRight: Ic,
  shininess: gy,
  sign: gl,
  sin: Qe,
  sinc: ub,
  sinh: jc,
  skinning: Wp,
  smoothstep: Qt,
  smoothstepElement: xd,
  specularColor: dy,
  specularColorBlended: py,
  specularF90: my,
  spherizeUV: Ab,
  split: sy,
  spritesheetUV: zb,
  sqrt: et,
  stack: G1,
  step: tr,
  stepElement: bd,
  storage: Es,
  storageBarrier: iT,
  storageTexture: Sm,
  storageTexture3D: tv,
  struct: Y1,
  sub: K,
  subBuild: Br,
  subgroupAdd: TT,
  subgroupAll: ET,
  subgroupAnd: AT,
  subgroupAny: LT,
  subgroupBallot: vT,
  subgroupBroadcast: BT,
  subgroupBroadcastFirst: IT,
  subgroupElect: bT,
  subgroupExclusiveAdd: NT,
  subgroupExclusiveMul: _T,
  subgroupInclusiveAdd: wT,
  subgroupInclusiveMul: ST,
  subgroupIndex: jy,
  subgroupMax: RT,
  subgroupMin: zT,
  subgroupMul: MT,
  subgroupOr: VT,
  subgroupShuffle: UT,
  subgroupShuffleDown: WT,
  subgroupShuffleUp: DT,
  subgroupShuffleXor: kT,
  subgroupSize: tT,
  subgroupXor: CT,
  tan: Hc,
  tangentGeometry: tn,
  tangentLocal: Os,
  tangentView: sn,
  tangentWorld: xp,
  tanh: Xc,
  texture: xe,
  texture3D: ru,
  texture3DLevel: av,
  texture3DLoad: iv,
  textureBarrier: aT,
  textureBicubic: g1,
  textureBicubicLevel: nm,
  textureCubeUV: lm,
  textureLevel: o0,
  textureLoad: ve,
  textureSize: sr,
  textureStore: Kb,
  thickness: by,
  time: Jr,
  toneMapping: Ed,
  toneMappingExposure: Ld,
  toonOutlinePass: Av,
  transformDirection: cd,
  transformNormal: Dl,
  transformNormalByInverseViewMatrix: pd,
  transformNormalByViewMatrix: dd,
  transformNormalToView: Wl,
  transformedClearcoatNormalView: F0,
  transformedNormalView: O0,
  transformedNormalWorld: P0,
  transmission: xy,
  transpose: sd,
  triNoise3D: yb,
  triplanarTexture: Rb,
  triplanarTextures: Tm,
  trunc: bl,
  uint: E,
  uintBitsToFloat: sb,
  uniform: q,
  uniformArray: Ge,
  uniformCubeTexture: k0,
  uniformFlow: vd,
  uniformGroup: gc,
  uniformTexture: n0,
  unpackHalf2x16: gb,
  unpackNormal: zo,
  unpackRGBToNormal: wp,
  unpackSnorm2x16: pb,
  unpackUnorm2x16: mb,
  unpremultiplyAlpha: Dd,
  userData: ov,
  uv: ae,
  uvec2: al,
  uvec3: or,
  uvec4: ul,
  varying: ur,
  varyingProperty: lr,
  vec2: B,
  vec3: N,
  vec4: D,
  vectorComponents: Xr,
  velocity: uv,
  vertexColor: Jp,
  vertexIndex: Id,
  vertexStage: Ad,
  vibrance: yv,
  viewZToLogarithmicDepth: on,
  viewZToOrthographicDepth: er,
  viewZToPerspectiveDepth: Zl,
  viewZToReversedOrthographicDepth: Zx,
  viewZToReversedPerspectiveDepth: Yp,
  viewport: Ur,
  viewportCoordinate: Yd,
  viewportDepthTexture: Yl,
  viewportLinearDepth: Qx,
  viewportMipTexture: Xp,
  viewportOpaqueMipTexture: $x,
  viewportResolution: m0,
  viewportSafeUV: Cb,
  viewportSharedTexture: wv,
  viewportSize: $d,
  viewportTexture: Hx,
  viewportUV: p0,
  vogelDiskSample: It,
  wgsl: Uv,
  wgslFn: qv,
  workgroupArray: lT,
  workgroupBarrier: rT,
  workgroupId: Qv,
  workingToColorSpace: zd,
  xor: Vc
});
new me(
  /* glsl */
  "uint tsl_bitcast_int_to_uint ( int x ) { return floatBitsToUint( intBitsToFloat ( x ) ); }"
), new me(
  /* glsl */
  "uint tsl_bitcast_uint_to_int ( uint x ) { return floatBitsToInt( uintBitsToFloat ( x ) ); }"
), new me(
  /* glsl */
  `
vec4 tsl_textureGather( const int comp, sampler2D map, vec2 coord, ivec2 offset, bool flipY ) {
	if ( flipY ) offset.y = - offset.y;
	vec2 size = vec2( textureSize( map, 0 ) );
	vec2 st = floor( coord * size + vec2( offset ) - 0.5 );
	vec4 ij = vec4( st + 0.5, st + 1.5 ) / size.xyxy;
	vec4 ret = vec4(
		textureLod( map, ij.xw, 0.0 )[ comp ],
		textureLod( map, ij.zw, 0.0 )[ comp ],
		textureLod( map, ij.zy, 0.0 )[ comp ],
		textureLod( map, ij.xy, 0.0 )[ comp ]
	);
	return flipY ? ret.wzyx : ret;
}
`
), new me(
  /* glsl */
  `
vec4 tsl_textureGather_array( const int comp, sampler2DArray map, vec3 coord, ivec2 offset, bool flipY ) {
	if ( flipY ) offset.y = - offset.y;
	vec2 size = vec2( textureSize( map, 0 ).xy );
	vec2 st = floor( coord.xy * size + vec2( offset ) - 0.5 );
	vec4 ij = vec4( st + 0.5, st + 1.5 ) / size.xyxy;
	vec4 ret = vec4(
		textureLod( map, vec3( ij.xw, coord.z ), 0.0 )[ comp ],
		textureLod( map, vec3( ij.zw, coord.z ), 0.0 )[ comp ],
		textureLod( map, vec3( ij.zy, coord.z ), 0.0 )[ comp ],
		textureLod( map, vec3( ij.xy, coord.z ), 0.0 )[ comp ]
	);
	return flipY ? ret.wzyx : ret;
}
`
), new me(
  /* glsl */
  `
vec4 tsl_textureGatherCompare( sampler2DShadow map, vec2 coord, ivec2 offset, float ref, bool flipY ) {
	if ( flipY ) offset.y = - offset.y;
	vec2 size = vec2( textureSize( map, 0 ) );
	vec2 st = floor( coord * size + vec2( offset ) - 0.5 );
	vec4 ij = vec4( st + 0.5, st + 1.5 ) / size.xyxy;
	vec4 ret = vec4(
		textureLod( map, vec3( ij.xw, ref ), 0.0 ),
		textureLod( map, vec3( ij.zw, ref ), 0.0 ),
		textureLod( map, vec3( ij.zy, ref ), 0.0 ),
		textureLod( map, vec3( ij.xy, ref ), 0.0 )
	);
	return flipY ? ret.wzyx : ret;
}
`
), new me(
  /* glsl */
  `
vec4 tsl_textureGatherCompare_array( sampler2DArrayShadow map, vec3 coord, ivec2 offset, float ref, bool flipY ) {
	if ( flipY ) offset.y = - offset.y;
	vec2 size = vec2( textureSize( map, 0 ).xy );
	vec2 st = floor( coord.xy * size + vec2( offset ) - 0.5 );
	vec4 ij = vec4( st + 0.5, st + 1.5 ) / size.xyxy;
	vec4 ret = vec4(
		texture( map, vec4( ij.xw, coord.z, ref ) ),
		texture( map, vec4( ij.zw, coord.z, ref ) ),
		texture( map, vec4( ij.zy, coord.z, ref ) ),
		texture( map, vec4( ij.xy, coord.z, ref ) )
	);
	return flipY ? ret.wzyx : ret;
}
`
);
const uo = typeof self < "u" && self.GPUShaderStage ? self.GPUShaderStage : { VERTEX: 1, FRAGMENT: 2, COMPUTE: 4 };
class nM {
  constructor() {
    this.texture = null, this.mipLevel = 0, this.origin = { x: 0, y: 0, z: 0 }, this.aspect = "all";
  }
  /**
   * Resets the descriptor to its default state.
   */
  reset() {
    this.texture = null, this.mipLevel = 0, this.origin.x = 0, this.origin.y = 0, this.origin.z = 0, this.aspect = "all";
  }
}
class oM extends nM {
  constructor() {
    super(), this.colorSpace = "srgb", this.premultipliedAlpha = !1;
  }
  /**
   * Resets the descriptor to its default state.
   */
  reset() {
    super.reset(), this.colorSpace = "srgb", this.premultipliedAlpha = !1;
  }
}
new oM();
Ht.READ_ONLY + "", Ht.WRITE_ONLY + "", Ht.READ_WRITE + "";
uo.VERTEX, uo.FRAGMENT, uo.COMPUTE;
new me("fn tsl_xor( a : bool, b : bool ) -> bool { return ( a || b ) && !( a && b ); }"), new me("fn tsl_mod_float( x : f32, y : f32 ) -> f32 { return x - y * floor( x / y ); }"), new me("fn tsl_mod_vec2( x : vec2f, y : vec2f ) -> vec2f { return x - y * floor( x / y ); }"), new me("fn tsl_mod_vec3( x : vec3f, y : vec3f ) -> vec3f { return x - y * floor( x / y ); }"), new me("fn tsl_mod_vec4( x : vec4f, y : vec4f ) -> vec4f { return x - y * floor( x / y ); }"), new me("fn tsl_equals_bool( a : bool, b : bool ) -> bool { return a == b; }"), new me("fn tsl_equals_bvec2( a : vec2f, b : vec2f ) -> vec2<bool> { return vec2<bool>( a.x == b.x, a.y == b.y ); }"), new me("fn tsl_equals_bvec3( a : vec3f, b : vec3f ) -> vec3<bool> { return vec3<bool>( a.x == b.x, a.y == b.y, a.z == b.z ); }"), new me("fn tsl_equals_bvec4( a : vec4f, b : vec4f ) -> vec4<bool> { return vec4<bool>( a.x == b.x, a.y == b.y, a.z == b.z, a.w == b.w ); }"), new me("fn tsl_repeatWrapping_float( coord: f32 ) -> f32 { return fract( coord ); }"), new me("fn tsl_mirrorWrapping_float( coord: f32 ) -> f32 { let mirrored = fract( coord * 0.5 ) * 2.0; return 1.0 - abs( 1.0 - mirrored ); }"), new me("fn tsl_clampWrapping_float( coord: f32 ) -> f32 { return clamp( coord, 0.0, 1.0 ); }"), new me(
  /* wgsl */
  `
fn tsl_inverse_mat2( m : mat2x2<f32> ) -> mat2x2<f32> {

	let det = m[ 0 ][ 0 ] * m[ 1 ][ 1 ] - m[ 0 ][ 1 ] * m[ 1 ][ 0 ];

	return mat2x2<f32>(
		m[ 1 ][ 1 ], - m[ 0 ][ 1 ],
		- m[ 1 ][ 0 ], m[ 0 ][ 0 ]
	) * ( 1.0 / det );

}
`
), new me(
  /* wgsl */
  `
fn tsl_inverse_mat3( m : mat3x3<f32> ) -> mat3x3<f32> {

	let a00 = m[ 0 ][ 0 ]; let a01 = m[ 0 ][ 1 ]; let a02 = m[ 0 ][ 2 ];
	let a10 = m[ 1 ][ 0 ]; let a11 = m[ 1 ][ 1 ]; let a12 = m[ 1 ][ 2 ];
	let a20 = m[ 2 ][ 0 ]; let a21 = m[ 2 ][ 1 ]; let a22 = m[ 2 ][ 2 ];

	let b01 = a22 * a11 - a12 * a21;
	let b11 = - a22 * a10 + a12 * a20;
	let b21 = a21 * a10 - a11 * a20;

	let det = a00 * b01 + a01 * b11 + a02 * b21;

	return mat3x3<f32>(
		b01, ( - a22 * a01 + a02 * a21 ), ( a12 * a01 - a02 * a11 ),
		b11, ( a22 * a00 - a02 * a20 ), ( - a12 * a00 + a02 * a10 ),
		b21, ( - a21 * a00 + a01 * a20 ), ( a11 * a00 - a01 * a10 )
	) * ( 1.0 / det );

}
`
), new me(
  /* wgsl */
  `
fn tsl_inverse_mat4( m : mat4x4<f32> ) -> mat4x4<f32> {

	let a00 = m[ 0 ][ 0 ]; let a01 = m[ 0 ][ 1 ]; let a02 = m[ 0 ][ 2 ]; let a03 = m[ 0 ][ 3 ];
	let a10 = m[ 1 ][ 0 ]; let a11 = m[ 1 ][ 1 ]; let a12 = m[ 1 ][ 2 ]; let a13 = m[ 1 ][ 3 ];
	let a20 = m[ 2 ][ 0 ]; let a21 = m[ 2 ][ 1 ]; let a22 = m[ 2 ][ 2 ]; let a23 = m[ 2 ][ 3 ];
	let a30 = m[ 3 ][ 0 ]; let a31 = m[ 3 ][ 1 ]; let a32 = m[ 3 ][ 2 ]; let a33 = m[ 3 ][ 3 ];

	let b00 = a00 * a11 - a01 * a10;
	let b01 = a00 * a12 - a02 * a10;
	let b02 = a00 * a13 - a03 * a10;
	let b03 = a01 * a12 - a02 * a11;
	let b04 = a01 * a13 - a03 * a11;
	let b05 = a02 * a13 - a03 * a12;
	let b06 = a20 * a31 - a21 * a30;
	let b07 = a20 * a32 - a22 * a30;
	let b08 = a20 * a33 - a23 * a30;
	let b09 = a21 * a32 - a22 * a31;
	let b10 = a21 * a33 - a23 * a31;
	let b11 = a22 * a33 - a23 * a32;

	let det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;

	return mat4x4<f32>(
		a11 * b11 - a12 * b10 + a13 * b09,
		a02 * b10 - a01 * b11 - a03 * b09,
		a31 * b05 - a32 * b04 + a33 * b03,
		a22 * b04 - a21 * b05 - a23 * b03,
		a12 * b08 - a10 * b11 - a13 * b07,
		a00 * b11 - a02 * b08 + a03 * b07,
		a32 * b02 - a30 * b05 - a33 * b01,
		a20 * b05 - a22 * b02 + a23 * b01,
		a10 * b10 - a11 * b08 + a13 * b06,
		a01 * b08 - a00 * b10 - a03 * b06,
		a30 * b04 - a31 * b02 + a33 * b00,
		a21 * b02 - a20 * b04 - a23 * b00,
		a11 * b07 - a10 * b09 - a12 * b06,
		a00 * b09 - a01 * b07 + a02 * b06,
		a31 * b01 - a30 * b03 - a32 * b00,
		a20 * b03 - a21 * b01 + a22 * b00
	) * ( 1.0 / det );

}
`
), new me(
  /* wgsl */
  `
fn tsl_biquadraticTexture( map : texture_2d<f32>, coord : vec2f, iRes : vec2u, level : u32 ) -> vec4f {

	let res = vec2f( iRes );

	let uvScaled = coord * res;
	let uvWrapping = ( ( uvScaled % res ) + res ) % res;

	// https://www.shadertoy.com/view/WtyXRy

	let uv = uvWrapping - 0.5;
	let iuv = floor( uv );
	let f = fract( uv );

	let rg1 = textureLoad( map, vec2u( iuv + vec2( 0.5, 0.5 ) ) % iRes, level );
	let rg2 = textureLoad( map, vec2u( iuv + vec2( 1.5, 0.5 ) ) % iRes, level );
	let rg3 = textureLoad( map, vec2u( iuv + vec2( 0.5, 1.5 ) ) % iRes, level );
	let rg4 = textureLoad( map, vec2u( iuv + vec2( 1.5, 1.5 ) ) % iRes, level );

	return mix( mix( rg1, rg2, f.x ), mix( rg3, rg4, f.x ), f.y );

}
`
), new me(
  /* wgsl */
  `
fn tsl_biquadraticTexture_array( map : texture_2d_array<f32>, coord : vec2f, iRes : vec2u, layer : u32, level : u32 ) -> vec4f {

	let res = vec2f( iRes );

	let uvScaled = coord * res;
	let uvWrapping = ( ( uvScaled % res ) + res ) % res;

	// https://www.shadertoy.com/view/WtyXRy

	let uv = uvWrapping - 0.5;
	let iuv = floor( uv );
	let f = fract( uv );

	let rg1 = textureLoad( map, vec2u( iuv + vec2( 0.5, 0.5 ) ) % iRes, layer, level );
	let rg2 = textureLoad( map, vec2u( iuv + vec2( 1.5, 0.5 ) ) % iRes, layer, level );
	let rg3 = textureLoad( map, vec2u( iuv + vec2( 0.5, 1.5 ) ) % iRes, layer, level );
	let rg4 = textureLoad( map, vec2u( iuv + vec2( 1.5, 1.5 ) ) % iRes, layer, level );

	return mix( mix( rg1, rg2, f.x ), mix( rg3, rg4, f.x ), f.y );

}
`
);
const lM = /* @__PURE__ */ new Map([
  [Int8Array, ["sint8", "snorm8"]],
  [Uint8Array, ["uint8", "unorm8"]],
  [Int16Array, ["sint16", "snorm16"]],
  [Uint16Array, ["uint16", "unorm16"]],
  [Int32Array, ["sint32", "snorm32"]],
  [Uint32Array, ["uint32", "unorm32"]],
  [Float32Array, ["float32"]]
]);
typeof Float16Array < "u" && lM.set(Float16Array, ["float16"]);
c.BRDF_GGX;
c.BRDF_Lambert;
c.BasicPointShadowFilter;
c.BasicShadowFilter;
c.Break;
c.Const;
c.Continue;
c.DFGLUT;
c.D_GGX;
c.Discard;
c.EPSILON;
c.F_Schlick;
c.Fn;
c.INFINITY;
c.If;
c.Loop;
c.NodeAccess;
c.NodeShaderStage;
c.NodeType;
c.NodeUpdateType;
c.PCFShadowFilter;
c.PCFSoftShadowFilter;
c.PI;
c.PI2;
c.TWO_PI;
c.HALF_PI;
c.PointShadowFilter;
c.Return;
c.Schlick_to_F0;
c.ShaderNode;
c.Stack;
c.Switch;
c.TBNViewMatrix;
c.VSMShadowFilter;
c.V_GGX_SmithCorrelated;
c.Var;
c.VarIntent;
const uM = c.abs;
c.acesFilmicToneMapping;
c.acos;
c.acosh;
c.add;
c.addMethodChaining;
c.addNodeElement;
c.agxToneMapping;
c.all;
c.alphaT;
c.ambientOcclusion;
c.and;
c.anisotropy;
c.anisotropyB;
c.anisotropyT;
c.any;
c.append;
c.array;
c.asin;
c.asinh;
c.assign;
c.atan;
c.atanh;
c.atomicAdd;
c.atomicAnd;
c.atomicFunc;
c.atomicLoad;
c.atomicMax;
c.atomicMin;
c.atomicOr;
c.atomicStore;
c.atomicSub;
c.atomicXor;
c.attenuationColor;
c.attenuationDistance;
c.attribute;
c.attributeArray;
c.backgroundBlurriness;
c.backgroundIntensity;
c.backgroundRotation;
c.batch;
c.bentNormalView;
c.billboarding;
c.bitAnd;
c.bitNot;
c.bitOr;
c.bitXor;
c.bitangentGeometry;
c.bitangentLocal;
c.bitangentView;
c.bitangentWorld;
c.bitcast;
c.blendBurn;
c.blendColor;
c.blendDodge;
c.blendOverlay;
c.blendScreen;
c.blur;
c.bool;
c.buffer;
c.bufferAttribute;
c.bumpMap;
c.builtin;
c.builtinAOContext;
c.builtinShadowContext;
c.bvec2;
c.bvec3;
c.bvec4;
c.bypass;
c.cache;
c.call;
c.cameraFar;
c.cameraIndex;
c.cameraNear;
c.cameraNormalMatrix;
c.cameraPosition;
c.cameraProjectionMatrix;
c.cameraProjectionMatrixInverse;
c.cameraViewMatrix;
c.cameraViewport;
c.cameraWorldMatrix;
c.cbrt;
c.cdl;
c.ceil;
c.checker;
c.cineonToneMapping;
c.clamp;
c.clearcoat;
c.clearcoatNormalView;
c.clearcoatRoughness;
c.clipSpace;
c.code;
c.color;
c.colorSpaceToWorking;
c.colorToDirection;
c.compute;
c.computeKernel;
c.computeSkinning;
c.context;
c.convert;
c.convertColorSpace;
c.convertToTexture;
c.countLeadingZeros;
c.countOneBits;
c.countTrailingZeros;
c.cos;
c.cosh;
c.cross;
c.cubeTexture;
c.cubeTextureBase;
c.dFdx;
c.dFdy;
c.dashSize;
c.debug;
c.decrement;
c.decrementBefore;
c.defaultBuildStages;
c.defaultShaderStages;
c.defined;
c.degrees;
c.deltaTime;
c.densityFog;
c.densityFogFactor;
c.depth;
c.depthPass;
c.determinant;
c.difference;
c.diffuseColor;
c.directPointLight;
c.directionToColor;
c.directionToFaceDirection;
c.dispersion;
c.distance;
c.div;
const hM = c.dot;
c.drawIndex;
c.dynamicBufferAttribute;
c.element;
c.emissive;
c.equal;
c.equirectDirection;
c.equirectUV;
c.exp;
c.exp2;
c.exponentialHeightFogFactor;
c.expression;
c.faceDirection;
c.faceForward;
c.faceforward;
const Nh = c.float;
c.floatBitsToInt;
c.floatBitsToUint;
c.floor;
c.fog;
c.fract;
c.frameGroup;
c.frameId;
c.frontFacing;
c.fwidth;
c.gain;
c.gapSize;
c.getConstNodeType;
c.getCurrentStack;
c.getDirection;
c.getDistanceAttenuation;
c.getGeometryRoughness;
c.getNormalFromDepth;
c.interleavedGradientNoise;
c.vogelDiskSample;
c.getParallaxCorrectNormal;
c.getRoughness;
c.getScreenPosition;
c.getShIrradianceAt;
c.getShadowMaterial;
c.getShadowRenderObjectFunction;
c.getTextureIndex;
c.getViewPosition;
c.globalId;
c.glsl;
c.glslFn;
c.grayscale;
c.greaterThan;
c.greaterThanEqual;
c.hash;
c.highpModelNormalViewMatrix;
c.highpModelViewMatrix;
c.hue;
c.increment;
c.incrementBefore;
c.instance;
c.instanceIndex;
c.instancedArray;
c.instancedBufferAttribute;
c.instancedDynamicBufferAttribute;
c.instancedMesh;
c.int;
c.intBitsToFloat;
c.inverse;
c.inverseSqrt;
c.inversesqrt;
c.invocationLocalIndex;
c.invocationSubgroupIndex;
c.ior;
c.iridescence;
c.iridescenceIOR;
c.iridescenceThickness;
c.ivec2;
c.ivec3;
c.ivec4;
c.js;
c.label;
c.length;
c.lengthSq;
c.lessThan;
c.lessThanEqual;
c.lightPosition;
c.lightProjectionUV;
c.lightShadowMatrix;
c.lightTargetDirection;
c.lightTargetPosition;
c.lightViewPosition;
c.lightingContext;
c.lights;
c.linearDepth;
c.linearToneMapping;
c.localId;
c.log;
c.log2;
c.logarithmicDepthToViewZ;
c.luminance;
c.mat2;
c.mat3;
c.mat4;
c.matcapUV;
c.materialAO;
c.materialAlphaTest;
c.materialAnisotropy;
c.materialAnisotropyVector;
c.materialAttenuationColor;
c.materialAttenuationDistance;
c.materialClearcoat;
c.materialClearcoatNormal;
c.materialClearcoatRoughness;
c.materialColor;
c.materialDispersion;
c.materialEmissive;
c.materialEnvIntensity;
c.materialEnvRotation;
c.materialIOR;
c.materialIridescence;
c.materialIridescenceIOR;
c.materialIridescenceThickness;
c.materialLightMap;
c.materialLineDashOffset;
c.materialLineDashSize;
c.materialLineGapSize;
c.materialLineScale;
c.materialLineWidth;
c.materialMetalness;
c.materialNormal;
c.materialOpacity;
c.materialPointSize;
c.materialReference;
c.materialReflectivity;
c.materialRefractionRatio;
c.materialRotation;
c.materialRoughness;
c.materialSheen;
c.materialSheenRoughness;
c.materialShininess;
c.materialSpecular;
c.materialSpecularColor;
c.materialSpecularIntensity;
c.materialSpecularStrength;
c.materialThickness;
c.materialTransmission;
c.max;
c.maxMipLevel;
c.mediumpModelViewMatrix;
c.metalness;
c.min;
c.mix;
c.mixElement;
c.mod;
c.modelDirection;
c.modelNormalMatrix;
c.modelPosition;
c.modelRadius;
c.modelScale;
c.modelViewMatrix;
c.modelViewPosition;
c.modelViewProjection;
c.modelWorldMatrix;
c.modelWorldMatrixInverse;
c.morphReference;
c.mrt;
c.mul;
c.mx_aastep;
c.mx_add;
c.mx_atan2;
c.mx_cell_noise_float;
c.mx_contrast;
c.mx_divide;
c.mx_fractal_noise_float;
c.mx_fractal_noise_vec2;
c.mx_fractal_noise_vec3;
c.mx_fractal_noise_vec4;
c.mx_frame;
c.mx_heighttonormal;
c.mx_hsvtorgb;
c.mx_ifequal;
c.mx_ifgreater;
c.mx_ifgreatereq;
c.mx_invert;
c.mx_modulo;
c.mx_multiply;
c.mx_noise_float;
c.mx_noise_vec3;
c.mx_noise_vec4;
c.mx_place2d;
c.mx_power;
c.mx_ramp4;
c.mx_ramplr;
c.mx_ramptb;
c.mx_rgbtohsv;
c.mx_rotate2d;
c.mx_rotate3d;
c.mx_safepower;
c.mx_separate;
c.mx_splitlr;
c.mx_splittb;
c.mx_srgb_texture_to_lin_rec709;
c.mx_subtract;
c.mx_timer;
c.mx_transform_uv;
c.mx_unifiednoise2d;
c.mx_unifiednoise3d;
c.mx_worley_noise_float;
c.mx_worley_noise_vec2;
c.mx_worley_noise_vec3;
c.negate;
c.negateOnBackSide;
c.neutralToneMapping;
c.nodeArray;
c.nodeImmutable;
c.nodeObject;
c.nodeObjectIntent;
c.nodeObjects;
c.nodeProxy;
c.nodeProxyIntent;
c.normalFlat;
c.normalGeometry;
c.normalLocal;
c.normalMap;
const cM = c.normalView;
c.normalViewGeometry;
c.normalWorld;
c.normalWorldGeometry;
c.normalize;
c.not;
c.notEqual;
c.numWorkgroups;
c.objectDirection;
c.objectGroup;
c.objectPosition;
c.objectRadius;
c.objectScale;
c.objectViewPosition;
c.objectWorldMatrix;
c.OnBeforeObjectUpdate;
c.OnBeforeMaterialUpdate;
c.OnObjectUpdate;
c.OnMaterialUpdate;
c.oneMinus;
c.or;
c.orthographicDepthToViewZ;
c.oscSawtooth;
c.oscSine;
c.oscSquare;
c.oscTriangle;
c.output;
c.outputStruct;
c.overloadingFn;
c.overrideNode;
c.overrideNodes;
c.packHalf2x16;
c.packSnorm2x16;
c.packUnorm2x16;
c.packNormalToRGB;
c.parabola;
c.parallaxDirection;
c.parallaxUV;
c.parameter;
c.pass;
c.passTexture;
c.pcurve;
c.perspectiveDepthToViewZ;
c.pmremTexture;
c.pointShadow;
c.pointUV;
c.pointWidth;
c.positionGeometry;
c.positionLocal;
c.positionPrevious;
c.positionView;
const dM = c.positionViewDirection;
c.positionWorld;
c.positionWorldDirection;
c.posterize;
const pM = c.pow;
c.pow2;
c.pow3;
c.pow4;
c.premultiplyAlpha;
c.property;
c.radians;
c.rand;
c.range;
c.rangeFog;
c.rangeFogFactor;
c.reciprocal;
c.reference;
c.referenceBuffer;
c.reflect;
c.reflectVector;
c.reflectView;
c.reflector;
c.refract;
c.refractVector;
c.refractView;
c.reinhardToneMapping;
c.remap;
c.remapClamp;
c.renderGroup;
c.renderOutput;
c.rendererReference;
c.replaceDefaultUV;
c.rotate;
c.rotateUV;
c.roughness;
c.round;
c.rtt;
c.sRGBTransferEOTF;
c.sRGBTransferOETF;
c.sample;
c.sampler;
c.samplerComparison;
c.saturate;
c.saturation;
c.screen;
c.screenCoordinate;
c.screenDPR;
c.screenSize;
c.screenUV;
c.select;
c.setCurrentStack;
c.setName;
c.shaderStages;
c.shadow;
c.shadowPositionWorld;
c.shapeCircle;
c.sharedUniformGroup;
c.sheen;
c.sheenRoughness;
c.shiftLeft;
c.shiftRight;
c.shininess;
c.sign;
c.sin;
c.sinh;
c.sinc;
c.skinning;
c.smoothstep;
c.smoothstepElement;
c.specularColor;
c.specularF90;
c.spherizeUV;
c.split;
c.spritesheetUV;
c.sqrt;
c.stack;
c.step;
c.stepElement;
c.storage;
c.storageBarrier;
c.storageTexture;
c.storageTexture3D;
c.struct;
c.sub;
c.subgroupAdd;
c.subgroupAll;
c.subgroupAnd;
c.subgroupAny;
c.subgroupBallot;
c.subgroupBroadcast;
c.subgroupBroadcastFirst;
c.subBuild;
c.subgroupElect;
c.subgroupExclusiveAdd;
c.subgroupExclusiveMul;
c.subgroupInclusiveAdd;
c.subgroupInclusiveMul;
c.subgroupIndex;
c.subgroupMax;
c.subgroupMin;
c.subgroupMul;
c.subgroupOr;
c.subgroupShuffle;
c.subgroupShuffleDown;
c.subgroupShuffleUp;
c.subgroupShuffleXor;
c.subgroupSize;
c.subgroupXor;
c.tan;
c.tanh;
c.tangentGeometry;
c.tangentLocal;
c.tangentView;
c.tangentWorld;
c.texture;
c.texture3D;
c.textureBarrier;
c.textureBicubic;
c.textureBicubicLevel;
c.textureCubeUV;
c.textureLoad;
c.textureSize;
c.textureLevel;
c.textureStore;
c.thickness;
c.time;
c.toneMapping;
c.toneMappingExposure;
c.toonOutlinePass;
c.transformDirection;
c.transformNormal;
c.transformNormalByInverseViewMatrix;
c.transformNormalByViewMatrix;
c.transformNormalToView;
c.transformedClearcoatNormalView;
c.transformedNormalView;
c.transformedNormalWorld;
c.transmission;
c.transpose;
c.triNoise3D;
c.triplanarTexture;
c.triplanarTextures;
c.trunc;
c.uint;
c.uintBitsToFloat;
c.uniform;
c.uniformArray;
c.uniformCubeTexture;
c.uniformGroup;
c.uniformFlow;
c.uniformTexture;
c.unpackHalf2x16;
c.unpackSnorm2x16;
c.unpackUnorm2x16;
c.unpackRGBToNormal;
c.unpremultiplyAlpha;
c.userData;
c.uv;
c.uvec2;
c.uvec3;
c.uvec4;
c.varying;
c.varyingProperty;
c.vec2;
const Mh = c.vec3;
c.vec4;
c.vectorComponents;
c.velocity;
c.vertexColor;
c.vertexIndex;
c.vertexStage;
c.vibrance;
c.viewZToLogarithmicDepth;
c.viewZToOrthographicDepth;
c.viewZToPerspectiveDepth;
c.viewZToReversedOrthographicDepth;
c.viewZToReversedPerspectiveDepth;
c.viewport;
c.viewportCoordinate;
c.viewportDepthTexture;
c.viewportLinearDepth;
c.viewportMipTexture;
c.viewportOpaqueMipTexture;
c.viewportResolution;
c.viewportSafeUV;
c.viewportSharedTexture;
c.viewportSize;
c.viewportTexture;
c.viewportUV;
c.wgsl;
c.wgslFn;
c.workgroupArray;
c.workgroupBarrier;
c.workgroupId;
c.workingToColorSpace;
c.xor;
function Sh(r, e = {}) {
  if (!r || !r.isNodeMaterial)
    return e.emissive && Array.isArray(e.emissive) && (r.emissive = new ie.Color(e.emissive[0], e.emissive[1], e.emissive[2]), r.emissiveIntensity = e.emissiveIntensity ?? 1), !1;
  const t = [];
  if (e.emissive && Array.isArray(e.emissive) && t.push(
    Mh(e.emissive[0], e.emissive[1], e.emissive[2]).mul(e.emissiveIntensity ?? 1)
  ), e.outline) {
    const s = e.outlineColor && Array.isArray(e.outlineColor) ? e.outlineColor : [0, 0, 0], i = pM(
      Nh(1).sub(uM(hM(cM, dM))),
      Nh(e.outlinePower ?? 3)
    );
    t.push(Mh(s[0], s[1], s[2]).mul(i.mul(e.outlineStrength ?? 1)));
  }
  if (t.length) {
    let s = t[0];
    for (let i = 1; i < t.length; i++) s = s.add(t[i]);
    r.emissiveNode = s;
  }
  return !0;
}
const Ua = [
  { n: [1, 0, 0], c: [[0.5, -0.5, -0.5], [0.5, 0.5, -0.5], [0.5, 0.5, 0.5], [0.5, -0.5, 0.5]] },
  { n: [-1, 0, 0], c: [[-0.5, -0.5, 0.5], [-0.5, 0.5, 0.5], [-0.5, 0.5, -0.5], [-0.5, -0.5, -0.5]] },
  { n: [0, 1, 0], c: [[-0.5, 0.5, 0.5], [0.5, 0.5, 0.5], [0.5, 0.5, -0.5], [-0.5, 0.5, -0.5]] },
  { n: [0, -1, 0], c: [[-0.5, -0.5, -0.5], [0.5, -0.5, -0.5], [0.5, -0.5, 0.5], [-0.5, -0.5, 0.5]] },
  { n: [0, 0, 1], c: [[-0.5, -0.5, 0.5], [0.5, -0.5, 0.5], [0.5, 0.5, 0.5], [-0.5, 0.5, 0.5]] },
  { n: [0, 0, -1], c: [[-0.5, -0.5, -0.5], [0.5, -0.5, -0.5], [0.5, 0.5, -0.5], [-0.5, 0.5, -0.5]] }
], Zm = [
  [1, 0, 0],
  [-1, 0, 0],
  [0, 1, 0],
  [0, -1, 0],
  [0, 0, 1],
  [0, 0, -1]
], ka = (r, e, t) => r + "," + e + "," + t, fa = new ie.Color();
function mM(r, e) {
  e ? r.push(e[0] / 255, e[1] / 255, e[2] / 255) : r.push(0.5, 0.5, 0.5);
}
function gM(r, e) {
  if (!e) {
    r.push(0.5, 0.5, 0.5);
    return;
  }
  fa.setRGB(e[0] / 255, e[1] / 255, e[2] / 255, ie.SRGBColorSpace), r.push(fa.r, fa.g, fa.b);
}
function gn(r) {
  return r === "linear" ? gM : mM;
}
function UM(r, e, t = {}) {
  const s = gn(t.colorSpace), i = /* @__PURE__ */ new Set();
  for (const d of r) i.add(ka(d.x, d.y, d.z));
  const a = [], n = [], o = [], l = [];
  let u = 0;
  for (const d of r) {
    const p = e ? e[d.i] : null;
    if (!(!p || p[3] === 0))
      for (let m = 0; m < 6; m++) {
        const [g, y, v] = Zm[m];
        if (i.has(ka(d.x + g, d.y + y, d.z + v))) continue;
        const w = Ua[m];
        for (const _ of w.c)
          a.push(d.x + _[0], d.y + _[1], d.z + _[2]), n.push(w.n[0], w.n[1], w.n[2]), s(o, p);
        l.push(u, u + 1, u + 2, u, u + 2, u + 3), u += 4;
      }
  }
  const h = new ie.BufferGeometry();
  return h.setAttribute("position", new ie.Float32BufferAttribute(a, 3)), h.setAttribute("normal", new ie.Float32BufferAttribute(n, 3)), h.setAttribute("color", new ie.Float32BufferAttribute(o, 3)), h.setIndex(l), h.computeBoundingBox(), h.computeBoundingSphere(), h;
}
function kM(r, e, t, s = {}) {
  const i = gn(s.colorSpace), a = t && Object.keys(t).length > 0, n = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Set();
  for (const h of r) o.add(ka(h.x, h.y, h.z));
  const l = (h) => (n.has(h) || n.set(h, { positions: [], normals: [], colors: [], indices: [], base: 0 }), n.get(h));
  for (const h of r) {
    const d = e ? e[h.i] : null;
    if (!d || d[3] === 0) continue;
    const p = a && t[h.i] ? h.i : 0, m = l(p);
    for (let g = 0; g < 6; g++) {
      const [y, v, w] = Zm[g];
      if (o.has(ka(h.x + y, h.y + v, h.z + w))) continue;
      const _ = Ua[g];
      for (const C of _.c)
        m.positions.push(h.x + C[0], h.y + C[1], h.z + C[2]), m.normals.push(_.n[0], _.n[1], _.n[2]), i(m.colors, d);
      m.indices.push(m.base, m.base + 1, m.base + 2, m.base, m.base + 2, m.base + 3), m.base += 4;
    }
  }
  const u = [];
  for (const [h, d] of n) {
    const p = new ie.BufferGeometry();
    p.setAttribute("position", new ie.Float32BufferAttribute(d.positions, 3)), p.setAttribute("normal", new ie.Float32BufferAttribute(d.normals, 3)), p.setAttribute("color", new ie.Float32BufferAttribute(d.colors, 3)), p.setIndex(d.indices), p.computeBoundingBox(), p.computeBoundingSphere(), u.push({ geometry: p, materialId: h });
  }
  return u;
}
function fM(r, e, t = {}) {
  const s = t.defaultMaterial || "lambert", i = t.side !== void 0 ? t.side : ie.DoubleSide, a = t.nodeMaterialClass || null, n = (u) => a ? new a({ vertexColors: !0, side: i, ...u }) : new ie.MeshStandardMaterial({ vertexColors: !0, side: i, ...u });
  if (!r || !e || !e[r]) {
    const u = n({ metalness: 0, roughness: 1 });
    if (t.tsl) Sh(u, t.tsl);
    else if (s === "lambert") return new ie.MeshLambertMaterial({ vertexColors: !0, side: i });
    return u;
  }
  const o = e[r], l = n({
    metalness: o.metalness || 0,
    roughness: o.roughness !== void 0 ? o.roughness : 1
  });
  return o.alpha !== void 0 && o.alpha < 1 && (l.transparent = !0, l.opacity = o.alpha), o.emissive && (l.emissive = new ie.Color(16777215), l.emissiveIntensity = o.emissive), o.ior && (l.ior = o.ior), t.tsl && Sh(l, t.tsl), l;
}
const Jm = [1, 2, 0], Qm = [2, 0, 1];
function yM(r) {
  let e = 1 / 0, t = 1 / 0, s = 1 / 0, i = -1 / 0, a = -1 / 0, n = -1 / 0;
  for (const o of r)
    o.x < e && (e = o.x), o.x > i && (i = o.x), o.y < t && (t = o.y), o.y > a && (a = o.y), o.z < s && (s = o.z), o.z > n && (n = o.z);
  return { min: [e, t, s], dims: [i - e + 1, a - t + 1, n - s + 1] };
}
function xM(r, e) {
  const { min: t, dims: s } = yM(r), [i, a, n] = t, o = /* @__PURE__ */ new Set(), l = /* @__PURE__ */ new Map();
  for (const u of r) {
    const h = u.x - i + "," + (u.y - a) + "," + (u.z - n);
    o.add(h);
    const d = e ? e[u.i] : null;
    d && d[3] !== 0 && l.set(h, u.i);
  }
  return { present: o, colorOf: l, min: t, dims: s };
}
const _h = (r, e, t) => r + "," + e + "," + t;
function Km(r, e) {
  if (!r.length) return { quads: [], min: [0, 0, 0] };
  const { present: t, colorOf: s, min: i, dims: a } = xM(r, e), n = [];
  for (let o = 0; o < 3; o++) {
    const l = Jm[o], u = Qm[o], h = a[l], d = a[u], p = a[o];
    for (let m = 1; m >= -1; m -= 2) {
      const g = o * 2 + (m > 0 ? 0 : 1);
      for (let y = 0; y < p; y++) {
        const v = new Int32Array(h * d).fill(-1);
        for (let _ = 0; _ < h; _++)
          for (let C = 0; C < d; C++) {
            const V = [0, 0, 0];
            V[o] = y, V[l] = _, V[u] = C;
            const P = _h(V[0], V[1], V[2]), z = s.get(P);
            if (z === void 0) continue;
            const R = [V[0], V[1], V[2]];
            R[o] = y + m, !t.has(_h(R[0], R[1], R[2])) && (v[_ * d + C] = z);
          }
        const w = new Uint8Array(h * d);
        for (let _ = 0; _ < d; _++)
          for (let C = 0; C < h; C++) {
            const V = C * d + _;
            if (v[V] < 0 || w[V]) continue;
            const P = v[V];
            let z = 1;
            for (; C + z < h && v[(C + z) * d + _] === P && !w[(C + z) * d + _]; ) z++;
            let R = 1;
            e: for (; _ + R < d; ) {
              for (let I = 0; I < z; I++) {
                const G = (C + I) * d + (_ + R);
                if (v[G] !== P || w[G]) break e;
              }
              R++;
            }
            for (let I = 0; I < R; I++) for (let G = 0; G < z; G++) w[(C + G) * d + (_ + I)] = 1;
            n.push({ f: g, w: y, u: C, v: _, du: z, dv: R, i: P });
          }
      }
    }
  }
  return { quads: n, min: i };
}
function eg() {
  return { positions: [], normals: [], colors: [], indices: [] };
}
function tg(r, e, t, s, i) {
  const a = e.f, n = Math.floor(a / 2), o = Jm[n], l = Qm[n], u = Ua[a].n, h = s ? s[e.i] : null;
  for (const p of Ua[a].c) {
    const m = e.w + p[n], g = e.u + (p[o] > 0 ? e.du : 0) - 0.5, y = e.v + (p[l] > 0 ? e.dv : 0) - 0.5, v = [0, 0, 0];
    v[n] = m, v[o] = g, v[l] = y, r.positions.push(v[0] + t[0], v[1] + t[1], v[2] + t[2]), r.normals.push(u[0], u[1], u[2]), i(r.colors, h);
  }
  const d = r.positions.length / 3 - 4;
  r.indices.push(d, d + 1, d + 2, d, d + 2, d + 3);
}
function sg(r) {
  const e = new ie.BufferGeometry();
  return e.setAttribute("position", new ie.Float32BufferAttribute(r.positions, 3)), e.setAttribute("normal", new ie.Float32BufferAttribute(r.normals, 3)), e.setAttribute("color", new ie.Float32BufferAttribute(r.colors, 3)), e.setIndex(r.indices), e.computeBoundingBox(), e.computeBoundingSphere(), e;
}
function bM(r, e, t = {}) {
  const s = gn(t.colorSpace), { quads: i, min: a } = Km(r, e), n = eg();
  for (const o of i) tg(n, o, a, e, s);
  return sg(n);
}
function vM(r, e, t, s = {}) {
  const i = gn(s.colorSpace), { quads: a, min: n } = Km(r, e), o = t && Object.keys(t).length > 0, l = /* @__PURE__ */ new Map(), u = (d) => (l.has(d) || l.set(d, eg()), l.get(d));
  for (const d of a) {
    const p = o && t[d.i] ? d.i : 0;
    tg(u(p), d, n, e, i);
  }
  const h = [];
  for (const [d, p] of l) h.push({ geometry: sg(p), materialId: d });
  return h;
}
function Ah(r, e) {
  const t = e || [0, 0, 0];
  return new ie.Matrix4().set(
    r[0],
    r[1],
    r[2],
    t[0],
    r[3],
    r[4],
    r[5],
    t[1],
    r[6],
    r[7],
    r[8],
    t[2],
    0,
    0,
    0,
    1
  );
}
function rg(r) {
  const e = r && r.palette ? r.palette : ng(), t = r && r.materials || {};
  let s = [];
  if (r && Array.isArray(r.instances))
    s = r.instances.map((i) => ({
      voxels: i.voxels || [],
      translation: i.translation || [0, 0, 0],
      rotation: i.rotation || 0,
      hidden: !!i.hidden,
      name: i.name || "",
      frames: i.frames || void 0
    }));
  else if (r && Array.isArray(r.models) && Array.isArray(r.scene)) {
    const i = r.models;
    s = r.scene.map((a) => ({
      voxels: i[a.modelIndex] && i[a.modelIndex].voxels || [],
      translation: a.translation || [0, 0, 0],
      rotation: a.rotation || 0,
      hidden: !!a.hidden,
      name: a.name || "",
      frames: a.frames || void 0
    }));
  } else {
    const i = r && (r.model || (Array.isArray(r.models) ? r.models[0] : null));
    i && (s = [{ voxels: i.voxels || [], translation: [0, 0, 0], rotation: 0, hidden: !1, name: "" }]);
  }
  return { palette: e, materials: t, instances: s };
}
function TM(r) {
  const { palette: e, materials: t, instances: s } = rg(r), i = new ie.Group();
  i.name = "VoxelExport", i.rotation.x = -Math.PI / 2;
  const a = t && Object.keys(t).length > 0, n = [];
  for (let o = 0; o < s.length; o++) {
    const l = s[o];
    if (l.hidden) continue;
    const u = (l.name || `instance_${o}`).replace(/\s+/g, "_"), h = a ? vM(l.voxels, e, t, { colorSpace: "linear" }) : [{ geometry: bM(l.voxels, e, { colorSpace: "linear" }), materialId: 0 }], d = l.frames && l.frames.length > 1 ? l.frames : null;
    for (let p = 0; p < h.length; p++) {
      const m = h[p], g = fM(m.materialId, t, { defaultMaterial: "standard", side: ie.FrontSide }), y = new ie.Mesh(m.geometry, g), v = h.length > 1 ? `${u}_m${p}` : u;
      if (y.name = v, d) {
        const w = [], _ = [], C = [];
        for (let z = 0; z < d.length; z++) {
          const R = d[z], I = Ri[R.rotation] || Ri[0], G = Ah(I, R.translation || [0, 0, 0]), $ = new ie.Vector3(), Z = new ie.Quaternion(), Ve = new ie.Vector3();
          G.decompose($, Z, Ve), w.push(z), _.push($.x, $.y, $.z), C.push(Z.x, Z.y, Z.z, Z.w);
        }
        const V = new ie.VectorKeyframeTrack(`${v}.position`, w, _), P = new ie.QuaternionKeyframeTrack(`${v}.quaternion`, w, C);
        n.push(new ie.AnimationClip(`anim_${v}`, d.length - 1, [V, P]));
      } else {
        const w = Ri[l.rotation] || Ri[0], _ = Ah(w, l.translation), C = new ie.Vector3(), V = new ie.Quaternion(), P = new ie.Vector3();
        _.decompose(C, V, P), y.position.copy(C), y.quaternion.copy(V), y.scale.copy(P);
      }
      i.add(y);
    }
  }
  return i.animations = n, i.updateMatrixWorld(!0), i;
}
const wM = ["glb", "gltf", "obj", "stl", "ply", "usdz", "fbx", "vox"], NM = {
  glb: "model.glb",
  gltf: "model.gltf",
  obj: "model.obj",
  stl: "model.stl",
  ply: "model.ply",
  usdz: "model.usdz",
  fbx: "model.fbx",
  vox: "model.vox"
}, Vh = {
  glb: "model/gltf-binary",
  gltf: "model/gltf+json",
  obj: "text/plain",
  stl: "application/octet-stream",
  ply: "application/octet-stream",
  usdz: "model/vnd.usdz+zip",
  fbx: "application/octet-stream"
};
async function MM(r, e, t = {}) {
  switch (e) {
    case "glb": {
      const s = new pu(), i = t.animations ?? r.animations ?? [];
      return await new Promise((a, n) => {
        s.parse(r, (o) => a(o), (o) => n(o), { binary: !0, ...t, animations: i });
      });
    }
    case "gltf": {
      const s = new pu(), i = t.animations ?? r.animations ?? [], a = await new Promise((n, o) => {
        s.parse(r, (l) => n(l), (l) => o(l), { binary: !1, ...t, animations: i });
      });
      return typeof a == "string" ? a : JSON.stringify(a, null, 2);
    }
    case "obj":
      return new og().parse(r);
    case "stl": {
      const s = new lg(), i = t.binary !== !1;
      return s.parse(r, { ...t, binary: i });
    }
    case "ply": {
      const s = new ug(), i = t.binary !== !1;
      return await new Promise((a, n) => {
        s.parse(r, (o) => a(o), { ...t, binary: i });
      });
    }
    case "usdz":
      return await new hg().parseAsync(r, t);
    case "fbx":
      return new cg().parseSync(r, { preset: "threejs", axisUp: "Y", ...t });
    default:
      throw new Error(`不支持的导出格式: ${e}。支持: ${wM.join(", ")}`);
  }
}
function DM(r) {
  if (r instanceof Uint8Array) return r;
  if (r instanceof ArrayBuffer) return new Uint8Array(r);
  if (r instanceof DataView) return new Uint8Array(r.buffer, r.byteOffset, r.byteLength);
  if (typeof r == "string") return new TextEncoder().encode(r);
  throw new TypeError("toUint8Array: 不支持的数据类型");
}
function ig(r, e = "application/octet-stream") {
  return r instanceof Blob ? r : typeof r == "string" ? new Blob([r], { type: e }) : new Blob([r], { type: e });
}
function SM(r, e, t) {
  if (typeof document > "u")
    throw new Error("downloadModel 仅在浏览器环境可用");
  const s = ig(r, t), i = URL.createObjectURL(s), a = document.createElement("a");
  a.href = i, a.download = e || "model.bin", document.body.appendChild(a), a.click(), document.body.removeChild(a), URL.revokeObjectURL(i);
}
async function _M(r, e = {}) {
  return (await import("./draco-DXkzQJZZ.js")).compressGlbDraco(r, e);
}
class WM {
  /**
   * @param {object} input VOX 解析结果 / { model } / { instances } 之一, 可带 palette/materials
   */
  constructor(e) {
    this.input = e, this._object = null;
  }
  /** 构建 (并缓存) y-up 的 THREE.Group */
  build() {
    return this._object || (this._object = TM(this.input)), this._object;
  }
  /**
   * 导出为指定格式。
   * @param {string} format 'glb'|'gltf'|'obj'|'stl'|'ply'|'usdz'|'fbx'|'vox'
   * @param {object} [options] 透传各 exporter + { binary?, filename?, draco? }
   *   - draco: 仅对 glb/gltf 生效, 为真时对导出的 glTF 做 KHR_draco_mesh_compression 后处理
   *     (大幅缩减体积, 保留 PBR 材质 + 烘焙动画)。需消费端安装 draco3d + @gltf-transform/*。
   * @returns {Promise<string|ArrayBuffer|Uint8Array|DataView>}
   */
  export(e, t = {}) {
    if (e === "vox") return this.exportVox(t);
    const s = this.build(), i = s.animations || [];
    return MM(s, e, { ...t, animations: i }).then((a) => (e === "glb" || e === "gltf") && t && t.draco ? _M(a, t.dracoOptions || {}) : a);
  }
  /**
   * 把体素数据无损写回 MagicaVoxel .vox 二进制 (round-trip)。
   * - 若输入是 parseVox 结果 (含 models + scene)，直接原样回写 (保留材质/变换/隐藏)。
   * - 否则把归一化后的实例反推成 { models, scene } 再写 (每个实例成为一个模型)。
   * @param {object} [_options]
   * @returns {Promise<Uint8Array>}
   */
  exportVox(e = {}) {
    const t = this.input;
    if (t && Array.isArray(t.models) && Array.isArray(t.scene))
      return Promise.resolve(du(t, t.palette || null));
    const { palette: s, materials: i, instances: a } = rg(t), n = a.map((l) => {
      let u = 0, h = 0, d = 0;
      for (const p of l.voxels)
        p.x + 1 > u && (u = p.x + 1), p.y + 1 > h && (h = p.y + 1), p.z + 1 > d && (d = p.z + 1);
      return { size: [u, h, d], voxels: l.voxels };
    }), o = a.map((l, u) => ({
      modelIndex: u,
      translation: l.translation || [0, 0, 0],
      rotation: l.rotation || 0,
      hidden: !!l.hidden,
      name: l.name || ""
    }));
    return Promise.resolve(du({ models: n, scene: o, materials: i }, s));
  }
  /**
   * 导出并包成 Blob。
   * @param {string} format
   * @param {object} [options]
   * @returns {Promise<Blob>}
   */
  toBlob(e, t = {}) {
    const s = t && t.mime || Vh[e] || "application/octet-stream";
    return this.export(e, t).then((i) => ig(i, s));
  }
  /**
   * 浏览器端直接下载。
   * @param {string} format
   * @param {object} [options]
   * @returns {Promise<void>}
   */
  download(e, t = {}) {
    const s = t && t.filename || NM[e] || "model.bin", i = Vh[e] || "application/octet-stream";
    return this.export(e, t).then((a) => SM(a, s, i));
  }
}
export {
  NM as DEFAULT_FILENAMES,
  wM as FORMATS,
  Vh as MIME_TYPES,
  WM as VoxelExporter,
  Sh as applyVoxelTsl,
  TM as buildExportObject,
  kM as buildVoxelBuckets,
  vM as buildVoxelBucketsGreedy,
  UM as buildVoxelGeometry,
  bM as buildVoxelGeometryGreedy,
  Ah as composeWorldMatrix,
  _M as compressGlbDraco,
  SM as downloadModel,
  MM as exportModel,
  fM as makeMaterial,
  rg as normalizeInput,
  ig as toBlob,
  DM as toUint8Array
};
